// AUTO-GENERATED by scripts/fetch-cms-content.mjs (DIT-264 / S8 → CMS).
// Gitignored — do NOT edit or commit. Empty `{}` means "use baked content".
/* eslint-disable */
export const CMS_ARTICLES: {
  industries: Record<string, unknown[]>;
  posts: Record<string, unknown[]>;
} = {
  "industries": {
    "en": [
      {
        "name": "Construction",
        "slug": "construction",
        "intro": "Crews spread across sites, hours scribbled on paper, subcontractor hours impossible to reconcile. Done-it gives every site a watertight digital timesheet that feeds your payroll in one click.",
        "pains": [
          {
            "body": "With multiple active sites and rotating crews, manual timesheets are wrong by design. Workers round up, forget entries or fill them in days later — leaving you with payroll figures you can't defend.",
            "title": "No reliable record of who worked where"
          },
          {
            "body": "By the time you notice a site has burned through its planned hours, the margin is already gone. There's no live countdown — just a nasty surprise at invoice time.",
            "title": "Budget overruns surface too late"
          },
          {
            "body": "Collecting timesheets, reconciling them against projects and preparing the payroll export takes days. Every entry is a potential error.",
            "title": "Payroll prep eats hours every month"
          }
        ],
        "quote": {
          "who": "Owner, construction company · 14 employees",
          "text": "Our crew checks in themselves on site. At month-end, payroll just adds up — we stopped chasing timesheets altogether.",
          "result": "5 hours a week saved on admin"
        },
        "stats": [
          {
            "label": "to check in on any site — no terminal, no paper",
            "value": "1 tap"
          },
          {
            "label": "payroll export ready for your provider",
            "value": "1 click"
          },
          {
            "label": "remaining-hours view per project and site",
            "value": "Live"
          }
        ],
        "features": [
          {
            "body": "One tap checks the worker in, location-verified, and links the hours to the right project. No card readers, no terminals — just the smartphone your crew already carries.",
            "title": "Location-verified check-in per site"
          },
          {
            "body": "Set planned hours as a budget when you open the project. Workers see a countdown of what's left; you see it live in your dashboard. Budget overruns are visible before they happen.",
            "title": "Live remaining-hours per project"
          },
          {
            "body": "Add subcontractors to a project, assign them to check-in and track their hours alongside your own crew — in the same overview.",
            "title": "Subcontractor management and presence"
          },
          {
            "body": "All registered hours — per worker, per project — export to a clean spreadsheet for your payroll provider. No manual preparation, no errors.",
            "title": "One-click payroll export"
          }
        ],
        "headline": "Time tracking for construction teams — location-verified check-in, project hours and budget control, in one app",
        "workflow": [
          {
            "body": "Each worker taps once to check in. GPS confirms the location, timestamps the entry and links hours to the project. No paper, no terminal.",
            "step": "Crew arrives on site"
          },
          {
            "body": "Hours, remaining budget, subcontractor presence and any extra work reported from site — all in your dashboard, in real time.",
            "step": "You see everything live"
          },
          {
            "body": "Export all hours per worker and per project. Send to your payroll provider. Done-it generates clean, audit-ready reports automatically.",
            "step": "Month-end in minutes"
          }
        ],
        "compliance": {
          "body": "Done-it provides location-verified check-in, per-project time tracking and a clean payroll export for construction teams. For teams operating on Belgian sites, it also feeds check-in at work automatically.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "Location-verified check-in built for construction sites"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Cleaning",
        "slug": "cleaning",
        "intro": "Cleaners move between locations all day. Done-it tracks who is where in real time — location-verified check-in at each site, automatic break deduction and a clean payroll export at month-end.",
        "pains": [
          {
            "body": "Clients and inspectors expect watertight attendance records. Manual sheets can be challenged; location-verified digital check-ins cannot.",
            "title": "Proving presence on every location"
          },
          {
            "body": "With cleaners moving between sites throughout the day, you have no live view of who is working where — until someone calls.",
            "title": "Teams spread across many locations"
          },
          {
            "body": "Without accurate in/out times, payroll is reconstructed from memory. Hours get rounded up, costs inflate and disputes follow.",
            "title": "Payroll errors from rounded hours"
          }
        ],
        "quote": {
          "who": "Manager, cleaning company · 9 employees",
          "text": "We can finally prove who cleaned where and when. No more attendance sheets, no more client disputes — GPS takes care of it.",
          "result": "Zero rounding-up of hours"
        },
        "stats": [
          {
            "label": "to check in at any location — no terminal needed",
            "value": "1 tap"
          },
          {
            "label": "view of who is on which site right now",
            "value": "Live"
          },
          {
            "label": "double entries — hours flow straight to payroll",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Workers tap in and out on their phone at each location, location-verified; time is exact, with break logging.",
            "plan": "Time Basic",
            "title": "Real-time check-in and out"
          },
          {
            "body": "Mandatory breaks are subtracted from the working day automatically — no manual maths, no disputes.",
            "plan": "Time Basic",
            "title": "Automatic break deduction"
          },
          {
            "body": "See which cleaners are at which locations right now. Spot gaps before clients do.",
            "title": "Multi-location live overview"
          },
          {
            "body": "Workers upload sick certificates and absence documents directly from the app. Create the absence types your team actually uses.",
            "title": "Absence registration with digital sick notes"
          },
          {
            "body": "Exact timestamps flow straight into a payroll-ready export for your provider. No transcription, no errors.",
            "title": "One-click payroll export"
          }
        ],
        "headline": "Time tracking for cleaning companies — location-verified check-in, attendance proof and payroll in one app",
        "workflow": [
          {
            "body": "One tap checks them in. GPS logs the site and timestamps the entry. Break registration is built into the app.",
            "step": "Cleaner arrives at location"
          },
          {
            "body": "Who is at which site right now — no phone calls, no guesswork. Spot coverage gaps before clients do.",
            "step": "You see every location live"
          },
          {
            "body": "All attendance data — exact times, locations and breaks — exports cleanly for your payroll provider.",
            "step": "Payroll is one click"
          }
        ],
        "compliance": {
          "body": "Done-it gives cleaning teams location-verified check-in at every location, automatic break deduction and a live view of who is on which site right now.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Location-verified attendance",
          "title": "Real-time attendance across every cleaning location"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Installation",
        "slug": "installation",
        "intro": "Send your fitters to the right address with everything they need, link every worked hour to the right job automatically, and see remaining budget before the site closes. Done-it is the simplest way to keep installation projects on time and on cost.",
        "pains": [
          {
            "body": "Crews arrive at a site without the address, contact person or scope details. That first phone call is ten minutes of billable time lost before a single hour is worked.",
            "title": "Job info doesn't reach the field in time"
          },
          {
            "body": "When workers fill in their hours manually at day's end — if they fill them in at all — hours land in the wrong job, or disappear entirely. Invoices don't match reality.",
            "title": "Hours aren't linked to the right project"
          },
          {
            "body": "Without a live countdown of remaining hours per project, you find out a job ran over when you close the invoice — not while you can still react.",
            "title": "Budget overruns spotted too late"
          },
          {
            "body": "Subcontractors working on the same site use different systems, fill in hours separately or not at all. Reconciling at month-end is a slow, error-prone process.",
            "title": "Subcontractor hours hard to track"
          }
        ],
        "quote": {
          "who": "Owner, installation company · 6 employees",
          "text": "Hours land on the right project automatically. Job costing is suddenly easy — we can see the real margin before we close a job.",
          "result": "Real cost per job, live"
        },
        "stats": [
          {
            "label": "remaining-hours view per project",
            "value": "Real-time"
          },
          {
            "label": "office calls for site addresses",
            "value": "0"
          },
          {
            "label": "navigate to any project address from the app",
            "value": "1 click"
          }
        ],
        "features": [
          {
            "body": "Workers open the project on their phone: address, planned hours, contact person and uploaded files (plans, instructions, PDFs). Everything they need is there before they arrive.",
            "plan": "Project Basic",
            "title": "Project info shared directly to the app"
          },
          {
            "body": "Tap once and the phone navigates to the project address — built into the app, no separate map app needed.",
            "title": "One-button navigation to site"
          },
          {
            "body": "Set planned hours when you open the project. Workers see how many hours are left; you see the live status in your dashboard. Overruns are visible before they happen.",
            "plan": "Project Basic",
            "title": "Per-project remaining-hours countdown"
          },
          {
            "body": "Each worker checks in at the right project. You always know who is on which site right now.",
            "plan": "Project Basic",
            "title": "Worker check-in per project"
          },
          {
            "body": "When scope creeps on site, workers log extra work and materials in real time — with text and photos — so nothing gets billed from memory.",
            "plan": "Project Basic",
            "title": "Extra work & material logging"
          }
        ],
        "headline": "Time tracking for installation teams — project hours, navigation and budget control in one app",
        "workflow": [
          {
            "body": "Address, contact, scope and file uploads are right there. They navigate with one tap — no calls to the office for directions.",
            "step": "Worker opens the project on their phone"
          },
          {
            "body": "Check-in ties every worked minute to the correct project. Remaining budget updates in real time.",
            "step": "Hours log automatically to the right job"
          },
          {
            "body": "Scope changes, extra materials and delays are logged with text and photos the moment they happen — ready for the invoice.",
            "step": "Extra work is captured on site"
          }
        ],
        "compliance": {
          "body": "Done-it gives installation teams location-verified check-in per project, a live remaining-hours countdown and automatic payroll export — covering any local time-registration requirement. For teams working on Belgian construction sites, it also integrates with CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "Per-project location-verified check-in for installation teams"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Field service",
        "slug": "field-service",
        "intro": "Technicians visiting multiple clients a day, receipts in gloveboxes, mileage logged from memory. Done-it captures hours, kilometres and expenses in the field — attached to the right job the moment they happen.",
        "pains": [
          {
            "body": "Asking technicians to reconstruct their routes at week's end means inaccurate reimbursements, disputes with clients and a growing pile of unclaimed kilometres.",
            "title": "Mileage logged days later — if at all"
          },
          {
            "body": "A receipt in a glovebox is a cost that may never make it into an invoice. The real cost per job is always an undercount.",
            "title": "Expenses on paper receipts that disappear"
          },
          {
            "body": "Without live check-ins, you only find out where a technician is when something goes wrong and someone calls.",
            "title": "No real-time view of where the team is"
          },
          {
            "body": "When labour, travel and expenses are tracked in separate systems — or not tracked at all — there's no single cost figure per job, ever.",
            "title": "Hard to see the actual margin per job"
          }
        ],
        "quote": {
          "who": "Operations manager, field service company · 11 employees",
          "text": "Mileage used to be a monthly headache. Now it logs itself — every kilometre is attached to the right client before we even get back to the office.",
          "result": "Accurate cost per job, every time"
        },
        "stats": [
          {
            "label": "mileage capture — no manual logbook",
            "value": "Automatic"
          },
          {
            "label": "cost per job: hours + travel + expenses",
            "value": "Live"
          },
          {
            "label": "kilometres lost — every trip captured automatically",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS logs departure, arrival and exact distance per trip. Configure transport types (own car, company vehicle, carpool) with their own reimbursement rates. No manual logbook.",
            "plan": "Add-on",
            "title": "Automatic mileage capture (Trax-it)"
          },
          {
            "body": "Workers snap a receipt in the field; it's attached to the job and ready for reimbursement — not chased at month-end.",
            "plan": "Time Basic",
            "title": "Expense management on site"
          },
          {
            "body": "Hours, mileage and expenses roll up against the job in real time. The cost per job is visible while the job is still open.",
            "plan": "Project Basic",
            "title": "Project-linked cost control"
          },
          {
            "body": "Each technician checks in at the client site. You see who is where, right now — no calls, no guesswork.",
            "title": "Location-verified check-in and live team overview"
          },
          {
            "body": "Hours and kilometre reimbursements export cleanly for your payroll provider — with your configured mileage rates applied automatically.",
            "title": "One-click payroll export"
          }
        ],
        "headline": "Time tracking for field service teams — mileage, expenses and hours from the road, all in one app",
        "workflow": [
          {
            "body": "Check-in starts the trip log. Kilometres are captured automatically from departure to arrival — no manual entry.",
            "step": "Technician leaves for the first call"
          },
          {
            "body": "Hours link to the right project. Extra work, materials and receipts are logged in the app the moment they happen.",
            "step": "At the job site"
          },
          {
            "body": "Every hour, kilometre and expense is already attached to the correct job. Export to payroll and invoice with real cost figures.",
            "step": "Month-end without the chaos"
          }
        ],
        "compliance": {
          "body": "Done-it captures mileage automatically per trip, applies your configured reimbursement rates and logs every kilometre to the right client or project. The EU Tyco ruling means home-to-first-client travel counts as working time — Done-it tracks that too.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Digital time & mileage tracking",
          "title": "GPS hours and automatic mileage for field service teams"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Every service call has three costs: labour, parts and travel. Done-it captures all three in the field and rolls them up against the right job — so you know your margin before you close the invoice.",
        "pains": [
          {
            "body": "Labour, parts and travel live in different systems — or different pockets. The real cost of a call-out only becomes clear long after the technician has left the site.",
            "title": "Service calls are hard to cost accurately"
          },
          {
            "body": "When a client disputes how long a repair took, a paper timesheet is easy to challenge. GPS-confirmed check-in and check-out timestamps are not.",
            "title": "No proof of service time"
          },
          {
            "body": "On recurring maintenance contracts, small overruns accumulate across many visits. Without a live hours counter, you only find out the contract is underwater at renewal.",
            "title": "Maintenance contracts erode margin silently"
          },
          {
            "body": "Manual time entries miss breaks, leading to overpayment and payroll that doesn't match reality.",
            "title": "Technicians forget to log breaks"
          }
        ],
        "quote": {
          "who": "Owner, HVAC company · 7 technicians",
          "text": "We finally know what each service contract actually costs us. The margin surprises stopped the day we started using Done-it.",
          "result": "Real cost per service call, live"
        },
        "stats": [
          {
            "label": "cost types captured per call: labour, travel, parts",
            "value": "3"
          },
          {
            "label": "margin visibility per service contract",
            "value": "Live"
          },
          {
            "label": "surprises at invoice time — costs visible in real time",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Every service call or maintenance contract is a project. Hours, travel and materials roll up in real time — giving you live margin visibility.",
            "plan": "Project Basic",
            "title": "Project-based time tracking"
          },
          {
            "body": "When a job grows, technicians log extra work and parts with text and photos before they leave. Nothing gets billed from memory.",
            "plan": "Project Basic",
            "title": "Extra work and materials, logged on site"
          },
          {
            "body": "Kilometres per call-out are logged automatically and costed against the job. Configure reimbursement rates per vehicle type.",
            "plan": "Add-on",
            "title": "Mileage and transport costs"
          },
          {
            "body": "Mandatory breaks are subtracted automatically from total time — no disputes, no payroll errors.",
            "title": "Automatic break deduction"
          },
          {
            "body": "Timestamped, GPS-confirmed check-in at each site. Undisputable proof of when the technician arrived and left.",
            "title": "Location-verified check-in and proof of presence"
          }
        ],
        "headline": "Time tracking for HVAC technicians — job costing, parts and travel in one app",
        "workflow": [
          {
            "body": "GPS timestamps the arrival and links hours to the service call or maintenance contract. No paper, no terminal.",
            "step": "Technician checks in at the site"
          },
          {
            "body": "Parts used, extra hours and scope changes are logged in the app with photos — before leaving the site.",
            "step": "Extra work is captured on the spot"
          },
          {
            "body": "Labour, travel and materials add up against the project in real time. You see the margin before you issue the invoice.",
            "step": "Job cost is visible immediately"
          }
        ],
        "compliance": {
          "body": "Done-it gives HVAC teams location-verified check-in per service call, live cost visibility per job (labour + travel + parts) and a clean payroll export — meeting any local time-registration requirement without extra hardware.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time & cost tracking",
          "title": "Full job costing for HVAC service calls"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Electricians",
        "slug": "electricians",
        "intro": "Per-project hours, a live countdown of remaining budget and one-button navigation to site — built for small electrical teams that need project control without the admin overhead.",
        "pains": [
          {
            "body": "When electricians work across multiple jobs in a week, manually allocating hours at day's end leads to misattributed costs, billing disputes and payroll you can't explain.",
            "title": "Hours aren't tied to the right project"
          },
          {
            "body": "Without a live view of hours consumed vs. hours budgeted, you find out a project ran over when you raise the invoice — not when you could still react.",
            "title": "Budget overruns spotted too late"
          },
          {
            "body": "Addresses typed into a separate app, calls to the office for directions, late arrivals at client sites. Every wasted minute is a billable minute lost.",
            "title": "Time wasted finding the site"
          },
          {
            "body": "On larger installs, subcontractor electricians track their own hours separately. Getting a combined view of labour costs at the end of a project is a manual, error-prone job.",
            "title": "Subcontractor hours hard to reconcile"
          }
        ],
        "quote": {
          "who": "Owner, electrical company · 5 electricians",
          "text": "We know in real time if a project is running over budget. That alone has saved us from two bad surprises this year.",
          "result": "Budget overruns caught before they happen"
        },
        "stats": [
          {
            "label": "remaining-hours view per project",
            "value": "Live"
          },
          {
            "label": "office calls for site addresses",
            "value": "0"
          },
          {
            "label": "to check in at any site — no terminal needed",
            "value": "1 tap"
          }
        ],
        "features": [
          {
            "body": "Every worked minute is linked to the right project automatically. A live countdown shows how many hours remain against the budget — for you and for the worker on site.",
            "plan": "Project Basic",
            "title": "Project hours with live remaining-budget"
          },
          {
            "body": "The project address is in the app. One tap opens navigation — no searching, no separate map app, no calls to the office.",
            "title": "One-button navigation to site"
          },
          {
            "body": "Each electrician checks in at the right job. You always know who's on which site right now.",
            "plan": "Project Basic",
            "title": "Worker check-in per project"
          },
          {
            "body": "When scope changes — an unexpected circuit, additional materials — it's logged in the app with photos, before the crew leaves.",
            "plan": "Project Basic",
            "title": "Extra work logged on site"
          },
          {
            "body": "Overtime is logged the moment it happens. Workers choose to have it paid out or converted to time off.",
            "plan": "Time Pro",
            "title": "Overtime tracking with flexible compensation"
          }
        ],
        "headline": "Time tracking for electricians — per-project hours, budget control and navigation in one app",
        "workflow": [
          {
            "body": "Address and scope are already in the app. One tap opens navigation — no calls, no confusion.",
            "step": "Electrician navigates to the job"
          },
          {
            "body": "Check-in at the site ties every worked minute to the correct project. The remaining-hours counter updates live.",
            "step": "Hours link to the right project automatically"
          },
          {
            "body": "Extra work and materials are logged on site, before leaving. The invoice reflects what actually happened.",
            "step": "Scope changes stay on the record"
          }
        ],
        "compliance": {
          "body": "Done-it gives electricians per-project location-verified check-in, a live remaining-hours budget and payroll export — satisfying any local time-registration requirement. For teams on Belgian construction sites, it also integrates with CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Per-project location-verified check-in",
          "title": "Live budget control and location-verified check-in for electrical teams"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Plumbing",
        "slug": "plumbing",
        "intro": "Emergency call-outs, multiple jobs per day, hours filled in from memory at week's end — or not at all. Done-it makes it a one-tap job at each site and a one-click payroll at month-end.",
        "pains": [
          {
            "body": "With several jobs in a day, plumbers rarely have time to fill in accurate timesheets. Hours are rounded or forgotten, and payroll is an estimate at best.",
            "title": "Call-out hours reconstructed from memory"
          },
          {
            "body": "When a client disputes how long a repair took, there's no objective record. A GPS-confirmed digital check-in is easy to produce — a paper timesheet is not.",
            "title": "No proof of time on site"
          },
          {
            "body": "Travel between call-outs adds up over the week and month, but without automatic capture it's rarely invoiced or reimbursed correctly.",
            "title": "Mileage between jobs untracked"
          },
          {
            "body": "At month-end, chasing timesheets, correcting errors and building the payroll export takes time your admin team shouldn't be spending.",
            "title": "Payroll preparation is slow"
          }
        ],
        "quote": {
          "who": "Owner, plumbing company · 4 plumbers",
          "text": "We used to spend a morning at month-end reconstructing hours. Now we just export and send. The payroll provider gets it clean.",
          "result": "Payroll prep down from hours to minutes"
        },
        "stats": [
          {
            "label": "to check in — fast enough for emergency calls",
            "value": "1 tap"
          },
          {
            "label": "payroll export to your provider",
            "value": "1 click"
          },
          {
            "label": "hours reconstructed from memory at month-end",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Arrival and departure logged in one tap, with location verification of the location. Fast enough for emergency calls; precise enough for disputes.",
            "plan": "Time Basic",
            "title": "One-tap location-verified check-in at each call-out"
          },
          {
            "body": "Mandatory breaks are subtracted from total time automatically — nothing to fill in, no payroll errors.",
            "plan": "Time Basic",
            "title": "Automatic break deduction"
          },
          {
            "body": "Configure transport types and reimbursement rates. Kilometres log automatically and link to the correct client or project.",
            "plan": "Add-on",
            "title": "Mileage captured per trip"
          },
          {
            "body": "Workers submit sick notes digitally from the app. Create the absence types your team actually uses, including weather delays.",
            "title": "Absence and sick-note management"
          },
          {
            "body": "All hours and kilometre data exports cleanly for your payroll provider — no manual preparation, no Excel.",
            "plan": "Time Basic",
            "title": "One-click payroll export"
          }
        ],
        "headline": "Time tracking for plumbing teams — fast check-in, accurate payroll and proof of presence for every call-out",
        "workflow": [
          {
            "body": "One tap checks in. GPS logs the location and time. Fast enough for an emergency job.",
            "step": "Plumber arrives at the call-out"
          },
          {
            "body": "Check-out closes the time entry. Mileage to the next job starts logging automatically.",
            "step": "Departure tapped on the way out"
          },
          {
            "body": "All call-outs, hours and kilometres export cleanly. Payroll prep goes from a day to minutes.",
            "step": "Month-end is one click"
          }
        ],
        "compliance": {
          "body": "Done-it covers any local time-registration requirement for plumbing teams — one-tap location-verified check-in per call-out, automatic break deduction and a clean payroll export. No paper timesheets, no manual reconstruction.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "Fast location-verified check-in for every call-out"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Landscaping",
        "slug": "landscaping",
        "intro": "Peak season means many sites, changing crews and a lot of kilometres. Done-it keeps every hour, every absence and every trip organised — so you can focus on the work, not the paperwork.",
        "pains": [
          {
            "body": "Temporary workers, shifting schedules and varying team sizes make accurate hour tracking almost impossible with paper. By the time you reconcile at month-end, something is always missing.",
            "title": "Seasonal crews are complex to manage"
          },
          {
            "body": "A crew that visits three or four sites per day generates hours that need to be split correctly. Manual entry leads to misattribution and contested payroll.",
            "title": "Hours spread across many sites"
          },
          {
            "body": "Bad-weather standstill is a real event in landscaping. Without a digital record, documenting stoppages and adjusting pay is slow and error-prone.",
            "title": "Weather stoppages are hard to document"
          },
          {
            "body": "Company vans, personal vehicles and carpools crisscross between sites all day. Without automatic capture, those kilometres never make it into the cost picture.",
            "title": "Mileage between sites goes untracked"
          }
        ],
        "quote": {
          "who": "Owner, landscaping company · 12 seasonal workers",
          "text": "Peak season used to mean payroll chaos. Now our foreman checks the app, everyone is accounted for, and I export the hours on the last day of the month.",
          "result": "No more end-of-month payroll reconstruction"
        },
        "stats": [
          {
            "label": "mileage capture — no more logbook",
            "value": "Automatic"
          },
          {
            "label": "crew overview across all sites",
            "value": "Live"
          },
          {
            "label": "payroll export for all sites and all crew",
            "value": "1 click"
          }
        ],
        "features": [
          {
            "body": "See all crew, all sites in real time. Know who is working where, right now — not at month-end.",
            "title": "Multi-site crew overview"
          },
          {
            "body": "Plan who works where, handle last-minute changes and push the schedule to the team's phones — without a phone call to each person.",
            "plan": "Time Pro",
            "title": "Shift scheduling for seasonal teams"
          },
          {
            "body": "Create custom absence types for your sector: seasonal weather stoppages, parental leave, sick days. Workers upload documentation digitally from the app.",
            "title": "Custom absence types"
          },
          {
            "body": "Configure transport types (company van, personal car, carpool driver vs. passenger) with their own rates. Kilometres log automatically per trip.",
            "plan": "Add-on",
            "title": "Mileage with carpool tracking"
          },
          {
            "body": "Peak-season overtime accumulates fast. Each worker can choose to be paid out or bank the hours as time off — tracked transparently.",
            "plan": "Time Pro",
            "title": "Overtime tracking with leave conversion"
          }
        ],
        "headline": "Time tracking for landscaping companies — seasonal crews, multiple sites and mileage in one overview",
        "workflow": [
          {
            "body": "GPS logs arrival. Hours automatically split to the right location and project — no manual allocation at day's end.",
            "step": "Crew checks in at the first site"
          },
          {
            "body": "Foreman registers the stoppage from the app — a clean digital record, no extra paperwork.",
            "step": "Weather stops work"
          },
          {
            "body": "Hours, absences and mileage across every site and every crew member export cleanly for payroll.",
            "step": "Month-end: all sites, all crew, one export"
          }
        ],
        "compliance": {
          "body": "Done-it gives landscaping teams digital time registration across all sites and seasonal staff — location-verified check-in, custom absence types for weather stoppages and a clean payroll export satisfying any local requirement.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "Location-verified check-in and absence tracking for seasonal landscaping teams"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Maintenance",
        "slug": "maintenance",
        "intro": "Recurring maintenance contracts live or die on cost visibility. Done-it logs every visit, tracks hours against the contract budget and gives you — and your clients — proof of presence for every call.",
        "pains": [
          {
            "body": "When hours for recurring visits aren't tracked against the specific contract, you don't know if a client is profitable until the year-end review — by which point it's too late to reprice.",
            "title": "No cost visibility per maintenance contract"
          },
          {
            "body": "Facilities managers and property owners increasingly want attendance records: who came, when they arrived, what they did. A paper log presented weeks later doesn't satisfy SLA requirements.",
            "title": "Clients expect proof of what was done"
          },
          {
            "body": "Rotating shifts across many recurring sites — with staff who cover for each other — create a scheduling and hour-tracking puzzle that manual processes can't reliably solve.",
            "title": "Recurring visits hard to schedule and log"
          },
          {
            "body": "Groundskeeping, facade maintenance and outdoor facilities work all face weather-related stoppages. Documenting them correctly requires a digital trail.",
            "title": "Weather stoppages affect outdoor maintenance too"
          }
        ],
        "quote": {
          "who": "Operations manager, maintenance company · 8 workers",
          "text": "We can tell a facilities manager exactly who was on site and when, in two minutes. That level of proof changed how clients see us.",
          "result": "Client disputes down to zero"
        },
        "stats": [
          {
            "label": "cost per maintenance contract",
            "value": "Live"
          },
          {
            "label": "attendance proof ready for clients on demand",
            "value": "GPS"
          },
          {
            "label": "contract renewals without knowing your margin",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Each maintenance contract is a project. Hours log automatically against it, giving you a live cost figure and remaining-hours countdown for each client.",
            "plan": "Project Basic",
            "title": "Contract-based cost tracking"
          },
          {
            "body": "Timestamped, location-verified check-ins are an undisputable record of who was on site, when, and for how long — ready to share with clients on request.",
            "title": "GPS-confirmed attendance proof"
          },
          {
            "body": "Workers report issues, completed tasks or extra work directly from the app — with text and photos. Clients get a real-time record; you have the documentation for billing.",
            "plan": "Project Basic",
            "title": "Updates with photos from site"
          },
          {
            "body": "Plan recurring visits across all contracts, assign workers and handle substitutions — without a phone call to each person.",
            "plan": "Time Pro",
            "title": "Recurring shift scheduling"
          },
          {
            "body": "Configure weather stoppages and other absence types. Workers register them from the app; documentation uploads digitally.",
            "title": "Absence types for outdoor maintenance"
          }
        ],
        "headline": "Time tracking for maintenance teams — recurring site visits, cost per contract and attendance proof in one app",
        "workflow": [
          {
            "body": "Location-verified check-in logs the arrival time and links hours to the correct contract. Attendance proof is created automatically.",
            "step": "Worker arrives at the maintenance site"
          },
          {
            "body": "Work completed and any issues are reported from the app with photos. Clients can see exactly what was done.",
            "step": "Tasks completed, issues logged"
          },
          {
            "body": "Hours accumulate against the contract budget in real time. You know the margin before the contract renews.",
            "step": "Cost per contract visible immediately"
          }
        ],
        "compliance": {
          "body": "Done-it gives maintenance teams GPS-confirmed attendance proof per contract, custom absence types and a live cost view per recurring client — satisfying any local time-registration requirement without extra hardware.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Contract-based time tracking",
          "title": "Live cost visibility per maintenance contract"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Shops & retail",
        "slug": "retail",
        "intro": "Opening shifts, late shifts and someone always covering for someone else. Done-it gives every shop a clean digital record of who worked which shift — clocked in on their own phone, ready for payroll at month-end.",
        "pains": [
          {
            "body": "Someone covers a sick colleague, someone stays an hour late at closing. It gets remembered on a note, or not at all — and payroll is wrong before you start.",
            "title": "Shift swaps never make it to payroll"
          },
          {
            "body": "Staff move between branches, part-timers work across two locations. Collecting hours per shop and merging them by hand costs a day every month.",
            "title": "Several shops, one payroll run"
          },
          {
            "body": "Statutory breaks get deducted from memory and extra hours are settled informally — the two things an inspection asks about first.",
            "title": "Breaks and overtime are guesswork"
          }
        ],
        "quote": {
          "who": "Owner, retail · 11 employees",
          "text": "Two shops and a lot of part-timers. Before, half the cover shifts were settled from memory. Now every hour is on the right shop and payroll takes minutes.",
          "result": "Payroll prep from a day to under an hour"
        },
        "stats": [
          {
            "label": "to clock in — no terminal at the till",
            "value": "1 tap"
          },
          {
            "label": "view of who is in, across every shop",
            "value": "Live"
          },
          {
            "label": "shift swaps lost between the floor and payroll",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "One tap on their own phone at the start of the shift. No terminal at the till, no shared card, no clipboard by the stockroom door.",
            "title": "Clock in on the shop floor"
          },
          {
            "body": "Each shop is a project. Someone covering another branch is clocked against that branch — you see the hours where they were actually worked.",
            "title": "Hours per shop, staff across branches"
          },
          {
            "body": "Set the break rule once and it applies to every shift. Overtime is logged the moment it happens, and each employee picks payout or time off.",
            "title": "Breaks deducted automatically"
          }
        ],
        "headline": "Time tracking for shops — shift clock-in, cover and a payroll-ready export, in one app",
        "workflow": [
          {
            "body": "One tap on their phone as the shift starts. Cover for another branch is clocked against that branch.",
            "step": "Staff clock in for their shift"
          },
          {
            "body": "A live view across every location — spot an unfilled opening shift before the doors open.",
            "step": "You see who is in, per shop"
          },
          {
            "body": "Hours, breaks and overtime per employee and per shop, exported ready for your payroll provider.",
            "step": "Payroll in one export"
          }
        ],
        "compliance": {
          "body": "Done-it keeps an objective digital record of every clock-in and clock-out, with breaks and overtime — the record an audit or a payroll dispute asks for.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shift-based time registration",
          "title": "A defensible record of every shift worked"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Offices & professional services",
        "slug": "offices",
        "intro": "Accountants, notaries, architects, agencies and consultancies bill their time — or at least need to know where it went. Done-it records hours against the right client and project, from the desk or on the road.",
        "pains": [
          {
            "body": "Time written down at the end of the week is time guessed. Whole hours quietly disappear between the work and the invoice.",
            "title": "Billable hours reconstructed on Friday"
          },
          {
            "body": "The fee was agreed months ago. Whether the work still fits inside it only becomes clear when someone adds it up — usually too late.",
            "title": "No idea what a client actually costs"
          },
          {
            "body": "Part of the team is at the office, part at home, part at the client. Attendance stops being a fact and becomes a reconstruction.",
            "title": "Hybrid work makes the record patchy"
          }
        ],
        "quote": {
          "who": "Partner, accountancy practice · 8 employees",
          "text": "We used to rebuild the week every Friday. Now the hours are already on the right client and I can see which files are eating the fee.",
          "result": "Billable hours recovered every month"
        },
        "stats": [
          {
            "label": "hours, visible while the work is still running",
            "value": "Per client"
          },
          {
            "label": "same record, phone and browser",
            "value": "Desk or road"
          },
          {
            "label": "for payroll and invoicing",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Every entry lands on a project, so you can see the hours per client without exporting anything or asking anyone.",
            "title": "Hours against client and project"
          },
          {
            "body": "The same app on the phone or the browser. Visiting a client counts as work on that client, including the travel if you want it to.",
            "title": "Works at the desk and off-site"
          },
          {
            "body": "Extra hours logged as they happen, leave requested and approved in the app — no parallel spreadsheet of who is off when.",
            "title": "Overtime and leave in one place"
          }
        ],
        "headline": "Time tracking for offices — hours per client and project, without the spreadsheet",
        "workflow": [
          {
            "body": "Set it up once with the client and, if you bill by budget, the hours you planned.",
            "step": "Open a client project"
          },
          {
            "body": "From the desk or the phone. Every hour lands on a client, not in someone's memory.",
            "step": "The team logs time to it"
          },
          {
            "body": "Live totals per project, and a clean export for payroll or invoicing at month-end.",
            "step": "See hours per client, export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital, tamper-evident record of working time per employee — the basis for both payroll and a defensible client invoice.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Per-client time registration",
          "title": "An objective record of hours worked"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salons & body care",
        "slug": "beauty",
        "intro": "Hairdressers, barbers, nail and beauty studios run on shifts and part-time contracts. Done-it records who worked when, deducts breaks automatically and hands payroll a clean file.",
        "pains": [
          {
            "body": "Three days one week, four the next, a Saturday swapped for a Tuesday. Contracted hours and worked hours drift apart fast.",
            "title": "Part-time contracts, endless variations"
          },
          {
            "body": "Appointments say what was booked, not who worked. When payroll or an inspection asks, the booking system is the wrong answer.",
            "title": "The diary is not a time record"
          },
          {
            "body": "Staying late for a last client is remembered, promised, and sometimes forgotten. That is the kind of gap that turns into a dispute.",
            "title": "Extra hours settled informally"
          }
        ],
        "quote": {
          "who": "Owner, hair salon · 6 employees",
          "text": "Everyone is part-time and every week is different. The app just records it — I stopped rebuilding the month in a spreadsheet.",
          "result": "No more disputed hours at month-end"
        },
        "stats": [
          {
            "label": "to clock in — nothing shared, nothing on paper",
            "value": "1 tap"
          },
          {
            "label": "break deduction on every shift",
            "value": "Auto"
          },
          {
            "label": "late hours settled from memory",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "One tap on their own phone at the start of the shift — no shared terminal at the desk, no signature list by the mirror.",
            "title": "Clock in at the salon"
          },
          {
            "body": "Set the break rule and the standard hours once; they apply to every shift, with per-person exceptions where a contract differs.",
            "title": "Breaks and part-time rules once"
          },
          {
            "body": "Extra hours are logged as they are worked, and each employee chooses payout or time off in lieu — settled in the app, not by memory.",
            "title": "Overtime, paid or taken back"
          }
        ],
        "headline": "Time tracking for salons — shifts, part-time hours and payroll without the paper diary",
        "workflow": [
          {
            "body": "One tap on arrival. Breaks are deducted by the rule you set once.",
            "step": "Staff clock in for the shift"
          },
          {
            "body": "Who is in, who is on a break, who stayed late — live, without asking.",
            "step": "You see the day as it runs"
          },
          {
            "body": "Worked hours, breaks and overtime per employee, exported for your payroll provider.",
            "step": "Payroll gets a clean file"
          }
        ],
        "compliance": {
          "body": "Done-it records actual working time per employee, with breaks and overtime — separate from bookings, and defensible when it is checked.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "A record that holds up beyond the appointment book"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Health & wellness",
        "slug": "wellness",
        "intro": "Gyms, fitness studios, physio practices and spas run long opening hours with rotating staff. Done-it records who covered which shift, deducts breaks automatically and exports payroll cleanly.",
        "pains": [
          {
            "body": "Early shifts, evening classes and weekends, filled by a mix of full-time, part-time and freelance staff. The roster is a plan, not a record.",
            "title": "Long opening hours, rotating cover"
          },
          {
            "body": "An instructor teaches two classes and covers reception in between. Paying that correctly means knowing what was actually worked, not what was scheduled.",
            "title": "Class hours and floor hours blur"
          },
          {
            "body": "Staff move between studios. Merging their hours by hand each month is slow and error-prone.",
            "title": "Several locations, one administration"
          }
        ],
        "quote": {
          "who": "Manager, fitness studio · 14 employees",
          "text": "Two studios, long opening hours and a lot of cover shifts. Now the hours land on the right site and payroll is one file.",
          "result": "Roster and payroll finally agree"
        },
        "stats": [
          {
            "label": "hours, even when staff cover elsewhere",
            "value": "Per studio"
          },
          {
            "label": "view of the floor across locations",
            "value": "Live"
          },
          {
            "label": "breaks and overtime, no manual maths",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "One tap on their phone at the site they are working. Cover at another studio lands on that studio's hours.",
            "title": "Clock in per studio"
          },
          {
            "body": "See the floor across every location in real time — an unfilled early shift is visible before the doors open, not after.",
            "title": "Live view of who is in"
          },
          {
            "body": "Break rules applied automatically, extra hours logged as they happen with payout or time off in lieu per employee.",
            "title": "Breaks and overtime handled"
          }
        ],
        "headline": "Time tracking for gyms, studios and spas — shifts, classes and payroll in one app",
        "workflow": [
          {
            "body": "One tap at the start of the shift, on the site where they are working.",
            "step": "Staff clock in at the studio"
          },
          {
            "body": "Who is in at which location right now, so gaps are filled before members notice.",
            "step": "Cover is visible live"
          },
          {
            "body": "Hours, breaks and overtime per employee and per studio, ready for the payroll provider.",
            "step": "One export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital record of working time per employee and per location — the basis for correct pay and for any check on hours worked.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Multi-site shift registration",
          "title": "An objective record for every shift and site"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Hospitality",
        "slug": "hospitality",
        "intro": "Split shifts, late closes and a busy Saturday that runs over. Done-it records the hours as they are actually worked, deducts breaks by your rule and gives payroll one clean file.",
        "pains": [
          {
            "body": "Service runs late, closing takes another half hour. Those minutes are real work, and settling them from memory is how disputes start.",
            "title": "The shift never ends when the roster says"
          },
          {
            "body": "Lunch service, a break, then dinner. On paper it becomes one long block or two guesses — neither is the truth.",
            "title": "Split shifts are hard to record"
          },
          {
            "body": "New staff every season. Any system that needs training will not survive the first busy week.",
            "title": "High turnover, constant onboarding"
          }
        ],
        "quote": {
          "who": "Owner, restaurant · 17 employees",
          "text": "Closing always runs over. Now those minutes are logged instead of argued about, and staff can take them back as time off.",
          "result": "Fewer disputes, faster payroll"
        },
        "stats": [
          {
            "label": "recorded as two blocks, not one guess",
            "value": "Split shifts"
          },
          {
            "label": "break deduction per your rule",
            "value": "Auto"
          },
          {
            "label": "to onboard a new starter — it is their own phone",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "One tap at the start and end of each block, so split shifts are recorded as they happened — not merged into one.",
            "title": "Clock in and out per service"
          },
          {
            "body": "Mandatory breaks deducted automatically, with exceptions per person where a contract needs it. No manual maths at month-end.",
            "title": "Breaks by your rule"
          },
          {
            "body": "The extra half hour after closing is logged the moment it is worked, and paid out or taken back as time off — the employee chooses.",
            "title": "Overtime settled in the app"
          }
        ],
        "headline": "Time tracking for cafés, restaurants and hotels — shifts, breaks and overtime, settled fairly",
        "workflow": [
          {
            "body": "One tap at the start of the block; the same at the end. Split shifts stay split.",
            "step": "Staff clock in for service"
          },
          {
            "body": "Who is in for tonight's service, who is still on a break, who stayed past closing.",
            "step": "You see the floor live"
          },
          {
            "body": "Worked time, breaks and overtime per employee, exported in one file.",
            "step": "Payroll gets the real hours"
          }
        ],
        "compliance": {
          "body": "Done-it keeps an objective digital record of every shift, break and extra hour — which is exactly what a payroll check or a labour inspection asks to see.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Split-shift time registration",
          "title": "A defensible record of hours in a high-turnover team"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Healthcare & care",
        "slug": "healthcare",
        "intro": "Practices, home-care teams and care homes run around shifts, visits and strict record-keeping. Done-it registers worked time per shift and per visit, and keeps employee documents where you can find them.",
        "pains": [
          {
            "body": "Home visits live in one tool, rostered hours in another, and payroll gets a third version. Reconciling them is a monthly job.",
            "title": "Visits and shifts in separate systems"
          },
          {
            "body": "Unsocial hours carry different rates. When the record is approximate, so is the pay — and the correction comes later.",
            "title": "Night and weekend hours priced wrong"
          },
          {
            "body": "Qualifications and certificates matter in care, and they sit in a folder nobody opens until an inspection asks.",
            "title": "Certificates expire quietly"
          }
        ],
        "quote": {
          "who": "Coordinator, home-care team · 22 employees",
          "text": "Home visits and rostered shifts finally sit in the same record. Payroll stopped being a reconciliation exercise.",
          "result": "One record instead of three"
        },
        "stats": [
          {
            "label": "or per shift — whichever your team runs on",
            "value": "Per visit"
          },
          {
            "label": "night and weekend hours, recorded as worked",
            "value": "Split"
          },
          {
            "label": "certificates stored per employee",
            "value": "Filed"
          }
        ],
        "features": [
          {
            "body": "One tap at the start of the shift, or at each client address for home care — location-verified where you need the proof.",
            "title": "Clock in per shift or per visit"
          },
          {
            "body": "Night, weekend and regular hours are recorded distinctly, so the payroll export already reflects how the work is actually paid.",
            "title": "Hours split the way you pay them"
          },
          {
            "body": "Contracts, certificates and IDs stored next to the person they belong to — found in seconds when someone asks for them.",
            "title": "Employee documents in one place"
          }
        ],
        "headline": "Time tracking for care teams — shifts, home visits and qualifications, in one record",
        "workflow": [
          {
            "body": "One tap at the site or the client's address, location-verified where proof is needed.",
            "step": "Clock in for the shift or visit"
          },
          {
            "body": "Regular, night and weekend hours recorded distinctly as they happen.",
            "step": "Hours land in the right bucket"
          },
          {
            "body": "One clean file per period, already split the way you pay it.",
            "step": "Export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital, objective record of working time per employee — hours, breaks and unsocial-hour splits — alongside the documents that go with each person.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shift & visit registration",
          "title": "Records that survive an inspection"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "nl": [
      {
        "name": "Bouw",
        "slug": "construction",
        "intro": "Ploegen verspreid over werven, uren op papier gekrabbeld, naleving door onderaannemers een constante zorg. Done-it geeft elke werf een waterdichte digitale tijdsregistratie die de inspecteur tevredenstelt en in één klik je loonverwerking voedt.",
        "pains": [
          {
            "body": "Met meerdere actieve werven en wisselende ploegen kloppen handmatige urenstaten per definitie niet. Werknemers ronden af, vergeten registraties of vullen ze dagen later in — waardoor je met loongegevens zit die je niet kan verantwoorden.",
            "title": "Geen betrouwbaar overzicht van wie waar werkte"
          },
          {
            "body": "De Belgische wet kent een hoofdelijke aansprakelijkheid: als een onderaannemer zijn werknemers niet registreert (Dimona) of CheckIn@Work niet naleeft, draag jij als hoofdaannemer het inspectierisico. Zonder één overzicht tast je in het duister.",
            "title": "Onderaannemers zijn ook jouw aansprakelijkheid"
          },
          {
            "body": "Tegen de tijd dat je merkt dat een werf zijn geplande uren heeft opgebruikt, is de marge al weg. Er is geen live aftelling — alleen een nare verrassing op het moment van facturatie.",
            "title": "Budgetoverschrijdingen komen te laat aan het licht"
          },
          {
            "body": "Urenstaten verzamelen, ze afstemmen op projecten en ze vertalen voor het sociaal secretariaat neemt dagen in beslag. Elke registratie is een mogelijke fout.",
            "title": "Loonvoorbereiding kost elke maand uren"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, bouwbedrijf · 14 werknemers",
          "text": "Onze ploeg checkt zichzelf in op de werf. Op het einde van de maand klopt de loonverwerking gewoon — we zijn helemaal gestopt met achter urenstaten aan te lopen.",
          "result": "5 uur per week bespaard op administratie"
        },
        "stats": [
          {
            "label": "om in te checken op elke werf — geen terminal, geen papier",
            "value": "1 tik"
          },
          {
            "label": "loonexport klaar voor je sociaal secretariaat",
            "value": "1 klik"
          },
          {
            "label": "algemene verplichting tot tijdsregistratie — wees klaar",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Eén tik checkt de werknemer in, locatiegeverifieerd, en koppelt de uren aan het juiste project. Geen kaartlezers, geen terminals — gewoon de smartphone die je ploeg al op zak heeft. Voedt check-in at work voor Belgische werven.",
            "title": "Locatiegeverifieerde check-in per werf"
          },
          {
            "body": "Stel de geplande uren in als budget wanneer je het project opent. Werknemers zien een aftelling van wat er nog rest; jij ziet het live in je dashboard. Budgetoverschrijdingen zijn zichtbaar voordat ze gebeuren.",
            "title": "Live resterende uren per project"
          },
          {
            "body": "Voeg onderaannemers toe aan een project, wijs ze toe aan de check-in en volg hun uren samen met je eigen ploeg — in hetzelfde overzicht.",
            "title": "Beheer en aanwezigheid van onderaannemers"
          },
          {
            "body": "Done-it stuurt aanwezigheidsgegevens automatisch door naar het officiële Belgische CheckIn@Work-platform. Geen dubbele invoer, geen handmatige sessies op het RSZ-portaal.",
            "title": "CheckIn@Work-synchronisatie"
          },
          {
            "body": "Alle geregistreerde uren — per werknemer, per project — exporteer je naar een nette spreadsheet en stuur je rechtstreeks door naar je sociaal secretariaat.",
            "title": "Loonexport in één klik"
          }
        ],
        "headline": "Tijdsregistratie voor bouwteams — locatiegeverifieerde check-in, projecturen en checkin@work, in één app",
        "workflow": [
          {
            "body": "Elke werknemer tikt één keer om in te checken. GPS bevestigt de locatie, registreert het tijdstip en koppelt de uren aan het project. Geen papier, geen terminal.",
            "step": "Ploeg komt aan op de werf"
          },
          {
            "body": "Uren, resterend budget, aanwezigheid van onderaannemers en elk gemeld meerwerk vanaf de werf — allemaal in je dashboard, in real time.",
            "step": "Je ziet alles live"
          },
          {
            "body": "Exporteer alle uren per werknemer en per project. Stuur ze naar je sociaal secretariaat. De gegevens van Done-it voldoen al aan CheckIn@Work en de vereisten van 2027.",
            "step": "Maandeinde in enkele minuten"
          }
        ],
        "compliance": {
          "body": "Op Belgische bouwwerven moet de aankomst van elke werknemer geregistreerd worden via check-in at work en doorgestuurd worden naar de RSZ (voor werven boven de drempel). Vandaag is dat enkel de check-in — de aankomst. Vanaf 1 januari 2027 voegt een algemene verplichting een volledige arbeidstijdregistratie toe voor elke werkgever, inclusief de bouw: je moet een betrouwbaar overzicht bijhouden van de volledige arbeidstijd (het begin en het einde van de dag moeten niet automatisch naar de RSZ doorgestuurd worden). Done-it dekt beide — het voedt check-in at work én houdt de waterdichte tijdsregistratie bij die de regels van 2027 vereisen.",
          "slug": "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "label": "Check-in at work + wet van 2027",
          "title": "De bouw registreert al aanwezigheid — en 2027 voegt er meer aan toe"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-vermijd-je-boetes-met-digitale-oplossingen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Schoonmaak",
        "slug": "cleaning",
        "intro": "Check-in and out at work (CIAO@work) is verplicht sinds 1 september 2024: realtime in- en uitchecken voor elke schoonmaker, op elke locatie, geen terugwerkende invoer toegestaan. Done-it verzorgt de registratie automatisch en zet ze om in een nette loonexport.",
        "pains": [
          {
            "body": "Elke werknemer moet zelf in real time in- en uitchecken, inclusief pauzes — en dat wordt telkens naar de RSZ doorgestuurd, soms meerdere keren per dag. De werkgever kan het niet in hun plaats doen, en voorafgaande registratie is verboden. Eén gemiste registratie is een inbreuk.",
            "title": "Check-in and out at work is verplicht — en omslachtig"
          },
          {
            "body": "De Belgische wet kent een hoofdelijke aansprakelijkheid: als een onderaannemer zijn werknemers niet registreert (Dimona) of check-in and out at work niet naleeft, draag jij als hoofdaannemer het inspectierisico. Zonder één overzicht tast je in het duister.",
            "title": "Onderaannemers zijn ook jouw aansprakelijkheid"
          },
          {
            "body": "Klanten en inspecteurs verwachten waterdichte aanwezigheidsregistraties. Manuele lijsten kunnen betwist worden; locatiegeverifieerde digitale check-ins niet.",
            "title": "Aanwezigheid bewijzen op elke locatie"
          },
          {
            "body": "Met schoonmakers die zich doorheen de dag tussen locaties verplaatsen, heb je geen live zicht op wie waar werkt — tot er iemand belt.",
            "title": "Teams verspreid over veel locaties"
          },
          {
            "body": "Zonder nauwkeurige in-/uittijden wordt de loonverwerking uit het geheugen gereconstrueerd. Uren worden naar boven afgerond, kosten lopen op en discussies volgen.",
            "title": "Loonfouten door afgeronde uren"
          }
        ],
        "quote": {
          "who": "Manager, schoonmaakbedrijf · 9 werknemers",
          "text": "We kunnen eindelijk bewijzen wie waar en wanneer schoonmaakte. Geen aanwezigheidslijsten meer, geen discussies met klanten meer — GPS regelt het.",
          "result": "Geen enkele afronding van uren naar boven"
        },
        "stats": [
          {
            "label": "2024 — check-in and out at work werd verplicht",
            "value": "1 sep"
          },
          {
            "label": "boete per werknemer bij niet-naleving",
            "value": "€300–€6k"
          },
          {
            "label": "dubbele invoeren — Done-it synchroniseert automatisch",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Werknemers tikken in en uit op hun telefoon op elke locatie, locatiegeverifieerd; de tijd is exact, met registratie van pauzes. (De officiële check-in and out at work / CIAO@work-integratie maakt deel uit van de Project plans.)",
            "plan": "Time Basic",
            "title": "Realtime check-in and out"
          },
          {
            "body": "Verplichte pauzes worden automatisch van de werkdag afgetrokken — geen handmatig rekenwerk, geen discussies.",
            "plan": "Time Basic",
            "title": "Automatische pauze-aftrek"
          },
          {
            "body": "Zie welke schoonmakers op welke locaties zijn op dit moment. Spot lacunes voordat klanten ze opmerken.",
            "title": "Live overzicht over meerdere locaties"
          },
          {
            "body": "Werknemers laden ziektebriefjes en afwezigheidsdocumenten rechtstreeks op vanuit de app. Ondersteunt weerverlet en andere afwezigheidstypes die relevant zijn voor de sector.",
            "title": "Afwezigheidsregistratie met digitale ziektebriefjes"
          },
          {
            "body": "Conforme tijdstempels stromen rechtstreeks door naar een loonklare export voor je sociaal secretariaat. Geen overtypen, geen fouten.",
            "title": "Loonexport in één klik"
          }
        ],
        "headline": "Tijdsregistratie voor schoonmaakbedrijven — check-in and out at work, aanwezigheidsbewijs en loonverwerking in één app",
        "workflow": [
          {
            "body": "Eén tik checkt hem in, locatiegeverifieerd. Begin en einde van de pauze worden geregistreerd in de app — precies zoals check-in and out at work vereist.",
            "step": "Schoonmaker komt aan op de locatie"
          },
          {
            "body": "Done-it stuurt de in-/uitgegevens in real time door naar het officiële platform. Je hoeft je nooit handmatig op het portaal aan te melden.",
            "step": "Gegevens stromen automatisch naar de RSZ"
          },
          {
            "body": "Alle aanwezigheidsgegevens — met exacte tijden, locaties en pauzes — exporteer je netjes voor je sociaal secretariaat.",
            "step": "Loonverwerking is één klik"
          }
        ],
        "compliance": {
          "body": "Check-in and out at work (CIAO@work) is verplicht voor het professioneel reinigen van onroerende goederen van derden sinds 1 september 2024. Elke werknemer — werknemer, zelfstandige, uitzendkracht of stagiair — moet het begin en het einde van het werk in real time registreren, inclusief pauzes, telkens doorgestuurd naar de RSZ (soms meerdere keren per dag). De verplichting treedt in werking vanaf €30.000 (geen onderaannemer), €5.000 (één onderaannemer), of elk bedrag bij twee of meer onderaannemers. Boetes onder het Sociaal Strafwetboek lopen van €300 tot €6.000 per werknemer. Done-it synchroniseert de in-/uitgegevens automatisch met het officiële platform — geen dubbele invoer.",
          "slug": "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "label": "Check-in and out at work — verplicht sinds sept 2024",
          "title": "Check-in and out at work is actief — elk schoonmaakbedrijf moet voldoen"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Installatie",
        "slug": "installation",
        "intro": "Stuur je monteurs naar het juiste adres met alles wat ze nodig hebben, koppel elk gewerkt uur automatisch aan de juiste job, en zie het resterende budget voordat de werf sluit. Done-it is de eenvoudigste manier om installatieprojecten op tijd en op kosten te houden.",
        "pains": [
          {
            "body": "Ploegen komen aan op een werf zonder het adres, de contactpersoon of de details van de opdracht. Dat eerste telefoontje is tien minuten factureerbare tijd verloren voordat er één uur gewerkt is.",
            "title": "Jobinfo bereikt het terrein niet op tijd"
          },
          {
            "body": "Wanneer werknemers hun uren handmatig invullen op het einde van de dag — als ze ze al invullen — belanden uren in de verkeerde job, of verdwijnen ze helemaal. Facturen kloppen niet met de werkelijkheid.",
            "title": "Uren zijn niet gekoppeld aan het juiste project"
          },
          {
            "body": "Zonder een live aftelling van de resterende uren per project kom je er pas achter dat een job is uitgelopen wanneer je de factuur opmaakt — niet wanneer je nog kan reageren.",
            "title": "Budgetoverschrijdingen worden te laat opgemerkt"
          },
          {
            "body": "Onderaannemers die op dezelfde werf werken, gebruiken andere systemen, vullen hun uren apart in of helemaal niet. Op het einde van de maand afstemmen is een traag en foutgevoelig proces.",
            "title": "Uren van onderaannemers moeilijk te volgen"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, installatiebedrijf · 6 werknemers",
          "text": "Uren belanden automatisch op het juiste project. Job costing is plots eenvoudig — we zien de echte marge voordat we een job afsluiten.",
          "result": "Werkelijke kost per job, live"
        },
        "stats": [
          {
            "label": "zicht op resterende uren per project",
            "value": "Real-time"
          },
          {
            "label": "telefoontjes naar kantoor voor werfadressen",
            "value": "0"
          },
          {
            "label": "algemene verplichting tot tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Werknemers openen het project op hun telefoon: adres, geplande uren, contactpersoon en opgeladen bestanden (plannen, instructies, PDF's). Alles wat ze nodig hebben staat er voordat ze aankomen.",
            "plan": "Project Basic",
            "title": "Projectinfo rechtstreeks gedeeld in de app"
          },
          {
            "body": "Tik één keer en de telefoon navigeert naar het projectadres — ingebouwd in de app, geen aparte kaartapp nodig.",
            "title": "Navigatie naar de werf met één knop"
          },
          {
            "body": "Stel de geplande uren in wanneer je het project opent. Werknemers zien hoeveel uren er nog rest; jij ziet de live status in je dashboard. Overschrijdingen zijn zichtbaar voordat ze gebeuren.",
            "plan": "Project Basic",
            "title": "Aftelling van resterende uren per project"
          },
          {
            "body": "Elke werknemer checkt in bij het juiste project. Je weet altijd wie op dit moment op welke werf zit.",
            "plan": "Project Basic",
            "title": "Check-in van werknemers per project"
          },
          {
            "body": "Wanneer de opdracht op de werf uitbreidt, registreren werknemers meerwerk en materiaal in real time — met tekst en foto's — zodat niets uit het geheugen gefactureerd wordt.",
            "plan": "Project Basic",
            "title": "Registratie van meerwerk & materiaal"
          }
        ],
        "headline": "Tijdsregistratie voor installatieteams — projecturen, navigatie en budgetbeheer in één app",
        "workflow": [
          {
            "body": "Adres, contact, opdracht en opgeladen bestanden staan er meteen. Ze navigeren met één tik — geen telefoontjes naar kantoor voor de weg.",
            "step": "Werknemer opent het project op zijn telefoon"
          },
          {
            "body": "De check-in koppelt elke gewerkte minuut aan het juiste project. Het resterende budget wordt live bijgewerkt.",
            "step": "Uren worden automatisch op de juiste job geregistreerd"
          },
          {
            "body": "Wijzigingen in de opdracht, extra materiaal en vertragingen worden geregistreerd met tekst en foto's op het moment dat ze gebeuren — klaar voor de factuur.",
            "step": "Meerwerk wordt op de werf vastgelegd"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke werkgever de arbeidsuren registreren met een digitaal, waterdicht systeem. Voor installatiewerk op grote bouwwerven (≥€500.000 excl. btw) is CheckIn@Work-registratie nu al verplicht — en met onderaannemers draag je een hoofdelijke aansprakelijkheid voor hun naleving. Done-it dekt beide: het levert het algemene systeem voor tijdsregistratie dat 2027 vereist en synchroniseert met CheckIn@Work waar de drempel van toepassing is.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027 + hoofdelijke aansprakelijkheid",
          "title": "Installatieteams vallen onder zowel de wet van 2027 als de regels voor onderaannemers"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Buitendienst",
        "slug": "field-service",
        "intro": "Technici die meerdere klanten per dag bezoeken, bonnetjes in dashboardkastjes, kilometers uit het geheugen genoteerd. Done-it legt uren, kilometers en onkosten vast op het terrein — gekoppeld aan de juiste job op het moment dat ze gebeuren.",
        "pains": [
          {
            "body": "Technici vragen hun routes op het einde van de week te reconstrueren, leidt tot onnauwkeurige vergoedingen, discussies met klanten en een groeiende stapel niet-ingediende kilometers.",
            "title": "Kilometers dagen later genoteerd — als het al gebeurt"
          },
          {
            "body": "Een bonnetje in een dashboardkastje is een kost die misschien nooit op een factuur belandt. De werkelijke kost per job is altijd een onderschatting.",
            "title": "Onkosten op papieren bonnetjes die verdwijnen"
          },
          {
            "body": "Zonder live check-ins kom je pas te weten waar een technicus is wanneer er iets misgaat en er iemand belt.",
            "title": "Geen realtime zicht op waar het team is"
          },
          {
            "body": "Wanneer arbeid, verplaatsing en onkosten in aparte systemen worden bijgehouden — of helemaal niet — is er nooit één kostencijfer per job.",
            "title": "Moeilijk om de werkelijke marge per job te zien"
          }
        ],
        "quote": {
          "who": "Operationeel manager, buitendienstbedrijf · 11 werknemers",
          "text": "Kilometers waren vroeger een maandelijkse kopzorg. Nu registreren ze zichzelf — elke kilometer is gekoppeld aan de juiste klant nog voor we terug op kantoor zijn.",
          "result": "Nauwkeurige kost per job, elke keer"
        },
        "stats": [
          {
            "label": "per km — officieel Belgisch tarief (jaarlijks, 2025–26)",
            "value": "€0,4449"
          },
          {
            "label": "km/jaar-drempel — daarboven moeten werkelijke kosten bewezen worden",
            "value": "24 000"
          },
          {
            "label": "algemene verplichting tot tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "GPS registreert vertrek, aankomst en de exacte afstand per rit. Configureer transporttypes (eigen wagen, bedrijfsvoertuig, carpool) met hun eigen vergoedingstarieven. Geen handmatig rittenboek.",
            "plan": "Add-on",
            "title": "Automatische kilometerregistratie (Trax-it)"
          },
          {
            "body": "Werknemers maken een foto van een bonnetje op het terrein; het wordt aan de job gekoppeld en is klaar voor terugbetaling — niet achternagelopen op het einde van de maand.",
            "plan": "Time Basic",
            "title": "Onkostenbeheer op het terrein"
          },
          {
            "body": "Uren, kilometers en onkosten worden in real time opgeteld bij de job. De kost per job is zichtbaar terwijl de job nog open is.",
            "plan": "Project Basic",
            "title": "Projectgekoppeld kostenbeheer"
          },
          {
            "body": "Elke technicus checkt in op de klantlocatie. Je ziet wie waar is, op dit moment — geen telefoontjes, geen giswerk.",
            "title": "Locatiegeverifieerde check-in en live teamoverzicht"
          },
          {
            "body": "Uren en kilometervergoedingen exporteer je netjes voor het sociaal secretariaat — met de officiële Belgische kilometertarieven automatisch toegepast.",
            "title": "Loonexport in één klik"
          }
        ],
        "headline": "Tijdsregistratie voor buitendienstteams — kilometers, onkosten en uren onderweg, allemaal in één app",
        "workflow": [
          {
            "body": "De check-in start het rittenlogboek. Kilometers worden automatisch vastgelegd van vertrek tot aankomst — geen handmatige invoer.",
            "step": "Technicus vertrekt voor de eerste oproep"
          },
          {
            "body": "Uren koppelen aan het juiste project. Meerwerk, materiaal en bonnetjes worden in de app geregistreerd op het moment dat ze gebeuren.",
            "step": "Op de werf"
          },
          {
            "body": "Elk uur, elke kilometer en elke onkost is al gekoppeld aan de juiste job. Exporteer naar de loonverwerking en factureer met werkelijke kostencijfers.",
            "step": "Maandeinde zonder de chaos"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke werkgever de uren digitaal registreren. Voor buitendienstwerknemers die tussen klantlocaties reizen, betekent het EU-Tyco-arrest (2015) ook dat de verplaatsing van thuis naar de eerste klant en van de laatste klant naar huis als arbeidstijd telt. De Belgische kilometervergoeding kent officiële maximumtarieven (€0,4449/km jaarlijks, Q2 2025: €0,4320/km) — deze overschrijden vereist een bewijs van de werkelijke kosten. Done-it past het huidige geïndexeerde tarief automatisch toe en signaleert de drempel van 24.000 km/jaar per werknemer.",
          "slug": "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "label": "Wet van 2027 + kilometerregels",
          "title": "Buitendienst valt onder de algemene verplichting van 2027 — en kilometers hebben hun eigen regels"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Elke serviceoproep heeft drie kosten: arbeid, onderdelen en verplaatsing. Done-it legt alle drie vast op het terrein en telt ze op bij de juiste job — zodat je je marge kent voordat je de factuur afsluit.",
        "pains": [
          {
            "body": "Arbeid, onderdelen en verplaatsing leven in verschillende systemen — of verschillende zakken. De werkelijke kost van een interventie wordt pas lang nadat de technicus de werf heeft verlaten duidelijk.",
            "title": "Serviceoproepen zijn moeilijk nauwkeurig te calculeren"
          },
          {
            "body": "Wanneer een klant betwist hoe lang een herstelling duurde, is een papieren urenstaat makkelijk aan te vechten. Door GPS bevestigde check-in- en check-out-tijdstempels niet.",
            "title": "Geen bewijs van servicetijd"
          },
          {
            "body": "Bij terugkerende onderhoudscontracten stapelen kleine overschrijdingen zich op over vele bezoeken. Zonder een live urenteller kom je pas bij verlenging te weten dat het contract verlieslatend is.",
            "title": "Onderhoudscontracten knagen stilletjes aan de marge"
          },
          {
            "body": "Handmatige tijdsregistraties missen pauzes, wat leidt tot overbetaling en een loonverwerking die niet overeenstemt met de werkelijkheid.",
            "title": "Technici vergeten pauzes te registreren"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, HVAC-bedrijf · 7 technici",
          "text": "We weten eindelijk wat elk servicecontract ons werkelijk kost. De margeverrassingen stopten de dag dat we Done-it begonnen te gebruiken.",
          "result": "Werkelijke kost per serviceoproep, live"
        },
        "stats": [
          {
            "label": "kostentypes vastgelegd per oproep: arbeid, verplaatsing, onderdelen",
            "value": "3"
          },
          {
            "label": "zicht op de marge per servicecontract",
            "value": "Live"
          },
          {
            "label": "verplichte digitale tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Elke serviceoproep of elk onderhoudscontract is een project. Uren, verplaatsing en materiaal worden in real time opgeteld — wat je live zicht op je marge geeft.",
            "plan": "Project Basic",
            "title": "Projectgebaseerde tijdsregistratie"
          },
          {
            "body": "Wanneer een job uitbreidt, registreren technici meerwerk en onderdelen met tekst en foto's voordat ze vertrekken. Niets wordt uit het geheugen gefactureerd.",
            "plan": "Project Basic",
            "title": "Meerwerk en materiaal, geregistreerd op het terrein"
          },
          {
            "body": "Kilometers per interventie worden automatisch geregistreerd en bij de job gecalculeerd. Configureer vergoedingstarieven per voertuigtype.",
            "plan": "Add-on",
            "title": "Kilometers en transportkosten"
          },
          {
            "body": "Verplichte pauzes worden automatisch van de totale tijd afgetrokken — geen discussies, geen loonfouten.",
            "title": "Automatische pauze-aftrek"
          },
          {
            "body": "Tijdstempel, door GPS bevestigde check-in op elke werf. Onbetwistbaar bewijs van wanneer de technicus aankwam en vertrok.",
            "title": "Locatiegeverifieerde check-in en aanwezigheidsbewijs"
          }
        ],
        "headline": "Tijdsregistratie voor HVAC-technici — job costing, onderdelen en verplaatsing in één app",
        "workflow": [
          {
            "body": "GPS zet een tijdstempel op de aankomst en koppelt de uren aan de serviceoproep of het onderhoudscontract. Geen papier, geen terminal.",
            "step": "Technicus checkt in op de werf"
          },
          {
            "body": "Gebruikte onderdelen, extra uren en wijzigingen in de opdracht worden in de app geregistreerd met foto's — voordat ze de werf verlaten.",
            "step": "Meerwerk wordt ter plaatse vastgelegd"
          },
          {
            "body": "Arbeid, verplaatsing en materiaal worden in real time bij het project opgeteld. Je ziet de marge voordat je de factuur opmaakt.",
            "step": "Jobkost is meteen zichtbaar"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke Belgische werkgever een digitaal, waterdicht overzicht van de arbeidsuren bijhouden. Voor HVAC-teams die werken op grote bouwwerven (≥€500.000 excl. btw) is CheckIn@Work-registratie nu al vereist. Done-it dekt beide scenario's en exporteert de gegevens rechtstreeks naar je sociaal secretariaat.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027",
          "title": "HVAC-teams vallen onder de algemene verplichting tot tijdsregistratie van 2027"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektriciens",
        "slug": "electricians",
        "intro": "Projecturen, een live aftelling van het resterende budget en navigatie naar de werf met één knop — gemaakt voor kleine elektriciensteams die projectbeheer nodig hebben zonder de administratieve last.",
        "pains": [
          {
            "body": "Wanneer elektriciens in een week aan meerdere jobs werken, leidt het handmatig toewijzen van uren op het einde van de dag tot verkeerd toegewezen kosten, factuurdiscussies en een loonverwerking die je niet kan uitleggen.",
            "title": "Uren zijn niet aan het juiste project gekoppeld"
          },
          {
            "body": "Zonder een live zicht op verbruikte uren versus begrote uren kom je er pas achter dat een project is uitgelopen wanneer je de factuur opmaakt — niet wanneer je nog kon reageren.",
            "title": "Budgetoverschrijdingen worden te laat opgemerkt"
          },
          {
            "body": "Adressen in een aparte app getypt, telefoontjes naar kantoor voor de weg, te laat aankomen op klantlocaties. Elke verloren minuut is een factureerbare minuut verloren.",
            "title": "Tijd verloren met het vinden van de werf"
          },
          {
            "body": "Bij grotere installaties houden onderaannemende elektriciens hun eigen uren apart bij. Een gecombineerd zicht op de arbeidskosten op het einde van een project krijgen is een handmatige, foutgevoelige klus.",
            "title": "Uren van onderaannemers moeilijk af te stemmen"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, elektriciteitsbedrijf · 5 elektriciens",
          "text": "We weten in real time of een project zijn budget overschrijdt. Dat alleen al heeft ons dit jaar twee slechte verrassingen bespaard.",
          "result": "Budgetoverschrijdingen opgemerkt voordat ze gebeuren"
        },
        "stats": [
          {
            "label": "zicht op resterende uren per project",
            "value": "Live"
          },
          {
            "label": "telefoontjes naar kantoor voor werfadressen",
            "value": "0"
          },
          {
            "label": "verplichte digitale tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Elke gewerkte minuut wordt automatisch aan het juiste project gekoppeld. Een live aftelling toont hoeveel uren er nog resten ten opzichte van het budget — voor jou en voor de werknemer op de werf.",
            "plan": "Project Basic",
            "title": "Projecturen met live resterend budget"
          },
          {
            "body": "Het projectadres staat in de app. Eén tik opent de navigatie — geen gezoek, geen aparte kaartapp, geen telefoontjes naar kantoor.",
            "title": "Navigatie naar de werf met één knop"
          },
          {
            "body": "Elke elektricien checkt in bij de juiste job. Je weet altijd wie op dit moment op welke werf zit.",
            "plan": "Project Basic",
            "title": "Check-in van werknemers per project"
          },
          {
            "body": "Wanneer de opdracht wijzigt — een onverwachte stroomkring, extra materiaal — wordt het in de app geregistreerd met foto's, voordat de ploeg vertrekt.",
            "plan": "Project Basic",
            "title": "Meerwerk geregistreerd op de werf"
          },
          {
            "body": "Overuren worden geregistreerd op het moment dat ze gebeuren. Werknemers kiezen om ze uitbetaald te krijgen of om te zetten in inhaalrust.",
            "plan": "Time Pro",
            "title": "Overurenregistratie met flexibele vergoeding"
          }
        ],
        "headline": "Tijdsregistratie voor elektriciens — projecturen, budgetbeheer en navigatie in één app",
        "workflow": [
          {
            "body": "Adres en opdracht staan al in de app. Eén tik opent de navigatie — geen telefoontjes, geen verwarring.",
            "step": "Elektricien navigeert naar de job"
          },
          {
            "body": "De check-in op de werf koppelt elke gewerkte minuut aan het juiste project. De teller voor resterende uren wordt live bijgewerkt.",
            "step": "Uren koppelen automatisch aan het juiste project"
          },
          {
            "body": "Meerwerk en materiaal worden op de werf geregistreerd, voordat ze vertrekken. De factuur weerspiegelt wat er werkelijk gebeurd is.",
            "step": "Wijzigingen in de opdracht blijven geregistreerd"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moeten alle werkgevers de uren digitaal registreren. Voor elektriciteitswerk op bouwwerven van ≥€500.000 excl. btw is CheckIn@Work nu al verplicht. Done-it dekt beide: het levert de digitale tijdsregistratie die 2027 vereist en synchroniseert met CheckIn@Work wanneer de werfdrempel bereikt is.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027 + CheckIn@Work op grote werven",
          "title": "Elektriciens vallen onder de verplichting van 2027 — en onder CheckIn@Work waar de werfdrempel van toepassing is"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Loodgieters",
        "slug": "plumbing",
        "intro": "Dringende interventies, meerdere jobs per dag, uren uit het geheugen ingevuld op het einde van de week — of helemaal niet. Done-it maakt er een klus van één tik op elke werf en een loonverwerking in één klik op het einde van de maand van.",
        "pains": [
          {
            "body": "Met meerdere jobs op een dag hebben loodgieters zelden de tijd om nauwkeurige urenstaten in te vullen. Uren worden afgerond of vergeten, en de loonverwerking is in het beste geval een schatting.",
            "title": "Interventie-uren uit het geheugen gereconstrueerd"
          },
          {
            "body": "Wanneer een klant betwist hoe lang een herstelling duurde, is er geen objectief overzicht. Een door GPS bevestigde digitale check-in is makkelijk te tonen — een papieren urenstaat niet.",
            "title": "Geen bewijs van tijd op de werf"
          },
          {
            "body": "Verplaatsingen tussen interventies tellen op over de week en de maand, maar zonder automatische registratie worden ze zelden correct gefactureerd of vergoed.",
            "title": "Kilometers tussen jobs niet bijgehouden"
          },
          {
            "body": "Op het einde van de maand kost het achternalopen van urenstaten, het corrigeren van fouten en het opbouwen van de export voor het sociaal secretariaat tijd die je administratieteam niet zou mogen besteden.",
            "title": "Loonvoorbereiding is traag"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, loodgietersbedrijf · 4 loodgieters",
          "text": "We waren vroeger op het einde van de maand een halve ochtend kwijt aan het reconstrueren van uren. Nu exporteren en versturen we gewoon. Het sociaal secretariaat krijgt het netjes binnen.",
          "result": "Loonvoorbereiding van uren naar minuten"
        },
        "stats": [
          {
            "label": "om in te checken — snel genoeg voor dringende oproepen",
            "value": "1 tik"
          },
          {
            "label": "loonexport naar je sociaal secretariaat",
            "value": "1 klik"
          },
          {
            "label": "verplichte digitale tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Aankomst en vertrek geregistreerd met één tik, met locatieverificatie van de locatie. Snel genoeg voor dringende oproepen; nauwkeurig genoeg voor discussies.",
            "plan": "Time Basic",
            "title": "Locatiegeverifieerde check-in met één tik bij elke interventie"
          },
          {
            "body": "Verplichte pauzes worden automatisch van de totale tijd afgetrokken — niets in te vullen, geen loonfouten.",
            "plan": "Time Basic",
            "title": "Automatische pauze-aftrek"
          },
          {
            "body": "Configureer transporttypes en vergoedingstarieven. Kilometers worden automatisch geregistreerd en gekoppeld aan de juiste klant of het juiste project.",
            "plan": "Add-on",
            "title": "Kilometers vastgelegd per rit"
          },
          {
            "body": "Werknemers dienen ziektebriefjes digitaal in vanuit de app. Ondersteunt weerverlet en andere afwezigheidstypes die relevant zijn voor loodgieterswerk buiten.",
            "title": "Afwezigheids- en ziektebriefjebeheer"
          },
          {
            "body": "Alle uren- en kilometergegevens exporteer je netjes voor je sociaal secretariaat — geen handmatige voorbereiding, geen Excel.",
            "plan": "Time Basic",
            "title": "Loonexport in één klik"
          }
        ],
        "headline": "Tijdsregistratie voor loodgietersteams — snelle check-in, nauwkeurige loonverwerking en aanwezigheidsbewijs voor elke interventie",
        "workflow": [
          {
            "body": "Eén tik checkt in. GPS registreert de locatie en de tijd. Snel genoeg voor een dringende job.",
            "step": "Loodgieter komt aan bij de interventie"
          },
          {
            "body": "De check-out sluit de tijdsregistratie af. De kilometers naar de volgende job beginnen automatisch te registreren.",
            "step": "Vertrek aangetikt op weg naar buiten"
          },
          {
            "body": "Alle interventies, uren en kilometers exporteer je netjes. Loonvoorbereiding gaat van een dag naar enkele minuten.",
            "step": "Maandeinde is één klik"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke Belgische werkgever — ook kleine loodgietersteams — een digitaal, nauwkeurig en fraudebestendig overzicht van de arbeidsuren bijhouden. Papieren urenstaten en gedeelde spreadsheets voldoen niet langer. Done-it dekt de vereiste meteen, exporteert naar je sociaal secretariaat en houdt alle registraties GDPR-proof.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027",
          "title": "Loodgieterswerk valt onder de algemene verplichting tot tijdsregistratie van 2027"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Tuinaanleg",
        "slug": "landscaping",
        "intro": "Het hoogseizoen betekent veel werven, wisselende ploegen en heel wat kilometers. Done-it houdt elk uur, elke afwezigheid en elke rit georganiseerd — zodat je je op het werk kan focussen, niet op het papierwerk.",
        "pains": [
          {
            "body": "Tijdelijke werknemers, wisselende uurroosters en variërende teamgroottes maken nauwkeurige urenregistratie bijna onmogelijk met papier. Tegen de tijd dat je op het einde van de maand afstemt, ontbreekt er altijd iets.",
            "title": "Seizoensploegen zijn complex te beheren"
          },
          {
            "body": "Een ploeg die drie of vier werven per dag bezoekt, genereert uren die correct verdeeld moeten worden. Handmatige invoer leidt tot verkeerde toewijzing en betwiste loonverwerking.",
            "title": "Uren verspreid over veel werven"
          },
          {
            "body": "Weerverlet is een reëel gegeven in de tuinaanleg. Zonder een digitaal overzicht is het aanvragen van de juiste vergoeding en het beheren van eC3.2A traag en foutgevoelig.",
            "title": "Weerverlet is moeilijk te documenteren"
          },
          {
            "body": "Bedrijfsbusjes, persoonlijke voertuigen en carpools rijden de hele dag tussen werven heen en weer. Zonder automatische registratie belanden die kilometers nooit in het kostenplaatje.",
            "title": "Kilometers tussen werven blijven onregistreerd"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, tuinaanlegbedrijf · 12 seizoenswerknemers",
          "text": "Het hoogseizoen betekende vroeger loonchaos. Nu checkt onze ploegbaas de app, is iedereen geregistreerd, en exporteer ik de uren op de laatste dag van de maand.",
          "result": "Geen reconstructie van de loonverwerking meer op het einde van de maand"
        },
        "stats": [
          {
            "label": "eC3.2A digitale kaart verplicht voor tijdelijke werkloosheid",
            "value": "1 jan 2025"
          },
          {
            "label": "algemene verplichting tot tijdsregistratie",
            "value": "1 jan 2027"
          },
          {
            "label": "kilometerregistratie — geen rittenboek meer",
            "value": "Automatisch"
          }
        ],
        "features": [
          {
            "body": "Zie alle ploegen, alle werven in real time. Weet wie waar werkt, op dit moment — niet op het einde van de maand.",
            "title": "Ploegoverzicht over meerdere werven"
          },
          {
            "body": "Plan wie waar werkt, behandel last-minute wijzigingen en stuur de planning naar de telefoons van het team — zonder een telefoontje naar elke persoon.",
            "plan": "Time Pro",
            "title": "Shiftplanning voor seizoensteams"
          },
          {
            "body": "Maak aangepaste afwezigheidstypes voor je sector: seizoensgebonden weerverlet, ouderschapsverlof, ziektedagen. Werknemers laden documentatie digitaal op vanuit de app.",
            "title": "Aangepaste afwezigheidstypes"
          },
          {
            "body": "Configureer transporttypes (bedrijfsbusje, persoonlijke wagen, carpool chauffeur vs. passagier) met hun eigen tarieven. Kilometers worden automatisch per rit geregistreerd.",
            "plan": "Add-on",
            "title": "Kilometers met carpoolregistratie"
          },
          {
            "body": "Overuren in het hoogseizoen stapelen zich snel op. Elke werknemer kan kiezen om ze uitbetaald te krijgen of de uren als inhaalrust op te sparen — transparant bijgehouden.",
            "plan": "Time Pro",
            "title": "Overurenregistratie met omzetting naar verlof"
          }
        ],
        "headline": "Tijdsregistratie voor tuinaanlegbedrijven — seizoensploegen, meerdere werven en kilometers in één overzicht",
        "workflow": [
          {
            "body": "GPS registreert de aankomst. Uren worden automatisch verdeeld over de juiste locatie en het juiste project — geen handmatige toewijzing op het einde van de dag.",
            "step": "Ploeg checkt in op de eerste werf"
          },
          {
            "body": "De ploegbaas registreert weerverlet vanuit de app. Het digitale overzicht ondersteunt de eC3.2A-procedure zonder extra papierwerk.",
            "step": "Het weer legt het werk stil"
          },
          {
            "body": "Uren, afwezigheden en kilometers over elke werf en elk ploeglid exporteer je netjes voor de loonverwerking.",
            "step": "Maandeinde: alle werven, alle ploegen, één export"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke werkgever de uren digitaal registreren. Tuinaanlegteams die buiten werken, krijgen ook vaak te maken met weerverlet (tijdelijke werkloosheid wegens slecht weer). Sinds 1 januari 2025 is de digitale controlekaart eC3.2A verplicht voor tijdelijke werkloosheid in sectoren waaronder buitenwerk. Done-it ondersteunt aangepaste afwezigheidstypes voor weerverlet en levert de digitale tijdsregistratie die de wet van 2027 vereist.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027 + weerverlet",
          "title": "Tuinaanleg valt onder de verplichting van 2027 — en weerverlet voegt een specifieke digitale plicht toe"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Onderhoud",
        "slug": "maintenance",
        "intro": "Terugkerende onderhoudscontracten staan of vallen met zicht op de kosten. Done-it registreert elk bezoek, volgt de uren ten opzichte van het contractbudget en geeft jou — en je klanten — een aanwezigheidsbewijs voor elke oproep.",
        "pains": [
          {
            "body": "Wanneer de uren voor terugkerende bezoeken niet worden bijgehouden ten opzichte van het specifieke contract, weet je pas bij de jaarafrekening of een klant winstgevend is — en dan is het te laat om te herprijzen.",
            "title": "Geen zicht op de kosten per onderhoudscontract"
          },
          {
            "body": "Facility managers en eigenaars willen steeds vaker aanwezigheidsregistraties: wie kwam, wanneer ze aankwamen, wat ze deden. Een papieren logboek dat weken later wordt voorgelegd, voldoet niet aan de SLA-vereisten.",
            "title": "Klanten verwachten een bewijs van wat er gedaan is"
          },
          {
            "body": "Wisselende shifts over veel terugkerende werven — met personeel dat voor elkaar invalt — creëren een planning- en urenregistratiepuzzel die handmatige processen niet betrouwbaar kunnen oplossen.",
            "title": "Terugkerende bezoeken moeilijk te plannen en te registreren"
          },
          {
            "body": "Tuinonderhoud, gevelonderhoud en buitenfaciliteitenwerk krijgen allemaal te maken met weergerelateerde stilstand. Weerverlet correct documenteren vereist een digitaal spoor.",
            "title": "Weerverlet treft ook buitenonderhoud"
          }
        ],
        "quote": {
          "who": "Operationeel manager, onderhoudsbedrijf · 8 werknemers",
          "text": "We kunnen een facility manager in twee minuten exact vertellen wie wanneer op de werf was. Dat niveau van bewijs heeft veranderd hoe klanten ons zien.",
          "result": "Klantendiscussies teruggebracht tot nul"
        },
        "stats": [
          {
            "label": "kost per onderhoudscontract",
            "value": "Live"
          },
          {
            "label": "aanwezigheidsbewijs klaar voor klanten",
            "value": "GPS"
          },
          {
            "label": "verplichte digitale tijdsregistratie",
            "value": "1 jan 2027"
          }
        ],
        "features": [
          {
            "body": "Elk onderhoudscontract is een project. Uren worden er automatisch op geregistreerd, wat je een live kostencijfer en aftelling van resterende uren per klant geeft.",
            "plan": "Project Basic",
            "title": "Contractgebaseerde kostenregistratie"
          },
          {
            "body": "Tijdstempel, locatiegeverifieerde check-ins zijn een onbetwistbaar overzicht van wie wanneer en hoe lang op de werf was — klaar om op verzoek met klanten te delen.",
            "title": "Door GPS bevestigd aanwezigheidsbewijs"
          },
          {
            "body": "Werknemers melden problemen, voltooide taken of meerwerk rechtstreeks vanuit de app — met tekst en foto's. Klanten krijgen een realtime overzicht; jij hebt de documentatie voor de facturatie.",
            "plan": "Project Basic",
            "title": "Updates met foto's vanaf de werf"
          },
          {
            "body": "Plan terugkerende bezoeken over alle contracten, wijs werknemers toe en behandel vervangingen — zonder een telefoontje naar elke persoon.",
            "plan": "Time Pro",
            "title": "Planning van terugkerende shifts"
          },
          {
            "body": "Configureer weerverlet en andere afwezigheidstypes. Werknemers registreren stilstand vanuit de app; documentatie wordt digitaal opgeladen.",
            "title": "Afwezigheidstypes voor buitenonderhoud"
          }
        ],
        "headline": "Tijdsregistratie voor onderhoudsteams — terugkerende werfbezoeken, kost per contract en aanwezigheidsbewijs in één app",
        "workflow": [
          {
            "body": "Locatiegeverifieerde check-in registreert het aankomsttijdstip en koppelt de uren aan het juiste contract. Aanwezigheidsbewijs wordt automatisch aangemaakt.",
            "step": "Werknemer komt aan op de onderhoudswerf"
          },
          {
            "body": "Voltooid werk en eventuele problemen worden vanuit de app gemeld met foto's. Klanten zien precies wat er gedaan is.",
            "step": "Taken voltooid, problemen geregistreerd"
          },
          {
            "body": "Uren stapelen zich in real time op ten opzichte van het contractbudget. Je kent de marge voordat het contract verlengd wordt.",
            "step": "Kost per contract meteen zichtbaar"
          }
        ],
        "compliance": {
          "body": "Vanaf 1 januari 2027 moet elke werkgever een digitaal overzicht van de arbeidsuren bijhouden. Voor buitenonderhoudswerk voegt weerverlet (tijdelijke werkloosheid wegens slecht weer) een specifieke plicht toe: sinds 1 januari 2025 is de controlekaart eC3.2A in digitale vorm verplicht. Done-it dekt beide: het levert de algemene tijdsregistratie die 2027 vereist en ondersteunt aangepaste afwezigheidstypes — inclusief weerverlet — met digitale documentatie.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Wet van 2027 + weerverlet",
          "title": "Onderhoudsteams vallen onder de verplichting van 2027 en krijgen te maken met weerverlet-specifieke digitale plichten"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Winkels & retail",
        "slug": "retail",
        "intro": "Openingsshiften, avondshiften en altijd wel iemand die voor iemand anders invalt. Done-it geeft elke winkel een heldere digitale registratie van wie welke shift werkte — ingeklokt op de eigen smartphone, klaar voor de loonverwerking op het einde van de maand.",
        "pains": [
          {
            "body": "Iemand valt in voor een zieke collega, iemand blijft een uur langer bij het sluiten. Het blijft hangen op een briefje, of helemaal niet — en je loon klopt al niet voor je begint.",
            "title": "Shiftwissels bereiken de loonverwerking nooit"
          },
          {
            "body": "Medewerkers wisselen van vestiging, deeltijders werken op twee locaties. De uren per winkel verzamelen en manueel samenvoegen kost elke maand een dag.",
            "title": "Meerdere winkels, één loonverwerking"
          },
          {
            "body": "Wettelijke pauzes worden uit het hoofd afgetrokken en extra uren informeel geregeld — precies de twee dingen waar een controle als eerste naar vraagt.",
            "title": "Pauzes en overuren zijn giswerk"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, retail · 11 medewerkers",
          "text": "Twee winkels en veel deeltijders. Vroeger werd de helft van de invalshiften uit het hoofd geregeld. Nu staat elk uur op de juiste winkel en kost de loonverwerking minuten.",
          "result": "Loonvoorbereiding van een dag naar minder dan een uur"
        },
        "stats": [
          {
            "label": "om in te klokken — geen terminal aan de kassa",
            "value": "1 tik"
          },
          {
            "label": "overzicht van wie aanwezig is, in elke winkel",
            "value": "Live"
          },
          {
            "label": "shiftwissels verloren tussen vloer en loon",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Eén tik op de eigen smartphone bij de start van de shift. Geen terminal aan de kassa, geen gedeelde badge, geen klembord aan de deur van het magazijn.",
            "title": "Inklokken op de winkelvloer"
          },
          {
            "body": "Elke winkel is een project. Wie in een andere vestiging invalt, klokt in op die vestiging — je ziet de uren waar ze echt gepresteerd zijn.",
            "title": "Uren per winkel, medewerkers over vestigingen heen"
          },
          {
            "body": "Stel de pauzeregel één keer in en ze geldt voor elke shift. Overuren worden geregistreerd zodra ze gemaakt worden, en elke medewerker kiest zelf tussen uitbetaling of inhaalrust.",
            "title": "Pauzes automatisch afgetrokken"
          }
        ],
        "headline": "Tijdregistratie voor winkels — inklokken per shift, vervanging en een loonklare export, in één app",
        "workflow": [
          {
            "body": "Eén tik op de smartphone bij de start van de shift. Invallen in een andere vestiging wordt op die vestiging geboekt.",
            "step": "Medewerkers klokken in voor hun shift"
          },
          {
            "body": "Een live overzicht over alle locaties — een niet-ingevulde openingsshift zie je voor de deuren opengaan.",
            "step": "Je ziet wie aanwezig is, per winkel"
          },
          {
            "body": "Uren, pauzes en overuren per medewerker en per winkel, klaar geëxporteerd voor je sociaal secretariaat.",
            "step": "Loonverwerking in één export"
          }
        ],
        "compliance": {
          "body": "Done-it houdt een objectieve digitale registratie bij van elk in- en uitklokken, met pauzes en overuren — precies het bewijs waar een audit of een loondiscussie om vraagt.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Tijdregistratie per shift",
          "title": "Een sluitend bewijs van elke gewerkte shift"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Kantoren & dienstverlening",
        "slug": "offices",
        "intro": "Accountants, notarissen, architecten, bureaus en consultants factureren hun tijd — of moeten op zijn minst weten waar ze naartoe ging. Done-it registreert uren op de juiste klant en het juiste project, vanaf het bureau of onderweg.",
        "pains": [
          {
            "body": "Tijd die je op het einde van de week opschrijft, is tijd die je gokt. Hele uren verdwijnen stilletjes tussen het werk en de factuur.",
            "title": "Factureerbare uren op vrijdag gereconstrueerd"
          },
          {
            "body": "Het ereloon werd maanden geleden afgesproken. Of het werk er nog binnen past, blijkt pas als iemand het optelt — meestal te laat.",
            "title": "Geen zicht op wat een klant echt kost"
          },
          {
            "body": "Een deel van het team zit op kantoor, een deel thuis, een deel bij de klant. Aanwezigheid is geen feit meer maar een reconstructie.",
            "title": "Hybride werken maakt de registratie onvolledig"
          }
        ],
        "quote": {
          "who": "Vennoot, accountantskantoor · 8 medewerkers",
          "text": "We bouwden elke vrijdag de hele week opnieuw op. Nu staan de uren al op de juiste klant en zie ik welke dossiers het ereloon opeten.",
          "result": "Elke maand factureerbare uren gerecupereerd"
        },
        "stats": [
          {
            "label": "uren, zichtbaar terwijl het werk nog loopt",
            "value": "Per klant"
          },
          {
            "label": "dezelfde registratie, smartphone en browser",
            "value": "Kantoor of onderweg"
          },
          {
            "label": "voor loonverwerking en facturatie",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Elke registratie komt op een project terecht, zodat je de uren per klant ziet zonder iets te exporteren of iemand iets te vragen.",
            "title": "Uren op klant en project"
          },
          {
            "body": "Dezelfde app op de smartphone of in de browser. Een klantbezoek telt als werk voor die klant, inclusief de verplaatsing als je dat zo wil.",
            "title": "Werkt op kantoor en onderweg"
          },
          {
            "body": "Extra uren geregistreerd op het moment zelf, verlof aangevraagd en goedgekeurd in de app — geen aparte spreadsheet meer van wie wanneer weg is.",
            "title": "Overuren en verlof op één plek"
          }
        ],
        "headline": "Tijdregistratie voor kantoren — uren per klant en project, zonder spreadsheet",
        "workflow": [
          {
            "body": "Eén keer instellen met de klant en, als je op budget factureert, de uren die je gepland hebt.",
            "step": "Open een klantproject"
          },
          {
            "body": "Vanaf het bureau of de smartphone. Elk uur komt op een klant terecht, niet in iemands geheugen.",
            "step": "Het team registreert er tijd op"
          },
          {
            "body": "Live totalen per project, en een propere export voor loon of facturatie op het einde van de maand.",
            "step": "Zie uren per klant, exporteer voor het loon"
          }
        ],
        "compliance": {
          "body": "Done-it houdt een digitale, fraudebestendige registratie bij van de arbeidstijd per medewerker — de basis voor zowel de loonverwerking als een verdedigbare klantfactuur.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Tijdregistratie per klant",
          "title": "Een objectieve registratie van gewerkte uren"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salons & lichaamsverzorging",
        "slug": "beauty",
        "intro": "Kappers, barbiers, nagel- en schoonheidssalons draaien op shiften en deeltijdse contracten. Done-it registreert wie wanneer werkte, trekt pauzes automatisch af en levert de loonverwerking een proper bestand.",
        "pains": [
          {
            "body": "Drie dagen de ene week, vier de volgende, een zaterdag geruild voor een dinsdag. Contracturen en gewerkte uren lopen snel uit elkaar.",
            "title": "Deeltijdse contracten, eindeloze varianten"
          },
          {
            "body": "Afspraken tonen wat geboekt werd, niet wie werkte. Als het loon of een controle ernaar vraagt, is het boekingssysteem het verkeerde antwoord.",
            "title": "De agenda is geen tijdregistratie"
          },
          {
            "body": "Langer blijven voor een laatste klant wordt onthouden, beloofd en soms vergeten. Net zo'n gat groeit uit tot een discussie.",
            "title": "Extra uren informeel geregeld"
          }
        ],
        "quote": {
          "who": "Zaakvoerster, kapsalon · 6 medewerkers",
          "text": "Iedereen werkt deeltijds en elke week is anders. De app registreert het gewoon — ik bouw de maand niet meer opnieuw op in een spreadsheet.",
          "result": "Geen betwiste uren meer op het einde van de maand"
        },
        "stats": [
          {
            "label": "om in te klokken — niets gedeeld, niets op papier",
            "value": "1 tik"
          },
          {
            "label": "pauzeaftrek op elke shift",
            "value": "Auto"
          },
          {
            "label": "late uren uit het hoofd geregeld",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Eén tik op de eigen smartphone bij de start van de shift — geen gedeelde terminal aan de balie, geen handtekeningenlijst bij de spiegel.",
            "title": "Inklokken in het salon"
          },
          {
            "body": "Stel de pauzeregel en de standaarduren één keer in; ze gelden voor elke shift, met uitzonderingen per persoon waar een contract afwijkt.",
            "title": "Pauzes en deeltijdregels één keer instellen"
          },
          {
            "body": "Extra uren worden geregistreerd terwijl ze gepresteerd worden, en elke medewerker kiest tussen uitbetaling of inhaalrust — geregeld in de app, niet uit het hoofd.",
            "title": "Overuren: uitbetaald of opgenomen"
          }
        ],
        "headline": "Tijdregistratie voor salons — shiften, deeltijdse uren en loon zonder papieren agenda",
        "workflow": [
          {
            "body": "Eén tik bij aankomst. Pauzes worden afgetrokken volgens de regel die je één keer instelt.",
            "step": "Medewerkers klokken in voor de shift"
          },
          {
            "body": "Wie aanwezig is, wie pauze neemt, wie langer bleef — live, zonder te vragen.",
            "step": "Je volgt de dag terwijl hij loopt"
          },
          {
            "body": "Gewerkte uren, pauzes en overuren per medewerker, geëxporteerd voor je sociaal secretariaat.",
            "step": "De loonverwerking krijgt een proper bestand"
          }
        ],
        "compliance": {
          "body": "Done-it registreert de werkelijke arbeidstijd per medewerker, met pauzes en overuren — los van de boekingen, en verdedigbaar wanneer ze gecontroleerd wordt.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale tijdregistratie",
          "title": "Een registratie die verder gaat dan het afsprakenboek"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Gezondheid & wellness",
        "slug": "wellness",
        "intro": "Fitnesscentra, studio's, kinepraktijken en spa's draaien lange openingsuren met wisselende medewerkers. Done-it registreert wie welke shift invulde, trekt pauzes automatisch af en exporteert het loon proper.",
        "pains": [
          {
            "body": "Vroege shiften, avondlessen en weekends, ingevuld door een mix van voltijders, deeltijders en freelancers. Het uurrooster is een plan, geen registratie.",
            "title": "Lange openingsuren, wisselende bezetting"
          },
          {
            "body": "Een lesgever geeft twee lessen en staat er tussenin aan het onthaal. Dat correct betalen betekent weten wat er echt gewerkt is, niet wat gepland stond.",
            "title": "Lesuren en vloeruren lopen door elkaar"
          },
          {
            "body": "Medewerkers wisselen tussen studio's. Hun uren elke maand manueel samenvoegen is traag en foutgevoelig.",
            "title": "Meerdere locaties, één administratie"
          }
        ],
        "quote": {
          "who": "Manager, fitnessstudio · 14 medewerkers",
          "text": "Twee studio's, lange openingsuren en veel invalshiften. Nu komen de uren op de juiste locatie en is de loonverwerking één bestand.",
          "result": "Uurrooster en loon kloppen eindelijk met elkaar"
        },
        "stats": [
          {
            "label": "uren, ook als medewerkers elders invallen",
            "value": "Per studio"
          },
          {
            "label": "zicht op de vloer over alle locaties",
            "value": "Live"
          },
          {
            "label": "pauzes en overuren, geen rekenwerk",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Eén tik op de smartphone op de locatie waar ze werken. Invallen in een andere studio komt op de uren van die studio.",
            "title": "Inklokken per studio"
          },
          {
            "body": "Zie de vloer op elke locatie in real time — een niet-ingevulde vroege shift zie je voor de deuren opengaan, niet erna.",
            "title": "Live zicht op wie aanwezig is"
          },
          {
            "body": "Pauzeregels automatisch toegepast, extra uren geregistreerd op het moment zelf, met uitbetaling of inhaalrust per medewerker.",
            "title": "Pauzes en overuren geregeld"
          }
        ],
        "headline": "Tijdregistratie voor fitness, studio's en spa's — shiften, lessen en loon in één app",
        "workflow": [
          {
            "body": "Eén tik bij de start van de shift, op de locatie waar ze werken.",
            "step": "Medewerkers klokken in op locatie"
          },
          {
            "body": "Wie op welke locatie aanwezig is, zodat gaten ingevuld raken voor leden ze merken.",
            "step": "De bezetting is live zichtbaar"
          },
          {
            "body": "Uren, pauzes en overuren per medewerker en per studio, klaar voor het sociaal secretariaat.",
            "step": "Eén export voor de loonverwerking"
          }
        ],
        "compliance": {
          "body": "Done-it houdt een digitale registratie bij van de arbeidstijd per medewerker en per locatie — de basis voor een correcte betaling en voor elke controle op de gepresteerde uren.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shiftregistratie over locaties",
          "title": "Een objectieve registratie voor elke shift en locatie"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Horeca",
        "slug": "hospitality",
        "intro": "Onderbroken diensten, late sluitingen en een drukke zaterdag die uitloopt. Done-it registreert de uren zoals ze echt gepresteerd worden, trekt pauzes af volgens jouw regel en geeft de loonverwerking één proper bestand.",
        "pains": [
          {
            "body": "De service loopt uit, sluiten kost nog een half uur. Die minuten zijn echt werk, en ze uit het hoofd regelen is hoe discussies beginnen.",
            "title": "De shift eindigt nooit wanneer het rooster het zegt"
          },
          {
            "body": "Lunchservice, een pauze, dan het diner. Op papier wordt dat één lang blok of twee gissingen — geen van beide klopt.",
            "title": "Onderbroken diensten zijn moeilijk te registreren"
          },
          {
            "body": "Elk seizoen nieuwe medewerkers. Een systeem dat opleiding vraagt, overleeft de eerste drukke week niet.",
            "title": "Veel verloop, constant inwerken"
          }
        ],
        "quote": {
          "who": "Zaakvoerder, restaurant · 17 medewerkers",
          "text": "Sluiten loopt altijd uit. Nu worden die minuten geregistreerd in plaats van betwist, en medewerkers kunnen ze opnemen als inhaalrust.",
          "result": "Minder discussies, snellere loonverwerking"
        },
        "stats": [
          {
            "label": "per onderbroken dienst — geen gissing",
            "value": "2 blokken"
          },
          {
            "label": "pauzeaftrek volgens jouw regel",
            "value": "Auto"
          },
          {
            "label": "om een nieuwe medewerker op te starten — op zijn eigen smartphone",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Eén tik bij de start en het einde van elk blok, zodat onderbroken diensten geregistreerd worden zoals ze gelopen zijn — niet samengevoegd tot één.",
            "title": "In- en uitklokken per service"
          },
          {
            "body": "Verplichte pauzes automatisch afgetrokken, met uitzonderingen per persoon waar een contract dat vraagt. Geen rekenwerk op het einde van de maand.",
            "title": "Pauzes volgens jouw regel"
          },
          {
            "body": "Het extra half uur na sluitingstijd wordt geregistreerd op het moment zelf, en uitbetaald of opgenomen als inhaalrust — de medewerker kiest.",
            "title": "Overuren geregeld in de app"
          }
        ],
        "headline": "Tijdregistratie voor cafés, restaurants en hotels — shiften, pauzes en overuren, eerlijk geregeld",
        "workflow": [
          {
            "body": "Eén tik bij de start van het blok; hetzelfde op het einde. Onderbroken diensten blijven onderbroken.",
            "step": "Medewerkers klokken in voor de service"
          },
          {
            "body": "Wie er is voor de service vanavond, wie nog pauze heeft, wie na sluitingstijd bleef.",
            "step": "Je ziet de vloer live"
          },
          {
            "body": "Gewerkte tijd, pauzes en overuren per medewerker, in één bestand geëxporteerd.",
            "step": "De loonverwerking krijgt de echte uren"
          }
        ],
        "compliance": {
          "body": "Done-it houdt een objectieve digitale registratie bij van elke shift, pauze en extra uur — precies wat een looncontrole of een sociale inspectie wil zien.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registratie van onderbroken diensten",
          "title": "Een sluitende registratie van uren in een team met veel verloop"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Zorg & gezondheid",
        "slug": "healthcare",
        "intro": "Praktijken, thuiszorgteams en woonzorgcentra draaien op shiften, bezoeken en strikte registratie. Done-it registreert de gewerkte tijd per shift en per bezoek, en houdt de documenten van je medewerkers op een vindbare plek.",
        "pains": [
          {
            "body": "Huisbezoeken zitten in de ene tool, geplande uren in de andere, en de loonverwerking krijgt een derde versie. Dat op elkaar afstemmen is elke maand weer werk.",
            "title": "Bezoeken en shiften in aparte systemen"
          },
          {
            "body": "Onregelmatige uren hebben andere tarieven. Als de registratie bij benadering is, is het loon dat ook — en de correctie komt achteraf.",
            "title": "Nacht- en weekenduren verkeerd verloond"
          },
          {
            "body": "Kwalificaties en attesten tellen in de zorg, en ze liggen in een map die niemand opent tot een inspectie ernaar vraagt.",
            "title": "Attesten vervallen ongemerkt"
          }
        ],
        "quote": {
          "who": "Coördinator, thuiszorgteam · 22 medewerkers",
          "text": "Huisbezoeken en geplande shiften zitten eindelijk in dezelfde registratie. De loonverwerking is geen puzzelwerk meer.",
          "result": "Eén registratie in plaats van drie"
        },
        "stats": [
          {
            "label": "of per shift — wat jouw team ook draait",
            "value": "Per bezoek"
          },
          {
            "label": "nacht- en weekenduren, geregistreerd zoals gewerkt",
            "value": "Apart"
          },
          {
            "label": "attesten opgeslagen per medewerker",
            "value": "Bewaard"
          }
        ],
        "features": [
          {
            "body": "Eén tik bij de start van de shift, of op elk klantadres bij thuiszorg — met locatiecontrole waar je het bewijs nodig hebt.",
            "title": "Inklokken per shift of per bezoek"
          },
          {
            "body": "Nacht-, weekend- en gewone uren worden apart geregistreerd, zodat de loonexport al weergeeft hoe het werk echt betaald wordt.",
            "title": "Uren opgesplitst zoals je ze uitbetaalt"
          },
          {
            "body": "Contracten, attesten en identiteitsbewijzen bewaard bij de persoon waar ze bij horen — in seconden gevonden als iemand ernaar vraagt.",
            "title": "Personeelsdocumenten op één plek"
          }
        ],
        "headline": "Tijdregistratie voor zorgteams — shiften, huisbezoeken en kwalificaties, in één registratie",
        "workflow": [
          {
            "body": "Eén tik op de locatie of op het adres van de klant, met locatiecontrole waar bewijs nodig is.",
            "step": "Inklokken voor de shift of het bezoek"
          },
          {
            "body": "Gewone, nacht- en weekenduren apart geregistreerd op het moment zelf.",
            "step": "Uren komen in de juiste categorie"
          },
          {
            "body": "Eén proper bestand per periode, al opgesplitst zoals je uitbetaalt.",
            "step": "Exporteren voor de loonverwerking"
          }
        ],
        "compliance": {
          "body": "Done-it houdt een digitale, objectieve registratie bij van de arbeidstijd per medewerker — uren, pauzes en de opsplitsing van onregelmatige uren — naast de documenten die bij elke persoon horen.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shift- & bezoekregistratie",
          "title": "Registraties die een inspectie doorstaan"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "fr-be": [
      {
        "name": "Construction",
        "slug": "construction",
        "intro": "Des équipes dispersées sur les chantiers, des heures griffonnées sur papier, la conformité des sous-traitants comme préoccupation permanente. Done-it dote chaque chantier d'un enregistrement du temps numérique étanche qui satisfait l'inspecteur et alimente votre traitement salarial en un clic.",
        "pains": [
          {
            "body": "Avec plusieurs chantiers actifs et des équipes changeantes, les relevés d'heures manuels sont par définition inexacts. Les travailleurs arrondissent, oublient des enregistrements ou les complètent des jours plus tard — ce qui vous laisse avec des données salariales que vous ne pouvez pas justifier.",
            "title": "Aucune vue fiable de qui a travaillé où"
          },
          {
            "body": "La loi belge prévoit une responsabilité solidaire : si un sous-traitant n'enregistre pas ses travailleurs (Dimona) ou ne respecte pas CheckIn@Work, c'est vous, en tant qu'entrepreneur principal, qui portez le risque d'inspection. Sans une vue unique, vous avancez à l'aveugle.",
            "title": "Les sous-traitants sont aussi votre responsabilité"
          },
          {
            "body": "Au moment où vous remarquez qu'un chantier a épuisé ses heures planifiées, la marge a déjà disparu. Il n'y a pas de décompte en direct — seulement une mauvaise surprise au moment de la facturation.",
            "title": "Les dépassements de budget se révèlent trop tard"
          },
          {
            "body": "Rassembler les relevés d'heures, les rapprocher des projets et les traduire pour le secrétariat social prend des jours. Chaque enregistrement est une erreur potentielle.",
            "title": "La préparation des salaires coûte des heures chaque mois"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise de construction · 14 travailleurs",
          "text": "Notre équipe s'enregistre elle-même sur le chantier. À la fin du mois, le traitement salarial est tout simplement correct — nous avons complètement arrêté de courir après les relevés d'heures.",
          "result": "5 heures par semaine économisées sur l'administration"
        },
        "stats": [
          {
            "label": "pour s'enregistrer sur chaque chantier — pas de terminal, pas de papier",
            "value": "1 pression"
          },
          {
            "label": "export salarial prêt pour votre secrétariat social",
            "value": "1 clic"
          },
          {
            "label": "obligation générale d'enregistrement du temps — soyez prêt",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Une seule pression enregistre l'arrivée du travailleur, vérifiée par géolocalisation, et rattache les heures au bon projet. Pas de lecteurs de cartes, pas de terminaux — simplement le smartphone que votre équipe a déjà en poche. Alimente check-in at work pour les chantiers belges.",
            "title": "Check-in vérifié par géolocalisation par chantier"
          },
          {
            "body": "Définissez les heures planifiées comme budget lorsque vous ouvrez le projet. Les travailleurs voient un décompte de ce qu'il reste ; vous le voyez en direct dans votre tableau de bord. Les dépassements de budget sont visibles avant qu'ils ne surviennent.",
            "title": "Heures restantes en direct par projet"
          },
          {
            "body": "Ajoutez des sous-traitants à un projet, attribuez-les au check-in et suivez leurs heures aux côtés de votre propre équipe — dans la même vue d'ensemble.",
            "title": "Gestion et présence des sous-traitants"
          },
          {
            "body": "Done-it transmet automatiquement les données de présence vers la plateforme officielle belge CheckIn@Work. Pas de double saisie, pas de sessions manuelles sur le portail de l'ONSS.",
            "title": "Synchronisation CheckIn@Work"
          },
          {
            "body": "Toutes les heures enregistrées — par travailleur, par projet — vous les exportez vers un tableur clair et les transmettez directement à votre secrétariat social.",
            "title": "Export salarial en un clic"
          }
        ],
        "headline": "Enregistrement du temps pour les équipes de chantier — check-in vérifié par géolocalisation, heures de projet et checkin@work, dans une seule app",
        "workflow": [
          {
            "body": "Chaque travailleur tape une seule fois pour s'enregistrer. Le GPS confirme la localisation, enregistre l'heure et rattache les heures au projet. Pas de papier, pas de terminal.",
            "step": "L'équipe arrive sur le chantier"
          },
          {
            "body": "Heures, budget restant, présence des sous-traitants et chaque travail supplémentaire signalé depuis le chantier — le tout dans votre tableau de bord, en temps réel.",
            "step": "Vous voyez tout en direct"
          },
          {
            "body": "Exportez toutes les heures par travailleur et par projet. Transmettez-les à votre secrétariat social. Les données de Done-it satisfont déjà à CheckIn@Work et aux exigences de 2027.",
            "step": "Fin de mois en quelques minutes"
          }
        ],
        "compliance": {
          "body": "Sur les chantiers belges, l'arrivée de chaque travailleur doit être enregistrée via check-in at work et transmise à l'ONSS (pour les chantiers au-dessus du seuil). Aujourd'hui, il s'agit uniquement du check-in — l'arrivée. À partir du 1er janvier 2027, une obligation générale ajoute un enregistrement complet du temps de travail pour chaque employeur, y compris la construction : vous devez tenir une vue fiable de l'intégralité du temps de travail (le début et la fin de la journée ne doivent pas être transmis automatiquement à l'ONSS). Done-it couvre les deux — il alimente check-in at work et tient l'enregistrement du temps étanche qu'exigent les règles de 2027.",
          "slug": "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "label": "Check-in at work + loi de 2027",
          "title": "La construction enregistre déjà la présence — et 2027 y ajoute davantage"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-vermijd-je-boetes-met-digitale-oplossingen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Nettoyage",
        "slug": "cleaning",
        "intro": "Check-in and out at work (CIAO@work) est obligatoire depuis le 1er septembre 2024 : enregistrement de l'entrée et de la sortie en temps réel pour chaque agent d'entretien, sur chaque site, sans saisie rétroactive autorisée. Done-it assure l'enregistrement automatiquement et le transforme en un export salarial clair.",
        "pains": [
          {
            "body": "Chaque travailleur doit enregistrer lui-même son entrée et sa sortie en temps réel, pauses comprises — et chaque fois cela est transmis à l'ONSS, parfois plusieurs fois par jour. L'employeur ne peut pas le faire à sa place, et l'enregistrement anticipé est interdit. Un seul enregistrement manqué constitue une infraction.",
            "title": "Check-in and out at work est obligatoire — et fastidieux"
          },
          {
            "body": "La loi belge prévoit une responsabilité solidaire : si un sous-traitant n'enregistre pas ses travailleurs (Dimona) ou ne respecte pas check-in and out at work, c'est vous, en tant qu'entrepreneur principal, qui portez le risque d'inspection. Sans une vue unique, vous avancez à l'aveugle.",
            "title": "Les sous-traitants sont aussi votre responsabilité"
          },
          {
            "body": "Clients et inspecteurs attendent des enregistrements de présence étanches. Les listes manuelles peuvent être contestées ; les check-ins numériques vérifiés par géolocalisation, non.",
            "title": "Prouver la présence sur chaque site"
          },
          {
            "body": "Avec des agents d'entretien qui se déplacent entre sites au fil de la journée, vous n'avez aucune vue en direct de qui travaille où — jusqu'à ce que quelqu'un appelle.",
            "title": "Des équipes dispersées sur de nombreux sites"
          },
          {
            "body": "Sans heures d'entrée et de sortie précises, le traitement salarial est reconstitué de mémoire. Les heures sont arrondies vers le haut, les coûts grimpent et les discussions suivent.",
            "title": "Des erreurs de salaire dues aux heures arrondies"
          }
        ],
        "quote": {
          "who": "Manager, entreprise de nettoyage · 9 travailleurs",
          "text": "Nous pouvons enfin prouver qui a nettoyé où et quand. Fini les listes de présence, finies les discussions avec les clients — le GPS s'en charge.",
          "result": "Plus aucun arrondi des heures vers le haut"
        },
        "stats": [
          {
            "label": "2024 — check-in and out at work est devenu obligatoire",
            "value": "1er sept."
          },
          {
            "label": "amende par travailleur en cas de non-respect",
            "value": "300 €–6k €"
          },
          {
            "label": "double saisie — Done-it synchronise automatiquement",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Les travailleurs enregistrent leur entrée et leur sortie sur leur téléphone, sur chaque site, vérifiés par géolocalisation ; l'heure est exacte, avec enregistrement des pauses. (L'intégration officielle check-in and out at work / CIAO@work fait partie des Project plans.)",
            "plan": "Time Basic",
            "title": "Check-in and out en temps réel"
          },
          {
            "body": "Les pauses obligatoires sont automatiquement déduites de la journée de travail — pas de calcul manuel, pas de discussions.",
            "plan": "Time Basic",
            "title": "Déduction automatique des pauses"
          },
          {
            "body": "Voyez quels agents d'entretien sont sur quels sites en ce moment. Repérez les lacunes avant que les clients ne les remarquent.",
            "title": "Vue en direct sur plusieurs sites"
          },
          {
            "body": "Les travailleurs chargent les certificats médicaux et les documents d'absence directement depuis l'app. Prend en charge le chômage intempéries et d'autres types d'absence pertinents pour le secteur.",
            "title": "Enregistrement des absences avec certificats médicaux numériques"
          },
          {
            "body": "Les horodatages conformes circulent directement vers un export prêt pour le salaire à destination de votre secrétariat social. Pas de recopiage, pas d'erreurs.",
            "title": "Export salarial en un clic"
          }
        ],
        "headline": "Enregistrement du temps pour les entreprises de nettoyage — check-in and out at work, preuve de présence et traitement salarial dans une seule app",
        "workflow": [
          {
            "body": "Une pression enregistre son entrée, vérifiée par géolocalisation. Le début et la fin de la pause sont enregistrés dans l'app — exactement comme l'exige check-in and out at work.",
            "step": "L'agent d'entretien arrive sur le site"
          },
          {
            "body": "Done-it transmet les données d'entrée et de sortie en temps réel vers la plateforme officielle. Vous ne devez jamais vous connecter manuellement au portail.",
            "step": "Les données circulent automatiquement vers l'ONSS"
          },
          {
            "body": "Toutes les données de présence — avec heures exactes, sites et pauses — vous les exportez proprement pour votre secrétariat social.",
            "step": "Le traitement salarial tient en un clic"
          }
        ],
        "compliance": {
          "body": "Check-in and out at work (CIAO@work) est obligatoire pour le nettoyage professionnel de biens immobiliers de tiers depuis le 1er septembre 2024. Chaque travailleur — salarié, indépendant, intérimaire ou stagiaire — doit enregistrer le début et la fin du travail en temps réel, pauses comprises, chaque fois transmis à l'ONSS (parfois plusieurs fois par jour). L'obligation entre en vigueur à partir de 30.000 € (aucun sous-traitant), 5.000 € (un sous-traitant), ou tout montant en cas de deux sous-traitants ou plus. Les amendes au titre du Code pénal social vont de 300 € à 6.000 € par travailleur. Done-it synchronise automatiquement les données d'entrée et de sortie avec la plateforme officielle — pas de double saisie.",
          "slug": "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "label": "Check-in and out at work — obligatoire depuis sept. 2024",
          "title": "Check-in and out at work est en vigueur — chaque entreprise de nettoyage doit s'y conformer"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Installation",
        "slug": "installation",
        "intro": "Envoyez vos monteurs à la bonne adresse avec tout ce dont ils ont besoin, rattachez chaque heure travaillée automatiquement au bon chantier, et voyez le budget restant avant que le chantier ne se termine. Done-it est la façon la plus simple de tenir les projets d'installation dans les délais et dans les coûts.",
        "pains": [
          {
            "body": "Les équipes arrivent sur un chantier sans l'adresse, la personne de contact ou les détails de la mission. Ce premier coup de fil, ce sont dix minutes de temps facturable perdues avant qu'une seule heure ne soit travaillée.",
            "title": "Les infos de chantier n'arrivent pas à temps sur le terrain"
          },
          {
            "body": "Lorsque les travailleurs complètent leurs heures manuellement en fin de journée — s'ils les complètent — les heures atterrissent sur le mauvais chantier, ou disparaissent complètement. Les factures ne correspondent pas à la réalité.",
            "title": "Les heures ne sont pas rattachées au bon projet"
          },
          {
            "body": "Sans un décompte en direct des heures restantes par projet, vous ne découvrez qu'un chantier a débordé qu'au moment d'établir la facture — pas quand vous pouviez encore réagir.",
            "title": "Les dépassements de budget sont remarqués trop tard"
          },
          {
            "body": "Les sous-traitants qui travaillent sur le même chantier utilisent d'autres systèmes, complètent leurs heures séparément ou pas du tout. Le rapprochement en fin de mois est un processus lent et sujet aux erreurs.",
            "title": "Les heures des sous-traitants difficiles à suivre"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise d'installation · 6 travailleurs",
          "text": "Les heures atterrissent automatiquement sur le bon projet. Le calcul du coût des chantiers est devenu simple d'un coup — nous voyons la marge réelle avant de clôturer un chantier.",
          "result": "Coût réel par chantier, en direct"
        },
        "stats": [
          {
            "label": "vue sur les heures restantes par projet",
            "value": "Temps réel"
          },
          {
            "label": "appels au bureau pour les adresses de chantier",
            "value": "0"
          },
          {
            "label": "obligation générale d'enregistrement du temps",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Les travailleurs ouvrent le projet sur leur téléphone : adresse, heures planifiées, personne de contact et fichiers chargés (plans, instructions, PDF). Tout ce dont ils ont besoin est là avant qu'ils n'arrivent.",
            "plan": "Project Basic",
            "title": "Infos de projet partagées directement dans l'app"
          },
          {
            "body": "Tapez une seule fois et le téléphone navigue vers l'adresse du projet — intégré à l'app, sans appli de cartes séparée.",
            "title": "Navigation vers le chantier en un bouton"
          },
          {
            "body": "Définissez les heures planifiées lorsque vous ouvrez le projet. Les travailleurs voient combien d'heures il reste ; vous voyez le statut en direct dans votre tableau de bord. Les dépassements sont visibles avant qu'ils ne surviennent.",
            "plan": "Project Basic",
            "title": "Décompte des heures restantes par projet"
          },
          {
            "body": "Chaque travailleur s'enregistre sur le bon projet. Vous savez toujours qui se trouve en ce moment sur quel chantier.",
            "plan": "Project Basic",
            "title": "Check-in des travailleurs par projet"
          },
          {
            "body": "Lorsque la mission s'étend sur le chantier, les travailleurs enregistrent le travail supplémentaire et le matériel en temps réel — avec texte et photos — pour que rien ne soit facturé de mémoire.",
            "plan": "Project Basic",
            "title": "Enregistrement du travail supplémentaire et du matériel"
          }
        ],
        "headline": "Enregistrement du temps pour les équipes d'installation — heures de projet, navigation et gestion de budget dans une seule app",
        "workflow": [
          {
            "body": "Adresse, contact, mission et fichiers chargés sont là immédiatement. Ils naviguent en une pression — pas d'appels au bureau pour la route.",
            "step": "Le travailleur ouvre le projet sur son téléphone"
          },
          {
            "body": "Le check-in rattache chaque minute travaillée au bon projet. Le budget restant est mis à jour en direct.",
            "step": "Les heures s'enregistrent automatiquement sur le bon chantier"
          },
          {
            "body": "Les modifications de la mission, le matériel supplémentaire et les retards sont enregistrés avec texte et photos au moment où ils surviennent — prêts pour la facture.",
            "step": "Le travail supplémentaire est consigné sur le chantier"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur doit enregistrer les heures de travail avec un système numérique étanche. Pour les travaux d'installation sur les grands chantiers (≥ 500.000 € hors TVA), l'enregistrement CheckIn@Work est déjà obligatoire aujourd'hui — et avec des sous-traitants, vous portez une responsabilité solidaire pour leur conformité. Done-it couvre les deux : il fournit le système général d'enregistrement du temps qu'exige 2027 et synchronise avec CheckIn@Work là où le seuil s'applique.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027 + responsabilité solidaire",
          "title": "Les équipes d'installation relèvent à la fois de la loi de 2027 et des règles sur les sous-traitants"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Service extérieur",
        "slug": "field-service",
        "intro": "Des techniciens qui visitent plusieurs clients par jour, des tickets dans les boîtes à gants, des kilomètres notés de mémoire. Done-it consigne les heures, les kilomètres et les frais sur le terrain — rattachés au bon chantier au moment où ils surviennent.",
        "pains": [
          {
            "body": "Demander aux techniciens de reconstituer leurs trajets en fin de semaine conduit à des indemnités inexactes, des discussions avec les clients et une pile croissante de kilomètres non introduits.",
            "title": "Des kilomètres notés des jours plus tard — quand ils le sont"
          },
          {
            "body": "Un ticket dans une boîte à gants est un coût qui n'atterrira peut-être jamais sur une facture. Le coût réel par chantier est toujours sous-estimé.",
            "title": "Des frais sur des tickets papier qui disparaissent"
          },
          {
            "body": "Sans check-ins en direct, vous n'apprenez où se trouve un technicien que lorsque quelque chose tourne mal et que quelqu'un appelle.",
            "title": "Aucune vue en temps réel de l'endroit où se trouve l'équipe"
          },
          {
            "body": "Lorsque main-d'œuvre, déplacement et frais sont suivis dans des systèmes séparés — ou pas du tout — il n'y a jamais un chiffre de coût unique par chantier.",
            "title": "Difficile de voir la marge réelle par chantier"
          }
        ],
        "quote": {
          "who": "Responsable opérationnel, entreprise de service extérieur · 11 travailleurs",
          "text": "Les kilomètres étaient autrefois un casse-tête mensuel. Maintenant ils s'enregistrent tout seuls — chaque kilomètre est rattaché au bon client avant même que nous soyons de retour au bureau.",
          "result": "Coût par chantier précis, à chaque fois"
        },
        "stats": [
          {
            "label": "par km — tarif officiel belge (annuel, 2025–26)",
            "value": "0,4449 €"
          },
          {
            "label": "seuil de km/an — au-delà, les coûts réels doivent être prouvés",
            "value": "24 000"
          },
          {
            "label": "obligation générale d'enregistrement du temps",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Le GPS enregistre le départ, l'arrivée et la distance exacte par trajet. Configurez des types de transport (voiture personnelle, véhicule de société, covoiturage) avec leurs propres tarifs d'indemnité. Pas de carnet de route manuel.",
            "plan": "Add-on",
            "title": "Enregistrement automatique des kilomètres (Trax-it)"
          },
          {
            "body": "Les travailleurs prennent en photo un ticket sur le terrain ; il est rattaché au chantier et prêt pour le remboursement — pas couru après en fin de mois.",
            "plan": "Time Basic",
            "title": "Gestion des frais sur le terrain"
          },
          {
            "body": "Heures, kilomètres et frais sont additionnés au chantier en temps réel. Le coût par chantier est visible tant que le chantier est encore ouvert.",
            "plan": "Project Basic",
            "title": "Gestion des coûts rattachée au projet"
          },
          {
            "body": "Chaque technicien s'enregistre sur le site client. Vous voyez qui est où, en ce moment — pas d'appels, pas de devinettes.",
            "title": "Check-in vérifié par géolocalisation et vue d'équipe en direct"
          },
          {
            "body": "Heures et indemnités kilométriques, vous les exportez proprement pour le secrétariat social — avec les tarifs kilométriques officiels belges appliqués automatiquement.",
            "title": "Export salarial en un clic"
          }
        ],
        "headline": "Enregistrement du temps pour les équipes de service extérieur — kilomètres, frais et heures en déplacement, le tout dans une seule app",
        "workflow": [
          {
            "body": "Le check-in démarre le carnet de trajets. Les kilomètres sont consignés automatiquement du départ à l'arrivée — pas de saisie manuelle.",
            "step": "Le technicien part pour le premier appel"
          },
          {
            "body": "Rattacher les heures au bon projet. Travail supplémentaire, matériel et tickets sont enregistrés dans l'app au moment où ils surviennent.",
            "step": "Sur le chantier"
          },
          {
            "body": "Chaque heure, chaque kilomètre et chaque frais est déjà rattaché au bon chantier. Exportez vers le traitement salarial et facturez avec des chiffres de coût réels.",
            "step": "Fin de mois sans le chaos"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur doit enregistrer les heures de manière numérique. Pour les travailleurs de service extérieur qui se déplacent entre sites clients, l'arrêt Tyco de l'UE (2015) signifie aussi que le déplacement du domicile au premier client et du dernier client au domicile compte comme temps de travail. L'indemnité kilométrique belge connaît des tarifs maximaux officiels (0,4449 €/km annuel, T2 2025 : 0,4320 €/km) — les dépasser exige une preuve des coûts réels. Done-it applique automatiquement le tarif indexé actuel et signale le seuil de 24.000 km/an par travailleur.",
          "slug": "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "label": "Loi de 2027 + règles kilométriques",
          "title": "Le service extérieur relève de l'obligation générale de 2027 — et les kilomètres ont leurs propres règles"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Chaque appel de service comporte trois coûts : main-d'œuvre, pièces et déplacement. Done-it consigne les trois sur le terrain et les additionne au bon chantier — afin que vous connaissiez votre marge avant de clôturer la facture.",
        "pains": [
          {
            "body": "Main-d'œuvre, pièces et déplacement vivent dans différents systèmes — ou différentes poches. Le coût réel d'une intervention n'apparaît clairement que bien après que le technicien a quitté le chantier.",
            "title": "Les appels de service sont difficiles à chiffrer avec précision"
          },
          {
            "body": "Lorsqu'un client conteste la durée d'une réparation, un relevé d'heures papier est facile à contester. Des horodatages de check-in et de check-out confirmés par GPS, non.",
            "title": "Aucune preuve du temps de service"
          },
          {
            "body": "Avec des contrats d'entretien récurrents, de petits dépassements s'accumulent au fil de nombreuses visites. Sans un compteur d'heures en direct, vous n'apprenez qu'au renouvellement que le contrat est déficitaire.",
            "title": "Les contrats d'entretien grignotent silencieusement la marge"
          },
          {
            "body": "Les enregistrements du temps manuels ratent les pauses, ce qui entraîne un surpaiement et un traitement salarial qui ne correspond pas à la réalité.",
            "title": "Les techniciens oublient d'enregistrer les pauses"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise HVAC · 7 techniciens",
          "text": "Nous savons enfin ce que chaque contrat de service nous coûte réellement. Les mauvaises surprises de marge ont cessé le jour où nous avons commencé à utiliser Done-it.",
          "result": "Coût réel par appel de service, en direct"
        },
        "stats": [
          {
            "label": "types de coûts consignés par appel : main-d'œuvre, déplacement, pièces",
            "value": "3"
          },
          {
            "label": "vue sur la marge par contrat de service",
            "value": "En direct"
          },
          {
            "label": "enregistrement numérique du temps obligatoire",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Chaque appel de service ou contrat d'entretien est un projet. Heures, déplacement et matériel sont additionnés en temps réel — ce qui vous donne une vue en direct sur votre marge.",
            "plan": "Project Basic",
            "title": "Enregistrement du temps basé sur le projet"
          },
          {
            "body": "Lorsqu'un chantier s'étend, les techniciens enregistrent le travail supplémentaire et les pièces avec texte et photos avant de partir. Rien n'est facturé de mémoire.",
            "plan": "Project Basic",
            "title": "Travail supplémentaire et matériel, enregistrés sur le terrain"
          },
          {
            "body": "Les kilomètres par intervention sont enregistrés automatiquement et imputés au chantier. Configurez les tarifs d'indemnité par type de véhicule.",
            "plan": "Add-on",
            "title": "Kilomètres et frais de transport"
          },
          {
            "body": "Les pauses obligatoires sont automatiquement déduites du temps total — pas de discussions, pas d'erreurs de salaire.",
            "title": "Déduction automatique des pauses"
          },
          {
            "body": "Check-in horodaté, confirmé par GPS sur chaque chantier. Preuve incontestable du moment où le technicien est arrivé et reparti.",
            "title": "Check-in vérifié par géolocalisation et preuve de présence"
          }
        ],
        "headline": "Enregistrement du temps pour les techniciens HVAC — calcul du coût des chantiers, pièces et déplacement dans une seule app",
        "workflow": [
          {
            "body": "Le GPS horodate l'arrivée et rattache les heures à l'appel de service ou au contrat d'entretien. Pas de papier, pas de terminal.",
            "step": "Le technicien s'enregistre sur le chantier"
          },
          {
            "body": "Pièces utilisées, heures supplémentaires et modifications de la mission sont enregistrées dans l'app avec photos — avant de quitter le chantier.",
            "step": "Le travail supplémentaire est consigné sur place"
          },
          {
            "body": "Main-d'œuvre, déplacement et matériel sont additionnés au projet en temps réel. Vous voyez la marge avant d'établir la facture.",
            "step": "Le coût du chantier est immédiatement visible"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur belge doit tenir une vue numérique et étanche des heures de travail. Pour les équipes HVAC qui travaillent sur de grands chantiers (≥ 500.000 € hors TVA), l'enregistrement CheckIn@Work est déjà requis aujourd'hui. Done-it couvre les deux scénarios et exporte les données directement vers votre secrétariat social.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027",
          "title": "Les équipes HVAC relèvent de l'obligation générale d'enregistrement du temps de 2027"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Électriciens",
        "slug": "electricians",
        "intro": "Heures de projet, décompte en direct du budget restant et navigation vers le chantier en un bouton — conçu pour les petites équipes d'électriciens qui ont besoin de gestion de projet sans la charge administrative.",
        "pains": [
          {
            "body": "Lorsque des électriciens travaillent sur plusieurs chantiers dans une semaine, l'attribution manuelle des heures en fin de journée mène à des coûts mal imputés, des discussions de facturation et un traitement salarial que vous ne pouvez pas expliquer.",
            "title": "Les heures ne sont pas rattachées au bon projet"
          },
          {
            "body": "Sans une vue en direct des heures consommées par rapport aux heures budgétées, vous ne découvrez qu'un projet a débordé qu'au moment d'établir la facture — pas quand vous pouviez encore réagir.",
            "title": "Les dépassements de budget sont remarqués trop tard"
          },
          {
            "body": "Des adresses tapées dans une appli séparée, des appels au bureau pour la route, des arrivées tardives sur les sites clients. Chaque minute perdue est une minute facturable perdue.",
            "title": "Du temps perdu à trouver le chantier"
          },
          {
            "body": "Sur les installations plus grandes, les électriciens sous-traitants tiennent leurs propres heures séparément. Obtenir une vue combinée des coûts de main-d'œuvre en fin de projet est une tâche manuelle et sujette aux erreurs.",
            "title": "Les heures des sous-traitants difficiles à rapprocher"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise d'électricité · 5 électriciens",
          "text": "Nous savons en temps réel si un projet dépasse son budget. Cela seul nous a épargné deux mauvaises surprises cette année.",
          "result": "Dépassements de budget repérés avant qu'ils ne surviennent"
        },
        "stats": [
          {
            "label": "vue sur les heures restantes par projet",
            "value": "En direct"
          },
          {
            "label": "appels au bureau pour les adresses de chantier",
            "value": "0"
          },
          {
            "label": "enregistrement numérique du temps obligatoire",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Chaque minute travaillée est automatiquement rattachée au bon projet. Un décompte en direct montre combien d'heures il reste par rapport au budget — pour vous et pour le travailleur sur le chantier.",
            "plan": "Project Basic",
            "title": "Heures de projet avec budget restant en direct"
          },
          {
            "body": "L'adresse du projet est dans l'app. Une pression ouvre la navigation — pas de recherche, pas d'appli de cartes séparée, pas d'appels au bureau.",
            "title": "Navigation vers le chantier en un bouton"
          },
          {
            "body": "Chaque électricien s'enregistre sur le bon chantier. Vous savez toujours qui se trouve en ce moment sur quel chantier.",
            "plan": "Project Basic",
            "title": "Check-in des travailleurs par projet"
          },
          {
            "body": "Lorsque la mission change — un circuit imprévu, du matériel supplémentaire — c'est enregistré dans l'app avec photos, avant que l'équipe ne parte.",
            "plan": "Project Basic",
            "title": "Travail supplémentaire enregistré sur le chantier"
          },
          {
            "body": "Les heures supplémentaires sont enregistrées au moment où elles surviennent. Les travailleurs choisissent de se les faire payer ou de les convertir en repos compensatoire.",
            "plan": "Time Pro",
            "title": "Enregistrement des heures supplémentaires avec rémunération flexible"
          }
        ],
        "headline": "Enregistrement du temps pour les électriciens — heures de projet, gestion de budget et navigation dans une seule app",
        "workflow": [
          {
            "body": "Adresse et mission sont déjà dans l'app. Une pression ouvre la navigation — pas d'appels, pas de confusion.",
            "step": "L'électricien navigue vers le chantier"
          },
          {
            "body": "Le check-in sur le chantier rattache chaque minute travaillée au bon projet. Le compteur d'heures restantes est mis à jour en direct.",
            "step": "Les heures se rattachent automatiquement au bon projet"
          },
          {
            "body": "Travail supplémentaire et matériel sont enregistrés sur le chantier, avant le départ. La facture reflète ce qui s'est réellement passé.",
            "step": "Les modifications de la mission restent enregistrées"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, tous les employeurs doivent enregistrer les heures de manière numérique. Pour les travaux d'électricité sur les chantiers de ≥ 500.000 € hors TVA, CheckIn@Work est déjà obligatoire aujourd'hui. Done-it couvre les deux : il fournit l'enregistrement du temps numérique qu'exige 2027 et synchronise avec CheckIn@Work lorsque le seuil de chantier est atteint.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027 + CheckIn@Work sur les grands chantiers",
          "title": "Les électriciens relèvent de l'obligation de 2027 — et de CheckIn@Work là où le seuil de chantier s'applique"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Plombiers",
        "slug": "plumbing",
        "intro": "Des interventions urgentes, plusieurs chantiers par jour, des heures complétées de mémoire en fin de semaine — ou pas du tout. Done-it en fait une affaire d'une seule pression sur chaque chantier et d'un traitement salarial en un clic en fin de mois.",
        "pains": [
          {
            "body": "Avec plusieurs chantiers dans une journée, les plombiers ont rarement le temps de compléter des relevés d'heures précis. Les heures sont arrondies ou oubliées, et le traitement salarial est au mieux une estimation.",
            "title": "Des heures d'intervention reconstituées de mémoire"
          },
          {
            "body": "Lorsqu'un client conteste la durée d'une réparation, il n'y a aucune vue objective. Un check-in numérique confirmé par GPS est facile à montrer — un relevé d'heures papier, non.",
            "title": "Aucune preuve du temps sur le chantier"
          },
          {
            "body": "Les déplacements entre interventions s'accumulent sur la semaine et le mois, mais sans enregistrement automatique ils sont rarement facturés ou indemnisés correctement.",
            "title": "Les kilomètres entre chantiers non suivis"
          },
          {
            "body": "En fin de mois, courir après les relevés d'heures, corriger les erreurs et constituer l'export pour le secrétariat social prend un temps que votre équipe administrative ne devrait pas y consacrer.",
            "title": "La préparation des salaires est lente"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise de plomberie · 4 plombiers",
          "text": "Nous perdions autrefois une demi-matinée en fin de mois à reconstituer les heures. Maintenant nous exportons et envoyons, tout simplement. Le secrétariat social le reçoit proprement.",
          "result": "Préparation des salaires : d'heures à minutes"
        },
        "stats": [
          {
            "label": "pour s'enregistrer — assez rapide pour les appels urgents",
            "value": "1 pression"
          },
          {
            "label": "export salarial vers votre secrétariat social",
            "value": "1 clic"
          },
          {
            "label": "enregistrement numérique du temps obligatoire",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Arrivée et départ enregistrés en une pression, avec vérification de la localisation du site. Assez rapide pour les appels urgents ; assez précis pour les discussions.",
            "plan": "Time Basic",
            "title": "Check-in vérifié par géolocalisation en une pression à chaque intervention"
          },
          {
            "body": "Les pauses obligatoires sont automatiquement déduites du temps total — rien à compléter, pas d'erreurs de salaire.",
            "plan": "Time Basic",
            "title": "Déduction automatique des pauses"
          },
          {
            "body": "Configurez les types de transport et les tarifs d'indemnité. Les kilomètres sont enregistrés automatiquement et rattachés au bon client ou au bon projet.",
            "plan": "Add-on",
            "title": "Kilomètres consignés par trajet"
          },
          {
            "body": "Les travailleurs introduisent les certificats médicaux numériquement depuis l'app. Prend en charge le chômage intempéries et d'autres types d'absence pertinents pour la plomberie en extérieur.",
            "title": "Gestion des absences et des certificats médicaux"
          },
          {
            "body": "Toutes les données d'heures et de kilomètres, vous les exportez proprement pour votre secrétariat social — pas de préparation manuelle, pas d'Excel.",
            "plan": "Time Basic",
            "title": "Export salarial en un clic"
          }
        ],
        "headline": "Enregistrement du temps pour les équipes de plomberie — check-in rapide, traitement salarial précis et preuve de présence pour chaque intervention",
        "workflow": [
          {
            "body": "Une pression enregistre l'entrée. Le GPS enregistre la localisation et l'heure. Assez rapide pour un chantier urgent.",
            "step": "Le plombier arrive à l'intervention"
          },
          {
            "body": "Le check-out clôture l'enregistrement du temps. Les kilomètres vers le chantier suivant commencent à s'enregistrer automatiquement.",
            "step": "Départ tapé en sortant"
          },
          {
            "body": "Toutes les interventions, heures et kilomètres, vous les exportez proprement. La préparation des salaires passe d'une journée à quelques minutes.",
            "step": "La fin de mois tient en un clic"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur belge — y compris les petites équipes de plomberie — doit tenir une vue numérique, précise et infalsifiable des heures de travail. Les relevés d'heures papier et les tableurs partagés ne suffisent plus. Done-it couvre l'exigence d'emblée, exporte vers votre secrétariat social et garde tous les enregistrements conformes au RGPD.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027",
          "title": "La plomberie relève de l'obligation générale d'enregistrement du temps de 2027"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
          "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Aménagement paysager",
        "slug": "landscaping",
        "intro": "La haute saison, ce sont beaucoup de chantiers, des équipes changeantes et pas mal de kilomètres. Done-it garde chaque heure, chaque absence et chaque trajet organisés — pour que vous puissiez vous concentrer sur le travail, pas sur la paperasse.",
        "pains": [
          {
            "body": "Les travailleurs temporaires, les horaires changeants et les tailles d'équipe variables rendent l'enregistrement précis des heures presque impossible sur papier. Au moment où vous faites le rapprochement en fin de mois, il manque toujours quelque chose.",
            "title": "Les équipes saisonnières sont complexes à gérer"
          },
          {
            "body": "Une équipe qui visite trois ou quatre chantiers par jour génère des heures qui doivent être réparties correctement. La saisie manuelle mène à des mauvaises imputations et un traitement salarial contesté.",
            "title": "Des heures dispersées sur de nombreux chantiers"
          },
          {
            "body": "Le chômage intempéries est une réalité dans l'aménagement paysager. Sans une vue numérique, demander l'indemnité correcte et gérer l'eC3.2A est lent et sujet aux erreurs.",
            "title": "Le chômage intempéries est difficile à documenter"
          },
          {
            "body": "Camionnettes de société, véhicules personnels et covoiturages roulent toute la journée entre chantiers. Sans enregistrement automatique, ces kilomètres n'atterrissent jamais dans le calcul des coûts.",
            "title": "Les kilomètres entre chantiers restent non enregistrés"
          }
        ],
        "quote": {
          "who": "Gérant, entreprise d'aménagement paysager · 12 travailleurs saisonniers",
          "text": "La haute saison rimait autrefois avec chaos salarial. Maintenant notre chef d'équipe consulte l'app, tout le monde est enregistré, et j'exporte les heures le dernier jour du mois.",
          "result": "Fini la reconstruction du traitement salarial en fin de mois"
        },
        "stats": [
          {
            "label": "carte numérique eC3.2A obligatoire pour le chômage temporaire",
            "value": "1 janv. 2025"
          },
          {
            "label": "obligation générale d'enregistrement du temps",
            "value": "1 janv. 2027"
          },
          {
            "label": "enregistrement des kilomètres — fini le carnet de route",
            "value": "Automatique"
          }
        ],
        "features": [
          {
            "body": "Voyez toutes les équipes, tous les chantiers en temps réel. Sachez qui travaille où, en ce moment — pas en fin de mois.",
            "title": "Vue d'équipe sur plusieurs chantiers"
          },
          {
            "body": "Planifiez qui travaille où, gérez les changements de dernière minute et envoyez le planning vers les téléphones de l'équipe — sans un appel à chaque personne.",
            "plan": "Time Pro",
            "title": "Planification des shifts pour les équipes saisonnières"
          },
          {
            "body": "Créez des types d'absence personnalisés pour votre secteur : chômage intempéries saisonnier, congé parental, jours de maladie. Les travailleurs chargent la documentation numériquement depuis l'app.",
            "title": "Types d'absence personnalisés"
          },
          {
            "body": "Configurez les types de transport (camionnette de société, voiture personnelle, covoiturage conducteur vs. passager) avec leurs propres tarifs. Les kilomètres sont enregistrés automatiquement par trajet.",
            "plan": "Add-on",
            "title": "Kilomètres avec enregistrement du covoiturage"
          },
          {
            "body": "Les heures supplémentaires en haute saison s'accumulent vite. Chaque travailleur peut choisir de se les faire payer ou d'épargner les heures en repos compensatoire — suivi de façon transparente.",
            "plan": "Time Pro",
            "title": "Enregistrement des heures supplémentaires avec conversion en congé"
          }
        ],
        "headline": "Enregistrement du temps pour les entreprises d'aménagement paysager — équipes saisonnières, chantiers multiples et kilomètres dans une seule vue",
        "workflow": [
          {
            "body": "Le GPS enregistre l'arrivée. Les heures sont automatiquement réparties sur le bon site et le bon projet — pas d'attribution manuelle en fin de journée.",
            "step": "L'équipe s'enregistre sur le premier chantier"
          },
          {
            "body": "Le chef d'équipe enregistre le chômage intempéries depuis l'app. La vue numérique soutient la procédure eC3.2A sans paperasse supplémentaire.",
            "step": "Le temps met le travail à l'arrêt"
          },
          {
            "body": "Heures, absences et kilomètres sur chaque chantier et chaque membre d'équipe, vous les exportez proprement pour le traitement salarial.",
            "step": "Fin de mois : tous les chantiers, toutes les équipes, un seul export"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur doit enregistrer les heures de manière numérique. Les équipes d'aménagement paysager qui travaillent en extérieur sont aussi souvent confrontées au chômage intempéries (chômage temporaire pour cause d'intempéries). Depuis le 1er janvier 2025, la carte de contrôle numérique eC3.2A est obligatoire pour le chômage temporaire dans les secteurs incluant le travail en extérieur. Done-it prend en charge des types d'absence personnalisés pour le chômage intempéries et fournit l'enregistrement du temps numérique qu'exige la loi de 2027.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027 + chômage intempéries",
          "title": "L'aménagement paysager relève de l'obligation de 2027 — et le chômage intempéries ajoute une obligation numérique spécifique"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
          "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Entretien",
        "slug": "maintenance",
        "intro": "Les contrats d'entretien récurrents tiennent ou tombent avec la vue sur les coûts. Done-it enregistre chaque visite, suit les heures par rapport au budget du contrat et vous donne — à vous et à vos clients — une preuve de présence pour chaque appel.",
        "pains": [
          {
            "body": "Lorsque les heures des visites récurrentes ne sont pas suivies par rapport au contrat spécifique, vous ne savez qu'au décompte annuel si un client est rentable — et il est alors trop tard pour reprixer.",
            "title": "Aucune vue sur les coûts par contrat d'entretien"
          },
          {
            "body": "Les facility managers et les propriétaires veulent de plus en plus des enregistrements de présence : qui est venu, quand ils sont arrivés, ce qu'ils ont fait. Un journal papier présenté des semaines plus tard ne satisfait pas aux exigences de SLA.",
            "title": "Les clients attendent une preuve de ce qui a été fait"
          },
          {
            "body": "Des shifts changeants sur de nombreux chantiers récurrents — avec du personnel qui remplace les uns les autres — créent un casse-tête de planification et d'enregistrement des heures que les processus manuels ne peuvent pas résoudre de façon fiable.",
            "title": "Les visites récurrentes difficiles à planifier et à enregistrer"
          },
          {
            "body": "L'entretien des jardins, l'entretien des façades et le travail sur les installations extérieures sont tous confrontés à l'arrêt lié au temps. Documenter correctement le chômage intempéries exige une trace numérique.",
            "title": "Le chômage intempéries touche aussi l'entretien extérieur"
          }
        ],
        "quote": {
          "who": "Responsable opérationnel, entreprise d'entretien · 8 travailleurs",
          "text": "Nous pouvons dire à un facility manager en deux minutes qui était exactement sur le chantier et quand. Ce niveau de preuve a changé la façon dont les clients nous perçoivent.",
          "result": "Discussions clients réduites à zéro"
        },
        "stats": [
          {
            "label": "coût par contrat d'entretien",
            "value": "En direct"
          },
          {
            "label": "preuve de présence prête pour les clients",
            "value": "GPS"
          },
          {
            "label": "enregistrement numérique du temps obligatoire",
            "value": "1 janv. 2027"
          }
        ],
        "features": [
          {
            "body": "Chaque contrat d'entretien est un projet. Les heures y sont automatiquement enregistrées, ce qui vous donne un chiffre de coût en direct et un décompte des heures restantes par client.",
            "plan": "Project Basic",
            "title": "Enregistrement des coûts basé sur le contrat"
          },
          {
            "body": "Des check-ins horodatés, vérifiés par géolocalisation, constituent une vue incontestable de qui était sur le chantier, quand et combien de temps — prête à être partagée avec les clients sur demande.",
            "title": "Preuve de présence confirmée par GPS"
          },
          {
            "body": "Les travailleurs signalent des problèmes, des tâches achevées ou du travail supplémentaire directement depuis l'app — avec texte et photos. Les clients reçoivent une vue en temps réel ; vous avez la documentation pour la facturation.",
            "plan": "Project Basic",
            "title": "Mises à jour avec photos depuis le chantier"
          },
          {
            "body": "Planifiez les visites récurrentes sur tous les contrats, attribuez les travailleurs et gérez les remplacements — sans un appel à chaque personne.",
            "plan": "Time Pro",
            "title": "Planification des shifts récurrents"
          },
          {
            "body": "Configurez le chômage intempéries et d'autres types d'absence. Les travailleurs enregistrent l'arrêt depuis l'app ; la documentation est chargée numériquement.",
            "title": "Types d'absence pour l'entretien extérieur"
          }
        ],
        "headline": "Enregistrement du temps pour les équipes d'entretien — visites de chantier récurrentes, coût par contrat et preuve de présence dans une seule app",
        "workflow": [
          {
            "body": "Le check-in vérifié par géolocalisation enregistre l'heure d'arrivée et rattache les heures au bon contrat. La preuve de présence est créée automatiquement.",
            "step": "Le travailleur arrive sur le chantier d'entretien"
          },
          {
            "body": "Le travail achevé et les éventuels problèmes sont signalés depuis l'app avec photos. Les clients voient précisément ce qui a été fait.",
            "step": "Tâches achevées, problèmes enregistrés"
          },
          {
            "body": "Les heures s'accumulent en temps réel par rapport au budget du contrat. Vous connaissez la marge avant que le contrat ne soit renouvelé.",
            "step": "Coût par contrat immédiatement visible"
          }
        ],
        "compliance": {
          "body": "À partir du 1er janvier 2027, chaque employeur doit tenir une vue numérique des heures de travail. Pour le travail d'entretien extérieur, le chômage intempéries (chômage temporaire pour cause d'intempéries) ajoute une obligation spécifique : depuis le 1er janvier 2025, la carte de contrôle eC3.2A sous forme numérique est obligatoire. Done-it couvre les deux : il fournit l'enregistrement général du temps qu'exige 2027 et prend en charge des types d'absence personnalisés — y compris le chômage intempéries — avec documentation numérique.",
          "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "label": "Loi de 2027 + chômage intempéries",
          "title": "Les équipes d'entretien relèvent de l'obligation de 2027 et sont confrontées à des obligations numériques spécifiques au chômage intempéries"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
          "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
          "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Commerces & retail",
        "slug": "retail",
        "intro": "Shifts d'ouverture, shifts tardifs et toujours quelqu'un qui remplace quelqu'un. Done-it donne à chaque magasin un relevé numérique clair de qui a presté quel shift — pointé depuis le téléphone de chacun, prêt pour la paie en fin de mois.",
        "pains": [
          {
            "body": "Une collègue malade remplacée, quelqu'un qui reste une heure de plus à la fermeture. Ça finit sur un post-it, ou nulle part — et la paie est déjà fausse avant même de commencer.",
            "title": "Les échanges de shifts n'arrivent jamais à la paie"
          },
          {
            "body": "Les collaborateurs circulent entre les points de vente, les temps partiels prestent sur deux adresses. Rassembler les heures par magasin et les fusionner à la main coûte une journée par mois.",
            "title": "Plusieurs magasins, une seule paie"
          },
          {
            "body": "Les pauses légales sont déduites de mémoire et les heures en plus se règlent de manière informelle — exactement les deux points qu'un contrôle examine en premier.",
            "title": "Pauses et heures supplémentaires au jugé"
          }
        ],
        "quote": {
          "who": "Gérante, commerce · 11 collaborateurs",
          "text": "Deux magasins et beaucoup de temps partiels. Avant, la moitié des remplacements se réglait de mémoire. Aujourd'hui chaque heure est sur le bon magasin et la paie prend quelques minutes.",
          "result": "Préparation de la paie : d'une journée à moins d'une heure"
        },
        "stats": [
          {
            "label": "pour pointer — sans terminal à la caisse",
            "value": "1 tap"
          },
          {
            "label": "qui est présent, dans chaque magasin",
            "value": "Live"
          },
          {
            "label": "remplacement perdu entre le magasin et la paie",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un tap sur son propre téléphone au début du shift. Pas de terminal à la caisse, pas de badge partagé, pas de feuille accrochée près de la réserve.",
            "title": "Pointer depuis la surface de vente"
          },
          {
            "body": "Chaque magasin est un projet. Un renfort dans un autre point de vente est pointé sur ce point de vente — vous voyez les heures là où elles ont réellement été prestées.",
            "title": "Les heures par magasin, l'équipe entre les points de vente"
          },
          {
            "body": "Vous définissez la règle de pause une fois, elle s'applique à chaque shift. Les heures supplémentaires sont enregistrées dès qu'elles tombent, et chaque collaborateur choisit le paiement ou la récupération.",
            "title": "Pauses déduites automatiquement"
          }
        ],
        "headline": "Pointage pour les commerces — shifts, remplacements et export prêt pour la paie, dans une seule app",
        "workflow": [
          {
            "body": "Un tap sur le téléphone au début du shift. Un renfort dans un autre point de vente est pointé sur ce point de vente.",
            "step": "L'équipe pointe pour son shift"
          },
          {
            "body": "Une vue en direct sur tous les points de vente — repérez un shift d'ouverture non couvert avant que les portes s'ouvrent.",
            "step": "Vous voyez qui est présent, par magasin"
          },
          {
            "body": "Heures, pauses et heures supplémentaires par collaborateur et par magasin, exportées telles quelles pour votre secrétariat social.",
            "step": "La paie en un seul export"
          }
        ],
        "compliance": {
          "body": "Done-it conserve un relevé numérique objectif de chaque pointage d'entrée et de sortie, pauses et heures supplémentaires comprises — le relevé qu'un contrôle ou un litige de paie réclame.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement du temps par shift",
          "title": "Un relevé défendable de chaque shift presté"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Bureaux & services professionnels",
        "slug": "offices",
        "intro": "Comptables, notaires, architectes, agences et bureaux de conseil facturent leur temps — ou doivent au moins savoir où il est passé. Done-it enregistre les heures sur le bon client et le bon projet, depuis le bureau comme en déplacement.",
        "pains": [
          {
            "body": "Un temps noté en fin de semaine est un temps estimé. Des heures entières disparaissent discrètement entre la prestation et la facture.",
            "title": "Des heures facturables reconstituées le vendredi"
          },
          {
            "body": "Les honoraires ont été convenus il y a des mois. Savoir si le travail y rentre encore n'apparaît que quand quelqu'un fait le total — souvent trop tard.",
            "title": "Aucune idée de ce que coûte réellement un client"
          },
          {
            "body": "Une partie de l'équipe au bureau, une partie à domicile, une partie chez le client. La présence n'est plus un fait, elle devient une reconstitution.",
            "title": "Le travail hybride rend le relevé lacunaire"
          }
        ],
        "quote": {
          "who": "Associé, cabinet comptable · 8 collaborateurs",
          "text": "On reconstituait la semaine chaque vendredi. Maintenant les heures sont déjà sur le bon client et je vois quels dossiers mangent les honoraires.",
          "result": "Des heures facturables récupérées chaque mois"
        },
        "stats": [
          {
            "label": "les heures, visibles pendant que le dossier tourne",
            "value": "Par client"
          },
          {
            "label": "le même relevé, téléphone et navigateur",
            "value": "Bureau ou route"
          },
          {
            "label": "pour la paie et la facturation",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Chaque saisie tombe sur un projet : vous voyez les heures par client sans rien exporter ni demander à personne.",
            "title": "Des heures liées au client et au projet"
          },
          {
            "body": "La même app sur le téléphone ou dans le navigateur. Une visite chez un client compte comme du travail sur ce client, déplacement inclus si vous le souhaitez.",
            "title": "Au bureau comme à l'extérieur"
          },
          {
            "body": "Les heures en plus enregistrées quand elles tombent, les congés demandés et approuvés dans l'app — plus de tableur parallèle pour savoir qui est absent quand.",
            "title": "Heures supplémentaires et congés au même endroit"
          }
        ],
        "headline": "Pointage pour les bureaux — les heures par client et par projet, sans tableur",
        "workflow": [
          {
            "body": "Configurez-le une fois avec le client et, si vous facturez au budget, les heures prévues.",
            "step": "Ouvrez un projet client"
          },
          {
            "body": "Depuis le bureau ou le téléphone. Chaque heure tombe sur un client, pas dans la mémoire de quelqu'un.",
            "step": "L'équipe y impute son temps"
          },
          {
            "body": "Des totaux en direct par projet et un export propre pour la paie ou la facturation en fin de mois.",
            "step": "Voyez les heures par client, exportez pour la paie"
          }
        ],
        "compliance": {
          "body": "Done-it conserve un relevé numérique et infalsifiable du temps de travail par collaborateur — la base d'une paie correcte comme d'une facture client défendable.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement du temps par client",
          "title": "Un relevé objectif des heures prestées"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salons & soins du corps",
        "slug": "beauty",
        "intro": "Coiffeurs, barbiers, onglerie et instituts de beauté tournent avec des shifts et des contrats à temps partiel. Done-it enregistre qui a presté quand, déduit les pauses automatiquement et remet à la paie un fichier propre.",
        "pains": [
          {
            "body": "Trois jours une semaine, quatre la suivante, un samedi échangé contre un mardi. Heures contractuelles et heures prestées s'écartent vite.",
            "title": "Temps partiels, variations sans fin"
          },
          {
            "body": "Les rendez-vous disent ce qui a été réservé, pas qui a presté. Quand la paie ou un contrôle pose la question, le logiciel de réservation est la mauvaise réponse.",
            "title": "L'agenda n'est pas un relevé du temps de travail"
          },
          {
            "body": "Rester plus tard pour une dernière cliente : on s'en souvient, on le promet, et parfois on l'oublie. C'est le genre d'écart qui finit en litige.",
            "title": "Des heures en plus réglées à l'amiable"
          }
        ],
        "quote": {
          "who": "Gérante, salon de coiffure · 6 collaborateurs",
          "text": "Tout le monde est à temps partiel et chaque semaine est différente. L'app enregistre, tout simplement — j'ai arrêté de reconstruire le mois dans un tableur.",
          "result": "Plus d'heures contestées en fin de mois"
        },
        "stats": [
          {
            "label": "pour pointer — rien de partagé, rien sur papier",
            "value": "1 tap"
          },
          {
            "label": "déduction des pauses à chaque shift",
            "value": "Auto"
          },
          {
            "label": "heure tardive réglée de mémoire",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un tap sur son propre téléphone au début du shift — pas de terminal partagé à l'accueil, pas de liste de signatures près du miroir.",
            "title": "Pointer au salon"
          },
          {
            "body": "Définissez la règle de pause et les heures standard une fois ; elles s'appliquent à chaque shift, avec des exceptions par personne là où un contrat diffère.",
            "title": "Pauses et règles de temps partiel, une seule fois"
          },
          {
            "body": "Les heures en plus sont enregistrées au moment où elles sont prestées, et chaque collaborateur choisit le paiement ou la récupération — réglé dans l'app, pas de mémoire.",
            "title": "Heures supplémentaires : payées ou récupérées"
          }
        ],
        "headline": "Pointage pour les salons — shifts, temps partiels et paie sans agenda papier",
        "workflow": [
          {
            "body": "Un tap à l'arrivée. Les pauses sont déduites selon la règle que vous définissez une fois.",
            "step": "L'équipe pointe pour son shift"
          },
          {
            "body": "Qui est présent, qui est en pause, qui est resté plus tard — en direct, sans devoir demander.",
            "step": "Vous suivez la journée en direct"
          },
          {
            "body": "Heures prestées, pauses et heures supplémentaires par collaborateur, exportées pour votre secrétariat social.",
            "step": "La paie reçoit un fichier propre"
          }
        ],
        "compliance": {
          "body": "Done-it enregistre le temps de travail réel par collaborateur, pauses et heures supplémentaires comprises — distinct des réservations, et défendable le jour du contrôle.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement numérique du temps",
          "title": "Un relevé qui tient au-delà du carnet de rendez-vous"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Santé & bien-être",
        "slug": "wellness",
        "intro": "Salles de sport, studios de fitness, cabinets de kiné et spas ouvrent longtemps avec des équipes qui tournent. Done-it enregistre qui a couvert quel shift, déduit les pauses automatiquement et exporte la paie proprement.",
        "pains": [
          {
            "body": "Shifts du matin, cours du soir et week-ends, couverts par un mélange de temps plein, de temps partiels et d'indépendants. Le planning est une intention, pas un relevé.",
            "title": "Longues heures d'ouverture, remplacements permanents"
          },
          {
            "body": "Un coach donne deux cours et tient l'accueil entre les deux. Le payer correctement suppose de savoir ce qui a été presté, pas ce qui était planifié.",
            "title": "Heures de cours et heures de salle se confondent"
          },
          {
            "body": "Les collaborateurs passent d'un studio à l'autre. Fusionner leurs heures à la main chaque mois est lent et source d'erreurs.",
            "title": "Plusieurs sites, une seule administration"
          }
        ],
        "quote": {
          "who": "Manager, studio de fitness · 14 collaborateurs",
          "text": "Deux studios, de longues heures d'ouverture et beaucoup de remplacements. Aujourd'hui les heures tombent sur le bon site et la paie tient dans un fichier.",
          "result": "Le planning et la paie concordent enfin"
        },
        "stats": [
          {
            "label": "les heures, même en renfort ailleurs",
            "value": "Par studio"
          },
          {
            "label": "la salle en vue, sur tous les sites",
            "value": "Live"
          },
          {
            "label": "pauses et heures sup, sans calcul manuel",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Un tap sur le téléphone, sur le site où l'on preste. Un remplacement dans un autre studio tombe sur les heures de ce studio.",
            "title": "Pointer par studio"
          },
          {
            "body": "Voyez la salle sur tous les sites en temps réel — un shift du matin non couvert se voit avant l'ouverture, pas après.",
            "title": "Vue en direct des présences"
          },
          {
            "body": "Règles de pause appliquées automatiquement, heures en plus enregistrées dès qu'elles tombent, avec paiement ou récupération au choix de chaque collaborateur.",
            "title": "Pauses et heures supplémentaires gérées"
          }
        ],
        "headline": "Pointage pour salles de sport, studios et spas — shifts, cours et paie dans une seule app",
        "workflow": [
          {
            "body": "Un tap au début du shift, sur le site où elle preste.",
            "step": "L'équipe pointe au studio"
          },
          {
            "body": "Qui est présent, sur quel site, à cet instant — les trous se comblent avant que les membres le remarquent.",
            "step": "Les remplacements se voient en direct"
          },
          {
            "body": "Heures, pauses et heures supplémentaires par collaborateur et par studio, prêtes pour le secrétariat social.",
            "step": "Un seul export pour la paie"
          }
        ],
        "compliance": {
          "body": "Done-it conserve un relevé numérique du temps de travail par collaborateur et par site — la base d'une rémunération correcte et de tout contrôle des heures prestées.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement des shifts multi-sites",
          "title": "Un relevé objectif pour chaque shift et chaque site"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Horeca",
        "slug": "hospitality",
        "intro": "Shifts coupés, fermetures tardives et un samedi chargé qui déborde. Done-it enregistre les heures telles qu'elles sont réellement prestées, déduit les pauses selon votre règle et remet à la paie un seul fichier propre.",
        "pains": [
          {
            "body": "Le service traîne, la fermeture prend encore une demi-heure. Ces minutes sont du vrai travail, et les régler de mémoire est le point de départ des litiges.",
            "title": "Le shift ne finit jamais à l'heure du planning"
          },
          {
            "body": "Service du midi, une coupure, puis le soir. Sur papier, ça devient un seul long bloc ou deux estimations — ni l'un ni l'autre n'est la réalité.",
            "title": "Les shifts coupés sont difficiles à enregistrer"
          },
          {
            "body": "De nouveaux collaborateurs à chaque saison. Un système qui demande une formation ne survivra pas à la première semaine chargée.",
            "title": "Fort turnover, onboarding permanent"
          }
        ],
        "quote": {
          "who": "Patron, restaurant · 17 collaborateurs",
          "text": "La fermeture déborde toujours. Aujourd'hui ces minutes sont enregistrées au lieu d'être discutées, et l'équipe peut les récupérer en congé.",
          "result": "Moins de litiges, une paie plus rapide"
        },
        "stats": [
          {
            "label": "enregistrés en deux blocs, pas en une estimation",
            "value": "Shifts coupés"
          },
          {
            "label": "déduction des pauses selon votre règle",
            "value": "Auto"
          },
          {
            "label": "pour lancer un nouveau — c'est son propre téléphone",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Un tap au début et à la fin de chaque bloc : les shifts coupés sont enregistrés tels qu'ils se sont déroulés, pas fusionnés en un seul.",
            "title": "Pointer à l'entrée et à la sortie de chaque service"
          },
          {
            "body": "Pauses obligatoires déduites automatiquement, avec des exceptions par personne là où un contrat l'exige. Aucun calcul manuel en fin de mois.",
            "title": "Les pauses selon votre règle"
          },
          {
            "body": "La demi-heure après la fermeture est enregistrée au moment où elle est prestée, puis payée ou récupérée en congé — le collaborateur choisit.",
            "title": "Heures supplémentaires réglées dans l'app"
          }
        ],
        "headline": "Pointage pour cafés, restaurants et hôtels — shifts, pauses et heures supplémentaires réglés équitablement",
        "workflow": [
          {
            "body": "Un tap au début du bloc, un autre à la fin. Les shifts coupés restent coupés.",
            "step": "L'équipe pointe pour le service"
          },
          {
            "body": "Qui est là pour le service du soir, qui est encore en pause, qui est resté après la fermeture.",
            "step": "Vous voyez la salle en direct"
          },
          {
            "body": "Temps presté, pauses et heures supplémentaires par collaborateur, exportés en un seul fichier.",
            "step": "La paie reçoit les heures réelles"
          }
        ],
        "compliance": {
          "body": "Done-it conserve un relevé numérique objectif de chaque shift, pause et heure en plus — exactement ce qu'un contrôle de la paie ou une inspection sociale demande à voir.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement des shifts coupés",
          "title": "Un relevé défendable dans une équipe à fort turnover"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Santé & soins",
        "slug": "healthcare",
        "intro": "Cabinets, équipes de soins à domicile et maisons de repos fonctionnent au rythme des shifts, des visites et d'une tenue de dossier stricte. Done-it enregistre le temps presté par shift et par visite, et garde les documents des collaborateurs là où vous les retrouvez.",
        "pains": [
          {
            "body": "Les visites à domicile vivent dans un outil, les heures planifiées dans un autre, et la paie reçoit une troisième version. Les rapprocher est un travail mensuel.",
            "title": "Visites et shifts dans des systèmes séparés"
          },
          {
            "body": "Les heures inconfortables ont d'autres barèmes. Quand le relevé est approximatif, la rémunération l'est aussi — et la correction arrive plus tard.",
            "title": "Heures de nuit et de week-end mal valorisées"
          },
          {
            "body": "Les qualifications et les certificats comptent dans les soins, et ils dorment dans un classeur que personne n'ouvre jusqu'au jour du contrôle.",
            "title": "Les certificats expirent en silence"
          }
        ],
        "quote": {
          "who": "Coordinatrice, équipe de soins à domicile · 22 collaborateurs",
          "text": "Les visites à domicile et les shifts planifiés sont enfin dans le même relevé. La paie a cessé d'être un exercice de rapprochement.",
          "result": "Un seul relevé au lieu de trois"
        },
        "stats": [
          {
            "label": "ou par shift — selon le rythme de votre équipe",
            "value": "Par visite"
          },
          {
            "label": "heures de nuit et de week-end, telles que prestées",
            "value": "Ventilées"
          },
          {
            "label": "certificats conservés par collaborateur",
            "value": "Classés"
          }
        ],
        "features": [
          {
            "body": "Un tap au début du shift, ou à chaque adresse de patient pour les soins à domicile — avec vérification du lieu là où la preuve est nécessaire.",
            "title": "Pointer par shift ou par visite"
          },
          {
            "body": "Heures de nuit, de week-end et normales enregistrées distinctement : l'export de paie reflète déjà la manière dont le travail est réellement rémunéré.",
            "title": "Des heures ventilées comme vous les payez"
          },
          {
            "body": "Contrats, certificats et pièces d'identité rangés à côté de la personne concernée — retrouvés en quelques secondes quand on les demande.",
            "title": "Les documents des collaborateurs au même endroit"
          }
        ],
        "headline": "Pointage pour les équipes de soins — shifts, visites à domicile et qualifications, dans un seul relevé",
        "workflow": [
          {
            "body": "Un tap sur le site ou à l'adresse du patient, avec vérification du lieu là où une preuve est nécessaire.",
            "step": "Pointer pour le shift ou la visite"
          },
          {
            "body": "Heures normales, de nuit et de week-end enregistrées distinctement, au fil de la prestation.",
            "step": "Les heures tombent dans la bonne catégorie"
          },
          {
            "body": "Un fichier propre par période, déjà ventilé comme vous le payez.",
            "step": "Export pour la paie"
          }
        ],
        "compliance": {
          "body": "Done-it conserve un relevé numérique et objectif du temps de travail par collaborateur — heures, pauses et ventilation des heures inconfortables — à côté des documents propres à chaque personne.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Enregistrement des shifts & visites",
          "title": "Des relevés qui tiennent face à une inspection"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "en-be": [
      {
        "name": "Shops & retail",
        "slug": "retail",
        "intro": "Opening shifts, late shifts and someone always covering for someone else. Done-it gives every shop a clean digital record of who worked which shift — clocked in on their own phone, ready for payroll at month-end.",
        "pains": [
          {
            "body": "Someone covers a sick colleague, someone stays an hour late at closing. It gets remembered on a note, or not at all — and payroll is wrong before you start.",
            "title": "Shift swaps never make it to payroll"
          },
          {
            "body": "Staff move between branches, part-timers work across two locations. Collecting hours per shop and merging them by hand costs a day every month.",
            "title": "Several shops, one payroll run"
          },
          {
            "body": "Statutory breaks get deducted from memory and extra hours are settled informally — the two things an inspection asks about first.",
            "title": "Breaks and overtime are guesswork"
          }
        ],
        "quote": {
          "who": "Owner, retail · 11 employees",
          "text": "Two shops and a lot of part-timers. Before, half the cover shifts were settled from memory. Now every hour is on the right shop and payroll takes minutes.",
          "result": "Payroll prep from a day to under an hour"
        },
        "stats": [
          {
            "label": "to clock in — no terminal at the till",
            "value": "1 tap"
          },
          {
            "label": "view of who is in, across every shop",
            "value": "Live"
          },
          {
            "label": "shift swaps lost between the floor and payroll",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "One tap on their own phone at the start of the shift. No terminal at the till, no shared card, no clipboard by the stockroom door.",
            "title": "Clock in on the shop floor"
          },
          {
            "body": "Each shop is a project. Someone covering another branch is clocked against that branch — you see the hours where they were actually worked.",
            "title": "Hours per shop, staff across branches"
          },
          {
            "body": "Set the break rule once and it applies to every shift. Overtime is logged the moment it happens, and each employee picks payout or time off.",
            "title": "Breaks deducted automatically"
          }
        ],
        "headline": "Time tracking for shops — shift clock-in, cover and a payroll-ready export, in one app",
        "workflow": [
          {
            "body": "One tap on their phone as the shift starts. Cover for another branch is clocked against that branch.",
            "step": "Staff clock in for their shift"
          },
          {
            "body": "A live view across every location — spot an unfilled opening shift before the doors open.",
            "step": "You see who is in, per shop"
          },
          {
            "body": "Hours, breaks and overtime per employee and per shop, exported ready for your payroll provider.",
            "step": "Payroll in one export"
          }
        ],
        "compliance": {
          "body": "Done-it keeps an objective digital record of every clock-in and clock-out, with breaks and overtime — the record an audit or a payroll dispute asks for.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shift-based time registration",
          "title": "A defensible record of every shift worked"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Offices & professional services",
        "slug": "offices",
        "intro": "Accountants, notaries, architects, agencies and consultancies bill their time — or at least need to know where it went. Done-it records hours against the right client and project, from the desk or on the road.",
        "pains": [
          {
            "body": "Time written down at the end of the week is time guessed. Whole hours quietly disappear between the work and the invoice.",
            "title": "Billable hours reconstructed on Friday"
          },
          {
            "body": "The fee was agreed months ago. Whether the work still fits inside it only becomes clear when someone adds it up — usually too late.",
            "title": "No idea what a client actually costs"
          },
          {
            "body": "Part of the team is at the office, part at home, part at the client. Attendance stops being a fact and becomes a reconstruction.",
            "title": "Hybrid work makes the record patchy"
          }
        ],
        "quote": {
          "who": "Partner, accountancy practice · 8 employees",
          "text": "We used to rebuild the week every Friday. Now the hours are already on the right client and I can see which files are eating the fee.",
          "result": "Billable hours recovered every month"
        },
        "stats": [
          {
            "label": "hours, visible while the work is still running",
            "value": "Per client"
          },
          {
            "label": "same record, phone and browser",
            "value": "Desk or road"
          },
          {
            "label": "for payroll and invoicing",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Every entry lands on a project, so you can see the hours per client without exporting anything or asking anyone.",
            "title": "Hours against client and project"
          },
          {
            "body": "The same app on the phone or the browser. Visiting a client counts as work on that client, including the travel if you want it to.",
            "title": "Works at the desk and off-site"
          },
          {
            "body": "Extra hours logged as they happen, leave requested and approved in the app — no parallel spreadsheet of who is off when.",
            "title": "Overtime and leave in one place"
          }
        ],
        "headline": "Time tracking for offices — hours per client and project, without the spreadsheet",
        "workflow": [
          {
            "body": "Set it up once with the client and, if you bill by budget, the hours you planned.",
            "step": "Open a client project"
          },
          {
            "body": "From the desk or the phone. Every hour lands on a client, not in someone's memory.",
            "step": "The team logs time to it"
          },
          {
            "body": "Live totals per project, and a clean export for payroll or invoicing at month-end.",
            "step": "See hours per client, export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital, tamper-evident record of working time per employee — the basis for both payroll and a defensible client invoice.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Per-client time registration",
          "title": "An objective record of hours worked"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salons & body care",
        "slug": "beauty",
        "intro": "Hairdressers, barbers, nail and beauty studios run on shifts and part-time contracts. Done-it records who worked when, deducts breaks automatically and hands payroll a clean file.",
        "pains": [
          {
            "body": "Three days one week, four the next, a Saturday swapped for a Tuesday. Contracted hours and worked hours drift apart fast.",
            "title": "Part-time contracts, endless variations"
          },
          {
            "body": "Appointments say what was booked, not who worked. When payroll or an inspection asks, the booking system is the wrong answer.",
            "title": "The diary is not a time record"
          },
          {
            "body": "Staying late for a last client is remembered, promised, and sometimes forgotten. That is the kind of gap that turns into a dispute.",
            "title": "Extra hours settled informally"
          }
        ],
        "quote": {
          "who": "Owner, hair salon · 6 employees",
          "text": "Everyone is part-time and every week is different. The app just records it — I stopped rebuilding the month in a spreadsheet.",
          "result": "No more disputed hours at month-end"
        },
        "stats": [
          {
            "label": "to clock in — nothing shared, nothing on paper",
            "value": "1 tap"
          },
          {
            "label": "break deduction on every shift",
            "value": "Auto"
          },
          {
            "label": "late hours settled from memory",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "One tap on their own phone at the start of the shift — no shared terminal at the desk, no signature list by the mirror.",
            "title": "Clock in at the salon"
          },
          {
            "body": "Set the break rule and the standard hours once; they apply to every shift, with per-person exceptions where a contract differs.",
            "title": "Breaks and part-time rules once"
          },
          {
            "body": "Extra hours are logged as they are worked, and each employee chooses payout or time off in lieu — settled in the app, not by memory.",
            "title": "Overtime, paid or taken back"
          }
        ],
        "headline": "Time tracking for salons — shifts, part-time hours and payroll without the paper diary",
        "workflow": [
          {
            "body": "One tap on arrival. Breaks are deducted by the rule you set once.",
            "step": "Staff clock in for the shift"
          },
          {
            "body": "Who is in, who is on a break, who stayed late — live, without asking.",
            "step": "You see the day as it runs"
          },
          {
            "body": "Worked hours, breaks and overtime per employee, exported for your payroll provider.",
            "step": "Payroll gets a clean file"
          }
        ],
        "compliance": {
          "body": "Done-it records actual working time per employee, with breaks and overtime — separate from bookings, and defensible when it is checked.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital time registration",
          "title": "A record that holds up beyond the appointment book"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Health & wellness",
        "slug": "wellness",
        "intro": "Gyms, fitness studios, physio practices and spas run long opening hours with rotating staff. Done-it records who covered which shift, deducts breaks automatically and exports payroll cleanly.",
        "pains": [
          {
            "body": "Early shifts, evening classes and weekends, filled by a mix of full-time, part-time and freelance staff. The roster is a plan, not a record.",
            "title": "Long opening hours, rotating cover"
          },
          {
            "body": "An instructor teaches two classes and covers reception in between. Paying that correctly means knowing what was actually worked, not what was scheduled.",
            "title": "Class hours and floor hours blur"
          },
          {
            "body": "Staff move between studios. Merging their hours by hand each month is slow and error-prone.",
            "title": "Several locations, one administration"
          }
        ],
        "quote": {
          "who": "Manager, fitness studio · 14 employees",
          "text": "Two studios, long opening hours and a lot of cover shifts. Now the hours land on the right site and payroll is one file.",
          "result": "Roster and payroll finally agree"
        },
        "stats": [
          {
            "label": "hours, even when staff cover elsewhere",
            "value": "Per studio"
          },
          {
            "label": "view of the floor across locations",
            "value": "Live"
          },
          {
            "label": "breaks and overtime, no manual maths",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "One tap on their phone at the site they are working. Cover at another studio lands on that studio's hours.",
            "title": "Clock in per studio"
          },
          {
            "body": "See the floor across every location in real time — an unfilled early shift is visible before the doors open, not after.",
            "title": "Live view of who is in"
          },
          {
            "body": "Break rules applied automatically, extra hours logged as they happen with payout or time off in lieu per employee.",
            "title": "Breaks and overtime handled"
          }
        ],
        "headline": "Time tracking for gyms, studios and spas — shifts, classes and payroll in one app",
        "workflow": [
          {
            "body": "One tap at the start of the shift, on the site where they are working.",
            "step": "Staff clock in at the studio"
          },
          {
            "body": "Who is in at which location right now, so gaps are filled before members notice.",
            "step": "Cover is visible live"
          },
          {
            "body": "Hours, breaks and overtime per employee and per studio, ready for the payroll provider.",
            "step": "One export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital record of working time per employee and per location — the basis for correct pay and for any check on hours worked.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Multi-site shift registration",
          "title": "An objective record for every shift and site"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Hospitality",
        "slug": "hospitality",
        "intro": "Split shifts, late closes and a busy Saturday that runs over. Done-it records the hours as they are actually worked, deducts breaks by your rule and gives payroll one clean file.",
        "pains": [
          {
            "body": "Service runs late, closing takes another half hour. Those minutes are real work, and settling them from memory is how disputes start.",
            "title": "The shift never ends when the roster says"
          },
          {
            "body": "Lunch service, a break, then dinner. On paper it becomes one long block or two guesses — neither is the truth.",
            "title": "Split shifts are hard to record"
          },
          {
            "body": "New staff every season. Any system that needs training will not survive the first busy week.",
            "title": "High turnover, constant onboarding"
          }
        ],
        "quote": {
          "who": "Owner, restaurant · 17 employees",
          "text": "Closing always runs over. Now those minutes are logged instead of argued about, and staff can take them back as time off.",
          "result": "Fewer disputes, faster payroll"
        },
        "stats": [
          {
            "label": "recorded as two blocks, not one guess",
            "value": "Split shifts"
          },
          {
            "label": "break deduction per your rule",
            "value": "Auto"
          },
          {
            "label": "to onboard a new starter — it is their own phone",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "One tap at the start and end of each block, so split shifts are recorded as they happened — not merged into one.",
            "title": "Clock in and out per service"
          },
          {
            "body": "Mandatory breaks deducted automatically, with exceptions per person where a contract needs it. No manual maths at month-end.",
            "title": "Breaks by your rule"
          },
          {
            "body": "The extra half hour after closing is logged the moment it is worked, and paid out or taken back as time off — the employee chooses.",
            "title": "Overtime settled in the app"
          }
        ],
        "headline": "Time tracking for cafés, restaurants and hotels — shifts, breaks and overtime, settled fairly",
        "workflow": [
          {
            "body": "One tap at the start of the block; the same at the end. Split shifts stay split.",
            "step": "Staff clock in for service"
          },
          {
            "body": "Who is in for tonight's service, who is still on a break, who stayed past closing.",
            "step": "You see the floor live"
          },
          {
            "body": "Worked time, breaks and overtime per employee, exported in one file.",
            "step": "Payroll gets the real hours"
          }
        ],
        "compliance": {
          "body": "Done-it keeps an objective digital record of every shift, break and extra hour — which is exactly what a payroll check or a labour inspection asks to see.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Split-shift time registration",
          "title": "A defensible record of hours in a high-turnover team"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Healthcare & care",
        "slug": "healthcare",
        "intro": "Practices, home-care teams and care homes run around shifts, visits and strict record-keeping. Done-it registers worked time per shift and per visit, and keeps employee documents where you can find them.",
        "pains": [
          {
            "body": "Home visits live in one tool, rostered hours in another, and payroll gets a third version. Reconciling them is a monthly job.",
            "title": "Visits and shifts in separate systems"
          },
          {
            "body": "Unsocial hours carry different rates. When the record is approximate, so is the pay — and the correction comes later.",
            "title": "Night and weekend hours priced wrong"
          },
          {
            "body": "Qualifications and certificates matter in care, and they sit in a folder nobody opens until an inspection asks.",
            "title": "Certificates expire quietly"
          }
        ],
        "quote": {
          "who": "Coordinator, home-care team · 22 employees",
          "text": "Home visits and rostered shifts finally sit in the same record. Payroll stopped being a reconciliation exercise.",
          "result": "One record instead of three"
        },
        "stats": [
          {
            "label": "or per shift — whichever your team runs on",
            "value": "Per visit"
          },
          {
            "label": "night and weekend hours, recorded as worked",
            "value": "Split"
          },
          {
            "label": "certificates stored per employee",
            "value": "Filed"
          }
        ],
        "features": [
          {
            "body": "One tap at the start of the shift, or at each client address for home care — location-verified where you need the proof.",
            "title": "Clock in per shift or per visit"
          },
          {
            "body": "Night, weekend and regular hours are recorded distinctly, so the payroll export already reflects how the work is actually paid.",
            "title": "Hours split the way you pay them"
          },
          {
            "body": "Contracts, certificates and IDs stored next to the person they belong to — found in seconds when someone asks for them.",
            "title": "Employee documents in one place"
          }
        ],
        "headline": "Time tracking for care teams — shifts, home visits and qualifications, in one record",
        "workflow": [
          {
            "body": "One tap at the site or the client's address, location-verified where proof is needed.",
            "step": "Clock in for the shift or visit"
          },
          {
            "body": "Regular, night and weekend hours recorded distinctly as they happen.",
            "step": "Hours land in the right bucket"
          },
          {
            "body": "One clean file per period, already split the way you pay it.",
            "step": "Export for payroll"
          }
        ],
        "compliance": {
          "body": "Done-it keeps a digital, objective record of working time per employee — hours, breaks and unsocial-hour splits — alongside the documents that go with each person.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Shift & visit registration",
          "title": "Records that survive an inspection"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "es": [
      {
        "name": "Construcción",
        "slug": "construction",
        "intro": "Cuadrillas repartidas entre obras, horas anotadas en papel, horas de subcontratistas imposibles de cuadrar. Done-it le da a cada obra un parte horario digital a prueba de fallos que alimenta tu nómina con un solo clic.",
        "pains": [
          {
            "body": "Con varias obras activas y cuadrillas rotativas, los partes horarios manuales fallan por diseño. Los trabajadores redondean al alza, olvidan registros o los rellenan días después, dejándote cifras de nómina que no puedes defender.",
            "title": "Sin un registro fiable de quién trabajó dónde"
          },
          {
            "body": "Cuando te das cuenta de que una obra ha consumido sus horas previstas, el margen ya se ha esfumado. No hay una cuenta atrás en tiempo real, solo una sorpresa desagradable a la hora de facturar.",
            "title": "Los sobrecostes salen a la luz demasiado tarde"
          },
          {
            "body": "Recopilar partes horarios, cuadrarlos con los proyectos y preparar la exportación de la nómina lleva días. Cada registro es un posible error.",
            "title": "Preparar la nómina se lleva horas cada mes"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de construcción · 14 empleados",
          "text": "Nuestra cuadrilla ficha por sí sola en la obra. A fin de mes, la nómina simplemente cuadra: dejamos de perseguir partes horarios por completo.",
          "result": "5 horas a la semana ahorradas en administración"
        },
        "stats": [
          {
            "label": "para fichar en cualquier obra: sin terminal, sin papel",
            "value": "1 toque"
          },
          {
            "label": "exportación de nómina lista para tu gestoría",
            "value": "1 clic"
          },
          {
            "label": "vista de horas restantes por proyecto y obra",
            "value": "En directo"
          }
        ],
        "features": [
          {
            "body": "Con un toque el trabajador ficha, verificado por ubicación, y vincula las horas al proyecto correcto. Sin lectores de tarjetas ni terminales: solo el smartphone que tu cuadrilla ya lleva encima.",
            "title": "Fichaje verificado por ubicación por obra"
          },
          {
            "body": "Define las horas previstas como presupuesto al abrir el proyecto. Los trabajadores ven una cuenta atrás de lo que queda; tú la ves en directo en tu panel. Los sobrecostes se ven antes de que ocurran.",
            "title": "Horas restantes en tiempo real por proyecto"
          },
          {
            "body": "Añade subcontratistas a un proyecto, asígnalos al fichaje y controla sus horas junto a las de tu propia cuadrilla, en la misma vista.",
            "title": "Gestión y presencia de subcontratistas"
          },
          {
            "body": "Todas las horas registradas —por trabajador, por proyecto— se exportan a una hoja de cálculo limpia para tu gestoría de nóminas. Sin preparación manual, sin errores.",
            "title": "Exportación de nómina con un clic"
          }
        ],
        "headline": "Control horario para equipos de construcción: fichaje verificado por ubicación, horas por proyecto y control de presupuesto, en una sola app",
        "workflow": [
          {
            "body": "Cada trabajador toca una vez para fichar. El GPS confirma la ubicación, marca la hora del registro y vincula las horas al proyecto. Sin papel, sin terminal.",
            "step": "La cuadrilla llega a la obra"
          },
          {
            "body": "Horas, presupuesto restante, presencia de subcontratistas y cualquier trabajo extra reportado desde la obra: todo en tu panel, en tiempo real.",
            "step": "Lo ves todo en directo"
          },
          {
            "body": "Exporta todas las horas por trabajador y por proyecto. Envíalas a tu gestoría de nóminas. Done-it genera informes limpios y listos para auditoría de forma automática.",
            "step": "Cierre de mes en minutos"
          }
        ],
        "compliance": {
          "body": "Done-it ofrece fichaje verificado por ubicación, control horario por proyecto y una exportación de nómina limpia para equipos de construcción. Para equipos que operan en obras belgas, también alimenta automáticamente el checkin@work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario digital",
          "title": "Fichaje verificado por ubicación pensado para obras de construcción"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Limpieza",
        "slug": "cleaning",
        "intro": "Los limpiadores se mueven entre ubicaciones todo el día. Done-it controla quién está dónde en tiempo real: fichaje verificado por ubicación en cada centro, deducción automática de pausas y una exportación de nómina limpia a fin de mes.",
        "pains": [
          {
            "body": "Clientes e inspectores esperan registros de presencia a prueba de fallos. Las hojas manuales se pueden impugnar; los fichajes digitales verificados por ubicación no.",
            "title": "Demostrar la presencia en cada ubicación"
          },
          {
            "body": "Con limpiadores que se mueven entre centros a lo largo del día, no tienes una vista en directo de quién trabaja dónde, hasta que alguien llama.",
            "title": "Equipos repartidos entre muchas ubicaciones"
          },
          {
            "body": "Sin horas de entrada y salida precisas, la nómina se reconstruye de memoria. Las horas se redondean al alza, los costes se inflan y llegan las disputas.",
            "title": "Errores de nómina por horas redondeadas"
          }
        ],
        "quote": {
          "who": "Responsable, empresa de limpieza · 9 empleados",
          "text": "Por fin podemos demostrar quién limpió dónde y cuándo. Se acabaron las hojas de presencia y las disputas con clientes: el GPS se encarga.",
          "result": "Cero redondeo al alza de horas"
        },
        "stats": [
          {
            "label": "para fichar en cualquier ubicación: sin terminal",
            "value": "1 toque"
          },
          {
            "label": "vista de quién está en qué centro ahora mismo",
            "value": "En directo"
          },
          {
            "label": "registros duplicados: las horas pasan directas a la nómina",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Los trabajadores fichan entrada y salida en su móvil en cada ubicación, verificado por ubicación; el tiempo es exacto, con registro de pausas.",
            "plan": "Time Basic",
            "title": "Fichaje de entrada y salida en tiempo real"
          },
          {
            "body": "Las pausas obligatorias se restan de la jornada laboral automáticamente: sin cálculos manuales, sin disputas.",
            "plan": "Time Basic",
            "title": "Deducción automática de pausas"
          },
          {
            "body": "Ve qué limpiadores están en qué ubicaciones ahora mismo. Detecta huecos antes que los clientes.",
            "title": "Vista en directo multiubicación"
          },
          {
            "body": "Los trabajadores suben certificados médicos y documentos de ausencia directamente desde la app. Crea los tipos de ausencia que tu equipo realmente usa.",
            "title": "Registro de ausencias con justificantes médicos digitales"
          },
          {
            "body": "Las marcas de tiempo exactas pasan directamente a una exportación lista para la nómina de tu gestoría. Sin transcripción, sin errores.",
            "title": "Exportación de nómina con un clic"
          }
        ],
        "headline": "Control horario para empresas de limpieza: fichaje verificado por ubicación, prueba de presencia y nómina en una sola app",
        "workflow": [
          {
            "body": "Un toque lo ficha. El GPS registra el centro y marca la hora del registro. El registro de pausas viene integrado en la app.",
            "step": "El limpiador llega a la ubicación"
          },
          {
            "body": "Quién está en qué centro ahora mismo: sin llamadas, sin conjeturas. Detecta huecos de cobertura antes que los clientes.",
            "step": "Ves cada ubicación en directo"
          },
          {
            "body": "Todos los datos de presencia —horas exactas, ubicaciones y pausas— se exportan limpios para tu gestoría de nóminas.",
            "step": "La nómina es un solo clic"
          }
        ],
        "compliance": {
          "body": "Done-it da a los equipos de limpieza fichaje verificado por ubicación en cada centro, deducción automática de pausas y una vista en directo de quién está en qué ubicación ahora mismo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Presencia verificada por ubicación",
          "title": "Presencia en tiempo real en cada ubicación de limpieza"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Instalación",
        "slug": "installation",
        "intro": "Envía a tus instaladores a la dirección correcta con todo lo que necesitan, vincula cada hora trabajada al trabajo correcto automáticamente y ve el presupuesto restante antes de que cierre la obra. Done-it es la forma más sencilla de mantener los proyectos de instalación a tiempo y en coste.",
        "pains": [
          {
            "body": "Las cuadrillas llegan a una obra sin la dirección, la persona de contacto o los detalles del alcance. Esa primera llamada son diez minutos de tiempo facturable perdidos antes de trabajar una sola hora.",
            "title": "La información del trabajo no llega al campo a tiempo"
          },
          {
            "body": "Cuando los trabajadores rellenan sus horas manualmente al final del día —si es que las rellenan—, las horas caen en el trabajo equivocado o desaparecen del todo. Las facturas no coinciden con la realidad.",
            "title": "Las horas no se vinculan al proyecto correcto"
          },
          {
            "body": "Sin una cuenta atrás en tiempo real de las horas restantes por proyecto, descubres que un trabajo se ha pasado al cerrar la factura, no cuando aún puedes reaccionar.",
            "title": "Sobrecostes detectados demasiado tarde"
          },
          {
            "body": "Los subcontratistas que trabajan en la misma obra usan sistemas diferentes, rellenan las horas por separado o no las rellenan. Cuadrarlas a fin de mes es un proceso lento y propenso a errores.",
            "title": "Difícil controlar las horas de subcontratistas"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de instalación · 6 empleados",
          "text": "Las horas caen en el proyecto correcto automáticamente. Calcular el coste de cada trabajo es de repente fácil: vemos el margen real antes de cerrar un trabajo.",
          "result": "Coste real por trabajo, en directo"
        },
        "stats": [
          {
            "label": "vista de horas restantes por proyecto",
            "value": "Tiempo real"
          },
          {
            "label": "llamadas a la oficina para pedir direcciones de obra",
            "value": "0"
          },
          {
            "label": "navega a cualquier dirección de proyecto desde la app",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "Los trabajadores abren el proyecto en su móvil: dirección, horas previstas, persona de contacto y archivos subidos (planos, instrucciones, PDF). Todo lo que necesitan está ahí antes de llegar.",
            "plan": "Project Basic",
            "title": "Información del proyecto compartida directamente en la app"
          },
          {
            "body": "Toca una vez y el móvil navega hasta la dirección del proyecto: integrado en la app, sin necesidad de una app de mapas aparte.",
            "title": "Navegación a la obra con un botón"
          },
          {
            "body": "Define las horas previstas al abrir el proyecto. Los trabajadores ven cuántas horas quedan; tú ves el estado en directo en tu panel. Los sobrecostes se ven antes de que ocurran.",
            "plan": "Project Basic",
            "title": "Cuenta atrás de horas restantes por proyecto"
          },
          {
            "body": "Cada trabajador ficha en el proyecto correcto. Siempre sabes quién está en qué obra ahora mismo.",
            "plan": "Project Basic",
            "title": "Fichaje del trabajador por proyecto"
          },
          {
            "body": "Cuando el alcance crece en la obra, los trabajadores registran trabajo extra y materiales en tiempo real —con texto y fotos— para que nada se facture de memoria.",
            "plan": "Project Basic",
            "title": "Registro de trabajo extra y materiales"
          }
        ],
        "headline": "Control horario para equipos de instalación: horas por proyecto, navegación y control de presupuesto en una sola app",
        "workflow": [
          {
            "body": "Dirección, contacto, alcance y archivos subidos están ahí mismo. Navega con un toque, sin llamadas a la oficina para pedir indicaciones.",
            "step": "El trabajador abre el proyecto en su móvil"
          },
          {
            "body": "El fichaje vincula cada minuto trabajado al proyecto correcto. El presupuesto restante se actualiza en tiempo real.",
            "step": "Las horas se registran automáticamente en el trabajo correcto"
          },
          {
            "body": "Los cambios de alcance, materiales extra y retrasos se registran con texto y fotos en el momento en que ocurren, listos para la factura.",
            "step": "El trabajo extra se captura en la obra"
          }
        ],
        "compliance": {
          "body": "Done-it da a los equipos de instalación fichaje verificado por ubicación por proyecto, una cuenta atrás de horas restantes en tiempo real y exportación de nómina automática, cubriendo cualquier requisito local de registro horario. Para equipos que trabajan en obras de construcción belgas, también se integra con CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario digital",
          "title": "Fichaje verificado por ubicación por proyecto para equipos de instalación"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Servicio de campo",
        "slug": "field-service",
        "intro": "Técnicos que visitan a varios clientes al día, tickets en la guantera, kilometraje anotado de memoria. Done-it captura horas, kilómetros y gastos en el campo, vinculados al trabajo correcto en el momento en que ocurren.",
        "pains": [
          {
            "body": "Pedir a los técnicos que reconstruyan sus rutas al final de la semana implica reembolsos inexactos, disputas con clientes y un montón cada vez mayor de kilómetros sin reclamar.",
            "title": "Kilometraje anotado días después, si acaso"
          },
          {
            "body": "Un ticket en la guantera es un coste que puede que nunca llegue a una factura. El coste real por trabajo siempre se queda corto.",
            "title": "Gastos en tickets de papel que desaparecen"
          },
          {
            "body": "Sin fichajes en directo, solo descubres dónde está un técnico cuando algo va mal y alguien llama.",
            "title": "Sin vista en tiempo real de dónde está el equipo"
          },
          {
            "body": "Cuando la mano de obra, los desplazamientos y los gastos se controlan en sistemas separados —o no se controlan—, nunca hay una cifra de coste única por trabajo.",
            "title": "Difícil ver el margen real por trabajo"
          }
        ],
        "quote": {
          "who": "Responsable de operaciones, empresa de servicio de campo · 11 empleados",
          "text": "El kilometraje era un quebradero de cabeza mensual. Ahora se registra solo: cada kilómetro queda vinculado al cliente correcto antes incluso de volver a la oficina.",
          "result": "Coste por trabajo preciso, siempre"
        },
        "stats": [
          {
            "label": "captura de kilometraje: sin cuaderno manual",
            "value": "Automática"
          },
          {
            "label": "coste por trabajo: horas + desplazamientos + gastos",
            "value": "En directo"
          },
          {
            "label": "kilómetros perdidos: cada trayecto capturado automáticamente",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "El GPS registra salida, llegada y distancia exacta por trayecto. Configura tipos de transporte (coche propio, vehículo de empresa, coche compartido) con sus propias tarifas de reembolso. Sin cuaderno manual.",
            "plan": "Add-on",
            "title": "Captura automática de kilometraje (Trax-it)"
          },
          {
            "body": "Los trabajadores fotografían un ticket en el campo; queda vinculado al trabajo y listo para el reembolso, sin perseguirlo a fin de mes.",
            "plan": "Time Basic",
            "title": "Gestión de gastos en la obra"
          },
          {
            "body": "Horas, kilometraje y gastos se acumulan contra el trabajo en tiempo real. El coste por trabajo es visible mientras el trabajo sigue abierto.",
            "plan": "Project Basic",
            "title": "Control de costes vinculado al proyecto"
          },
          {
            "body": "Cada técnico ficha en la sede del cliente. Ves quién está dónde, ahora mismo: sin llamadas, sin conjeturas.",
            "title": "Fichaje verificado por ubicación y vista del equipo en directo"
          },
          {
            "body": "Las horas y los reembolsos de kilometraje se exportan limpios para tu gestoría de nóminas, con tus tarifas de kilometraje configuradas aplicadas automáticamente.",
            "title": "Exportación de nómina con un clic"
          }
        ],
        "headline": "Control horario para equipos de servicio de campo: kilometraje, gastos y horas desde la carretera, todo en una sola app",
        "workflow": [
          {
            "body": "El fichaje inicia el registro del trayecto. Los kilómetros se capturan automáticamente desde la salida hasta la llegada, sin entrada manual.",
            "step": "El técnico sale hacia el primer aviso"
          },
          {
            "body": "Las horas se vinculan al proyecto correcto. El trabajo extra, los materiales y los tickets se registran en la app en el momento en que ocurren.",
            "step": "En el lugar de trabajo"
          },
          {
            "body": "Cada hora, kilómetro y gasto ya está vinculado al trabajo correcto. Exporta a la nómina y factura con cifras de coste reales.",
            "step": "Cierre de mes sin el caos"
          }
        ],
        "compliance": {
          "body": "Done-it captura el kilometraje automáticamente por trayecto, aplica tus tarifas de reembolso configuradas y registra cada kilómetro al cliente o proyecto correcto. La sentencia Tyco de la UE implica que el desplazamiento de casa al primer cliente cuenta como tiempo de trabajo: Done-it también lo controla.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Control digital de horas y kilometraje",
          "title": "Horas por GPS y kilometraje automático para equipos de servicio de campo"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "Climatización (HVAC)",
        "slug": "hvac",
        "intro": "Cada aviso de servicio tiene tres costes: mano de obra, piezas y desplazamiento. Done-it captura los tres en el campo y los acumula contra el trabajo correcto, para que conozcas tu margen antes de cerrar la factura.",
        "pains": [
          {
            "body": "La mano de obra, las piezas y el desplazamiento viven en sistemas diferentes, o en bolsillos diferentes. El coste real de una salida solo queda claro mucho después de que el técnico haya abandonado el lugar.",
            "title": "Es difícil calcular el coste exacto de los avisos de servicio"
          },
          {
            "body": "Cuando un cliente discute cuánto duró una reparación, un parte horario en papel es fácil de impugnar. Las marcas de tiempo de fichaje de entrada y salida confirmadas por GPS no lo son.",
            "title": "Sin prueba del tiempo de servicio"
          },
          {
            "body": "En los contratos de mantenimiento recurrente, los pequeños sobrecostes se acumulan a lo largo de muchas visitas. Sin un contador de horas en directo, solo descubres que el contrato está en números rojos en la renovación.",
            "title": "Los contratos de mantenimiento erosionan el margen en silencio"
          },
          {
            "body": "Las entradas de tiempo manuales se saltan las pausas, lo que lleva a pagar de más y a una nómina que no coincide con la realidad.",
            "title": "Los técnicos olvidan registrar las pausas"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de climatización · 7 técnicos",
          "text": "Por fin sabemos lo que nos cuesta realmente cada contrato de servicio. Las sorpresas en el margen pararon el día que empezamos a usar Done-it.",
          "result": "Coste real por aviso de servicio, en directo"
        },
        "stats": [
          {
            "label": "tipos de coste capturados por aviso: mano de obra, desplazamiento, piezas",
            "value": "3"
          },
          {
            "label": "visibilidad del margen por contrato de servicio",
            "value": "En directo"
          },
          {
            "label": "sorpresas al facturar: costes visibles en tiempo real",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Cada aviso de servicio o contrato de mantenimiento es un proyecto. Horas, desplazamientos y materiales se acumulan en tiempo real, dándote visibilidad del margen en directo.",
            "plan": "Project Basic",
            "title": "Control horario basado en proyectos"
          },
          {
            "body": "Cuando un trabajo crece, los técnicos registran el trabajo extra y las piezas con texto y fotos antes de irse. Nada se factura de memoria.",
            "plan": "Project Basic",
            "title": "Trabajo extra y materiales, registrados en la obra"
          },
          {
            "body": "Los kilómetros por salida se registran automáticamente y se imputan al trabajo. Configura las tarifas de reembolso por tipo de vehículo.",
            "plan": "Add-on",
            "title": "Kilometraje y costes de transporte"
          },
          {
            "body": "Las pausas obligatorias se restan automáticamente del tiempo total: sin disputas, sin errores de nómina.",
            "title": "Deducción automática de pausas"
          },
          {
            "body": "Fichaje con marca de tiempo y confirmado por GPS en cada sede. Prueba incuestionable de cuándo llegó y se fue el técnico.",
            "title": "Fichaje verificado por ubicación y prueba de presencia"
          }
        ],
        "headline": "Control horario para técnicos de climatización: cálculo de costes por trabajo, piezas y desplazamientos en una sola app",
        "workflow": [
          {
            "body": "El GPS marca la hora de llegada y vincula las horas al aviso de servicio o contrato de mantenimiento. Sin papel, sin terminal.",
            "step": "El técnico ficha en la sede"
          },
          {
            "body": "Las piezas utilizadas, las horas extra y los cambios de alcance se registran en la app con fotos, antes de abandonar la sede.",
            "step": "El trabajo extra se captura sobre la marcha"
          },
          {
            "body": "Mano de obra, desplazamiento y materiales se suman contra el proyecto en tiempo real. Ves el margen antes de emitir la factura.",
            "step": "El coste del trabajo es visible de inmediato"
          }
        ],
        "compliance": {
          "body": "Done-it da a los equipos de climatización fichaje verificado por ubicación por aviso de servicio, visibilidad de costes en directo por trabajo (mano de obra + desplazamiento + piezas) y una exportación de nómina limpia, cumpliendo cualquier requisito local de registro horario sin hardware adicional.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Control digital de horas y costes",
          "title": "Cálculo completo de costes por trabajo para avisos de servicio de climatización"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Electricistas",
        "slug": "electricians",
        "intro": "Horas por proyecto, una cuenta atrás en directo del presupuesto restante y navegación a la obra con un botón: hecho para pequeños equipos de electricistas que necesitan control del proyecto sin la carga administrativa.",
        "pains": [
          {
            "body": "Cuando los electricistas trabajan en varios trabajos en una semana, asignar las horas manualmente al final del día genera costes mal atribuidos, disputas de facturación y una nómina que no puedes explicar.",
            "title": "Las horas no se vinculan al proyecto correcto"
          },
          {
            "body": "Sin una vista en directo de las horas consumidas frente a las presupuestadas, descubres que un proyecto se ha pasado al emitir la factura, no cuando aún podías reaccionar.",
            "title": "Sobrecostes detectados demasiado tarde"
          },
          {
            "body": "Direcciones tecleadas en una app aparte, llamadas a la oficina para pedir indicaciones, llegadas tarde a las sedes de los clientes. Cada minuto perdido es un minuto facturable perdido.",
            "title": "Tiempo perdido buscando la obra"
          },
          {
            "body": "En instalaciones mayores, los electricistas subcontratados controlan sus propias horas por separado. Conseguir una vista combinada de los costes de mano de obra al final de un proyecto es un trabajo manual y propenso a errores.",
            "title": "Difícil cuadrar las horas de subcontratistas"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de electricidad · 5 electricistas",
          "text": "Sabemos en tiempo real si un proyecto se está pasando de presupuesto. Solo eso nos ha librado de dos malas sorpresas este año.",
          "result": "Sobrecostes detectados antes de que ocurran"
        },
        "stats": [
          {
            "label": "vista de horas restantes por proyecto",
            "value": "En directo"
          },
          {
            "label": "llamadas a la oficina para pedir direcciones de obra",
            "value": "0"
          },
          {
            "label": "para fichar en cualquier obra: sin terminal",
            "value": "1 toque"
          }
        ],
        "features": [
          {
            "body": "Cada minuto trabajado se vincula automáticamente al proyecto correcto. Una cuenta atrás en directo muestra cuántas horas quedan frente al presupuesto, para ti y para el trabajador en la obra.",
            "plan": "Project Basic",
            "title": "Horas de proyecto con presupuesto restante en directo"
          },
          {
            "body": "La dirección del proyecto está en la app. Un toque abre la navegación: sin buscar, sin app de mapas aparte, sin llamadas a la oficina.",
            "title": "Navegación a la obra con un botón"
          },
          {
            "body": "Cada electricista ficha en el trabajo correcto. Siempre sabes quién está en qué obra ahora mismo.",
            "plan": "Project Basic",
            "title": "Fichaje del trabajador por proyecto"
          },
          {
            "body": "Cuando cambia el alcance —un circuito inesperado, materiales adicionales—, se registra en la app con fotos, antes de que la cuadrilla se vaya.",
            "plan": "Project Basic",
            "title": "Trabajo extra registrado en la obra"
          },
          {
            "body": "Las horas extra se registran en el momento en que ocurren. Los trabajadores eligen entre cobrarlas o convertirlas en tiempo libre.",
            "plan": "Time Pro",
            "title": "Control de horas extra con compensación flexible"
          }
        ],
        "headline": "Control horario para electricistas: horas por proyecto, control de presupuesto y navegación en una sola app",
        "workflow": [
          {
            "body": "La dirección y el alcance ya están en la app. Un toque abre la navegación: sin llamadas, sin confusión.",
            "step": "El electricista navega hasta el trabajo"
          },
          {
            "body": "El fichaje en la obra vincula cada minuto trabajado al proyecto correcto. El contador de horas restantes se actualiza en directo.",
            "step": "Las horas se vinculan al proyecto correcto automáticamente"
          },
          {
            "body": "El trabajo extra y los materiales se registran en la obra, antes de irse. La factura refleja lo que realmente ocurrió.",
            "step": "Los cambios de alcance quedan registrados"
          }
        ],
        "compliance": {
          "body": "Done-it da a los electricistas fichaje verificado por ubicación por proyecto, un presupuesto de horas restantes en directo y exportación de nómina, satisfaciendo cualquier requisito local de registro horario. Para equipos en obras de construcción belgas, también se integra con CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Fichaje verificado por ubicación por proyecto",
          "title": "Control de presupuesto en directo y fichaje verificado por ubicación para equipos de electricistas"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Fontanería",
        "slug": "plumbing",
        "intro": "Salidas de urgencia, varios trabajos al día, horas rellenadas de memoria al final de la semana, o nada. Done-it lo convierte en un trabajo de un toque en cada sede y una nómina de un clic a fin de mes.",
        "pains": [
          {
            "body": "Con varios trabajos en un día, los fontaneros rara vez tienen tiempo de rellenar partes horarios precisos. Las horas se redondean o se olvidan, y la nómina es, en el mejor de los casos, una estimación.",
            "title": "Horas de salida reconstruidas de memoria"
          },
          {
            "body": "Cuando un cliente discute cuánto duró una reparación, no hay un registro objetivo. Un fichaje digital confirmado por GPS es fácil de aportar; un parte horario en papel no.",
            "title": "Sin prueba del tiempo en la sede"
          },
          {
            "body": "El desplazamiento entre salidas se acumula a lo largo de la semana y del mes, pero sin captura automática rara vez se factura o reembolsa correctamente.",
            "title": "Kilometraje entre trabajos sin controlar"
          },
          {
            "body": "A fin de mes, perseguir partes horarios, corregir errores y construir la exportación de la nómina lleva un tiempo que tu equipo administrativo no debería estar dedicando.",
            "title": "La preparación de la nómina es lenta"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de fontanería · 4 fontaneros",
          "text": "Antes pasábamos una mañana a fin de mes reconstruyendo horas. Ahora solo exportamos y enviamos. La gestoría de nóminas lo recibe limpio.",
          "result": "Preparación de nómina reducida de horas a minutos"
        },
        "stats": [
          {
            "label": "para fichar: lo bastante rápido para urgencias",
            "value": "1 toque"
          },
          {
            "label": "exportación de nómina a tu gestoría",
            "value": "1 clic"
          },
          {
            "label": "horas reconstruidas de memoria a fin de mes",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Llegada y salida registradas con un toque, con verificación de la ubicación. Lo bastante rápido para urgencias; lo bastante preciso para disputas.",
            "plan": "Time Basic",
            "title": "Fichaje verificado por ubicación de un toque en cada salida"
          },
          {
            "body": "Las pausas obligatorias se restan del tiempo total automáticamente: nada que rellenar, sin errores de nómina.",
            "plan": "Time Basic",
            "title": "Deducción automática de pausas"
          },
          {
            "body": "Configura tipos de transporte y tarifas de reembolso. Los kilómetros se registran automáticamente y se vinculan al cliente o proyecto correcto.",
            "plan": "Add-on",
            "title": "Kilometraje capturado por trayecto"
          },
          {
            "body": "Los trabajadores envían justificantes médicos digitalmente desde la app. Crea los tipos de ausencia que tu equipo realmente usa, incluidos los retrasos por mal tiempo.",
            "title": "Gestión de ausencias y justificantes médicos"
          },
          {
            "body": "Todos los datos de horas y kilometraje se exportan limpios para tu gestoría de nóminas: sin preparación manual, sin Excel.",
            "plan": "Time Basic",
            "title": "Exportación de nómina con un clic"
          }
        ],
        "headline": "Control horario para equipos de fontanería: fichaje rápido, nómina precisa y prueba de presencia en cada salida",
        "workflow": [
          {
            "body": "Un toque ficha. El GPS registra la ubicación y la hora. Lo bastante rápido para un trabajo de urgencia.",
            "step": "El fontanero llega a la salida"
          },
          {
            "body": "El fichaje de salida cierra el registro de tiempo. El kilometraje hasta el siguiente trabajo empieza a registrarse automáticamente.",
            "step": "La salida se ficha al irse"
          },
          {
            "body": "Todas las salidas, horas y kilómetros se exportan limpios. La preparación de la nómina pasa de un día a minutos.",
            "step": "El cierre de mes es un clic"
          }
        ],
        "compliance": {
          "body": "Done-it cubre cualquier requisito local de registro horario para equipos de fontanería: fichaje verificado por ubicación de un toque por salida, deducción automática de pausas y una exportación de nómina limpia. Sin partes horarios en papel, sin reconstrucción manual.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario digital",
          "title": "Fichaje verificado por ubicación rápido en cada salida"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Jardinería y paisajismo",
        "slug": "landscaping",
        "intro": "La temporada alta significa muchas obras, cuadrillas cambiantes y muchos kilómetros. Done-it mantiene organizada cada hora, cada ausencia y cada trayecto, para que puedas centrarte en el trabajo, no en el papeleo.",
        "pains": [
          {
            "body": "Trabajadores temporales, horarios cambiantes y tamaños de equipo variables hacen que el control horario preciso sea casi imposible con papel. Para cuando cuadras a fin de mes, siempre falta algo.",
            "title": "Las cuadrillas de temporada son complejas de gestionar"
          },
          {
            "body": "Una cuadrilla que visita tres o cuatro obras al día genera horas que hay que repartir correctamente. La entrada manual lleva a una mala atribución y a una nómina impugnada.",
            "title": "Horas repartidas entre muchas obras"
          },
          {
            "body": "La parada por mal tiempo es un evento real en jardinería. Sin un registro digital, documentar las paradas y ajustar el pago es lento y propenso a errores.",
            "title": "Las paradas por mal tiempo son difíciles de documentar"
          },
          {
            "body": "Furgonetas de empresa, vehículos personales y coches compartidos cruzan entre obras todo el día. Sin captura automática, esos kilómetros nunca llegan a la imagen de costes.",
            "title": "El kilometraje entre obras se queda sin controlar"
          }
        ],
        "quote": {
          "who": "Propietario, empresa de jardinería · 12 trabajadores de temporada",
          "text": "La temporada alta solía significar caos en la nómina. Ahora nuestro encargado revisa la app, todo el mundo está contabilizado, y yo exporto las horas el último día del mes.",
          "result": "Se acabó la reconstrucción de nómina a fin de mes"
        },
        "stats": [
          {
            "label": "captura de kilometraje: se acabó el cuaderno",
            "value": "Automática"
          },
          {
            "label": "vista de cuadrillas en todas las obras",
            "value": "En directo"
          },
          {
            "label": "exportación de nómina para todas las obras y toda la cuadrilla",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "Ve todas las cuadrillas, todas las obras en tiempo real. Sabe quién trabaja dónde, ahora mismo, no a fin de mes.",
            "title": "Vista de cuadrillas multiobra"
          },
          {
            "body": "Planifica quién trabaja dónde, gestiona cambios de última hora y envía el horario a los móviles del equipo, sin una llamada a cada persona.",
            "plan": "Time Pro",
            "title": "Planificación de turnos para equipos de temporada"
          },
          {
            "body": "Crea tipos de ausencia personalizados para tu sector: paradas estacionales por mal tiempo, permiso parental, días de baja. Los trabajadores suben la documentación digitalmente desde la app.",
            "title": "Tipos de ausencia personalizados"
          },
          {
            "body": "Configura tipos de transporte (furgoneta de empresa, coche personal, conductor frente a pasajero en coche compartido) con sus propias tarifas. Los kilómetros se registran automáticamente por trayecto.",
            "plan": "Add-on",
            "title": "Kilometraje con control de coche compartido"
          },
          {
            "body": "Las horas extra de temporada alta se acumulan rápido. Cada trabajador puede elegir entre cobrarlas o acumular las horas como tiempo libre, controlado de forma transparente.",
            "plan": "Time Pro",
            "title": "Control de horas extra con conversión en días libres"
          }
        ],
        "headline": "Control horario para empresas de jardinería: cuadrillas de temporada, múltiples obras y kilometraje en una sola vista",
        "workflow": [
          {
            "body": "El GPS registra la llegada. Las horas se reparten automáticamente a la ubicación y el proyecto correctos, sin asignación manual al final del día.",
            "step": "La cuadrilla ficha en la primera obra"
          },
          {
            "body": "El encargado registra la parada desde la app: un registro digital limpio, sin papeleo extra.",
            "step": "El mal tiempo detiene el trabajo"
          },
          {
            "body": "Horas, ausencias y kilometraje en cada obra y de cada miembro de la cuadrilla se exportan limpios para la nómina.",
            "step": "Cierre de mes: todas las obras, toda la cuadrilla, una exportación"
          }
        ],
        "compliance": {
          "body": "Done-it da a los equipos de jardinería registro horario digital en todas las obras y para el personal de temporada: fichaje verificado por ubicación, tipos de ausencia personalizados para paradas por mal tiempo y una exportación de nómina limpia que satisface cualquier requisito local.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario digital",
          "title": "Fichaje verificado por ubicación y control de ausencias para equipos de jardinería de temporada"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Mantenimiento",
        "slug": "maintenance",
        "intro": "Los contratos de mantenimiento recurrente viven o mueren por la visibilidad de costes. Done-it registra cada visita, controla las horas frente al presupuesto del contrato y te da —a ti y a tus clientes— prueba de presencia en cada aviso.",
        "pains": [
          {
            "body": "Cuando las horas de las visitas recurrentes no se controlan frente al contrato concreto, no sabes si un cliente es rentable hasta la revisión de fin de año, momento en el que ya es demasiado tarde para reajustar el precio.",
            "title": "Sin visibilidad de costes por contrato de mantenimiento"
          },
          {
            "body": "Los gestores de instalaciones y los propietarios quieren cada vez más registros de presencia: quién vino, cuándo llegó, qué hizo. Un registro en papel presentado semanas después no satisface los requisitos del SLA.",
            "title": "Los clientes esperan prueba de lo que se hizo"
          },
          {
            "body": "Los turnos rotativos en muchas obras recurrentes —con personal que se cubre entre sí— crean un rompecabezas de planificación y control horario que los procesos manuales no pueden resolver con fiabilidad.",
            "title": "Las visitas recurrentes son difíciles de planificar y registrar"
          },
          {
            "body": "El mantenimiento de zonas verdes, de fachadas y de instalaciones exteriores se enfrenta a paradas por mal tiempo. Documentarlas correctamente requiere un rastro digital.",
            "title": "Las paradas por mal tiempo también afectan al mantenimiento en exteriores"
          }
        ],
        "quote": {
          "who": "Responsable de operaciones, empresa de mantenimiento · 8 trabajadores",
          "text": "Podemos decirle a un gestor de instalaciones exactamente quién estuvo en la sede y cuándo, en dos minutos. Ese nivel de prueba cambió cómo nos ven los clientes.",
          "result": "Disputas con clientes reducidas a cero"
        },
        "stats": [
          {
            "label": "coste por contrato de mantenimiento",
            "value": "En directo"
          },
          {
            "label": "prueba de presencia lista para clientes cuando lo pidan",
            "value": "GPS"
          },
          {
            "label": "renovaciones de contrato sin conocer tu margen",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Cada contrato de mantenimiento es un proyecto. Las horas se registran automáticamente contra él, dándote una cifra de coste en directo y una cuenta atrás de horas restantes por cada cliente.",
            "plan": "Project Basic",
            "title": "Control de costes basado en contratos"
          },
          {
            "body": "Los fichajes con marca de tiempo y verificados por ubicación son un registro incuestionable de quién estuvo en la sede, cuándo y durante cuánto tiempo, listo para compartir con los clientes cuando lo pidan.",
            "title": "Prueba de presencia confirmada por GPS"
          },
          {
            "body": "Los trabajadores reportan incidencias, tareas completadas o trabajo extra directamente desde la app, con texto y fotos. Los clientes obtienen un registro en tiempo real; tú tienes la documentación para facturar.",
            "plan": "Project Basic",
            "title": "Actualizaciones con fotos desde la obra"
          },
          {
            "body": "Planifica las visitas recurrentes en todos los contratos, asigna trabajadores y gestiona las sustituciones, sin una llamada a cada persona.",
            "plan": "Time Pro",
            "title": "Planificación de turnos recurrentes"
          },
          {
            "body": "Configura paradas por mal tiempo y otros tipos de ausencia. Los trabajadores los registran desde la app; la documentación se sube digitalmente.",
            "title": "Tipos de ausencia para mantenimiento en exteriores"
          }
        ],
        "headline": "Control horario para equipos de mantenimiento: visitas recurrentes, coste por contrato y prueba de presencia en una sola app",
        "workflow": [
          {
            "body": "El fichaje verificado por ubicación registra la hora de llegada y vincula las horas al contrato correcto. La prueba de presencia se crea automáticamente.",
            "step": "El trabajador llega a la obra de mantenimiento"
          },
          {
            "body": "El trabajo completado y cualquier incidencia se reportan desde la app con fotos. Los clientes pueden ver exactamente qué se hizo.",
            "step": "Tareas completadas, incidencias registradas"
          },
          {
            "body": "Las horas se acumulan contra el presupuesto del contrato en tiempo real. Conoces el margen antes de que el contrato se renueve.",
            "step": "Coste por contrato visible de inmediato"
          }
        ],
        "compliance": {
          "body": "Done-it da a los equipos de mantenimiento prueba de presencia confirmada por GPS por contrato, tipos de ausencia personalizados y una vista de costes en directo por cada cliente recurrente, satisfaciendo cualquier requisito local de registro horario sin hardware adicional.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Control horario basado en contratos",
          "title": "Visibilidad de costes en directo por contrato de mantenimiento"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Tiendas y comercio",
        "slug": "retail",
        "intro": "Turnos de apertura, turnos de cierre y siempre alguien cubriendo a alguien. Done-it le da a cada tienda un registro digital limpio de quién trabajó cada turno: fichado desde su propio móvil y listo para la nómina a fin de mes.",
        "pains": [
          {
            "body": "Alguien cubre a un compañero enfermo, otro se queda una hora más al cierre. Se apunta en una nota, o no se apunta. Y la nómina ya sale mal antes de empezar.",
            "title": "Los cambios de turno nunca llegan a la nómina"
          },
          {
            "body": "El personal se mueve entre locales y los de jornada parcial trabajan en dos sitios. Recoger las horas de cada tienda y unirlas a mano cuesta un día cada mes.",
            "title": "Varias tiendas, una sola nómina"
          },
          {
            "body": "Los descansos obligatorios se descuentan de memoria y las horas extra se arreglan de palabra: justo lo primero que pregunta una inspección.",
            "title": "Descansos y horas extra a ojo"
          }
        ],
        "quote": {
          "who": "Propietaria, comercio · 11 empleados",
          "text": "Dos tiendas y mucha jornada parcial. Antes, la mitad de las coberturas se ajustaban de memoria. Ahora cada hora está en la tienda correcta y la nómina lleva minutos.",
          "result": "La nómina pasó de un día a menos de una hora"
        },
        "stats": [
          {
            "label": "para fichar, sin terminal en la caja",
            "value": "1 toque"
          },
          {
            "label": "quién está trabajando, en todas las tiendas",
            "value": "En directo"
          },
          {
            "label": "cambios de turno perdidos entre la tienda y la nómina",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un toque en su móvil al empezar el turno. Sin terminal en la caja, sin tarjeta compartida, sin hoja en la puerta del almacén.",
            "title": "Fichaje en la propia tienda"
          },
          {
            "body": "Cada tienda es un proyecto. Quien cubre en otro local ficha en ese local: ves las horas donde se trabajaron de verdad.",
            "title": "Horas por tienda, personal entre locales"
          },
          {
            "body": "Configuras la regla de descanso una vez y se aplica a todos los turnos. Las horas extra se registran en el momento y cada empleado elige entre cobrarlas o compensarlas.",
            "title": "Descansos descontados automáticamente"
          }
        ],
        "headline": "Control horario para tiendas: fichaje por turnos, coberturas y una exportación lista para nóminas, en una sola app",
        "workflow": [
          {
            "body": "Un toque en el móvil al empezar. La cobertura en otro local se ficha en ese local.",
            "step": "El equipo ficha su turno"
          },
          {
            "body": "Una vista en directo de todos los locales: detectas un turno de apertura sin cubrir antes de abrir.",
            "step": "Ves quién está, tienda a tienda"
          },
          {
            "body": "Horas, descansos y horas extra por empleado y por tienda, exportados listos para tu proveedor de nóminas.",
            "step": "Nómina en una exportación"
          }
        ],
        "compliance": {
          "body": "Done-it guarda un registro digital y objetivo de cada entrada y salida, con descansos y horas extra: el registro que pide una auditoría o una reclamación de nómina.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario por turnos",
          "title": "Un registro defendible de cada turno trabajado"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Oficinas y servicios profesionales",
        "slug": "offices",
        "intro": "Asesorías, notarías, estudios de arquitectura, agencias y consultoras facturan su tiempo, o al menos necesitan saber a dónde fue. Done-it registra las horas en el cliente y el proyecto correctos, desde el escritorio o fuera de la oficina.",
        "pains": [
          {
            "body": "El tiempo que se apunta al final de la semana es tiempo estimado. Horas enteras desaparecen en silencio entre el trabajo y la factura.",
            "title": "Horas facturables reconstruidas el viernes"
          },
          {
            "body": "Los honorarios se acordaron hace meses. Si el trabajo sigue cabiendo dentro solo se ve cuando alguien lo suma, y normalmente ya es tarde.",
            "title": "Nadie sabe cuánto cuesta un cliente"
          },
          {
            "body": "Parte del equipo está en la oficina, parte en casa y parte en el cliente. La presencia deja de ser un dato y pasa a ser una reconstrucción.",
            "title": "El trabajo híbrido deja el registro incompleto"
          }
        ],
        "quote": {
          "who": "Socio, asesoría contable · 8 empleados",
          "text": "Antes reconstruíamos la semana cada viernes. Ahora las horas ya están en el cliente correcto y veo qué expedientes se están comiendo los honorarios.",
          "result": "Horas facturables recuperadas cada mes"
        },
        "stats": [
          {
            "label": "horas visibles mientras el trabajo sigue en marcha",
            "value": "Por cliente"
          },
          {
            "label": "el mismo registro, en móvil y navegador",
            "value": "Oficina o calle"
          },
          {
            "label": "para nóminas y facturación",
            "value": "1 exportación"
          }
        ],
        "features": [
          {
            "body": "Cada registro cae en un proyecto, así que ves las horas por cliente sin exportar nada ni preguntar a nadie.",
            "title": "Horas por cliente y proyecto"
          },
          {
            "body": "La misma app en el móvil o en el navegador. Visitar a un cliente cuenta como trabajo para ese cliente, incluido el desplazamiento si así lo quieres.",
            "title": "Funciona en el escritorio y fuera"
          },
          {
            "body": "Las horas extra se registran en el momento; las vacaciones se solicitan y se aprueban en la app. Sin hoja de cálculo paralela de quién está fuera y cuándo.",
            "title": "Horas extra y vacaciones en un solo sitio"
          }
        ],
        "headline": "Control horario para oficinas: horas por cliente y proyecto, sin hojas de cálculo",
        "workflow": [
          {
            "body": "Se configura una vez con el cliente y, si facturas por presupuesto, las horas previstas.",
            "step": "Abre un proyecto de cliente"
          },
          {
            "body": "Desde el escritorio o el móvil. Cada hora cae en un cliente, no en la memoria de alguien.",
            "step": "El equipo imputa su tiempo"
          },
          {
            "body": "Totales en directo por proyecto y una exportación limpia para la nómina o la facturación a fin de mes.",
            "step": "Ves las horas por cliente y exportas para nóminas"
          }
        ],
        "compliance": {
          "body": "Done-it mantiene un registro digital y a prueba de manipulaciones del tiempo de trabajo de cada empleado: la base tanto para la nómina como para una factura defendible ante el cliente.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario por cliente",
          "title": "Un registro objetivo de las horas trabajadas"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salones y estética",
        "slug": "beauty",
        "intro": "Peluquerías, barberías y centros de uñas y estética funcionan con turnos y contratos a tiempo parcial. Done-it registra quién trabajó y cuándo, descuenta los descansos automáticamente y entrega a nóminas un archivo limpio.",
        "pains": [
          {
            "body": "Tres días una semana, cuatro la siguiente, un sábado cambiado por un martes. Las horas del contrato y las trabajadas se separan rápido.",
            "title": "Contratos parciales, variaciones sin fin"
          },
          {
            "body": "Las citas dicen qué se reservó, no quién trabajó. Cuando lo pregunta la nómina o una inspección, el sistema de reservas es la respuesta equivocada.",
            "title": "La agenda no es un registro horario"
          },
          {
            "body": "Quedarse hasta tarde por una última clienta se recuerda, se promete y a veces se olvida. Ese es el hueco que acaba en conflicto.",
            "title": "Las horas extra se arreglan de palabra"
          }
        ],
        "quote": {
          "who": "Propietaria, peluquería · 6 empleados",
          "text": "Todo el mundo es de jornada parcial y cada semana es distinta. La app simplemente lo registra: he dejado de rehacer el mes en una hoja de cálculo.",
          "result": "Se acabaron las horas discutidas a fin de mes"
        },
        "stats": [
          {
            "label": "para fichar, sin nada compartido ni en papel",
            "value": "1 toque"
          },
          {
            "label": "descuento de descansos en cada turno",
            "value": "Auto"
          },
          {
            "label": "horas de más ajustadas de memoria",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un toque en su propio móvil al empezar el turno: sin terminal compartido en recepción, sin lista de firmas junto al espejo.",
            "title": "Fichaje en el salón"
          },
          {
            "body": "Configura la regla de descanso y la jornada estándar una vez; se aplican a todos los turnos, con excepciones por persona cuando el contrato es distinto.",
            "title": "Descansos y jornada parcial, una sola vez"
          },
          {
            "body": "Las horas extra se registran según se trabajan y cada empleado elige entre cobrarlas o compensarlas con tiempo libre. Se cierra en la app, no de memoria.",
            "title": "Horas extra: cobradas o compensadas"
          }
        ],
        "headline": "Control horario para salones: turnos, jornada parcial y nóminas sin agenda de papel",
        "workflow": [
          {
            "body": "Un toque al llegar. Los descansos se descuentan con la regla que configuraste una vez.",
            "step": "El equipo ficha su turno"
          },
          {
            "body": "Quién está, quién está en su descanso, quién se quedó hasta tarde. En directo y sin preguntar.",
            "step": "Ves el día según avanza"
          },
          {
            "body": "Horas trabajadas, descansos y horas extra por empleado, exportados para tu proveedor de nóminas.",
            "step": "Nóminas recibe un archivo limpio"
          }
        ],
        "compliance": {
          "body": "Done-it registra el tiempo de trabajo real de cada empleado, con descansos y horas extra: separado de las reservas y defendible cuando lo revisan.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro horario digital",
          "title": "Un registro que va más allá del libro de citas"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salud y bienestar",
        "slug": "wellness",
        "intro": "Gimnasios, estudios de fitness, clínicas de fisioterapia y spas abren muchas horas con personal rotativo. Done-it registra quién cubrió cada turno, descuenta los descansos automáticamente y exporta la nómina sin líos.",
        "pains": [
          {
            "body": "Turnos de mañana, clases de tarde y fines de semana, cubiertos por una mezcla de jornada completa, parcial y autónomos. El cuadrante es un plan, no un registro.",
            "title": "Horarios largos, coberturas rotativas"
          },
          {
            "body": "Un instructor da dos clases y cubre recepción entre medias. Pagar eso bien exige saber qué se trabajó de verdad, no qué estaba programado.",
            "title": "Las horas de clase y de sala se mezclan"
          },
          {
            "body": "El personal se mueve entre estudios. Unir sus horas a mano cada mes es lento y da errores.",
            "title": "Varios centros, una sola administración"
          }
        ],
        "quote": {
          "who": "Gerente, estudio de fitness · 14 empleados",
          "text": "Dos estudios, horarios largos y muchas coberturas. Ahora las horas caen en el centro correcto y la nómina es un solo archivo.",
          "result": "El cuadrante y la nómina por fin coinciden"
        },
        "stats": [
          {
            "label": "horas, aunque el personal cubra en otro sitio",
            "value": "Por centro"
          },
          {
            "label": "vista de la sala en todos los centros",
            "value": "En directo"
          },
          {
            "label": "descansos y horas extra, sin cálculos a mano",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Un toque en su móvil en el centro donde trabaja. La cobertura en otro estudio cae en las horas de ese estudio.",
            "title": "Fichaje por centro"
          },
          {
            "body": "Ves la sala de todos los centros en tiempo real: un turno de mañana sin cubrir se ve antes de abrir, no después.",
            "title": "Vista en directo de quién está"
          },
          {
            "body": "Reglas de descanso aplicadas automáticamente y horas extra registradas en el momento, con cobro o compensación en tiempo libre según el empleado.",
            "title": "Descansos y horas extra resueltos"
          }
        ],
        "headline": "Control horario para gimnasios, estudios y spas: turnos, clases y nóminas en una app",
        "workflow": [
          {
            "body": "Un toque al empezar el turno, en el centro donde trabaja.",
            "step": "El equipo ficha en el estudio"
          },
          {
            "body": "Quién está en cada centro ahora mismo, para cubrir los huecos antes de que los socios lo noten.",
            "step": "Las coberturas se ven en directo"
          },
          {
            "body": "Horas, descansos y horas extra por empleado y por estudio, listos para el proveedor de nóminas.",
            "step": "Una exportación para nóminas"
          }
        ],
        "compliance": {
          "body": "Done-it mantiene un registro digital del tiempo de trabajo por empleado y por centro: la base para pagar correctamente y para cualquier revisión de las horas trabajadas.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro de turnos multicentro",
          "title": "Un registro objetivo de cada turno y cada centro"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Hostelería",
        "slug": "hospitality",
        "intro": "Turnos partidos, cierres tarde y un sábado con lleno que se alarga. Done-it registra las horas tal y como se trabajan, descuenta los descansos según tu regla y entrega a nóminas un solo archivo limpio.",
        "pains": [
          {
            "body": "El servicio se alarga y el cierre lleva media hora más. Esos minutos son trabajo real, y ajustarlos de memoria es como empiezan los conflictos.",
            "title": "El turno nunca acaba cuando dice el cuadrante"
          },
          {
            "body": "Servicio de mediodía, descanso y luego cenas. En papel acaba siendo un bloque largo o dos estimaciones: ninguna es la verdad.",
            "title": "Los turnos partidos son difíciles de registrar"
          },
          {
            "body": "Personal nuevo cada temporada. Cualquier sistema que exija formación no sobrevive a la primera semana fuerte.",
            "title": "Mucha rotación, formación constante"
          }
        ],
        "quote": {
          "who": "Propietario, restaurante · 17 empleados",
          "text": "El cierre siempre se alarga. Ahora esos minutos se registran en vez de discutirse, y el equipo puede recuperarlos como tiempo libre.",
          "result": "Menos conflictos y nóminas más rápidas"
        },
        "stats": [
          {
            "label": "registrados como dos bloques, no como una estimación",
            "value": "Turnos partidos"
          },
          {
            "label": "descuento de descansos según tu regla",
            "value": "Auto"
          },
          {
            "label": "para dar de alta a alguien nuevo: es su propio móvil",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Un toque al empezar y al terminar cada bloque, para que los turnos partidos queden registrados como fueron, no unidos en uno solo.",
            "title": "Fichaje de entrada y salida por servicio"
          },
          {
            "body": "Descansos obligatorios descontados automáticamente, con excepciones por persona cuando el contrato lo exige. Sin cálculos a mano a fin de mes.",
            "title": "Descansos según tu regla"
          },
          {
            "body": "La media hora de más tras el cierre se registra en cuanto se trabaja y se cobra o se compensa con tiempo libre: elige el empleado.",
            "title": "Horas extra resueltas en la app"
          }
        ],
        "headline": "Control horario para cafeterías, restaurantes y hoteles: turnos, descansos y horas extra, resueltos con justicia",
        "workflow": [
          {
            "body": "Un toque al empezar el bloque y otro al terminar. Los turnos partidos siguen partidos.",
            "step": "El equipo ficha para el servicio"
          },
          {
            "body": "Quién está para el servicio de esta noche, quién sigue en su descanso, quién se quedó después del cierre.",
            "step": "Ves la sala en directo"
          },
          {
            "body": "Tiempo trabajado, descansos y horas extra por empleado, exportados en un solo archivo.",
            "step": "Nóminas recibe las horas reales"
          }
        ],
        "compliance": {
          "body": "Done-it guarda un registro digital y objetivo de cada turno, descanso y hora extra: exactamente lo que pide ver una revisión de nóminas o una inspección de trabajo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro de turnos partidos",
          "title": "Un registro defendible en un equipo con mucha rotación"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sanidad y cuidados",
        "slug": "healthcare",
        "intro": "Clínicas, equipos de ayuda a domicilio y residencias funcionan con turnos, visitas y una documentación estricta. Done-it registra el tiempo trabajado por turno y por visita, y guarda los documentos de cada empleado donde puedes encontrarlos.",
        "pains": [
          {
            "body": "Las visitas a domicilio viven en una herramienta, las horas del cuadrante en otra y la nómina recibe una tercera versión. Cuadrarlas es una tarea mensual.",
            "title": "Visitas y turnos en sistemas distintos"
          },
          {
            "body": "Las horas con complemento tienen tarifas distintas. Si el registro es aproximado, el pago también, y la corrección llega después.",
            "title": "Horas nocturnas y de fin de semana mal pagadas"
          },
          {
            "body": "Las titulaciones y los certificados importan en el sector de cuidados, y están en una carpeta que nadie abre hasta que la pide una inspección.",
            "title": "Los certificados caducan en silencio"
          }
        ],
        "quote": {
          "who": "Coordinadora, equipo de ayuda a domicilio · 22 empleados",
          "text": "Las visitas a domicilio y los turnos del cuadrante por fin están en el mismo registro. La nómina ha dejado de ser un ejercicio de cuadre.",
          "result": "Un solo registro en lugar de tres"
        },
        "stats": [
          {
            "label": "o por turno, según trabaje tu equipo",
            "value": "Por visita"
          },
          {
            "label": "de horas nocturnas y de fin de semana, tal como se trabajan",
            "value": "Desglose"
          },
          {
            "label": "certificados guardados por empleado",
            "value": "Archivados"
          }
        ],
        "features": [
          {
            "body": "Un toque al empezar el turno, o en cada domicilio en la atención a domicilio, con ubicación verificada donde necesitas la prueba.",
            "title": "Fichaje por turno o por visita"
          },
          {
            "body": "Las horas nocturnas, de fin de semana y ordinarias se registran por separado, así que la exportación para nóminas ya refleja cómo se paga el trabajo.",
            "title": "Horas desglosadas como las pagas"
          },
          {
            "body": "Contratos, certificados y DNI guardados junto a la persona a la que pertenecen: se encuentran en segundos cuando alguien los pide.",
            "title": "Documentos del empleado en un solo sitio"
          }
        ],
        "headline": "Control horario para equipos de cuidados: turnos, visitas a domicilio y titulaciones, en un solo registro",
        "workflow": [
          {
            "body": "Un toque en el centro o en el domicilio del paciente, con ubicación verificada donde hace falta la prueba.",
            "step": "Ficha el turno o la visita"
          },
          {
            "body": "Horas ordinarias, nocturnas y de fin de semana registradas por separado según ocurren.",
            "step": "Cada hora cae donde corresponde"
          },
          {
            "body": "Un archivo limpio por periodo, ya desglosado como lo pagas.",
            "step": "Exporta para nóminas"
          }
        ],
        "compliance": {
          "body": "Done-it mantiene un registro digital y objetivo del tiempo de trabajo de cada empleado (horas, descansos y desglose de complementos) junto a la documentación que corresponde a cada persona.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registro de turnos y visitas",
          "title": "Registros que aguantan una inspección"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "de": [
      {
        "name": "Baugewerbe",
        "slug": "construction",
        "intro": "Teams über mehrere Baustellen verteilt, Stunden auf Papier gekritzelt, Subunternehmerstunden unmöglich abzugleichen. Done-it gibt jeder Baustelle einen wasserdichten digitalen Stundenzettel, der mit einem Klick in Ihre Lohnabrechnung fließt.",
        "pains": [
          {
            "body": "Mit mehreren aktiven Baustellen und wechselnden Teams sind manuelle Stundenzettel von Natur aus fehlerhaft. Mitarbeitende runden auf, vergessen Einträge oder tragen sie Tage später ein — und Sie bleiben mit Lohnzahlen zurück, die Sie nicht verteidigen können.",
            "title": "Keine zuverlässige Aufzeichnung, wer wo gearbeitet hat"
          },
          {
            "body": "Wenn Sie bemerken, dass eine Baustelle ihre geplanten Stunden aufgebraucht hat, ist die Marge bereits weg. Es gibt keinen Live-Countdown — nur eine böse Überraschung bei der Rechnungsstellung.",
            "title": "Budgetüberschreitungen tauchen zu spät auf"
          },
          {
            "body": "Stundenzettel einsammeln, mit den Projekten abgleichen und den Lohnexport vorbereiten dauert Tage. Jeder Eintrag ist ein potenzieller Fehler.",
            "title": "Die Lohnvorbereitung frisst jeden Monat Stunden"
          }
        ],
        "quote": {
          "who": "Inhaber, Bauunternehmen · 14 Mitarbeitende",
          "text": "Unser Team checkt sich vor Ort selbst ein. Zum Monatsende geht die Lohnabrechnung einfach auf — wir jagen Stundenzetteln überhaupt nicht mehr hinterher.",
          "result": "5 Stunden pro Woche bei der Verwaltung gespart"
        },
        "stats": [
          {
            "label": "zum Einchecken auf jeder Baustelle — kein Terminal, kein Papier",
            "value": "1 Tippen"
          },
          {
            "label": "Lohnexport, bereit für Ihren Anbieter",
            "value": "1 Klick"
          },
          {
            "label": "Ansicht der Reststunden pro Projekt und Baustelle",
            "value": "Live"
          }
        ],
        "features": [
          {
            "body": "Ein Tippen checkt den Mitarbeitenden ein, standortverifiziert, und verknüpft die Stunden mit dem richtigen Projekt. Keine Kartenleser, keine Terminals — nur das Smartphone, das Ihr Team ohnehin schon dabei hat.",
            "title": "Standortverifizierter Check-in pro Baustelle"
          },
          {
            "body": "Legen Sie beim Eröffnen des Projekts die geplanten Stunden als Budget fest. Mitarbeitende sehen einen Countdown des Verbleibenden; Sie sehen es live in Ihrem Dashboard. Budgetüberschreitungen sind sichtbar, bevor sie eintreten.",
            "title": "Live-Restsstunden pro Projekt"
          },
          {
            "body": "Fügen Sie Subunternehmer zu einem Projekt hinzu, weisen Sie sie dem Check-in zu und erfassen Sie ihre Stunden neben Ihrem eigenen Team — in derselben Übersicht.",
            "title": "Subunternehmerverwaltung und Anwesenheit"
          },
          {
            "body": "Alle erfassten Stunden — pro Mitarbeitendem, pro Projekt — werden in eine saubere Tabelle für Ihren Lohnabrechnungsanbieter exportiert. Keine manuelle Vorbereitung, keine Fehler.",
            "title": "Lohnexport mit einem Klick"
          }
        ],
        "headline": "Zeiterfassung für Bauteams — standortverifizierter Check-in, Projektstunden und Budgetkontrolle, in einer App",
        "workflow": [
          {
            "body": "Jeder Mitarbeitende tippt einmal zum Einchecken. GPS bestätigt den Standort, versieht den Eintrag mit einem Zeitstempel und verknüpft die Stunden mit dem Projekt. Kein Papier, kein Terminal.",
            "step": "Team kommt auf der Baustelle an"
          },
          {
            "body": "Stunden, verbleibendes Budget, Subunternehmer-Anwesenheit und alle von der Baustelle gemeldeten zusätzlichen Arbeiten — alles in Ihrem Dashboard, in Echtzeit.",
            "step": "Sie sehen alles live"
          },
          {
            "body": "Exportieren Sie alle Stunden pro Mitarbeitendem und pro Projekt. Senden Sie sie an Ihren Lohnabrechnungsanbieter. Done-it erstellt automatisch saubere, prüfungsbereite Berichte.",
            "step": "Monatsende in Minuten"
          }
        ],
        "compliance": {
          "body": "Done-it bietet standortverifizierten Check-in, projektbezogene Zeiterfassung und einen sauberen Lohnexport für Bauteams. Für Teams, die auf belgischen Baustellen tätig sind, speist es zudem automatisch Check-in am Arbeitsplatz.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeiterfassung",
          "title": "Standortverifizierter Check-in für Baustellen entwickelt"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Reinigung",
        "slug": "cleaning",
        "intro": "Reinigungskräfte sind den ganzen Tag zwischen Standorten unterwegs. Done-it erfasst in Echtzeit, wer wo ist — standortverifizierter Check-in an jedem Standort, automatischer Pausenabzug und ein sauberer Lohnexport zum Monatsende.",
        "pains": [
          {
            "body": "Kunden und Kontrolleure erwarten wasserdichte Anwesenheitsaufzeichnungen. Manuelle Zettel können angefochten werden; standortverifizierte digitale Check-ins nicht.",
            "title": "Anwesenheit an jedem Standort nachweisen"
          },
          {
            "body": "Da sich die Reinigungskräfte den ganzen Tag zwischen Standorten bewegen, haben Sie keine Live-Ansicht darüber, wer wo arbeitet — bis jemand anruft.",
            "title": "Teams über viele Standorte verteilt"
          },
          {
            "body": "Ohne präzise Ein-/Auscheckzeiten wird die Lohnabrechnung aus dem Gedächtnis rekonstruiert. Stunden werden aufgerundet, Kosten steigen und Streitigkeiten folgen.",
            "title": "Lohnfehler durch gerundete Stunden"
          }
        ],
        "quote": {
          "who": "Manager, Reinigungsunternehmen · 9 Mitarbeitende",
          "text": "Wir können endlich nachweisen, wer wo und wann gereinigt hat. Keine Anwesenheitszettel mehr, keine Kundenstreitigkeiten mehr — GPS erledigt das.",
          "result": "Null Aufrunden von Stunden"
        },
        "stats": [
          {
            "label": "zum Einchecken an jedem Standort — kein Terminal nötig",
            "value": "1 Tippen"
          },
          {
            "label": "Ansicht darüber, wer gerade an welchem Standort ist",
            "value": "Live"
          },
          {
            "label": "Doppeleinträge — Stunden fließen direkt in die Lohnabrechnung",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Mitarbeitende tippen sich an jedem Standort auf ihrem Telefon ein und aus, standortverifiziert; die Zeit ist exakt, mit Pausenerfassung.",
            "plan": "Time Basic",
            "title": "Echtzeit-Check-in und Check-out"
          },
          {
            "body": "Vorgeschriebene Pausen werden automatisch vom Arbeitstag abgezogen — keine manuelle Rechnerei, keine Streitigkeiten.",
            "plan": "Time Basic",
            "title": "Automatischer Pausenabzug"
          },
          {
            "body": "Sehen Sie, welche Reinigungskräfte gerade an welchen Standorten sind. Erkennen Sie Lücken, bevor Kunden es tun.",
            "title": "Live-Übersicht über mehrere Standorte"
          },
          {
            "body": "Mitarbeitende laden Krankmeldungen und Abwesenheitsdokumente direkt aus der App hoch. Erstellen Sie die Abwesenheitsarten, die Ihr Team tatsächlich nutzt.",
            "title": "Abwesenheitserfassung mit digitalen Krankmeldungen"
          },
          {
            "body": "Exakte Zeitstempel fließen direkt in einen lohnfertigen Export für Ihren Anbieter. Keine Übertragung, keine Fehler.",
            "title": "Lohnexport mit einem Klick"
          }
        ],
        "headline": "Zeiterfassung für Reinigungsunternehmen — standortverifizierter Check-in, Anwesenheitsnachweis und Lohnabrechnung in einer App",
        "workflow": [
          {
            "body": "Ein Tippen checkt sie ein. GPS protokolliert den Standort und versieht den Eintrag mit einem Zeitstempel. Die Pausenerfassung ist in die App integriert.",
            "step": "Reinigungskraft kommt am Standort an"
          },
          {
            "body": "Wer gerade an welchem Standort ist — keine Anrufe, kein Rätselraten. Erkennen Sie Lücken in der Abdeckung, bevor Kunden es tun.",
            "step": "Sie sehen jeden Standort live"
          },
          {
            "body": "Alle Anwesenheitsdaten — exakte Zeiten, Standorte und Pausen — werden sauber für Ihren Lohnabrechnungsanbieter exportiert.",
            "step": "Lohnabrechnung mit einem Klick"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Reinigungsteams standortverifizierten Check-in an jedem Standort, automatischen Pausenabzug und eine Live-Ansicht darüber, wer gerade an welchem Standort ist.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Standortverifizierte Anwesenheit",
          "title": "Echtzeit-Anwesenheit an jedem Reinigungsstandort"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Installation",
        "slug": "installation",
        "intro": "Schicken Sie Ihre Monteure mit allem, was sie brauchen, zur richtigen Adresse, verknüpfen Sie jede geleistete Stunde automatisch mit dem richtigen Auftrag und sehen Sie das verbleibende Budget, bevor die Baustelle schließt. Done-it ist der einfachste Weg, Installationsprojekte termin- und kostengerecht zu halten.",
        "pains": [
          {
            "body": "Teams kommen ohne Adresse, Ansprechpartner oder Details zum Auftragsumfang an einer Baustelle an. Dieser erste Anruf sind zehn Minuten abrechenbarer Zeit, die verloren gehen, bevor auch nur eine Stunde gearbeitet wurde.",
            "title": "Auftragsinformationen erreichen das Feld nicht rechtzeitig"
          },
          {
            "body": "Wenn Mitarbeitende ihre Stunden am Ende des Tages manuell eintragen — sofern sie sie überhaupt eintragen — landen die Stunden auf dem falschen Auftrag oder verschwinden ganz. Die Rechnungen stimmen nicht mit der Realität überein.",
            "title": "Stunden sind nicht mit dem richtigen Projekt verknüpft"
          },
          {
            "body": "Ohne einen Live-Countdown der verbleibenden Stunden pro Projekt erfahren Sie erst beim Abschluss der Rechnung, dass ein Auftrag überzogen wurde — nicht, solange Sie noch reagieren können.",
            "title": "Budgetüberschreitungen zu spät erkannt"
          },
          {
            "body": "Subunternehmer, die auf derselben Baustelle arbeiten, nutzen unterschiedliche Systeme, tragen Stunden separat oder gar nicht ein. Der Abgleich zum Monatsende ist ein langsamer, fehleranfälliger Prozess.",
            "title": "Subunternehmerstunden schwer zu erfassen"
          }
        ],
        "quote": {
          "who": "Inhaber, Installationsbetrieb · 6 Mitarbeitende",
          "text": "Stunden landen automatisch auf dem richtigen Projekt. Die Projektkalkulation ist plötzlich einfach — wir sehen die echte Marge, bevor wir einen Auftrag abschließen.",
          "result": "Echte Kosten pro Auftrag, live"
        },
        "stats": [
          {
            "label": "Ansicht der verbleibenden Stunden pro Projekt",
            "value": "Echtzeit"
          },
          {
            "label": "Anrufe ins Büro nach Baustellenadressen",
            "value": "0"
          },
          {
            "label": "Navigation zu jeder Projektadresse aus der App",
            "value": "1 Klick"
          }
        ],
        "features": [
          {
            "body": "Mitarbeitende öffnen das Projekt auf ihrem Telefon: Adresse, geplante Stunden, Ansprechpartner und hochgeladene Dateien (Pläne, Anleitungen, PDFs). Alles, was sie brauchen, ist da, bevor sie ankommen.",
            "plan": "Project Basic",
            "title": "Projektinformationen direkt in die App geteilt"
          },
          {
            "body": "Tippen Sie einmal und das Telefon navigiert zur Projektadresse — in die App integriert, keine separate Karten-App nötig.",
            "title": "Navigation zum Standort per Knopfdruck"
          },
          {
            "body": "Legen Sie beim Eröffnen des Projekts die geplanten Stunden fest. Mitarbeitende sehen, wie viele Stunden übrig sind; Sie sehen den Live-Status in Ihrem Dashboard. Überschreitungen sind sichtbar, bevor sie eintreten.",
            "plan": "Project Basic",
            "title": "Countdown der verbleibenden Stunden pro Projekt"
          },
          {
            "body": "Jeder Mitarbeitende checkt am richtigen Projekt ein. Sie wissen immer, wer gerade an welchem Standort ist.",
            "plan": "Project Basic",
            "title": "Mitarbeiter-Check-in pro Projekt"
          },
          {
            "body": "Wenn der Umfang vor Ort wächst, erfassen Mitarbeitende zusätzliche Arbeiten und Materialien in Echtzeit — mit Text und Fotos — sodass nichts aus dem Gedächtnis abgerechnet wird.",
            "plan": "Project Basic",
            "title": "Erfassung zusätzlicher Arbeiten & Materialien"
          }
        ],
        "headline": "Zeiterfassung für Installationsteams — Projektstunden, Navigation und Budgetkontrolle in einer App",
        "workflow": [
          {
            "body": "Adresse, Kontakt, Umfang und Datei-Uploads sind direkt vorhanden. Sie navigieren mit einem Tippen — keine Anrufe ins Büro nach dem Weg.",
            "step": "Mitarbeitender öffnet das Projekt auf seinem Telefon"
          },
          {
            "body": "Der Check-in verknüpft jede geleistete Minute mit dem korrekten Projekt. Das verbleibende Budget aktualisiert sich in Echtzeit.",
            "step": "Stunden werden automatisch dem richtigen Auftrag zugeordnet"
          },
          {
            "body": "Umfangsänderungen, zusätzliche Materialien und Verzögerungen werden in dem Moment, in dem sie anfallen, mit Text und Fotos erfasst — bereit für die Rechnung.",
            "step": "Zusätzliche Arbeiten werden vor Ort erfasst"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Installationsteams standortverifizierten Check-in pro Projekt, einen Live-Countdown der verbleibenden Stunden und automatischen Lohnexport — und deckt damit jede lokale Anforderung an die Zeiterfassung ab. Für Teams, die auf belgischen Baustellen arbeiten, lässt es sich zudem mit CheckIn@Work integrieren.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeiterfassung",
          "title": "Projektbezogener standortverifizierter Check-in für Installationsteams"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Außendienst",
        "slug": "field-service",
        "intro": "Techniker, die mehrere Kunden am Tag besuchen, Belege in Handschuhfächern, Kilometer aus dem Gedächtnis erfasst. Done-it erfasst Stunden, Kilometer und Spesen im Feld — dem richtigen Auftrag zugeordnet in dem Moment, in dem sie anfallen.",
        "pains": [
          {
            "body": "Techniker zu bitten, ihre Routen am Ende der Woche zu rekonstruieren, bedeutet ungenaue Erstattungen, Streitigkeiten mit Kunden und einen wachsenden Stapel nicht abgerechneter Kilometer.",
            "title": "Kilometer erst Tage später erfasst — wenn überhaupt"
          },
          {
            "body": "Ein Beleg im Handschuhfach ist eine Kostenposition, die es vielleicht nie in eine Rechnung schafft. Die echten Kosten pro Auftrag sind immer zu niedrig angesetzt.",
            "title": "Spesen auf Papierbelegen, die verschwinden"
          },
          {
            "body": "Ohne Live-Check-ins erfahren Sie erst, wo ein Techniker ist, wenn etwas schiefgeht und jemand anruft.",
            "title": "Keine Echtzeit-Ansicht, wo das Team ist"
          },
          {
            "body": "Wenn Arbeit, Anfahrt und Spesen in separaten Systemen erfasst werden — oder gar nicht — gibt es nie eine einzige Kostenzahl pro Auftrag.",
            "title": "Schwer, die tatsächliche Marge pro Auftrag zu sehen"
          }
        ],
        "quote": {
          "who": "Betriebsleiter, Außendienstunternehmen · 11 Mitarbeitende",
          "text": "Die Kilometer waren früher ein monatliches Ärgernis. Jetzt protokolliert es sich von selbst — jeder Kilometer ist dem richtigen Kunden zugeordnet, bevor wir überhaupt wieder im Büro sind.",
          "result": "Präzise Kosten pro Auftrag, jedes Mal"
        },
        "stats": [
          {
            "label": "Kilometererfassung — kein manuelles Fahrtenbuch",
            "value": "Automatisch"
          },
          {
            "label": "Kosten pro Auftrag: Stunden + Anfahrt + Spesen",
            "value": "Live"
          },
          {
            "label": "verlorene Kilometer — jede Fahrt automatisch erfasst",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS protokolliert Abfahrt, Ankunft und exakte Distanz pro Fahrt. Konfigurieren Sie Transportarten (eigenes Auto, Firmenfahrzeug, Fahrgemeinschaft) mit jeweils eigenen Erstattungssätzen. Kein manuelles Fahrtenbuch.",
            "plan": "Add-on",
            "title": "Automatische Kilometererfassung (Trax-it)"
          },
          {
            "body": "Mitarbeitende fotografieren einen Beleg im Feld; er wird dem Auftrag zugeordnet und ist erstattungsbereit — und wird nicht zum Monatsende hinterhergejagt.",
            "plan": "Time Basic",
            "title": "Spesenverwaltung vor Ort"
          },
          {
            "body": "Stunden, Kilometer und Spesen werden in Echtzeit gegen den Auftrag aufsummiert. Die Kosten pro Auftrag sind sichtbar, solange der Auftrag noch offen ist.",
            "plan": "Project Basic",
            "title": "Projektgebundene Kostenkontrolle"
          },
          {
            "body": "Jeder Techniker checkt am Kundenstandort ein. Sie sehen, wer gerade wo ist — keine Anrufe, kein Rätselraten.",
            "title": "Standortverifizierter Check-in und Live-Teamübersicht"
          },
          {
            "body": "Stunden und Kilometererstattungen werden sauber für Ihren Lohnabrechnungsanbieter exportiert — mit Ihren konfigurierten Kilometersätzen, die automatisch angewendet werden.",
            "title": "Lohnexport mit einem Klick"
          }
        ],
        "headline": "Zeiterfassung für Außendienstteams — Kilometer, Spesen und Stunden von unterwegs, alles in einer App",
        "workflow": [
          {
            "body": "Der Check-in startet das Fahrtenprotokoll. Kilometer werden automatisch von der Abfahrt bis zur Ankunft erfasst — keine manuelle Eingabe.",
            "step": "Techniker fährt zum ersten Einsatz los"
          },
          {
            "body": "Die Stunden werden mit dem richtigen Projekt verknüpft. Zusätzliche Arbeiten, Materialien und Belege werden in dem Moment in der App erfasst, in dem sie anfallen.",
            "step": "Am Einsatzort"
          },
          {
            "body": "Jede Stunde, jeder Kilometer und jede Spesenposition ist bereits dem korrekten Auftrag zugeordnet. Exportieren Sie in die Lohnabrechnung und Rechnung mit echten Kostenzahlen.",
            "step": "Monatsende ohne Chaos"
          }
        ],
        "compliance": {
          "body": "Done-it erfasst Kilometer automatisch pro Fahrt, wendet Ihre konfigurierten Erstattungssätze an und protokolliert jeden Kilometer beim richtigen Kunden oder Projekt. Das EU-Urteil Tyco bedeutet, dass die Fahrt von zu Hause zum ersten Kunden als Arbeitszeit zählt — Done-it erfasst auch das.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Digitale Zeit- & Kilometererfassung",
          "title": "GPS-Stunden und automatische Kilometer für Außendienstteams"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "Heizung-Lüftung-Klima",
        "slug": "hvac",
        "intro": "Jeder Serviceeinsatz hat drei Kostenarten: Arbeit, Teile und Anfahrt. Done-it erfasst alle drei im Feld und summiert sie gegen den richtigen Auftrag — sodass Sie Ihre Marge kennen, bevor Sie die Rechnung abschließen.",
        "pains": [
          {
            "body": "Arbeit, Teile und Anfahrt liegen in verschiedenen Systemen — oder in verschiedenen Taschen. Die echten Kosten eines Einsatzes werden erst lange klar, nachdem der Techniker den Standort verlassen hat.",
            "title": "Serviceeinsätze sind schwer präzise zu kalkulieren"
          },
          {
            "body": "Wenn ein Kunde anficht, wie lange eine Reparatur gedauert hat, ist ein Papier-Stundenzettel leicht anzufechten. GPS-bestätigte Check-in- und Check-out-Zeitstempel sind es nicht.",
            "title": "Kein Nachweis der Servicezeit"
          },
          {
            "body": "Bei wiederkehrenden Wartungsverträgen summieren sich kleine Überschreitungen über viele Einsätze. Ohne einen Live-Stundenzähler erfahren Sie erst bei der Verlängerung, dass der Vertrag unter Wasser steht.",
            "title": "Wartungsverträge zehren still an der Marge"
          },
          {
            "body": "Manuelle Zeiteinträge übersehen Pausen, was zu Überbezahlung und einer Lohnabrechnung führt, die nicht mit der Realität übereinstimmt.",
            "title": "Techniker vergessen, Pausen zu erfassen"
          }
        ],
        "quote": {
          "who": "Inhaber, Heizung-Lüftung-Klima-Unternehmen · 7 Techniker",
          "text": "Wir wissen endlich, was uns jeder Servicevertrag tatsächlich kostet. Die Margenüberraschungen hörten an dem Tag auf, an dem wir Done-it einsetzten.",
          "result": "Echte Kosten pro Serviceeinsatz, live"
        },
        "stats": [
          {
            "label": "erfasste Kostenarten pro Einsatz: Arbeit, Anfahrt, Teile",
            "value": "3"
          },
          {
            "label": "Margentransparenz pro Servicevertrag",
            "value": "Live"
          },
          {
            "label": "Überraschungen bei der Rechnungsstellung — Kosten in Echtzeit sichtbar",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Jeder Serviceeinsatz oder Wartungsvertrag ist ein Projekt. Stunden, Anfahrt und Materialien werden in Echtzeit aufsummiert — und geben Ihnen Live-Einblick in die Marge.",
            "plan": "Project Basic",
            "title": "Projektbasierte Zeiterfassung"
          },
          {
            "body": "Wenn ein Auftrag wächst, erfassen Techniker zusätzliche Arbeiten und Teile mit Text und Fotos, bevor sie gehen. Nichts wird aus dem Gedächtnis abgerechnet.",
            "plan": "Project Basic",
            "title": "Zusätzliche Arbeiten und Materialien, vor Ort erfasst"
          },
          {
            "body": "Kilometer pro Einsatz werden automatisch protokolliert und dem Auftrag zugerechnet. Konfigurieren Sie Erstattungssätze pro Fahrzeugtyp.",
            "plan": "Add-on",
            "title": "Kilometer und Transportkosten"
          },
          {
            "body": "Vorgeschriebene Pausen werden automatisch von der Gesamtzeit abgezogen — keine Streitigkeiten, keine Lohnfehler.",
            "title": "Automatischer Pausenabzug"
          },
          {
            "body": "Mit Zeitstempel versehener, GPS-bestätigter Check-in an jedem Standort. Unanfechtbarer Nachweis, wann der Techniker ankam und ging.",
            "title": "Standortverifizierter Check-in und Anwesenheitsnachweis"
          }
        ],
        "headline": "Zeiterfassung für Heizungs-, Lüftungs- und Klimatechniker — Projektkalkulation, Teile und Anfahrt in einer App",
        "workflow": [
          {
            "body": "GPS versieht die Ankunft mit einem Zeitstempel und verknüpft die Stunden mit dem Serviceeinsatz oder Wartungsvertrag. Kein Papier, kein Terminal.",
            "step": "Techniker checkt am Standort ein"
          },
          {
            "body": "Verwendete Teile, zusätzliche Stunden und Umfangsänderungen werden in der App mit Fotos erfasst — bevor der Standort verlassen wird.",
            "step": "Zusätzliche Arbeiten werden direkt vor Ort erfasst"
          },
          {
            "body": "Arbeit, Anfahrt und Materialien summieren sich in Echtzeit gegen das Projekt. Sie sehen die Marge, bevor Sie die Rechnung ausstellen.",
            "step": "Auftragskosten sofort sichtbar"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Heizung-Lüftung-Klima-Teams standortverifizierten Check-in pro Serviceeinsatz, Live-Kostentransparenz pro Auftrag (Arbeit + Anfahrt + Teile) und einen sauberen Lohnexport — und erfüllt jede lokale Anforderung an die Zeiterfassung ohne zusätzliche Hardware.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeit- & Kostenerfassung",
          "title": "Vollständige Auftragskalkulation für Heizung-Lüftung-Klima-Serviceeinsätze"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektriker",
        "slug": "electricians",
        "intro": "Stunden pro Projekt, ein Live-Countdown des verbleibenden Budgets und Navigation zum Standort per Knopfdruck — entwickelt für kleine Elektroteams, die Projektkontrolle ohne Verwaltungsaufwand brauchen.",
        "pains": [
          {
            "body": "Wenn Elektriker in einer Woche über mehrere Aufträge hinweg arbeiten, führt die manuelle Zuordnung der Stunden am Ende des Tages zu falsch zugeordneten Kosten, Abrechnungsstreitigkeiten und einer Lohnabrechnung, die Sie nicht erklären können.",
            "title": "Stunden sind nicht mit dem richtigen Projekt verknüpft"
          },
          {
            "body": "Ohne eine Live-Ansicht der verbrauchten vs. budgetierten Stunden erfahren Sie erst bei der Rechnungsstellung, dass ein Projekt überzogen wurde — nicht, als Sie noch hätten reagieren können.",
            "title": "Budgetüberschreitungen zu spät erkannt"
          },
          {
            "body": "Adressen in eine separate App getippt, Anrufe ins Büro nach dem Weg, verspätete Ankünfte an Kundenstandorten. Jede verschwendete Minute ist eine verlorene abrechenbare Minute.",
            "title": "Zeit verschwendet bei der Standortsuche"
          },
          {
            "body": "Bei größeren Installationen erfassen Subunternehmer-Elektriker ihre eigenen Stunden separat. Eine kombinierte Ansicht der Arbeitskosten am Ende eines Projekts zu erhalten, ist eine manuelle, fehleranfällige Aufgabe.",
            "title": "Subunternehmerstunden schwer abzugleichen"
          }
        ],
        "quote": {
          "who": "Inhaber, Elektrounternehmen · 5 Elektriker",
          "text": "Wir wissen in Echtzeit, ob ein Projekt das Budget überschreitet. Allein das hat uns dieses Jahr vor zwei bösen Überraschungen bewahrt.",
          "result": "Budgetüberschreitungen erkannt, bevor sie eintreten"
        },
        "stats": [
          {
            "label": "Ansicht der verbleibenden Stunden pro Projekt",
            "value": "Live"
          },
          {
            "label": "Anrufe ins Büro nach Baustellenadressen",
            "value": "0"
          },
          {
            "label": "zum Einchecken an jedem Standort — kein Terminal nötig",
            "value": "1 Tippen"
          }
        ],
        "features": [
          {
            "body": "Jede geleistete Minute wird automatisch mit dem richtigen Projekt verknüpft. Ein Live-Countdown zeigt, wie viele Stunden gegen das Budget übrig sind — für Sie und für den Mitarbeitenden vor Ort.",
            "plan": "Project Basic",
            "title": "Projektstunden mit Live-Restbudget"
          },
          {
            "body": "Die Projektadresse ist in der App. Ein Tippen öffnet die Navigation — kein Suchen, keine separate Karten-App, keine Anrufe ins Büro.",
            "title": "Navigation zum Standort per Knopfdruck"
          },
          {
            "body": "Jeder Elektriker checkt am richtigen Auftrag ein. Sie wissen immer, wer gerade an welchem Standort ist.",
            "plan": "Project Basic",
            "title": "Mitarbeiter-Check-in pro Projekt"
          },
          {
            "body": "Wenn sich der Umfang ändert — ein unerwarteter Stromkreis, zusätzliche Materialien — wird es in der App mit Fotos erfasst, bevor das Team geht.",
            "plan": "Project Basic",
            "title": "Zusätzliche Arbeiten vor Ort erfasst"
          },
          {
            "body": "Überstunden werden in dem Moment erfasst, in dem sie anfallen. Mitarbeitende wählen, ob sie ausgezahlt oder in Freizeit umgewandelt werden.",
            "plan": "Time Pro",
            "title": "Überstundenerfassung mit flexibler Vergütung"
          }
        ],
        "headline": "Zeiterfassung für Elektriker — Stunden pro Projekt, Budgetkontrolle und Navigation in einer App",
        "workflow": [
          {
            "body": "Adresse und Umfang sind bereits in der App. Ein Tippen öffnet die Navigation — keine Anrufe, keine Verwirrung.",
            "step": "Elektriker navigiert zum Auftrag"
          },
          {
            "body": "Der Check-in am Standort verknüpft jede geleistete Minute mit dem korrekten Projekt. Der Reststundenzähler aktualisiert sich live.",
            "step": "Stunden werden automatisch dem richtigen Projekt zugeordnet"
          },
          {
            "body": "Zusätzliche Arbeiten und Materialien werden vor Ort erfasst, bevor man geht. Die Rechnung spiegelt wider, was tatsächlich geschah.",
            "step": "Umfangsänderungen bleiben in der Aufzeichnung"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Elektrikern projektbezogenen standortverifizierten Check-in, ein Live-Stundenbudget und Lohnexport — und erfüllt jede lokale Anforderung an die Zeiterfassung. Für Teams auf belgischen Baustellen lässt es sich zudem mit CheckIn@Work integrieren.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Projektbezogener standortverifizierter Check-in",
          "title": "Live-Budgetkontrolle und standortverifizierter Check-in für Elektroteams"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Sanitär",
        "slug": "plumbing",
        "intro": "Notdiensteinsätze, mehrere Aufträge pro Tag, Stunden am Ende der Woche aus dem Gedächtnis eingetragen — oder gar nicht. Done-it macht daraus an jedem Standort eine Sache von einem Tippen und zum Monatsende eine Lohnabrechnung mit einem Klick.",
        "pains": [
          {
            "body": "Bei mehreren Aufträgen an einem Tag haben Installateure selten Zeit, präzise Stundenzettel auszufüllen. Stunden werden gerundet oder vergessen, und die Lohnabrechnung ist bestenfalls eine Schätzung.",
            "title": "Einsatzstunden aus dem Gedächtnis rekonstruiert"
          },
          {
            "body": "Wenn ein Kunde anficht, wie lange eine Reparatur gedauert hat, gibt es keine objektive Aufzeichnung. Ein GPS-bestätigter digitaler Check-in lässt sich leicht vorlegen — ein Papier-Stundenzettel nicht.",
            "title": "Kein Nachweis der Zeit vor Ort"
          },
          {
            "body": "Die Fahrten zwischen Einsätzen summieren sich über die Woche und den Monat, aber ohne automatische Erfassung werden sie selten korrekt abgerechnet oder erstattet.",
            "title": "Kilometer zwischen Aufträgen nicht erfasst"
          },
          {
            "body": "Zum Monatsende kostet das Hinterherjagen von Stundenzetteln, das Korrigieren von Fehlern und das Erstellen des Lohnexports Zeit, die Ihr Verwaltungsteam nicht aufwenden sollte.",
            "title": "Die Lohnvorbereitung ist langsam"
          }
        ],
        "quote": {
          "who": "Inhaber, Sanitärunternehmen · 4 Installateure",
          "text": "Wir haben früher zum Monatsende einen ganzen Vormittag damit verbracht, Stunden zu rekonstruieren. Jetzt exportieren und senden wir einfach. Der Lohnabrechnungsanbieter bekommt es sauber.",
          "result": "Lohnvorbereitung von Stunden auf Minuten reduziert"
        },
        "stats": [
          {
            "label": "zum Einchecken — schnell genug für Notrufe",
            "value": "1 Tippen"
          },
          {
            "label": "Lohnexport an Ihren Anbieter",
            "value": "1 Klick"
          },
          {
            "label": "aus dem Gedächtnis rekonstruierte Stunden zum Monatsende",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ankunft und Abfahrt mit einem Tippen erfasst, mit Standortverifizierung des Standorts. Schnell genug für Notrufe; präzise genug für Streitigkeiten.",
            "plan": "Time Basic",
            "title": "Standortverifizierter Check-in mit einem Tippen bei jedem Einsatz"
          },
          {
            "body": "Vorgeschriebene Pausen werden automatisch von der Gesamtzeit abgezogen — nichts auszufüllen, keine Lohnfehler.",
            "plan": "Time Basic",
            "title": "Automatischer Pausenabzug"
          },
          {
            "body": "Konfigurieren Sie Transportarten und Erstattungssätze. Kilometer werden automatisch protokolliert und mit dem richtigen Kunden oder Projekt verknüpft.",
            "plan": "Add-on",
            "title": "Kilometer pro Fahrt erfasst"
          },
          {
            "body": "Mitarbeitende reichen Krankmeldungen digital aus der App ein. Erstellen Sie die Abwesenheitsarten, die Ihr Team tatsächlich nutzt, einschließlich wetterbedingter Verzögerungen.",
            "title": "Abwesenheits- und Krankmeldungsverwaltung"
          },
          {
            "body": "Alle Stunden- und Kilometerdaten werden sauber für Ihren Lohnabrechnungsanbieter exportiert — keine manuelle Vorbereitung, kein Excel.",
            "plan": "Time Basic",
            "title": "Lohnexport mit einem Klick"
          }
        ],
        "headline": "Zeiterfassung für Sanitärteams — schneller Check-in, präzise Lohnabrechnung und Anwesenheitsnachweis für jeden Einsatz",
        "workflow": [
          {
            "body": "Ein Tippen checkt ein. GPS protokolliert Standort und Zeit. Schnell genug für einen Notfalleinsatz.",
            "step": "Installateur kommt beim Einsatz an"
          },
          {
            "body": "Der Check-out schließt den Zeiteintrag. Die Kilometer zum nächsten Auftrag beginnen automatisch zu protokollieren.",
            "step": "Abfahrt beim Gehen angetippt"
          },
          {
            "body": "Alle Einsätze, Stunden und Kilometer werden sauber exportiert. Die Lohnvorbereitung geht von einem Tag auf Minuten zurück.",
            "step": "Monatsende mit einem Klick"
          }
        ],
        "compliance": {
          "body": "Done-it deckt jede lokale Anforderung an die Zeiterfassung für Sanitärteams ab — standortverifizierter Check-in mit einem Tippen pro Einsatz, automatischer Pausenabzug und ein sauberer Lohnexport. Keine Papier-Stundenzettel, keine manuelle Rekonstruktion.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeiterfassung",
          "title": "Schneller standortverifizierter Check-in für jeden Einsatz"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Garten- und Landschaftsbau",
        "slug": "landscaping",
        "intro": "Hochsaison bedeutet viele Standorte, wechselnde Teams und viele Kilometer. Done-it hält jede Stunde, jede Abwesenheit und jede Fahrt organisiert — sodass Sie sich auf die Arbeit konzentrieren können, nicht auf den Papierkram.",
        "pains": [
          {
            "body": "Befristete Mitarbeitende, wechselnde Pläne und unterschiedliche Teamgrößen machen eine präzise Stundenerfassung mit Papier nahezu unmöglich. Wenn Sie zum Monatsende abgleichen, fehlt immer etwas.",
            "title": "Saisonteams sind komplex zu verwalten"
          },
          {
            "body": "Ein Team, das drei oder vier Standorte pro Tag besucht, erzeugt Stunden, die korrekt aufgeteilt werden müssen. Manuelle Eingabe führt zu Fehlzuordnungen und angefochtener Lohnabrechnung.",
            "title": "Stunden über viele Standorte verteilt"
          },
          {
            "body": "Schlechtwetterstillstand ist im Garten- und Landschaftsbau ein reales Ereignis. Ohne eine digitale Aufzeichnung ist das Dokumentieren von Ausfällen und das Anpassen der Bezahlung langsam und fehleranfällig.",
            "title": "Wetterbedingte Ausfälle sind schwer zu dokumentieren"
          },
          {
            "body": "Firmentransporter, Privatfahrzeuge und Fahrgemeinschaften kreuzen den ganzen Tag zwischen den Standorten. Ohne automatische Erfassung schaffen es diese Kilometer nie in das Kostenbild.",
            "title": "Kilometer zwischen Standorten bleiben unerfasst"
          }
        ],
        "quote": {
          "who": "Inhaber, Garten- und Landschaftsbauunternehmen · 12 Saisonkräfte",
          "text": "Die Hochsaison bedeutete früher Lohnchaos. Jetzt prüft unser Vorarbeiter die App, jeder ist erfasst, und ich exportiere die Stunden am letzten Tag des Monats.",
          "result": "Keine Lohnrekonstruktion zum Monatsende mehr"
        },
        "stats": [
          {
            "label": "Kilometererfassung — kein Fahrtenbuch mehr",
            "value": "Automatisch"
          },
          {
            "label": "Teamübersicht über alle Standorte",
            "value": "Live"
          },
          {
            "label": "Lohnexport für alle Standorte und alle Teams",
            "value": "1 Klick"
          }
        ],
        "features": [
          {
            "body": "Sehen Sie alle Teams, alle Standorte in Echtzeit. Wissen Sie, wer gerade wo arbeitet — nicht erst zum Monatsende.",
            "title": "Teamübersicht über mehrere Standorte"
          },
          {
            "body": "Planen Sie, wer wo arbeitet, handhaben Sie kurzfristige Änderungen und übertragen Sie den Plan auf die Telefone des Teams — ohne einen Anruf bei jeder Person.",
            "plan": "Time Pro",
            "title": "Schichtplanung für Saisonteams"
          },
          {
            "body": "Erstellen Sie individuelle Abwesenheitsarten für Ihre Branche: saisonale Wetterausfälle, Elternzeit, Krankheitstage. Mitarbeitende laden die Dokumentation digital aus der App hoch.",
            "title": "Individuelle Abwesenheitsarten"
          },
          {
            "body": "Konfigurieren Sie Transportarten (Firmentransporter, Privatauto, Fahrgemeinschaft Fahrer vs. Beifahrer) mit jeweils eigenen Sätzen. Kilometer werden automatisch pro Fahrt protokolliert.",
            "plan": "Add-on",
            "title": "Kilometer mit Fahrgemeinschaftserfassung"
          },
          {
            "body": "Überstunden in der Hochsaison summieren sich schnell. Jeder Mitarbeitende kann wählen, sich auszahlen zu lassen oder die Stunden als Freizeit anzusparen — transparent erfasst.",
            "plan": "Time Pro",
            "title": "Überstundenerfassung mit Umwandlung in Urlaub"
          }
        ],
        "headline": "Zeiterfassung für Garten- und Landschaftsbauunternehmen — Saisonteams, mehrere Standorte und Kilometer in einer Übersicht",
        "workflow": [
          {
            "body": "GPS protokolliert die Ankunft. Stunden werden automatisch auf den richtigen Standort und das richtige Projekt aufgeteilt — keine manuelle Zuordnung am Ende des Tages.",
            "step": "Team checkt am ersten Standort ein"
          },
          {
            "body": "Der Vorarbeiter erfasst den Ausfall aus der App — eine saubere digitale Aufzeichnung, kein zusätzlicher Papierkram.",
            "step": "Wetter stoppt die Arbeit"
          },
          {
            "body": "Stunden, Abwesenheiten und Kilometer über jeden Standort und jedes Teammitglied hinweg werden sauber für die Lohnabrechnung exportiert.",
            "step": "Monatsende: alle Standorte, alle Teams, ein Export"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Garten- und Landschaftsbauteams digitale Zeiterfassung über alle Standorte und Saisonkräfte hinweg — standortverifizierter Check-in, individuelle Abwesenheitsarten für Wetterausfälle und ein sauberer Lohnexport, der jede lokale Anforderung erfüllt.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeiterfassung",
          "title": "Standortverifizierter Check-in und Abwesenheitserfassung für Saison-Landschaftsbauteams"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Wartung",
        "slug": "maintenance",
        "intro": "Wiederkehrende Wartungsverträge stehen und fallen mit der Kostentransparenz. Done-it protokolliert jeden Besuch, erfasst die Stunden gegen das Vertragsbudget und gibt Ihnen — und Ihren Kunden — einen Anwesenheitsnachweis für jeden Einsatz.",
        "pains": [
          {
            "body": "Wenn die Stunden für wiederkehrende Besuche nicht gegen den spezifischen Vertrag erfasst werden, wissen Sie erst beim Jahresendreview, ob ein Kunde rentabel ist — und zu diesem Zeitpunkt ist es zu spät für eine Neukalkulation.",
            "title": "Keine Kostentransparenz pro Wartungsvertrag"
          },
          {
            "body": "Facility-Manager und Immobilieneigentümer wünschen sich zunehmend Anwesenheitsaufzeichnungen: wer kam, wann er ankam, was er tat. Ein Papierprotokoll, das Wochen später vorgelegt wird, erfüllt keine SLA-Anforderungen.",
            "title": "Kunden erwarten einen Nachweis darüber, was getan wurde"
          },
          {
            "body": "Rotierende Schichten über viele wiederkehrende Standorte hinweg — mit Personal, das sich gegenseitig vertritt — schaffen ein Planungs- und Stundenerfassungs-Puzzle, das manuelle Prozesse nicht zuverlässig lösen können.",
            "title": "Wiederkehrende Besuche schwer zu planen und zu protokollieren"
          },
          {
            "body": "Grünflächenpflege, Fassadenwartung und Außenanlagenarbeiten sind alle von wetterbedingten Ausfällen betroffen. Sie korrekt zu dokumentieren erfordert einen digitalen Nachweis.",
            "title": "Wetterbedingte Ausfälle betreffen auch die Außenwartung"
          }
        ],
        "quote": {
          "who": "Betriebsleiter, Wartungsunternehmen · 8 Mitarbeitende",
          "text": "Wir können einem Facility-Manager in zwei Minuten genau sagen, wer wann vor Ort war. Dieses Maß an Nachweis hat verändert, wie Kunden uns sehen.",
          "result": "Kundenstreitigkeiten auf null reduziert"
        },
        "stats": [
          {
            "label": "Kosten pro Wartungsvertrag",
            "value": "Live"
          },
          {
            "label": "Anwesenheitsnachweis, auf Anfrage bereit für Kunden",
            "value": "GPS"
          },
          {
            "label": "Vertragsverlängerungen, ohne Ihre Marge zu kennen",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Jeder Wartungsvertrag ist ein Projekt. Die Stunden werden automatisch dagegen protokolliert und geben Ihnen eine Live-Kostenzahl und einen Reststunden-Countdown für jeden Kunden.",
            "plan": "Project Basic",
            "title": "Vertragsbasierte Kostenerfassung"
          },
          {
            "body": "Mit Zeitstempel versehene, standortverifizierte Check-ins sind eine unanfechtbare Aufzeichnung darüber, wer wann und wie lange vor Ort war — bereit, auf Anfrage mit Kunden geteilt zu werden.",
            "title": "GPS-bestätigter Anwesenheitsnachweis"
          },
          {
            "body": "Mitarbeitende melden Probleme, erledigte Aufgaben oder zusätzliche Arbeiten direkt aus der App — mit Text und Fotos. Kunden erhalten eine Echtzeit-Aufzeichnung; Sie haben die Dokumentation für die Abrechnung.",
            "plan": "Project Basic",
            "title": "Updates mit Fotos vom Standort"
          },
          {
            "body": "Planen Sie wiederkehrende Besuche über alle Verträge hinweg, weisen Sie Mitarbeitende zu und handhaben Sie Vertretungen — ohne einen Anruf bei jeder Person.",
            "plan": "Time Pro",
            "title": "Planung wiederkehrender Schichten"
          },
          {
            "body": "Konfigurieren Sie Wetterausfälle und andere Abwesenheitsarten. Mitarbeitende erfassen sie aus der App; die Dokumentation wird digital hochgeladen.",
            "title": "Abwesenheitsarten für die Außenwartung"
          }
        ],
        "headline": "Zeiterfassung für Wartungsteams — wiederkehrende Standortbesuche, Kosten pro Vertrag und Anwesenheitsnachweis in einer App",
        "workflow": [
          {
            "body": "Der standortverifizierte Check-in protokolliert die Ankunftszeit und verknüpft die Stunden mit dem korrekten Vertrag. Der Anwesenheitsnachweis wird automatisch erstellt.",
            "step": "Mitarbeitender kommt am Wartungsstandort an"
          },
          {
            "body": "Erledigte Arbeiten und etwaige Probleme werden aus der App mit Fotos gemeldet. Kunden können genau sehen, was getan wurde.",
            "step": "Aufgaben erledigt, Probleme protokolliert"
          },
          {
            "body": "Stunden summieren sich in Echtzeit gegen das Vertragsbudget. Sie kennen die Marge, bevor der Vertrag verlängert wird.",
            "step": "Kosten pro Vertrag sofort sichtbar"
          }
        ],
        "compliance": {
          "body": "Done-it gibt Wartungsteams GPS-bestätigten Anwesenheitsnachweis pro Vertrag, individuelle Abwesenheitsarten und eine Live-Kostenansicht pro wiederkehrendem Kunden — und erfüllt jede lokale Anforderung an die Zeiterfassung ohne zusätzliche Hardware.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Vertragsbasierte Zeiterfassung",
          "title": "Live-Kostentransparenz pro Wartungsvertrag"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Geschäfte & Einzelhandel",
        "slug": "retail",
        "intro": "Frühschichten, Spätschichten und ständig vertritt jemand jemanden. Done-it gibt jedem Geschäft eine saubere digitale Aufzeichnung darüber, wer welche Schicht gearbeitet hat – erfasst über das eigene Handy, zum Monatsende fertig für die Lohnabrechnung.",
        "pains": [
          {
            "body": "Jemand vertritt eine kranke Kollegin, jemand bleibt zum Feierabend eine Stunde länger. Das landet auf einem Zettel oder gar nicht – und die Lohnabrechnung stimmt schon nicht, bevor Sie anfangen.",
            "title": "Schichttausch kommt nie in der Lohnabrechnung an"
          },
          {
            "body": "Mitarbeitende wechseln zwischen Filialen, Teilzeitkräfte arbeiten an zwei Standorten. Stunden je Geschäft zu sammeln und von Hand zusammenzuführen kostet jeden Monat einen Tag.",
            "title": "Mehrere Geschäfte, eine Lohnabrechnung"
          },
          {
            "body": "Gesetzliche Pausen werden aus dem Gedächtnis abgezogen und Mehrstunden formlos geregelt – genau die zwei Punkte, nach denen eine Prüfung zuerst fragt.",
            "title": "Pausen und Überstunden bleiben Schätzung"
          }
        ],
        "quote": {
          "who": "Inhaber, Einzelhandel · 11 Mitarbeitende",
          "text": "Zwei Geschäfte und viele Teilzeitkräfte. Früher wurde die Hälfte der Vertretungsschichten aus dem Gedächtnis abgerechnet. Jetzt liegt jede Stunde auf dem richtigen Geschäft und die Lohnabrechnung dauert Minuten.",
          "result": "Lohnvorbereitung von einem Tag auf unter eine Stunde"
        },
        "stats": [
          {
            "label": "zum Einstempeln – kein Terminal an der Kasse",
            "value": "1 Tipp"
          },
          {
            "label": "Überblick, wer da ist – in jedem Geschäft",
            "value": "Live"
          },
          {
            "label": "Schichttausche gehen auf dem Weg zur Lohnabrechnung verloren",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ein Tippen auf dem eigenen Handy zum Schichtbeginn. Kein Terminal an der Kasse, keine gemeinsame Karte, kein Klemmbrett an der Lagertür.",
            "title": "Erfassung direkt auf der Fläche"
          },
          {
            "body": "Jedes Geschäft ist ein Projekt. Wer eine andere Filiale vertritt, erfasst seine Zeit auf diese Filiale – Sie sehen die Stunden dort, wo sie tatsächlich gearbeitet wurden.",
            "title": "Stunden je Geschäft, Personal über Filialen hinweg"
          },
          {
            "body": "Pausenregel einmal festlegen, sie gilt für jede Schicht. Überstunden werden erfasst, sobald sie entstehen, und jede Person wählt Auszahlung oder Freizeitausgleich.",
            "title": "Pausen automatisch abgezogen"
          }
        ],
        "headline": "Zeiterfassung für Geschäfte – Schichtbeginn, Vertretung und ein lohnfertiger Export in einer App",
        "workflow": [
          {
            "body": "Ein Tippen auf dem Handy zum Schichtbeginn. Vertretung in einer anderen Filiale wird auf diese Filiale gebucht.",
            "step": "Team stempelt zur Schicht ein"
          },
          {
            "body": "Ein Live-Überblick über alle Standorte – eine unbesetzte Frühschicht fällt auf, bevor geöffnet wird.",
            "step": "Sie sehen je Geschäft, wer da ist"
          },
          {
            "body": "Stunden, Pausen und Überstunden je Mitarbeitendem und je Geschäft, fertig exportiert für Ihren Lohndienstleister.",
            "step": "Lohnabrechnung in einem Export"
          }
        ],
        "compliance": {
          "body": "Done-it führt eine objektive digitale Aufzeichnung jeder Kommen- und Gehen-Buchung, inklusive Pausen und Überstunden – genau den Nachweis, den eine Prüfung oder ein Streit über die Lohnabrechnung verlangt.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Schichtbasierte Zeiterfassung",
          "title": "Ein belastbarer Nachweis über jede gearbeitete Schicht"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Büros & Dienstleistung",
        "slug": "offices",
        "intro": "Steuerberatungen, Notariate, Architekturbüros, Agenturen und Beratungen rechnen ihre Zeit ab – oder müssen zumindest wissen, wohin sie geflossen ist. Done-it erfasst Stunden auf dem richtigen Kunden und Projekt, vom Schreibtisch aus und unterwegs.",
        "pains": [
          {
            "body": "Zeit, die am Ende der Woche aufgeschrieben wird, ist geschätzte Zeit. Ganze Stunden verschwinden still zwischen der Arbeit und der Rechnung.",
            "title": "Abrechenbare Stunden, freitags rekonstruiert"
          },
          {
            "body": "Das Honorar wurde vor Monaten vereinbart. Ob die Arbeit noch hineinpasst, zeigt sich erst, wenn jemand nachrechnet – meist zu spät.",
            "title": "Niemand weiß, was ein Kunde wirklich kostet"
          },
          {
            "body": "Ein Teil des Teams sitzt im Büro, ein Teil zu Hause, ein Teil beim Kunden. Anwesenheit ist dann keine Tatsache mehr, sondern eine Rekonstruktion.",
            "title": "Hybrides Arbeiten macht den Nachweis lückenhaft"
          }
        ],
        "quote": {
          "who": "Partner, Steuerkanzlei · 8 Mitarbeitende",
          "text": "Früher haben wir jeden Freitag die Woche neu zusammengebaut. Jetzt liegen die Stunden schon auf dem richtigen Kunden und ich sehe, welche Akten das Honorar auffressen.",
          "result": "Jeden Monat zurückgewonnene abrechenbare Stunden"
        },
        "stats": [
          {
            "label": "Stunden, sichtbar während die Arbeit noch läuft",
            "value": "Je Kunde"
          },
          {
            "label": "derselbe Nachweis, Handy und Browser",
            "value": "Büro oder unterwegs"
          },
          {
            "label": "für Lohnabrechnung und Rechnungsstellung",
            "value": "1 Export"
          }
        ],
        "features": [
          {
            "body": "Jeder Eintrag landet auf einem Projekt. So sehen Sie die Stunden je Kunde, ohne etwas zu exportieren oder jemanden zu fragen.",
            "title": "Stunden auf Kunde und Projekt"
          },
          {
            "body": "Dieselbe App auf dem Handy oder im Browser. Ein Kundentermin zählt als Arbeit für diesen Kunden, auf Wunsch inklusive Fahrzeit.",
            "title": "Am Schreibtisch und außer Haus"
          },
          {
            "body": "Mehrstunden werden erfasst, sobald sie entstehen, Urlaub wird in der App beantragt und genehmigt – keine parallele Tabelle darüber, wer wann frei hat.",
            "title": "Überstunden und Urlaub an einem Ort"
          }
        ],
        "headline": "Zeiterfassung für Büros – Stunden je Kunde und Projekt, ohne Tabelle",
        "workflow": [
          {
            "body": "Einmal einrichten, mit dem Kunden und – wenn Sie nach Budget abrechnen – den geplanten Stunden.",
            "step": "Kundenprojekt anlegen"
          },
          {
            "body": "Vom Schreibtisch oder vom Handy. Jede Stunde landet auf einem Kunden, nicht im Gedächtnis.",
            "step": "Das Team bucht seine Zeit darauf"
          },
          {
            "body": "Live-Summen je Projekt und zum Monatsende ein sauberer Export für Lohnabrechnung oder Rechnungsstellung.",
            "step": "Stunden je Kunde sehen, für die Lohnabrechnung exportieren"
          }
        ],
        "compliance": {
          "body": "Done-it führt eine digitale, manipulationssichere Aufzeichnung der Arbeitszeit je Mitarbeitendem – die Grundlage für die Lohnabrechnung und für eine belastbare Kundenrechnung.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Zeiterfassung je Kunde",
          "title": "Ein objektiver Nachweis der geleisteten Arbeitszeit"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salons & Körperpflege",
        "slug": "beauty",
        "intro": "Friseursalons, Barbershops, Nagel- und Kosmetikstudios arbeiten mit Schichten und Teilzeitverträgen. Done-it erfasst, wer wann gearbeitet hat, zieht Pausen automatisch ab und übergibt der Lohnabrechnung eine saubere Datei.",
        "pains": [
          {
            "body": "Diese Woche drei Tage, nächste Woche vier, ein Samstag gegen einen Dienstag getauscht. Vereinbarte und tatsächlich geleistete Stunden laufen schnell auseinander.",
            "title": "Teilzeitverträge, endlose Varianten"
          },
          {
            "body": "Termine zeigen, was gebucht war, nicht wer gearbeitet hat. Wenn die Lohnabrechnung oder eine Prüfung fragt, ist das Buchungssystem die falsche Antwort.",
            "title": "Das Terminbuch ist keine Zeiterfassung"
          },
          {
            "body": "Für den letzten Kunden länger zu bleiben wird erinnert, versprochen und manchmal vergessen. Aus solchen Lücken werden Streitfälle.",
            "title": "Mehrstunden formlos geregelt"
          }
        ],
        "quote": {
          "who": "Inhaberin, Friseursalon · 6 Mitarbeitende",
          "text": "Alle arbeiten Teilzeit und jede Woche ist anders. Die App erfasst es einfach – ich baue den Monat nicht mehr in einer Tabelle nach.",
          "result": "Keine strittigen Stunden mehr zum Monatsende"
        },
        "stats": [
          {
            "label": "zum Einstempeln – nichts geteilt, nichts auf Papier",
            "value": "1 Tipp"
          },
          {
            "label": "Pausenabzug bei jeder Schicht",
            "value": "Auto"
          },
          {
            "label": "Überstunden, die aus dem Gedächtnis abgerechnet werden",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ein Tippen auf dem eigenen Handy zum Schichtbeginn – kein gemeinsames Terminal am Empfang, keine Unterschriftenliste am Spiegel.",
            "title": "Einstempeln im Salon"
          },
          {
            "body": "Pausenregel und Sollstunden einmal einstellen; sie gelten für jede Schicht, mit Ausnahmen pro Person, wo ein Vertrag abweicht.",
            "title": "Pausen und Teilzeitregeln einmal festlegen"
          },
          {
            "body": "Mehrstunden werden erfasst, während sie entstehen, und jede Person wählt Auszahlung oder Freizeitausgleich – geregelt in der App, nicht aus dem Gedächtnis.",
            "title": "Überstunden: auszahlen oder abfeiern"
          }
        ],
        "headline": "Zeiterfassung für Salons – Schichten, Teilzeitstunden und Lohnabrechnung ohne Terminbuch auf Papier",
        "workflow": [
          {
            "body": "Ein Tippen bei Ankunft. Pausen zieht die Regel ab, die Sie einmal festgelegt haben.",
            "step": "Team stempelt zur Schicht ein"
          },
          {
            "body": "Wer da ist, wer Pause macht, wer länger geblieben ist – live, ohne nachzufragen.",
            "step": "Sie sehen den Tag, während er läuft"
          },
          {
            "body": "Geleistete Stunden, Pausen und Überstunden je Mitarbeitendem, exportiert für Ihren Lohndienstleister.",
            "step": "Die Lohnabrechnung bekommt eine saubere Datei"
          }
        ],
        "compliance": {
          "body": "Done-it erfasst die tatsächliche Arbeitszeit je Mitarbeitendem, mit Pausen und Überstunden – getrennt von den Buchungen und belastbar, wenn geprüft wird.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digitale Zeiterfassung",
          "title": "Ein Nachweis, der über das Terminbuch hinausgeht"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Gesundheit & Wellness",
        "slug": "wellness",
        "intro": "Fitnessstudios, Kursstudios, Physiotherapiepraxen und Spas haben lange Öffnungszeiten und wechselndes Personal. Done-it erfasst, wer welche Schicht übernommen hat, zieht Pausen automatisch ab und exportiert die Lohnabrechnung sauber.",
        "pains": [
          {
            "body": "Frühschichten, Abendkurse und Wochenenden, besetzt aus einer Mischung von Vollzeit, Teilzeit und Freiberuflichen. Der Dienstplan ist eine Planung, kein Nachweis.",
            "title": "Lange Öffnungszeiten, wechselnde Vertretung"
          },
          {
            "body": "Eine Trainerin gibt zwei Kurse und übernimmt dazwischen den Empfang. Das korrekt zu bezahlen heißt zu wissen, was tatsächlich gearbeitet wurde, nicht was geplant war.",
            "title": "Kursstunden und Stunden auf der Fläche verschwimmen"
          },
          {
            "body": "Personal wechselt zwischen Studios. Die Stunden jeden Monat von Hand zusammenzuführen ist langsam und fehleranfällig.",
            "title": "Mehrere Standorte, eine Verwaltung"
          }
        ],
        "quote": {
          "who": "Leiter, Fitnessstudio · 14 Mitarbeitende",
          "text": "Zwei Studios, lange Öffnungszeiten und viele Vertretungsschichten. Jetzt landen die Stunden am richtigen Standort und die Lohnabrechnung ist eine Datei.",
          "result": "Dienstplan und Lohnabrechnung stimmen endlich überein"
        },
        "stats": [
          {
            "label": "Stunden, auch wenn anderswo vertreten wird",
            "value": "Je Studio"
          },
          {
            "label": "Überblick über die Fläche an allen Standorten",
            "value": "Live"
          },
          {
            "label": "Pausen und Überstunden, ohne Rechnen von Hand",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Ein Tippen auf dem Handy an dem Standort, an dem gearbeitet wird. Vertretung in einem anderen Studio landet auf dessen Stunden.",
            "title": "Einstempeln je Studio"
          },
          {
            "body": "Die Fläche an allen Standorten in Echtzeit – eine unbesetzte Frühschicht sehen Sie, bevor geöffnet wird, nicht danach.",
            "title": "Live sehen, wer da ist"
          },
          {
            "body": "Pausenregeln werden automatisch angewendet, Mehrstunden erfasst, sobald sie entstehen, mit Auszahlung oder Freizeitausgleich je Mitarbeitendem.",
            "title": "Pausen und Überstunden erledigt"
          }
        ],
        "headline": "Zeiterfassung für Fitnessstudios, Studios und Spas – Schichten, Kurse und Lohnabrechnung in einer App",
        "workflow": [
          {
            "body": "Ein Tippen zum Schichtbeginn, an dem Standort, an dem gearbeitet wird.",
            "step": "Team stempelt im Studio ein"
          },
          {
            "body": "Wer gerade an welchem Standort ist, damit Lücken geschlossen werden, bevor Mitglieder es merken.",
            "step": "Vertretung ist live sichtbar"
          },
          {
            "body": "Stunden, Pausen und Überstunden je Mitarbeitendem und je Studio, fertig für den Lohndienstleister.",
            "step": "Ein Export für die Lohnabrechnung"
          }
        ],
        "compliance": {
          "body": "Done-it führt eine digitale Aufzeichnung der Arbeitszeit je Mitarbeitendem und je Standort – die Grundlage für korrekte Bezahlung und für jede Prüfung der geleisteten Stunden.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Schichterfassung für mehrere Standorte",
          "title": "Ein objektiver Nachweis für jede Schicht und jeden Standort"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Gastronomie & Hotellerie",
        "slug": "hospitality",
        "intro": "Geteilte Dienste, später Feierabend und ein voller Samstag, der überzieht. Done-it erfasst die Stunden so, wie sie tatsächlich gearbeitet werden, zieht Pausen nach Ihrer Regel ab und gibt der Lohnabrechnung eine saubere Datei.",
        "pains": [
          {
            "body": "Der Service zieht sich, das Abschließen dauert noch eine halbe Stunde. Diese Minuten sind echte Arbeit, und sie aus dem Gedächtnis zu regeln ist der Anfang jedes Streits.",
            "title": "Die Schicht endet nie, wenn der Dienstplan es sagt"
          },
          {
            "body": "Mittagsservice, Pause, dann Abendservice. Auf Papier wird daraus ein langer Block oder zwei Schätzungen – beides stimmt nicht.",
            "title": "Geteilte Dienste sind schwer zu erfassen"
          },
          {
            "body": "Jede Saison neues Personal. Ein System, das Schulung braucht, überlebt die erste volle Woche nicht.",
            "title": "Hohe Fluktuation, ständige Einarbeitung"
          }
        ],
        "quote": {
          "who": "Inhaber, Restaurant · 17 Mitarbeitende",
          "text": "Das Abschließen zieht sich immer. Jetzt werden diese Minuten erfasst statt diskutiert, und das Team kann sie abfeiern.",
          "result": "Weniger Streit, schnellere Lohnabrechnung"
        },
        "stats": [
          {
            "label": "als zwei Blöcke erfasst, nicht als eine Schätzung",
            "value": "Geteilte Dienste"
          },
          {
            "label": "Pausenabzug nach Ihrer Regel",
            "value": "Auto"
          },
          {
            "label": "zum Einarbeiten neuer Kräfte – es ist ihr eigenes Handy",
            "value": "1 Min."
          }
        ],
        "features": [
          {
            "body": "Ein Tippen zu Beginn und am Ende jedes Blocks, damit geteilte Dienste so erfasst werden, wie sie stattgefunden haben – nicht zu einem Block zusammengefasst.",
            "title": "Ein- und Ausstempeln je Service"
          },
          {
            "body": "Pflichtpausen werden automatisch abgezogen, mit Ausnahmen pro Person, wo ein Vertrag es verlangt. Kein Rechnen von Hand zum Monatsende.",
            "title": "Pausen nach Ihrer Regel"
          },
          {
            "body": "Die halbe Stunde nach dem Abschließen wird erfasst, sobald sie gearbeitet ist, und ausgezahlt oder abgefeiert – die Mitarbeitenden entscheiden.",
            "title": "Überstunden in der App geregelt"
          }
        ],
        "headline": "Zeiterfassung für Cafés, Restaurants und Hotels – Schichten, Pausen und Überstunden, fair abgerechnet",
        "workflow": [
          {
            "body": "Ein Tippen zu Beginn des Blocks, dasselbe am Ende. Geteilte Dienste bleiben getrennt.",
            "step": "Team stempelt zum Service ein"
          },
          {
            "body": "Wer für den heutigen Abendservice da ist, wer noch Pause macht, wer über den Feierabend hinaus geblieben ist.",
            "step": "Sie sehen die Fläche live"
          },
          {
            "body": "Arbeitszeit, Pausen und Überstunden je Mitarbeitendem, exportiert in einer Datei.",
            "step": "Die Lohnabrechnung bekommt die echten Stunden"
          }
        ],
        "compliance": {
          "body": "Done-it führt eine objektive digitale Aufzeichnung jeder Schicht, jeder Pause und jeder Mehrstunde – genau das, was eine Lohnprüfung oder eine Arbeitszeitkontrolle sehen will.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Zeiterfassung für geteilte Dienste",
          "title": "Ein belastbarer Nachweis in einem Team mit hoher Fluktuation"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Gesundheit & Pflege",
        "slug": "healthcare",
        "intro": "Praxen, ambulante Pflegeteams und Pflegeheime laufen über Schichten, Besuche und strenge Dokumentation. Done-it erfasst die Arbeitszeit je Schicht und je Besuch und bewahrt Mitarbeiterdokumente dort auf, wo Sie sie finden.",
        "pains": [
          {
            "body": "Hausbesuche liegen in einem Tool, Dienstplanstunden in einem anderen, und die Lohnabrechnung bekommt eine dritte Version. Das abzugleichen ist ein Monatsjob.",
            "title": "Besuche und Schichten in getrennten Systemen"
          },
          {
            "body": "Zuschlagszeiten werden anders vergütet. Wenn der Nachweis ungefähr ist, ist es die Bezahlung auch – und die Korrektur kommt später.",
            "title": "Nacht- und Wochenendstunden falsch bewertet"
          },
          {
            "body": "Qualifikationen und Nachweise zählen in der Pflege, und sie liegen in einem Ordner, den niemand öffnet, bis eine Prüfung danach fragt.",
            "title": "Zertifikate laufen unbemerkt ab"
          }
        ],
        "quote": {
          "who": "Koordinatorin, ambulantes Pflegeteam · 22 Mitarbeitende",
          "text": "Hausbesuche und Dienstplanschichten liegen endlich im selben Nachweis. Die Lohnabrechnung ist kein Abgleich mehr.",
          "result": "Ein Nachweis statt drei"
        },
        "stats": [
          {
            "label": "oder je Schicht – so, wie Ihr Team arbeitet",
            "value": "Je Besuch"
          },
          {
            "label": "Nacht- und Wochenendstunden, erfasst wie gearbeitet",
            "value": "Getrennt"
          },
          {
            "label": "Zertifikate je Mitarbeitendem gespeichert",
            "value": "Abgelegt"
          }
        ],
        "features": [
          {
            "body": "Ein Tippen zum Schichtbeginn oder an jeder Adresse in der ambulanten Pflege – mit Standortprüfung, wo Sie den Nachweis brauchen.",
            "title": "Einstempeln je Schicht oder je Besuch"
          },
          {
            "body": "Nacht-, Wochenend- und Regelstunden werden getrennt erfasst, sodass der Lohnexport bereits abbildet, wie die Arbeit tatsächlich bezahlt wird.",
            "title": "Stunden getrennt, so wie Sie sie vergüten"
          },
          {
            "body": "Verträge, Zertifikate und Ausweise liegen bei der Person, zu der sie gehören – in Sekunden gefunden, wenn jemand danach fragt.",
            "title": "Mitarbeiterdokumente an einem Ort"
          }
        ],
        "headline": "Zeiterfassung für Pflegeteams – Schichten, Hausbesuche und Qualifikationen in einem Nachweis",
        "workflow": [
          {
            "body": "Ein Tippen am Standort oder an der Adresse der betreuten Person, mit Standortprüfung, wo ein Nachweis nötig ist.",
            "step": "Zur Schicht oder zum Besuch einstempeln"
          },
          {
            "body": "Regel-, Nacht- und Wochenendstunden werden getrennt erfasst, während sie entstehen.",
            "step": "Stunden landen in der richtigen Kategorie"
          },
          {
            "body": "Eine saubere Datei je Zeitraum, bereits so aufgeteilt, wie Sie vergüten.",
            "step": "Export für die Lohnabrechnung"
          }
        ],
        "compliance": {
          "body": "Done-it führt eine digitale, objektive Aufzeichnung der Arbeitszeit je Mitarbeitendem – Stunden, Pausen und die Aufteilung der Zuschlagszeiten – zusammen mit den Dokumenten, die zu jeder Person gehören.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Schicht- & Besuchserfassung",
          "title": "Nachweise, die eine Prüfung überstehen"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "it": [
      {
        "name": "Edilizia",
        "slug": "construction",
        "intro": "Squadre distribuite tra i cantieri, ore scritte a mano su carta, ore dei subappaltatori impossibili da riconciliare. Done-it dà a ogni cantiere un foglio ore digitale a prova di tutto che alimenta le tue buste paga con un clic.",
        "pains": [
          {
            "body": "Con più cantieri attivi e squadre a rotazione, i fogli ore manuali sono sbagliati per natura. I lavoratori arrotondano, dimenticano le registrazioni o le compilano giorni dopo — lasciandoti cifre per le buste paga che non puoi difendere.",
            "title": "Nessun record affidabile di chi ha lavorato dove"
          },
          {
            "body": "Quando ti accorgi che un cantiere ha esaurito le ore previste, il margine è già perso. Non c'è un conto alla rovescia in tempo reale — solo una brutta sorpresa al momento della fattura.",
            "title": "Gli sforamenti di budget emergono troppo tardi"
          },
          {
            "body": "Raccogliere i fogli ore, riconciliarli con i progetti e preparare l'esportazione per le buste paga richiede giorni. Ogni registrazione è un potenziale errore.",
            "title": "La preparazione delle buste paga divora ore ogni mese"
          }
        ],
        "quote": {
          "who": "Titolare, impresa edile · 14 dipendenti",
          "text": "La nostra squadra registra l'entrata da sola in cantiere. A fine mese, le buste paga semplicemente tornano — abbiamo smesso del tutto di rincorrere i fogli ore.",
          "result": "5 ore a settimana risparmiate sul lavoro amministrativo"
        },
        "stats": [
          {
            "label": "per registrare l'entrata in qualsiasi cantiere — niente terminale, niente carta",
            "value": "1 tocco"
          },
          {
            "label": "esportazione per le buste paga pronta per il tuo fornitore",
            "value": "1 clic"
          },
          {
            "label": "vista delle ore residue per progetto e cantiere",
            "value": "In tempo reale"
          }
        ],
        "features": [
          {
            "body": "Un tocco registra l'entrata del lavoratore, con posizione verificata, e collega le ore al progetto giusto. Niente lettori di tessere, niente terminali — solo lo smartphone che la tua squadra ha già in tasca.",
            "title": "Check-in con verifica della posizione per ogni cantiere"
          },
          {
            "body": "Imposta le ore previste come budget quando apri il progetto. I lavoratori vedono un conto alla rovescia di ciò che resta; tu lo vedi in tempo reale nella tua dashboard. Gli sforamenti di budget sono visibili prima che accadano.",
            "title": "Ore residue in tempo reale per progetto"
          },
          {
            "body": "Aggiungi i subappaltatori a un progetto, assegnali al check-in e traccia le loro ore insieme alla tua squadra — nella stessa panoramica.",
            "title": "Gestione e presenza dei subappaltatori"
          },
          {
            "body": "Tutte le ore registrate — per lavoratore, per progetto — si esportano in un foglio di calcolo pulito per il tuo fornitore di buste paga. Nessuna preparazione manuale, nessun errore.",
            "title": "Esportazione per le buste paga con un clic"
          }
        ],
        "headline": "Rilevazione delle ore per i team edili — check-in con verifica della posizione, ore di progetto e controllo del budget, in un'unica app",
        "workflow": [
          {
            "body": "Ogni lavoratore tocca una volta per registrare l'entrata. Il GPS conferma la posizione, marca temporalmente la registrazione e collega le ore al progetto. Niente carta, niente terminale.",
            "step": "La squadra arriva in cantiere"
          },
          {
            "body": "Ore, budget residuo, presenza dei subappaltatori ed eventuali lavori extra segnalati dal cantiere — tutto nella tua dashboard, in tempo reale.",
            "step": "Vedi tutto in tempo reale"
          },
          {
            "body": "Esporta tutte le ore per lavoratore e per progetto. Invia al tuo fornitore di buste paga. Done-it genera automaticamente report puliti e pronti per l'audit.",
            "step": "Fine mese in pochi minuti"
          }
        ],
        "compliance": {
          "body": "Done-it fornisce check-in con verifica della posizione, rilevazione delle ore per progetto e un'esportazione pulita per le buste paga dei team edili. Per i team che operano nei cantieri belgi, alimenta anche automaticamente check-in at work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrazione delle ore digitale",
          "title": "Check-in con verifica della posizione pensato per i cantieri edili"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Pulizie",
        "slug": "cleaning",
        "intro": "Gli addetti alle pulizie si spostano tra le sedi tutto il giorno. Done-it traccia in tempo reale chi è dove — check-in con verifica della posizione in ogni sede, detrazione automatica delle pause e un'esportazione pulita per le buste paga a fine mese.",
        "pains": [
          {
            "body": "Clienti e ispettori si aspettano registrazioni delle presenze a prova di tutto. I fogli manuali possono essere contestati; i check-in digitali con posizione verificata no.",
            "title": "Dimostrare la presenza in ogni sede"
          },
          {
            "body": "Con gli addetti che si spostano tra le sedi durante la giornata, non hai una vista in tempo reale di chi lavora dove — finché qualcuno non chiama.",
            "title": "Squadre distribuite su molte sedi"
          },
          {
            "body": "Senza orari di entrata/uscita accurati, le buste paga vengono ricostruite a memoria. Le ore vengono arrotondate per eccesso, i costi si gonfiano e seguono le contestazioni.",
            "title": "Errori nelle buste paga dovuti alle ore arrotondate"
          }
        ],
        "quote": {
          "who": "Responsabile, impresa di pulizie · 9 dipendenti",
          "text": "Possiamo finalmente dimostrare chi ha pulito dove e quando. Niente più fogli presenze, niente più contestazioni dei clienti — ci pensa il GPS.",
          "result": "Zero arrotondamenti delle ore"
        },
        "stats": [
          {
            "label": "per registrare l'entrata in qualsiasi sede — nessun terminale necessario",
            "value": "1 tocco"
          },
          {
            "label": "vista di chi è in quale sede in questo momento",
            "value": "In tempo reale"
          },
          {
            "label": "doppie registrazioni — le ore confluiscono direttamente nelle buste paga",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "I lavoratori timbrano entrata e uscita sul telefono in ogni sede, con posizione verificata; il tempo è esatto, con la registrazione delle pause.",
            "plan": "Time Basic",
            "title": "Check-in ed check-out in tempo reale"
          },
          {
            "body": "Le pause obbligatorie vengono sottratte automaticamente dalla giornata lavorativa — niente calcoli manuali, niente contestazioni.",
            "plan": "Time Basic",
            "title": "Detrazione automatica delle pause"
          },
          {
            "body": "Vedi quali addetti sono in quali sedi in questo momento. Individua le lacune prima dei clienti.",
            "title": "Panoramica multi-sede in tempo reale"
          },
          {
            "body": "I lavoratori caricano certificati di malattia e documenti di assenza direttamente dall'app. Crea i tipi di assenza che la tua squadra usa davvero.",
            "title": "Registrazione delle assenze con certificati medici digitali"
          },
          {
            "body": "Le marche temporali esatte confluiscono direttamente in un'esportazione pronta per le buste paga del tuo fornitore. Niente trascrizione, niente errori.",
            "title": "Esportazione per le buste paga con un clic"
          }
        ],
        "headline": "Rilevazione delle ore per le imprese di pulizie — check-in con verifica della posizione, prova di presenza e buste paga in un'unica app",
        "workflow": [
          {
            "body": "Un tocco registra l'entrata. Il GPS registra la sede e marca temporalmente la registrazione. La registrazione delle pause è integrata nell'app.",
            "step": "L'addetto arriva alla sede"
          },
          {
            "body": "Chi è in quale sede in questo momento — niente telefonate, niente supposizioni. Individua le lacune di copertura prima dei clienti.",
            "step": "Vedi ogni sede in tempo reale"
          },
          {
            "body": "Tutti i dati di presenza — orari esatti, sedi e pause — si esportano in modo pulito per il tuo fornitore di buste paga.",
            "step": "Le buste paga sono un clic"
          }
        ],
        "compliance": {
          "body": "Done-it dà ai team di pulizie il check-in con verifica della posizione in ogni sede, la detrazione automatica delle pause e una vista in tempo reale di chi è in quale cantiere in questo momento.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Presenze con verifica della posizione",
          "title": "Presenze in tempo reale in ogni sede di pulizia"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Installazione",
        "slug": "installation",
        "intro": "Manda i tuoi installatori all'indirizzo giusto con tutto ciò che serve, collega automaticamente ogni ora lavorata al lavoro giusto e vedi il budget residuo prima che il cantiere chiuda. Done-it è il modo più semplice per tenere i progetti di installazione nei tempi e nei costi.",
        "pains": [
          {
            "body": "Le squadre arrivano in un cantiere senza l'indirizzo, la persona di contatto o i dettagli dell'ambito. Quella prima telefonata sono dieci minuti di tempo fatturabile persi prima ancora di lavorare un'ora.",
            "title": "Le informazioni sul lavoro non arrivano sul campo in tempo"
          },
          {
            "body": "Quando i lavoratori compilano le ore manualmente a fine giornata — se le compilano — le ore finiscono nel lavoro sbagliato, o spariscono del tutto. Le fatture non corrispondono alla realtà.",
            "title": "Le ore non sono collegate al progetto giusto"
          },
          {
            "body": "Senza un conto alla rovescia in tempo reale delle ore residue per progetto, scopri che un lavoro è andato fuori budget quando chiudi la fattura — non mentre puoi ancora reagire.",
            "title": "Gli sforamenti di budget vengono individuati troppo tardi"
          },
          {
            "body": "I subappaltatori che lavorano sullo stesso cantiere usano sistemi diversi, compilano le ore separatamente o non le compilano affatto. Riconciliare a fine mese è un processo lento e soggetto a errori.",
            "title": "Difficile tracciare le ore dei subappaltatori"
          }
        ],
        "quote": {
          "who": "Titolare, impresa di installazioni · 6 dipendenti",
          "text": "Le ore finiscono sul progetto giusto automaticamente. Il calcolo dei costi di commessa è diventato improvvisamente facile — possiamo vedere il margine reale prima di chiudere un lavoro.",
          "result": "Costo reale per lavoro, in tempo reale"
        },
        "stats": [
          {
            "label": "vista delle ore residue per progetto",
            "value": "In tempo reale"
          },
          {
            "label": "chiamate all'ufficio per gli indirizzi dei cantieri",
            "value": "0"
          },
          {
            "label": "naviga verso qualsiasi indirizzo di progetto dall'app",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "I lavoratori aprono il progetto sul telefono: indirizzo, ore previste, persona di contatto e file caricati (piani, istruzioni, PDF). Tutto ciò che serve è lì prima ancora di arrivare.",
            "plan": "Project Basic",
            "title": "Informazioni di progetto condivise direttamente sull'app"
          },
          {
            "body": "Tocca una volta e il telefono naviga verso l'indirizzo del progetto — integrato nell'app, senza bisogno di un'app di mappe separata.",
            "title": "Navigazione verso il cantiere con un solo pulsante"
          },
          {
            "body": "Imposta le ore previste quando apri il progetto. I lavoratori vedono quante ore restano; tu vedi lo stato in tempo reale nella tua dashboard. Gli sforamenti sono visibili prima che accadano.",
            "plan": "Project Basic",
            "title": "Conto alla rovescia delle ore residue per progetto"
          },
          {
            "body": "Ogni lavoratore registra l'entrata sul progetto giusto. Sai sempre chi è in quale cantiere in questo momento.",
            "plan": "Project Basic",
            "title": "Check-in del lavoratore per progetto"
          },
          {
            "body": "Quando l'ambito si amplia in cantiere, i lavoratori registrano lavoro e materiali extra in tempo reale — con testo e foto — così nulla viene fatturato a memoria.",
            "plan": "Project Basic",
            "title": "Registrazione di lavoro e materiali extra"
          }
        ],
        "headline": "Rilevazione delle ore per i team di installazione — ore di progetto, navigazione e controllo del budget in un'unica app",
        "workflow": [
          {
            "body": "Indirizzo, contatto, ambito e file caricati sono proprio lì. Naviga con un tocco — niente chiamate all'ufficio per le indicazioni.",
            "step": "Il lavoratore apre il progetto sul telefono"
          },
          {
            "body": "Il check-in collega ogni minuto lavorato al progetto corretto. Il budget residuo si aggiorna in tempo reale.",
            "step": "Le ore si registrano automaticamente sul lavoro giusto"
          },
          {
            "body": "Modifiche di ambito, materiali extra e ritardi vengono registrati con testo e foto nel momento in cui accadono — pronti per la fattura.",
            "step": "Il lavoro extra viene registrato in cantiere"
          }
        ],
        "compliance": {
          "body": "Done-it dà ai team di installazione il check-in con verifica della posizione per progetto, un conto alla rovescia delle ore residue in tempo reale e l'esportazione automatica per le buste paga — coprendo qualsiasi requisito locale di rilevazione delle ore. Per i team che lavorano nei cantieri edili belgi, si integra anche con CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrazione delle ore digitale",
          "title": "Check-in con verifica della posizione per progetto per i team di installazione"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Assistenza sul campo",
        "slug": "field-service",
        "intro": "Tecnici che visitano più clienti al giorno, ricevute nel cassetto portaoggetti, chilometraggio registrato a memoria. Done-it cattura ore, chilometri e spese sul campo — collegati al lavoro giusto nel momento in cui accadono.",
        "pains": [
          {
            "body": "Chiedere ai tecnici di ricostruire i percorsi a fine settimana significa rimborsi imprecisi, contestazioni con i clienti e una pila crescente di chilometri non rivendicati.",
            "title": "Chilometraggio registrato giorni dopo — se mai lo è"
          },
          {
            "body": "Una ricevuta nel cassetto portaoggetti è un costo che potrebbe non finire mai in una fattura. Il costo reale per lavoro è sempre sottostimato.",
            "title": "Spese su ricevute cartacee che spariscono"
          },
          {
            "body": "Senza check-in in tempo reale, scopri dove si trova un tecnico solo quando qualcosa va storto e qualcuno chiama.",
            "title": "Nessuna vista in tempo reale di dove si trova la squadra"
          },
          {
            "body": "Quando manodopera, viaggi e spese vengono tracciati in sistemi separati — o non vengono tracciati affatto — non c'è mai un'unica cifra di costo per lavoro.",
            "title": "Difficile vedere il margine reale per lavoro"
          }
        ],
        "quote": {
          "who": "Responsabile operativo, impresa di assistenza sul campo · 11 dipendenti",
          "text": "Il chilometraggio era un grattacapo mensile. Ora si registra da solo — ogni chilometro è collegato al cliente giusto prima ancora che torniamo in ufficio.",
          "result": "Costo per lavoro accurato, ogni volta"
        },
        "stats": [
          {
            "label": "cattura del chilometraggio — nessun registro manuale",
            "value": "Automatica"
          },
          {
            "label": "costo per lavoro: ore + viaggi + spese",
            "value": "In tempo reale"
          },
          {
            "label": "chilometri persi — ogni spostamento catturato automaticamente",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Il GPS registra partenza, arrivo e distanza esatta per ogni spostamento. Configura i tipi di trasporto (auto propria, veicolo aziendale, car pooling) con le rispettive tariffe di rimborso. Nessun registro manuale.",
            "plan": "Add-on",
            "title": "Cattura automatica del chilometraggio (Trax-it)"
          },
          {
            "body": "I lavoratori fotografano una ricevuta sul campo; viene collegata al lavoro e pronta per il rimborso — non rincorsa a fine mese.",
            "plan": "Time Basic",
            "title": "Gestione delle spese sul campo"
          },
          {
            "body": "Ore, chilometraggio e spese confluiscono sul lavoro in tempo reale. Il costo per lavoro è visibile mentre il lavoro è ancora aperto.",
            "plan": "Project Basic",
            "title": "Controllo dei costi collegato al progetto"
          },
          {
            "body": "Ogni tecnico registra l'entrata presso la sede del cliente. Vedi chi è dove, in questo momento — niente chiamate, niente supposizioni.",
            "title": "Check-in con verifica della posizione e panoramica della squadra in tempo reale"
          },
          {
            "body": "Ore e rimborsi chilometrici si esportano in modo pulito per il tuo fornitore di buste paga — con le tue tariffe chilometriche configurate applicate automaticamente.",
            "title": "Esportazione per le buste paga con un clic"
          }
        ],
        "headline": "Rilevazione delle ore per i team di assistenza sul campo — chilometraggio, spese e ore dalla strada, tutto in un'unica app",
        "workflow": [
          {
            "body": "Il check-in avvia la registrazione dello spostamento. I chilometri vengono catturati automaticamente dalla partenza all'arrivo — nessun inserimento manuale.",
            "step": "Il tecnico parte per il primo intervento"
          },
          {
            "body": "Le ore si collegano al progetto giusto. Lavoro extra, materiali e ricevute vengono registrati nell'app nel momento in cui accadono.",
            "step": "Sul luogo del lavoro"
          },
          {
            "body": "Ogni ora, chilometro e spesa è già collegato al lavoro corretto. Esporta verso le buste paga e fattura con cifre di costo reali.",
            "step": "Fine mese senza il caos"
          }
        ],
        "compliance": {
          "body": "Done-it cattura il chilometraggio automaticamente per ogni spostamento, applica le tue tariffe di rimborso configurate e registra ogni chilometro sul cliente o progetto giusto. La sentenza Tyco dell'UE significa che il viaggio da casa al primo cliente conta come tempo di lavoro — Done-it traccia anche quello.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Rilevazione digitale di ore e chilometraggio",
          "title": "Ore con GPS e chilometraggio automatico per i team di assistenza sul campo"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Ogni intervento ha tre costi: manodopera, ricambi e viaggi. Done-it cattura tutti e tre sul campo e li fa confluire sul lavoro giusto — così conosci il tuo margine prima di chiudere la fattura.",
        "pains": [
          {
            "body": "Manodopera, ricambi e viaggi vivono in sistemi diversi — o in tasche diverse. Il costo reale di un intervento diventa chiaro solo molto tempo dopo che il tecnico ha lasciato il cantiere.",
            "title": "Gli interventi sono difficili da quotare con precisione"
          },
          {
            "body": "Quando un cliente contesta quanto è durata una riparazione, un foglio ore cartaceo è facile da contestare. Le marche temporali di entrata e uscita confermate dal GPS no.",
            "title": "Nessuna prova del tempo di servizio"
          },
          {
            "body": "Sui contratti di manutenzione ricorrenti, i piccoli sforamenti si accumulano tra molte visite. Senza un contatore delle ore in tempo reale, scopri che il contratto è in perdita solo al rinnovo.",
            "title": "I contratti di manutenzione erodono il margine silenziosamente"
          },
          {
            "body": "Le registrazioni manuali del tempo tralasciano le pause, portando a pagamenti eccessivi e a buste paga che non corrispondono alla realtà.",
            "title": "I tecnici dimenticano di registrare le pause"
          }
        ],
        "quote": {
          "who": "Titolare, impresa HVAC · 7 tecnici",
          "text": "Finalmente sappiamo quanto ci costa davvero ogni contratto di servizio. Le sorprese sul margine sono finite il giorno in cui abbiamo iniziato a usare Done-it.",
          "result": "Costo reale per intervento, in tempo reale"
        },
        "stats": [
          {
            "label": "tipi di costo catturati per intervento: manodopera, viaggi, ricambi",
            "value": "3"
          },
          {
            "label": "visibilità del margine per contratto di servizio",
            "value": "In tempo reale"
          },
          {
            "label": "sorprese al momento della fattura — costi visibili in tempo reale",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ogni intervento o contratto di manutenzione è un progetto. Ore, viaggi e materiali confluiscono in tempo reale — dandoti visibilità del margine in tempo reale.",
            "plan": "Project Basic",
            "title": "Rilevazione delle ore basata sul progetto"
          },
          {
            "body": "Quando un lavoro cresce, i tecnici registrano lavoro e ricambi extra con testo e foto prima di andare via. Nulla viene fatturato a memoria.",
            "plan": "Project Basic",
            "title": "Lavoro e materiali extra, registrati in cantiere"
          },
          {
            "body": "I chilometri per intervento vengono registrati automaticamente e imputati al lavoro. Configura le tariffe di rimborso per tipo di veicolo.",
            "plan": "Add-on",
            "title": "Chilometraggio e costi di trasporto"
          },
          {
            "body": "Le pause obbligatorie vengono sottratte automaticamente dal tempo totale — niente contestazioni, niente errori nelle buste paga.",
            "title": "Detrazione automatica delle pause"
          },
          {
            "body": "Check-in con marca temporale e confermato dal GPS in ogni sede. Prova incontestabile di quando il tecnico è arrivato e andato via.",
            "title": "Check-in con verifica della posizione e prova di presenza"
          }
        ],
        "headline": "Rilevazione delle ore per i tecnici HVAC — calcolo dei costi di commessa, ricambi e viaggi in un'unica app",
        "workflow": [
          {
            "body": "Il GPS marca temporalmente l'arrivo e collega le ore all'intervento o al contratto di manutenzione. Niente carta, niente terminale.",
            "step": "Il tecnico registra l'entrata in cantiere"
          },
          {
            "body": "Ricambi usati, ore extra e modifiche di ambito vengono registrati nell'app con foto — prima di lasciare il cantiere.",
            "step": "Il lavoro extra viene registrato sul posto"
          },
          {
            "body": "Manodopera, viaggi e materiali si sommano sul progetto in tempo reale. Vedi il margine prima di emettere la fattura.",
            "step": "Il costo del lavoro è visibile immediatamente"
          }
        ],
        "compliance": {
          "body": "Done-it dà ai team HVAC il check-in con verifica della posizione per intervento, la visibilità dei costi in tempo reale per lavoro (manodopera + viaggi + ricambi) e un'esportazione pulita per le buste paga — soddisfacendo qualsiasi requisito locale di rilevazione delle ore senza hardware aggiuntivo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione digitale di ore e costi",
          "title": "Calcolo completo dei costi di commessa per gli interventi HVAC"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elettricisti",
        "slug": "electricians",
        "intro": "Ore per progetto, un conto alla rovescia in tempo reale del budget residuo e navigazione verso il cantiere con un solo pulsante — pensato per i piccoli team di elettricisti che hanno bisogno del controllo dei progetti senza il sovraccarico amministrativo.",
        "pains": [
          {
            "body": "Quando gli elettricisti lavorano su più lavori in una settimana, allocare manualmente le ore a fine giornata porta a costi attribuiti erroneamente, contestazioni di fatturazione e buste paga che non sai spiegare.",
            "title": "Le ore non sono collegate al progetto giusto"
          },
          {
            "body": "Senza una vista in tempo reale delle ore consumate rispetto a quelle previste, scopri che un progetto è andato fuori budget quando emetti la fattura — non quando potresti ancora reagire.",
            "title": "Gli sforamenti di budget individuati troppo tardi"
          },
          {
            "body": "Indirizzi digitati in un'app separata, chiamate all'ufficio per le indicazioni, arrivi in ritardo presso i clienti. Ogni minuto perso è un minuto fatturabile perso.",
            "title": "Tempo perso a trovare il cantiere"
          },
          {
            "body": "Sui lavori più grandi, gli elettricisti subappaltatori tracciano le proprie ore separatamente. Ottenere una vista combinata dei costi della manodopera a fine progetto è un lavoro manuale e soggetto a errori.",
            "title": "Difficile riconciliare le ore dei subappaltatori"
          }
        ],
        "quote": {
          "who": "Titolare, impresa elettrica · 5 elettricisti",
          "text": "Sappiamo in tempo reale se un progetto sta andando fuori budget. Solo questo ci ha salvato da due brutte sorprese quest'anno.",
          "result": "Sforamenti di budget colti prima che accadano"
        },
        "stats": [
          {
            "label": "vista delle ore residue per progetto",
            "value": "In tempo reale"
          },
          {
            "label": "chiamate all'ufficio per gli indirizzi dei cantieri",
            "value": "0"
          },
          {
            "label": "per registrare l'entrata in qualsiasi cantiere — nessun terminale necessario",
            "value": "1 tocco"
          }
        ],
        "features": [
          {
            "body": "Ogni minuto lavorato è collegato automaticamente al progetto giusto. Un conto alla rovescia in tempo reale mostra quante ore restano rispetto al budget — per te e per il lavoratore in cantiere.",
            "plan": "Project Basic",
            "title": "Ore di progetto con budget residuo in tempo reale"
          },
          {
            "body": "L'indirizzo del progetto è nell'app. Un tocco apre la navigazione — niente ricerche, niente app di mappe separata, niente chiamate all'ufficio.",
            "title": "Navigazione verso il cantiere con un solo pulsante"
          },
          {
            "body": "Ogni elettricista registra l'entrata sul lavoro giusto. Sai sempre chi è in quale cantiere in questo momento.",
            "plan": "Project Basic",
            "title": "Check-in del lavoratore per progetto"
          },
          {
            "body": "Quando l'ambito cambia — un circuito imprevisto, materiali aggiuntivi — viene registrato nell'app con foto, prima che la squadra vada via.",
            "plan": "Project Basic",
            "title": "Lavoro extra registrato in cantiere"
          },
          {
            "body": "Gli straordinari vengono registrati nel momento in cui accadono. I lavoratori scelgono di farseli pagare o di convertirli in tempo libero.",
            "plan": "Time Pro",
            "title": "Rilevazione degli straordinari con compensazione flessibile"
          }
        ],
        "headline": "Rilevazione delle ore per gli elettricisti — ore per progetto, controllo del budget e navigazione in un'unica app",
        "workflow": [
          {
            "body": "Indirizzo e ambito sono già nell'app. Un tocco apre la navigazione — niente chiamate, niente confusione.",
            "step": "L'elettricista naviga verso il lavoro"
          },
          {
            "body": "Il check-in in cantiere collega ogni minuto lavorato al progetto corretto. Il contatore delle ore residue si aggiorna in tempo reale.",
            "step": "Le ore si collegano automaticamente al progetto giusto"
          },
          {
            "body": "Lavoro e materiali extra vengono registrati in cantiere, prima di andare via. La fattura riflette ciò che è realmente accaduto.",
            "step": "Le modifiche di ambito restano agli atti"
          }
        ],
        "compliance": {
          "body": "Done-it dà agli elettricisti il check-in con verifica della posizione per progetto, un budget di ore residue in tempo reale e l'esportazione per le buste paga — soddisfacendo qualsiasi requisito locale di rilevazione delle ore. Per i team nei cantieri edili belgi, si integra anche con CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Check-in con verifica della posizione per progetto",
          "title": "Controllo del budget in tempo reale e check-in con verifica della posizione per i team di elettricisti"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Idraulica",
        "slug": "plumbing",
        "intro": "Interventi d'emergenza, più lavori al giorno, ore compilate a memoria a fine settimana — o per niente. Done-it lo rende un lavoro da un tocco in ogni sede e una busta paga da un clic a fine mese.",
        "pains": [
          {
            "body": "Con diversi lavori in un giorno, gli idraulici raramente hanno tempo di compilare fogli ore accurati. Le ore vengono arrotondate o dimenticate, e le buste paga sono al massimo una stima.",
            "title": "Ore di intervento ricostruite a memoria"
          },
          {
            "body": "Quando un cliente contesta quanto è durata una riparazione, non c'è un record oggettivo. Un check-in digitale confermato dal GPS è facile da produrre — un foglio ore cartaceo no.",
            "title": "Nessuna prova del tempo in cantiere"
          },
          {
            "body": "Gli spostamenti tra gli interventi si accumulano nell'arco della settimana e del mese, ma senza la cattura automatica raramente vengono fatturati o rimborsati correttamente.",
            "title": "Chilometraggio tra i lavori non tracciato"
          },
          {
            "body": "A fine mese, rincorrere i fogli ore, correggere gli errori e costruire l'esportazione per le buste paga richiede un tempo che il tuo team amministrativo non dovrebbe impiegare.",
            "title": "La preparazione delle buste paga è lenta"
          }
        ],
        "quote": {
          "who": "Titolare, impresa di idraulica · 4 idraulici",
          "text": "Prima passavamo una mattinata a fine mese a ricostruire le ore. Ora esportiamo e basta. Il fornitore di buste paga le riceve pulite.",
          "result": "Preparazione delle buste paga passata da ore a minuti"
        },
        "stats": [
          {
            "label": "per registrare l'entrata — abbastanza rapido per le chiamate d'emergenza",
            "value": "1 tocco"
          },
          {
            "label": "esportazione per le buste paga verso il tuo fornitore",
            "value": "1 clic"
          },
          {
            "label": "ore ricostruite a memoria a fine mese",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Arrivo e partenza registrati con un tocco, con verifica della posizione. Abbastanza rapido per le chiamate d'emergenza; abbastanza preciso per le contestazioni.",
            "plan": "Time Basic",
            "title": "Check-in con verifica della posizione e un tocco a ogni intervento"
          },
          {
            "body": "Le pause obbligatorie vengono sottratte automaticamente dal tempo totale — niente da compilare, niente errori nelle buste paga.",
            "plan": "Time Basic",
            "title": "Detrazione automatica delle pause"
          },
          {
            "body": "Configura i tipi di trasporto e le tariffe di rimborso. I chilometri si registrano automaticamente e si collegano al cliente o progetto corretto.",
            "plan": "Add-on",
            "title": "Chilometraggio catturato per spostamento"
          },
          {
            "body": "I lavoratori inviano i certificati medici in digitale dall'app. Crea i tipi di assenza che la tua squadra usa davvero, inclusi i ritardi per maltempo.",
            "title": "Gestione delle assenze e dei certificati medici"
          },
          {
            "body": "Tutti i dati di ore e chilometri si esportano in modo pulito per il tuo fornitore di buste paga — nessuna preparazione manuale, niente Excel.",
            "plan": "Time Basic",
            "title": "Esportazione per le buste paga con un clic"
          }
        ],
        "headline": "Rilevazione delle ore per i team di idraulica — check-in rapido, buste paga accurate e prova di presenza per ogni intervento",
        "workflow": [
          {
            "body": "Un tocco registra l'entrata. Il GPS registra la posizione e l'ora. Abbastanza rapido per un lavoro d'emergenza.",
            "step": "L'idraulico arriva all'intervento"
          },
          {
            "body": "Il check-out chiude la registrazione del tempo. Il chilometraggio verso il lavoro successivo inizia a registrarsi automaticamente.",
            "step": "La partenza si tocca uscendo"
          },
          {
            "body": "Tutti gli interventi, le ore e i chilometri si esportano in modo pulito. La preparazione delle buste paga passa da un giorno a pochi minuti.",
            "step": "La fine mese è un clic"
          }
        ],
        "compliance": {
          "body": "Done-it copre qualsiasi requisito locale di rilevazione delle ore per i team di idraulica — check-in con verifica della posizione e un tocco per intervento, detrazione automatica delle pause e un'esportazione pulita per le buste paga. Niente fogli ore cartacei, nessuna ricostruzione manuale.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrazione delle ore digitale",
          "title": "Check-in con verifica della posizione rapido per ogni intervento"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Giardinaggio",
        "slug": "landscaping",
        "intro": "L'alta stagione significa molte sedi, squadre che cambiano e tanti chilometri. Done-it mantiene organizzata ogni ora, ogni assenza e ogni spostamento — così puoi concentrarti sul lavoro, non sulle scartoffie.",
        "pains": [
          {
            "body": "Lavoratori temporanei, orari mutevoli e dimensioni variabili dei team rendono quasi impossibile una rilevazione accurata delle ore con la carta. Quando riconcili a fine mese, manca sempre qualcosa.",
            "title": "Le squadre stagionali sono complesse da gestire"
          },
          {
            "body": "Una squadra che visita tre o quattro sedi al giorno genera ore che vanno suddivise correttamente. L'inserimento manuale porta a errate attribuzioni e a buste paga contestate.",
            "title": "Ore distribuite su molte sedi"
          },
          {
            "body": "Il fermo per maltempo è un evento reale nel giardinaggio. Senza un record digitale, documentare le interruzioni e adeguare le retribuzioni è lento e soggetto a errori.",
            "title": "Le interruzioni per maltempo sono difficili da documentare"
          },
          {
            "body": "Furgoni aziendali, veicoli personali e car pooling si incrociano tra le sedi tutto il giorno. Senza la cattura automatica, quei chilometri non entrano mai nel quadro dei costi.",
            "title": "Il chilometraggio tra le sedi resta non tracciato"
          }
        ],
        "quote": {
          "who": "Titolare, impresa di giardinaggio · 12 lavoratori stagionali",
          "text": "L'alta stagione significava caos nelle buste paga. Ora il nostro caposquadra controlla l'app, tutti sono conteggiati, e io esporto le ore l'ultimo giorno del mese.",
          "result": "Niente più ricostruzione delle buste paga a fine mese"
        },
        "stats": [
          {
            "label": "cattura del chilometraggio — niente più registro",
            "value": "Automatica"
          },
          {
            "label": "panoramica delle squadre in tutte le sedi",
            "value": "In tempo reale"
          },
          {
            "label": "esportazione per le buste paga per tutte le sedi e tutte le squadre",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "Vedi tutte le squadre, tutte le sedi in tempo reale. Sai chi lavora dove, in questo momento — non a fine mese.",
            "title": "Panoramica delle squadre multi-sede"
          },
          {
            "body": "Pianifica chi lavora dove, gestisci le modifiche dell'ultimo minuto e invia il programma ai telefoni della squadra — senza una telefonata a ciascuna persona.",
            "plan": "Time Pro",
            "title": "Programmazione dei turni per i team stagionali"
          },
          {
            "body": "Crea tipi di assenza personalizzati per il tuo settore: interruzioni stagionali per maltempo, congedo parentale, giorni di malattia. I lavoratori caricano la documentazione in digitale dall'app.",
            "title": "Tipi di assenza personalizzati"
          },
          {
            "body": "Configura i tipi di trasporto (furgone aziendale, auto personale, conducente vs. passeggero in car pooling) con le rispettive tariffe. I chilometri si registrano automaticamente per spostamento.",
            "plan": "Add-on",
            "title": "Chilometraggio con tracciamento del car pooling"
          },
          {
            "body": "Gli straordinari dell'alta stagione si accumulano in fretta. Ogni lavoratore può scegliere di farseli pagare o di accantonare le ore come tempo libero — tracciate in modo trasparente.",
            "plan": "Time Pro",
            "title": "Rilevazione degli straordinari con conversione in ferie"
          }
        ],
        "headline": "Rilevazione delle ore per le imprese di giardinaggio — squadre stagionali, sedi multiple e chilometraggio in un'unica panoramica",
        "workflow": [
          {
            "body": "Il GPS registra l'arrivo. Le ore si suddividono automaticamente sulla sede e sul progetto giusti — nessuna allocazione manuale a fine giornata.",
            "step": "La squadra registra l'entrata alla prima sede"
          },
          {
            "body": "Il caposquadra registra l'interruzione dall'app — un record digitale pulito, niente scartoffie aggiuntive.",
            "step": "Il maltempo ferma il lavoro"
          },
          {
            "body": "Ore, assenze e chilometraggio di ogni sede e di ogni membro della squadra si esportano in modo pulito per le buste paga.",
            "step": "Fine mese: tutte le sedi, tutte le squadre, un'unica esportazione"
          }
        ],
        "compliance": {
          "body": "Done-it dà ai team di giardinaggio la registrazione delle ore digitale in tutte le sedi e per il personale stagionale — check-in con verifica della posizione, tipi di assenza personalizzati per le interruzioni per maltempo e un'esportazione pulita per le buste paga che soddisfa qualsiasi requisito locale.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrazione delle ore digitale",
          "title": "Check-in con verifica della posizione e tracciamento delle assenze per i team stagionali di giardinaggio"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Manutenzione",
        "slug": "maintenance",
        "intro": "I contratti di manutenzione ricorrenti vivono o muoiono sulla visibilità dei costi. Done-it registra ogni visita, traccia le ore rispetto al budget del contratto e dà a te — e ai tuoi clienti — la prova di presenza per ogni intervento.",
        "pains": [
          {
            "body": "Quando le ore delle visite ricorrenti non vengono tracciate rispetto al contratto specifico, non sai se un cliente è redditizio fino alla revisione di fine anno — quando ormai è troppo tardi per riquotare.",
            "title": "Nessuna visibilità dei costi per contratto di manutenzione"
          },
          {
            "body": "I facility manager e i proprietari di immobili vogliono sempre più registrazioni delle presenze: chi è venuto, quando è arrivato, cosa ha fatto. Un registro cartaceo presentato settimane dopo non soddisfa i requisiti degli SLA.",
            "title": "I clienti si aspettano la prova di ciò che è stato fatto"
          },
          {
            "body": "Turni a rotazione su molte sedi ricorrenti — con personale che si sostituisce a vicenda — creano un rompicapo di programmazione e rilevazione delle ore che i processi manuali non possono risolvere in modo affidabile.",
            "title": "Visite ricorrenti difficili da programmare e registrare"
          },
          {
            "body": "Cura del verde, manutenzione delle facciate e lavori sugli impianti all'aperto affrontano tutti interruzioni legate al maltempo. Documentarle correttamente richiede una traccia digitale.",
            "title": "Le interruzioni per maltempo riguardano anche la manutenzione all'aperto"
          }
        ],
        "quote": {
          "who": "Responsabile operativo, impresa di manutenzione · 8 lavoratori",
          "text": "Possiamo dire a un facility manager esattamente chi era in cantiere e quando, in due minuti. Quel livello di prova ha cambiato il modo in cui i clienti ci vedono.",
          "result": "Contestazioni dei clienti ridotte a zero"
        },
        "stats": [
          {
            "label": "costo per contratto di manutenzione",
            "value": "In tempo reale"
          },
          {
            "label": "prova di presenza pronta per i clienti su richiesta",
            "value": "GPS"
          },
          {
            "label": "rinnovi di contratto senza conoscere il tuo margine",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ogni contratto di manutenzione è un progetto. Le ore si registrano automaticamente su di esso, dandoti una cifra di costo in tempo reale e un conto alla rovescia delle ore residue per ogni cliente.",
            "plan": "Project Basic",
            "title": "Tracciamento dei costi basato sul contratto"
          },
          {
            "body": "I check-in con marca temporale e posizione verificata sono un record incontestabile di chi era in cantiere, quando e per quanto tempo — pronti da condividere con i clienti su richiesta.",
            "title": "Prova di presenza confermata dal GPS"
          },
          {
            "body": "I lavoratori segnalano problemi, attività completate o lavoro extra direttamente dall'app — con testo e foto. I clienti ottengono un record in tempo reale; tu hai la documentazione per la fatturazione.",
            "plan": "Project Basic",
            "title": "Aggiornamenti con foto dal cantiere"
          },
          {
            "body": "Pianifica le visite ricorrenti su tutti i contratti, assegna i lavoratori e gestisci le sostituzioni — senza una telefonata a ciascuna persona.",
            "plan": "Time Pro",
            "title": "Programmazione dei turni ricorrenti"
          },
          {
            "body": "Configura le interruzioni per maltempo e altri tipi di assenza. I lavoratori le registrano dall'app; la documentazione si carica in digitale.",
            "title": "Tipi di assenza per la manutenzione all'aperto"
          }
        ],
        "headline": "Rilevazione delle ore per i team di manutenzione — visite ricorrenti, costo per contratto e prova di presenza in un'unica app",
        "workflow": [
          {
            "body": "Il check-in con verifica della posizione registra l'ora di arrivo e collega le ore al contratto corretto. La prova di presenza viene creata automaticamente.",
            "step": "Il lavoratore arriva alla sede di manutenzione"
          },
          {
            "body": "Il lavoro completato ed eventuali problemi vengono segnalati dall'app con foto. I clienti possono vedere esattamente cosa è stato fatto.",
            "step": "Attività completate, problemi registrati"
          },
          {
            "body": "Le ore si accumulano rispetto al budget del contratto in tempo reale. Conosci il margine prima che il contratto si rinnovi.",
            "step": "Costo per contratto visibile immediatamente"
          }
        ],
        "compliance": {
          "body": "Done-it dà ai team di manutenzione la prova di presenza confermata dal GPS per contratto, tipi di assenza personalizzati e una vista dei costi in tempo reale per ogni cliente ricorrente — soddisfacendo qualsiasi requisito locale di rilevazione delle ore senza hardware aggiuntivo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione delle ore basata sul contratto",
          "title": "Visibilità dei costi in tempo reale per contratto di manutenzione"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Negozi e retail",
        "slug": "retail",
        "intro": "Turni di apertura, turni serali e qualcuno che copre sempre qualcun altro. Done-it dà a ogni negozio un registro digitale pulito di chi ha lavorato in quale turno — timbrato dal proprio telefono, pronto per le paghe a fine mese.",
        "pains": [
          {
            "body": "Qualcuno copre un collega malato, qualcuno resta un'ora in più alla chiusura. Finisce su un post-it, o da nessuna parte — e le paghe sono già sbagliate prima di iniziare.",
            "title": "I cambi turno non arrivano mai alle paghe"
          },
          {
            "body": "Il personale si sposta tra le filiali, i part-time lavorano su due sedi. Raccogliere le ore per negozio e unirle a mano costa una giornata al mese.",
            "title": "Più negozi, un unico ciclo paghe"
          },
          {
            "body": "Le pause di legge vengono scalate a memoria e le ore extra si sistemano in via informale — le prime due cose che un'ispezione va a controllare.",
            "title": "Pause e straordinari a occhio"
          }
        ],
        "quote": {
          "who": "Titolare, retail · 11 dipendenti",
          "text": "Due negozi e tanti part-time. Prima metà delle sostituzioni si sistemava a memoria. Ora ogni ora è sul negozio giusto e le paghe si chiudono in pochi minuti.",
          "result": "Preparazione paghe da un giorno a meno di un'ora"
        },
        "stats": [
          {
            "label": "per timbrare — nessun terminale alla cassa",
            "value": "1 tap"
          },
          {
            "label": "chi è in servizio, in ogni negozio",
            "value": "Live"
          },
          {
            "label": "cambi turno persi tra il punto vendita e le paghe",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un tap dal proprio telefono all'inizio del turno. Nessun terminale alla cassa, nessuna tessera condivisa, nessun foglio appeso in magazzino.",
            "title": "Timbrare in negozio"
          },
          {
            "body": "Ogni negozio è un progetto. Chi copre un'altra filiale timbra su quella filiale — vedi le ore dove sono state davvero lavorate.",
            "title": "Ore per negozio, personale tra le filiali"
          },
          {
            "body": "Imposti la regola una volta e vale per ogni turno. Gli straordinari vengono registrati nel momento in cui maturano e ogni dipendente sceglie tra pagamento e recupero.",
            "title": "Pause scalate in automatico"
          }
        ],
        "headline": "Rilevazione presenze per negozi — timbratura dei turni, sostituzioni ed export pronto per le paghe, in un'unica app",
        "workflow": [
          {
            "body": "Un tap dal telefono all'inizio del turno. Le sostituzioni in un'altra filiale vengono registrate su quella filiale.",
            "step": "Il personale timbra il turno"
          },
          {
            "body": "Una vista in tempo reale su tutte le sedi — individui un turno di apertura scoperto prima che il negozio apra.",
            "step": "Vedi chi è in servizio, per negozio"
          },
          {
            "body": "Ore, pause e straordinari per dipendente e per negozio, esportati pronti per il vostro consulente paghe.",
            "step": "Paghe in un unico export"
          }
        ],
        "compliance": {
          "body": "Done-it conserva un registro digitale e oggettivo di ogni entrata e uscita, con pause e straordinari — il registro che un audit o una contestazione sulle paghe richiede.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione presenze a turni",
          "title": "Un registro difendibile di ogni turno lavorato"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Uffici e servizi professionali",
        "slug": "offices",
        "intro": "Commercialisti, notai, architetti, agenzie e società di consulenza fatturano il proprio tempo — o quantomeno devono sapere dov'è finito. Done-it registra le ore sul cliente e sul progetto giusti, dalla scrivania o fuori sede.",
        "pains": [
          {
            "body": "Il tempo annotato a fine settimana è tempo stimato. Ore intere spariscono in silenzio tra il lavoro e la fattura.",
            "title": "Ore fatturabili ricostruite il venerdì"
          },
          {
            "body": "Il compenso è stato concordato mesi fa. Se il lavoro ci sta ancora dentro si scopre solo quando qualcuno fa i conti — di solito troppo tardi.",
            "title": "Nessuna idea di quanto costi davvero un cliente"
          },
          {
            "body": "Una parte del team è in ufficio, una a casa, una dal cliente. La presenza smette di essere un dato e diventa una ricostruzione.",
            "title": "Il lavoro ibrido rende il registro incompleto"
          }
        ],
        "quote": {
          "who": "Socio, studio commercialistico · 8 dipendenti",
          "text": "Ogni venerdì ricostruivamo la settimana. Ora le ore sono già sul cliente giusto e vedo quali pratiche stanno erodendo il compenso.",
          "result": "Ore fatturabili recuperate ogni mese"
        },
        "stats": [
          {
            "label": "ore visibili mentre il lavoro è ancora in corso",
            "value": "Per cliente"
          },
          {
            "label": "stesso registro, telefono e browser",
            "value": "In sede o fuori"
          },
          {
            "label": "per paghe e fatturazione",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Ogni registrazione finisce su un progetto, così vedi le ore per cliente senza esportare nulla e senza chiedere a nessuno.",
            "title": "Ore su cliente e progetto"
          },
          {
            "body": "La stessa app su telefono o browser. Una visita da un cliente conta come lavoro su quel cliente, trasferta inclusa se lo desideri.",
            "title": "Funziona alla scrivania e fuori sede"
          },
          {
            "body": "Ore extra registrate nel momento in cui maturano, ferie richieste e approvate nell'app — niente foglio parallelo con chi è assente e quando.",
            "title": "Straordinari e ferie in un solo posto"
          }
        ],
        "headline": "Rilevazione presenze per uffici — ore per cliente e per progetto, senza fogli di calcolo",
        "workflow": [
          {
            "body": "Lo configuri una volta con il cliente e, se fatturi a budget, con le ore che avevi previsto.",
            "step": "Apri un progetto cliente"
          },
          {
            "body": "Dalla scrivania o dal telefono. Ogni ora finisce su un cliente, non nella memoria di qualcuno.",
            "step": "Il team ci registra il tempo"
          },
          {
            "body": "Totali in tempo reale per progetto e un export pulito per paghe o fatturazione a fine mese.",
            "step": "Vedi le ore per cliente, esporti per le paghe"
          }
        ],
        "compliance": {
          "body": "Done-it conserva un registro digitale e a prova di manomissione dell'orario di lavoro per dipendente — la base sia per le paghe sia per una fattura al cliente difendibile.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione presenze per cliente",
          "title": "Un registro oggettivo delle ore lavorate"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Saloni e cura della persona",
        "slug": "beauty",
        "intro": "Parrucchieri, barbieri, centri estetici e nail studio vivono di turni e contratti part-time. Done-it registra chi ha lavorato e quando, scala le pause in automatico e consegna alle paghe un file pulito.",
        "pains": [
          {
            "body": "Tre giorni una settimana, quattro quella dopo, un sabato scambiato con un martedì. Ore contrattuali e ore lavorate divergono in fretta.",
            "title": "Contratti part-time, variazioni infinite"
          },
          {
            "body": "Gli appuntamenti dicono cosa è stato prenotato, non chi ha lavorato. Quando lo chiedono le paghe o un'ispezione, il gestionale delle prenotazioni è la risposta sbagliata.",
            "title": "L'agenda non è un registro presenze"
          },
          {
            "body": "Restare oltre l'orario per un ultimo cliente si ricorda, si promette e a volte si dimentica. È il tipo di buco che diventa una contestazione.",
            "title": "Ore extra sistemate a voce"
          }
        ],
        "quote": {
          "who": "Titolare, salone di parrucchiere · 6 dipendenti",
          "text": "Sono tutti part-time e ogni settimana è diversa. L'app lo registra e basta — ho smesso di ricostruire il mese in un foglio di calcolo.",
          "result": "Niente più ore contestate a fine mese"
        },
        "stats": [
          {
            "label": "per timbrare — niente di condiviso, niente su carta",
            "value": "1 tap"
          },
          {
            "label": "pause scalate su ogni turno",
            "value": "Auto"
          },
          {
            "label": "ore extra sistemate a memoria",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Un tap dal proprio telefono all'inizio del turno — nessun terminale condiviso alla reception, nessun foglio firme accanto allo specchio.",
            "title": "Timbrare in salone"
          },
          {
            "body": "Imposti la regola delle pause e l'orario standard una volta; valgono per ogni turno, con eccezioni per persona dove il contratto è diverso.",
            "title": "Pause e regole part-time una volta sola"
          },
          {
            "body": "Le ore extra vengono registrate mentre si lavorano e ogni dipendente sceglie tra pagamento e recupero — si chiude nell'app, non a memoria.",
            "title": "Straordinari, pagati o recuperati"
          }
        ],
        "headline": "Rilevazione presenze per saloni — turni, ore part-time e paghe senza agenda cartacea",
        "workflow": [
          {
            "body": "Un tap all'arrivo. Le pause vengono scalate con la regola impostata una volta.",
            "step": "Il personale timbra il turno"
          },
          {
            "body": "Chi è in servizio, chi è in pausa, chi è rimasto oltre l'orario — in tempo reale, senza chiedere.",
            "step": "Vedi la giornata mentre scorre"
          },
          {
            "body": "Ore lavorate, pause e straordinari per dipendente, esportati per il vostro consulente paghe.",
            "step": "Le paghe ricevono un file pulito"
          }
        ],
        "compliance": {
          "body": "Done-it registra l'orario di lavoro effettivo per dipendente, con pause e straordinari — separato dalle prenotazioni e difendibile quando viene verificato.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione presenze digitale",
          "title": "Un registro che regge oltre l'agenda appuntamenti"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salute e benessere",
        "slug": "wellness",
        "intro": "Palestre, studi fitness, centri di fisioterapia e spa hanno orari di apertura lunghi e personale che ruota. Done-it registra chi ha coperto quale turno, scala le pause in automatico ed esporta le paghe senza intoppi.",
        "pains": [
          {
            "body": "Turni mattutini, corsi serali e weekend, coperti da un mix di full-time, part-time e collaboratori. Il planning è un piano, non un registro.",
            "title": "Orari lunghi, coperture a rotazione"
          },
          {
            "body": "Un istruttore tiene due corsi e nel mezzo copre la reception. Pagarlo correttamente significa sapere cosa è stato davvero lavorato, non cosa era in programma.",
            "title": "Ore di corso e ore in sala si confondono"
          },
          {
            "body": "Il personale si sposta tra gli studi. Unire le loro ore a mano ogni mese è lento e pieno di errori.",
            "title": "Più sedi, un'unica amministrazione"
          }
        ],
        "quote": {
          "who": "Responsabile, studio fitness · 14 dipendenti",
          "text": "Due studi, orari lunghi e tante sostituzioni. Ora le ore finiscono sulla sede giusta e le paghe sono un unico file.",
          "result": "Planning e paghe finalmente coincidono"
        },
        "stats": [
          {
            "label": "ore, anche quando il personale copre altrove",
            "value": "Per studio"
          },
          {
            "label": "la sala in tempo reale, in tutte le sedi",
            "value": "Live"
          },
          {
            "label": "pause e straordinari, nessun calcolo manuale",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Un tap dal telefono nella sede in cui si lavora. La copertura in un altro studio finisce sulle ore di quello studio.",
            "title": "Timbratura per studio"
          },
          {
            "body": "Vedi la sala in ogni sede in tempo reale — un turno mattutino scoperto si vede prima dell'apertura, non dopo.",
            "title": "Vista live di chi è in servizio"
          },
          {
            "body": "Regole delle pause applicate in automatico, ore extra registrate mentre maturano con pagamento o recupero a scelta del dipendente.",
            "title": "Pause e straordinari gestiti"
          }
        ],
        "headline": "Rilevazione presenze per palestre, studi e spa — turni, corsi e paghe in un'unica app",
        "workflow": [
          {
            "body": "Un tap all'inizio del turno, nella sede in cui si lavora.",
            "step": "Il personale timbra in studio"
          },
          {
            "body": "Chi è in servizio e in quale sede in questo momento, così i buchi si coprono prima che gli iscritti se ne accorgano.",
            "step": "Le coperture si vedono in tempo reale"
          },
          {
            "body": "Ore, pause e straordinari per dipendente e per studio, pronti per il consulente paghe.",
            "step": "Un export per le paghe"
          }
        ],
        "compliance": {
          "body": "Done-it conserva un registro digitale dell'orario di lavoro per dipendente e per sede — la base per una retribuzione corretta e per qualsiasi verifica sulle ore lavorate.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione turni multi-sede",
          "title": "Un registro oggettivo per ogni turno e ogni sede"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Ristorazione e ospitalità",
        "slug": "hospitality",
        "intro": "Turni spezzati, chiusure tardive e un sabato pieno che sfora. Done-it registra le ore come vengono davvero lavorate, scala le pause secondo la vostra regola e consegna alle paghe un unico file pulito.",
        "pains": [
          {
            "body": "Il servizio va per le lunghe, la chiusura porta via un'altra mezz'ora. Quei minuti sono lavoro vero, e sistemarli a memoria è così che nascono le contestazioni.",
            "title": "Il turno non finisce mai quando dice il planning"
          },
          {
            "body": "Servizio a pranzo, una pausa, poi la cena. Sulla carta diventa un unico blocco lungo o due stime — nessuna delle due è la verità.",
            "title": "I turni spezzati sono difficili da registrare"
          },
          {
            "body": "Personale nuovo ogni stagione. Un sistema che richiede formazione non sopravvive alla prima settimana piena.",
            "title": "Turnover alto, inserimenti continui"
          }
        ],
        "quote": {
          "who": "Titolare, ristorante · 17 dipendenti",
          "text": "La chiusura sfora sempre. Ora quei minuti vengono registrati invece che discussi, e il personale può recuperarli come permesso.",
          "result": "Meno contestazioni, paghe più veloci"
        },
        "stats": [
          {
            "label": "registrati come due blocchi, non come una stima",
            "value": "Turni spezzati"
          },
          {
            "label": "pause scalate secondo la vostra regola",
            "value": "Auto"
          },
          {
            "label": "per inserire un nuovo assunto — usa il suo telefono",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Un tap all'inizio e alla fine di ogni blocco, così i turni spezzati restano registrati come sono andati — non fusi in uno solo.",
            "title": "Entrata e uscita per ogni servizio"
          },
          {
            "body": "Pause obbligatorie scalate in automatico, con eccezioni per persona dove serve al contratto. Nessun calcolo manuale a fine mese.",
            "title": "Pause secondo la vostra regola"
          },
          {
            "body": "La mezz'ora in più dopo la chiusura viene registrata nel momento in cui si lavora e viene pagata o recuperata come permesso — sceglie il dipendente.",
            "title": "Straordinari chiusi nell'app"
          }
        ],
        "headline": "Rilevazione presenze per bar, ristoranti e hotel — turni, pause e straordinari, chiusi in modo equo",
        "workflow": [
          {
            "body": "Un tap all'inizio del blocco e lo stesso alla fine. I turni spezzati restano spezzati.",
            "step": "Il personale timbra per il servizio"
          },
          {
            "body": "Chi è in servizio stasera, chi è ancora in pausa, chi è rimasto oltre la chiusura.",
            "step": "Vedi la sala in tempo reale"
          },
          {
            "body": "Tempo lavorato, pause e straordinari per dipendente, esportati in un unico file.",
            "step": "Le paghe ricevono le ore reali"
          }
        ],
        "compliance": {
          "body": "Done-it conserva un registro digitale e oggettivo di ogni turno, pausa e ora extra — esattamente ciò che una verifica sulle paghe o un'ispezione del lavoro chiede di vedere.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Rilevazione turni spezzati",
          "title": "Un registro difendibile delle ore in un team ad alto turnover"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sanità e assistenza",
        "slug": "healthcare",
        "intro": "Ambulatori, team di assistenza domiciliare e case di riposo ruotano intorno a turni, visite e obblighi documentali stringenti. Done-it registra il tempo lavorato per turno e per visita, e tiene i documenti dei dipendenti dove sai ritrovarli.",
        "pains": [
          {
            "body": "Le visite domiciliari stanno in uno strumento, le ore pianificate in un altro e alle paghe arriva una terza versione. Riconciliarli è un lavoro mensile.",
            "title": "Visite e turni in sistemi separati"
          },
          {
            "body": "Le ore disagiate hanno tariffe diverse. Quando il registro è approssimativo, lo è anche la retribuzione — e la correzione arriva dopo.",
            "title": "Ore notturne e festive valorizzate male"
          },
          {
            "body": "Qualifiche e certificazioni contano nell'assistenza, e restano in una cartella che nessuno apre finché non arriva un'ispezione.",
            "title": "I certificati scadono in silenzio"
          }
        ],
        "quote": {
          "who": "Coordinatrice, team di assistenza domiciliare · 22 dipendenti",
          "text": "Visite domiciliari e turni pianificati stanno finalmente nello stesso registro. Le paghe hanno smesso di essere un lavoro di riconciliazione.",
          "result": "Un solo registro invece di tre"
        },
        "stats": [
          {
            "label": "o per turno — a seconda di come lavora il team",
            "value": "Per visita"
          },
          {
            "label": "ore notturne e festive, registrate come lavorate",
            "value": "Distinte"
          },
          {
            "label": "certificati conservati per dipendente",
            "value": "Archiviati"
          }
        ],
        "features": [
          {
            "body": "Un tap all'inizio del turno, oppure a ogni indirizzo del cliente per l'assistenza domiciliare — con verifica della posizione dove serve la prova.",
            "title": "Timbratura per turno o per visita"
          },
          {
            "body": "Ore notturne, festive e ordinarie vengono registrate distintamente, così l'export per le paghe rispecchia già come il lavoro viene effettivamente retribuito.",
            "title": "Ore suddivise come le paghi"
          },
          {
            "body": "Contratti, certificati e documenti d'identità archiviati accanto alla persona a cui appartengono — si trovano in pochi secondi quando qualcuno li chiede.",
            "title": "Documenti dei dipendenti in un unico posto"
          }
        ],
        "headline": "Rilevazione presenze per team di assistenza — turni, visite domiciliari e qualifiche, in un unico registro",
        "workflow": [
          {
            "body": "Un tap in sede o all'indirizzo del cliente, con verifica della posizione dove serve la prova.",
            "step": "Timbri per il turno o la visita"
          },
          {
            "body": "Ore ordinarie, notturne e festive registrate distintamente mentre maturano.",
            "step": "Le ore finiscono nella voce giusta"
          },
          {
            "body": "Un file pulito per periodo, già suddiviso come lo paghi.",
            "step": "Export per le paghe"
          }
        ],
        "compliance": {
          "body": "Done-it conserva un registro digitale e oggettivo dell'orario di lavoro per dipendente — ore, pause e suddivisione delle ore disagiate — insieme ai documenti di ogni persona.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrazione turni e visite",
          "title": "Registri che reggono un'ispezione"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "pt": [
      {
        "name": "Construção",
        "slug": "construction",
        "intro": "Equipas espalhadas por várias obras, horas anotadas em papel, horas de subcontratados impossíveis de reconciliar. A Done-it dá a cada obra uma folha de horas digital à prova de água que alimenta o seu processamento salarial com um clique.",
        "pains": [
          {
            "body": "Com várias obras ativas e equipas que rodam, as folhas de horas manuais estão erradas por natureza. Os trabalhadores arredondam, esquecem-se de registos ou preenchem-nos dias depois — deixando-o com números salariais que não consegue defender.",
            "title": "Sem registo fiável de quem trabalhou onde"
          },
          {
            "body": "Quando percebe que uma obra já consumiu as horas planeadas, a margem já se foi. Não há uma contagem decrescente em tempo real — apenas uma surpresa desagradável na altura de faturar.",
            "title": "Os desvios de orçamento aparecem demasiado tarde"
          },
          {
            "body": "Recolher as folhas de horas, reconciliá-las com os projetos e preparar a exportação para o processamento salarial demora dias. Cada registo é um erro em potencial.",
            "title": "A preparação do salário consome horas todos os meses"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de construção · 14 colaboradores",
          "text": "A nossa equipa faz o seu próprio check-in na obra. No fecho do mês, o salário simplesmente fecha — deixámos por completo de andar atrás das folhas de horas.",
          "result": "5 horas por semana poupadas em tarefas administrativas"
        },
        "stats": [
          {
            "label": "para fazer check-in em qualquer obra — sem terminal, sem papel",
            "value": "1 toque"
          },
          {
            "label": "exportação salarial pronta para o seu prestador",
            "value": "1 clique"
          },
          {
            "label": "vista de horas restantes por projeto e obra",
            "value": "Tempo real"
          }
        ],
        "features": [
          {
            "body": "Um toque regista a entrada do trabalhador, com verificação de localização, e associa as horas ao projeto certo. Sem leitores de cartões, sem terminais — apenas o smartphone que a sua equipa já tem consigo.",
            "title": "Check-in com verificação de localização por obra"
          },
          {
            "body": "Defina as horas planeadas como orçamento quando abre o projeto. Os trabalhadores veem uma contagem decrescente do que resta; o gestor vê-a em tempo real no painel. Os desvios de orçamento são visíveis antes de acontecerem.",
            "title": "Horas restantes em tempo real por projeto"
          },
          {
            "body": "Adicione subcontratados a um projeto, atribua-lhes o check-in e acompanhe as suas horas a par da sua própria equipa — na mesma visão geral.",
            "title": "Gestão de subcontratados e presença"
          },
          {
            "body": "Todas as horas registadas — por trabalhador, por projeto — exportam para uma folha de cálculo limpa para o seu prestador de processamento salarial. Sem preparação manual, sem erros.",
            "title": "Exportação salarial com um clique"
          }
        ],
        "headline": "Registo de tempo para equipas de construção — check-in com verificação de localização, horas por obra e controlo de orçamento, numa só aplicação",
        "workflow": [
          {
            "body": "Cada trabalhador toca uma vez para fazer check-in. O GPS confirma a localização, regista a hora da entrada e associa as horas ao projeto. Sem papel, sem terminal.",
            "step": "A equipa chega à obra"
          },
          {
            "body": "Horas, orçamento restante, presença de subcontratados e qualquer trabalho extra reportado da obra — tudo no seu painel, em tempo real.",
            "step": "Vê tudo em tempo real"
          },
          {
            "body": "Exporte todas as horas por trabalhador e por projeto. Envie ao seu prestador de processamento salarial. A Done-it gera relatórios limpos e prontos para auditoria automaticamente.",
            "step": "Fecho do mês em minutos"
          }
        ],
        "compliance": {
          "body": "A Done-it oferece check-in com verificação de localização, registo de tempo por projeto e uma exportação salarial limpa para equipas de construção. Para equipas que operam em obras belgas, alimenta também automaticamente o check-in no trabalho.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo digital",
          "title": "Check-in com verificação de localização concebido para obras de construção"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Limpeza",
        "slug": "cleaning",
        "intro": "Os funcionários de limpeza deslocam-se entre locais durante todo o dia. A Done-it acompanha quem está onde em tempo real — check-in com verificação de localização em cada local, dedução automática de pausas e uma exportação salarial limpa no fecho do mês.",
        "pains": [
          {
            "body": "Clientes e inspetores esperam registos de presença à prova de água. As folhas manuais podem ser contestadas; os check-ins digitais com verificação de localização não.",
            "title": "Provar a presença em cada local"
          },
          {
            "body": "Com os funcionários de limpeza a deslocarem-se entre locais ao longo do dia, não tem uma visão em tempo real de quem está a trabalhar onde — até alguém ligar.",
            "title": "Equipas espalhadas por muitos locais"
          },
          {
            "body": "Sem horas exatas de entrada e saída, o salário é reconstruído de memória. As horas são arredondadas para cima, os custos inflacionam e seguem-se as disputas.",
            "title": "Erros salariais por horas arredondadas"
          }
        ],
        "quote": {
          "who": "Gestor, empresa de limpeza · 9 colaboradores",
          "text": "Conseguimos finalmente provar quem limpou onde e quando. Acabaram-se as folhas de presença, acabaram-se as disputas com os clientes — o GPS trata disso.",
          "result": "Zero arredondamentos de horas"
        },
        "stats": [
          {
            "label": "para fazer check-in em qualquer local — sem terminal",
            "value": "1 toque"
          },
          {
            "label": "vista de quem está em que local neste momento",
            "value": "Tempo real"
          },
          {
            "label": "registos duplicados — as horas fluem diretamente para o salário",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Os trabalhadores registam a entrada e a saída no telemóvel em cada local, com verificação de localização; o tempo é exato, com registo de pausas.",
            "plan": "Time Basic",
            "title": "Check-in e check-out em tempo real"
          },
          {
            "body": "As pausas obrigatórias são subtraídas do dia de trabalho automaticamente — sem cálculos manuais, sem disputas.",
            "plan": "Time Basic",
            "title": "Dedução automática de pausas"
          },
          {
            "body": "Veja que funcionários de limpeza estão em que locais neste momento. Detete falhas antes dos clientes.",
            "title": "Visão geral em tempo real de vários locais"
          },
          {
            "body": "Os trabalhadores carregam certificados de baixa e documentos de ausência diretamente a partir da aplicação. Crie os tipos de ausência que a sua equipa realmente utiliza.",
            "title": "Registo de ausências com justificações de baixa digitais"
          },
          {
            "body": "As horas exatas fluem diretamente para uma exportação pronta para o processamento salarial do seu prestador. Sem transcrição, sem erros.",
            "title": "Exportação salarial com um clique"
          }
        ],
        "headline": "Registo de tempo para empresas de limpeza — check-in com verificação de localização, prova de presença e salário numa só aplicação",
        "workflow": [
          {
            "body": "Um toque regista a entrada. O GPS regista o local e a hora da entrada. O registo de pausas está integrado na aplicação.",
            "step": "O funcionário de limpeza chega ao local"
          },
          {
            "body": "Quem está em que local neste momento — sem telefonemas, sem adivinhação. Detete falhas de cobertura antes dos clientes.",
            "step": "Vê cada local em tempo real"
          },
          {
            "body": "Todos os dados de presença — horas exatas, locais e pausas — exportam de forma limpa para o seu prestador de processamento salarial.",
            "step": "O salário é um clique"
          }
        ],
        "compliance": {
          "body": "A Done-it dá às equipas de limpeza check-in com verificação de localização em cada local, dedução automática de pausas e uma visão em tempo real de quem está em que local neste momento.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Presença com verificação de localização",
          "title": "Presença em tempo real em todos os locais de limpeza"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Instalação",
        "slug": "installation",
        "intro": "Envie os seus instaladores para a morada certa com tudo o que precisam, associe automaticamente cada hora trabalhada ao serviço certo e veja o orçamento restante antes de a obra fechar. A Done-it é a forma mais simples de manter os projetos de instalação dentro do prazo e do custo.",
        "pains": [
          {
            "body": "As equipas chegam a uma obra sem a morada, a pessoa de contacto ou os detalhes do âmbito. Esse primeiro telefonema são dez minutos de tempo faturável perdidos antes de se trabalhar uma única hora.",
            "title": "A informação do serviço não chega ao terreno a tempo"
          },
          {
            "body": "Quando os trabalhadores preenchem as horas manualmente ao fim do dia — se é que as preenchem — as horas vão parar ao serviço errado, ou desaparecem por completo. As faturas não correspondem à realidade.",
            "title": "As horas não estão associadas ao projeto certo"
          },
          {
            "body": "Sem uma contagem decrescente em tempo real das horas restantes por projeto, só descobre que um serviço excedeu o previsto quando fecha a fatura — não enquanto ainda pode reagir.",
            "title": "Desvios de orçamento detetados demasiado tarde"
          },
          {
            "body": "Os subcontratados que trabalham na mesma obra usam sistemas diferentes, preenchem as horas em separado ou não o fazem de todo. Reconciliar no fecho do mês é um processo lento e propenso a erros.",
            "title": "Horas de subcontratados difíceis de acompanhar"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de instalação · 6 colaboradores",
          "text": "As horas vão parar ao projeto certo automaticamente. O cálculo de custos por serviço passou a ser fácil — conseguimos ver a margem real antes de fechar um serviço.",
          "result": "Custo real por serviço, em tempo real"
        },
        "stats": [
          {
            "label": "vista de horas restantes por projeto",
            "value": "Tempo real"
          },
          {
            "label": "chamadas ao escritório a pedir moradas de obras",
            "value": "0"
          },
          {
            "label": "navegue para qualquer morada de projeto a partir da aplicação",
            "value": "1 clique"
          }
        ],
        "features": [
          {
            "body": "Os trabalhadores abrem o projeto no telemóvel: morada, horas planeadas, pessoa de contacto e ficheiros carregados (plantas, instruções, PDFs). Tudo o que precisam está lá antes de chegarem.",
            "plan": "Project Basic",
            "title": "Informação do projeto partilhada diretamente para a aplicação"
          },
          {
            "body": "Toque uma vez e o telemóvel navega até à morada do projeto — integrado na aplicação, sem necessidade de uma aplicação de mapas separada.",
            "title": "Navegação para a obra com um botão"
          },
          {
            "body": "Defina as horas planeadas quando abre o projeto. Os trabalhadores veem quantas horas restam; o gestor vê o estado em tempo real no painel. Os desvios são visíveis antes de acontecerem.",
            "plan": "Project Basic",
            "title": "Contagem decrescente de horas restantes por projeto"
          },
          {
            "body": "Cada trabalhador faz check-in no projeto certo. Sabe sempre quem está em que obra neste momento.",
            "plan": "Project Basic",
            "title": "Check-in do trabalhador por projeto"
          },
          {
            "body": "Quando o âmbito aumenta na obra, os trabalhadores registam o trabalho extra e os materiais em tempo real — com texto e fotos — para que nada seja faturado de memória.",
            "plan": "Project Basic",
            "title": "Registo de trabalho extra e materiais"
          }
        ],
        "headline": "Registo de tempo para equipas de instalação — horas por projeto, navegação e controlo de orçamento numa só aplicação",
        "workflow": [
          {
            "body": "A morada, o contacto, o âmbito e os ficheiros carregados estão ali mesmo. Navega com um toque — sem chamadas ao escritório a pedir direções.",
            "step": "O trabalhador abre o projeto no telemóvel"
          },
          {
            "body": "O check-in associa cada minuto trabalhado ao projeto correto. O orçamento restante atualiza-se em tempo real.",
            "step": "As horas registam-se automaticamente no serviço certo"
          },
          {
            "body": "As alterações de âmbito, os materiais extra e os atrasos são registados com texto e fotos no momento em que acontecem — prontos para a fatura.",
            "step": "O trabalho extra é capturado na obra"
          }
        ],
        "compliance": {
          "body": "A Done-it dá às equipas de instalação check-in com verificação de localização por projeto, uma contagem decrescente de horas restantes em tempo real e exportação salarial automática — cobrindo qualquer requisito local de registo de tempo. Para equipas que trabalham em obras de construção belgas, integra também com o CIAO@work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo digital",
          "title": "Check-in com verificação de localização por projeto para equipas de instalação"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Assistência técnica no terreno",
        "slug": "field-service",
        "intro": "Técnicos que visitam vários clientes por dia, recibos no porta-luvas, quilometragem registada de memória. A Done-it captura as horas, os quilómetros e as despesas no terreno — associados ao serviço certo no momento em que acontecem.",
        "pains": [
          {
            "body": "Pedir aos técnicos que reconstruam os seus percursos no fim da semana significa reembolsos imprecisos, disputas com os clientes e uma pilha crescente de quilómetros não reclamados.",
            "title": "Quilometragem registada dias depois — quando muito"
          },
          {
            "body": "Um recibo no porta-luvas é um custo que pode nunca chegar a entrar numa fatura. O custo real por serviço fica sempre subestimado.",
            "title": "Despesas em recibos de papel que desaparecem"
          },
          {
            "body": "Sem check-ins em tempo real, só descobre onde está um técnico quando algo corre mal e alguém liga.",
            "title": "Sem visão em tempo real de onde está a equipa"
          },
          {
            "body": "Quando a mão de obra, as deslocações e as despesas são acompanhadas em sistemas separados — ou não são acompanhadas de todo — nunca existe um único valor de custo por serviço.",
            "title": "Difícil ver a margem real por serviço"
          }
        ],
        "quote": {
          "who": "Gestor de operações, empresa de assistência técnica no terreno · 11 colaboradores",
          "text": "A quilometragem costumava ser uma dor de cabeça mensal. Agora regista-se sozinha — cada quilómetro está associado ao cliente certo antes mesmo de regressarmos ao escritório.",
          "result": "Custo por serviço exato, sempre"
        },
        "stats": [
          {
            "label": "captura de quilometragem — sem caderno de bordo manual",
            "value": "Automática"
          },
          {
            "label": "custo por serviço: horas + deslocações + despesas",
            "value": "Tempo real"
          },
          {
            "label": "quilómetros perdidos — cada viagem capturada automaticamente",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "O GPS regista a partida, a chegada e a distância exata por viagem. Configure tipos de transporte (carro próprio, viatura da empresa, boleia) com as suas próprias taxas de reembolso. Sem caderno de bordo manual.",
            "plan": "Add-on",
            "title": "Captura automática de quilometragem (Trax-it)"
          },
          {
            "body": "Os trabalhadores fotografam um recibo no terreno; fica associado ao serviço e pronto para reembolso — sem ter de andar atrás dele no fecho do mês.",
            "plan": "Time Basic",
            "title": "Gestão de despesas na obra"
          },
          {
            "body": "As horas, a quilometragem e as despesas acumulam-se no serviço em tempo real. O custo por serviço fica visível enquanto o serviço ainda está em aberto.",
            "plan": "Project Basic",
            "title": "Controlo de custos associado ao projeto"
          },
          {
            "body": "Cada técnico faz check-in no local do cliente. Vê quem está onde, neste momento — sem chamadas, sem adivinhação.",
            "title": "Check-in com verificação de localização e visão geral da equipa em tempo real"
          },
          {
            "body": "As horas e os reembolsos de quilometragem exportam de forma limpa para o seu prestador de processamento salarial — com as suas taxas de quilometragem configuradas aplicadas automaticamente.",
            "title": "Exportação salarial com um clique"
          }
        ],
        "headline": "Registo de tempo para equipas de assistência técnica no terreno — quilometragem, despesas e horas a partir da estrada, tudo numa só aplicação",
        "workflow": [
          {
            "body": "O check-in inicia o registo da viagem. Os quilómetros são capturados automaticamente da partida à chegada — sem introdução manual.",
            "step": "O técnico parte para a primeira intervenção"
          },
          {
            "body": "As horas associam-se ao projeto certo. O trabalho extra, os materiais e os recibos são registados na aplicação no momento em que acontecem.",
            "step": "No local do serviço"
          },
          {
            "body": "Cada hora, quilómetro e despesa já está associada ao serviço correto. Exporte para o salário e fature com valores de custo reais.",
            "step": "Fecho do mês sem o caos"
          }
        ],
        "compliance": {
          "body": "A Done-it captura a quilometragem automaticamente por viagem, aplica as suas taxas de reembolso configuradas e regista cada quilómetro ao cliente ou projeto certo. O acórdão Tyco da UE significa que a deslocação de casa ao primeiro cliente conta como tempo de trabalho — a Done-it acompanha isso também.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Registo digital de tempo e quilometragem",
          "title": "Horas por GPS e quilometragem automática para equipas de assistência técnica no terreno"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "AVAC",
        "slug": "hvac",
        "intro": "Cada intervenção de assistência tem três custos: mão de obra, peças e deslocação. A Done-it captura os três no terreno e acumula-os no serviço certo — para que conheça a sua margem antes de fechar a fatura.",
        "pains": [
          {
            "body": "A mão de obra, as peças e a deslocação vivem em sistemas diferentes — ou em bolsos diferentes. O custo real de uma intervenção só fica claro muito depois de o técnico ter saído do local.",
            "title": "As intervenções são difíceis de orçamentar com precisão"
          },
          {
            "body": "Quando um cliente contesta quanto tempo demorou uma reparação, uma folha de horas em papel é fácil de contestar. As horas de check-in e check-out confirmadas por GPS não são.",
            "title": "Sem prova do tempo de serviço"
          },
          {
            "body": "Nos contratos de manutenção recorrentes, pequenos excessos acumulam-se ao longo de muitas visitas. Sem um contador de horas em tempo real, só descobre que o contrato está no vermelho na renovação.",
            "title": "Os contratos de manutenção corroem a margem em silêncio"
          },
          {
            "body": "Os registos de tempo manuais falham as pausas, levando a pagamentos a mais e a um salário que não corresponde à realidade.",
            "title": "Os técnicos esquecem-se de registar pausas"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de AVAC · 7 técnicos",
          "text": "Finalmente sabemos quanto cada contrato de assistência nos custa realmente. As surpresas na margem acabaram no dia em que começámos a usar a Done-it.",
          "result": "Custo real por intervenção, em tempo real"
        },
        "stats": [
          {
            "label": "tipos de custo capturados por intervenção: mão de obra, deslocações, peças",
            "value": "3"
          },
          {
            "label": "visibilidade da margem por contrato de assistência",
            "value": "Tempo real"
          },
          {
            "label": "surpresas na altura de faturar — custos visíveis em tempo real",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Cada intervenção ou contrato de manutenção é um projeto. As horas, as deslocações e os materiais acumulam-se em tempo real — dando-lhe visibilidade da margem em tempo real.",
            "plan": "Project Basic",
            "title": "Registo de tempo por projeto"
          },
          {
            "body": "Quando um serviço cresce, os técnicos registam o trabalho extra e as peças com texto e fotos antes de saírem. Nada é faturado de memória.",
            "plan": "Project Basic",
            "title": "Trabalho extra e materiais, registados na obra"
          },
          {
            "body": "Os quilómetros por intervenção são registados automaticamente e imputados ao serviço. Configure taxas de reembolso por tipo de viatura.",
            "plan": "Add-on",
            "title": "Custos de quilometragem e transporte"
          },
          {
            "body": "As pausas obrigatórias são subtraídas automaticamente do tempo total — sem disputas, sem erros salariais.",
            "title": "Dedução automática de pausas"
          },
          {
            "body": "Check-in com data e hora, confirmado por GPS, em cada local. Prova inquestionável de quando o técnico chegou e saiu.",
            "title": "Check-in com verificação de localização e prova de presença"
          }
        ],
        "headline": "Registo de tempo para técnicos de AVAC — cálculo de custos por serviço, peças e deslocações numa só aplicação",
        "workflow": [
          {
            "body": "O GPS regista a hora da chegada e associa as horas à intervenção ou ao contrato de manutenção. Sem papel, sem terminal.",
            "step": "O técnico faz check-in no local"
          },
          {
            "body": "As peças usadas, as horas extra e as alterações de âmbito são registadas na aplicação com fotos — antes de sair do local.",
            "step": "O trabalho extra é capturado no momento"
          },
          {
            "body": "A mão de obra, as deslocações e os materiais somam-se ao projeto em tempo real. Vê a margem antes de emitir a fatura.",
            "step": "O custo do serviço fica visível de imediato"
          }
        ],
        "compliance": {
          "body": "A Done-it dá às equipas de AVAC check-in com verificação de localização por intervenção, visibilidade de custos em tempo real por serviço (mão de obra + deslocações + peças) e uma exportação salarial limpa — cumprindo qualquer requisito local de registo de tempo sem hardware adicional.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo digital de tempo e custos",
          "title": "Cálculo de custos completo para intervenções de AVAC"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Eletricistas",
        "slug": "electricians",
        "intro": "Horas por projeto, uma contagem decrescente em tempo real do orçamento restante e navegação para a obra com um botão — concebido para pequenas equipas de eletricidade que precisam de controlo de projeto sem a sobrecarga administrativa.",
        "pains": [
          {
            "body": "Quando os eletricistas trabalham em vários serviços numa semana, atribuir manualmente as horas ao fim do dia leva a custos mal imputados, disputas de faturação e um salário que não consegue explicar.",
            "title": "As horas não estão associadas ao projeto certo"
          },
          {
            "body": "Sem uma visão em tempo real das horas consumidas vs. horas orçamentadas, só descobre que um projeto excedeu o previsto quando emite a fatura — não quando ainda podia reagir.",
            "title": "Desvios de orçamento detetados demasiado tarde"
          },
          {
            "body": "Moradas escritas numa aplicação separada, chamadas ao escritório a pedir direções, chegadas atrasadas a locais de clientes. Cada minuto desperdiçado é um minuto faturável perdido.",
            "title": "Tempo perdido a encontrar a obra"
          },
          {
            "body": "Em instalações maiores, os eletricistas subcontratados acompanham as suas próprias horas em separado. Obter uma visão combinada dos custos de mão de obra no fim de um projeto é uma tarefa manual e propensa a erros.",
            "title": "Horas de subcontratados difíceis de reconciliar"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de eletricidade · 5 eletricistas",
          "text": "Sabemos em tempo real se um projeto está a exceder o orçamento. Só isso nos salvou de duas surpresas más este ano.",
          "result": "Desvios de orçamento detetados antes de acontecerem"
        },
        "stats": [
          {
            "label": "vista de horas restantes por projeto",
            "value": "Tempo real"
          },
          {
            "label": "chamadas ao escritório a pedir moradas de obras",
            "value": "0"
          },
          {
            "label": "para fazer check-in em qualquer obra — sem terminal",
            "value": "1 toque"
          }
        ],
        "features": [
          {
            "body": "Cada minuto trabalhado é associado ao projeto certo automaticamente. Uma contagem decrescente em tempo real mostra quantas horas restam face ao orçamento — para si e para o trabalhador na obra.",
            "plan": "Project Basic",
            "title": "Horas por projeto com orçamento restante em tempo real"
          },
          {
            "body": "A morada do projeto está na aplicação. Um toque abre a navegação — sem procuras, sem aplicação de mapas separada, sem chamadas ao escritório.",
            "title": "Navegação para a obra com um botão"
          },
          {
            "body": "Cada eletricista faz check-in no serviço certo. Sabe sempre quem está em que obra neste momento.",
            "plan": "Project Basic",
            "title": "Check-in do trabalhador por projeto"
          },
          {
            "body": "Quando o âmbito muda — um circuito inesperado, materiais adicionais — fica registado na aplicação com fotos, antes de a equipa sair.",
            "plan": "Project Basic",
            "title": "Trabalho extra registado na obra"
          },
          {
            "body": "As horas extra são registadas no momento em que acontecem. Os trabalhadores escolhem que sejam pagas ou convertidas em tempo de folga.",
            "plan": "Time Pro",
            "title": "Registo de horas extra com compensação flexível"
          }
        ],
        "headline": "Registo de tempo para eletricistas — horas por projeto, controlo de orçamento e navegação numa só aplicação",
        "workflow": [
          {
            "body": "A morada e o âmbito já estão na aplicação. Um toque abre a navegação — sem chamadas, sem confusão.",
            "step": "O eletricista navega para o serviço"
          },
          {
            "body": "O check-in no local associa cada minuto trabalhado ao projeto correto. O contador de horas restantes atualiza-se em tempo real.",
            "step": "As horas associam-se ao projeto certo automaticamente"
          },
          {
            "body": "O trabalho extra e os materiais são registados na obra, antes de sair. A fatura reflete o que realmente aconteceu.",
            "step": "As alterações de âmbito ficam registadas"
          }
        ],
        "compliance": {
          "body": "A Done-it dá aos eletricistas check-in com verificação de localização por projeto, um orçamento de horas restantes em tempo real e exportação salarial — satisfazendo qualquer requisito local de registo de tempo. Para equipas em obras de construção belgas, integra também com o CIAO@work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Check-in com verificação de localização por projeto",
          "title": "Controlo de orçamento em tempo real e check-in com verificação de localização para equipas de eletricidade"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Canalização",
        "slug": "plumbing",
        "intro": "Intervenções de emergência, vários serviços por dia, horas preenchidas de memória no fim da semana — ou de todo. A Done-it transforma isto num trabalho de um toque em cada local e num salário de um clique no fecho do mês.",
        "pains": [
          {
            "body": "Com vários serviços num dia, os canalizadores raramente têm tempo para preencher folhas de horas exatas. As horas são arredondadas ou esquecidas, e o salário é, na melhor das hipóteses, uma estimativa.",
            "title": "Horas de intervenção reconstruídas de memória"
          },
          {
            "body": "Quando um cliente contesta quanto tempo demorou uma reparação, não há registo objetivo. Um check-in digital confirmado por GPS é fácil de apresentar — uma folha de horas em papel não é.",
            "title": "Sem prova do tempo no local"
          },
          {
            "body": "As deslocações entre intervenções acumulam-se ao longo da semana e do mês, mas sem captura automática raramente são faturadas ou reembolsadas corretamente.",
            "title": "Quilometragem entre serviços não acompanhada"
          },
          {
            "body": "No fecho do mês, andar atrás das folhas de horas, corrigir erros e construir a exportação salarial leva tempo que a sua equipa administrativa não devia estar a gastar.",
            "title": "A preparação do salário é lenta"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de canalização · 4 canalizadores",
          "text": "Costumávamos passar uma manhã no fecho do mês a reconstruir horas. Agora basta exportar e enviar. O prestador de processamento salarial recebe tudo limpo.",
          "result": "Preparação do salário reduzida de horas para minutos"
        },
        "stats": [
          {
            "label": "para fazer check-in — rápido o suficiente para chamadas de emergência",
            "value": "1 toque"
          },
          {
            "label": "exportação salarial para o seu prestador",
            "value": "1 clique"
          },
          {
            "label": "horas reconstruídas de memória no fecho do mês",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Chegada e partida registadas com um toque, com verificação de localização do local. Rápido o suficiente para chamadas de emergência; preciso o suficiente para disputas.",
            "plan": "Time Basic",
            "title": "Check-in com verificação de localização e um toque em cada intervenção"
          },
          {
            "body": "As pausas obrigatórias são subtraídas do tempo total automaticamente — nada para preencher, sem erros salariais.",
            "plan": "Time Basic",
            "title": "Dedução automática de pausas"
          },
          {
            "body": "Configure tipos de transporte e taxas de reembolso. Os quilómetros registam-se automaticamente e associam-se ao cliente ou projeto correto.",
            "plan": "Add-on",
            "title": "Quilometragem capturada por viagem"
          },
          {
            "body": "Os trabalhadores submetem justificações de baixa digitalmente a partir da aplicação. Crie os tipos de ausência que a sua equipa realmente utiliza, incluindo paragens por mau tempo.",
            "title": "Gestão de ausências e justificações de baixa"
          },
          {
            "body": "Todos os dados de horas e quilometragem exportam de forma limpa para o seu prestador de processamento salarial — sem preparação manual, sem Excel.",
            "plan": "Time Basic",
            "title": "Exportação salarial com um clique"
          }
        ],
        "headline": "Registo de tempo para equipas de canalização — check-in rápido, salário exato e prova de presença em cada intervenção",
        "workflow": [
          {
            "body": "Um toque faz check-in. O GPS regista o local e a hora. Rápido o suficiente para um serviço de emergência.",
            "step": "O canalizador chega à intervenção"
          },
          {
            "body": "O check-out fecha o registo de tempo. A quilometragem para o próximo serviço começa a ser registada automaticamente.",
            "step": "Partida registada à saída"
          },
          {
            "body": "Todas as intervenções, horas e quilómetros exportam de forma limpa. A preparação do salário passa de um dia para minutos.",
            "step": "O fecho do mês é um clique"
          }
        ],
        "compliance": {
          "body": "A Done-it cobre qualquer requisito local de registo de tempo para equipas de canalização — check-in com verificação de localização e um toque por intervenção, dedução automática de pausas e uma exportação salarial limpa. Sem folhas de horas em papel, sem reconstrução manual.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo digital",
          "title": "Check-in rápido com verificação de localização para cada intervenção"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Jardinagem e paisagismo",
        "slug": "landscaping",
        "intro": "A época alta significa muitos locais, equipas que mudam e muitos quilómetros. A Done-it mantém cada hora, cada ausência e cada viagem organizadas — para que se possa focar no trabalho, e não na papelada.",
        "pains": [
          {
            "body": "Trabalhadores temporários, horários que mudam e equipas de dimensão variável tornam o registo de horas exato quase impossível com papel. Quando reconcilia no fecho do mês, está sempre a faltar alguma coisa.",
            "title": "As equipas sazonais são complexas de gerir"
          },
          {
            "body": "Uma equipa que visita três ou quatro locais por dia gera horas que precisam de ser divididas corretamente. A introdução manual leva a má imputação e a salários contestados.",
            "title": "Horas espalhadas por muitos locais"
          },
          {
            "body": "A paragem por mau tempo é um evento real na jardinagem e paisagismo. Sem um registo digital, documentar as paragens e ajustar o pagamento é lento e propenso a erros.",
            "title": "As paragens por mau tempo são difíceis de documentar"
          },
          {
            "body": "Carrinhas da empresa, viaturas pessoais e boleias cruzam-se entre locais durante todo o dia. Sem captura automática, esses quilómetros nunca chegam a entrar na imagem de custos.",
            "title": "A quilometragem entre locais fica por acompanhar"
          }
        ],
        "quote": {
          "who": "Proprietário, empresa de jardinagem e paisagismo · 12 trabalhadores sazonais",
          "text": "A época alta costumava significar caos no salário. Agora o nosso encarregado consulta a aplicação, está toda a gente contabilizada, e eu exporto as horas no último dia do mês.",
          "result": "Sem mais reconstrução salarial no fim do mês"
        },
        "stats": [
          {
            "label": "captura de quilometragem — sem mais caderno de bordo",
            "value": "Automática"
          },
          {
            "label": "visão geral da equipa em todos os locais",
            "value": "Tempo real"
          },
          {
            "label": "exportação salarial para todos os locais e toda a equipa",
            "value": "1 clique"
          }
        ],
        "features": [
          {
            "body": "Veja toda a equipa, todos os locais em tempo real. Saiba quem está a trabalhar onde, neste momento — e não no fecho do mês.",
            "title": "Visão geral da equipa em vários locais"
          },
          {
            "body": "Planeie quem trabalha onde, lide com alterações de última hora e envie o horário para os telemóveis da equipa — sem um telefonema a cada pessoa.",
            "plan": "Time Pro",
            "title": "Planeamento de turnos para equipas sazonais"
          },
          {
            "body": "Crie tipos de ausência personalizados para o seu setor: paragens sazonais por mau tempo, licença parental, dias de baixa. Os trabalhadores carregam a documentação digitalmente a partir da aplicação.",
            "title": "Tipos de ausência personalizados"
          },
          {
            "body": "Configure tipos de transporte (carrinha da empresa, carro pessoal, condutor vs. passageiro em boleia) com as suas próprias taxas. Os quilómetros registam-se automaticamente por viagem.",
            "plan": "Add-on",
            "title": "Quilometragem com registo de boleias"
          },
          {
            "body": "As horas extra de época alta acumulam-se depressa. Cada trabalhador pode escolher ser pago ou acumular as horas como tempo de folga — acompanhado de forma transparente.",
            "plan": "Time Pro",
            "title": "Registo de horas extra com conversão em folga"
          }
        ],
        "headline": "Registo de tempo para empresas de jardinagem e paisagismo — equipas sazonais, vários locais e quilometragem numa só visão geral",
        "workflow": [
          {
            "body": "O GPS regista a chegada. As horas dividem-se automaticamente pelo local e projeto certos — sem atribuição manual ao fim do dia.",
            "step": "A equipa faz check-in no primeiro local"
          },
          {
            "body": "O encarregado regista a paragem a partir da aplicação — um registo digital limpo, sem papelada extra.",
            "step": "O mau tempo para o trabalho"
          },
          {
            "body": "As horas, as ausências e a quilometragem em cada local e de cada membro da equipa exportam de forma limpa para o salário.",
            "step": "Fecho do mês: todos os locais, toda a equipa, uma exportação"
          }
        ],
        "compliance": {
          "body": "A Done-it dá às equipas de jardinagem e paisagismo registo de tempo digital em todos os locais e pessoal sazonal — check-in com verificação de localização, tipos de ausência personalizados para paragens por mau tempo e uma exportação salarial limpa que satisfaz qualquer requisito local.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo digital",
          "title": "Check-in com verificação de localização e registo de ausências para equipas sazonais de jardinagem e paisagismo"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Manutenção",
        "slug": "maintenance",
        "intro": "Os contratos de manutenção recorrentes vivem ou morrem da visibilidade de custos. A Done-it regista cada visita, acompanha as horas face ao orçamento do contrato e dá-lhe a si — e aos seus clientes — prova de presença em cada intervenção.",
        "pains": [
          {
            "body": "Quando as horas das visitas recorrentes não são acompanhadas face ao contrato específico, não sabe se um cliente é rentável até à revisão de fim de ano — altura em que já é tarde demais para rever os preços.",
            "title": "Sem visibilidade de custos por contrato de manutenção"
          },
          {
            "body": "Os gestores de instalações e os proprietários querem cada vez mais registos de presença: quem veio, quando chegou, o que fez. Um registo em papel apresentado semanas depois não satisfaz os requisitos de SLA.",
            "title": "Os clientes esperam prova do que foi feito"
          },
          {
            "body": "Turnos rotativos por muitos locais recorrentes — com pessoal que se substitui mutuamente — criam um quebra-cabeças de agendamento e de registo de horas que os processos manuais não conseguem resolver de forma fiável.",
            "title": "Visitas recorrentes difíceis de agendar e registar"
          },
          {
            "body": "A manutenção de espaços verdes, de fachadas e de instalações exteriores enfrenta paragens relacionadas com o tempo. Documentá-las corretamente exige um rasto digital.",
            "title": "As paragens por mau tempo afetam também a manutenção no exterior"
          }
        ],
        "quote": {
          "who": "Gestor de operações, empresa de manutenção · 8 trabalhadores",
          "text": "Conseguimos dizer a um gestor de instalações exatamente quem esteve no local e quando, em dois minutos. Esse nível de prova mudou a forma como os clientes nos veem.",
          "result": "Disputas com clientes reduzidas a zero"
        },
        "stats": [
          {
            "label": "custo por contrato de manutenção",
            "value": "Tempo real"
          },
          {
            "label": "prova de presença pronta para os clientes a pedido",
            "value": "GPS"
          },
          {
            "label": "renovações de contrato sem conhecer a sua margem",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Cada contrato de manutenção é um projeto. As horas registam-se automaticamente nele, dando-lhe um valor de custo em tempo real e uma contagem decrescente de horas restantes para cada cliente.",
            "plan": "Project Basic",
            "title": "Registo de custos por contrato"
          },
          {
            "body": "Os check-ins com data e hora, verificados por localização, são um registo inquestionável de quem esteve no local, quando e durante quanto tempo — prontos a partilhar com os clientes a pedido.",
            "title": "Prova de presença confirmada por GPS"
          },
          {
            "body": "Os trabalhadores reportam problemas, tarefas concluídas ou trabalho extra diretamente a partir da aplicação — com texto e fotos. Os clientes recebem um registo em tempo real; o gestor tem a documentação para faturar.",
            "plan": "Project Basic",
            "title": "Atualizações com fotos a partir do local"
          },
          {
            "body": "Planeie as visitas recorrentes em todos os contratos, atribua trabalhadores e lide com substituições — sem um telefonema a cada pessoa.",
            "plan": "Time Pro",
            "title": "Planeamento de turnos recorrentes"
          },
          {
            "body": "Configure paragens por mau tempo e outros tipos de ausência. Os trabalhadores registam-nas a partir da aplicação; a documentação carrega-se digitalmente.",
            "title": "Tipos de ausência para manutenção no exterior"
          }
        ],
        "headline": "Registo de tempo para equipas de manutenção — visitas recorrentes a locais, custo por contrato e prova de presença numa só aplicação",
        "workflow": [
          {
            "body": "O check-in com verificação de localização regista a hora da chegada e associa as horas ao contrato correto. A prova de presença é criada automaticamente.",
            "step": "O trabalhador chega ao local de manutenção"
          },
          {
            "body": "O trabalho concluído e quaisquer problemas são reportados a partir da aplicação com fotos. Os clientes conseguem ver exatamente o que foi feito.",
            "step": "Tarefas concluídas, problemas registados"
          },
          {
            "body": "As horas acumulam-se face ao orçamento do contrato em tempo real. Conhece a margem antes de o contrato renovar.",
            "step": "Custo por contrato visível de imediato"
          }
        ],
        "compliance": {
          "body": "A Done-it dá às equipas de manutenção prova de presença confirmada por GPS por contrato, tipos de ausência personalizados e uma vista de custos em tempo real por cliente recorrente — satisfazendo qualquer requisito local de registo de tempo sem hardware adicional.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo por contrato",
          "title": "Visibilidade de custos em tempo real por contrato de manutenção"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Lojas e retalho",
        "slug": "retail",
        "intro": "Turnos de abertura, turnos de fecho e há sempre alguém a substituir alguém. A Done-it dá a cada loja um registo digital limpo de quem fez que turno — picado no próprio telemóvel, pronto para o processamento salarial ao fim do mês.",
        "pains": [
          {
            "body": "Alguém substitui um colega doente, alguém fica mais uma hora no fecho. Fica anotado num papel, ou não fica de todo — e os salários já estão errados antes de começar.",
            "title": "As trocas de turno nunca chegam aos salários"
          },
          {
            "body": "Os colaboradores circulam entre lojas, os de tempo parcial trabalham em dois locais. Recolher as horas loja a loja e juntá-las à mão custa um dia por mês.",
            "title": "Várias lojas, um só processamento salarial"
          },
          {
            "body": "As pausas obrigatórias são descontadas de cor e as horas a mais acertadas informalmente — as duas primeiras coisas que uma inspeção pergunta.",
            "title": "Pausas e horas extraordinárias são adivinhação"
          }
        ],
        "quote": {
          "who": "Proprietária, retalho · 11 colaboradores",
          "text": "Duas lojas e muita gente a tempo parcial. Antes, metade das substituições era acertada de memória. Agora cada hora fica na loja certa e o processamento salarial demora minutos.",
          "result": "Preparação salarial de um dia para menos de uma hora"
        },
        "stats": [
          {
            "label": "para picar o ponto — sem terminal na caixa",
            "value": "1 toque"
          },
          {
            "label": "quem está ao serviço, em todas as lojas",
            "value": "Em direto"
          },
          {
            "label": "trocas de turno perdidas entre a loja e os salários",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Um toque no telemóvel no início do turno. Sem terminal junto à caixa, sem cartão partilhado, sem folha à porta do armazém.",
            "title": "Picar o ponto na própria loja"
          },
          {
            "body": "Cada loja é um projeto. Quem substitui noutra loja fica registado nessa loja — vê as horas onde foram efetivamente trabalhadas.",
            "title": "Horas por loja, equipa entre lojas"
          },
          {
            "body": "Define a regra de pausas uma vez e aplica-se a todos os turnos. As horas extraordinárias ficam registadas no momento e cada colaborador escolhe entre pagamento ou descanso.",
            "title": "Pausas descontadas automaticamente"
          }
        ],
        "headline": "Registo de tempo para lojas — picagem de turnos, substituições e exportação pronta para salários, numa só aplicação",
        "workflow": [
          {
            "body": "Um toque no telemóvel quando o turno começa. A substituição noutra loja fica registada nessa loja.",
            "step": "A equipa pica o ponto no turno"
          },
          {
            "body": "Uma vista em tempo real de todos os locais — deteta um turno de abertura por preencher antes de abrir as portas.",
            "step": "Vê quem está ao serviço, loja a loja"
          },
          {
            "body": "Horas, pausas e horas extraordinárias por colaborador e por loja, exportadas prontas para o seu processador salarial.",
            "step": "Salários numa só exportação"
          }
        ],
        "compliance": {
          "body": "A Done-it mantém um registo digital e objetivo de cada entrada e saída, com pausas e horas extraordinárias — o registo que uma auditoria ou um litígio salarial exige.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo por turnos",
          "title": "Um registo defensável de cada turno trabalhado"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Escritórios e serviços profissionais",
        "slug": "offices",
        "intro": "Contabilistas, notários, arquitetos, agências e consultoras faturam o seu tempo — ou, no mínimo, precisam de saber para onde foi. A Done-it regista as horas no cliente e no projeto certos, da secretária ou fora do escritório.",
        "pains": [
          {
            "body": "Tempo apontado no fim da semana é tempo adivinhado. Horas inteiras desaparecem discretamente entre o trabalho e a fatura.",
            "title": "Horas faturáveis reconstruídas à sexta-feira"
          },
          {
            "body": "Os honorários foram acordados há meses. Se o trabalho ainda cabe lá dentro só se percebe quando alguém faz as contas — normalmente tarde de mais.",
            "title": "Não faz ideia do que um cliente custa"
          },
          {
            "body": "Parte da equipa está no escritório, parte em casa, parte no cliente. A assiduidade deixa de ser um facto e passa a ser uma reconstrução.",
            "title": "O trabalho híbrido deixa o registo cheio de buracos"
          }
        ],
        "quote": {
          "who": "Sócio, gabinete de contabilidade · 8 colaboradores",
          "text": "Antes reconstruíamos a semana toda às sextas-feiras. Agora as horas já estão no cliente certo e vejo quais são os processos que estão a comer os honorários.",
          "result": "Horas faturáveis recuperadas todos os meses"
        },
        "stats": [
          {
            "label": "horas visíveis enquanto o trabalho decorre",
            "value": "Por cliente"
          },
          {
            "label": "o mesmo registo, telemóvel e browser",
            "value": "Escritório ou rua"
          },
          {
            "label": "para salários e faturação",
            "value": "1 exportação"
          }
        ],
        "features": [
          {
            "body": "Cada registo cai num projeto, por isso vê as horas por cliente sem exportar nada nem perguntar a ninguém.",
            "title": "Horas associadas a cliente e projeto"
          },
          {
            "body": "A mesma aplicação no telemóvel ou no browser. Visitar um cliente conta como trabalho nesse cliente, incluindo a deslocação se assim o quiser.",
            "title": "Funciona na secretária e no exterior"
          },
          {
            "body": "Horas a mais registadas na hora, férias pedidas e aprovadas na aplicação — sem folha de cálculo paralela de quem está ausente e quando.",
            "title": "Horas extraordinárias e férias no mesmo sítio"
          }
        ],
        "headline": "Registo de tempo para escritórios — horas por cliente e projeto, sem folha de cálculo",
        "workflow": [
          {
            "body": "Configure-o uma vez com o cliente e, se fatura por orçamento, com as horas previstas.",
            "step": "Abra um projeto de cliente"
          },
          {
            "body": "Da secretária ou do telemóvel. Cada hora cai num cliente, não na memória de alguém.",
            "step": "A equipa regista o tempo nele"
          },
          {
            "body": "Totais em tempo real por projeto e uma exportação limpa para salários ou faturação no fim do mês.",
            "step": "Veja as horas por cliente, exporte para salários"
          }
        ],
        "compliance": {
          "body": "A Done-it mantém um registo digital e inviolável do tempo de trabalho por colaborador — a base tanto para os salários como para uma fatura ao cliente que se sustenta.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo por cliente",
          "title": "Um registo objetivo das horas trabalhadas"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salões e cuidados de beleza",
        "slug": "beauty",
        "intro": "Cabeleireiros, barbearias, estúdios de unhas e de estética vivem de turnos e contratos a tempo parcial. A Done-it regista quem trabalhou quando, desconta as pausas automaticamente e entrega aos salários um ficheiro limpo.",
        "pains": [
          {
            "body": "Três dias numa semana, quatro na seguinte, um sábado trocado por uma terça-feira. As horas contratadas e as horas trabalhadas afastam-se depressa.",
            "title": "Contratos a tempo parcial, variações sem fim"
          },
          {
            "body": "As marcações dizem o que foi reservado, não quem trabalhou. Quando os salários ou uma inspeção perguntam, o sistema de marcações é a resposta errada.",
            "title": "A agenda não é um registo de tempo"
          },
          {
            "body": "Ficar até mais tarde para o último cliente fica na memória, é prometido e às vezes esquecido. É esse tipo de falha que se transforma em litígio.",
            "title": "Horas a mais acertadas informalmente"
          }
        ],
        "quote": {
          "who": "Proprietária, salão de cabeleireiro · 6 colaboradoras",
          "text": "Toda a gente está a tempo parcial e cada semana é diferente. A aplicação limita-se a registar — deixei de reconstruir o mês numa folha de cálculo.",
          "result": "Acabaram as horas contestadas no fim do mês"
        },
        "stats": [
          {
            "label": "para picar o ponto — nada partilhado, nada em papel",
            "value": "1 toque"
          },
          {
            "label": "desconto de pausas em todos os turnos",
            "value": "Auto"
          },
          {
            "label": "horas tardias acertadas de memória",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Um toque no próprio telemóvel no início do turno — sem terminal partilhado na receção, sem folha de assinaturas ao lado do espelho.",
            "title": "Picar o ponto no salão"
          },
          {
            "body": "Defina a regra de pausas e o horário normal uma vez; aplicam-se a todos os turnos, com exceções por pessoa quando o contrato é diferente.",
            "title": "Pausas e regras de tempo parcial, uma só vez"
          },
          {
            "body": "As horas a mais são registadas à medida que são trabalhadas e cada colaborador escolhe entre pagamento ou descanso compensatório — acertado na aplicação, não de cor.",
            "title": "Horas extraordinárias, pagas ou compensadas"
          }
        ],
        "headline": "Registo de tempo para salões — turnos, horas a tempo parcial e salários sem a agenda em papel",
        "workflow": [
          {
            "body": "Um toque à chegada. As pausas são descontadas pela regra que definiu uma vez.",
            "step": "A equipa pica o ponto no turno"
          },
          {
            "body": "Quem está ao serviço, quem está em pausa, quem ficou até mais tarde — em direto, sem perguntar.",
            "step": "Vê o dia enquanto ele acontece"
          },
          {
            "body": "Horas trabalhadas, pausas e horas extraordinárias por colaborador, exportadas para o seu processador salarial.",
            "step": "Os salários recebem um ficheiro limpo"
          }
        ],
        "compliance": {
          "body": "A Done-it regista o tempo de trabalho efetivo por colaborador, com pausas e horas extraordinárias — separado das marcações e defensável quando é verificado.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de tempo digital",
          "title": "Um registo que se sustenta para lá do livro de marcações"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Saúde e bem-estar",
        "slug": "wellness",
        "intro": "Ginásios, estúdios de fitness, clínicas de fisioterapia e spas têm horários alargados com equipas rotativas. A Done-it regista quem cobriu que turno, desconta as pausas automaticamente e exporta os salários sem confusões.",
        "pains": [
          {
            "body": "Turnos de manhã cedo, aulas à noite e fins de semana, preenchidos por uma mistura de tempo inteiro, tempo parcial e recibos verdes. A escala é um plano, não um registo.",
            "title": "Horários alargados, substituições rotativas"
          },
          {
            "body": "Um instrutor dá duas aulas e fica na receção entre elas. Pagar isso corretamente exige saber o que foi mesmo trabalhado, não o que estava previsto.",
            "title": "As horas de aula e as de sala confundem-se"
          },
          {
            "body": "As pessoas circulam entre estúdios. Juntar as horas à mão todos os meses é lento e propício a erros.",
            "title": "Vários locais, uma só administração"
          }
        ],
        "quote": {
          "who": "Gestor, estúdio de fitness · 14 colaboradores",
          "text": "Dois estúdios, horários alargados e muitas substituições. Agora as horas caem no local certo e os salários são um só ficheiro.",
          "result": "Escala e salários finalmente coincidem"
        },
        "stats": [
          {
            "label": "horas, mesmo quando a equipa substitui noutro local",
            "value": "Por estúdio"
          },
          {
            "label": "vista da sala em todos os locais",
            "value": "Em direto"
          },
          {
            "label": "pausas e horas extraordinárias, sem contas à mão",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Um toque no telemóvel no local onde estão a trabalhar. A substituição noutro estúdio entra nas horas desse estúdio.",
            "title": "Picar o ponto por estúdio"
          },
          {
            "body": "Veja a sala em todos os locais em tempo real — um turno de manhã por preencher fica visível antes de abrir as portas, não depois.",
            "title": "Vista em direto de quem está ao serviço"
          },
          {
            "body": "Regras de pausa aplicadas automaticamente, horas a mais registadas no momento com pagamento ou descanso compensatório por colaborador.",
            "title": "Pausas e horas extraordinárias tratadas"
          }
        ],
        "headline": "Registo de tempo para ginásios, estúdios e spas — turnos, aulas e salários numa só aplicação",
        "workflow": [
          {
            "body": "Um toque no início do turno, no local onde está a trabalhar.",
            "step": "A equipa pica o ponto no estúdio"
          },
          {
            "body": "Quem está em cada local neste momento, para que as falhas sejam preenchidas antes de os sócios darem por elas.",
            "step": "As substituições ficam visíveis em direto"
          },
          {
            "body": "Horas, pausas e horas extraordinárias por colaborador e por estúdio, prontas para o processador salarial.",
            "step": "Uma exportação para os salários"
          }
        ],
        "compliance": {
          "body": "A Done-it mantém um registo digital do tempo de trabalho por colaborador e por local — a base para pagar corretamente e para qualquer verificação das horas trabalhadas.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de turnos multilocal",
          "title": "Um registo objetivo para cada turno e cada local"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Restauração e hotelaria",
        "slug": "hospitality",
        "intro": "Horários repartidos, fechos tardios e um sábado cheio que se prolonga. A Done-it regista as horas tal como são trabalhadas, desconta as pausas pela sua regra e entrega aos salários um único ficheiro limpo.",
        "pains": [
          {
            "body": "O serviço prolonga-se, o fecho leva mais meia hora. Esses minutos são trabalho real, e acertá-los de memória é como começam os litígios.",
            "title": "O turno nunca acaba à hora que a escala diz"
          },
          {
            "body": "Serviço de almoço, uma pausa, depois o jantar. No papel vira um bloco único ou dois palpites — nenhum deles é a verdade.",
            "title": "Os horários repartidos são difíceis de registar"
          },
          {
            "body": "Pessoal novo a cada época. Qualquer sistema que exija formação não sobrevive à primeira semana cheia.",
            "title": "Muita rotatividade, integração constante"
          }
        ],
        "quote": {
          "who": "Proprietário, restaurante · 17 colaboradores",
          "text": "O fecho prolonga-se sempre. Agora esses minutos ficam registados em vez de discutidos, e a equipa pode recuperá-los como descanso.",
          "result": "Menos discussões, salários mais rápidos"
        },
        "stats": [
          {
            "label": "registados como dois blocos, não como um palpite",
            "value": "Horários repartidos"
          },
          {
            "label": "desconto de pausas pela sua regra",
            "value": "Auto"
          },
          {
            "label": "para integrar alguém novo — é o telemóvel dele",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Um toque no início e no fim de cada bloco, para que os horários repartidos fiquem registados como aconteceram — sem serem fundidos num só.",
            "title": "Entradas e saídas por serviço"
          },
          {
            "body": "Pausas obrigatórias descontadas automaticamente, com exceções por pessoa quando o contrato o exige. Sem contas à mão no fim do mês.",
            "title": "Pausas pela sua regra"
          },
          {
            "body": "A meia hora a mais depois do fecho fica registada no momento em que é trabalhada e é paga ou compensada com descanso — o colaborador escolhe.",
            "title": "Horas extraordinárias acertadas na aplicação"
          }
        ],
        "headline": "Registo de tempo para cafés, restaurantes e hotéis — turnos, pausas e horas extraordinárias, acertados com justiça",
        "workflow": [
          {
            "body": "Um toque no início do bloco; o mesmo no fim. Os horários repartidos continuam repartidos.",
            "step": "A equipa pica o ponto para o serviço"
          },
          {
            "body": "Quem está ao serviço esta noite, quem ainda está em pausa, quem ficou para lá do fecho.",
            "step": "Vê a sala em direto"
          },
          {
            "body": "Tempo trabalhado, pausas e horas extraordinárias por colaborador, exportados num só ficheiro.",
            "step": "Os salários recebem as horas reais"
          }
        ],
        "compliance": {
          "body": "A Done-it mantém um registo digital e objetivo de cada turno, pausa e hora extraordinária — exatamente o que uma verificação salarial ou uma inspeção do trabalho pede para ver.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de horários repartidos",
          "title": "Um registo defensável das horas numa equipa com muita rotatividade"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Saúde e cuidados",
        "slug": "healthcare",
        "intro": "Clínicas, equipas de apoio domiciliário e lares funcionam à volta de turnos, visitas e regras rígidas de documentação. A Done-it regista o tempo trabalhado por turno e por visita, e guarda os documentos dos colaboradores onde os consegue encontrar.",
        "pains": [
          {
            "body": "As visitas domiciliárias vivem numa ferramenta, as horas de escala noutra, e os salários recebem uma terceira versão. Conciliá-las é um trabalho mensal.",
            "title": "Visitas e turnos em sistemas separados"
          },
          {
            "body": "O trabalho fora do horário normal tem taxas diferentes. Quando o registo é aproximado, o pagamento também é — e a correção só chega depois.",
            "title": "Horas noturnas e de fim de semana mal pagas"
          },
          {
            "body": "As qualificações e os certificados contam nos cuidados de saúde, e ficam numa pasta que ninguém abre até uma inspeção perguntar.",
            "title": "Os certificados caducam em silêncio"
          }
        ],
        "quote": {
          "who": "Coordenadora, equipa de apoio domiciliário · 22 colaboradores",
          "text": "As visitas domiciliárias e os turnos de escala estão finalmente no mesmo registo. Os salários deixaram de ser um exercício de conciliação.",
          "result": "Um registo em vez de três"
        },
        "stats": [
          {
            "label": "ou por turno — como a sua equipa funcionar",
            "value": "Por visita"
          },
          {
            "label": "horas noturnas e de fim de semana, registadas como trabalhadas",
            "value": "Separadas"
          },
          {
            "label": "certificados guardados por colaborador",
            "value": "Arquivados"
          }
        ],
        "features": [
          {
            "body": "Um toque no início do turno, ou em cada morada de cliente no apoio domiciliário — com localização verificada onde precisa da prova.",
            "title": "Picar o ponto por turno ou por visita"
          },
          {
            "body": "As horas noturnas, de fim de semana e normais são registadas em separado, para que a exportação salarial já reflita como o trabalho é efetivamente pago.",
            "title": "Horas separadas como as paga"
          },
          {
            "body": "Contratos, certificados e documentos de identificação guardados junto da pessoa a que pertencem — encontrados em segundos quando alguém os pede.",
            "title": "Documentos dos colaboradores num só lugar"
          }
        ],
        "headline": "Registo de tempo para equipas de cuidados — turnos, visitas domiciliárias e qualificações, num só registo",
        "workflow": [
          {
            "body": "Um toque no local ou na morada do cliente, com localização verificada onde é preciso prova.",
            "step": "Picar o ponto no turno ou na visita"
          },
          {
            "body": "Horas normais, noturnas e de fim de semana registadas em separado à medida que acontecem.",
            "step": "As horas caem na categoria certa"
          },
          {
            "body": "Um ficheiro limpo por período, já separado tal como o paga.",
            "step": "Exportar para os salários"
          }
        ],
        "compliance": {
          "body": "A Done-it mantém um registo digital e objetivo do tempo de trabalho por colaborador — horas, pausas e separação de horas fora do horário normal — a par dos documentos associados a cada pessoa.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registo de turnos e visitas",
          "title": "Registos que resistem a uma inspeção"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "pl": [
      {
        "name": "Budownictwo",
        "slug": "construction",
        "intro": "Ekipy rozproszone po lokalizacjach, godziny gryzmolone na papierze, godziny podwykonawców niemożliwe do uzgodnienia. Done-it daje każdej lokalizacji niepodważalną cyfrową kartę pracy, która zasila Twoje płace jednym kliknięciem.",
        "pains": [
          {
            "body": "Przy wielu aktywnych lokalizacjach i rotujących ekipach ręczne karty pracy są z założenia błędne. Pracownicy zaokrąglają w górę, zapominają o wpisach lub uzupełniają je wiele dni później — pozostawiając Cię z danymi płacowymi, których nie da się obronić.",
            "title": "Brak rzetelnego zapisu, kto i gdzie pracował"
          },
          {
            "body": "Zanim zauważysz, że lokalizacja wyczerpała zaplanowane godziny, marża już zniknęła. Nie ma odliczania na żywo — tylko nieprzyjemna niespodzianka w chwili wystawiania faktury.",
            "title": "Przekroczenia budżetu wychodzą na jaw za późno"
          },
          {
            "body": "Zbieranie kart pracy, uzgadnianie ich z projektami i przygotowywanie eksportu do płac trwa wiele dni. Każdy wpis to potencjalny błąd.",
            "title": "Przygotowanie płac pochłania godziny każdego miesiąca"
          }
        ],
        "quote": {
          "who": "Właściciel, firma budowlana · 14 pracowników",
          "text": "Nasza ekipa melduje się sama na lokalizacji. Na koniec miesiąca płace po prostu się zgadzają — całkowicie przestaliśmy gonić za kartami pracy.",
          "result": "5 godzin tygodniowo zaoszczędzone na biurokracji"
        },
        "stats": [
          {
            "label": "aby zameldować się na dowolnej lokalizacji — bez terminala, bez papieru",
            "value": "1 dotknięcie"
          },
          {
            "label": "eksport do płac gotowy dla Twojego dostawcy",
            "value": "1 kliknięcie"
          },
          {
            "label": "widok pozostałych godzin w podziale na projekt i lokalizację",
            "value": "Na żywo"
          }
        ],
        "features": [
          {
            "body": "Jedno dotknięcie melduje pracownika, z weryfikacją lokalizacji, i wiąże godziny z właściwym projektem. Bez czytników kart, bez terminali — wystarczy smartfon, który Twoja ekipa już ma przy sobie.",
            "title": "Zameldowanie z weryfikacją lokalizacji na każdej lokalizacji"
          },
          {
            "body": "Ustaw planowane godziny jako budżet przy otwieraniu projektu. Pracownicy widzą odliczanie tego, co pozostało; Ty widzisz to na żywo na swoim pulpicie. Przekroczenia budżetu są widoczne, zanim nastąpią.",
            "title": "Pozostałe godziny na żywo w podziale na projekt"
          },
          {
            "body": "Dodaj podwykonawców do projektu, przypisz ich do meldowania i śledź ich godziny obok własnej ekipy — w tym samym zestawieniu.",
            "title": "Zarządzanie podwykonawcami i obecnością"
          },
          {
            "body": "Wszystkie zarejestrowane godziny — w podziale na pracownika i projekt — eksportowane do przejrzystego arkusza kalkulacyjnego dla Twojego dostawcy usług płacowych. Bez ręcznego przygotowania, bez błędów.",
            "title": "Eksport do płac jednym kliknięciem"
          }
        ],
        "headline": "Rejestracja czasu pracy dla zespołów budowlanych — zameldowanie z weryfikacją lokalizacji, godziny projektowe i kontrola budżetu, w jednej aplikacji",
        "workflow": [
          {
            "body": "Każdy pracownik dotyka raz, aby się zameldować. GPS potwierdza lokalizację, opatruje wpis znacznikiem czasu i wiąże godziny z projektem. Bez papieru, bez terminala.",
            "step": "Ekipa przybywa na lokalizację"
          },
          {
            "body": "Godziny, pozostały budżet, obecność podwykonawców i wszelkie prace dodatkowe zgłoszone z lokalizacji — wszystko na Twoim pulpicie, w czasie rzeczywistym.",
            "step": "Widzisz wszystko na żywo"
          },
          {
            "body": "Wyeksportuj wszystkie godziny w podziale na pracownika i projekt. Wyślij do swojego dostawcy usług płacowych. Done-it automatycznie generuje przejrzyste, gotowe do audytu raporty.",
            "step": "Koniec miesiąca w kilka minut"
          }
        ],
        "compliance": {
          "body": "Done-it zapewnia zameldowanie z weryfikacją lokalizacji, rejestrację czasu w podziale na projekt i przejrzysty eksport do płac dla zespołów budowlanych. Dla zespołów działających na belgijskich lokalizacjach automatycznie zasila również check-in at work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa rejestracja czasu pracy",
          "title": "Zameldowanie z weryfikacją lokalizacji stworzone dla placów budowy"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Sprzątanie",
        "slug": "cleaning",
        "intro": "Osoby sprzątające przemieszczają się między lokalizacjami przez cały dzień. Done-it śledzi, kto i gdzie jest, w czasie rzeczywistym — zameldowanie z weryfikacją lokalizacji na każdej lokalizacji, automatyczne odejmowanie przerw i przejrzysty eksport do płac na koniec miesiąca.",
        "pains": [
          {
            "body": "Klienci i inspektorzy oczekują niepodważalnych zapisów obecności. Ręczne arkusze można zakwestionować; cyfrowych zameldowań z weryfikacją lokalizacji — nie.",
            "title": "Udowadnianie obecności na każdej lokalizacji"
          },
          {
            "body": "Przy osobach sprzątających przemieszczających się między lokalizacjami w ciągu dnia nie masz widoku na żywo, kto i gdzie pracuje — dopóki ktoś nie zadzwoni.",
            "title": "Zespoły rozproszone po wielu lokalizacjach"
          },
          {
            "body": "Bez dokładnych godzin wejścia/wyjścia płace są odtwarzane z pamięci. Godziny są zaokrąglane w górę, koszty rosną, a spory są nieuniknione.",
            "title": "Błędy płacowe wynikające z zaokrąglonych godzin"
          }
        ],
        "quote": {
          "who": "Menedżer, firma sprzątająca · 9 pracowników",
          "text": "W końcu możemy udowodnić, kto sprzątał, gdzie i kiedy. Koniec z arkuszami obecności, koniec ze sporami z klientami — GPS zajmuje się tym za nas.",
          "result": "Zero zaokrąglania godzin w górę"
        },
        "stats": [
          {
            "label": "aby zameldować się na dowolnej lokalizacji — bez potrzeby terminala",
            "value": "1 dotknięcie"
          },
          {
            "label": "widok, kto jest na której lokalizacji w danej chwili",
            "value": "Na żywo"
          },
          {
            "label": "podwójnych wpisów — godziny trafiają prosto do płac",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Pracownicy meldują się i wymeldowują na telefonie na każdej lokalizacji, z weryfikacją lokalizacji; czas jest dokładny, z rejestracją przerw.",
            "plan": "Time Basic",
            "title": "Meldowanie i wymeldowanie w czasie rzeczywistym"
          },
          {
            "body": "Obowiązkowe przerwy są automatycznie odejmowane od dnia pracy — bez ręcznych obliczeń, bez sporów.",
            "plan": "Time Basic",
            "title": "Automatyczne odejmowanie przerw"
          },
          {
            "body": "Zobacz, które osoby sprzątające są na których lokalizacjach w danej chwili. Wyłap luki, zanim zrobią to klienci.",
            "title": "Przegląd na żywo wielu lokalizacji"
          },
          {
            "body": "Pracownicy przesyłają zaświadczenia lekarskie i dokumenty nieobecności bezpośrednio z aplikacji. Utwórz rodzaje nieobecności, których Twój zespół faktycznie używa.",
            "title": "Rejestracja nieobecności z cyfrowymi zwolnieniami lekarskimi"
          },
          {
            "body": "Dokładne znaczniki czasu trafiają prosto do eksportu gotowego do rozliczenia płac dla Twojego dostawcy. Bez przepisywania, bez błędów.",
            "title": "Eksport do płac jednym kliknięciem"
          }
        ],
        "headline": "Rejestracja czasu pracy dla firm sprzątających — zameldowanie z weryfikacją lokalizacji, dowód obecności i płace w jednej aplikacji",
        "workflow": [
          {
            "body": "Jedno dotknięcie ją melduje. GPS rejestruje lokalizację i opatruje wpis znacznikiem czasu. Rejestracja przerw jest wbudowana w aplikację.",
            "step": "Osoba sprzątająca przybywa na lokalizację"
          },
          {
            "body": "Kto jest na której lokalizacji w danej chwili — bez telefonów, bez zgadywania. Wyłap luki w obsadzie, zanim zrobią to klienci.",
            "step": "Widzisz każdą lokalizację na żywo"
          },
          {
            "body": "Wszystkie dane o obecności — dokładne godziny, lokalizacje i przerwy — eksportowane w przejrzystej formie dla Twojego dostawcy usług płacowych.",
            "step": "Płace jednym kliknięciem"
          }
        ],
        "compliance": {
          "body": "Done-it daje zespołom sprzątającym zameldowanie z weryfikacją lokalizacji na każdej lokalizacji, automatyczne odejmowanie przerw i widok na żywo, kto jest na której lokalizacji w danej chwili.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Obecność z weryfikacją lokalizacji",
          "title": "Obecność w czasie rzeczywistym na każdej lokalizacji sprzątania"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Instalacje",
        "slug": "installation",
        "intro": "Wyślij swoich monterów pod właściwy adres ze wszystkim, czego potrzebują, powiąż każdą przepracowaną godzinę z właściwym zleceniem automatycznie i zobacz pozostały budżet, zanim lokalizacja zostanie zamknięta. Done-it to najprostszy sposób na utrzymanie projektów instalacyjnych w terminie i w ramach kosztów.",
        "pains": [
          {
            "body": "Ekipy przybywają na lokalizację bez adresu, osoby kontaktowej czy szczegółów zakresu. Ten pierwszy telefon to dziesięć minut godzin podlegających rozliczeniu, straconych, zanim przepracowano choćby jedną godzinę.",
            "title": "Informacje o zleceniu nie docierają do terenu na czas"
          },
          {
            "body": "Gdy pracownicy uzupełniają swoje godziny ręcznie na koniec dnia — o ile w ogóle je uzupełniają — godziny trafiają do niewłaściwego zlecenia lub znikają całkowicie. Faktury nie zgadzają się z rzeczywistością.",
            "title": "Godziny nie są powiązane z właściwym projektem"
          },
          {
            "body": "Bez odliczania na żywo pozostałych godzin w podziale na projekt dowiadujesz się, że zlecenie przekroczyło budżet, gdy zamykasz fakturę — a nie wtedy, gdy jeszcze możesz zareagować.",
            "title": "Przekroczenia budżetu zauważane za późno"
          },
          {
            "body": "Podwykonawcy pracujący na tej samej lokalizacji korzystają z różnych systemów, uzupełniają godziny osobno lub wcale. Uzgadnianie ich na koniec miesiąca to powolny, podatny na błędy proces.",
            "title": "Godziny podwykonawców trudne do śledzenia"
          }
        ],
        "quote": {
          "who": "Właściciel, firma instalacyjna · 6 pracowników",
          "text": "Godziny trafiają do właściwego projektu automatycznie. Kosztorysowanie zleceń stało się nagle proste — widzimy rzeczywistą marżę, zanim zamkniemy zlecenie.",
          "result": "Rzeczywisty koszt zlecenia, na żywo"
        },
        "stats": [
          {
            "label": "widok pozostałych godzin w podziale na projekt",
            "value": "W czasie rzeczywistym"
          },
          {
            "label": "telefonów do biura po adresy lokalizacji",
            "value": "0"
          },
          {
            "label": "nawigacja do dowolnego adresu projektu z aplikacji",
            "value": "1 kliknięcie"
          }
        ],
        "features": [
          {
            "body": "Pracownicy otwierają projekt na telefonie: adres, planowane godziny, osoba kontaktowa i przesłane pliki (plany, instrukcje, pliki PDF). Wszystko, czego potrzebują, jest tam, zanim przybędą.",
            "plan": "Project Basic",
            "title": "Informacje o projekcie udostępniane bezpośrednio do aplikacji"
          },
          {
            "body": "Dotknij raz, a telefon nawiguje do adresu projektu — wbudowane w aplikację, bez potrzeby osobnej aplikacji z mapami.",
            "title": "Nawigacja do lokalizacji jednym przyciskiem"
          },
          {
            "body": "Ustaw planowane godziny przy otwieraniu projektu. Pracownicy widzą, ile godzin pozostało; Ty widzisz status na żywo na swoim pulpicie. Przekroczenia są widoczne, zanim nastąpią.",
            "plan": "Project Basic",
            "title": "Odliczanie pozostałych godzin w podziale na projekt"
          },
          {
            "body": "Każdy pracownik melduje się w odpowiednim projekcie. Zawsze wiesz, kto jest na której lokalizacji w danej chwili.",
            "plan": "Project Basic",
            "title": "Zameldowanie pracownika w podziale na projekt"
          },
          {
            "body": "Gdy zakres rozrasta się na lokalizacji, pracownicy rejestrują prace dodatkowe i materiały w czasie rzeczywistym — z tekstem i zdjęciami — więc nic nie jest rozliczane z pamięci.",
            "plan": "Project Basic",
            "title": "Rejestracja prac dodatkowych i materiałów"
          }
        ],
        "headline": "Rejestracja czasu pracy dla zespołów instalacyjnych — godziny projektowe, nawigacja i kontrola budżetu w jednej aplikacji",
        "workflow": [
          {
            "body": "Adres, kontakt, zakres i przesłane pliki są od razu pod ręką. Nawiguje jednym dotknięciem — bez telefonów do biura po wskazówki.",
            "step": "Pracownik otwiera projekt na telefonie"
          },
          {
            "body": "Zameldowanie wiąże każdą przepracowaną minutę z właściwym projektem. Pozostały budżet aktualizuje się w czasie rzeczywistym.",
            "step": "Godziny rejestrują się automatycznie do właściwego zlecenia"
          },
          {
            "body": "Zmiany zakresu, dodatkowe materiały i opóźnienia są rejestrowane z tekstem i zdjęciami w chwili, gdy się dzieją — gotowe na fakturę.",
            "step": "Prace dodatkowe rejestrowane na lokalizacji"
          }
        ],
        "compliance": {
          "body": "Done-it daje zespołom instalacyjnym zameldowanie z weryfikacją lokalizacji w podziale na projekt, odliczanie pozostałych godzin na żywo i automatyczny eksport do płac — pokrywając każdy lokalny wymóg rejestracji czasu pracy. Dla zespołów pracujących na belgijskich placach budowy integruje się również z CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa rejestracja czasu pracy",
          "title": "Zameldowanie z weryfikacją lokalizacji w podziale na projekt dla zespołów instalacyjnych"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Serwis terenowy",
        "slug": "field-service",
        "intro": "Technicy odwiedzający wielu klientów dziennie, paragony w schowkach, przebieg rejestrowany z pamięci. Done-it rejestruje godziny, kilometry i wydatki w terenie — przypisane do właściwego zlecenia w chwili, gdy się dzieją.",
        "pains": [
          {
            "body": "Proszenie techników o odtworzenie tras na koniec tygodnia oznacza niedokładne zwroty kosztów, spory z klientami i rosnący stos nierozliczonych kilometrów.",
            "title": "Przebieg rejestrowany wiele dni później — o ile w ogóle"
          },
          {
            "body": "Paragon w schowku to koszt, który być może nigdy nie trafi na fakturę. Rzeczywisty koszt zlecenia jest zawsze zaniżony.",
            "title": "Wydatki na papierowych paragonach, które znikają"
          },
          {
            "body": "Bez zameldowań na żywo dowiadujesz się, gdzie jest technik, tylko wtedy, gdy coś pójdzie nie tak i ktoś zadzwoni.",
            "title": "Brak widoku w czasie rzeczywistym, gdzie jest zespół"
          },
          {
            "body": "Gdy robocizna, dojazd i wydatki są śledzone w osobnych systemach — albo wcale — nigdy nie ma jednej kwoty kosztu zlecenia.",
            "title": "Trudno zobaczyć rzeczywistą marżę zlecenia"
          }
        ],
        "quote": {
          "who": "Kierownik operacyjny, firma serwisu terenowego · 11 pracowników",
          "text": "Przebieg był kiedyś comiesięcznym bólem głowy. Teraz rejestruje się sam — każdy kilometr jest przypisany do właściwego klienta, zanim w ogóle wrócimy do biura.",
          "result": "Dokładny koszt zlecenia, za każdym razem"
        },
        "stats": [
          {
            "label": "rejestracja przebiegu — bez ręcznego rejestru",
            "value": "Automatycznie"
          },
          {
            "label": "koszt zlecenia: godziny + dojazd + wydatki",
            "value": "Na żywo"
          },
          {
            "label": "utraconych kilometrów — każdy przejazd rejestrowany automatycznie",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS rejestruje wyjazd, przybycie i dokładną odległość każdego przejazdu. Skonfiguruj rodzaje transportu (własny samochód, pojazd służbowy, wspólny dojazd) z ich własnymi stawkami zwrotu. Bez ręcznego rejestru.",
            "plan": "Dodatek",
            "title": "Automatyczna rejestracja przebiegu (Trax-it)"
          },
          {
            "body": "Pracownicy robią zdjęcie paragonu w terenie; jest on przypisywany do zlecenia i gotowy do zwrotu — a nie ścigany na koniec miesiąca.",
            "plan": "Time Basic",
            "title": "Zarządzanie wydatkami na lokalizacji"
          },
          {
            "body": "Godziny, przebieg i wydatki sumują się w ramach zlecenia w czasie rzeczywistym. Koszt zlecenia jest widoczny, gdy zlecenie jest jeszcze otwarte.",
            "plan": "Project Basic",
            "title": "Kontrola kosztów powiązana z projektem"
          },
          {
            "body": "Każdy technik melduje się na lokalizacji klienta. Widzisz, kto i gdzie jest w danej chwili — bez telefonów, bez zgadywania.",
            "title": "Zameldowanie z weryfikacją lokalizacji i przegląd zespołu na żywo"
          },
          {
            "body": "Godziny i zwroty kosztów kilometrów eksportowane w przejrzystej formie dla Twojego dostawcy usług płacowych — z automatycznie zastosowanymi skonfigurowanymi stawkami przebiegu.",
            "title": "Eksport do płac jednym kliknięciem"
          }
        ],
        "headline": "Rejestracja czasu pracy dla zespołów serwisu terenowego — przebieg, wydatki i godziny z drogi, wszystko w jednej aplikacji",
        "workflow": [
          {
            "body": "Zameldowanie rozpoczyna rejestr przejazdu. Kilometry są rejestrowane automatycznie od wyjazdu do przybycia — bez ręcznego wprowadzania.",
            "step": "Technik wyrusza na pierwsze wezwanie"
          },
          {
            "body": "Godziny wiążą się z właściwym projektem. Prace dodatkowe, materiały i paragony są rejestrowane w aplikacji w chwili, gdy się dzieją.",
            "step": "Na lokalizacji zlecenia"
          },
          {
            "body": "Każda godzina, kilometr i wydatek są już przypisane do właściwego zlecenia. Eksportuj do płac i fakturuj z rzeczywistymi danymi kosztowymi.",
            "step": "Koniec miesiąca bez chaosu"
          }
        ],
        "compliance": {
          "body": "Done-it rejestruje przebieg automatycznie dla każdego przejazdu, stosuje skonfigurowane stawki zwrotu i przypisuje każdy kilometr do właściwego klienta lub projektu. Unijny wyrok w sprawie Tyco oznacza, że dojazd z domu do pierwszego klienta liczy się jako czas pracy — Done-it śledzi również to.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Cyfrowa rejestracja czasu i przebiegu",
          "title": "Godziny z GPS i automatyczny przebieg dla zespołów serwisu terenowego"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Każde wezwanie serwisowe ma trzy koszty: robociznę, części i dojazd. Done-it rejestruje wszystkie trzy w terenie i sumuje je w ramach właściwego zlecenia — dzięki czemu znasz swoją marżę, zanim zamkniesz fakturę.",
        "pains": [
          {
            "body": "Robocizna, części i dojazd żyją w różnych systemach — lub różnych kieszeniach. Rzeczywisty koszt wezwania staje się jasny dopiero długo po tym, jak technik opuści lokalizację.",
            "title": "Wezwania serwisowe trudno dokładnie wycenić"
          },
          {
            "body": "Gdy klient kwestionuje, jak długo trwała naprawa, papierową kartę pracy łatwo podważyć. Potwierdzonych przez GPS znaczników czasu zameldowania i wymeldowania — nie.",
            "title": "Brak dowodu czasu serwisu"
          },
          {
            "body": "W przypadku cyklicznych umów serwisowych drobne przekroczenia kumulują się na przestrzeni wielu wizyt. Bez licznika godzin na żywo dowiadujesz się, że umowa jest pod kreską, dopiero przy jej odnowieniu.",
            "title": "Umowy serwisowe po cichu zżerają marżę"
          },
          {
            "body": "Ręczne wpisy czasu pomijają przerwy, co prowadzi do nadpłat i płac, które nie zgadzają się z rzeczywistością.",
            "title": "Technicy zapominają rejestrować przerwy"
          }
        ],
        "quote": {
          "who": "Właściciel, firma HVAC · 7 techników",
          "text": "W końcu wiemy, ile naprawdę kosztuje nas każda umowa serwisowa. Niespodzianki z marżą skończyły się w dniu, w którym zaczęliśmy używać Done-it.",
          "result": "Rzeczywisty koszt wezwania serwisowego, na żywo"
        },
        "stats": [
          {
            "label": "rodzaje kosztów rejestrowane na wezwanie: robocizna, dojazd, części",
            "value": "3"
          },
          {
            "label": "widoczność marży w podziale na umowę serwisową",
            "value": "Na żywo"
          },
          {
            "label": "niespodzianek przy fakturowaniu — koszty widoczne w czasie rzeczywistym",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Każde wezwanie serwisowe lub umowa serwisowa to projekt. Godziny, dojazd i materiały sumują się w czasie rzeczywistym — dając Ci widoczność marży na żywo.",
            "plan": "Project Basic",
            "title": "Rejestracja czasu oparta na projektach"
          },
          {
            "body": "Gdy zlecenie się rozrasta, technicy rejestrują prace dodatkowe i części z tekstem i zdjęciami, zanim wyjadą. Nic nie jest rozliczane z pamięci.",
            "plan": "Project Basic",
            "title": "Prace dodatkowe i materiały rejestrowane na lokalizacji"
          },
          {
            "body": "Kilometry na wezwanie są rejestrowane automatycznie i przypisywane do kosztów zlecenia. Skonfiguruj stawki zwrotu dla rodzaju pojazdu.",
            "plan": "Dodatek",
            "title": "Przebieg i koszty transportu"
          },
          {
            "body": "Obowiązkowe przerwy są automatycznie odejmowane od całkowitego czasu — bez sporów, bez błędów płacowych.",
            "title": "Automatyczne odejmowanie przerw"
          },
          {
            "body": "Opatrzone znacznikiem czasu, potwierdzone przez GPS zameldowanie na każdej lokalizacji. Niepodważalny dowód, kiedy technik przybył i wyjechał.",
            "title": "Zameldowanie z weryfikacją lokalizacji i dowód obecności"
          }
        ],
        "headline": "Rejestracja czasu pracy dla techników HVAC — kosztorysowanie zleceń, części i dojazd w jednej aplikacji",
        "workflow": [
          {
            "body": "GPS opatruje przybycie znacznikiem czasu i wiąże godziny z wezwaniem serwisowym lub umową serwisową. Bez papieru, bez terminala.",
            "step": "Technik melduje się na lokalizacji"
          },
          {
            "body": "Użyte części, dodatkowe godziny i zmiany zakresu są rejestrowane w aplikacji ze zdjęciami — przed opuszczeniem lokalizacji.",
            "step": "Prace dodatkowe rejestrowane na miejscu"
          },
          {
            "body": "Robocizna, dojazd i materiały sumują się w ramach projektu w czasie rzeczywistym. Widzisz marżę, zanim wystawisz fakturę.",
            "step": "Koszt zlecenia widoczny natychmiast"
          }
        ],
        "compliance": {
          "body": "Done-it daje zespołom HVAC zameldowanie z weryfikacją lokalizacji w podziale na wezwanie serwisowe, widoczność kosztów na żywo w podziale na zlecenie (robocizna + dojazd + części) i przejrzysty eksport do płac — spełniając każdy lokalny wymóg rejestracji czasu pracy bez dodatkowego sprzętu.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa rejestracja czasu i kosztów",
          "title": "Pełne kosztorysowanie zleceń dla wezwań serwisowych HVAC"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektrycy",
        "slug": "electricians",
        "intro": "Godziny w podziale na projekt, odliczanie pozostałego budżetu na żywo i nawigacja do lokalizacji jednym przyciskiem — stworzone dla małych zespołów elektryków, które potrzebują kontroli nad projektami bez nadmiaru biurokracji.",
        "pains": [
          {
            "body": "Gdy elektrycy pracują przy wielu zleceniach w tygodniu, ręczne przypisywanie godzin na koniec dnia prowadzi do błędnie przypisanych kosztów, sporów dotyczących rozliczeń i płac, których nie da się wyjaśnić.",
            "title": "Godziny nie są powiązane z właściwym projektem"
          },
          {
            "body": "Bez widoku na żywo godzin zużytych względem zaplanowanych dowiadujesz się, że projekt przekroczył budżet, gdy wystawiasz fakturę — a nie wtedy, gdy jeszcze mógłbyś zareagować.",
            "title": "Przekroczenia budżetu zauważane za późno"
          },
          {
            "body": "Adresy wpisywane do osobnej aplikacji, telefony do biura po wskazówki, spóźnione przyjazdy do klientów. Każda zmarnowana minuta to stracona minuta podlegająca rozliczeniu.",
            "title": "Czas tracony na znalezienie lokalizacji"
          },
          {
            "body": "Przy większych instalacjach podwykonawcy elektrycy śledzą swoje godziny osobno. Uzyskanie połączonego widoku kosztów robocizny na koniec projektu to ręczna, podatna na błędy praca.",
            "title": "Godziny podwykonawców trudne do uzgodnienia"
          }
        ],
        "quote": {
          "who": "Właściciel, firma elektryczna · 5 elektryków",
          "text": "W czasie rzeczywistym wiemy, czy projekt przekracza budżet. Już samo to uchroniło nas przed dwiema przykrymi niespodziankami w tym roku.",
          "result": "Przekroczenia budżetu wyłapywane, zanim nastąpią"
        },
        "stats": [
          {
            "label": "widok pozostałych godzin w podziale na projekt",
            "value": "Na żywo"
          },
          {
            "label": "telefonów do biura po adresy lokalizacji",
            "value": "0"
          },
          {
            "label": "aby zameldować się na dowolnej lokalizacji — bez potrzeby terminala",
            "value": "1 dotknięcie"
          }
        ],
        "features": [
          {
            "body": "Każda przepracowana minuta jest automatycznie powiązana z właściwym projektem. Odliczanie na żywo pokazuje, ile godzin pozostało względem budżetu — dla Ciebie i dla pracownika na lokalizacji.",
            "plan": "Project Basic",
            "title": "Godziny projektowe z pozostałym budżetem na żywo"
          },
          {
            "body": "Adres projektu jest w aplikacji. Jedno dotknięcie otwiera nawigację — bez szukania, bez osobnej aplikacji z mapami, bez telefonów do biura.",
            "title": "Nawigacja do lokalizacji jednym przyciskiem"
          },
          {
            "body": "Każdy elektryk melduje się przy odpowiednim zleceniu. Zawsze wiesz, kto jest na której lokalizacji w danej chwili.",
            "plan": "Project Basic",
            "title": "Zameldowanie pracownika w podziale na projekt"
          },
          {
            "body": "Gdy zakres się zmienia — nieoczekiwany obwód, dodatkowe materiały — jest to rejestrowane w aplikacji ze zdjęciami, zanim ekipa wyjedzie.",
            "plan": "Project Basic",
            "title": "Prace dodatkowe rejestrowane na lokalizacji"
          },
          {
            "body": "Nadgodziny są rejestrowane w chwili, gdy następują. Pracownicy wybierają wypłatę lub zamianę na czas wolny.",
            "plan": "Time Pro",
            "title": "Rejestracja nadgodzin z elastyczną rekompensatą"
          }
        ],
        "headline": "Rejestracja czasu pracy dla elektryków — godziny w podziale na projekt, kontrola budżetu i nawigacja w jednej aplikacji",
        "workflow": [
          {
            "body": "Adres i zakres są już w aplikacji. Jedno dotknięcie otwiera nawigację — bez telefonów, bez zamieszania.",
            "step": "Elektryk nawiguje do zlecenia"
          },
          {
            "body": "Zameldowanie na lokalizacji wiąże każdą przepracowaną minutę z właściwym projektem. Licznik pozostałych godzin aktualizuje się na żywo.",
            "step": "Godziny wiążą się z właściwym projektem automatycznie"
          },
          {
            "body": "Prace dodatkowe i materiały są rejestrowane na lokalizacji, przed wyjazdem. Faktura odzwierciedla to, co naprawdę się wydarzyło.",
            "step": "Zmiany zakresu pozostają w zapisie"
          }
        ],
        "compliance": {
          "body": "Done-it daje elektrykom zameldowanie z weryfikacją lokalizacji w podziale na projekt, budżet pozostałych godzin na żywo i eksport do płac — spełniając każdy lokalny wymóg rejestracji czasu pracy. Dla zespołów na belgijskich placach budowy integruje się również z CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Zameldowanie z weryfikacją lokalizacji w podziale na projekt",
          "title": "Kontrola budżetu na żywo i zameldowanie z weryfikacją lokalizacji dla zespołów elektryków"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Hydraulika",
        "slug": "plumbing",
        "intro": "Wezwania awaryjne, wiele zleceń dziennie, godziny uzupełniane z pamięci na koniec tygodnia — albo wcale. Done-it sprawia, że na każdej lokalizacji to kwestia jednego dotknięcia, a na koniec miesiąca płace to jedno kliknięcie.",
        "pains": [
          {
            "body": "Przy kilku zleceniach dziennie hydraulicy rzadko mają czas na wypełnienie dokładnych kart pracy. Godziny są zaokrąglane lub zapominane, a płace to w najlepszym razie szacunek.",
            "title": "Godziny wezwań odtwarzane z pamięci"
          },
          {
            "body": "Gdy klient kwestionuje, jak długo trwała naprawa, nie ma obiektywnego zapisu. Potwierdzone przez GPS cyfrowe zameldowanie łatwo przedstawić — papierowej karty pracy nie.",
            "title": "Brak dowodu czasu na lokalizacji"
          },
          {
            "body": "Dojazdy między wezwaniami sumują się w ciągu tygodnia i miesiąca, ale bez automatycznej rejestracji rzadko są poprawnie fakturowane lub zwracane.",
            "title": "Nieśledzony przebieg między zleceniami"
          },
          {
            "body": "Na koniec miesiąca gonienie za kartami pracy, poprawianie błędów i budowanie eksportu do płac zajmuje czas, którego Twój zespół administracyjny nie powinien na to poświęcać.",
            "title": "Przygotowanie płac jest powolne"
          }
        ],
        "quote": {
          "who": "Właściciel, firma hydrauliczna · 4 hydraulików",
          "text": "Kiedyś spędzaliśmy poranek na koniec miesiąca, odtwarzając godziny. Teraz po prostu eksportujemy i wysyłamy. Dostawca usług płacowych otrzymuje je w przejrzystej formie.",
          "result": "Przygotowanie płac skrócone z godzin do minut"
        },
        "stats": [
          {
            "label": "aby się zameldować — wystarczająco szybkie dla wezwań awaryjnych",
            "value": "1 dotknięcie"
          },
          {
            "label": "eksport do płac do Twojego dostawcy",
            "value": "1 kliknięcie"
          },
          {
            "label": "godzin odtwarzanych z pamięci na koniec miesiąca",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Przybycie i wyjazd rejestrowane jednym dotknięciem, z weryfikacją lokalizacji. Wystarczająco szybkie dla wezwań awaryjnych; wystarczająco dokładne dla sporów.",
            "plan": "Time Basic",
            "title": "Zameldowanie z weryfikacją lokalizacji jednym dotknięciem przy każdym wezwaniu"
          },
          {
            "body": "Obowiązkowe przerwy są automatycznie odejmowane od całkowitego czasu — nic do uzupełnienia, bez błędów płacowych.",
            "plan": "Time Basic",
            "title": "Automatyczne odejmowanie przerw"
          },
          {
            "body": "Skonfiguruj rodzaje transportu i stawki zwrotu. Kilometry rejestrują się automatycznie i wiążą z właściwym klientem lub projektem.",
            "plan": "Dodatek",
            "title": "Przebieg rejestrowany dla każdego przejazdu"
          },
          {
            "body": "Pracownicy przesyłają zwolnienia lekarskie cyfrowo z aplikacji. Utwórz rodzaje nieobecności, których Twój zespół faktycznie używa, w tym przestoje pogodowe.",
            "title": "Zarządzanie nieobecnościami i zwolnieniami lekarskimi"
          },
          {
            "body": "Wszystkie dane o godzinach i kilometrach eksportowane w przejrzystej formie dla Twojego dostawcy usług płacowych — bez ręcznego przygotowania, bez Excela.",
            "plan": "Time Basic",
            "title": "Eksport do płac jednym kliknięciem"
          }
        ],
        "headline": "Rejestracja czasu pracy dla zespołów hydraulicznych — szybkie zameldowanie, dokładne płace i dowód obecności dla każdego wezwania",
        "workflow": [
          {
            "body": "Jedno dotknięcie melduje go. GPS rejestruje lokalizację i czas. Wystarczająco szybkie dla zlecenia awaryjnego.",
            "step": "Hydraulik przybywa na wezwanie"
          },
          {
            "body": "Wymeldowanie zamyka wpis czasu. Przebieg do następnego zlecenia zaczyna rejestrować się automatycznie.",
            "step": "Wyjazd zaznaczany dotknięciem w drodze powrotnej"
          },
          {
            "body": "Wszystkie wezwania, godziny i kilometry eksportowane w przejrzystej formie. Przygotowanie płac skraca się z dnia do minut.",
            "step": "Koniec miesiąca to jedno kliknięcie"
          }
        ],
        "compliance": {
          "body": "Done-it pokrywa każdy lokalny wymóg rejestracji czasu pracy dla zespołów hydraulicznych — zameldowanie z weryfikacją lokalizacji jednym dotknięciem przy każdym wezwaniu, automatyczne odejmowanie przerw i przejrzysty eksport do płac. Bez papierowych kart pracy, bez ręcznego odtwarzania.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa rejestracja czasu pracy",
          "title": "Szybkie zameldowanie z weryfikacją lokalizacji dla każdego wezwania"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Architektura krajobrazu",
        "slug": "landscaping",
        "intro": "Szczyt sezonu oznacza wiele lokalizacji, zmieniające się ekipy i mnóstwo kilometrów. Done-it utrzymuje każdą godzinę, każdą nieobecność i każdy przejazd w porządku — dzięki czemu możesz skupić się na pracy, a nie na papierkowej robocie.",
        "pains": [
          {
            "body": "Pracownicy tymczasowi, zmieniające się grafiki i różny rozmiar zespołów sprawiają, że dokładne śledzenie godzin na papierze jest niemal niemożliwe. Zanim uzgodnisz wszystko na koniec miesiąca, zawsze czegoś brakuje.",
            "title": "Ekipy sezonowe są złożone w zarządzaniu"
          },
          {
            "body": "Ekipa odwiedzająca trzy lub cztery lokalizacje dziennie generuje godziny, które trzeba poprawnie rozdzielić. Ręczne wprowadzanie prowadzi do błędnego przypisania i kwestionowanych płac.",
            "title": "Godziny rozproszone po wielu lokalizacjach"
          },
          {
            "body": "Przestój z powodu złej pogody to realne zdarzenie w architekturze krajobrazu. Bez cyfrowego zapisu dokumentowanie przestojów i korygowanie wypłat jest powolne i podatne na błędy.",
            "title": "Przestoje pogodowe trudno udokumentować"
          },
          {
            "body": "Furgonetki firmowe, pojazdy prywatne i wspólne dojazdy krzyżują się między lokalizacjami przez cały dzień. Bez automatycznej rejestracji te kilometry nigdy nie trafiają do obrazu kosztów.",
            "title": "Przebieg między lokalizacjami pozostaje nieśledzony"
          }
        ],
        "quote": {
          "who": "Właściciel, firma architektury krajobrazu · 12 pracowników sezonowych",
          "text": "Szczyt sezonu oznaczał kiedyś chaos płacowy. Teraz nasz brygadzista sprawdza aplikację, wszyscy są rozliczeni, a ja eksportuję godziny ostatniego dnia miesiąca.",
          "result": "Koniec z odtwarzaniem płac na koniec miesiąca"
        },
        "stats": [
          {
            "label": "rejestracja przebiegu — koniec z rejestrem",
            "value": "Automatycznie"
          },
          {
            "label": "przegląd ekip na wszystkich lokalizacjach",
            "value": "Na żywo"
          },
          {
            "label": "eksport do płac dla wszystkich lokalizacji i wszystkich ekip",
            "value": "1 kliknięcie"
          }
        ],
        "features": [
          {
            "body": "Zobacz wszystkie ekipy, wszystkie lokalizacje w czasie rzeczywistym. Wiedz, kto i gdzie pracuje w danej chwili — a nie na koniec miesiąca.",
            "title": "Przegląd ekip na wielu lokalizacjach"
          },
          {
            "body": "Zaplanuj, kto i gdzie pracuje, obsłuż zmiany w ostatniej chwili i wyślij grafik na telefony zespołu — bez dzwonienia do każdej osoby.",
            "plan": "Time Pro",
            "title": "Planowanie zmian dla zespołów sezonowych"
          },
          {
            "body": "Utwórz niestandardowe rodzaje nieobecności dla swojego sektora: sezonowe przestoje pogodowe, urlop rodzicielski, dni chorobowe. Pracownicy przesyłają dokumentację cyfrowo z aplikacji.",
            "title": "Niestandardowe rodzaje nieobecności"
          },
          {
            "body": "Skonfiguruj rodzaje transportu (furgonetka firmowa, samochód prywatny, kierowca a pasażer wspólnego dojazdu) z ich własnymi stawkami. Kilometry rejestrują się automatycznie dla każdego przejazdu.",
            "plan": "Dodatek",
            "title": "Przebieg ze śledzeniem wspólnych dojazdów"
          },
          {
            "body": "Nadgodziny w szczycie sezonu kumulują się szybko. Każdy pracownik może wybrać wypłatę lub odłożenie godzin jako czasu wolnego — śledzone w przejrzysty sposób.",
            "plan": "Time Pro",
            "title": "Rejestracja nadgodzin z zamianą na urlop"
          }
        ],
        "headline": "Rejestracja czasu pracy dla firm zajmujących się architekturą krajobrazu — ekipy sezonowe, wiele lokalizacji i przebieg w jednym zestawieniu",
        "workflow": [
          {
            "body": "GPS rejestruje przybycie. Godziny automatycznie dzielą się na właściwą lokalizację i projekt — bez ręcznego przypisywania na koniec dnia.",
            "step": "Ekipa melduje się na pierwszej lokalizacji"
          },
          {
            "body": "Brygadzista rejestruje przestój z aplikacji — przejrzysty zapis cyfrowy, bez dodatkowej papierkowej roboty.",
            "step": "Pogoda wstrzymuje pracę"
          },
          {
            "body": "Godziny, nieobecności i przebieg ze wszystkich lokalizacji i od każdego członka ekipy eksportowane w przejrzystej formie do płac.",
            "step": "Koniec miesiąca: wszystkie lokalizacje, wszystkie ekipy, jeden eksport"
          }
        ],
        "compliance": {
          "body": "Done-it daje zespołom architektury krajobrazu cyfrową rejestrację czasu pracy na wszystkich lokalizacjach i wśród personelu sezonowego — zameldowanie z weryfikacją lokalizacji, niestandardowe rodzaje nieobecności dla przestojów pogodowych i przejrzysty eksport do płac spełniający każdy lokalny wymóg.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa rejestracja czasu pracy",
          "title": "Zameldowanie z weryfikacją lokalizacji i śledzenie nieobecności dla sezonowych zespołów architektury krajobrazu"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Konserwacja",
        "slug": "maintenance",
        "intro": "Cykliczne umowy konserwacyjne stoją lub upadają na widoczności kosztów. Done-it rejestruje każdą wizytę, śledzi godziny względem budżetu umowy i daje Tobie — oraz Twoim klientom — dowód obecności na każde wezwanie.",
        "pains": [
          {
            "body": "Gdy godziny cyklicznych wizyt nie są śledzone względem konkretnej umowy, nie wiesz, czy klient jest rentowny, aż do przeglądu na koniec roku — a wtedy jest już za późno na zmianę ceny.",
            "title": "Brak widoczności kosztów w podziale na umowę konserwacyjną"
          },
          {
            "body": "Zarządcy obiektów i właściciele nieruchomości coraz częściej chcą zapisów obecności: kto przyszedł, kiedy przybył, co zrobił. Papierowy rejestr przedstawiony wiele tygodni później nie spełnia wymogów SLA.",
            "title": "Klienci oczekują dowodu na to, co zrobiono"
          },
          {
            "body": "Rotujące zmiany na wielu cyklicznych lokalizacjach — z personelem, który się wzajemnie zastępuje — tworzą zagadkę planowania i śledzenia godzin, której procesy ręczne nie potrafią rzetelnie rozwiązać.",
            "title": "Cykliczne wizyty trudno zaplanować i zarejestrować"
          },
          {
            "body": "Utrzymanie terenów zielonych, konserwacja elewacji i prace przy obiektach zewnętrznych — wszystkie mierzą się z przestojami pogodowymi. Poprawne ich udokumentowanie wymaga cyfrowego śladu.",
            "title": "Przestoje pogodowe dotyczą również konserwacji na zewnątrz"
          }
        ],
        "quote": {
          "who": "Kierownik operacyjny, firma konserwacyjna · 8 pracowników",
          "text": "Możemy powiedzieć zarządcy obiektu dokładnie, kto był na lokalizacji i kiedy, w dwie minuty. Ten poziom dowodu zmienił sposób, w jaki klienci nas postrzegają.",
          "result": "Spory z klientami zredukowane do zera"
        },
        "stats": [
          {
            "label": "koszt w podziale na umowę konserwacyjną",
            "value": "Na żywo"
          },
          {
            "label": "dowód obecności gotowy dla klientów na żądanie",
            "value": "GPS"
          },
          {
            "label": "odnowień umów bez znajomości swojej marży",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Każda umowa konserwacyjna to projekt. Godziny rejestrują się względem niej automatycznie, dając Ci kwotę kosztu na żywo i odliczanie pozostałych godzin dla każdego klienta.",
            "plan": "Project Basic",
            "title": "Śledzenie kosztów oparte na umowach"
          },
          {
            "body": "Opatrzone znacznikiem czasu, zweryfikowane lokalizacyjnie zameldowania są niepodważalnym zapisem, kto był na lokalizacji, kiedy i jak długo — gotowym do udostępnienia klientom na żądanie.",
            "title": "Dowód obecności potwierdzony przez GPS"
          },
          {
            "body": "Pracownicy zgłaszają problemy, ukończone zadania lub prace dodatkowe bezpośrednio z aplikacji — z tekstem i zdjęciami. Klienci otrzymują zapis w czasie rzeczywistym; Ty masz dokumentację do rozliczeń.",
            "plan": "Project Basic",
            "title": "Aktualizacje ze zdjęciami z lokalizacji"
          },
          {
            "body": "Zaplanuj cykliczne wizyty na wszystkich umowach, przypisz pracowników i obsłuż zastępstwa — bez dzwonienia do każdej osoby.",
            "plan": "Time Pro",
            "title": "Planowanie cyklicznych zmian"
          },
          {
            "body": "Skonfiguruj przestoje pogodowe i inne rodzaje nieobecności. Pracownicy rejestrują je z aplikacji; dokumentacja przesyłana jest cyfrowo.",
            "title": "Rodzaje nieobecności dla konserwacji na zewnątrz"
          }
        ],
        "headline": "Rejestracja czasu pracy dla zespołów konserwacyjnych — cykliczne wizyty na lokalizacjach, koszt w podziale na umowę i dowód obecności w jednej aplikacji",
        "workflow": [
          {
            "body": "Zameldowanie z weryfikacją lokalizacji rejestruje czas przybycia i wiąże godziny z właściwą umową. Dowód obecności tworzony jest automatycznie.",
            "step": "Pracownik przybywa na lokalizację konserwacyjną"
          },
          {
            "body": "Ukończona praca i wszelkie problemy są zgłaszane z aplikacji ze zdjęciami. Klienci mogą dokładnie zobaczyć, co zostało zrobione.",
            "step": "Zadania ukończone, problemy zarejestrowane"
          },
          {
            "body": "Godziny kumulują się względem budżetu umowy w czasie rzeczywistym. Znasz marżę, zanim umowa zostanie odnowiona.",
            "step": "Koszt w podziale na umowę widoczny natychmiast"
          }
        ],
        "compliance": {
          "body": "Done-it daje zespołom konserwacyjnym dowód obecności potwierdzony przez GPS w podziale na umowę, niestandardowe rodzaje nieobecności i widok kosztów na żywo dla każdego cyklicznego klienta — spełniając każdy lokalny wymóg rejestracji czasu pracy bez dodatkowego sprzętu.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Śledzenie czasu oparte na umowach",
          "title": "Widoczność kosztów na żywo w podziale na umowę konserwacyjną"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Sklepy i handel",
        "slug": "retail",
        "intro": "Zmiany poranne, zmiany zamykające i ciągłe zastępstwa. Done-it daje każdemu sklepowi czysty, cyfrowy zapis tego, kto pracował na której zmianie — zarejestrowany z własnego telefonu, gotowy do naliczenia płac na koniec miesiąca.",
        "pains": [
          {
            "body": "Ktoś zastępuje chorego kolegę, ktoś inny zostaje godzinę dłużej przy zamykaniu. Zapisane na karteczce albo wcale — i lista płac jest błędna, zanim się zacznie.",
            "title": "Zamiany zmian nigdy nie docierają do płac"
          },
          {
            "body": "Ludzie przechodzą między filiami, pracownicy na część etatu obsługują dwie lokalizacje. Zbieranie godzin z każdego sklepu i ręczne scalanie zabiera dzień w miesiącu.",
            "title": "Kilka sklepów, jedno naliczanie płac"
          },
          {
            "body": "Przerwy ustawowe odliczane z pamięci, dodatkowe godziny rozliczane nieformalnie — czyli dokładnie to, o co kontrola pyta w pierwszej kolejności.",
            "title": "Przerwy i nadgodziny liczone na oko"
          }
        ],
        "quote": {
          "who": "Właściciel, handel detaliczny · 11 pracowników",
          "text": "Dwa sklepy i sporo osób na część etatu. Wcześniej połowę zastępstw rozliczaliśmy z pamięci. Teraz każda godzina trafia na właściwy sklep, a płace zajmują minuty.",
          "result": "Przygotowanie płac z całego dnia do niecałej godziny"
        },
        "stats": [
          {
            "label": "aby zarejestrować wejście — bez terminala przy kasie",
            "value": "1 tapnięcie"
          },
          {
            "label": "podgląd, kto pracuje, we wszystkich sklepach",
            "value": "Na żywo"
          },
          {
            "label": "zamian zmian zgubionych między sklepem a płacami",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Jedno tapnięcie na własnym telefonie na początku zmiany. Bez terminala przy kasie, bez wspólnej karty, bez listy na magazynie.",
            "title": "Rejestracja wejścia na sali sprzedaży"
          },
          {
            "body": "Każdy sklep to osobny projekt. Kto zastępuje w innej filii, rejestruje godziny na tę filię — widzisz je tam, gdzie faktycznie zostały przepracowane.",
            "title": "Godziny na sklep, ludzie między filiami"
          },
          {
            "body": "Ustawiasz regułę przerw raz i obowiązuje na każdej zmianie. Nadgodziny zapisują się w momencie powstania, a każdy pracownik wybiera wypłatę albo odbiór.",
            "title": "Przerwy odliczane automatycznie"
          }
        ],
        "headline": "Ewidencja czasu pracy w sklepie — rejestracja zmiany, zastępstwa i eksport do płac w jednej aplikacji",
        "workflow": [
          {
            "body": "Jedno tapnięcie na telefonie na starcie zmiany. Zastępstwo w innej filii zapisuje się na tę filię.",
            "step": "Pracownik rejestruje wejście na zmianę"
          },
          {
            "body": "Podgląd na żywo we wszystkich lokalizacjach — nieobsadzoną zmianę poranną zauważysz, zanim otworzysz drzwi.",
            "step": "Widzisz, kto jest w pracy, w każdym sklepie"
          },
          {
            "body": "Godziny, przerwy i nadgodziny na pracownika i na sklep, wyeksportowane w formie gotowej dla biura rachunkowego.",
            "step": "Płace w jednym eksporcie"
          }
        ],
        "compliance": {
          "body": "Done-it prowadzi obiektywny, cyfrowy zapis każdego wejścia i wyjścia, wraz z przerwami i nadgodzinami — dokładnie taki, jakiego wymaga kontrola albo spór o wynagrodzenie.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Ewidencja pracy zmianowej",
          "title": "Zapis każdej przepracowanej zmiany, który się obroni"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Biura i usługi profesjonalne",
        "slug": "offices",
        "intro": "Biura rachunkowe, kancelarie notarialne, pracownie architektoniczne, agencje i firmy doradcze fakturują swój czas — albo przynajmniej muszą wiedzieć, gdzie zniknął. Done-it zapisuje godziny na właściwego klienta i projekt, zza biurka i w terenie.",
        "pains": [
          {
            "body": "Czas spisany na koniec tygodnia to czas zgadnięty. Całe godziny po cichu znikają między pracą a fakturą.",
            "title": "Godziny do faktury odtwarzane w piątek"
          },
          {
            "body": "Stawkę ustalono kilka miesięcy temu. Czy praca wciąż się w niej mieści, okazuje się dopiero, gdy ktoś to podliczy — zwykle za późno.",
            "title": "Nie wiadomo, ile naprawdę kosztuje klient"
          },
          {
            "body": "Część zespołu w biurze, część w domu, część u klienta. Obecność przestaje być faktem, a staje się rekonstrukcją.",
            "title": "Praca hybrydowa dziurawi ewidencję"
          }
        ],
        "quote": {
          "who": "Wspólnik, biuro rachunkowe · 8 pracowników",
          "text": "Kiedyś w każdy piątek odtwarzaliśmy cały tydzień. Teraz godziny są już przy właściwym kliencie i widzę, które sprawy zjadają honorarium.",
          "result": "Odzyskane godziny do zafakturowania co miesiąc"
        },
        "stats": [
          {
            "label": "godziny widoczne, gdy praca jeszcze trwa",
            "value": "Na klienta"
          },
          {
            "label": "ta sama ewidencja, telefon i przeglądarka",
            "value": "Biuro i teren"
          },
          {
            "label": "do płac i do fakturowania",
            "value": "1 eksport"
          }
        ],
        "features": [
          {
            "body": "Każdy wpis trafia do projektu, więc widzisz godziny na klienta bez eksportowania czegokolwiek i bez pytania kogokolwiek.",
            "title": "Godziny na klienta i projekt"
          },
          {
            "body": "Ta sama aplikacja w telefonie i w przeglądarce. Wizyta u klienta liczy się jako praca dla tego klienta, razem z dojazdem, jeśli tak chcesz.",
            "title": "Działa przy biurku i poza nim"
          },
          {
            "body": "Dodatkowe godziny zapisywane na bieżąco, urlop zgłaszany i zatwierdzany w aplikacji — bez równoległego arkusza, kto i kiedy jest wolny.",
            "title": "Nadgodziny i urlopy w jednym miejscu"
          }
        ],
        "headline": "Ewidencja czasu pracy w biurze — godziny na klienta i projekt, bez arkusza kalkulacyjnego",
        "workflow": [
          {
            "body": "Konfigurujesz go raz — z klientem i, jeśli rozliczasz się z budżetu, z zaplanowaną liczbą godzin.",
            "step": "Zakładasz projekt klienta"
          },
          {
            "body": "Zza biurka albo z telefonu. Każda godzina trafia do klienta, a nie do czyjejś pamięci.",
            "step": "Zespół zapisuje na nim czas"
          },
          {
            "body": "Sumy na projekt na żywo i czysty eksport do płac albo do fakturowania na koniec miesiąca.",
            "step": "Widzisz godziny na klienta, eksportujesz do płac"
          }
        ],
        "compliance": {
          "body": "Done-it prowadzi cyfrową, odporną na manipulacje ewidencję czasu pracy każdego pracownika — podstawę zarówno dla płac, jak i dla faktury, którą obronisz przed klientem.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Ewidencja czasu na klienta",
          "title": "Obiektywny zapis przepracowanych godzin"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salony i pielęgnacja ciała",
        "slug": "beauty",
        "intro": "Fryzjerzy, barberzy, studia paznokci i gabinety kosmetyczne działają na zmianach i umowach na część etatu. Done-it zapisuje, kto kiedy pracował, automatycznie odlicza przerwy i przekazuje do płac czysty plik.",
        "pains": [
          {
            "body": "Trzy dni w jednym tygodniu, cztery w kolejnym, sobota zamieniona na wtorek. Godziny z umowy i godziny faktyczne szybko się rozjeżdżają.",
            "title": "Praca na część etatu, niekończące się warianty"
          },
          {
            "body": "Rezerwacje mówią, co było umówione, a nie kto pracował. Gdy pyta księgowość albo kontrola, system rezerwacji jest złą odpowiedzią.",
            "title": "Kalendarz wizyt to nie ewidencja czasu pracy"
          },
          {
            "body": "Zostanie po godzinach dla ostatniego klienta jest zapamiętane, obiecane i czasem zapomniane. Z takiej luki rodzi się spór.",
            "title": "Dodatkowe godziny rozliczane nieformalnie"
          }
        ],
        "quote": {
          "who": "Właścicielka, salon fryzjerski · 6 pracowników",
          "text": "Wszyscy są na część etatu i każdy tydzień wygląda inaczej. Aplikacja po prostu to zapisuje — przestałam odtwarzać cały miesiąc w arkuszu.",
          "result": "Koniec sporów o godziny na koniec miesiąca"
        },
        "stats": [
          {
            "label": "aby zarejestrować wejście — nic wspólnego, nic na papierze",
            "value": "1 tapnięcie"
          },
          {
            "label": "odliczanie przerw na każdej zmianie",
            "value": "Auto"
          },
          {
            "label": "godzin po zamknięciu rozliczanych z pamięci",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Jedno tapnięcie na własnym telefonie na początku zmiany — bez wspólnego terminala w recepcji, bez listy obecności przy lustrze.",
            "title": "Rejestracja wejścia w salonie"
          },
          {
            "body": "Regułę przerw i wymiar godzin ustawiasz raz; obowiązują na każdej zmianie, z wyjątkami dla osób, których umowa mówi co innego.",
            "title": "Przerwy i zasady niepełnego etatu raz"
          },
          {
            "body": "Dodatkowe godziny zapisują się w trakcie pracy, a każdy pracownik wybiera wypłatę albo czas wolny — rozliczane w aplikacji, nie z pamięci.",
            "title": "Nadgodziny: wypłata albo odbiór"
          }
        ],
        "headline": "Ewidencja czasu pracy w salonie — zmiany, praca na część etatu i płace bez papierowego kalendarza",
        "workflow": [
          {
            "body": "Jedno tapnięcie po przyjściu. Przerwy odliczane według reguły, którą ustawiasz raz.",
            "step": "Pracownik rejestruje wejście na zmianę"
          },
          {
            "body": "Kto pracuje, kto jest na przerwie, kto został dłużej — na żywo, bez pytania.",
            "step": "Widzisz dzień na bieżąco"
          },
          {
            "body": "Przepracowane godziny, przerwy i nadgodziny na pracownika, wyeksportowane dla biura rachunkowego.",
            "step": "Płace dostają czysty plik"
          }
        ],
        "compliance": {
          "body": "Done-it rejestruje faktyczny czas pracy każdej osoby, z przerwami i nadgodzinami — niezależnie od rezerwacji i wiarygodnie, gdy przychodzi kontrola.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Cyfrowa ewidencja czasu pracy",
          "title": "Zapis, który znaczy więcej niż kalendarz wizyt"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Zdrowie i wellness",
        "slug": "wellness",
        "intro": "Siłownie, studia fitness, gabinety fizjoterapii i spa pracują w długich godzinach otwarcia z rotującą obsadą. Done-it zapisuje, kto obsłużył którą zmianę, automatycznie odlicza przerwy i czysto eksportuje dane do płac.",
        "pains": [
          {
            "body": "Poranne zmiany, wieczorne zajęcia i weekendy, obsadzane mieszanką etatów, części etatu i współpracowników. Grafik to plan, a nie ewidencja.",
            "title": "Długie godziny otwarcia, rotujące zastępstwa"
          },
          {
            "body": "Instruktor prowadzi dwa treningi, a w przerwie zastępuje w recepcji. Żeby zapłacić poprawnie, trzeba wiedzieć, co faktycznie przepracował, a nie co było w grafiku.",
            "title": "Godziny zajęć i godziny na sali się zlewają"
          },
          {
            "body": "Ludzie przechodzą między studiami. Ręczne scalanie ich godzin co miesiąc jest wolne i podatne na błędy.",
            "title": "Kilka lokalizacji, jedna administracja"
          }
        ],
        "quote": {
          "who": "Menedżer, studio fitness · 14 pracowników",
          "text": "Dwa studia, długie godziny otwarcia i mnóstwo zastępstw. Teraz godziny trafiają do właściwego obiektu, a płace to jeden plik.",
          "result": "Grafik i płace wreszcie się zgadzają"
        },
        "stats": [
          {
            "label": "godziny, nawet gdy ktoś zastępuje gdzie indziej",
            "value": "Na studio"
          },
          {
            "label": "podgląd sali we wszystkich lokalizacjach",
            "value": "Na żywo"
          },
          {
            "label": "przerwy i nadgodziny, bez ręcznych obliczeń",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Jedno tapnięcie na telefonie w obiekcie, w którym pracują. Zastępstwo w innym studiu trafia na godziny tego studia.",
            "title": "Rejestracja wejścia w każdym studiu"
          },
          {
            "body": "Widzisz salę we wszystkich lokalizacjach w czasie rzeczywistym — nieobsadzoną poranną zmianę zauważysz przed otwarciem, a nie po.",
            "title": "Podgląd na żywo, kto jest w pracy"
          },
          {
            "body": "Reguły przerw stosowane automatycznie, dodatkowe godziny zapisywane na bieżąco, z wyborem wypłaty albo odbioru dla każdego pracownika.",
            "title": "Przerwy i nadgodziny pod kontrolą"
          }
        ],
        "headline": "Ewidencja czasu pracy dla siłowni, studiów i spa — zmiany, zajęcia i płace w jednej aplikacji",
        "workflow": [
          {
            "body": "Jedno tapnięcie na początku zmiany, w obiekcie, w którym pracuje.",
            "step": "Pracownik rejestruje wejście w studiu"
          },
          {
            "body": "Kto pracuje i w której lokalizacji w tej chwili, więc luki zapełniasz, zanim zauważą je klienci.",
            "step": "Zastępstwa widać na żywo"
          },
          {
            "body": "Godziny, przerwy i nadgodziny na pracownika i na studio, gotowe dla biura rachunkowego.",
            "step": "Jeden eksport do płac"
          }
        ],
        "compliance": {
          "body": "Done-it prowadzi cyfrową ewidencję czasu pracy na pracownika i na lokalizację — podstawę poprawnego wynagrodzenia i każdej kontroli przepracowanych godzin.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Ewidencja zmian w wielu obiektach",
          "title": "Obiektywny zapis każdej zmiany i każdego obiektu"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Gastronomia i hotelarstwo",
        "slug": "hospitality",
        "intro": "Zmiany dzielone, późne zamknięcia i sobota, która się przeciąga. Done-it zapisuje godziny tak, jak zostały faktycznie przepracowane, odlicza przerwy według twojej reguły i przekazuje do płac jeden czysty plik.",
        "pains": [
          {
            "body": "Serwis się przeciąga, zamykanie zajmuje kolejne pół godziny. To realna praca, a rozliczanie jej z pamięci to początek sporów.",
            "title": "Zmiana nigdy nie kończy się wtedy, co w grafiku"
          },
          {
            "body": "Serwis lunchowy, przerwa, potem kolacje. Na papierze robi się z tego jeden długi blok albo dwa domysły — i jedno, i drugie mija się z prawdą.",
            "title": "Zmiany dzielone trudno zapisać"
          },
          {
            "body": "Nowi ludzie w każdym sezonie. System, który wymaga szkolenia, nie przetrwa pierwszego gorącego tygodnia.",
            "title": "Duża rotacja, ciągłe wdrażanie"
          }
        ],
        "quote": {
          "who": "Właściciel, restauracja · 17 pracowników",
          "text": "Zamykanie zawsze się przeciąga. Teraz te minuty są zapisane zamiast być tematem kłótni, a ludzie mogą je odebrać jako czas wolny.",
          "result": "Mniej sporów, szybsze płace"
        },
        "stats": [
          {
            "label": "zapisane jako dwa bloki, a nie jeden domysł",
            "value": "Zmiany dzielone"
          },
          {
            "label": "odliczanie przerw według twojej reguły",
            "value": "Auto"
          },
          {
            "label": "na wdrożenie nowej osoby — to jej własny telefon",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Jedno tapnięcie na początku i na końcu każdego bloku, więc zmiany dzielone są zapisane tak, jak przebiegły — a nie scalone w jedną.",
            "title": "Wejście i wyjście przy każdym serwisie"
          },
          {
            "body": "Obowiązkowe przerwy odliczane automatycznie, z wyjątkami dla osób, których umowa tego wymaga. Bez ręcznych obliczeń na koniec miesiąca.",
            "title": "Przerwy według twojej reguły"
          },
          {
            "body": "Dodatkowe pół godziny po zamknięciu zapisuje się w momencie pracy i zostaje wypłacone albo odebrane jako czas wolny — wybiera pracownik.",
            "title": "Nadgodziny rozliczane w aplikacji"
          }
        ],
        "headline": "Ewidencja czasu pracy w kawiarniach, restauracjach i hotelach — zmiany, przerwy i nadgodziny rozliczone uczciwie",
        "workflow": [
          {
            "body": "Jedno tapnięcie na początku bloku i tak samo na końcu. Zmiany dzielone pozostają dzielone.",
            "step": "Pracownik rejestruje wejście na serwis"
          },
          {
            "body": "Kto pracuje na dzisiejszym serwisie, kto jest jeszcze na przerwie, kto został po zamknięciu.",
            "step": "Widzisz salę na żywo"
          },
          {
            "body": "Czas pracy, przerwy i nadgodziny na pracownika, wyeksportowane w jednym pliku.",
            "step": "Płace dostają realne godziny"
          }
        ],
        "compliance": {
          "body": "Done-it prowadzi obiektywny, cyfrowy zapis każdej zmiany, przerwy i dodatkowej godziny — dokładnie to, o co pyta kontrola płac albo inspekcja pracy.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Ewidencja zmian dzielonych",
          "title": "Wiarygodny zapis godzin w zespole o dużej rotacji"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Ochrona zdrowia i opieka",
        "slug": "healthcare",
        "intro": "Przychodnie, zespoły opieki domowej i domy opieki działają wokół zmian, wizyt i rygorystycznej dokumentacji. Done-it rejestruje czas pracy na zmianę i na wizytę oraz przechowuje dokumenty pracowników tam, gdzie je znajdziesz.",
        "pains": [
          {
            "body": "Wizyty domowe w jednym narzędziu, godziny z grafiku w drugim, a płace dostają trzecią wersję. Uzgadnianie tego to comiesięczna praca.",
            "title": "Wizyty i zmiany w osobnych systemach"
          },
          {
            "body": "Praca w porze nocnej i w weekendy ma inne stawki. Gdy ewidencja jest przybliżona, wynagrodzenie też — a korekta przychodzi później.",
            "title": "Godziny nocne i weekendowe wyceniane błędnie"
          },
          {
            "body": "W opiece kwalifikacje i certyfikaty mają znaczenie, a leżą w segregatorze, którego nikt nie otwiera do czasu kontroli.",
            "title": "Certyfikaty wygasają po cichu"
          }
        ],
        "quote": {
          "who": "Koordynatorka, zespół opieki domowej · 22 pracowników",
          "text": "Wizyty domowe i zmiany z grafiku wreszcie są w jednym zapisie. Płace przestały być ćwiczeniem z uzgadniania danych.",
          "result": "Jeden zapis zamiast trzech"
        },
        "stats": [
          {
            "label": "albo na zmianę — jak pracuje twój zespół",
            "value": "Na wizytę"
          },
          {
            "label": "godziny nocne i weekendowe, zapisane jak przepracowane",
            "value": "Osobno"
          },
          {
            "label": "certyfikaty przechowywane przy każdym pracowniku",
            "value": "W aktach"
          }
        ],
        "features": [
          {
            "body": "Jedno tapnięcie na początku zmiany albo pod każdym adresem klienta w opiece domowej — z weryfikacją lokalizacji tam, gdzie potrzebujesz dowodu.",
            "title": "Rejestracja na zmianę albo na wizytę"
          },
          {
            "body": "Godziny nocne, weekendowe i zwykłe zapisywane osobno, więc eksport do płac od razu odzwierciedla sposób rozliczania pracy.",
            "title": "Godziny podzielone tak, jak je płacisz"
          },
          {
            "body": "Umowy, certyfikaty i dokumenty tożsamości przechowywane przy osobie, której dotyczą — odnajdziesz je w kilka sekund, gdy ktoś o nie poprosi.",
            "title": "Dokumenty pracowników w jednym miejscu"
          }
        ],
        "headline": "Ewidencja czasu pracy dla zespołów opiekuńczych — zmiany, wizyty domowe i kwalifikacje w jednym zapisie",
        "workflow": [
          {
            "body": "Jedno tapnięcie w placówce albo pod adresem klienta, z weryfikacją lokalizacji tam, gdzie potrzebny jest dowód.",
            "step": "Rejestracja wejścia na zmianę lub wizytę"
          },
          {
            "body": "Godziny zwykłe, nocne i weekendowe zapisywane osobno, na bieżąco.",
            "step": "Godziny trafiają do właściwej kategorii"
          },
          {
            "body": "Jeden czysty plik za okres, już podzielony tak, jak rozliczasz wynagrodzenia.",
            "step": "Eksport do płac"
          }
        ],
        "compliance": {
          "body": "Done-it prowadzi cyfrowy, obiektywny zapis czasu pracy każdej osoby — godziny, przerwy i podział na godziny nocne i weekendowe — razem z dokumentami przypisanymi do pracownika.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Ewidencja zmian i wizyt",
          "title": "Dokumentacja, która przechodzi kontrolę"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "ro": [
      {
        "name": "Construcții",
        "slug": "construction",
        "intro": "Echipe răspândite pe șantiere, ore mâzgălite pe hârtie, ore ale subcontractanților imposibil de reconciliat. Done-it oferă fiecărui șantier o fișă de pontaj digitală etanșă care alimentează salarizarea cu un singur clic.",
        "pains": [
          {
            "body": "Cu mai multe șantiere active și echipe care se rotesc, fișele de pontaj manuale sunt greșite din construcție. Lucrătorii rotunjesc în plus, uită înregistrări sau le completează zile mai târziu — lăsându-te cu cifre de salarizare pe care nu le poți susține.",
            "title": "Nicio evidență fiabilă a cine a lucrat și unde"
          },
          {
            "body": "Până observi că un șantier a consumat orele planificate, marja deja a dispărut. Nu există o numărătoare inversă în timp real — doar o surpriză neplăcută la momentul facturării.",
            "title": "Depășirile de buget apar prea târziu"
          },
          {
            "body": "Colectarea fișelor de pontaj, reconcilierea lor cu proiectele și pregătirea exportului pentru salarizare durează zile. Fiecare înregistrare este o potențială eroare.",
            "title": "Pregătirea salarizării înghite ore în fiecare lună"
          }
        ],
        "quote": {
          "who": "Patron, firmă de construcții · 14 angajați",
          "text": "Echipa noastră se pontează singură pe șantier. La sfârșitul lunii, salarizarea pur și simplu se adună — am încetat complet să mai alergăm după fișe de pontaj.",
          "result": "5 ore pe săptămână economisite la administrație"
        },
        "stats": [
          {
            "label": "pentru a te ponta pe orice șantier — fără terminal, fără hârtie",
            "value": "1 atingere"
          },
          {
            "label": "export pentru salarizare gata pentru furnizorul tău",
            "value": "1 clic"
          },
          {
            "label": "vizualizarea orelor rămase pe proiect și șantier",
            "value": "În timp real"
          }
        ],
        "features": [
          {
            "body": "O singură atingere pontează lucrătorul, verificat prin locație, și leagă orele de proiectul potrivit. Fără cititoare de carduri, fără terminale — doar smartphone-ul pe care echipa ta îl are deja.",
            "title": "Pontaj verificat prin locație pe fiecare șantier"
          },
          {
            "body": "Stabilește orele planificate ca buget când deschizi proiectul. Lucrătorii văd o numărătoare inversă a ceea ce a mai rămas; tu o vezi în timp real în panoul de control. Depășirile de buget sunt vizibile înainte să se întâmple.",
            "title": "Ore rămase în timp real pe proiect"
          },
          {
            "body": "Adaugă subcontractanți la un proiect, atribuie-le pontajul și urmărește-le orele alături de propria echipă — în aceeași privire de ansamblu.",
            "title": "Gestionarea și prezența subcontractanților"
          },
          {
            "body": "Toate orele înregistrate — pe lucrător, pe proiect — se exportă într-o foaie de calcul curată pentru furnizorul tău de salarizare. Fără pregătire manuală, fără erori.",
            "title": "Export pentru salarizare cu un singur clic"
          }
        ],
        "headline": "Pontaj pentru echipele de construcții — pontaj verificat prin locație, ore pe proiect și control al bugetului, într-o singură aplicație",
        "workflow": [
          {
            "body": "Fiecare lucrător atinge o dată pentru a se ponta. GPS-ul confirmă locația, marchează ora înregistrării și leagă orele de proiect. Fără hârtie, fără terminal.",
            "step": "Echipa ajunge pe șantier"
          },
          {
            "body": "Ore, buget rămas, prezența subcontractanților și orice lucrare suplimentară raportată de pe șantier — toate în panoul tău de control, în timp real.",
            "step": "Vezi totul în timp real"
          },
          {
            "body": "Exportă toate orele pe lucrător și pe proiect. Trimite-le furnizorului tău de salarizare. Done-it generează automat rapoarte curate, pregătite pentru audit.",
            "step": "Sfârșitul lunii în câteva minute"
          }
        ],
        "compliance": {
          "body": "Done-it oferă pontaj verificat prin locație, urmărirea timpului pe proiect și un export curat pentru salarizare destinate echipelor de construcții. Pentru echipele care operează pe șantiere belgiene, alimentează automat și pontajul la locul de muncă.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Înregistrare digitală a timpului",
          "title": "Pontaj verificat prin locație creat pentru șantierele de construcții"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Curățenie",
        "slug": "cleaning",
        "intro": "Personalul de curățenie se deplasează între locații toată ziua. Done-it urmărește cine se află unde în timp real — pontaj verificat prin locație la fiecare punct de lucru, deducerea automată a pauzelor și un export curat pentru salarizare la sfârșitul lunii.",
        "pains": [
          {
            "body": "Clienții și inspectorii se așteaptă la evidențe de prezență etanșe. Fișele manuale pot fi contestate; pontajele digitale verificate prin locație nu pot.",
            "title": "Dovedirea prezenței la fiecare locație"
          },
          {
            "body": "Cu personalul de curățenie care se deplasează între puncte de lucru pe parcursul zilei, nu ai nicio imagine în timp real a cine lucrează și unde — până când sună cineva.",
            "title": "Echipe răspândite în multe locații"
          },
          {
            "body": "Fără ore exacte de intrare/ieșire, salarizarea este reconstruită din memorie. Orele sunt rotunjite în plus, costurile cresc și urmează dispute.",
            "title": "Erori de salarizare din orele rotunjite"
          }
        ],
        "quote": {
          "who": "Manager, firmă de curățenie · 9 angajați",
          "text": "În sfârșit putem dovedi cine a făcut curățenie unde și când. Gata cu fișele de prezență, gata cu disputele cu clienții — GPS-ul se ocupă de asta.",
          "result": "Zero rotunjire în plus a orelor"
        },
        "stats": [
          {
            "label": "pentru a te ponta la orice locație — fără terminal",
            "value": "1 atingere"
          },
          {
            "label": "vizualizarea cine se află pe ce locație chiar acum",
            "value": "În timp real"
          },
          {
            "label": "înregistrări duble — orele ajung direct la salarizare",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Lucrătorii se pontează la intrare și ieșire de pe telefon la fiecare locație, verificat prin locație; timpul este exact, cu înregistrarea pauzelor.",
            "plan": "Time Basic",
            "title": "Pontaj la intrare și ieșire în timp real"
          },
          {
            "body": "Pauzele obligatorii sunt scăzute automat din ziua de lucru — fără calcule manuale, fără dispute.",
            "plan": "Time Basic",
            "title": "Deducerea automată a pauzelor"
          },
          {
            "body": "Vezi care persoane de la curățenie sunt la care locații chiar acum. Identifică lipsurile înainte ca clienții să o facă.",
            "title": "Privire de ansamblu în timp real pe mai multe locații"
          },
          {
            "body": "Lucrătorii încarcă certificatele medicale și documentele de absență direct din aplicație. Creează tipurile de absență pe care echipa ta chiar le folosește.",
            "title": "Înregistrarea absențelor cu certificate medicale digitale"
          },
          {
            "body": "Marcajele de timp exacte ajung direct într-un export pregătit pentru salarizare pentru furnizorul tău. Fără transcriere, fără erori.",
            "title": "Export pentru salarizare cu un singur clic"
          }
        ],
        "headline": "Pontaj pentru firmele de curățenie — pontaj verificat prin locație, dovadă a prezenței și salarizare într-o singură aplicație",
        "workflow": [
          {
            "body": "O singură atingere o pontează. GPS-ul înregistrează punctul de lucru și marchează ora înregistrării. Înregistrarea pauzelor este integrată în aplicație.",
            "step": "Persoana de la curățenie ajunge la locație"
          },
          {
            "body": "Cine se află la care locație chiar acum — fără telefoane, fără presupuneri. Identifică lipsurile de acoperire înainte ca clienții să o facă.",
            "step": "Vezi fiecare locație în timp real"
          },
          {
            "body": "Toate datele de prezență — ore exacte, locații și pauze — se exportă curat pentru furnizorul tău de salarizare.",
            "step": "Salarizarea înseamnă un singur clic"
          }
        ],
        "compliance": {
          "body": "Done-it oferă echipelor de curățenie pontaj verificat prin locație la fiecare punct de lucru, deducerea automată a pauzelor și o imagine în timp real a cine se află pe ce locație chiar acum.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Prezență verificată prin locație",
          "title": "Prezență în timp real la fiecare locație de curățenie"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Instalații",
        "slug": "installation",
        "intro": "Trimite-ți montatorii la adresa potrivită cu tot ce le trebuie, leagă automat fiecare oră lucrată de lucrarea potrivită și vezi bugetul rămas înainte ca șantierul să se închidă. Done-it este cea mai simplă cale de a menține proiectele de instalații la timp și în limita costurilor.",
        "pains": [
          {
            "body": "Echipele ajung pe un șantier fără adresă, persoană de contact sau detalii despre scop. Primul telefon înseamnă zece minute de timp facturabil pierdute înainte ca o singură oră să fie lucrată.",
            "title": "Informațiile despre lucrare nu ajung la timp pe teren"
          },
          {
            "body": "Când lucrătorii își completează orele manual la sfârșitul zilei — dacă le completează — orele ajung pe lucrarea greșită sau dispar complet. Facturile nu corespund realității.",
            "title": "Orele nu sunt legate de proiectul potrivit"
          },
          {
            "body": "Fără o numărătoare inversă în timp real a orelor rămase pe proiect, afli că o lucrare a depășit bugetul când închizi factura — nu cât încă poți reacționa.",
            "title": "Depășirile de buget observate prea târziu"
          },
          {
            "body": "Subcontractanții care lucrează pe același șantier folosesc sisteme diferite, completează orele separat sau deloc. Reconcilierea la sfârșitul lunii este un proces lent și predispus la erori.",
            "title": "Orele subcontractanților greu de urmărit"
          }
        ],
        "quote": {
          "who": "Patron, firmă de instalații · 6 angajați",
          "text": "Orele ajung automat pe proiectul potrivit. Calculul costurilor pe lucrare a devenit dintr-odată ușor — putem vedea marja reală înainte să închidem o lucrare.",
          "result": "Cost real pe lucrare, în timp real"
        },
        "stats": [
          {
            "label": "vizualizarea orelor rămase pe proiect",
            "value": "În timp real"
          },
          {
            "label": "telefoane la birou pentru adresele șantierelor",
            "value": "0"
          },
          {
            "label": "navighează către orice adresă de proiect din aplicație",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "Lucrătorii deschid proiectul pe telefon: adresă, ore planificate, persoană de contact și fișiere încărcate (planuri, instrucțiuni, PDF-uri). Tot ce le trebuie este acolo înainte să ajungă.",
            "plan": "Project Basic",
            "title": "Informațiile despre proiect partajate direct în aplicație"
          },
          {
            "body": "Atinge o dată și telefonul navighează către adresa proiectului — integrat în aplicație, fără o aplicație separată de hartă.",
            "title": "Navigație către șantier cu un singur buton"
          },
          {
            "body": "Stabilește orele planificate când deschizi proiectul. Lucrătorii văd câte ore au rămas; tu vezi starea în timp real în panoul de control. Depășirile sunt vizibile înainte să se întâmple.",
            "plan": "Project Basic",
            "title": "Numărătoare inversă a orelor rămase pe proiect"
          },
          {
            "body": "Fiecare lucrător se pontează pe proiectul potrivit. Știi mereu cine se află pe ce șantier chiar acum.",
            "plan": "Project Basic",
            "title": "Pontajul lucrătorului pe proiect"
          },
          {
            "body": "Când scopul crește pe șantier, lucrătorii înregistrează lucrările și materialele suplimentare în timp real — cu text și fotografii — astfel încât nimic nu se facturează din memorie.",
            "plan": "Project Basic",
            "title": "Înregistrarea lucrărilor și materialelor suplimentare"
          }
        ],
        "headline": "Pontaj pentru echipele de instalații — ore pe proiect, navigație și control al bugetului într-o singură aplicație",
        "workflow": [
          {
            "body": "Adresa, contactul, scopul și fișierele încărcate sunt chiar acolo. Navighează cu o singură atingere — fără telefoane la birou pentru indicații.",
            "step": "Lucrătorul deschide proiectul pe telefon"
          },
          {
            "body": "Pontajul leagă fiecare minut lucrat de proiectul corect. Bugetul rămas se actualizează în timp real.",
            "step": "Orele se înregistrează automat pe lucrarea potrivită"
          },
          {
            "body": "Modificările de scop, materialele suplimentare și întârzierile sunt înregistrate cu text și fotografii în momentul în care se întâmplă — gata pentru factură.",
            "step": "Lucrările suplimentare sunt înregistrate pe șantier"
          }
        ],
        "compliance": {
          "body": "Done-it oferă echipelor de instalații pontaj verificat prin locație pe proiect, o numărătoare inversă în timp real a orelor rămase și export automat pentru salarizare — acoperind orice cerință locală de înregistrare a timpului. Pentru echipele care lucrează pe șantiere de construcții belgiene, se integrează și cu CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Înregistrare digitală a timpului",
          "title": "Pontaj verificat prin locație pe proiect pentru echipele de instalații"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Servicii pe teren",
        "slug": "field-service",
        "intro": "Tehnicieni care vizitează mai mulți clienți pe zi, bonuri în torpedouri, kilometraj înregistrat din memorie. Done-it captează ore, kilometri și cheltuieli pe teren — atașate lucrării potrivite în momentul în care se întâmplă.",
        "pains": [
          {
            "body": "A le cere tehnicienilor să-și reconstituie rutele la sfârșitul săptămânii înseamnă rambursări inexacte, dispute cu clienții și un teanc tot mai mare de kilometri nedecontați.",
            "title": "Kilometraj înregistrat zile mai târziu — dacă e înregistrat"
          },
          {
            "body": "Un bon dintr-un torpedou este un cost care s-ar putea să nu ajungă niciodată într-o factură. Costul real pe lucrare este mereu subestimat.",
            "title": "Cheltuieli pe bonuri de hârtie care dispar"
          },
          {
            "body": "Fără pontaje în timp real, afli unde se află un tehnician doar când ceva merge prost și sună cineva.",
            "title": "Nicio imagine în timp real a locului în care se află echipa"
          },
          {
            "body": "Când manopera, deplasarea și cheltuielile sunt urmărite în sisteme separate — sau deloc — nu există niciodată o singură cifră de cost pe lucrare.",
            "title": "Greu de văzut marja reală pe lucrare"
          }
        ],
        "quote": {
          "who": "Manager de operațiuni, firmă de servicii pe teren · 11 angajați",
          "text": "Kilometrajul era o bătaie de cap lunară. Acum se înregistrează singur — fiecare kilometru este atașat clientului potrivit înainte să ne întoarcem măcar la birou.",
          "result": "Cost exact pe lucrare, de fiecare dată"
        },
        "stats": [
          {
            "label": "captarea kilometrajului — fără jurnal de bord manual",
            "value": "Automat"
          },
          {
            "label": "cost pe lucrare: ore + deplasare + cheltuieli",
            "value": "În timp real"
          },
          {
            "label": "kilometri pierduți — fiecare deplasare captată automat",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS-ul înregistrează plecarea, sosirea și distanța exactă pentru fiecare deplasare. Configurează tipuri de transport (mașină proprie, vehicul de firmă, transport în comun) cu propriile tarife de rambursare. Fără jurnal de bord manual.",
            "plan": "Add-on",
            "title": "Captarea automată a kilometrajului (Trax-it)"
          },
          {
            "body": "Lucrătorii fotografiază un bon pe teren; este atașat lucrării și pregătit pentru rambursare — nu urmărit la sfârșitul lunii.",
            "plan": "Time Basic",
            "title": "Gestionarea cheltuielilor pe teren"
          },
          {
            "body": "Orele, kilometrajul și cheltuielile se adună pe lucrare în timp real. Costul pe lucrare este vizibil cât lucrarea este încă deschisă.",
            "plan": "Project Basic",
            "title": "Control al costurilor legat de proiect"
          },
          {
            "body": "Fiecare tehnician se pontează la sediul clientului. Vezi cine se află unde, chiar acum — fără telefoane, fără presupuneri.",
            "title": "Pontaj verificat prin locație și privire de ansamblu a echipei în timp real"
          },
          {
            "body": "Orele și rambursările de kilometraj se exportă curat pentru furnizorul tău de salarizare — cu tarifele de kilometraj configurate aplicate automat.",
            "title": "Export pentru salarizare cu un singur clic"
          }
        ],
        "headline": "Pontaj pentru echipele de servicii pe teren — kilometraj, cheltuieli și ore din mers, toate într-o singură aplicație",
        "workflow": [
          {
            "body": "Pontajul pornește jurnalul deplasării. Kilometrii sunt captați automat de la plecare la sosire — fără înregistrare manuală.",
            "step": "Tehnicianul pleacă spre primul apel"
          },
          {
            "body": "Orele se leagă de proiectul potrivit. Lucrările suplimentare, materialele și bonurile sunt înregistrate în aplicație în momentul în care se întâmplă.",
            "step": "La șantier"
          },
          {
            "body": "Fiecare oră, kilometru și cheltuială este deja atașată lucrării corecte. Exportă pentru salarizare și facturează cu cifre de cost reale.",
            "step": "Sfârșitul lunii fără haos"
          }
        ],
        "compliance": {
          "body": "Done-it captează automat kilometrajul pentru fiecare deplasare, aplică tarifele de rambursare configurate de tine și înregistrează fiecare kilometru pentru clientul sau proiectul potrivit. Hotărârea UE în cazul Tyco înseamnă că deplasarea de acasă la primul client contează ca timp de lucru — Done-it urmărește și asta.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Urmărire digitală a timpului și kilometrajului",
          "title": "Ore prin GPS și kilometraj automat pentru echipele de servicii pe teren"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "HVAC",
        "slug": "hvac",
        "intro": "Fiecare apel de service are trei costuri: manoperă, piese și deplasare. Done-it le captează pe toate trei pe teren și le adună pe lucrarea potrivită — așa că îți cunoști marja înainte să închizi factura.",
        "pains": [
          {
            "body": "Manopera, piesele și deplasarea trăiesc în sisteme diferite — sau buzunare diferite. Costul real al unei intervenții devine clar abia mult după ce tehnicianul a plecat de pe șantier.",
            "title": "Apelurile de service sunt greu de calculat cu exactitate ca și cost"
          },
          {
            "body": "Când un client contestă cât a durat o reparație, o fișă de pontaj pe hârtie este ușor de contestat. Marcajele de pontaj la intrare și ieșire confirmate prin GPS nu sunt.",
            "title": "Nicio dovadă a timpului de service"
          },
          {
            "body": "Pe contractele de mentenanță recurentă, micile depășiri se acumulează de-a lungul multor vizite. Fără un contor de ore în timp real, afli că contractul este în pierdere abia la reînnoire.",
            "title": "Contractele de mentenanță erodează marja în tăcere"
          },
          {
            "body": "Înregistrările manuale de timp ratează pauzele, ducând la supraplată și o salarizare care nu corespunde realității.",
            "title": "Tehnicienii uită să înregistreze pauzele"
          }
        ],
        "quote": {
          "who": "Patron, firmă HVAC · 7 tehnicieni",
          "text": "În sfârșit știm cât ne costă cu adevărat fiecare contract de service. Surprizele legate de marjă au încetat din ziua în care am început să folosim Done-it.",
          "result": "Cost real pe apel de service, în timp real"
        },
        "stats": [
          {
            "label": "tipuri de cost captate pe apel: manoperă, deplasare, piese",
            "value": "3"
          },
          {
            "label": "vizibilitate a marjei pe contract de service",
            "value": "În timp real"
          },
          {
            "label": "surprize la momentul facturării — costuri vizibile în timp real",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Fiecare apel de service sau contract de mentenanță este un proiect. Orele, deplasarea și materialele se adună în timp real — oferindu-ți vizibilitate a marjei în timp real.",
            "plan": "Project Basic",
            "title": "Pontaj bazat pe proiect"
          },
          {
            "body": "Când o lucrare crește, tehnicienii înregistrează lucrările suplimentare și piesele cu text și fotografii înainte să plece. Nimic nu se facturează din memorie.",
            "plan": "Project Basic",
            "title": "Lucrări și materiale suplimentare, înregistrate pe șantier"
          },
          {
            "body": "Kilometrii pe intervenție sunt înregistrați automat și alocați ca și cost lucrării. Configurează tarifele de rambursare pe tip de vehicul.",
            "plan": "Add-on",
            "title": "Kilometraj și costuri de transport"
          },
          {
            "body": "Pauzele obligatorii sunt scăzute automat din timpul total — fără dispute, fără erori de salarizare.",
            "title": "Deducerea automată a pauzelor"
          },
          {
            "body": "Pontaj la intrare confirmat prin GPS, cu marcaj de timp, la fiecare șantier. Dovadă incontestabilă a momentului în care tehnicianul a sosit și a plecat.",
            "title": "Pontaj verificat prin locație și dovadă a prezenței"
          }
        ],
        "headline": "Pontaj pentru tehnicienii HVAC — calculul costurilor pe lucrare, piese și deplasare într-o singură aplicație",
        "workflow": [
          {
            "body": "GPS-ul marchează ora sosirii și leagă orele de apelul de service sau de contractul de mentenanță. Fără hârtie, fără terminal.",
            "step": "Tehnicianul se pontează la șantier"
          },
          {
            "body": "Piesele folosite, orele suplimentare și modificările de scop sunt înregistrate în aplicație cu fotografii — înainte de a părăsi șantierul.",
            "step": "Lucrările suplimentare sunt înregistrate pe loc"
          },
          {
            "body": "Manopera, deplasarea și materialele se adună pe proiect în timp real. Vezi marja înainte să emiți factura.",
            "step": "Costul lucrării este vizibil imediat"
          }
        ],
        "compliance": {
          "body": "Done-it oferă echipelor HVAC pontaj verificat prin locație pe fiecare apel de service, vizibilitate a costurilor în timp real pe lucrare (manoperă + deplasare + piese) și un export curat pentru salarizare — îndeplinind orice cerință locală de înregistrare a timpului fără echipamente suplimentare.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Urmărire digitală a timpului și costurilor",
          "title": "Calculul complet al costurilor pe lucrare pentru apelurile de service HVAC"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Electricieni",
        "slug": "electricians",
        "intro": "Ore pe proiect, o numărătoare inversă în timp real a bugetului rămas și navigație către șantier cu un singur buton — creat pentru echipele mici de electricieni care au nevoie de control al proiectului fără povara administrativă.",
        "pains": [
          {
            "body": "Când electricienii lucrează la mai multe lucrări într-o săptămână, alocarea manuală a orelor la sfârșitul zilei duce la costuri atribuite greșit, dispute de facturare și o salarizare pe care nu o poți explica.",
            "title": "Orele nu sunt legate de proiectul potrivit"
          },
          {
            "body": "Fără o imagine în timp real a orelor consumate față de orele bugetate, afli că un proiect a depășit bugetul când emiți factura — nu când încă puteai reacționa.",
            "title": "Depășirile de buget observate prea târziu"
          },
          {
            "body": "Adrese tastate într-o aplicație separată, telefoane la birou pentru indicații, sosiri târzii la sediile clienților. Fiecare minut pierdut este un minut facturabil pierdut.",
            "title": "Timp pierdut găsind șantierul"
          },
          {
            "body": "La instalațiile mai mari, electricienii subcontractanți își urmăresc orele separat. Obținerea unei imagini combinate a costurilor de manoperă la sfârșitul unui proiect este o muncă manuală, predispusă la erori.",
            "title": "Orele subcontractanților greu de reconciliat"
          }
        ],
        "quote": {
          "who": "Patron, firmă de electrice · 5 electricieni",
          "text": "Știm în timp real dacă un proiect depășește bugetul. Doar atât ne-a scutit de două surprize neplăcute anul acesta.",
          "result": "Depășiri de buget prinse înainte să se întâmple"
        },
        "stats": [
          {
            "label": "vizualizarea orelor rămase pe proiect",
            "value": "În timp real"
          },
          {
            "label": "telefoane la birou pentru adresele șantierelor",
            "value": "0"
          },
          {
            "label": "pentru a te ponta la orice șantier — fără terminal",
            "value": "1 atingere"
          }
        ],
        "features": [
          {
            "body": "Fiecare minut lucrat este legat automat de proiectul potrivit. O numărătoare inversă în timp real arată câte ore au rămas din buget — pentru tine și pentru lucrătorul de pe șantier.",
            "plan": "Project Basic",
            "title": "Ore pe proiect cu buget rămas în timp real"
          },
          {
            "body": "Adresa proiectului este în aplicație. O singură atingere deschide navigația — fără căutări, fără o aplicație separată de hartă, fără telefoane la birou.",
            "title": "Navigație către șantier cu un singur buton"
          },
          {
            "body": "Fiecare electrician se pontează pe lucrarea potrivită. Știi mereu cine se află pe ce șantier chiar acum.",
            "plan": "Project Basic",
            "title": "Pontajul lucrătorului pe proiect"
          },
          {
            "body": "Când scopul se schimbă — un circuit neprevăzut, materiale suplimentare — este înregistrat în aplicație cu fotografii, înainte ca echipa să plece.",
            "plan": "Project Basic",
            "title": "Lucrări suplimentare înregistrate pe șantier"
          },
          {
            "body": "Orele suplimentare sunt înregistrate în momentul în care se întâmplă. Lucrătorii aleg să le primească plătite sau convertite în timp liber.",
            "plan": "Time Pro",
            "title": "Urmărirea orelor suplimentare cu compensare flexibilă"
          }
        ],
        "headline": "Pontaj pentru electricieni — ore pe proiect, control al bugetului și navigație într-o singură aplicație",
        "workflow": [
          {
            "body": "Adresa și scopul sunt deja în aplicație. O singură atingere deschide navigația — fără telefoane, fără confuzie.",
            "step": "Electricianul navighează către lucrare"
          },
          {
            "body": "Pontajul la șantier leagă fiecare minut lucrat de proiectul corect. Contorul de ore rămase se actualizează în timp real.",
            "step": "Orele se leagă automat de proiectul potrivit"
          },
          {
            "body": "Lucrările și materialele suplimentare sunt înregistrate pe șantier, înainte de plecare. Factura reflectă ce s-a întâmplat cu adevărat.",
            "step": "Modificările de scop rămân în evidență"
          }
        ],
        "compliance": {
          "body": "Done-it oferă electricienilor pontaj verificat prin locație pe proiect, un buget de ore rămase în timp real și export pentru salarizare — satisfăcând orice cerință locală de înregistrare a timpului. Pentru echipele de pe șantierele de construcții belgiene, se integrează și cu CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj verificat prin locație pe proiect",
          "title": "Control al bugetului în timp real și pontaj verificat prin locație pentru echipele de electricieni"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Instalații sanitare",
        "slug": "plumbing",
        "intro": "Intervenții de urgență, mai multe lucrări pe zi, ore completate din memorie la sfârșitul săptămânii — sau deloc. Done-it transformă asta într-o operațiune de o singură atingere la fiecare șantier și o salarizare de un singur clic la sfârșitul lunii.",
        "pains": [
          {
            "body": "Cu mai multe lucrări pe zi, instalatorii rareori au timp să completeze fișe de pontaj exacte. Orele sunt rotunjite sau uitate, iar salarizarea este în cel mai bun caz o estimare.",
            "title": "Orele de intervenție reconstruite din memorie"
          },
          {
            "body": "Când un client contestă cât a durat o reparație, nu există o evidență obiectivă. Un pontaj digital confirmat prin GPS este ușor de produs — o fișă de pontaj pe hârtie nu.",
            "title": "Nicio dovadă a timpului pe șantier"
          },
          {
            "body": "Deplasarea între intervenții se adună de-a lungul săptămânii și lunii, dar fără captare automată este rareori facturată sau rambursată corect.",
            "title": "Kilometrajul între lucrări neurmărit"
          },
          {
            "body": "La sfârșitul lunii, alergatul după fișe de pontaj, corectarea erorilor și construirea exportului pentru salarizare consumă timp pe care echipa ta administrativă nu ar trebui să-l cheltuiască.",
            "title": "Pregătirea salarizării este lentă"
          }
        ],
        "quote": {
          "who": "Patron, firmă de instalații sanitare · 4 instalatori",
          "text": "Obișnuiam să petrecem o dimineață la sfârșitul lunii reconstruind orele. Acum doar exportăm și trimitem. Furnizorul de salarizare le primește curate.",
          "result": "Pregătirea salarizării redusă de la ore la minute"
        },
        "stats": [
          {
            "label": "pentru a te ponta — suficient de rapid pentru apeluri de urgență",
            "value": "1 atingere"
          },
          {
            "label": "export pentru salarizare către furnizorul tău",
            "value": "1 clic"
          },
          {
            "label": "ore reconstruite din memorie la sfârșitul lunii",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Sosirea și plecarea înregistrate cu o singură atingere, cu verificarea locației. Suficient de rapid pentru apeluri de urgență; suficient de precis pentru dispute.",
            "plan": "Time Basic",
            "title": "Pontaj verificat prin locație cu o singură atingere la fiecare intervenție"
          },
          {
            "body": "Pauzele obligatorii sunt scăzute automat din timpul total — nimic de completat, fără erori de salarizare.",
            "plan": "Time Basic",
            "title": "Deducerea automată a pauzelor"
          },
          {
            "body": "Configurează tipuri de transport și tarife de rambursare. Kilometrii se înregistrează automat și se leagă de clientul sau proiectul corect.",
            "plan": "Add-on",
            "title": "Kilometraj captat pe deplasare"
          },
          {
            "body": "Lucrătorii trimit certificate medicale digital din aplicație. Creează tipurile de absență pe care echipa ta chiar le folosește, inclusiv întârzieri cauzate de vreme.",
            "title": "Gestionarea absențelor și a certificatelor medicale"
          },
          {
            "body": "Toate orele și datele de kilometraj se exportă curat pentru furnizorul tău de salarizare — fără pregătire manuală, fără Excel.",
            "plan": "Time Basic",
            "title": "Export pentru salarizare cu un singur clic"
          }
        ],
        "headline": "Pontaj pentru echipele de instalații sanitare — pontaj rapid, salarizare exactă și dovadă a prezenței pentru fiecare intervenție",
        "workflow": [
          {
            "body": "O singură atingere îl pontează. GPS-ul înregistrează locația și ora. Suficient de rapid pentru o lucrare de urgență.",
            "step": "Instalatorul ajunge la intervenție"
          },
          {
            "body": "Pontajul de ieșire închide înregistrarea de timp. Kilometrajul către următoarea lucrare începe să se înregistreze automat.",
            "step": "Plecarea este atinsă la ieșire"
          },
          {
            "body": "Toate intervențiile, orele și kilometrii se exportă curat. Pregătirea salarizării scade de la o zi la câteva minute.",
            "step": "Sfârșitul lunii înseamnă un singur clic"
          }
        ],
        "compliance": {
          "body": "Done-it acoperă orice cerință locală de înregistrare a timpului pentru echipele de instalații sanitare — pontaj verificat prin locație cu o singură atingere pe intervenție, deducerea automată a pauzelor și un export curat pentru salarizare. Fără fișe de pontaj pe hârtie, fără reconstrucție manuală.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Înregistrare digitală a timpului",
          "title": "Pontaj rapid verificat prin locație pentru fiecare intervenție"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Amenajări peisagistice",
        "slug": "landscaping",
        "intro": "Sezonul de vârf înseamnă multe locații, echipe care se schimbă și mulți kilometri. Done-it ține fiecare oră, fiecare absență și fiecare deplasare organizate — ca să te poți concentra pe muncă, nu pe hârtii.",
        "pains": [
          {
            "body": "Lucrătorii temporari, programele schimbătoare și dimensiunile variabile ale echipelor fac aproape imposibilă urmărirea exactă a orelor cu hârtia. Până reconciliezi la sfârșitul lunii, mereu lipsește ceva.",
            "title": "Echipele sezoniere sunt complexe de gestionat"
          },
          {
            "body": "O echipă care vizitează trei sau patru locații pe zi generează ore care trebuie împărțite corect. Înregistrarea manuală duce la atribuiri greșite și la o salarizare contestată.",
            "title": "Ore răspândite în multe locații"
          },
          {
            "body": "Întreruperea din cauza vremii nefavorabile este un eveniment real în amenajările peisagistice. Fără o evidență digitală, documentarea opririlor și ajustarea plății este lentă și predispusă la erori.",
            "title": "Opririle cauzate de vreme sunt greu de documentat"
          },
          {
            "body": "Dube de firmă, vehicule personale și transport în comun circulă între locații toată ziua. Fără captare automată, acei kilometri nu ajung niciodată în imaginea costurilor.",
            "title": "Kilometrajul între locații rămâne neurmărit"
          }
        ],
        "quote": {
          "who": "Patron, firmă de amenajări peisagistice · 12 lucrători sezonieri",
          "text": "Sezonul de vârf însemna haos la salarizare. Acum șeful nostru de echipă verifică aplicația, toată lumea este contabilizată, iar eu export orele în ultima zi a lunii.",
          "result": "Gata cu reconstrucția salarizării de la sfârșitul lunii"
        },
        "stats": [
          {
            "label": "captarea kilometrajului — gata cu jurnalul de bord",
            "value": "Automat"
          },
          {
            "label": "privire de ansamblu a echipei pe toate locațiile",
            "value": "În timp real"
          },
          {
            "label": "export pentru salarizare pentru toate locațiile și toată echipa",
            "value": "1 clic"
          }
        ],
        "features": [
          {
            "body": "Vezi întreaga echipă, toate locațiile în timp real. Află cine lucrează și unde, chiar acum — nu la sfârșitul lunii.",
            "title": "Privire de ansamblu a echipei pe mai multe locații"
          },
          {
            "body": "Planifică cine lucrează și unde, gestionează modificările de ultim moment și trimite programul pe telefoanele echipei — fără un telefon către fiecare persoană.",
            "plan": "Time Pro",
            "title": "Programarea turelor pentru echipe sezoniere"
          },
          {
            "body": "Creează tipuri de absență personalizate pentru sectorul tău: opriri sezoniere cauzate de vreme, concediu parental, zile de concediu medical. Lucrătorii încarcă documentația digital din aplicație.",
            "title": "Tipuri de absență personalizate"
          },
          {
            "body": "Configurează tipuri de transport (dubă de firmă, mașină personală, șofer vs. pasager în transportul în comun) cu propriile tarife. Kilometrii se înregistrează automat pe deplasare.",
            "plan": "Add-on",
            "title": "Kilometraj cu urmărirea transportului în comun"
          },
          {
            "body": "Orele suplimentare din sezonul de vârf se acumulează rapid. Fiecare lucrător poate alege să fie plătit sau să strângă orele ca timp liber — urmărite transparent.",
            "plan": "Time Pro",
            "title": "Urmărirea orelor suplimentare cu conversie în concediu"
          }
        ],
        "headline": "Pontaj pentru firmele de amenajări peisagistice — echipe sezoniere, mai multe locații și kilometraj într-o singură privire de ansamblu",
        "workflow": [
          {
            "body": "GPS-ul înregistrează sosirea. Orele se împart automat pe locația și proiectul potrivit — fără alocare manuală la sfârșitul zilei.",
            "step": "Echipa se pontează la prima locație"
          },
          {
            "body": "Șeful de echipă înregistrează oprirea din aplicație — o evidență digitală curată, fără hârtii suplimentare.",
            "step": "Vremea oprește lucrul"
          },
          {
            "body": "Orele, absențele și kilometrajul de la fiecare locație și fiecare membru al echipei se exportă curat pentru salarizare.",
            "step": "Sfârșitul lunii: toate locațiile, toată echipa, un singur export"
          }
        ],
        "compliance": {
          "body": "Done-it oferă echipelor de amenajări peisagistice înregistrarea digitală a timpului pentru toate locațiile și personalul sezonier — pontaj verificat prin locație, tipuri de absență personalizate pentru opririle cauzate de vreme și un export curat pentru salarizare care satisface orice cerință locală.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Înregistrare digitală a timpului",
          "title": "Pontaj verificat prin locație și urmărirea absențelor pentru echipele sezoniere de amenajări peisagistice"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Mentenanță",
        "slug": "maintenance",
        "intro": "Contractele de mentenanță recurentă trăiesc sau mor în funcție de vizibilitatea costurilor. Done-it înregistrează fiecare vizită, urmărește orele față de bugetul contractului și îți oferă ție — și clienților tăi — dovada prezenței pentru fiecare apel.",
        "pains": [
          {
            "body": "Când orele pentru vizitele recurente nu sunt urmărite pe contractul specific, nu știi dacă un client este profitabil până la analiza de sfârșit de an — moment în care este prea târziu să mai repreciezi.",
            "title": "Nicio vizibilitate a costurilor pe contract de mentenanță"
          },
          {
            "body": "Administratorii de clădiri și proprietarii doresc tot mai mult evidențe de prezență: cine a venit, când a sosit, ce a făcut. Un jurnal pe hârtie prezentat săptămâni mai târziu nu satisface cerințele SLA.",
            "title": "Clienții se așteaptă la dovada a ceea ce s-a făcut"
          },
          {
            "body": "Turele rotative la multe locații recurente — cu personal care se acoperă reciproc — creează un puzzle de programare și urmărire a orelor pe care procesele manuale nu îl pot rezolva fiabil.",
            "title": "Vizitele recurente greu de programat și înregistrat"
          },
          {
            "body": "Întreținerea spațiilor verzi, mentenanța fațadelor și lucrările la facilitățile exterioare se confruntă toate cu opriri legate de vreme. Documentarea lor corectă necesită o urmă digitală.",
            "title": "Opririle cauzate de vreme afectează și mentenanța în exterior"
          }
        ],
        "quote": {
          "who": "Manager de operațiuni, firmă de mentenanță · 8 lucrători",
          "text": "Putem spune unui administrator de clădire exact cine s-a aflat pe șantier și când, în două minute. Acel nivel de dovadă a schimbat modul în care ne văd clienții.",
          "result": "Disputele cu clienții reduse la zero"
        },
        "stats": [
          {
            "label": "cost pe contract de mentenanță",
            "value": "În timp real"
          },
          {
            "label": "dovadă a prezenței gata pentru clienți la cerere",
            "value": "GPS"
          },
          {
            "label": "reînnoiri de contract fără a-ți cunoaște marja",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Fiecare contract de mentenanță este un proiect. Orele se înregistrează automat pe el, oferindu-ți o cifră de cost în timp real și o numărătoare inversă a orelor rămase pentru fiecare client.",
            "plan": "Project Basic",
            "title": "Urmărirea costurilor bazată pe contract"
          },
          {
            "body": "Pontajele verificate prin locație, cu marcaj de timp, sunt o evidență incontestabilă a cine s-a aflat pe șantier, când și pentru cât timp — gata de partajat cu clienții la cerere.",
            "title": "Dovadă a prezenței confirmată prin GPS"
          },
          {
            "body": "Lucrătorii raportează probleme, sarcini finalizate sau lucrări suplimentare direct din aplicație — cu text și fotografii. Clienții primesc o evidență în timp real; tu ai documentația pentru facturare.",
            "plan": "Project Basic",
            "title": "Actualizări cu fotografii de pe șantier"
          },
          {
            "body": "Planifică vizitele recurente pe toate contractele, atribuie lucrători și gestionează înlocuirile — fără un telefon către fiecare persoană.",
            "plan": "Time Pro",
            "title": "Programarea turelor recurente"
          },
          {
            "body": "Configurează opririle cauzate de vreme și alte tipuri de absență. Lucrătorii le înregistrează din aplicație; documentația se încarcă digital.",
            "title": "Tipuri de absență pentru mentenanța în exterior"
          }
        ],
        "headline": "Pontaj pentru echipele de mentenanță — vizite recurente la șantiere, cost pe contract și dovadă a prezenței într-o singură aplicație",
        "workflow": [
          {
            "body": "Pontajul verificat prin locație înregistrează ora sosirii și leagă orele de contractul corect. Dovada prezenței este creată automat.",
            "step": "Lucrătorul ajunge la locația de mentenanță"
          },
          {
            "body": "Lucrările finalizate și orice probleme sunt raportate din aplicație cu fotografii. Clienții pot vedea exact ce s-a făcut.",
            "step": "Sarcini finalizate, probleme înregistrate"
          },
          {
            "body": "Orele se acumulează față de bugetul contractului în timp real. Cunoști marja înainte ca contractul să se reînnoiască.",
            "step": "Costul pe contract vizibil imediat"
          }
        ],
        "compliance": {
          "body": "Done-it oferă echipelor de mentenanță dovadă a prezenței confirmată prin GPS pe fiecare contract, tipuri de absență personalizate și o imagine în timp real a costurilor pe client recurent — satisfăcând orice cerință locală de înregistrare a timpului fără echipamente suplimentare.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj bazat pe contract",
          "title": "Vizibilitate a costurilor în timp real pe contract de mentenanță"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Magazine și retail",
        "slug": "retail",
        "intro": "Ture de dimineață, ture de seară și mereu cineva care ține locul altcuiva. Done-it oferă fiecărui magazin o evidență digitală clară a cui a lucrat în ce tură — pontat de pe propriul telefon, gata pentru salarizare la final de lună.",
        "pains": [
          {
            "body": "Cineva ține locul unui coleg bolnav, altcineva rămâne o oră în plus la închidere. Se reține pe un bilețel, sau deloc — iar salarizarea e greșită înainte să începeți.",
            "title": "Schimburile de tură nu ajung niciodată la salarizare"
          },
          {
            "body": "Angajații se mută între puncte de lucru, cei cu program parțial lucrează în două locații. Adunarea orelor pe fiecare magazin și îmbinarea lor manuală costă o zi în fiecare lună.",
            "title": "Mai multe magazine, o singură salarizare"
          },
          {
            "body": "Pauzele legale se scad din memorie, iar orele în plus se decontează informal — exact primele două lucruri pe care le verifică un control.",
            "title": "Pauzele și orele suplimentare rămân la aproximație"
          }
        ],
        "quote": {
          "who": "Proprietar, retail · 11 angajați",
          "text": "Două magazine și mulți angajați cu program parțial. Înainte, jumătate din turele de înlocuire se decontau din memorie. Acum fiecare oră ajunge pe magazinul corect, iar salarizarea durează câteva minute.",
          "result": "Pregătirea salarizării, de la o zi la sub o oră"
        },
        "stats": [
          {
            "label": "pentru pontare — fără terminal la casă",
            "value": "1 apăsare"
          },
          {
            "label": "vedeți cine este prezent, în toate magazinele",
            "value": "Live"
          },
          {
            "label": "schimburi de tură pierdute între magazin și salarizare",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "O apăsare pe propriul telefon la începutul turei. Fără terminal la casă, fără card comun, fără condică lângă ușa depozitului.",
            "title": "Pontare direct în magazin"
          },
          {
            "body": "Fiecare magazin este un proiect. Cine ține locul în alt punct de lucru se pontează pe acel punct — vedeți orele acolo unde au fost lucrate efectiv.",
            "title": "Ore pe magazin, angajați între puncte de lucru"
          },
          {
            "body": "Setați regula de pauză o singură dată și se aplică fiecărei ture. Orele suplimentare se înregistrează în momentul în care apar, iar fiecare angajat alege plata sau timp liber.",
            "title": "Pauze scăzute automat"
          }
        ],
        "headline": "Pontaj pentru magazine — pontare pe tură, înlocuiri și un export gata de salarizare, într-o singură aplicație",
        "workflow": [
          {
            "body": "O apăsare pe telefon când începe tura. Înlocuirea în alt punct de lucru se pontează pe acel punct.",
            "step": "Angajații se pontează la începutul turei"
          },
          {
            "body": "O imagine live în toate locațiile — observați o tură de deschidere neacoperită înainte să se deschidă ușile.",
            "step": "Vedeți cine este prezent, pe fiecare magazin"
          },
          {
            "body": "Ore, pauze și ore suplimentare pe angajat și pe magazin, exportate gata pentru furnizorul de salarizare.",
            "step": "Salarizare într-un singur export"
          }
        ],
        "compliance": {
          "body": "Done-it păstrează o înregistrare digitală obiectivă a fiecărei pontări de intrare și ieșire, cu pauze și ore suplimentare — exact evidența cerută de un audit sau de o dispută pe salariu.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj pe ture",
          "title": "O evidență solidă a fiecărei ture lucrate"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Birouri și servicii profesionale",
        "slug": "offices",
        "intro": "Contabili, notari, arhitecți, agenții și firme de consultanță își facturează timpul — sau măcar trebuie să știe unde s-a dus. Done-it înregistrează orele pe clientul și proiectul potrivit, de la birou sau din teren.",
        "pains": [
          {
            "body": "Timpul notat la sfârșitul săptămânii este timp ghicit. Ore întregi dispar discret între munca făcută și factură.",
            "title": "Orele facturabile, reconstruite vineri"
          },
          {
            "body": "Onorariul a fost agreat acum câteva luni. Dacă munca mai încape în el se vede abia când cineva face totalul — de obicei prea târziu.",
            "title": "Nu știți cât costă de fapt un client"
          },
          {
            "body": "O parte din echipă e la birou, o parte acasă, o parte la client. Prezența încetează să fie un fapt și devine o reconstituire.",
            "title": "Munca hibridă face evidența incompletă"
          }
        ],
        "quote": {
          "who": "Partener, firmă de contabilitate · 8 angajați",
          "text": "Înainte reconstruiam săptămâna în fiecare vineri. Acum orele sunt deja pe clientul corect și văd ce dosare mănâncă onorariul.",
          "result": "Ore facturabile recuperate în fiecare lună"
        },
        "stats": [
          {
            "label": "ore, vizibile în timp ce munca este încă în desfășurare",
            "value": "Pe client"
          },
          {
            "label": "aceeași evidență, pe telefon și în browser",
            "value": "Birou sau teren"
          },
          {
            "label": "pentru salarizare și facturare",
            "value": "1 export"
          }
        ],
        "features": [
          {
            "body": "Fiecare înregistrare ajunge pe un proiect, așa că vedeți orele pe fiecare client fără să exportați nimic și fără să întrebați pe nimeni.",
            "title": "Ore pe client și proiect"
          },
          {
            "body": "Aceeași aplicație pe telefon sau în browser. Vizita la un client se contorizează ca muncă pentru acel client, inclusiv deplasarea, dacă vreți.",
            "title": "Funcționează la birou și în deplasare"
          },
          {
            "body": "Orele în plus se înregistrează pe loc, concediile se cer și se aprobă în aplicație — fără un tabel paralel cu cine lipsește și când.",
            "title": "Ore suplimentare și concedii într-un singur loc"
          }
        ],
        "headline": "Pontaj pentru birouri — ore pe client și proiect, fără tabele Excel",
        "workflow": [
          {
            "body": "Îl configurați o singură dată, cu clientul și, dacă facturați pe buget, orele planificate.",
            "step": "Deschideți un proiect de client"
          },
          {
            "body": "De la birou sau de pe telefon. Fiecare oră ajunge pe un client, nu în memoria cuiva.",
            "step": "Echipa înregistrează timpul pe el"
          },
          {
            "body": "Totaluri live pe fiecare proiect și un export curat pentru salarizare sau facturare la final de lună.",
            "step": "Vedeți orele pe client, exportați pentru salarizare"
          }
        ],
        "compliance": {
          "body": "Done-it păstrează o evidență digitală, protejată la modificări, a timpului de lucru pentru fiecare angajat — baza atât pentru salarizare, cât și pentru o factură pe care o puteți susține în fața clientului.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj pe client",
          "title": "O evidență obiectivă a orelor lucrate"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Saloane și îngrijire corporală",
        "slug": "beauty",
        "intro": "Coafori, frizerii, saloane de manichiură și studiouri de înfrumusețare funcționează pe ture și contracte cu timp parțial. Done-it înregistrează cine a lucrat și când, scade pauzele automat și predă salarizării un fișier curat.",
        "pains": [
          {
            "body": "Trei zile într-o săptămână, patru în următoarea, o sâmbătă schimbată pe o marți. Orele din contract și orele lucrate se depărtează rapid.",
            "title": "Contracte cu timp parțial, variante fără sfârșit"
          },
          {
            "body": "Programările arată ce s-a rezervat, nu cine a lucrat. Când întreabă salarizarea sau un control, sistemul de rezervări este răspunsul greșit.",
            "title": "Agenda de programări nu este o evidență a timpului"
          },
          {
            "body": "Faptul că cineva a rămas peste program pentru un ultim client se ține minte, se promite și uneori se uită. Exact genul de scăpare care ajunge dispută.",
            "title": "Orele în plus, decontate informal"
          }
        ],
        "quote": {
          "who": "Proprietar, salon de coafură · 6 angajați",
          "text": "Toată lumea lucrează cu program parțial și fiecare săptămână e diferită. Aplicația pur și simplu înregistrează — am încetat să reconstruiesc luna în Excel.",
          "result": "Fără ore contestate la final de lună"
        },
        "stats": [
          {
            "label": "pentru pontare — nimic comun, nimic pe hârtie",
            "value": "1 apăsare"
          },
          {
            "label": "pauzele se scad la fiecare tură",
            "value": "Automat"
          },
          {
            "label": "ore peste program decontate din memorie",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "O apăsare pe propriul telefon la începutul turei — fără terminal comun la recepție, fără listă de semnături lângă oglindă.",
            "title": "Pontare la salon"
          },
          {
            "body": "Setați o singură dată regula de pauză și orele standard; se aplică fiecărei ture, cu excepții per persoană acolo unde contractul diferă.",
            "title": "Pauze și reguli de program parțial, setate o dată"
          },
          {
            "body": "Orele în plus se înregistrează pe măsură ce sunt lucrate, iar fiecare angajat alege plata sau timp liber compensator — decontat în aplicație, nu din memorie.",
            "title": "Ore suplimentare, plătite sau recuperate"
          }
        ],
        "headline": "Pontaj pentru saloane — ture, program parțial și salarizare fără agendă pe hârtie",
        "workflow": [
          {
            "body": "O apăsare la sosire. Pauzele se scad după regula setată o singură dată.",
            "step": "Angajații se pontează la începutul turei"
          },
          {
            "body": "Cine este prezent, cine este în pauză, cine a rămas peste program — live, fără să întrebați.",
            "step": "Vedeți ziua în desfășurare"
          },
          {
            "body": "Ore lucrate, pauze și ore suplimentare pe angajat, exportate pentru furnizorul de salarizare.",
            "step": "Salarizarea primește un fișier curat"
          }
        ],
        "compliance": {
          "body": "Done-it înregistrează timpul de lucru efectiv al fiecărui angajat, cu pauze și ore suplimentare — separat de rezervări și solid atunci când este verificat.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj digital",
          "title": "O evidență care rezistă dincolo de agenda de programări"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sănătate și wellness",
        "slug": "wellness",
        "intro": "Sălile de fitness, studiourile, cabinetele de fizioterapie și spa-urile au program lung și personal care se rotește. Done-it înregistrează cine a acoperit fiecare tură, scade pauzele automat și exportă salarizarea curat.",
        "pains": [
          {
            "body": "Ture de dimineață, clase seara și weekenduri, acoperite de un amestec de angajați cu normă întreagă, program parțial și colaboratori. Planificarea este un plan, nu o evidență.",
            "title": "Program lung, înlocuiri permanente"
          },
          {
            "body": "Un instructor ține două clase și acoperă recepția între ele. Ca să plătiți corect trebuie să știți ce s-a lucrat efectiv, nu ce era planificat.",
            "title": "Orele de clasă se amestecă cu orele în sală"
          },
          {
            "body": "Angajații se mută între studiouri. Îmbinarea manuală a orelor lor în fiecare lună este lentă și predispusă la erori.",
            "title": "Mai multe locații, o singură administrare"
          }
        ],
        "quote": {
          "who": "Manager, studio de fitness · 14 angajați",
          "text": "Două studiouri, program lung și multe ture de înlocuire. Acum orele ajung pe locația corectă, iar salarizarea este un singur fișier.",
          "result": "Planificarea și salarizarea coincid, în sfârșit"
        },
        "stats": [
          {
            "label": "ore, chiar și când angajații acoperă în altă parte",
            "value": "Pe studio"
          },
          {
            "label": "vedeți sala în toate locațiile",
            "value": "Live"
          },
          {
            "label": "pauze și ore suplimentare, fără calcule manuale",
            "value": "Automat"
          }
        ],
        "features": [
          {
            "body": "O apăsare pe telefon în locația în care lucrează. Înlocuirea în alt studio ajunge în orele acelui studio.",
            "title": "Pontare pe fiecare studio"
          },
          {
            "body": "Vedeți sala în toate locațiile, în timp real — o tură de dimineață neacoperită se vede înainte să se deschidă ușile, nu după.",
            "title": "Imagine live a cine este prezent"
          },
          {
            "body": "Reguli de pauză aplicate automat, ore în plus înregistrate pe loc, cu plată sau timp liber compensator pentru fiecare angajat.",
            "title": "Pauze și ore suplimentare rezolvate"
          }
        ],
        "headline": "Pontaj pentru săli de fitness, studiouri și spa-uri — ture, clase și salarizare într-o singură aplicație",
        "workflow": [
          {
            "body": "O apăsare la începutul turei, în locația în care lucrează.",
            "step": "Angajații se pontează la studio"
          },
          {
            "body": "Cine este prezent și în ce locație chiar acum, ca golurile să fie acoperite înainte să observe membrii.",
            "step": "Înlocuirile se văd live"
          },
          {
            "body": "Ore, pauze și ore suplimentare pe angajat și pe studio, gata pentru furnizorul de salarizare.",
            "step": "Un singur export pentru salarizare"
          }
        ],
        "compliance": {
          "body": "Done-it păstrează o evidență digitală a timpului de lucru pe fiecare angajat și pe fiecare locație — baza pentru plată corectă și pentru orice verificare a orelor lucrate.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj pe ture, în mai multe locații",
          "title": "O evidență obiectivă pentru fiecare tură și locație"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "HoReCa",
        "slug": "hospitality",
        "intro": "Ture fracționate, închideri târzii și o sâmbătă aglomerată care se prelungește. Done-it înregistrează orele așa cum sunt lucrate efectiv, scade pauzele după regula voastră și dă salarizării un singur fișier curat.",
        "pains": [
          {
            "body": "Serviciul se prelungește, închiderea mai ia o jumătate de oră. Minutele acelea sunt muncă reală, iar decontarea lor din memorie e începutul disputelor.",
            "title": "Tura nu se termină niciodată când spune planificarea"
          },
          {
            "body": "Serviciul de prânz, o pauză, apoi cina. Pe hârtie devine un bloc lung sau două aproximări — niciuna nu este adevărul.",
            "title": "Turele fracționate sunt greu de înregistrat"
          },
          {
            "body": "Personal nou în fiecare sezon. Orice sistem care cere instruire nu supraviețuiește primei săptămâni aglomerate.",
            "title": "Fluctuație mare, instruire continuă"
          }
        ],
        "quote": {
          "who": "Proprietar, restaurant · 17 angajați",
          "text": "Închiderea se prelungește mereu. Acum minutele acelea sunt înregistrate, nu discutate în contradictoriu, iar angajații le pot recupera ca timp liber.",
          "result": "Mai puține dispute, salarizare mai rapidă"
        },
        "stats": [
          {
            "label": "înregistrate ca două blocuri, nu ca o aproximare",
            "value": "Ture fracționate"
          },
          {
            "label": "pauzele se scad după regula voastră",
            "value": "Automat"
          },
          {
            "label": "pentru a integra un angajat nou — e propriul lui telefon",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "O apăsare la începutul și la finalul fiecărui bloc, așa că turele fracționate sunt înregistrate așa cum s-au petrecut — nu unite într-una singură.",
            "title": "Pontare la început și la final de serviciu"
          },
          {
            "body": "Pauzele obligatorii se scad automat, cu excepții per persoană acolo unde contractul o cere. Fără calcule manuale la final de lună.",
            "title": "Pauze după regula voastră"
          },
          {
            "body": "Jumătatea de oră în plus după închidere se înregistrează în momentul în care este lucrată și se plătește sau se recuperează ca timp liber — angajatul alege.",
            "title": "Ore suplimentare decontate în aplicație"
          }
        ],
        "headline": "Pontaj pentru cafenele, restaurante și hoteluri — ture, pauze și ore suplimentare, decontate corect",
        "workflow": [
          {
            "body": "O apăsare la începutul blocului; la fel la final. Turele fracționate rămân fracționate.",
            "step": "Angajații se pontează pentru serviciu"
          },
          {
            "body": "Cine este prezent pentru serviciul de diseară, cine este încă în pauză, cine a rămas după închidere.",
            "step": "Vedeți sala live"
          },
          {
            "body": "Timp lucrat, pauze și ore suplimentare pe angajat, exportate într-un singur fișier.",
            "step": "Salarizarea primește orele reale"
          }
        ],
        "compliance": {
          "body": "Done-it păstrează o înregistrare digitală obiectivă a fiecărei ture, pauze și ore în plus — exact ce cere să vadă o verificare de salarizare sau un control de la inspecția muncii.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj pentru ture fracționate",
          "title": "O evidență solidă a orelor într-o echipă cu fluctuație mare"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sănătate și îngrijire",
        "slug": "healthcare",
        "intro": "Cabinetele, echipele de îngrijire la domiciliu și căminele de bătrâni funcționează pe ture, vizite și evidențe stricte. Done-it înregistrează timpul lucrat pe fiecare tură și pe fiecare vizită și păstrează documentele angajaților acolo unde le găsiți.",
        "pains": [
          {
            "body": "Vizitele la domiciliu stau într-un instrument, orele planificate în altul, iar salarizarea primește o a treia versiune. Reconcilierea lor este o muncă lunară.",
            "title": "Vizitele și turele, în sisteme separate"
          },
          {
            "body": "Orele în afara programului normal au tarife diferite. Când evidența este aproximativă, la fel este și plata — iar corecția vine mai târziu.",
            "title": "Orele de noapte și de weekend, plătite greșit"
          },
          {
            "body": "Calificările și certificatele contează în îngrijire, iar ele stau într-un dosar pe care nu îl deschide nimeni până când întreabă un control.",
            "title": "Certificatele expiră pe tăcute"
          }
        ],
        "quote": {
          "who": "Coordonator, echipă de îngrijire la domiciliu · 22 angajați",
          "text": "Vizitele la domiciliu și turele planificate stau în sfârșit în aceeași evidență. Salarizarea a încetat să fie un exercițiu de reconciliere.",
          "result": "O singură evidență în loc de trei"
        },
        "stats": [
          {
            "label": "sau pe tură — cum funcționează echipa voastră",
            "value": "Pe vizită"
          },
          {
            "label": "orele de noapte și de weekend, înregistrate ca lucrate",
            "value": "Separate"
          },
          {
            "label": "certificate stocate pe fiecare angajat",
            "value": "Arhivate"
          }
        ],
        "features": [
          {
            "body": "O apăsare la începutul turei sau la fiecare adresă de client pentru îngrijirea la domiciliu — cu locație verificată acolo unde aveți nevoie de dovadă.",
            "title": "Pontare pe tură sau pe vizită"
          },
          {
            "body": "Orele de noapte, de weekend și cele normale sunt înregistrate distinct, așa că exportul pentru salarizare reflectă deja modul real de plată.",
            "title": "Ore împărțite așa cum le plătiți"
          },
          {
            "body": "Contracte, certificate și acte de identitate stocate lângă persoana căreia îi aparțin — găsite în câteva secunde când le cere cineva.",
            "title": "Documentele angajaților într-un singur loc"
          }
        ],
        "headline": "Pontaj pentru echipele de îngrijire — ture, vizite la domiciliu și calificări, într-o singură evidență",
        "workflow": [
          {
            "body": "O apăsare la locație sau la adresa clientului, cu locație verificată acolo unde este nevoie de dovadă.",
            "step": "Pontare pentru tură sau vizită"
          },
          {
            "body": "Orele normale, de noapte și de weekend sunt înregistrate distinct, pe măsură ce sunt lucrate.",
            "step": "Orele ajung în categoria corectă"
          },
          {
            "body": "Un singur fișier curat pe perioadă, deja împărțit așa cum îl plătiți.",
            "step": "Export pentru salarizare"
          }
        ],
        "compliance": {
          "body": "Done-it păstrează o evidență digitală și obiectivă a timpului de lucru pentru fiecare angajat — ore, pauze și separarea orelor în afara programului normal — alături de documentele care aparțin fiecărei persoane.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pontaj pe ture și vizite",
          "title": "Evidențe care trec de un control"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "no": [
      {
        "name": "Bygg og anlegg",
        "slug": "construction",
        "intro": "Arbeidslag spredt over flere steder, timer rablet ned på papir, underleverandørtimer umulige å avstemme. Done-it gir hvert sted en vanntett digital timeliste som mater lønnssystemet ditt med ett klikk.",
        "pains": [
          {
            "body": "Med flere aktive steder og roterende arbeidslag er manuelle timelister feil per design. Arbeidere runder opp, glemmer registreringer eller fyller dem inn dager senere — og etterlater deg med lønnstall du ikke kan forsvare.",
            "title": "Ingen pålitelig registrering av hvem som jobbet hvor"
          },
          {
            "body": "Når du merker at et sted har brukt opp de planlagte timene, er marginen allerede borte. Det finnes ingen sanntids nedtelling — bare en ubehagelig overraskelse ved faktureringstidspunktet.",
            "title": "Budsjettoverskridelser dukker opp for sent"
          },
          {
            "body": "Å samle inn timelister, avstemme dem mot prosjekter og forberede lønnseksporten tar dager. Hver registrering er en potensiell feil.",
            "title": "Lønnsforberedelser spiser opp timer hver måned"
          }
        ],
        "quote": {
          "who": "Eier, byggefirma · 14 ansatte",
          "text": "Arbeidslaget vårt sjekker inn selv på stedet. Ved månedsslutt går lønn bare opp — vi sluttet helt å jakte på timelister.",
          "result": "5 timer i uken spart på administrasjon"
        },
        "stats": [
          {
            "label": "for å sjekke inn på ethvert sted — ingen terminal, ingen papir",
            "value": "1 trykk"
          },
          {
            "label": "lønnseksport klar for leverandøren din",
            "value": "1 klikk"
          },
          {
            "label": "visning av gjenstående timer per prosjekt og sted",
            "value": "Sanntid"
          }
        ],
        "features": [
          {
            "body": "Ett trykk sjekker arbeideren inn, stedsverifisert, og knytter timene til riktig prosjekt. Ingen kortlesere, ingen terminaler — bare smarttelefonen arbeidslaget ditt allerede har med seg.",
            "title": "Stedsverifisert innsjekk per sted"
          },
          {
            "body": "Sett planlagte timer som et budsjett når du åpner prosjektet. Arbeidere ser en nedtelling av hva som er igjen; du ser det i sanntid i dashbordet ditt. Budsjettoverskridelser er synlige før de skjer.",
            "title": "Sanntids gjenstående timer per prosjekt"
          },
          {
            "body": "Legg til underleverandører i et prosjekt, tildel dem innsjekk og følg timene deres sammen med ditt eget arbeidslag — i samme oversikt.",
            "title": "Håndtering og tilstedeværelse av underleverandører"
          },
          {
            "body": "Alle registrerte timer — per arbeider, per prosjekt — eksporteres til et rent regneark for lønnsleverandøren din. Ingen manuell forberedelse, ingen feil.",
            "title": "Lønnseksport med ett klikk"
          }
        ],
        "headline": "Tidsregistrering for byggelag — stedsverifisert innsjekk, prosjekttimer og budsjettkontroll, i én app",
        "workflow": [
          {
            "body": "Hver arbeider trykker én gang for å sjekke inn. GPS bekrefter stedet, tidsstempler registreringen og knytter timene til prosjektet. Ingen papir, ingen terminal.",
            "step": "Arbeidslaget kommer til stedet"
          },
          {
            "body": "Timer, gjenstående budsjett, underleverandørtilstedeværelse og eventuelt ekstraarbeid rapportert fra stedet — alt i dashbordet ditt, i sanntid.",
            "step": "Du ser alt i sanntid"
          },
          {
            "body": "Eksporter alle timer per arbeider og per prosjekt. Send til lønnsleverandøren din. Done-it genererer rene, revisjonsklare rapporter automatisk.",
            "step": "Månedsslutt på minutter"
          }
        ],
        "compliance": {
          "body": "Done-it leverer stedsverifisert innsjekk, tidsregistrering per prosjekt og en ren lønnseksport for byggelag. For team som opererer på belgiske steder mater den også innsjekk på jobben automatisk.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital tidsregistrering",
          "title": "Stedsverifisert innsjekk bygget for byggeplasser"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Renhold",
        "slug": "cleaning",
        "intro": "Renholdere flytter seg mellom steder hele dagen. Done-it sporer hvem som er hvor i sanntid — stedsverifisert innsjekk på hvert sted, automatisk pausefradrag og en ren lønnseksport ved månedsslutt.",
        "pains": [
          {
            "body": "Kunder og inspektører forventer vanntette oppmøteregistreringer. Manuelle ark kan bestrides; stedsverifiserte digitale innsjekker kan det ikke.",
            "title": "Å bevise tilstedeværelse på hvert sted"
          },
          {
            "body": "Med renholdere som flytter seg mellom steder gjennom dagen, har du ingen sanntidsoversikt over hvem som jobber hvor — før noen ringer.",
            "title": "Team spredt over mange steder"
          },
          {
            "body": "Uten nøyaktige inn-/ut-tider rekonstrueres lønn fra hukommelsen. Timer rundes opp, kostnader vokser og tvister følger.",
            "title": "Lønnsfeil fra avrundede timer"
          }
        ],
        "quote": {
          "who": "Leder, renholdsfirma · 9 ansatte",
          "text": "Vi kan endelig bevise hvem som rengjorde hvor og når. Ikke flere oppmøteark, ikke flere kundetvister — GPS tar seg av det.",
          "result": "Null oppjustering av timer"
        },
        "stats": [
          {
            "label": "for å sjekke inn på ethvert sted — ingen terminal nødvendig",
            "value": "1 trykk"
          },
          {
            "label": "visning av hvem som er på hvilket sted akkurat nå",
            "value": "Sanntid"
          },
          {
            "label": "doble registreringer — timer flyter rett til lønn",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Arbeidere trykker inn og ut på telefonen på hvert sted, stedsverifisert; tiden er nøyaktig, med pauselogging.",
            "plan": "Time Basic",
            "title": "Inn- og utsjekk i sanntid"
          },
          {
            "body": "Obligatoriske pauser trekkes fra arbeidsdagen automatisk — ingen manuell regning, ingen tvister.",
            "plan": "Time Basic",
            "title": "Automatisk pausefradrag"
          },
          {
            "body": "Se hvilke renholdere som er på hvilke steder akkurat nå. Oppdag mangler før kundene gjør det.",
            "title": "Sanntidsoversikt over flere steder"
          },
          {
            "body": "Arbeidere laster opp sykmeldinger og fraværsdokumenter direkte fra appen. Opprett fraværstypene teamet ditt faktisk bruker.",
            "title": "Fraværsregistrering med digitale sykmeldinger"
          },
          {
            "body": "Nøyaktige tidsstempler flyter rett inn i en lønnsklar eksport for leverandøren din. Ingen avskrift, ingen feil.",
            "title": "Lønnseksport med ett klikk"
          }
        ],
        "headline": "Tidsregistrering for renholdsfirmaer — stedsverifisert innsjekk, oppmøtebevis og lønn i én app",
        "workflow": [
          {
            "body": "Ett trykk sjekker dem inn. GPS logger stedet og tidsstempler registreringen. Pauseregistrering er innebygd i appen.",
            "step": "Renholderen kommer til stedet"
          },
          {
            "body": "Hvem som er på hvilket sted akkurat nå — ingen telefoner, ingen gjetting. Oppdag dekningsmangler før kundene gjør det.",
            "step": "Du ser hvert sted i sanntid"
          },
          {
            "body": "Alle oppmøtedata — nøyaktige tider, steder og pauser — eksporteres rent for lønnsleverandøren din.",
            "step": "Lønn er ett klikk"
          }
        ],
        "compliance": {
          "body": "Done-it gir renholdsteam stedsverifisert innsjekk på hvert sted, automatisk pausefradrag og en sanntidsoversikt over hvem som er på hvilket sted akkurat nå.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Stedsverifisert oppmøte",
          "title": "Sanntidsoppmøte på tvers av hvert renholdssted"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Montering",
        "slug": "installation",
        "intro": "Send montørene dine til riktig adresse med alt de trenger, knytt hver arbeidet time til riktig jobb automatisk, og se gjenstående budsjett før stedet stenger. Done-it er den enkleste måten å holde monteringsprosjekter i tide og innenfor kostnad.",
        "pains": [
          {
            "body": "Arbeidslag kommer til et sted uten adressen, kontaktpersonen eller omfangsdetaljene. Den første telefonen er ti minutter med fakturerbar tid tapt før en eneste time er jobbet.",
            "title": "Jobbinfo når ikke felten i tide"
          },
          {
            "body": "Når arbeidere fyller inn timene sine manuelt ved dagens slutt — hvis de i det hele tatt fyller dem inn — lander timer på feil jobb, eller forsvinner helt. Fakturaer stemmer ikke med virkeligheten.",
            "title": "Timer er ikke knyttet til riktig prosjekt"
          },
          {
            "body": "Uten en sanntids nedtelling av gjenstående timer per prosjekt, finner du ut at en jobb gikk over når du avslutter fakturaen — ikke mens du fortsatt kan reagere.",
            "title": "Budsjettoverskridelser oppdaget for sent"
          },
          {
            "body": "Underleverandører som jobber på samme sted bruker forskjellige systemer, fyller inn timer separat eller ikke i det hele tatt. Å avstemme ved månedsslutt er en treg, feilutsatt prosess.",
            "title": "Underleverandørtimer vanskelige å spore"
          }
        ],
        "quote": {
          "who": "Eier, monteringsfirma · 6 ansatte",
          "text": "Timene lander på riktig prosjekt automatisk. Jobbkalkyle er plutselig enkelt — vi kan se den reelle marginen før vi avslutter en jobb.",
          "result": "Reell kostnad per jobb, i sanntid"
        },
        "stats": [
          {
            "label": "visning av gjenstående timer per prosjekt",
            "value": "Sanntid"
          },
          {
            "label": "kontorsamtaler for stedsadresser",
            "value": "0"
          },
          {
            "label": "naviger til enhver prosjektadresse fra appen",
            "value": "1 klikk"
          }
        ],
        "features": [
          {
            "body": "Arbeidere åpner prosjektet på telefonen: adresse, planlagte timer, kontaktperson og opplastede filer (tegninger, instruksjoner, PDF-er). Alt de trenger er der før de kommer.",
            "plan": "Project Basic",
            "title": "Prosjektinfo delt direkte til appen"
          },
          {
            "body": "Trykk én gang, så navigerer telefonen til prosjektadressen — innebygd i appen, ingen separat kartapp nødvendig.",
            "title": "Navigasjon til stedet med ett trykk"
          },
          {
            "body": "Sett planlagte timer når du åpner prosjektet. Arbeidere ser hvor mange timer som er igjen; du ser sanntidsstatusen i dashbordet ditt. Overskridelser er synlige før de skjer.",
            "plan": "Project Basic",
            "title": "Nedtelling av gjenstående timer per prosjekt"
          },
          {
            "body": "Hver arbeider sjekker inn på riktig prosjekt. Du vet alltid hvem som er på hvilket sted akkurat nå.",
            "plan": "Project Basic",
            "title": "Arbeiderinnsjekk per prosjekt"
          },
          {
            "body": "Når omfanget vokser på stedet, logger arbeidere ekstraarbeid og materialer i sanntid — med tekst og bilder — så ingenting faktureres fra hukommelsen.",
            "plan": "Project Basic",
            "title": "Logging av ekstraarbeid og materiale"
          }
        ],
        "headline": "Tidsregistrering for monteringsteam — prosjekttimer, navigasjon og budsjettkontroll i én app",
        "workflow": [
          {
            "body": "Adresse, kontakt, omfang og filopplastinger er rett der. De navigerer med ett trykk — ingen samtaler til kontoret for veibeskrivelse.",
            "step": "Arbeideren åpner prosjektet på telefonen"
          },
          {
            "body": "Innsjekk knytter hvert arbeidet minutt til riktig prosjekt. Gjenstående budsjett oppdateres i sanntid.",
            "step": "Timer logges automatisk til riktig jobb"
          },
          {
            "body": "Omfangsendringer, ekstra materialer og forsinkelser logges med tekst og bilder i det øyeblikket de skjer — klart for fakturaen.",
            "step": "Ekstraarbeid fanges på stedet"
          }
        ],
        "compliance": {
          "body": "Done-it gir monteringsteam stedsverifisert innsjekk per prosjekt, en sanntids nedtelling av gjenstående timer og automatisk lønnseksport — og dekker ethvert lokalt krav til tidsregistrering. For team som jobber på belgiske byggeplasser integrerer den også med CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital tidsregistrering",
          "title": "Stedsverifisert innsjekk per prosjekt for monteringsteam"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Felttjeneste",
        "slug": "field-service",
        "intro": "Teknikere som besøker flere kunder om dagen, kvitteringer i hanskerom, kjørelengde logget fra hukommelsen. Done-it fanger timer, kilometer og utgifter ute i felten — knyttet til riktig jobb i det øyeblikket de skjer.",
        "pains": [
          {
            "body": "Å be teknikere rekonstruere rutene sine ved ukens slutt betyr unøyaktige refusjoner, tvister med kunder og en voksende haug med ukrevde kilometer.",
            "title": "Kjørelengde logget dager senere — om i det hele tatt"
          },
          {
            "body": "En kvittering i et hanskerom er en kostnad som kanskje aldri kommer inn i en faktura. Den reelle kostnaden per jobb er alltid for lav.",
            "title": "Utgifter på papirkvitteringer som forsvinner"
          },
          {
            "body": "Uten sanntidsinnsjekker finner du bare ut hvor en tekniker er når noe går galt og noen ringer.",
            "title": "Ingen sanntidsoversikt over hvor teamet er"
          },
          {
            "body": "Når arbeid, reise og utgifter spores i separate systemer — eller ikke spores i det hele tatt — finnes det aldri ett enkelt kostnadstall per jobb.",
            "title": "Vanskelig å se den faktiske marginen per jobb"
          }
        ],
        "quote": {
          "who": "Driftsleder, felttjenestefirma · 11 ansatte",
          "text": "Kjørelengde pleide å være en månedlig hodepine. Nå logger den seg selv — hver kilometer er knyttet til riktig kunde før vi i det hele tatt er tilbake på kontoret.",
          "result": "Nøyaktig kostnad per jobb, hver gang"
        },
        "stats": [
          {
            "label": "fangst av kjørelengde — ingen manuell kjørebok",
            "value": "Automatisk"
          },
          {
            "label": "kostnad per jobb: timer + reise + utgifter",
            "value": "Sanntid"
          },
          {
            "label": "kilometer tapt — hver tur fanget automatisk",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS logger avgang, ankomst og nøyaktig distanse per tur. Konfigurer transporttyper (egen bil, firmabil, samkjøring) med egne refusjonssatser. Ingen manuell kjørebok.",
            "plan": "Add-on",
            "title": "Automatisk fangst av kjørelengde (Trax-it)"
          },
          {
            "body": "Arbeidere knipser en kvittering ute i felten; den knyttes til jobben og er klar for refusjon — ikke jaktet på ved månedsslutt.",
            "plan": "Time Basic",
            "title": "Utgiftshåndtering på stedet"
          },
          {
            "body": "Timer, kjørelengde og utgifter samles mot jobben i sanntid. Kostnaden per jobb er synlig mens jobben fortsatt er åpen.",
            "plan": "Project Basic",
            "title": "Prosjektknyttet kostnadskontroll"
          },
          {
            "body": "Hver tekniker sjekker inn på kundens sted. Du ser hvem som er hvor, akkurat nå — ingen samtaler, ingen gjetting.",
            "title": "Stedsverifisert innsjekk og sanntidsoversikt over teamet"
          },
          {
            "body": "Timer og kilometerrefusjoner eksporteres rent for lønnsleverandøren din — med de konfigurerte kjøresatsene dine brukt automatisk.",
            "title": "Lønnseksport med ett klikk"
          }
        ],
        "headline": "Tidsregistrering for felttjenesteteam — kjørelengde, utgifter og timer fra veien, alt i én app",
        "workflow": [
          {
            "body": "Innsjekk starter turloggen. Kilometer fanges automatisk fra avgang til ankomst — ingen manuell registrering.",
            "step": "Teknikeren drar til det første oppdraget"
          },
          {
            "body": "Timer knyttes til riktig prosjekt. Ekstraarbeid, materialer og kvitteringer logges i appen i det øyeblikket de skjer.",
            "step": "På jobbstedet"
          },
          {
            "body": "Hver time, kilometer og utgift er allerede knyttet til riktig jobb. Eksporter til lønn og fakturer med reelle kostnadstall.",
            "step": "Månedsslutt uten kaoset"
          }
        ],
        "compliance": {
          "body": "Done-it fanger kjørelengde automatisk per tur, bruker de konfigurerte refusjonssatsene dine og logger hver kilometer til riktig kunde eller prosjekt. EUs Tyco-dom betyr at reise fra hjemmet til første kunde teller som arbeidstid — Done-it sporer det også.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Digital tids- og kjørelengderegistrering",
          "title": "GPS-timer og automatisk kjørelengde for felttjenesteteam"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "VVS",
        "slug": "hvac",
        "intro": "Hvert servicebesøk har tre kostnader: arbeid, deler og reise. Done-it fanger alle tre ute i felten og samler dem mot riktig jobb — så du kjenner marginen din før du avslutter fakturaen.",
        "pains": [
          {
            "body": "Arbeid, deler og reise ligger i forskjellige systemer — eller forskjellige lommer. Den reelle kostnaden av en utrykning blir først tydelig lenge etter at teknikeren har forlatt stedet.",
            "title": "Servicebesøk er vanskelige å kostnadsberegne nøyaktig"
          },
          {
            "body": "Når en kunde bestrider hvor lang tid en reparasjon tok, er en papir-timeliste lett å bestride. GPS-bekreftede inn- og utsjekkstidsstempler er det ikke.",
            "title": "Ingen bevis på servicetid"
          },
          {
            "body": "På gjentakende vedlikeholdskontrakter akkumuleres små overskridelser over mange besøk. Uten en sanntids timeteller finner du først ut at kontrakten er under vann ved fornyelse.",
            "title": "Vedlikeholdskontrakter eroderer marginen stille"
          },
          {
            "body": "Manuelle tidsregistreringer går glipp av pauser, noe som fører til overbetaling og lønn som ikke stemmer med virkeligheten.",
            "title": "Teknikere glemmer å logge pauser"
          }
        ],
        "quote": {
          "who": "Eier, VVS-firma · 7 teknikere",
          "text": "Vi vet endelig hva hver servicekontrakt faktisk koster oss. Marginoverraskelsene stoppet den dagen vi begynte å bruke Done-it.",
          "result": "Reell kostnad per servicebesøk, i sanntid"
        },
        "stats": [
          {
            "label": "kostnadstyper fanget per utrykning: arbeid, reise, deler",
            "value": "3"
          },
          {
            "label": "oversikt over margin per servicekontrakt",
            "value": "Sanntid"
          },
          {
            "label": "overraskelser ved faktureringstidspunktet — kostnader synlige i sanntid",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Hvert servicebesøk eller vedlikeholdskontrakt er et prosjekt. Timer, reise og materialer samles i sanntid — og gir deg sanntidsoversikt over marginen.",
            "plan": "Project Basic",
            "title": "Prosjektbasert tidsregistrering"
          },
          {
            "body": "Når en jobb vokser, logger teknikere ekstraarbeid og deler med tekst og bilder før de drar. Ingenting faktureres fra hukommelsen.",
            "plan": "Project Basic",
            "title": "Ekstraarbeid og materialer, logget på stedet"
          },
          {
            "body": "Kilometer per utrykning logges automatisk og kostnadsføres mot jobben. Konfigurer refusjonssatser per kjøretøytype.",
            "plan": "Add-on",
            "title": "Kjørelengde- og transportkostnader"
          },
          {
            "body": "Obligatoriske pauser trekkes automatisk fra total tid — ingen tvister, ingen lønnsfeil.",
            "title": "Automatisk pausefradrag"
          },
          {
            "body": "Tidsstemplet, GPS-bekreftet innsjekk på hvert sted. Ubestridelig bevis på når teknikeren kom og dro.",
            "title": "Stedsverifisert innsjekk og tilstedeværelsesbevis"
          }
        ],
        "headline": "Tidsregistrering for VVS-teknikere — jobbkalkyle, deler og reise i én app",
        "workflow": [
          {
            "body": "GPS tidsstempler ankomsten og knytter timer til servicebesøket eller vedlikeholdskontrakten. Ingen papir, ingen terminal.",
            "step": "Teknikeren sjekker inn på stedet"
          },
          {
            "body": "Deler brukt, ekstra timer og omfangsendringer logges i appen med bilder — før man forlater stedet.",
            "step": "Ekstraarbeid fanges på stedet"
          },
          {
            "body": "Arbeid, reise og materialer summeres mot prosjektet i sanntid. Du ser marginen før du utsteder fakturaen.",
            "step": "Jobbkostnaden er synlig umiddelbart"
          }
        ],
        "compliance": {
          "body": "Done-it gir VVS-team stedsverifisert innsjekk per servicebesøk, sanntidsoversikt over kostnad per jobb (arbeid + reise + deler) og en ren lønnseksport — og oppfyller ethvert lokalt krav til tidsregistrering uten ekstra maskinvare.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital tids- og kostnadsregistrering",
          "title": "Full jobbkalkyle for VVS-servicebesøk"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektrikere",
        "slug": "electricians",
        "intro": "Timer per prosjekt, en sanntids nedtelling av gjenstående budsjett og navigasjon til stedet med ett trykk — bygget for små elektroteam som trenger prosjektkontroll uten den administrative belastningen.",
        "pains": [
          {
            "body": "Når elektrikere jobber på tvers av flere jobber i en uke, fører manuell fordeling av timer ved dagens slutt til feilattribuerte kostnader, faktureringstvister og lønn du ikke kan forklare.",
            "title": "Timer er ikke knyttet til riktig prosjekt"
          },
          {
            "body": "Uten en sanntidsoversikt over timer brukt mot timer budsjettert, finner du ut at et prosjekt gikk over når du sender fakturaen — ikke når du fortsatt kunne reagere.",
            "title": "Budsjettoverskridelser oppdaget for sent"
          },
          {
            "body": "Adresser tastet inn i en separat app, samtaler til kontoret for veibeskrivelse, sene ankomster på kundesteder. Hvert bortkastet minutt er et fakturerbart minutt tapt.",
            "title": "Tid bortkastet på å finne stedet"
          },
          {
            "body": "På større installasjoner sporer underleverandørelektrikere sine egne timer separat. Å få en samlet oversikt over arbeidskostnadene ved slutten av et prosjekt er en manuell, feilutsatt jobb.",
            "title": "Underleverandørtimer vanskelige å avstemme"
          }
        ],
        "quote": {
          "who": "Eier, elektrofirma · 5 elektrikere",
          "text": "Vi vet i sanntid om et prosjekt går over budsjett. Det alene har reddet oss fra to dårlige overraskelser i år.",
          "result": "Budsjettoverskridelser fanget før de skjer"
        },
        "stats": [
          {
            "label": "visning av gjenstående timer per prosjekt",
            "value": "Sanntid"
          },
          {
            "label": "kontorsamtaler for stedsadresser",
            "value": "0"
          },
          {
            "label": "for å sjekke inn på ethvert sted — ingen terminal nødvendig",
            "value": "1 trykk"
          }
        ],
        "features": [
          {
            "body": "Hvert arbeidet minutt knyttes til riktig prosjekt automatisk. En sanntids nedtelling viser hvor mange timer som gjenstår mot budsjettet — for deg og for arbeideren på stedet.",
            "plan": "Project Basic",
            "title": "Prosjekttimer med sanntids gjenstående budsjett"
          },
          {
            "body": "Prosjektadressen er i appen. Ett trykk åpner navigasjon — ingen søking, ingen separat kartapp, ingen samtaler til kontoret.",
            "title": "Navigasjon til stedet med ett trykk"
          },
          {
            "body": "Hver elektriker sjekker inn på riktig jobb. Du vet alltid hvem som er på hvilket sted akkurat nå.",
            "plan": "Project Basic",
            "title": "Arbeiderinnsjekk per prosjekt"
          },
          {
            "body": "Når omfanget endres — en uventet kurs, ekstra materialer — logges det i appen med bilder, før arbeidslaget drar.",
            "plan": "Project Basic",
            "title": "Ekstraarbeid logget på stedet"
          },
          {
            "body": "Overtid logges i det øyeblikket den skjer. Arbeidere velger å få den utbetalt eller konvertert til avspasering.",
            "plan": "Time Pro",
            "title": "Overtidsregistrering med fleksibel kompensasjon"
          }
        ],
        "headline": "Tidsregistrering for elektrikere — timer per prosjekt, budsjettkontroll og navigasjon i én app",
        "workflow": [
          {
            "body": "Adresse og omfang er allerede i appen. Ett trykk åpner navigasjon — ingen samtaler, ingen forvirring.",
            "step": "Elektrikeren navigerer til jobben"
          },
          {
            "body": "Innsjekk på stedet knytter hvert arbeidet minutt til riktig prosjekt. Gjenstående-timer-telleren oppdateres i sanntid.",
            "step": "Timer knyttes til riktig prosjekt automatisk"
          },
          {
            "body": "Ekstraarbeid og materialer logges på stedet, før man drar. Fakturaen gjenspeiler hva som faktisk skjedde.",
            "step": "Omfangsendringer blir registrert"
          }
        ],
        "compliance": {
          "body": "Done-it gir elektrikere stedsverifisert innsjekk per prosjekt, et sanntids gjenstående-timer-budsjett og lønnseksport — og oppfyller ethvert lokalt krav til tidsregistrering. For team på belgiske byggeplasser integrerer den også med CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Stedsverifisert innsjekk per prosjekt",
          "title": "Sanntids budsjettkontroll og stedsverifisert innsjekk for elektroteam"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Rørlegging",
        "slug": "plumbing",
        "intro": "Akuttutrykninger, flere jobber per dag, timer fylt inn fra hukommelsen ved ukens slutt — eller ikke i det hele tatt. Done-it gjør det til en jobb med ett trykk på hvert sted og en lønn med ett klikk ved månedsslutt.",
        "pains": [
          {
            "body": "Med flere jobber på en dag har rørleggere sjelden tid til å fylle inn nøyaktige timelister. Timer rundes eller glemmes, og lønn er i beste fall et estimat.",
            "title": "Utrykningstimer rekonstruert fra hukommelsen"
          },
          {
            "body": "Når en kunde bestrider hvor lang tid en reparasjon tok, finnes det ingen objektiv registrering. En GPS-bekreftet digital innsjekk er lett å fremlegge — en papir-timeliste er det ikke.",
            "title": "Ingen bevis på tid på stedet"
          },
          {
            "body": "Reise mellom utrykninger summerer seg over uken og måneden, men uten automatisk fangst blir den sjelden fakturert eller refundert riktig.",
            "title": "Kjørelengde mellom jobber usporet"
          },
          {
            "body": "Ved månedsslutt tar det å jakte på timelister, korrigere feil og bygge lønnseksporten tid administrasjonsteamet ditt ikke burde bruke.",
            "title": "Lønnsforberedelse er treg"
          }
        ],
        "quote": {
          "who": "Eier, rørleggerfirma · 4 rørleggere",
          "text": "Vi pleide å bruke en formiddag ved månedsslutt på å rekonstruere timer. Nå eksporterer og sender vi bare. Lønnsleverandøren får det rent.",
          "result": "Lønnsforberedelse ned fra timer til minutter"
        },
        "stats": [
          {
            "label": "for å sjekke inn — raskt nok for akuttsamtaler",
            "value": "1 trykk"
          },
          {
            "label": "lønnseksport til leverandøren din",
            "value": "1 klikk"
          },
          {
            "label": "timer rekonstruert fra hukommelsen ved månedsslutt",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ankomst og avgang logget med ett trykk, med stedsverifisering av stedet. Raskt nok for akuttsamtaler; presist nok for tvister.",
            "plan": "Time Basic",
            "title": "Stedsverifisert innsjekk med ett trykk på hver utrykning"
          },
          {
            "body": "Obligatoriske pauser trekkes fra total tid automatisk — ingenting å fylle inn, ingen lønnsfeil.",
            "plan": "Time Basic",
            "title": "Automatisk pausefradrag"
          },
          {
            "body": "Konfigurer transporttyper og refusjonssatser. Kilometer logges automatisk og knyttes til riktig kunde eller prosjekt.",
            "plan": "Add-on",
            "title": "Kjørelengde fanget per tur"
          },
          {
            "body": "Arbeidere sender inn sykmeldinger digitalt fra appen. Opprett fraværstypene teamet ditt faktisk bruker, inkludert værforsinkelser.",
            "title": "Fraværs- og sykmeldingshåndtering"
          },
          {
            "body": "Alle time- og kilometerdata eksporteres rent for lønnsleverandøren din — ingen manuell forberedelse, ingen Excel.",
            "plan": "Time Basic",
            "title": "Lønnseksport med ett klikk"
          }
        ],
        "headline": "Tidsregistrering for rørleggerteam — rask innsjekk, nøyaktig lønn og tilstedeværelsesbevis for hver utrykning",
        "workflow": [
          {
            "body": "Ett trykk sjekker inn. GPS logger stedet og tiden. Raskt nok for en akuttjobb.",
            "step": "Rørleggeren kommer til utrykningen"
          },
          {
            "body": "Utsjekk lukker tidsregistreringen. Kjørelengde til neste jobb begynner å logges automatisk.",
            "step": "Avgang trykket på vei ut"
          },
          {
            "body": "Alle utrykninger, timer og kilometer eksporteres rent. Lønnsforberedelse går fra en dag til minutter.",
            "step": "Månedsslutt er ett klikk"
          }
        ],
        "compliance": {
          "body": "Done-it dekker ethvert lokalt krav til tidsregistrering for rørleggerteam — stedsverifisert innsjekk med ett trykk per utrykning, automatisk pausefradrag og en ren lønnseksport. Ingen papir-timelister, ingen manuell rekonstruksjon.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital tidsregistrering",
          "title": "Rask stedsverifisert innsjekk for hver utrykning"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Hagearbeid",
        "slug": "landscaping",
        "intro": "Høysesong betyr mange steder, skiftende arbeidslag og mange kilometer. Done-it holder hver time, hvert fravær og hver tur organisert — så du kan fokusere på arbeidet, ikke papirarbeidet.",
        "pains": [
          {
            "body": "Midlertidige arbeidere, skiftende timeplaner og varierende teamstørrelser gjør nøyaktig timeregistrering nesten umulig med papir. Når du avstemmer ved månedsslutt, mangler det alltid noe.",
            "title": "Sesongarbeidslag er komplekse å håndtere"
          },
          {
            "body": "Et arbeidslag som besøker tre eller fire steder per dag genererer timer som må fordeles riktig. Manuell registrering fører til feilattribusjon og omstridt lønn.",
            "title": "Timer spredt over mange steder"
          },
          {
            "body": "Stans på grunn av dårlig vær er en reell hendelse i hagearbeid. Uten en digital registrering er det tregt og feilutsatt å dokumentere stans og justere lønn.",
            "title": "Værstans er vanskelig å dokumentere"
          },
          {
            "body": "Firmabiler, private kjøretøy og samkjøring krysser mellom steder hele dagen. Uten automatisk fangst kommer de kilometrene aldri inn i kostnadsbildet.",
            "title": "Kjørelengde mellom steder blir usporet"
          }
        ],
        "quote": {
          "who": "Eier, hagearbeidsfirma · 12 sesongarbeidere",
          "text": "Høysesong pleide å bety lønnskaos. Nå sjekker formannen vår appen, alle er gjort rede for, og jeg eksporterer timene på den siste dagen i måneden.",
          "result": "Ikke mer lønnsrekonstruksjon ved månedsslutt"
        },
        "stats": [
          {
            "label": "fangst av kjørelengde — ikke mer kjørebok",
            "value": "Automatisk"
          },
          {
            "label": "oversikt over arbeidslag på tvers av alle steder",
            "value": "Sanntid"
          },
          {
            "label": "lønnseksport for alle steder og alle arbeidslag",
            "value": "1 klikk"
          }
        ],
        "features": [
          {
            "body": "Se alle arbeidslag, alle steder i sanntid. Vit hvem som jobber hvor, akkurat nå — ikke ved månedsslutt.",
            "title": "Oversikt over arbeidslag på flere steder"
          },
          {
            "body": "Planlegg hvem som jobber hvor, håndter endringer i siste liten og send timeplanen til teamets telefoner — uten en telefon til hver person.",
            "plan": "Time Pro",
            "title": "Skiftplanlegging for sesongteam"
          },
          {
            "body": "Opprett tilpassede fraværstyper for din bransje: sesongmessig værstans, foreldrepermisjon, sykedager. Arbeidere laster opp dokumentasjon digitalt fra appen.",
            "title": "Tilpassede fraværstyper"
          },
          {
            "body": "Konfigurer transporttyper (firmabil, privatbil, samkjøringssjåfør mot passasjer) med egne satser. Kilometer logges automatisk per tur.",
            "plan": "Add-on",
            "title": "Kjørelengde med samkjøringssporing"
          },
          {
            "body": "Overtid i høysesongen akkumuleres raskt. Hver arbeider kan velge å få den utbetalt eller spare timene som avspasering — sporet transparent.",
            "plan": "Time Pro",
            "title": "Overtidsregistrering med permisjonskonvertering"
          }
        ],
        "headline": "Tidsregistrering for hagearbeidsfirmaer — sesongarbeidslag, flere steder og kjørelengde i én oversikt",
        "workflow": [
          {
            "body": "GPS logger ankomst. Timer fordeles automatisk til riktig sted og prosjekt — ingen manuell fordeling ved dagens slutt.",
            "step": "Arbeidslaget sjekker inn på det første stedet"
          },
          {
            "body": "Formannen registrerer stansen fra appen — en ren digital registrering, ikke noe ekstra papirarbeid.",
            "step": "Været stopper arbeidet"
          },
          {
            "body": "Timer, fravær og kjørelengde på tvers av hvert sted og hvert arbeidslagsmedlem eksporteres rent for lønn.",
            "step": "Månedsslutt: alle steder, alle arbeidslag, én eksport"
          }
        ],
        "compliance": {
          "body": "Done-it gir hagearbeidsteam digital tidsregistrering på tvers av alle steder og sesongarbeidere — stedsverifisert innsjekk, tilpassede fraværstyper for værstans og en ren lønnseksport som oppfyller ethvert lokalt krav.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital tidsregistrering",
          "title": "Stedsverifisert innsjekk og fraværssporing for sesongbaserte hagearbeidsteam"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Vedlikehold",
        "slug": "maintenance",
        "intro": "Gjentakende vedlikeholdskontrakter står og faller på kostnadsoversikt. Done-it logger hvert besøk, sporer timer mot kontraktbudsjettet og gir deg — og kundene dine — bevis på tilstedeværelse for hvert besøk.",
        "pains": [
          {
            "body": "Når timer for gjentakende besøk ikke spores mot den spesifikke kontrakten, vet du ikke om en kunde er lønnsom før gjennomgangen ved årsslutt — og da er det for sent å reprise.",
            "title": "Ingen kostnadsoversikt per vedlikeholdskontrakt"
          },
          {
            "body": "Eiendomsforvaltere og eiendomseiere ønsker i økende grad oppmøteregistreringer: hvem kom, når de kom, hva de gjorde. En papirlogg fremlagt uker senere oppfyller ikke SLA-krav.",
            "title": "Kunder forventer bevis på hva som ble gjort"
          },
          {
            "body": "Roterende skift på tvers av mange gjentakende steder — med ansatte som dekker for hverandre — skaper et planleggings- og timesporingspuslespill som manuelle prosesser ikke kan løse pålitelig.",
            "title": "Gjentakende besøk vanskelige å planlegge og logge"
          },
          {
            "body": "Plenstell, fasadevedlikehold og utendørs anleggsarbeid møter alle værrelatert stans. Å dokumentere dem riktig krever et digitalt spor.",
            "title": "Værstans påvirker utendørs vedlikehold også"
          }
        ],
        "quote": {
          "who": "Driftsleder, vedlikeholdsfirma · 8 arbeidere",
          "text": "Vi kan fortelle en eiendomsforvalter nøyaktig hvem som var på stedet og når, på to minutter. Det nivået av bevis endret hvordan kunder ser på oss.",
          "result": "Kundetvister ned til null"
        },
        "stats": [
          {
            "label": "kostnad per vedlikeholdskontrakt",
            "value": "Sanntid"
          },
          {
            "label": "oppmøtebevis klart for kunder på forespørsel",
            "value": "GPS"
          },
          {
            "label": "kontraktfornyelser uten å kjenne marginen din",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Hver vedlikeholdskontrakt er et prosjekt. Timer logges automatisk mot den, og gir deg et sanntids kostnadstall og en nedtelling av gjenstående timer for hver kunde.",
            "plan": "Project Basic",
            "title": "Kontraktbasert kostnadssporing"
          },
          {
            "body": "Tidsstemplede, stedsverifiserte innsjekker er en ubestridelig registrering av hvem som var på stedet, når og hvor lenge — klar til å deles med kunder på forespørsel.",
            "title": "GPS-bekreftet oppmøtebevis"
          },
          {
            "body": "Arbeidere rapporterer problemer, fullførte oppgaver eller ekstraarbeid direkte fra appen — med tekst og bilder. Kunder får en sanntidsregistrering; du har dokumentasjonen for fakturering.",
            "plan": "Project Basic",
            "title": "Oppdateringer med bilder fra stedet"
          },
          {
            "body": "Planlegg gjentakende besøk på tvers av alle kontrakter, tildel arbeidere og håndter erstatninger — uten en telefon til hver person.",
            "plan": "Time Pro",
            "title": "Gjentakende skiftplanlegging"
          },
          {
            "body": "Konfigurer værstans og andre fraværstyper. Arbeidere registrerer dem fra appen; dokumentasjon lastes opp digitalt.",
            "title": "Fraværstyper for utendørs vedlikehold"
          }
        ],
        "headline": "Tidsregistrering for vedlikeholdsteam — gjentakende stedsbesøk, kostnad per kontrakt og oppmøtebevis i én app",
        "workflow": [
          {
            "body": "Stedsverifisert innsjekk logger ankomsttiden og knytter timer til riktig kontrakt. Oppmøtebevis opprettes automatisk.",
            "step": "Arbeideren kommer til vedlikeholdsstedet"
          },
          {
            "body": "Fullført arbeid og eventuelle problemer rapporteres fra appen med bilder. Kunder kan se nøyaktig hva som ble gjort.",
            "step": "Oppgaver fullført, problemer logget"
          },
          {
            "body": "Timer akkumuleres mot kontraktbudsjettet i sanntid. Du kjenner marginen før kontrakten fornyes.",
            "step": "Kostnad per kontrakt synlig umiddelbart"
          }
        ],
        "compliance": {
          "body": "Done-it gir vedlikeholdsteam GPS-bekreftet oppmøtebevis per kontrakt, tilpassede fraværstyper og en sanntidsoversikt over kostnad per gjentakende kunde — og oppfyller ethvert lokalt krav til tidsregistrering uten ekstra maskinvare.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Kontraktbasert tidsregistrering",
          "title": "Sanntids kostnadsoversikt per vedlikeholdskontrakt"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Butikk og detaljhandel",
        "slug": "retail",
        "intro": "Åpningsskift, kveldsskift og alltid noen som dekker for noen andre. Done-it gir hver butikk en ryddig digital oversikt over hvem som jobbet hvilket skift — stemplet inn på egen telefon, klart til lønnskjøring ved månedsslutt.",
        "pains": [
          {
            "body": "Noen dekker for en syk kollega, noen blir en time ekstra ved stenging. Det huskes på en lapp, eller ikke i det hele tatt — og lønnen er feil før du har begynt.",
            "title": "Skiftbytter når aldri fram til lønn"
          },
          {
            "body": "Ansatte flytter seg mellom avdelinger, deltidsansatte jobber på to steder. Å samle timer per butikk og slå dem sammen for hånd koster en dag hver måned.",
            "title": "Flere butikker, én lønnskjøring"
          },
          {
            "body": "Lovpålagte pauser trekkes fra etter hukommelsen og ekstratimer gjøres opp uformelt — nettopp de to tingene et tilsyn spør om først.",
            "title": "Pauser og overtid er gjetning"
          }
        ],
        "quote": {
          "who": "Eier, butikk · 11 ansatte",
          "text": "To butikker og mange deltidsansatte. Før ble halvparten av vaktdekningene gjort opp etter hukommelsen. Nå ligger hver time på riktig butikk, og lønnskjøringen tar minutter.",
          "result": "Lønnsforberedelse fra en dag til under en time"
        },
        "stats": [
          {
            "label": "for å stemple inn — ingen terminal ved kassa",
            "value": "1 trykk"
          },
          {
            "label": "oversikt over hvem som er på jobb, i alle butikker",
            "value": "Sanntid"
          },
          {
            "label": "skiftbytter tapt mellom butikkgulvet og lønn",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ett trykk på egen telefon når skiftet starter. Ingen terminal ved kassa, ikke noe delt kort, ingen perm ved lagerdøra.",
            "title": "Stemple inn i butikken"
          },
          {
            "body": "Hver butikk er et prosjekt. Den som dekker en annen avdeling, stemples på den avdelingen — du ser timene der de faktisk ble jobbet.",
            "title": "Timer per butikk, ansatte på tvers av avdelinger"
          },
          {
            "body": "Sett pauseregelen én gang, så gjelder den for hvert skift. Overtid registreres i det øyeblikket den oppstår, og hver ansatt velger utbetaling eller avspasering.",
            "title": "Pauser trekkes fra automatisk"
          }
        ],
        "headline": "Timeregistrering for butikker — innstempling på skift, vaktdekning og en lønnsklar eksport, i én app",
        "workflow": [
          {
            "body": "Ett trykk på telefonen når skiftet starter. Dekning for en annen avdeling stemples på den avdelingen.",
            "step": "Ansatte stempler inn på skiftet"
          },
          {
            "body": "Sanntidsoversikt på tvers av alle lokasjoner — oppdag et udekket åpningsskift før dørene åpner.",
            "step": "Du ser hvem som er på jobb, per butikk"
          },
          {
            "body": "Timer, pauser og overtid per ansatt og per butikk, eksportert klart til lønnssystemet.",
            "step": "Lønn i én eksport"
          }
        ],
        "compliance": {
          "body": "Done-it holder en objektiv digital oversikt over hver inn- og utstempling, med pauser og overtid — dokumentasjonen et tilsyn eller en lønnstvist ber om.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skiftbasert timeregistrering",
          "title": "Dokumentasjon som holder for hvert skift"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Kontor og profesjonelle tjenester",
        "slug": "offices",
        "intro": "Regnskapsførere, advokater, arkitekter, byråer og konsulenter fakturerer tiden sin — eller trenger i det minste å vite hvor den ble av. Done-it fører timene på riktig kunde og prosjekt, fra pulten eller på farten.",
        "pains": [
          {
            "body": "Tid som skrives ned på slutten av uka, er tid som gjettes. Hele timer forsvinner stille mellom jobben og fakturaen.",
            "title": "Fakturerbare timer rekonstruert på fredag"
          },
          {
            "body": "Honoraret ble avtalt for måneder siden. Om jobben fortsatt får plass innenfor det, blir først klart når noen summerer — vanligvis for sent.",
            "title": "Ingen anelse om hva en kunde faktisk koster"
          },
          {
            "body": "Deler av teamet er på kontoret, deler hjemme, deler hos kunden. Tilstedeværelse slutter å være et faktum og blir en rekonstruksjon.",
            "title": "Hybridarbeid gjør oversikten hullete"
          }
        ],
        "quote": {
          "who": "Partner, regnskapskontor · 8 ansatte",
          "text": "Vi pleide å bygge opp igjen hele uka hver fredag. Nå ligger timene allerede på riktig kunde, og jeg ser hvilke saker som spiser opp honoraret.",
          "result": "Fakturerbare timer hentet inn hver måned"
        },
        "stats": [
          {
            "label": "timer, synlige mens jobben fortsatt pågår",
            "value": "Per kunde"
          },
          {
            "label": "samme oversikt, telefon og nettleser",
            "value": "Kontor eller vei"
          },
          {
            "label": "til lønn og fakturering",
            "value": "1 eksport"
          }
        ],
        "features": [
          {
            "body": "Hver føring lander på et prosjekt, så du ser timene per kunde uten å eksportere noe eller spørre noen.",
            "title": "Timer på kunde og prosjekt"
          },
          {
            "body": "Samme app på telefonen eller i nettleseren. Et kundebesøk teller som arbeid på den kunden, inkludert reisetiden hvis du vil ha den med.",
            "title": "Fungerer ved pulten og ute"
          },
          {
            "body": "Ekstratimer registreres når de oppstår, ferie og fravær søkes om og godkjennes i appen — ingen parallelle regneark over hvem som er borte når.",
            "title": "Overtid og fravær på ett sted"
          }
        ],
        "headline": "Timeregistrering for kontorer — timer per kunde og prosjekt, uten regnearket",
        "workflow": [
          {
            "body": "Sett det opp én gang med kunden og, hvis du fakturerer mot budsjett, timene du har planlagt.",
            "step": "Opprett et kundeprosjekt"
          },
          {
            "body": "Fra pulten eller telefonen. Hver time lander på en kunde, ikke i noens hukommelse.",
            "step": "Teamet fører timer på det"
          },
          {
            "body": "Løpende totaler per prosjekt, og en ryddig eksport til lønn eller fakturering ved månedsslutt.",
            "step": "Se timer per kunde, eksporter til lønn"
          }
        ],
        "compliance": {
          "body": "Done-it holder en digital oversikt over arbeidstid per ansatt, med sporbare endringer — grunnlaget for både lønn og en kundefaktura som holder.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Timeregistrering per kunde",
          "title": "En objektiv oversikt over arbeidede timer"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salonger og kroppspleie",
        "slug": "beauty",
        "intro": "Frisører, barberere, negle- og skjønnhetsstudioer går på skift og deltidskontrakter. Done-it registrerer hvem som jobbet når, trekker fra pauser automatisk og gir lønn en ryddig fil.",
        "pains": [
          {
            "body": "Tre dager én uke, fire den neste, en lørdag byttet mot en tirsdag. Avtalte timer og jobbede timer glir fort fra hverandre.",
            "title": "Deltidskontrakter, endeløse varianter"
          },
          {
            "body": "Avtalene sier hva som ble booket, ikke hvem som jobbet. Når lønn eller et tilsyn spør, er bookingsystemet feil svar.",
            "title": "Timeboka er ikke en timeliste"
          },
          {
            "body": "Å bli igjen for en siste kunde blir husket, lovet — og noen ganger glemt. Det er den typen hull som ender i en tvist.",
            "title": "Ekstratimer gjøres opp uformelt"
          }
        ],
        "quote": {
          "who": "Eier, frisørsalong · 6 ansatte",
          "text": "Alle jobber deltid, og hver uke er forskjellig. Appen bare registrerer det — jeg har sluttet å bygge opp igjen måneden i et regneark.",
          "result": "Slutt på omstridte timer ved månedsslutt"
        },
        "stats": [
          {
            "label": "for å stemple inn — ingenting delt, ingenting på papir",
            "value": "1 trykk"
          },
          {
            "label": "pausetrekk på hvert skift",
            "value": "Auto"
          },
          {
            "label": "sene timer gjort opp etter hukommelsen",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Ett trykk på egen telefon når skiftet starter — ingen delt terminal i resepsjonen, ingen signaturliste ved speilet.",
            "title": "Stemple inn i salongen"
          },
          {
            "body": "Sett pauseregelen og standardtimene én gang; de gjelder for hvert skift, med unntak per person der en kontrakt avviker.",
            "title": "Pauser og deltidsregler én gang"
          },
          {
            "body": "Ekstratimer registreres mens de jobbes, og hver ansatt velger utbetaling eller avspasering — gjort opp i appen, ikke etter hukommelsen.",
            "title": "Overtid, utbetalt eller avspasert"
          }
        ],
        "headline": "Timeregistrering for salonger — skift, deltidstimer og lønn uten papirkalenderen",
        "workflow": [
          {
            "body": "Ett trykk ved ankomst. Pauser trekkes fra etter regelen du satte én gang.",
            "step": "Ansatte stempler inn på skiftet"
          },
          {
            "body": "Hvem som er inne, hvem som har pause, hvem som ble igjen — i sanntid, uten å spørre.",
            "step": "Du ser dagen mens den går"
          },
          {
            "body": "Jobbede timer, pauser og overtid per ansatt, eksportert til lønnssystemet.",
            "step": "Lønn får en ryddig fil"
          }
        ],
        "compliance": {
          "body": "Done-it registrerer faktisk arbeidstid per ansatt, med pauser og overtid — atskilt fra bookingene, og holdbart når det kontrolleres.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Digital timeregistrering",
          "title": "Dokumentasjon som holder utover timeboka"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Helse og velvære",
        "slug": "wellness",
        "intro": "Treningssentre, treningsstudioer, fysioterapiklinikker og spa har lange åpningstider med roterende bemanning. Done-it registrerer hvem som dekket hvilket skift, trekker fra pauser automatisk og eksporterer lønn rent.",
        "pains": [
          {
            "body": "Tidligskift, kveldstimer og helger, dekket av en blanding av heltids-, deltids- og frilansansatte. Vaktplanen er en plan, ikke en registrering.",
            "title": "Lange åpningstider, roterende dekning"
          },
          {
            "body": "En instruktør holder to gruppetimer og tar resepsjonen imellom. Å betale det riktig krever å vite hva som faktisk ble jobbet, ikke hva som stod på planen.",
            "title": "Gruppetimer og gulvtimer flyter sammen"
          },
          {
            "body": "Ansatte flytter seg mellom studioene. Å slå sammen timene deres for hånd hver måned er tregt og feilutsatt.",
            "title": "Flere lokasjoner, én administrasjon"
          }
        ],
        "quote": {
          "who": "Daglig leder, treningsstudio · 14 ansatte",
          "text": "To studioer, lange åpningstider og mange vaktdekninger. Nå havner timene på riktig sted, og lønn er én fil.",
          "result": "Vaktplan og lønn stemmer endelig"
        },
        "stats": [
          {
            "label": "timer, også når ansatte dekker andre steder",
            "value": "Per studio"
          },
          {
            "label": "oversikt over gulvet på tvers av lokasjoner",
            "value": "Sanntid"
          },
          {
            "label": "pauser og overtid, ingen manuell regning",
            "value": "Auto"
          }
        ],
        "features": [
          {
            "body": "Ett trykk på telefonen på stedet de jobber. Dekning på et annet studio havner på det studioets timer.",
            "title": "Stemple inn per studio"
          },
          {
            "body": "Se gulvet på tvers av alle lokasjoner i sanntid — et udekket tidligskift er synlig før dørene åpner, ikke etterpå.",
            "title": "Sanntidsoversikt over hvem som er på jobb"
          },
          {
            "body": "Pauseregler brukes automatisk, ekstratimer registreres når de oppstår, med utbetaling eller avspasering per ansatt.",
            "title": "Pauser og overtid håndtert"
          }
        ],
        "headline": "Timeregistrering for treningssentre, studioer og spa — skift, gruppetimer og lønn i én app",
        "workflow": [
          {
            "body": "Ett trykk når skiftet starter, på stedet der de jobber.",
            "step": "Ansatte stempler inn på studioet"
          },
          {
            "body": "Hvem som er på jobb på hvilken lokasjon akkurat nå, så hull fylles før medlemmene merker det.",
            "step": "Dekningen er synlig i sanntid"
          },
          {
            "body": "Timer, pauser og overtid per ansatt og per studio, klart til lønnssystemet.",
            "step": "Én eksport til lønn"
          }
        ],
        "compliance": {
          "body": "Done-it holder en digital oversikt over arbeidstid per ansatt og per lokasjon — grunnlaget for riktig lønn og for enhver kontroll av arbeidede timer.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skiftregistrering på flere steder",
          "title": "Objektiv dokumentasjon for hvert skift og sted"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Servering og hotell",
        "slug": "hospitality",
        "intro": "Delte vakter, sene stenginger og en travel lørdag som drar ut. Done-it registrerer timene slik de faktisk jobbes, trekker fra pauser etter din regel og gir lønn én ryddig fil.",
        "pains": [
          {
            "body": "Serveringen drar ut, stengingen tar en halvtime til. De minuttene er ekte arbeid, og å gjøre dem opp etter hukommelsen er slik tvister starter.",
            "title": "Skiftet slutter aldri når vaktplanen sier"
          },
          {
            "body": "Lunsjservering, en pause, så middag. På papiret blir det én lang blokk eller to gjetninger — ingen av dem er sannheten.",
            "title": "Delte vakter er vanskelige å registrere"
          },
          {
            "body": "Nye ansatte hver sesong. Ethvert system som krever opplæring, overlever ikke den første travle uka.",
            "title": "Høy gjennomtrekk, konstant opplæring"
          }
        ],
        "quote": {
          "who": "Eier, restaurant · 17 ansatte",
          "text": "Stengingen drar alltid ut. Nå logges de minuttene i stedet for å bli kranglet om, og de ansatte kan ta dem ut som avspasering.",
          "result": "Færre tvister, raskere lønn"
        },
        "stats": [
          {
            "label": "registrert som to blokker, ikke én gjetning",
            "value": "Delte vakter"
          },
          {
            "label": "pausetrekk etter din regel",
            "value": "Auto"
          },
          {
            "label": "å få en nyansatt i gang — det er deres egen telefon",
            "value": "1 min"
          }
        ],
        "features": [
          {
            "body": "Ett trykk ved start og slutt på hver blokk, så delte vakter registreres slik de skjedde — ikke slått sammen til én.",
            "title": "Stemple inn og ut per servering"
          },
          {
            "body": "Lovpålagte pauser trekkes fra automatisk, med unntak per person der en kontrakt krever det. Ingen manuell regning ved månedsslutt.",
            "title": "Pauser etter din regel"
          },
          {
            "body": "Den ekstra halvtimen etter stenging registreres i det øyeblikket den jobbes, og utbetales eller tas ut som avspasering — den ansatte velger.",
            "title": "Overtid gjøres opp i appen"
          }
        ],
        "headline": "Timeregistrering for kafeer, restauranter og hoteller — skift, pauser og overtid, gjort opp rettferdig",
        "workflow": [
          {
            "body": "Ett trykk når blokken starter; det samme ved slutt. Delte vakter forblir delte.",
            "step": "Ansatte stempler inn til servering"
          },
          {
            "body": "Hvem som er på jobb til kveldens servering, hvem som fortsatt har pause, hvem som ble igjen etter stengetid.",
            "step": "Du ser gulvet i sanntid"
          },
          {
            "body": "Arbeidstid, pauser og overtid per ansatt, eksportert i én fil.",
            "step": "Lønn får de virkelige timene"
          }
        ],
        "compliance": {
          "body": "Done-it holder en objektiv digital oversikt over hvert skift, hver pause og hver ekstratime — nøyaktig det en lønnskontroll eller et arbeidstilsyn ber om å se.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registrering av delte vakter",
          "title": "Dokumentasjon som holder i et team med høy gjennomtrekk"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Helse og omsorg",
        "slug": "healthcare",
        "intro": "Klinikker, hjemmetjenester og omsorgsboliger går på skift, besøk og strenge dokumentasjonskrav. Done-it registrerer arbeidstid per skift og per besøk, og holder ansattdokumentene der du finner dem.",
        "pains": [
          {
            "body": "Hjemmebesøk ligger i ett verktøy, vaktplantimer i et annet, og lønn får en tredje versjon. Å avstemme dem er en månedlig jobb.",
            "title": "Besøk og skift i hvert sitt system"
          },
          {
            "body": "Ubekvem arbeidstid har egne satser. Når registreringen er omtrentlig, blir lønnen det også — og korrigeringen kommer i etterkant.",
            "title": "Natt- og helgetimer prises feil"
          },
          {
            "body": "Kvalifikasjoner og sertifikater betyr noe i omsorg, og de ligger i en perm ingen åpner før et tilsyn spør.",
            "title": "Sertifikater går ut på dato i stillhet"
          }
        ],
        "quote": {
          "who": "Koordinator, hjemmetjeneste · 22 ansatte",
          "text": "Hjemmebesøk og vaktplanskift ligger endelig i samme oversikt. Lønn har sluttet å være en avstemmingsøvelse.",
          "result": "Én oversikt i stedet for tre"
        },
        "stats": [
          {
            "label": "eller per skift — det teamet ditt går på",
            "value": "Per besøk"
          },
          {
            "label": "natt- og helgetimer, registrert slik de jobbes",
            "value": "Delt"
          },
          {
            "label": "sertifikater lagret per ansatt",
            "value": "Arkivert"
          }
        ],
        "features": [
          {
            "body": "Ett trykk når skiftet starter, eller på hver klientadresse i hjemmetjenesten — stedfestet der du trenger dokumentasjonen.",
            "title": "Stemple inn per skift eller per besøk"
          },
          {
            "body": "Natt-, helge- og ordinære timer registreres hver for seg, så lønnseksporten allerede gjenspeiler hvordan arbeidet faktisk betales.",
            "title": "Timer delt slik du betaler dem"
          },
          {
            "body": "Kontrakter, sertifikater og legitimasjon lagret ved siden av personen de hører til — funnet på sekunder når noen spør.",
            "title": "Ansattdokumenter på ett sted"
          }
        ],
        "headline": "Timeregistrering for omsorgsteam — skift, hjemmebesøk og kvalifikasjoner, i én oversikt",
        "workflow": [
          {
            "body": "Ett trykk på stedet eller på klientens adresse, stedfestet der dokumentasjon trengs.",
            "step": "Stemple inn på skiftet eller besøket"
          },
          {
            "body": "Ordinære timer, nattetimer og helgetimer registreres hver for seg mens de oppstår.",
            "step": "Timene havner i riktig kategori"
          },
          {
            "body": "Én ryddig fil per periode, allerede delt slik du betaler den.",
            "step": "Eksporter til lønn"
          }
        ],
        "compliance": {
          "body": "Done-it holder en digital, objektiv oversikt over arbeidstid per ansatt — timer, pauser og fordeling av ubekvem arbeidstid — sammen med dokumentene som hører til hver person.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skift- og besøksregistrering",
          "title": "Dokumentasjon som tåler et tilsyn"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "bg": [
      {
        "name": "Строителство",
        "slug": "construction",
        "intro": "Екипи, разпръснати по различни обекти, часове, нахвърляни на хартия, подизпълнителски часове, които е невъзможно да се съгласуват. Done-it дава на всеки обект непробиваем дигитален график за работно време, който захранва ведомостта Ви с едно кликване.",
        "pains": [
          {
            "body": "При няколко активни обекта и сменящи се екипи ръчните графици са грешни по дефиниция. Работниците закръгляват, забравят записи или ги попълват дни по-късно — оставяйки Ви с данни за заплати, които не можете да защитите.",
            "title": "Няма надежден запис кой къде е работил"
          },
          {
            "body": "Докато забележите, че даден обект е изчерпал планираните си часове, маржът вече е изгубен. Няма обратно отброяване на живо — само неприятна изненада в момента на фактуриране.",
            "title": "Преразходът на бюджет излиза наяве твърде късно"
          },
          {
            "body": "Събирането на графиците, съгласуването им с проектите и подготовката на експорта за заплати отнема дни. Всеки запис е потенциална грешка.",
            "title": "Подготовката на заплатите изяжда часове всеки месец"
          }
        ],
        "quote": {
          "who": "Собственик, строителна фирма · 14 служители",
          "text": "Екипът ни сам се отчита на обекта. В края на месеца заплатите просто се събират — спряхме изцяло да гоним графиците.",
          "result": "5 спестени часа седмично за администрация"
        },
        "stats": [
          {
            "label": "за отметка на всеки обект — без терминал, без хартия",
            "value": "1 докосване"
          },
          {
            "label": "експорт за заплати, готов за доставчика Ви",
            "value": "1 кликване"
          },
          {
            "label": "преглед на оставащите часове за всеки проект и обект",
            "value": "На живо"
          }
        ],
        "features": [
          {
            "body": "Едно докосване отчита работника, с потвърждение на местоположението, и свързва часовете с правилния проект. Без четци за карти, без терминали — само смартфонът, който екипът Ви вече носи.",
            "title": "Отметка с потвърждение на местоположението за всеки обект"
          },
          {
            "body": "Задайте планираните часове като бюджет, когато откривате проекта. Работниците виждат обратно отброяване на това, което остава; Вие го виждате на живо в таблото си. Преразходът на бюджет е видим, преди да се случи.",
            "title": "Оставащи часове на живо за всеки проект"
          },
          {
            "body": "Добавете подизпълнители към проект, задайте им отметка и проследявайте часовете им заедно с тези на собствения си екип — в един и същ преглед.",
            "title": "Управление на подизпълнители и присъствие"
          },
          {
            "body": "Всички регистрирани часове — за всеки работник, за всеки проект — се експортират в чиста таблица за доставчика Ви на услуги за заплати. Без ръчна подготовка, без грешки.",
            "title": "Експорт за заплати с едно кликване"
          }
        ],
        "headline": "Отчитане на времето за строителни екипи — отметка с потвърждение на местоположението, проектни часове и контрол на бюджета в едно приложение",
        "workflow": [
          {
            "body": "Всеки работник докосва веднъж, за да се отчете. GPS потвърждава местоположението, поставя времеви печат на записа и свързва часовете с проекта. Без хартия, без терминал.",
            "step": "Екипът пристига на обекта"
          },
          {
            "body": "Часове, оставащ бюджет, присъствие на подизпълнители и всяка допълнителна работа, докладвана от обекта — всичко в таблото Ви, в реално време.",
            "step": "Виждате всичко на живо"
          },
          {
            "body": "Експортирайте всички часове за всеки работник и за всеки проект. Изпратете ги на доставчика си за заплати. Done-it автоматично генерира чисти, готови за одит отчети.",
            "step": "Краят на месеца за минути"
          }
        ],
        "compliance": {
          "body": "Done-it осигурява отметка с потвърждение на местоположението, отчитане на времето по проекти и чист експорт за заплати за строителни екипи. За екипи, работещи на белгийски обекти, той също така автоматично захранва отметката на работното място.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Дигитално отчитане на работното време",
          "title": "Отметка с потвърждение на местоположението, създадена за строителни обекти"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Почистване",
        "slug": "cleaning",
        "intro": "Чистачите се местят между обекти през целия ден. Done-it проследява кой къде е в реално време — отметка с потвърждение на местоположението на всеки обект, автоматично приспадане на почивките и чист експорт за заплати в края на месеца.",
        "pains": [
          {
            "body": "Клиентите и инспекторите очакват непробиваеми записи за присъствие. Ръчните листове могат да бъдат оспорени; отметките с потвърждение на местоположението — не.",
            "title": "Доказване на присъствие на всяко местоположение"
          },
          {
            "body": "Тъй като чистачите се местят между обектите през деня, нямате преглед на живо кой къде работи — докато някой не се обади.",
            "title": "Екипи, разпръснати по много места"
          },
          {
            "body": "Без точни часове на влизане/излизане заплатите се възстановяват по памет. Часовете се закръгляват нагоре, разходите се надуват и следват спорове.",
            "title": "Грешки в заплатите от закръглени часове"
          }
        ],
        "quote": {
          "who": "Управител, фирма за почистване · 9 служители",
          "text": "Най-сетне можем да докажем кой къде и кога е почиствал. Край с присъствените листове, край с клиентските спорове — GPS се грижи за това.",
          "result": "Нула закръгляне на часовете нагоре"
        },
        "stats": [
          {
            "label": "за отметка на всяко местоположение — без нужда от терминал",
            "value": "1 докосване"
          },
          {
            "label": "преглед кой е на кой обект в момента",
            "value": "На живо"
          },
          {
            "label": "двойни записи — часовете се вливат директно в заплатите",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Работниците се отчитат на влизане и излизане от телефона си на всяко местоположение, с потвърждение на местоположението; времето е точно, с регистриране на почивките.",
            "plan": "Time Basic",
            "title": "Отметка за влизане и излизане в реално време"
          },
          {
            "body": "Задължителните почивки се изваждат автоматично от работния ден — без ръчни изчисления, без спорове.",
            "plan": "Time Basic",
            "title": "Автоматично приспадане на почивките"
          },
          {
            "body": "Вижте кои чистачи са на кои местоположения в момента. Забелязвайте пропуските, преди клиентите да го направят.",
            "title": "Преглед на живо на множество местоположения"
          },
          {
            "body": "Работниците качват болнични удостоверения и документи за отсъствие директно от приложението. Създайте видовете отсъствия, които екипът Ви наистина използва.",
            "title": "Регистриране на отсъствия с дигитални болнични листове"
          },
          {
            "body": "Точните времеви печати се вливат директно в готов за заплати експорт за доставчика Ви. Без преписване, без грешки.",
            "title": "Експорт за заплати с едно кликване"
          }
        ],
        "headline": "Отчитане на времето за фирми за почистване — отметка с потвърждение на местоположението, доказателство за присъствие и заплати в едно приложение",
        "workflow": [
          {
            "body": "Едно докосване го отчита. GPS регистрира обекта и поставя времеви печат на записа. Регистрирането на почивките е вградено в приложението.",
            "step": "Чистачът пристига на местоположението"
          },
          {
            "body": "Кой е на кой обект в момента — без телефонни обаждания, без догадки. Забелязвайте пропуските в покритието, преди клиентите да го направят.",
            "step": "Виждате всяко местоположение на живо"
          },
          {
            "body": "Всички данни за присъствие — точни часове, местоположения и почивки — се експортират чисто за доставчика Ви за заплати.",
            "step": "Заплатите са едно кликване"
          }
        ],
        "compliance": {
          "body": "Done-it дава на екипите за почистване отметка с потвърждение на местоположението на всяко място, автоматично приспадане на почивките и преглед на живо кой е на кой обект в момента.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Присъствие с потвърждение на местоположението",
          "title": "Присъствие в реално време на всяко местоположение за почистване"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Монтаж",
        "slug": "installation",
        "intro": "Изпращайте монтажниците си на правилния адрес с всичко необходимо, свързвайте автоматично всеки отработен час с правилната задача и виждайте оставащия бюджет, преди обектът да приключи. Done-it е най-простият начин да поддържате монтажните проекти навреме и в рамките на разходите.",
        "pains": [
          {
            "body": "Екипите пристигат на обект без адреса, лицето за контакт или подробностите за обхвата. Това първо телефонно обаждане е десет минути изгубено фактурируемо време, преди да бъде отработен дори един час.",
            "title": "Информацията за задачата не достига до терена навреме"
          },
          {
            "body": "Когато работниците попълват часовете си ръчно в края на деня — ако изобщо ги попълнят — часовете попадат в грешна задача или изчезват напълно. Фактурите не отговарят на реалността.",
            "title": "Часовете не са свързани с правилния проект"
          },
          {
            "body": "Без обратно отброяване на живо на оставащите часове за всеки проект разбирате, че дадена задача е надхвърлила бюджета, когато издавате фактурата — а не докато все още можете да реагирате.",
            "title": "Преразходът на бюджет се забелязва твърде късно"
          },
          {
            "body": "Подизпълнителите, работещи на същия обект, използват различни системи, попълват часове отделно или изобщо не ги попълват. Съгласуването в края на месеца е бавен и склонен към грешки процес.",
            "title": "Подизпълнителските часове са трудни за проследяване"
          }
        ],
        "quote": {
          "who": "Собственик, монтажна фирма · 6 служители",
          "text": "Часовете попадат автоматично в правилния проект. Изчисляването на себестойността на задачите изведнъж стана лесно — можем да видим реалния марж, преди да приключим дадена задача.",
          "result": "Реална себестойност за всяка задача, на живо"
        },
        "stats": [
          {
            "label": "преглед на оставащите часове за всеки проект",
            "value": "В реално време"
          },
          {
            "label": "обаждания до офиса за адреси на обекти",
            "value": "0"
          },
          {
            "label": "навигация до всеки адрес на проект от приложението",
            "value": "1 кликване"
          }
        ],
        "features": [
          {
            "body": "Работниците отварят проекта на телефона си: адрес, планирани часове, лице за контакт и качени файлове (планове, инструкции, PDF-и). Всичко необходимо е там, преди да пристигнат.",
            "plan": "Project Basic",
            "title": "Информацията за проекта се споделя директно в приложението"
          },
          {
            "body": "Докоснете веднъж и телефонът навигира до адреса на проекта — вградено в приложението, без нужда от отделно приложение за карти.",
            "title": "Навигация до обекта с един бутон"
          },
          {
            "body": "Задайте планираните часове, когато откривате проекта. Работниците виждат колко часа остават; Вие виждате състоянието на живо в таблото си. Преразходът е видим, преди да се случи.",
            "plan": "Project Basic",
            "title": "Обратно отброяване на оставащите часове за всеки проект"
          },
          {
            "body": "Всеки работник се отчита към правилния проект. Винаги знаете кой е на кой обект в момента.",
            "plan": "Project Basic",
            "title": "Отметка на работника за всеки проект"
          },
          {
            "body": "Когато обхватът на обекта се разраства, работниците регистрират допълнителната работа и материалите в реално време — с текст и снимки — така че нищо да не се фактурира по памет.",
            "plan": "Project Basic",
            "title": "Регистриране на допълнителна работа и материали"
          }
        ],
        "headline": "Отчитане на времето за монтажни екипи — проектни часове, навигация и контрол на бюджета в едно приложение",
        "workflow": [
          {
            "body": "Адрес, контакт, обхват и качени файлове са точно там. Навигира с едно докосване — без обаждания до офиса за упътвания.",
            "step": "Работникът отваря проекта на телефона си"
          },
          {
            "body": "Отметката свързва всяка отработена минута с правилния проект. Оставащият бюджет се обновява в реално време.",
            "step": "Часовете се записват автоматично към правилната задача"
          },
          {
            "body": "Промените в обхвата, допълнителните материали и забавянията се регистрират с текст и снимки в момента, в който се случват — готови за фактурата.",
            "step": "Допълнителната работа се улавя на обекта"
          }
        ],
        "compliance": {
          "body": "Done-it дава на монтажните екипи отметка с потвърждение на местоположението за всеки проект, обратно отброяване на оставащите часове на живо и автоматичен експорт за заплати — покривайки всяко местно изискване за отчитане на работното време. За екипи, работещи на белгийски строителни обекти, той също така се интегрира с CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Дигитално отчитане на работното време",
          "title": "Отметка с потвърждение на местоположението за всеки проект за монтажни екипи"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Изнесено обслужване",
        "slug": "field-service",
        "intro": "Техници, посещаващи по няколко клиента на ден, касови бележки в жабките, километри, записани по памет. Done-it улавя часовете, километрите и разходите на терен — прикрепени към правилната задача в момента, в който се случват.",
        "pains": [
          {
            "body": "Изискването техниците да възстановяват маршрутите си в края на седмицата означава неточни възстановявания, спорове с клиенти и растяща купчина непредявени километри.",
            "title": "Километрите се записват дни по-късно — ако изобщо се записват"
          },
          {
            "body": "Касова бележка в жабка е разход, който може никога да не попадне във фактура. Реалната себестойност за всяка задача винаги е занижена.",
            "title": "Разходи върху хартиени касови бележки, които изчезват"
          },
          {
            "body": "Без отметки на живо разбирате къде е даден техник едва когато нещо се обърка и някой се обади.",
            "title": "Няма преглед в реално време къде е екипът"
          },
          {
            "body": "Когато трудът, пътуването и разходите се проследяват в отделни системи — или изобщо не се проследяват — никога няма единна стойност на себестойността за всяка задача.",
            "title": "Трудно е да се види действителният марж за всяка задача"
          }
        ],
        "quote": {
          "who": "Оперативен директор, фирма за изнесено обслужване · 11 служители",
          "text": "Километрите бяха месечно главоболие. Сега се записват сами — всеки километър е прикрепен към правилния клиент, преди дори да се върнем в офиса.",
          "result": "Точна себестойност за всяка задача, всеки път"
        },
        "stats": [
          {
            "label": "улавяне на километрите — без ръчен дневник",
            "value": "Автоматично"
          },
          {
            "label": "себестойност за всяка задача: часове + пътуване + разходи",
            "value": "На живо"
          },
          {
            "label": "изгубени километри — всяко пътуване се улавя автоматично",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS регистрира тръгването, пристигането и точното разстояние за всяко пътуване. Конфигурирайте видове транспорт (собствен автомобил, служебен автомобил, споделено пътуване) със собствени ставки за възстановяване. Без ръчен дневник.",
            "plan": "Add-on",
            "title": "Автоматично улавяне на километрите (Trax-it)"
          },
          {
            "body": "Работниците щракват касова бележка на терен; тя се прикрепя към задачата и е готова за възстановяване — а не да се гони в края на месеца.",
            "plan": "Time Basic",
            "title": "Управление на разходите на обекта"
          },
          {
            "body": "Часовете, километрите и разходите се сумират към задачата в реално време. Себестойността за всяка задача е видима, докато задачата все още е отворена.",
            "plan": "Project Basic",
            "title": "Контрол на разходите, свързан с проекта"
          },
          {
            "body": "Всеки техник се отчита на обекта на клиента. Виждате кой къде е в момента — без обаждания, без догадки.",
            "title": "Отметка с потвърждение на местоположението и преглед на екипа на живо"
          },
          {
            "body": "Часовете и възстановяванията за километри се експортират чисто за доставчика Ви за заплати — с автоматично приложени конфигурирани от Вас ставки за километри.",
            "title": "Експорт за заплати с едно кликване"
          }
        ],
        "headline": "Отчитане на времето за изнесени обслужващи екипи — километри, разходи и часове от пътя, всичко в едно приложение",
        "workflow": [
          {
            "body": "Отметката стартира дневника на пътуването. Километрите се улавят автоматично от тръгването до пристигането — без ръчно въвеждане.",
            "step": "Техникът тръгва за първото повикване"
          },
          {
            "body": "Часовете се свързват с правилния проект. Допълнителната работа, материалите и касовите бележки се регистрират в приложението в момента, в който се случват.",
            "step": "На мястото на работа"
          },
          {
            "body": "Всеки час, километър и разход вече е прикрепен към правилната задача. Експортирайте към заплати и фактурирайте с реални данни за себестойност.",
            "step": "Краят на месеца без хаоса"
          }
        ],
        "compliance": {
          "body": "Done-it улавя километрите автоматично за всяко пътуване, прилага конфигурираните от Вас ставки за възстановяване и регистрира всеки километър към правилния клиент или проект. Решението Tyco на ЕС означава, че пътуването от дома до първия клиент се счита за работно време — Done-it проследява и това.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Дигитално проследяване на време и километри",
          "title": "GPS часове и автоматични километри за изнесени обслужващи екипи"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "ОВК",
        "slug": "hvac",
        "intro": "Всяко сервизно повикване има три разхода: труд, части и пътуване. Done-it улавя и трите на терен и ги сумира към правилната задача — така че да знаете маржа си, преди да приключите фактурата.",
        "pains": [
          {
            "body": "Трудът, частите и пътуването се намират в различни системи — или различни джобове. Реалната себестойност на едно повикване става ясна едва дълго след като техникът е напуснал обекта.",
            "title": "Сервизните повиквания са трудни за точно остойностяване"
          },
          {
            "body": "Когато клиент оспорва колко е продължил един ремонт, хартиеният график лесно се оспорва. Потвърдените с GPS времеви печати за влизане и излизане — не.",
            "title": "Няма доказателство за сервизното време"
          },
          {
            "body": "При повтарящи се договори за поддръжка малките преразходи се натрупват през много посещения. Без брояч на часовете на живо разбирате, че договорът е на загуба едва при подновяване.",
            "title": "Договорите за поддръжка незабележимо ерозират маржа"
          },
          {
            "body": "Ръчните записи на времето пропускат почивките, което води до надплащане и заплати, които не отговарят на реалността.",
            "title": "Техниците забравят да регистрират почивките"
          }
        ],
        "quote": {
          "who": "Собственик, ОВК фирма · 7 техници",
          "text": "Най-сетне знаем какво всъщност ни струва всеки сервизен договор. Изненадите с маржа спряха в деня, в който започнахме да използваме Done-it.",
          "result": "Реална себестойност за всяко сервизно повикване, на живо"
        },
        "stats": [
          {
            "label": "вида разходи, уловени за всяко повикване: труд, пътуване, части",
            "value": "3"
          },
          {
            "label": "видимост на маржа за всеки сервизен договор",
            "value": "На живо"
          },
          {
            "label": "изненади при фактуриране — разходите са видими в реално време",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Всяко сервизно повикване или договор за поддръжка е проект. Часовете, пътуването и материалите се сумират в реално време — давайки Ви видимост на маржа на живо.",
            "plan": "Project Basic",
            "title": "Отчитане на времето на проектна база"
          },
          {
            "body": "Когато една задача се разраства, техниците регистрират допълнителната работа и частите с текст и снимки, преди да си тръгнат. Нищо не се фактурира по памет.",
            "plan": "Project Basic",
            "title": "Допълнителна работа и материали, регистрирани на обекта"
          },
          {
            "body": "Километрите за всяко повикване се регистрират автоматично и се остойностяват към задачата. Конфигурирайте ставки за възстановяване за всеки вид превозно средство.",
            "plan": "Add-on",
            "title": "Километри и транспортни разходи"
          },
          {
            "body": "Задължителните почивки се изваждат автоматично от общото време — без спорове, без грешки в заплатите.",
            "title": "Автоматично приспадане на почивките"
          },
          {
            "body": "Отметка с времеви печат и потвърждение чрез GPS на всеки обект. Неоспоримо доказателство кога техникът е пристигнал и си е тръгнал.",
            "title": "Отметка с потвърждение на местоположението и доказателство за присъствие"
          }
        ],
        "headline": "Отчитане на времето за ОВК техници — себестойност на задачите, части и пътуване в едно приложение",
        "workflow": [
          {
            "body": "GPS поставя времеви печат на пристигането и свързва часовете със сервизното повикване или договора за поддръжка. Без хартия, без терминал.",
            "step": "Техникът се отчита на обекта"
          },
          {
            "body": "Използваните части, допълнителните часове и промените в обхвата се регистрират в приложението със снимки — преди напускане на обекта.",
            "step": "Допълнителната работа се улавя на момента"
          },
          {
            "body": "Трудът, пътуването и материалите се сумират към проекта в реално време. Виждате маржа, преди да издадете фактурата.",
            "step": "Себестойността на задачата е видима веднага"
          }
        ],
        "compliance": {
          "body": "Done-it дава на ОВК екипите отметка с потвърждение на местоположението за всяко сервизно повикване, видимост на разходите на живо за всяка задача (труд + пътуване + части) и чист експорт за заплати — отговаряйки на всяко местно изискване за отчитане на работното време без допълнителен хардуер.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Дигитално проследяване на време и разходи",
          "title": "Пълно остойностяване на задачите за ОВК сервизни повиквания"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Електротехници",
        "slug": "electricians",
        "intro": "Проектни часове, обратно отброяване на оставащия бюджет на живо и навигация до обекта с един бутон — създадено за малки електротехнически екипи, които се нуждаят от контрол над проектите без административната тежест.",
        "pains": [
          {
            "body": "Когато електротехниците работят по няколко задачи в рамките на седмицата, ръчното разпределяне на часовете в края на деня води до погрешно отнесени разходи, спорове за фактуриране и заплати, които не можете да обясните.",
            "title": "Часовете не са свързани с правилния проект"
          },
          {
            "body": "Без преглед на живо на изразходваните часове спрямо бюджетираните разбирате, че даден проект е надхвърлил бюджета, когато издавате фактурата — а не когато все още можете да реагирате.",
            "title": "Преразходът на бюджет се забелязва твърде късно"
          },
          {
            "body": "Адреси, въведени в отделно приложение, обаждания до офиса за упътвания, закъснения на обектите на клиентите. Всяка изгубена минута е изгубена фактурируема минута.",
            "title": "Изгубено време в намиране на обекта"
          },
          {
            "body": "При по-големи монтажи подизпълнителските електротехници проследяват часовете си отделно. Получаването на комбиниран преглед на разходите за труд в края на проекта е ръчна и склонна към грешки задача.",
            "title": "Подизпълнителските часове са трудни за съгласуване"
          }
        ],
        "quote": {
          "who": "Собственик, електротехническа фирма · 5 електротехници",
          "text": "Знаем в реално време дали даден проект надхвърля бюджета. Само това ни спести две лоши изненади тази година.",
          "result": "Преразходът на бюджет се улавя, преди да се случи"
        },
        "stats": [
          {
            "label": "преглед на оставащите часове за всеки проект",
            "value": "На живо"
          },
          {
            "label": "обаждания до офиса за адреси на обекти",
            "value": "0"
          },
          {
            "label": "за отметка на всеки обект — без нужда от терминал",
            "value": "1 докосване"
          }
        ],
        "features": [
          {
            "body": "Всяка отработена минута се свързва автоматично с правилния проект. Обратно отброяване на живо показва колко часа остават спрямо бюджета — за Вас и за работника на обекта.",
            "plan": "Project Basic",
            "title": "Проектни часове с оставащ бюджет на живо"
          },
          {
            "body": "Адресът на проекта е в приложението. Едно докосване отваря навигацията — без търсене, без отделно приложение за карти, без обаждания до офиса.",
            "title": "Навигация до обекта с един бутон"
          },
          {
            "body": "Всеки електротехник се отчита към правилната задача. Винаги знаете кой е на кой обект в момента.",
            "plan": "Project Basic",
            "title": "Отметка на работника за всеки проект"
          },
          {
            "body": "Когато обхватът се промени — неочаквана верига, допълнителни материали — това се регистрира в приложението със снимки, преди екипът да си тръгне.",
            "plan": "Project Basic",
            "title": "Допълнителна работа, регистрирана на обекта"
          },
          {
            "body": "Извънредният труд се регистрира в момента, в който се случва. Работниците избират да им бъде изплатен или преобразуван в почивни дни.",
            "plan": "Time Pro",
            "title": "Проследяване на извънредния труд с гъвкаво компенсиране"
          }
        ],
        "headline": "Отчитане на времето за електротехници — проектни часове, контрол на бюджета и навигация в едно приложение",
        "workflow": [
          {
            "body": "Адресът и обхватът вече са в приложението. Едно докосване отваря навигацията — без обаждания, без объркване.",
            "step": "Електротехникът навигира до задачата"
          },
          {
            "body": "Отметката на обекта свързва всяка отработена минута с правилния проект. Броячът на оставащите часове се обновява на живо.",
            "step": "Часовете се свързват автоматично с правилния проект"
          },
          {
            "body": "Допълнителната работа и материалите се регистрират на обекта, преди напускане. Фактурата отразява това, което действително се е случило.",
            "step": "Промените в обхвата остават в архива"
          }
        ],
        "compliance": {
          "body": "Done-it дава на електротехниците отметка с потвърждение на местоположението за всеки проект, бюджет на оставащите часове на живо и експорт за заплати — удовлетворявайки всяко местно изискване за отчитане на работното време. За екипи на белгийски строителни обекти той също така се интегрира с CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отметка с потвърждение на местоположението за всеки проект",
          "title": "Контрол на бюджета на живо и отметка с потвърждение на местоположението за електротехнически екипи"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "ВиК",
        "slug": "plumbing",
        "intro": "Аварийни повиквания, по няколко задачи на ден, часове, попълвани по памет в края на седмицата — или изобщо не попълвани. Done-it превръща това в задача с едно докосване на всеки обект и заплати с едно кликване в края на месеца.",
        "pains": [
          {
            "body": "С няколко задачи на ден ВиК специалистите рядко имат време да попълват точни графици. Часовете се закръгляват или забравят, а заплатите в най-добрия случай са приблизителна оценка.",
            "title": "Часовете за повикванията, възстановени по памет"
          },
          {
            "body": "Когато клиент оспорва колко е продължил един ремонт, няма обективен запис. Потвърдената с GPS дигитална отметка е лесна за представяне — хартиеният график не е.",
            "title": "Няма доказателство за времето на обекта"
          },
          {
            "body": "Пътуването между повикванията се натрупва през седмицата и месеца, но без автоматично улавяне рядко се фактурира или възстановява правилно.",
            "title": "Километрите между задачите не се проследяват"
          },
          {
            "body": "В края на месеца гоненето на графиците, коригирането на грешките и изграждането на експорта за заплати отнема време, което администрацията Ви не би трябвало да отделя.",
            "title": "Подготовката на заплатите е бавна"
          }
        ],
        "quote": {
          "who": "Собственик, ВиК фирма · 4 ВиК специалисти",
          "text": "Преди прекарвахме по една сутрин в края на месеца във възстановяване на часовете. Сега просто експортираме и изпращаме. Доставчикът за заплати ги получава чисти.",
          "result": "Подготовката на заплатите намалена от часове до минути"
        },
        "stats": [
          {
            "label": "за отметка — достатъчно бързо за аварийни повиквания",
            "value": "1 докосване"
          },
          {
            "label": "експорт за заплати към доставчика Ви",
            "value": "1 кликване"
          },
          {
            "label": "часове, възстановени по памет в края на месеца",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Пристигането и тръгването се регистрират с едно докосване, с потвърждение на местоположението. Достатъчно бързо за аварийни повиквания; достатъчно точно за спорове.",
            "plan": "Time Basic",
            "title": "Отметка с потвърждение на местоположението с едно докосване при всяко повикване"
          },
          {
            "body": "Задължителните почивки се изваждат автоматично от общото време — нищо за попълване, без грешки в заплатите.",
            "plan": "Time Basic",
            "title": "Автоматично приспадане на почивките"
          },
          {
            "body": "Конфигурирайте видове транспорт и ставки за възстановяване. Километрите се записват автоматично и се свързват с правилния клиент или проект.",
            "plan": "Add-on",
            "title": "Километри, уловени за всяко пътуване"
          },
          {
            "body": "Работниците подават болнични листове дигитално от приложението. Създайте видовете отсъствия, които екипът Ви наистина използва, включително прекъсвания заради време.",
            "title": "Управление на отсъствия и болнични листове"
          },
          {
            "body": "Всички данни за часове и километри се експортират чисто за доставчика Ви за заплати — без ръчна подготовка, без Excel.",
            "plan": "Time Basic",
            "title": "Експорт за заплати с едно кликване"
          }
        ],
        "headline": "Отчитане на времето за ВиК екипи — бърза отметка, точни заплати и доказателство за присъствие за всяко повикване",
        "workflow": [
          {
            "body": "Едно докосване го отчита. GPS регистрира местоположението и времето. Достатъчно бързо за аварийна задача.",
            "step": "ВиК специалистът пристига на повикването"
          },
          {
            "body": "Отметката за излизане затваря записа на времето. Километрите до следващата задача започват да се записват автоматично.",
            "step": "Тръгването се отбелязва на излизане"
          },
          {
            "body": "Всички повиквания, часове и километри се експортират чисто. Подготовката на заплатите се свежда от ден до минути.",
            "step": "Краят на месеца е едно кликване"
          }
        ],
        "compliance": {
          "body": "Done-it покрива всяко местно изискване за отчитане на работното време за ВиК екипи — отметка с потвърждение на местоположението с едно докосване за всяко повикване, автоматично приспадане на почивките и чист експорт за заплати. Без хартиени графици, без ръчно възстановяване.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Дигитално отчитане на работното време",
          "title": "Бърза отметка с потвърждение на местоположението за всяко повикване"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Озеленяване",
        "slug": "landscaping",
        "intro": "Пиковият сезон означава много обекти, сменящи се екипи и много километри. Done-it поддържа всеки час, всяко отсъствие и всяко пътуване организирани — за да можете да се съсредоточите върху работата, а не върху документацията.",
        "pains": [
          {
            "body": "Временни работници, променящи се графици и различни размери на екипите правят точното проследяване на часовете почти невъзможно с хартия. Докато съгласувате в края на месеца, винаги нещо липсва.",
            "title": "Сезонните екипи са сложни за управление"
          },
          {
            "body": "Екип, който посещава три или четири обекта на ден, генерира часове, които трябва да бъдат правилно разпределени. Ръчното въвеждане води до погрешно отнасяне и оспорвани заплати.",
            "title": "Часовете, разпръснати по много обекти"
          },
          {
            "body": "Принудителните прекъсвания заради лошо време са реално събитие в озеленяването. Без дигитален запис документирането на прекъсванията и коригирането на заплащането е бавно и склонно към грешки.",
            "title": "Прекъсванията заради времето са трудни за документиране"
          },
          {
            "body": "Служебни ванове, лични автомобили и споделени пътувания кръстосват между обектите цял ден. Без автоматично улавяне тези километри никога не попадат в картината на разходите.",
            "title": "Километрите между обектите не се проследяват"
          }
        ],
        "quote": {
          "who": "Собственик, фирма за озеленяване · 12 сезонни работници",
          "text": "Пиковият сезон преди означаваше хаос със заплатите. Сега бригадирът ни проверява приложението, всички са отчетени, а аз експортирам часовете в последния ден на месеца.",
          "result": "Край с възстановяването на заплатите в края на месеца"
        },
        "stats": [
          {
            "label": "улавяне на километрите — край с дневника",
            "value": "Автоматично"
          },
          {
            "label": "преглед на екипа на всички обекти",
            "value": "На живо"
          },
          {
            "label": "експорт за заплати за всички обекти и целия екип",
            "value": "1 кликване"
          }
        ],
        "features": [
          {
            "body": "Вижте целия екип, всички обекти в реално време. Знайте кой къде работи в момента — а не в края на месеца.",
            "title": "Преглед на екипа на множество обекти"
          },
          {
            "body": "Планирайте кой къде работи, справяйте се с промени в последния момент и изпращайте графика на телефоните на екипа — без обаждане до всеки човек.",
            "plan": "Time Pro",
            "title": "Планиране на смени за сезонни екипи"
          },
          {
            "body": "Създайте персонализирани видове отсъствия за Вашия сектор: сезонни прекъсвания заради времето, родителски отпуск, болнични дни. Работниците качват документация дигитално от приложението.",
            "title": "Персонализирани видове отсъствия"
          },
          {
            "body": "Конфигурирайте видове транспорт (служебен ван, личен автомобил, шофьор спрямо пътник при споделено пътуване) със собствени ставки. Километрите се записват автоматично за всяко пътуване.",
            "plan": "Add-on",
            "title": "Километри с проследяване на споделени пътувания"
          },
          {
            "body": "Извънредният труд в пиковия сезон се натрупва бързо. Всеки работник може да избере да му бъде изплатен или да натрупа часовете като почивни дни — проследявано прозрачно.",
            "plan": "Time Pro",
            "title": "Проследяване на извънредния труд с преобразуване в отпуск"
          }
        ],
        "headline": "Отчитане на времето за фирми за озеленяване — сезонни екипи, множество обекти и километри в един преглед",
        "workflow": [
          {
            "body": "GPS регистрира пристигането. Часовете се разпределят автоматично към правилното местоположение и проект — без ръчно разпределяне в края на деня.",
            "step": "Екипът се отчита на първия обект"
          },
          {
            "body": "Бригадирът регистрира прекъсването от приложението — чист дигитален запис, без допълнителна документация.",
            "step": "Времето спира работата"
          },
          {
            "body": "Часовете, отсъствията и километрите на всеки обект и за всеки член на екипа се експортират чисто за заплати.",
            "step": "Краят на месеца: всички обекти, целият екип, един експорт"
          }
        ],
        "compliance": {
          "body": "Done-it дава на екипите за озеленяване дигитално отчитане на работното време на всички обекти и за сезонния персонал — отметка с потвърждение на местоположението, персонализирани видове отсъствия за прекъсвания заради времето и чист експорт за заплати, удовлетворяващ всяко местно изискване.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Дигитално отчитане на работното време",
          "title": "Отметка с потвърждение на местоположението и проследяване на отсъствия за сезонни екипи за озеленяване"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Поддръжка",
        "slug": "maintenance",
        "intro": "Повтарящите се договори за поддръжка стоят или падат върху видимостта на разходите. Done-it регистрира всяко посещение, проследява часовете спрямо бюджета на договора и дава на Вас — и на Вашите клиенти — доказателство за присъствие за всяко повикване.",
        "pains": [
          {
            "body": "Когато часовете за повтарящи се посещения не се проследяват спрямо конкретния договор, не знаете дали даден клиент е печеливш до годишния преглед — а тогава вече е твърде късно за преоценка.",
            "title": "Няма видимост на разходите за всеки договор за поддръжка"
          },
          {
            "body": "Фасилити мениджърите и собствениците на имоти все по-често искат записи за присъствие: кой е дошъл, кога е пристигнал, какво е направил. Хартиен дневник, представен седмици по-късно, не удовлетворява изискванията на SLA.",
            "title": "Клиентите очакват доказателство за извършеното"
          },
          {
            "body": "Сменящи се смени на много повтарящи се обекти — с персонал, който се замества — създават пъзел от планиране и проследяване на часовете, който ръчните процеси не могат надеждно да решат.",
            "title": "Повтарящите се посещения са трудни за планиране и регистриране"
          },
          {
            "body": "Поддръжката на зелени площи, фасадите и съоръженията на открито всички са изправени пред прекъсвания заради времето. Правилното им документиране изисква дигитална следа.",
            "title": "Прекъсванията заради времето засягат и поддръжката на открито"
          }
        ],
        "quote": {
          "who": "Оперативен директор, фирма за поддръжка · 8 работници",
          "text": "Можем да кажем на фасилити мениджъра точно кой е бил на обекта и кога, за две минути. Това ниво на доказателство промени начина, по който клиентите ни възприемат.",
          "result": "Клиентските спорове сведени до нула"
        },
        "stats": [
          {
            "label": "себестойност за всеки договор за поддръжка",
            "value": "На живо"
          },
          {
            "label": "доказателство за присъствие, готово за клиентите при поискване",
            "value": "GPS"
          },
          {
            "label": "подновявания на договори без да знаете маржа си",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Всеки договор за поддръжка е проект. Часовете се записват автоматично спрямо него, давайки Ви стойност на разходите на живо и обратно отброяване на оставащите часове за всеки клиент.",
            "plan": "Project Basic",
            "title": "Проследяване на разходите на база договор"
          },
          {
            "body": "Отметките с времеви печат и потвърждение на местоположението са неоспорим запис кой е бил на обекта, кога и за колко време — готов за споделяне с клиентите при поискване.",
            "title": "Доказателство за присъствие, потвърдено с GPS"
          },
          {
            "body": "Работниците докладват проблеми, изпълнени задачи или допълнителна работа директно от приложението — с текст и снимки. Клиентите получават запис в реално време; Вие разполагате с документацията за фактуриране.",
            "plan": "Project Basic",
            "title": "Актуализации със снимки от обекта"
          },
          {
            "body": "Планирайте повтарящите се посещения по всички договори, разпределяйте работници и се справяйте със замествания — без обаждане до всеки човек.",
            "plan": "Time Pro",
            "title": "Планиране на повтарящи се смени"
          },
          {
            "body": "Конфигурирайте прекъсвания заради времето и други видове отсъствия. Работниците ги регистрират от приложението; документацията се качва дигитално.",
            "title": "Видове отсъствия за поддръжка на открито"
          }
        ],
        "headline": "Отчитане на времето за екипи по поддръжка — повтарящи се посещения на обекти, себестойност на договор и доказателство за присъствие в едно приложение",
        "workflow": [
          {
            "body": "Отметката с потвърждение на местоположението регистрира часа на пристигане и свързва часовете с правилния договор. Доказателството за присъствие се създава автоматично.",
            "step": "Работникът пристига на обекта за поддръжка"
          },
          {
            "body": "Извършената работа и всички проблеми се докладват от приложението със снимки. Клиентите могат да видят точно какво е било направено.",
            "step": "Задачите изпълнени, проблемите регистрирани"
          },
          {
            "body": "Часовете се натрупват спрямо бюджета на договора в реално време. Знаете маржа, преди договорът да се поднови.",
            "step": "Себестойността за всеки договор е видима веднага"
          }
        ],
        "compliance": {
          "body": "Done-it дава на екипите по поддръжка доказателство за присъствие, потвърдено с GPS за всеки договор, персонализирани видове отсъствия и преглед на разходите на живо за всеки повтарящ се клиент — удовлетворявайки всяко местно изискване за отчитане на работното време без допълнителен хардуер.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Проследяване на времето на база договор",
          "title": "Видимост на разходите на живо за всеки договор за поддръжка"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Магазини и търговия",
        "slug": "retail",
        "intro": "Отваряща смяна, късна смяна и вечно някой замества някого. Done-it дава на всеки магазин чист цифров запис кой каква смяна е работил — чекиране от собствения телефон, готово за заплатите в края на месеца.",
        "pains": [
          {
            "body": "Някой покрива болен колега, друг остава час повече при затваряне. Записва се на листче или изобщо не се записва — и заплатите са грешни още преди да сте започнали.",
            "title": "Заместванията не стигат до ведомостта"
          },
          {
            "body": "Хората се местят между обектите, работещите на непълно време покриват по два адреса. Събирането на часовете по магазин и ръчното им сливане отнема по един ден всеки месец.",
            "title": "Няколко магазина, една ведомост"
          },
          {
            "body": "Задължителните почивки се приспадат по памет, а допълнителните часове се уреждат неформално — точно двете неща, за които проверката пита първо.",
            "title": "Почивките и извънредните часове са на око"
          }
        ],
        "quote": {
          "who": "Собственик, търговия · 11 служители",
          "text": "Два магазина и много хора на непълно време. Преди половината заместващи смени се уреждаха по памет. Сега всеки час е на правилния магазин и заплатите отнемат минути.",
          "result": "Подготовката за заплати — от ден на под час"
        },
        "stats": [
          {
            "label": "за чекиране — без терминал на касата",
            "value": "1 докосване"
          },
          {
            "label": "кой е на работа, във всички магазини",
            "value": "На живо"
          },
          {
            "label": "загубени замествания между щанда и ведомостта",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Едно докосване на собствения телефон в началото на смяната. Без терминал на касата, без обща карта, без списък на вратата на склада.",
            "title": "Чекиране направо в магазина"
          },
          {
            "body": "Всеки магазин е отделен проект. Който покрива друг обект, се чекира към този обект — виждате часовете там, където наистина са отработени.",
            "title": "Часове по магазин, хора между обектите"
          },
          {
            "body": "Задавате правилото за почивка веднъж и то важи за всяка смяна. Извънредният труд се записва в момента, в който възникне, а всеки служител избира изплащане или отгул.",
            "title": "Автоматично приспадане на почивките"
          }
        ],
        "headline": "Отчитане на работното време за магазини — чекиране на смяна, замествания и експорт, готов за заплати, в едно приложение",
        "workflow": [
          {
            "body": "Едно докосване на телефона в началото на смяната. Заместването в друг обект се отчита към него.",
            "step": "Хората се чекират за смяната"
          },
          {
            "body": "Изглед в реално време за всички обекти — забелязвате незапълнена отваряща смяна, преди вратите да се отворят.",
            "step": "Виждате кой е на работа, по магазини"
          },
          {
            "body": "Часове, почивки и извънреден труд по служител и по магазин, експортирани готови за счетоводството.",
            "step": "Заплатите с един експорт"
          }
        ],
        "compliance": {
          "body": "Done-it пази обективен цифров запис на всяко започване и приключване на работа, с почивките и извънредните часове — записът, който одит или спор за заплата изисква.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отчитане на времето по смени",
          "title": "Защитим запис за всяка отработена смяна"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Офиси и професионални услуги",
        "slug": "offices",
        "intro": "Счетоводители, нотариуси, архитекти, агенции и консултанти таксуват времето си — или поне трябва да знаят къде е отишло. Done-it записва часовете към правилния клиент и проект, от бюрото или на път.",
        "pains": [
          {
            "body": "Време, записано в края на седмицата, е време по предположение. Цели часове тихо изчезват между работата и фактурата.",
            "title": "Часовете за фактуриране, възстановени в петък"
          },
          {
            "body": "Хонорарът е договорен преди месеци. Дали работата още се събира в него, става ясно едва когато някой седне да сметне — обикновено твърде късно.",
            "title": "Никой не знае колко наистина струва един клиент"
          },
          {
            "body": "Част от екипа е в офиса, част у дома, част при клиента. Присъствието спира да е факт и се превръща в реконструкция.",
            "title": "Хибридната работа прави записа на парче"
          }
        ],
        "quote": {
          "who": "Съдружник, счетоводна кантора · 8 служители",
          "text": "Преди възстановявахме цялата седмица всеки петък. Сега часовете вече са при правилния клиент и виждам кои преписки изяждат хонорара.",
          "result": "Възстановени часове за фактуриране всеки месец"
        },
        "stats": [
          {
            "label": "часове, видими още докато работата тече",
            "value": "По клиент"
          },
          {
            "label": "един и същ запис, телефон и браузър",
            "value": "Офис или път"
          },
          {
            "label": "за заплати и фактуриране",
            "value": "1 експорт"
          }
        ],
        "features": [
          {
            "body": "Всеки запис попада в проект, така че виждате часовете по клиент, без да експортирате нищо и без да питате никого.",
            "title": "Часове към клиент и проект"
          },
          {
            "body": "Едно и също приложение на телефона или в браузъра. Посещението при клиент се отчита като работа по този клиент, включително пътуването, ако искате.",
            "title": "Работи на бюрото и извън офиса"
          },
          {
            "body": "Допълнителните часове се записват в момента, отпуските се заявяват и одобряват в приложението — без паралелна таблица кой кога отсъства.",
            "title": "Извънреден труд и отпуски на едно място"
          }
        ],
        "headline": "Отчитане на времето за офиси — часове по клиент и проект, без електронна таблица",
        "workflow": [
          {
            "body": "Настройвате го веднъж — клиента и, ако таксувате по бюджет, планираните часове.",
            "step": "Отваряте проект за клиента"
          },
          {
            "body": "От бюрото или от телефона. Всеки час попада при клиент, а не в нечия памет.",
            "step": "Екипът записва времето си към него"
          },
          {
            "body": "Текущи суми по проект и чист експорт за заплати или фактуриране в края на месеца.",
            "step": "Виждате часовете по клиент, експортирате за заплати"
          }
        ],
        "compliance": {
          "body": "Done-it пази цифров запис на работното време по служител, защитен от подмяна — основата както за заплатите, така и за защитима фактура към клиента.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отчитане на времето по клиенти",
          "title": "Обективен запис на отработените часове"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Салони и грижа за тялото",
        "slug": "beauty",
        "intro": "Фризьорските, бръснарските, маникюрните и козметичните студиа работят на смени и на непълно работно време. Done-it записва кой кога е работил, приспада почивките автоматично и подава на счетоводството чист файл.",
        "pains": [
          {
            "body": "Три дни едната седмица, четири следващата, събота, разменена за вторник. Договорените и отработените часове се разминават бързо.",
            "title": "Договори на непълно време, безброй варианти"
          },
          {
            "body": "Записаните часове показват какво е било запазено, не кой е работил. Когато счетоводството или проверка попита, системата за резервации е грешният отговор.",
            "title": "Тефтерът с часовете не е отчет на работното време"
          },
          {
            "body": "Оставането за последен клиент се помни, обещава се и понякога се забравя. Точно от такива пропуски тръгват споровете.",
            "title": "Допълнителните часове се уреждат неформално"
          }
        ],
        "quote": {
          "who": "Собственик, фризьорски салон · 6 служители",
          "text": "Всички са на непълно време и всяка седмица е различна. Приложението просто го записва — спрях да сглобявам месеца в таблица.",
          "result": "Край на спорните часове в края на месеца"
        },
        "stats": [
          {
            "label": "за чекиране — нищо общо, нищо на хартия",
            "value": "1 докосване"
          },
          {
            "label": "приспадане на почивката при всяка смяна",
            "value": "Авто"
          },
          {
            "label": "късни часове, уредени по памет",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Едно докосване на собствения телефон в началото на смяната — без общ терминал на рецепцията, без списък за подпис до огледалото.",
            "title": "Чекиране в салона"
          },
          {
            "body": "Задавате правилото за почивка и стандартните часове веднъж; важат за всяка смяна, с изключения по човек, където договорът е различен.",
            "title": "Почивки и правила за непълно време — веднъж"
          },
          {
            "body": "Допълнителните часове се записват докато се работят и всеки служител избира изплащане или отгул — уредено в приложението, не по памет.",
            "title": "Извънреден труд — платен или взет като отгул"
          }
        ],
        "headline": "Отчитане на времето за салони — смени, часове на непълно време и заплати без хартиен тефтер",
        "workflow": [
          {
            "body": "Едно докосване при идване. Почивките се приспадат по правилото, което сте задали веднъж.",
            "step": "Хората се чекират за смяната"
          },
          {
            "body": "Кой е на работа, кой е в почивка, кой е останал по-късно — на живо, без да питате.",
            "step": "Виждате деня в движение"
          },
          {
            "body": "Отработени часове, почивки и извънреден труд по служител, експортирани за обработката на заплатите.",
            "step": "Счетоводството получава чист файл"
          }
        ],
        "compliance": {
          "body": "Done-it записва реалното работно време по служител, с почивките и извънредния труд — отделно от резервациите и защитимо при проверка.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Цифрово отчитане на времето",
          "title": "Запис, който важи и извън тефтера с часовете"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Здраве и уелнес",
        "slug": "wellness",
        "intro": "Фитнес залите, студиата, физиотерапевтичните практики и спа центровете работят с дълго работно време и сменящ се персонал. Done-it записва кой коя смяна е покрил, приспада почивките автоматично и експортира заплатите чисто.",
        "pains": [
          {
            "body": "Ранни смени, вечерни тренировки и уикенди, покривани от смес от щатни, почасови и външни специалисти. Графикът е план, не отчет.",
            "title": "Дълго работно време, постоянни замествания"
          },
          {
            "body": "Инструктор води две тренировки и междувременно поема рецепцията. Да го платите правилно значи да знаете какво е отработено, а не какво е било планирано.",
            "title": "Часовете в залата и на рецепцията се смесват"
          },
          {
            "body": "Хората се местят между студиата. Ръчното сливане на часовете им всеки месец е бавно и води до грешки.",
            "title": "Няколко обекта, една администрация"
          }
        ],
        "quote": {
          "who": "Мениджър, фитнес студио · 14 служители",
          "text": "Две студиа, дълго работно време и много заместващи смени. Сега часовете попадат в правилния обект и заплатите са един файл.",
          "result": "Графикът и заплатите най-накрая съвпадат"
        },
        "stats": [
          {
            "label": "часове, дори когато хората заместват другаде",
            "value": "По студио"
          },
          {
            "label": "изглед на залата във всички обекти",
            "value": "На живо"
          },
          {
            "label": "почивки и извънреден труд, без ръчни сметки",
            "value": "Авто"
          }
        ],
        "features": [
          {
            "body": "Едно докосване на телефона в обекта, където работят. Заместването в друго студио попада в часовете на това студио.",
            "title": "Чекиране по студио"
          },
          {
            "body": "Виждате залата във всички обекти в реално време — незапълнена ранна смяна се вижда преди отварянето, а не след това.",
            "title": "Изглед на живо кой е на работа"
          },
          {
            "body": "Правилата за почивка се прилагат автоматично, допълнителните часове се записват в момента, с изплащане или отгул по избор на служителя.",
            "title": "Почивките и извънредният труд — решени"
          }
        ],
        "headline": "Отчитане на времето за фитнеси, студиа и спа центрове — смени, тренировки и заплати в едно приложение",
        "workflow": [
          {
            "body": "Едно докосване в началото на смяната, в обекта, където работят.",
            "step": "Хората се чекират в студиото"
          },
          {
            "body": "Кой е на работа и в кой обект в момента, за да запълните дупките, преди клиентите да ги усетят.",
            "step": "Заместванията се виждат на живо"
          },
          {
            "body": "Часове, почивки и извънреден труд по служител и по студио, готови за счетоводството.",
            "step": "Един експорт за заплатите"
          }
        ],
        "compliance": {
          "body": "Done-it пази цифров запис на работното време по служител и по обект — основата за правилно заплащане и за всяка проверка на отработените часове.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отчитане на смени в няколко обекта",
          "title": "Обективен запис за всяка смяна и всеки обект"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Ресторанти и хотели",
        "slug": "hospitality",
        "intro": "Разкъсани смени, късни затваряния и събота, която се проточва. Done-it записва часовете така, както са отработени, приспада почивките по вашето правило и дава на счетоводството един чист файл.",
        "pains": [
          {
            "body": "Обслужването се проточва, затварянето отнема още половин час. Тези минути са реална работа, а уреждането им по памет е началото на споровете.",
            "title": "Смяната никога не свършва, когато казва графикът"
          },
          {
            "body": "Обяд, почивка, после вечеря. На хартия става един дълъг блок или две предположения — нито едното не е истината.",
            "title": "Разкъсаните смени трудно се отчитат"
          },
          {
            "body": "Нови хора всеки сезон. Система, която изисква обучение, няма да оцелее и една натоварена седмица.",
            "title": "Голямо текучество, постоянно обучение"
          }
        ],
        "quote": {
          "who": "Собственик, ресторант · 17 служители",
          "text": "Затварянето винаги се проточва. Сега тези минути се записват, вместо да се спори за тях, и хората могат да си ги вземат като отгул.",
          "result": "По-малко спорове, по-бързи заплати"
        },
        "stats": [
          {
            "label": "записани като два блока, не като едно предположение",
            "value": "Разкъсани смени"
          },
          {
            "label": "приспадане на почивката по вашето правило",
            "value": "Авто"
          },
          {
            "label": "за въвеждане на нов човек — това е собственият му телефон",
            "value": "1 мин"
          }
        ],
        "features": [
          {
            "body": "Едно докосване в началото и края на всеки блок, така че разкъсаните смени се записват както са протекли — а не слети в една.",
            "title": "Чекиране в началото и края на всяко обслужване"
          },
          {
            "body": "Задължителните почивки се приспадат автоматично, с изключения по човек, където договорът го изисква. Без ръчни сметки в края на месеца.",
            "title": "Почивки по вашето правило"
          },
          {
            "body": "Допълнителният половин час след затваряне се записва в момента, в който е отработен, и се изплаща или се взема като отгул — служителят избира.",
            "title": "Извънредният труд се урежда в приложението"
          }
        ],
        "headline": "Отчитане на времето за кафенета, ресторанти и хотели — смени, почивки и извънреден труд, уредени честно",
        "workflow": [
          {
            "body": "Едно докосване в началото на блока, същото в края. Разкъсаните смени остават разделени.",
            "step": "Хората се чекират за обслужването"
          },
          {
            "body": "Кой е на смяна за довечера, кой е още в почивка, кой е останал след затварянето.",
            "step": "Виждате залата на живо"
          },
          {
            "body": "Отработено време, почивки и извънреден труд по служител, експортирани в един файл.",
            "step": "Счетоводството получава реалните часове"
          }
        ],
        "compliance": {
          "body": "Done-it пази обективен цифров запис на всяка смяна, почивка и допълнителен час — точно това, което проверка на заплатите или инспекция по труда иска да види.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отчитане на разкъсани смени",
          "title": "Защитим запис на часовете при голямо текучество"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Здравеопазване и грижа",
        "slug": "healthcare",
        "intro": "Практиките, екипите за домашни грижи и домовете за възрастни работят на смени, посещения и стриктна документация. Done-it отчита отработеното време по смяна и по посещение и пази документите на служителите там, където ще ги намерите.",
        "pains": [
          {
            "body": "Домашните посещения са в един инструмент, графикът — в друг, а счетоводството получава трета версия. Изравняването им е месечна задача.",
            "title": "Посещенията и смените са в различни системи"
          },
          {
            "body": "Нощният труд и уикендите имат различни ставки. Когато записът е приблизителен, такова е и заплащането — а корекцията идва по-късно.",
            "title": "Нощните и почивните часове се плащат грешно"
          },
          {
            "body": "Квалификациите и сертификатите имат значение в грижата, а стоят в папка, която никой не отваря до първата проверка.",
            "title": "Сертификатите изтичат незабелязано"
          }
        ],
        "quote": {
          "who": "Координатор, екип за домашни грижи · 22 служители",
          "text": "Домашните посещения и смените по график най-накрая са в един запис. Заплатите спряха да бъдат упражнение по изравняване.",
          "result": "Един запис вместо три"
        },
        "stats": [
          {
            "label": "или по смяна — както работи вашият екип",
            "value": "По посещение"
          },
          {
            "label": "нощни и почивни часове, записани както са отработени",
            "value": "Разделени"
          },
          {
            "label": "сертификати, съхранени по служител",
            "value": "Подредени"
          }
        ],
        "features": [
          {
            "body": "Едно докосване в началото на смяната или на всеки адрес при домашни грижи — с потвърдено местоположение там, където ви трябва доказателство.",
            "title": "Чекиране по смяна или по посещение"
          },
          {
            "body": "Нощните, почивните и редовните часове се записват поотделно, така че експортът за заплати вече отразява как работата реално се плаща.",
            "title": "Часовете, разделени както ги плащате"
          },
          {
            "body": "Договори, сертификати и документи за самоличност се пазят при човека, за когото се отнасят — намират се за секунди, когато някой ги поиска.",
            "title": "Документите на служителите на едно място"
          }
        ],
        "headline": "Отчитане на времето за екипи в грижата — смени, домашни посещения и квалификации, в един запис",
        "workflow": [
          {
            "body": "Едно докосване в обекта или на адреса на клиента, с потвърдено местоположение там, където трябва доказателство.",
            "step": "Чекиране за смяната или посещението"
          },
          {
            "body": "Редовните, нощните и почивните часове се записват поотделно, в момента на възникване.",
            "step": "Часовете попадат в правилната категория"
          },
          {
            "body": "Един чист файл за период, вече разделен така, както плащате.",
            "step": "Експорт за заплатите"
          }
        ],
        "compliance": {
          "body": "Done-it пази цифров, обективен запис на работното време по служител — часове, почивки и разделение на нощния и почивния труд — заедно с документите, които вървят с всеки човек.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Отчитане на смени и посещения",
          "title": "Записи, които издържат проверка"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "tr": [
      {
        "name": "İnşaat",
        "slug": "construction",
        "intro": "Ekipler farklı şantiyelere dağılmış, saatler kâğıda karalanmış, taşeron saatlerini mutabık kılmak imkânsız. Done-it her şantiyeye, bordronuzu tek tıkla besleyen kusursuz bir dijital zaman çizelgesi sunar.",
        "pains": [
          {
            "body": "Birden fazla aktif şantiye ve dönüşümlü ekiplerle, manuel zaman çizelgeleri doğası gereği hatalıdır. Çalışanlar saatleri yukarı yuvarlar, kayıtları unutur veya günler sonra doldurur — elinizde savunamayacağınız bordro rakamları kalır.",
            "title": "Kimin nerede çalıştığına dair güvenilir bir kayıt yok"
          },
          {
            "body": "Bir şantiyenin planlanan saatlerini tükettiğini fark ettiğinizde, kâr marjı çoktan kaybolmuştur. Canlı bir geri sayım yoktur — yalnızca fatura zamanında kötü bir sürpriz vardır.",
            "title": "Bütçe aşımları çok geç fark edilir"
          },
          {
            "body": "Zaman çizelgelerini toplamak, bunları projelerle mutabık kılmak ve bordro dışa aktarımını hazırlamak günler sürer. Her kayıt potansiyel bir hatadır.",
            "title": "Bordro hazırlığı her ay saatler alıyor"
          }
        ],
        "quote": {
          "who": "Sahip, inşaat şirketi · 14 çalışan",
          "text": "Ekibimiz şantiyede kendileri giriş yapıyor. Ay sonunda bordro kendiliğinden toplanıyor — zaman çizelgelerinin peşinde koşmayı tamamen bıraktık.",
          "result": "Haftada idari işlerde 5 saat tasarruf"
        },
        "stats": [
          {
            "label": "herhangi bir şantiyeye giriş yapmak için — terminal yok, kâğıt yok",
            "value": "1 dokunuş"
          },
          {
            "label": "sağlayıcınız için hazır bordro dışa aktarımı",
            "value": "1 tık"
          },
          {
            "label": "proje ve şantiye başına kalan saat görünümü",
            "value": "Canlı"
          }
        ],
        "features": [
          {
            "body": "Tek dokunuş çalışanı konum doğrulamalı olarak giriş yaptırır ve saatleri doğru projeye bağlar. Kart okuyucu yok, terminal yok — yalnızca ekibinizin zaten taşıdığı akıllı telefon.",
            "title": "Şantiye başına konum doğrulamalı giriş"
          },
          {
            "body": "Projeyi açtığınızda planlanan saatleri bir bütçe olarak belirleyin. Çalışanlar kalan saatlerin geri sayımını görür; siz bunu panonuzda canlı olarak görürsünüz. Bütçe aşımları olmadan önce görünür hale gelir.",
            "title": "Proje başına canlı kalan saat"
          },
          {
            "body": "Bir projeye taşeronları ekleyin, onları girişe atayın ve saatlerini kendi ekibinizle birlikte takip edin — aynı genel görünümde.",
            "title": "Taşeron yönetimi ve mevcudiyet"
          },
          {
            "body": "Kaydedilen tüm saatler — çalışan başına, proje başına — bordro sağlayıcınız için temiz bir tabloya aktarılır. Manuel hazırlık yok, hata yok.",
            "title": "Tek tıkla bordro dışa aktarımı"
          }
        ],
        "headline": "İnşaat ekipleri için zaman takibi — konum doğrulamalı giriş, proje saatleri ve bütçe kontrolü, tek bir uygulamada",
        "workflow": [
          {
            "body": "Her çalışan giriş yapmak için bir kez dokunur. GPS konumu doğrular, kaydı zaman damgasıyla işaretler ve saatleri projeye bağlar. Kâğıt yok, terminal yok.",
            "step": "Ekip şantiyeye varır"
          },
          {
            "body": "Saatler, kalan bütçe, taşeron mevcudiyeti ve şantiyeden bildirilen her türlü ek iş — hepsi panonuzda, gerçek zamanlı.",
            "step": "Her şeyi canlı görürsünüz"
          },
          {
            "body": "Tüm saatleri çalışan ve proje başına dışa aktarın. Bordro sağlayıcınıza gönderin. Done-it, denetime hazır temiz raporları otomatik olarak üretir.",
            "step": "Ay sonu dakikalar içinde"
          }
        ],
        "compliance": {
          "body": "Done-it, inşaat ekipleri için konum doğrulamalı giriş, proje bazlı zaman takibi ve temiz bir bordro dışa aktarımı sağlar. Belçika şantiyelerinde faaliyet gösteren ekipler için, işyeri girişini de otomatik olarak besler.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman kaydı",
          "title": "İnşaat şantiyeleri için tasarlanmış konum doğrulamalı giriş"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Temizlik",
        "slug": "cleaning",
        "intro": "Temizlikçiler gün boyu lokasyonlar arasında hareket eder. Done-it kimin nerede olduğunu gerçek zamanlı takip eder — her lokasyonda konum doğrulamalı giriş, otomatik mola düşümü ve ay sonunda temiz bir bordro dışa aktarımı.",
        "pains": [
          {
            "body": "Müşteriler ve müfettişler kusursuz mevcudiyet kayıtları bekler. Manuel formlara itiraz edilebilir; konum doğrulamalı dijital girişlere edilemez.",
            "title": "Her lokasyonda mevcudiyeti kanıtlamak"
          },
          {
            "body": "Temizlikçiler gün boyu lokasyonlar arasında hareket ederken, kimin nerede çalıştığına dair canlı bir görünümünüz olmaz — biri arayana kadar.",
            "title": "Ekipler birçok lokasyona dağılmış"
          },
          {
            "body": "Doğru giriş/çıkış saatleri olmadan, bordro hafızadan yeniden oluşturulur. Saatler yukarı yuvarlanır, maliyetler şişer ve anlaşmazlıklar takip eder.",
            "title": "Yuvarlanan saatlerden kaynaklanan bordro hataları"
          }
        ],
        "quote": {
          "who": "Müdür, temizlik şirketi · 9 çalışan",
          "text": "Sonunda kimin nerede ve ne zaman temizlik yaptığını kanıtlayabiliyoruz. Artık mevcudiyet formları yok, müşteri anlaşmazlıkları yok — GPS bunu hallediyor.",
          "result": "Saatlerde sıfır yukarı yuvarlama"
        },
        "stats": [
          {
            "label": "herhangi bir lokasyona giriş yapmak için — terminale gerek yok",
            "value": "1 dokunuş"
          },
          {
            "label": "şu anda kimin hangi sahada olduğu görünümü",
            "value": "Canlı"
          },
          {
            "label": "çift giriş — saatler doğrudan bordroya akar",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Çalışanlar her lokasyonda telefonlarından konum doğrulamalı olarak giriş ve çıkış yapar; saat tam olarak, mola kaydıyla birlikte tutulur.",
            "plan": "Time Basic",
            "title": "Gerçek zamanlı giriş ve çıkış"
          },
          {
            "body": "Zorunlu molalar çalışma gününden otomatik olarak düşülür — manuel hesap yok, anlaşmazlık yok.",
            "plan": "Time Basic",
            "title": "Otomatik mola düşümü"
          },
          {
            "body": "Hangi temizlikçinin şu anda hangi lokasyonda olduğunu görün. Müşterilerden önce boşlukları fark edin.",
            "title": "Çoklu lokasyon canlı genel görünümü"
          },
          {
            "body": "Çalışanlar hastalık raporlarını ve devamsızlık belgelerini doğrudan uygulamadan yükler. Ekibinizin gerçekten kullandığı devamsızlık türlerini oluşturun.",
            "title": "Dijital hastalık raporlarıyla devamsızlık kaydı"
          },
          {
            "body": "Tam zaman damgaları doğrudan sağlayıcınız için bordroya hazır bir dışa aktarıma akar. Kopyalama yok, hata yok.",
            "title": "Tek tıkla bordro dışa aktarımı"
          }
        ],
        "headline": "Temizlik şirketleri için zaman takibi — konum doğrulamalı giriş, mevcudiyet kanıtı ve bordro tek bir uygulamada",
        "workflow": [
          {
            "body": "Tek dokunuş onları giriş yaptırır. GPS sahayı kaydeder ve girişi zaman damgasıyla işaretler. Mola kaydı uygulamaya yerleşiktir.",
            "step": "Temizlikçi lokasyona varır"
          },
          {
            "body": "Şu anda kimin hangi sahada olduğu — telefon görüşmesi yok, tahmin yok. Müşterilerden önce kapsama boşluklarını fark edin.",
            "step": "Her lokasyonu canlı görürsünüz"
          },
          {
            "body": "Tüm mevcudiyet verileri — tam saatler, lokasyonlar ve molalar — bordro sağlayıcınız için temiz bir şekilde dışa aktarılır.",
            "step": "Bordro tek tıktır"
          }
        ],
        "compliance": {
          "body": "Done-it, temizlik ekiplerine her lokasyonda konum doğrulamalı giriş, otomatik mola düşümü ve şu anda kimin hangi sahada olduğuna dair canlı bir görünüm sunar.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Konum doğrulamalı mevcudiyet",
          "title": "Her temizlik lokasyonunda gerçek zamanlı mevcudiyet"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Montaj",
        "slug": "installation",
        "intro": "Montajcılarınızı ihtiyaç duydukları her şeyle birlikte doğru adrese gönderin, çalışılan her saati otomatik olarak doğru işe bağlayın ve saha kapanmadan önce kalan bütçeyi görün. Done-it, montaj projelerini zamanında ve bütçede tutmanın en basit yoludur.",
        "pains": [
          {
            "body": "Ekipler bir sahaya adres, irtibat kişisi veya kapsam ayrıntıları olmadan varır. O ilk telefon görüşmesi, tek bir saat çalışılmadan önce kaybedilen on dakikalık faturalandırılabilir zamandır.",
            "title": "İş bilgisi sahaya zamanında ulaşmıyor"
          },
          {
            "body": "Çalışanlar saatlerini gün sonunda manuel olarak doldurduğunda — eğer doldururlarsa — saatler yanlış işe düşer veya tamamen kaybolur. Faturalar gerçekle örtüşmez.",
            "title": "Saatler doğru projeye bağlanmıyor"
          },
          {
            "body": "Proje başına kalan saatlerin canlı bir geri sayımı olmadan, bir işin bütçeyi aştığını faturayı kapattığınızda öğrenirsiniz — hâlâ tepki verebileceğiniz zaman değil.",
            "title": "Bütçe aşımları çok geç fark edilir"
          },
          {
            "body": "Aynı sahada çalışan taşeronlar farklı sistemler kullanır, saatleri ayrı doldurur veya hiç doldurmaz. Ay sonunda mutabakat yavaş, hataya açık bir süreçtir.",
            "title": "Taşeron saatlerini takip etmek zor"
          }
        ],
        "quote": {
          "who": "Sahip, montaj şirketi · 6 çalışan",
          "text": "Saatler otomatik olarak doğru projeye düşüyor. İş maliyetlendirmesi birden kolaylaştı — bir işi kapatmadan önce gerçek kâr marjını görebiliyoruz.",
          "result": "İş başına gerçek maliyet, canlı"
        },
        "stats": [
          {
            "label": "proje başına kalan saat görünümü",
            "value": "Gerçek zamanlı"
          },
          {
            "label": "saha adresleri için ofis telefonu",
            "value": "0"
          },
          {
            "label": "uygulamadan herhangi bir proje adresine yol tarifi",
            "value": "1 tık"
          }
        ],
        "features": [
          {
            "body": "Çalışanlar projeyi telefonlarında açar: adres, planlanan saatler, irtibat kişisi ve yüklenen dosyalar (planlar, talimatlar, PDF'ler). İhtiyaç duydukları her şey varmadan önce oradadır.",
            "plan": "Project Basic",
            "title": "Proje bilgisi doğrudan uygulamaya paylaşılır"
          },
          {
            "body": "Bir kez dokunun ve telefon proje adresine yönlendirir — uygulamaya yerleşik, ayrı bir harita uygulamasına gerek yok.",
            "title": "Sahaya tek tuşla navigasyon"
          },
          {
            "body": "Projeyi açtığınızda planlanan saatleri belirleyin. Çalışanlar kaç saat kaldığını görür; siz canlı durumu panonuzda görürsünüz. Aşımlar olmadan önce görünür hale gelir.",
            "plan": "Project Basic",
            "title": "Proje başına kalan saat geri sayımı"
          },
          {
            "body": "Her çalışan doğru projeye giriş yapar. Şu anda kimin hangi sahada olduğunu her zaman bilirsiniz.",
            "plan": "Project Basic",
            "title": "Proje başına çalışan girişi"
          },
          {
            "body": "Sahada kapsam genişlediğinde, çalışanlar ek iş ve malzemeleri gerçek zamanlı olarak — metin ve fotoğraflarla — kaydeder, böylece hiçbir şey hafızadan faturalandırılmaz.",
            "plan": "Project Basic",
            "title": "Ek iş ve malzeme kaydı"
          }
        ],
        "headline": "Montaj ekipleri için zaman takibi — proje saatleri, navigasyon ve bütçe kontrolü tek bir uygulamada",
        "workflow": [
          {
            "body": "Adres, irtibat, kapsam ve dosya yüklemeleri tam orada. Tek dokunuşla yol tarifi alırlar — yön sormak için ofise telefon yok.",
            "step": "Çalışan projeyi telefonunda açar"
          },
          {
            "body": "Giriş, çalışılan her dakikayı doğru projeye bağlar. Kalan bütçe gerçek zamanlı güncellenir.",
            "step": "Saatler otomatik olarak doğru işe kaydedilir"
          },
          {
            "body": "Kapsam değişiklikleri, ek malzemeler ve gecikmeler oldukları anda metin ve fotoğraflarla kaydedilir — fatura için hazır.",
            "step": "Ek iş sahada yakalanır"
          }
        ],
        "compliance": {
          "body": "Done-it, montaj ekiplerine proje başına konum doğrulamalı giriş, canlı kalan saat geri sayımı ve otomatik bordro dışa aktarımı sunar — her türlü yerel zaman kaydı gerekliliğini karşılar. Belçika inşaat şantiyelerinde çalışan ekipler için, CheckIn@Work ile de entegre olur.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman kaydı",
          "title": "Montaj ekipleri için proje başına konum doğrulamalı giriş"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Saha servisi",
        "slug": "field-service",
        "intro": "Günde birden fazla müşteriyi ziyaret eden teknisyenler, torpido gözündeki fişler, hafızadan kaydedilen kilometreler. Done-it saatleri, kilometreleri ve masrafları sahada yakalar — oldukları anda doğru işe bağlı olarak.",
        "pains": [
          {
            "body": "Teknisyenlerden rotalarını hafta sonunda yeniden oluşturmalarını istemek, hatalı geri ödemeler, müşterilerle anlaşmazlıklar ve giderek büyüyen bir talep edilmemiş kilometre yığını anlamına gelir.",
            "title": "Kilometreler günler sonra kaydedilir — eğer kaydedilirse"
          },
          {
            "body": "Torpido gözündeki bir fiş, asla bir faturaya yansımayabilecek bir maliyettir. İş başına gerçek maliyet her zaman olduğundan az hesaplanır.",
            "title": "Kaybolan kâğıt fişlerdeki masraflar"
          },
          {
            "body": "Canlı girişler olmadan, bir teknisyenin nerede olduğunu yalnızca bir şeyler ters gittiğinde ve biri aradığında öğrenirsiniz.",
            "title": "Ekibin nerede olduğuna dair gerçek zamanlı görünüm yok"
          },
          {
            "body": "İşçilik, seyahat ve masraflar ayrı sistemlerde takip edildiğinde — veya hiç takip edilmediğinde — iş başına tek bir maliyet rakamı asla olmaz.",
            "title": "İş başına gerçek kâr marjını görmek zor"
          }
        ],
        "quote": {
          "who": "Operasyon müdürü, saha servisi şirketi · 11 çalışan",
          "text": "Kilometre eskiden aylık bir baş ağrısıydı. Artık kendiliğinden kaydediliyor — biz daha ofise dönmeden her kilometre doğru müşteriye bağlanmış oluyor.",
          "result": "Her seferinde iş başına doğru maliyet"
        },
        "stats": [
          {
            "label": "kilometre yakalama — manuel kayıt defteri yok",
            "value": "Otomatik"
          },
          {
            "label": "iş başına maliyet: saatler + seyahat + masraflar",
            "value": "Canlı"
          },
          {
            "label": "kaybolan kilometre — her yolculuk otomatik yakalanır",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS her yolculuk için kalkış, varış ve tam mesafeyi kaydeder. Ulaşım türlerini (kendi aracı, şirket aracı, ortak araç) kendi geri ödeme oranlarıyla yapılandırın. Manuel kayıt defteri yok.",
            "plan": "Add-on",
            "title": "Otomatik kilometre yakalama (Trax-it)"
          },
          {
            "body": "Çalışanlar sahada bir fişin fotoğrafını çeker; işe bağlanır ve geri ödemeye hazır olur — ay sonunda peşinde koşulmaz.",
            "plan": "Time Basic",
            "title": "Sahada masraf yönetimi"
          },
          {
            "body": "Saatler, kilometreler ve masraflar gerçek zamanlı olarak işe yansır. İş başına maliyet, iş hâlâ açıkken görünür.",
            "plan": "Project Basic",
            "title": "Projeye bağlı maliyet kontrolü"
          },
          {
            "body": "Her teknisyen müşteri sahasında giriş yapar. Kimin nerede olduğunu şu anda görürsünüz — telefon yok, tahmin yok.",
            "title": "Konum doğrulamalı giriş ve canlı ekip görünümü"
          },
          {
            "body": "Saatler ve kilometre geri ödemeleri bordro sağlayıcınız için temiz bir şekilde dışa aktarılır — yapılandırılmış kilometre oranlarınız otomatik olarak uygulanır.",
            "title": "Tek tıkla bordro dışa aktarımı"
          }
        ],
        "headline": "Saha servisi ekipleri için zaman takibi — kilometre, masraflar ve saatler yolda, hepsi tek bir uygulamada",
        "workflow": [
          {
            "body": "Giriş, yolculuk kaydını başlatır. Kilometreler kalkıştan varışa otomatik olarak yakalanır — manuel giriş yok.",
            "step": "Teknisyen ilk çağrıya çıkar"
          },
          {
            "body": "Saatler doğru projeye bağlanır. Ek işler, malzemeler ve fişler oldukları anda uygulamaya kaydedilir.",
            "step": "İş sahasında"
          },
          {
            "body": "Her saat, kilometre ve masraf zaten doğru işe bağlanmıştır. Gerçek maliyet rakamlarıyla bordroya ve faturaya aktarın.",
            "step": "Kaos olmadan ay sonu"
          }
        ],
        "compliance": {
          "body": "Done-it, kilometreyi her yolculuk için otomatik yakalar, yapılandırdığınız geri ödeme oranlarını uygular ve her kilometreyi doğru müşteriye veya projeye kaydeder. AB Tyco kararı, evden ilk müşteriye seyahatin çalışma süresi sayıldığı anlamına gelir — Done-it bunu da takip eder.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Dijital zaman ve kilometre takibi",
          "title": "Saha servisi ekipleri için GPS saatleri ve otomatik kilometre"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "İklimlendirme (HVAC)",
        "slug": "hvac",
        "intro": "Her servis çağrısının üç maliyeti vardır: işçilik, parçalar ve seyahat. Done-it her üçünü de sahada yakalar ve doğru işe yansıtır — böylece faturayı kapatmadan önce kâr marjınızı bilirsiniz.",
        "pains": [
          {
            "body": "İşçilik, parçalar ve seyahat farklı sistemlerde — veya farklı ceplerde — bulunur. Bir çağrının gerçek maliyeti, ancak teknisyen sahadan ayrıldıktan çok sonra netleşir.",
            "title": "Servis çağrılarını doğru maliyetlendirmek zor"
          },
          {
            "body": "Bir müşteri bir onarımın ne kadar sürdüğüne itiraz ettiğinde, kâğıt zaman çizelgesine itiraz etmek kolaydır. GPS doğrulamalı giriş ve çıkış zaman damgalarına ise değildir.",
            "title": "Servis süresinin kanıtı yok"
          },
          {
            "body": "Yinelenen bakım sözleşmelerinde, küçük aşımlar birçok ziyaret boyunca birikir. Canlı bir saat sayacı olmadan, sözleşmenin zarar ettiğini ancak yenilemede öğrenirsiniz.",
            "title": "Bakım sözleşmeleri kâr marjını sessizce eritir"
          },
          {
            "body": "Manuel zaman girişleri molaları atlar, bu da fazla ödemeye ve gerçekle örtüşmeyen bir bordroya yol açar.",
            "title": "Teknisyenler molaları kaydetmeyi unutur"
          }
        ],
        "quote": {
          "who": "Sahip, iklimlendirme şirketi · 7 teknisyen",
          "text": "Sonunda her servis sözleşmesinin bize gerçekte ne kadara mal olduğunu biliyoruz. Done-it kullanmaya başladığımız gün kâr marjı sürprizleri sona erdi.",
          "result": "Servis çağrısı başına gerçek maliyet, canlı"
        },
        "stats": [
          {
            "label": "çağrı başına yakalanan maliyet türü: işçilik, seyahat, parçalar",
            "value": "3"
          },
          {
            "label": "servis sözleşmesi başına kâr marjı görünürlüğü",
            "value": "Canlı"
          },
          {
            "label": "fatura zamanında sürpriz — maliyetler gerçek zamanlı görünür",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Her servis çağrısı veya bakım sözleşmesi bir projedir. Saatler, seyahat ve malzemeler gerçek zamanlı yansır — size canlı kâr marjı görünürlüğü sağlar.",
            "plan": "Project Basic",
            "title": "Proje bazlı zaman takibi"
          },
          {
            "body": "Bir iş büyüdüğünde, teknisyenler ek işleri ve parçaları ayrılmadan önce metin ve fotoğraflarla kaydeder. Hiçbir şey hafızadan faturalandırılmaz.",
            "plan": "Project Basic",
            "title": "Sahada kaydedilen ek iş ve malzemeler"
          },
          {
            "body": "Çağrı başına kilometreler otomatik olarak kaydedilir ve işe maliyetlendirilir. Araç türü başına geri ödeme oranlarını yapılandırın.",
            "plan": "Add-on",
            "title": "Kilometre ve ulaşım maliyetleri"
          },
          {
            "body": "Zorunlu molalar toplam süreden otomatik olarak düşülür — anlaşmazlık yok, bordro hatası yok.",
            "title": "Otomatik mola düşümü"
          },
          {
            "body": "Her sahada zaman damgalı, GPS doğrulamalı giriş. Teknisyenin ne zaman vardığının ve ayrıldığının tartışılmaz kanıtı.",
            "title": "Konum doğrulamalı giriş ve mevcudiyet kanıtı"
          }
        ],
        "headline": "İklimlendirme teknisyenleri için zaman takibi — iş maliyetlendirmesi, parçalar ve seyahat tek bir uygulamada",
        "workflow": [
          {
            "body": "GPS varışı zaman damgasıyla işaretler ve saatleri servis çağrısına veya bakım sözleşmesine bağlar. Kâğıt yok, terminal yok.",
            "step": "Teknisyen sahada giriş yapar"
          },
          {
            "body": "Kullanılan parçalar, ek saatler ve kapsam değişiklikleri sahadan ayrılmadan önce fotoğraflarla uygulamaya kaydedilir.",
            "step": "Ek iş anında yakalanır"
          },
          {
            "body": "İşçilik, seyahat ve malzemeler gerçek zamanlı olarak projeye eklenir. Faturayı düzenlemeden önce kâr marjını görürsünüz.",
            "step": "İş maliyeti hemen görünür"
          }
        ],
        "compliance": {
          "body": "Done-it, iklimlendirme ekiplerine servis çağrısı başına konum doğrulamalı giriş, iş başına canlı maliyet görünürlüğü (işçilik + seyahat + parçalar) ve temiz bir bordro dışa aktarımı sunar — ek donanım olmadan her türlü yerel zaman kaydı gerekliliğini karşılar.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman ve maliyet takibi",
          "title": "İklimlendirme servis çağrıları için eksiksiz iş maliyetlendirmesi"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektrikçiler",
        "slug": "electricians",
        "intro": "Proje başına saatler, kalan bütçenin canlı bir geri sayımı ve sahaya tek tuşla navigasyon — idari yük olmadan proje kontrolüne ihtiyaç duyan küçük elektrik ekipleri için tasarlandı.",
        "pains": [
          {
            "body": "Elektrikçiler bir hafta içinde birden fazla işte çalıştığında, saatleri gün sonunda manuel olarak dağıtmak yanlış atfedilen maliyetlere, faturalandırma anlaşmazlıklarına ve açıklayamayacağınız bir bordroya yol açar.",
            "title": "Saatler doğru projeye bağlanmıyor"
          },
          {
            "body": "Tüketilen saatlerin bütçelenen saatlere karşı canlı bir görünümü olmadan, bir projenin bütçeyi aştığını faturayı düzenlerken öğrenirsiniz — hâlâ tepki verebileceğiniz zaman değil.",
            "title": "Bütçe aşımları çok geç fark edilir"
          },
          {
            "body": "Adresler ayrı bir uygulamaya yazılır, yön için ofise telefon edilir, müşteri sahalarına geç varılır. Boşa harcanan her dakika kaybedilen bir faturalandırılabilir dakikadır.",
            "title": "Sahayı bulurken zaman kaybı"
          },
          {
            "body": "Büyük montajlarda, taşeron elektrikçiler kendi saatlerini ayrı takip eder. Bir projenin sonunda işçilik maliyetlerinin birleşik bir görünümünü elde etmek manuel, hataya açık bir iştir.",
            "title": "Taşeron saatlerini mutabık kılmak zor"
          }
        ],
        "quote": {
          "who": "Sahip, elektrik şirketi · 5 elektrikçi",
          "text": "Bir projenin bütçeyi aşıp aşmadığını gerçek zamanlı biliyoruz. Yalnızca bu bile bu yıl bizi iki kötü sürprizden kurtardı.",
          "result": "Bütçe aşımları olmadan önce yakalanır"
        },
        "stats": [
          {
            "label": "proje başına kalan saat görünümü",
            "value": "Canlı"
          },
          {
            "label": "saha adresleri için ofis telefonu",
            "value": "0"
          },
          {
            "label": "herhangi bir sahaya giriş yapmak için — terminale gerek yok",
            "value": "1 dokunuş"
          }
        ],
        "features": [
          {
            "body": "Çalışılan her dakika otomatik olarak doğru projeye bağlanır. Canlı bir geri sayım, bütçeye karşı kaç saat kaldığını gösterir — hem sizin için hem de sahadaki çalışan için.",
            "plan": "Project Basic",
            "title": "Canlı kalan bütçeli proje saatleri"
          },
          {
            "body": "Proje adresi uygulamadadır. Tek dokunuş navigasyonu açar — arama yok, ayrı bir harita uygulaması yok, ofise telefon yok.",
            "title": "Sahaya tek tuşla navigasyon"
          },
          {
            "body": "Her elektrikçi doğru işe giriş yapar. Şu anda kimin hangi sahada olduğunu her zaman bilirsiniz.",
            "plan": "Project Basic",
            "title": "Proje başına çalışan girişi"
          },
          {
            "body": "Kapsam değiştiğinde — beklenmedik bir devre, ek malzemeler — ekip ayrılmadan önce fotoğraflarla uygulamaya kaydedilir.",
            "plan": "Project Basic",
            "title": "Sahada kaydedilen ek iş"
          },
          {
            "body": "Fazla mesai oluştuğu anda kaydedilir. Çalışanlar bunun ödenmesini veya izne dönüştürülmesini seçer.",
            "plan": "Time Pro",
            "title": "Esnek telafili fazla mesai takibi"
          }
        ],
        "headline": "Elektrikçiler için zaman takibi — proje başına saatler, bütçe kontrolü ve navigasyon tek bir uygulamada",
        "workflow": [
          {
            "body": "Adres ve kapsam zaten uygulamadadır. Tek dokunuş navigasyonu açar — telefon yok, karışıklık yok.",
            "step": "Elektrikçi işe yol tarifi alır"
          },
          {
            "body": "Sahada giriş, çalışılan her dakikayı doğru projeye bağlar. Kalan saat sayacı canlı güncellenir.",
            "step": "Saatler otomatik olarak doğru projeye bağlanır"
          },
          {
            "body": "Ek iş ve malzemeler sahada, ayrılmadan önce kaydedilir. Fatura gerçekte ne olduğunu yansıtır.",
            "step": "Kapsam değişiklikleri kayıtta kalır"
          }
        ],
        "compliance": {
          "body": "Done-it, elektrikçilere proje başına konum doğrulamalı giriş, canlı kalan saat bütçesi ve bordro dışa aktarımı sunar — her türlü yerel zaman kaydı gerekliliğini karşılar. Belçika inşaat şantiyelerindeki ekipler için, CheckIn@Work ile de entegre olur.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Proje başına konum doğrulamalı giriş",
          "title": "Elektrik ekipleri için canlı bütçe kontrolü ve konum doğrulamalı giriş"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Tesisat",
        "slug": "plumbing",
        "intro": "Acil çağrılar, günde birden fazla iş, hafta sonunda hafızadan doldurulan saatler — veya hiç doldurulmayan. Done-it bunu her sahada tek dokunuşluk bir iş ve ay sonunda tek tıklık bir bordro haline getirir.",
        "pains": [
          {
            "body": "Bir günde birkaç işle, tesisatçıların doğru zaman çizelgeleri doldurmaya nadiren vakti olur. Saatler yuvarlanır veya unutulur, bordro en iyi ihtimalle bir tahmindir.",
            "title": "Çağrı saatleri hafızadan yeniden oluşturuluyor"
          },
          {
            "body": "Bir müşteri bir onarımın ne kadar sürdüğüne itiraz ettiğinde, objektif bir kayıt yoktur. GPS doğrulamalı dijital giriş kolayca üretilebilir — kâğıt zaman çizelgesi ise üretilemez.",
            "title": "Sahadaki sürenin kanıtı yok"
          },
          {
            "body": "Çağrılar arası seyahat hafta ve ay boyunca birikir, ancak otomatik yakalama olmadan nadiren doğru faturalandırılır veya geri ödenir.",
            "title": "İşler arası kilometre takip edilmiyor"
          },
          {
            "body": "Ay sonunda, zaman çizelgelerinin peşinde koşmak, hataları düzeltmek ve bordro dışa aktarımını oluşturmak, idari ekibinizin harcamaması gereken zamanı alır.",
            "title": "Bordro hazırlığı yavaş"
          }
        ],
        "quote": {
          "who": "Sahip, tesisat şirketi · 4 tesisatçı",
          "text": "Eskiden ay sonunda saatleri yeniden oluşturarak bir sabahımızı harcardık. Artık sadece dışa aktarıp gönderiyoruz. Bordro sağlayıcısı temiz bir şekilde alıyor.",
          "result": "Bordro hazırlığı saatlerden dakikalara indi"
        },
        "stats": [
          {
            "label": "giriş yapmak için — acil çağrılar için yeterince hızlı",
            "value": "1 dokunuş"
          },
          {
            "label": "sağlayıcınıza bordro dışa aktarımı",
            "value": "1 tık"
          },
          {
            "label": "ay sonunda hafızadan yeniden oluşturulan saat",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Varış ve ayrılış, lokasyonun konum doğrulamasıyla birlikte tek dokunuşla kaydedilir. Acil çağrılar için yeterince hızlı; anlaşmazlıklar için yeterince hassas.",
            "plan": "Time Basic",
            "title": "Her çağrıda tek dokunuşla konum doğrulamalı giriş"
          },
          {
            "body": "Zorunlu molalar toplam süreden otomatik olarak düşülür — doldurulacak bir şey yok, bordro hatası yok.",
            "plan": "Time Basic",
            "title": "Otomatik mola düşümü"
          },
          {
            "body": "Ulaşım türlerini ve geri ödeme oranlarını yapılandırın. Kilometreler otomatik olarak kaydedilir ve doğru müşteriye veya projeye bağlanır.",
            "plan": "Add-on",
            "title": "Yolculuk başına yakalanan kilometre"
          },
          {
            "body": "Çalışanlar hastalık raporlarını uygulamadan dijital olarak gönderir. Hava koşullarına bağlı gecikmeler dahil, ekibinizin gerçekten kullandığı devamsızlık türlerini oluşturun.",
            "title": "Devamsızlık ve hastalık raporu yönetimi"
          },
          {
            "body": "Tüm saat ve kilometre verileri bordro sağlayıcınız için temiz bir şekilde dışa aktarılır — manuel hazırlık yok, Excel yok.",
            "plan": "Time Basic",
            "title": "Tek tıkla bordro dışa aktarımı"
          }
        ],
        "headline": "Tesisat ekipleri için zaman takibi — hızlı giriş, doğru bordro ve her çağrı için mevcudiyet kanıtı",
        "workflow": [
          {
            "body": "Tek dokunuş giriş yaptırır. GPS lokasyonu ve zamanı kaydeder. Acil bir iş için yeterince hızlı.",
            "step": "Tesisatçı çağrıya varır"
          },
          {
            "body": "Çıkış, zaman kaydını kapatır. Sonraki işe kilometre otomatik kaydedilmeye başlar.",
            "step": "Çıkışta ayrılış dokunuşu"
          },
          {
            "body": "Tüm çağrılar, saatler ve kilometreler temiz bir şekilde dışa aktarılır. Bordro hazırlığı bir günden dakikalara iner.",
            "step": "Ay sonu tek tıktır"
          }
        ],
        "compliance": {
          "body": "Done-it, tesisat ekipleri için her türlü yerel zaman kaydı gerekliliğini karşılar — çağrı başına tek dokunuşla konum doğrulamalı giriş, otomatik mola düşümü ve temiz bir bordro dışa aktarımı. Kâğıt zaman çizelgesi yok, manuel yeniden oluşturma yok.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman kaydı",
          "title": "Her çağrı için hızlı konum doğrulamalı giriş"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Peyzaj",
        "slug": "landscaping",
        "intro": "Yoğun sezon, çok sayıda saha, değişen ekipler ve bir sürü kilometre demektir. Done-it her saati, her devamsızlığı ve her yolculuğu düzenli tutar — böylece evrak işlerine değil, işe odaklanabilirsiniz.",
        "pains": [
          {
            "body": "Geçici çalışanlar, değişen programlar ve farklı ekip büyüklükleri, kâğıtla doğru saat takibini neredeyse imkânsız kılar. Ay sonunda mutabakat yaptığınızda, her zaman bir şeyler eksiktir.",
            "title": "Mevsimlik ekipleri yönetmek karmaşık"
          },
          {
            "body": "Günde üç veya dört saha ziyaret eden bir ekip, doğru bölünmesi gereken saatler üretir. Manuel giriş, yanlış atfetmeye ve itiraz edilen bordroya yol açar.",
            "title": "Saatler birçok sahaya dağılmış"
          },
          {
            "body": "Kötü hava nedeniyle duraklama, peyzajda gerçek bir olaydır. Dijital bir kayıt olmadan, durmaları belgelemek ve ücreti ayarlamak yavaş ve hataya açıktır.",
            "title": "Hava koşulu kaynaklı durmaları belgelemek zor"
          },
          {
            "body": "Şirket minibüsleri, kişisel araçlar ve ortak araçlar gün boyu sahalar arasında dolaşır. Otomatik yakalama olmadan, o kilometreler asla maliyet tablosuna girmez.",
            "title": "Sahalar arası kilometre takip edilmiyor"
          }
        ],
        "quote": {
          "who": "Sahip, peyzaj şirketi · 12 mevsimlik çalışan",
          "text": "Yoğun sezon eskiden bordro kaosu demekti. Artık ustabaşımız uygulamayı kontrol ediyor, herkes hesaba katılıyor ve ben ayın son günü saatleri dışa aktarıyorum.",
          "result": "Artık ay sonu bordro yeniden oluşturması yok"
        },
        "stats": [
          {
            "label": "kilometre yakalama — artık kayıt defteri yok",
            "value": "Otomatik"
          },
          {
            "label": "tüm sahalarda ekip görünümü",
            "value": "Canlı"
          },
          {
            "label": "tüm sahalar ve tüm ekip için bordro dışa aktarımı",
            "value": "1 tık"
          }
        ],
        "features": [
          {
            "body": "Tüm ekibi, tüm sahaları gerçek zamanlı görün. Şu anda kimin nerede çalıştığını bilin — ay sonunda değil.",
            "title": "Çoklu saha ekip görünümü"
          },
          {
            "body": "Kimin nerede çalışacağını planlayın, son dakika değişikliklerini halledin ve programı ekibin telefonlarına gönderin — herkesi tek tek aramadan.",
            "plan": "Time Pro",
            "title": "Mevsimlik ekipler için vardiya planlaması"
          },
          {
            "body": "Sektörünüze özel devamsızlık türleri oluşturun: mevsimlik hava durmaları, ebeveyn izni, hastalık günleri. Çalışanlar belgeleri uygulamadan dijital olarak yükler.",
            "title": "Özel devamsızlık türleri"
          },
          {
            "body": "Ulaşım türlerini (şirket minibüsü, kişisel araç, ortak araç sürücüsü ve yolcusu) kendi oranlarıyla yapılandırın. Kilometreler yolculuk başına otomatik kaydedilir.",
            "plan": "Add-on",
            "title": "Ortak araç takibiyle kilometre"
          },
          {
            "body": "Yoğun sezonda fazla mesai hızla birikir. Her çalışan ödeme almayı veya saatleri izin olarak biriktirmeyi seçebilir — şeffaf bir şekilde takip edilir.",
            "plan": "Time Pro",
            "title": "İzne dönüştürmeli fazla mesai takibi"
          }
        ],
        "headline": "Peyzaj şirketleri için zaman takibi — mevsimlik ekipler, birden fazla saha ve kilometre tek bir genel görünümde",
        "workflow": [
          {
            "body": "GPS varışı kaydeder. Saatler otomatik olarak doğru lokasyona ve projeye bölünür — gün sonunda manuel dağıtım yok.",
            "step": "Ekip ilk sahada giriş yapar"
          },
          {
            "body": "Ustabaşı durmayı uygulamadan kaydeder — temiz bir dijital kayıt, ek evrak işi yok.",
            "step": "Hava işi durdurur"
          },
          {
            "body": "Her sahadaki ve her ekip üyesindeki saatler, devamsızlıklar ve kilometreler bordro için temiz bir şekilde dışa aktarılır.",
            "step": "Ay sonu: tüm sahalar, tüm ekip, tek dışa aktarım"
          }
        ],
        "compliance": {
          "body": "Done-it, peyzaj ekiplerine tüm sahalarda ve mevsimlik personelde dijital zaman kaydı sunar — konum doğrulamalı giriş, hava durmaları için özel devamsızlık türleri ve her türlü yerel gerekliliği karşılayan temiz bir bordro dışa aktarımı.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman kaydı",
          "title": "Mevsimlik peyzaj ekipleri için konum doğrulamalı giriş ve devamsızlık takibi"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Bakım",
        "slug": "maintenance",
        "intro": "Yinelenen bakım sözleşmeleri maliyet görünürlüğüyle ayakta kalır veya çöker. Done-it her ziyareti kaydeder, saatleri sözleşme bütçesine karşı takip eder ve size — ve müşterilerinize — her çağrı için mevcudiyet kanıtı sunar.",
        "pains": [
          {
            "body": "Yinelenen ziyaretlerin saatleri belirli sözleşmeye karşı takip edilmediğinde, bir müşterinin kârlı olup olmadığını yıl sonu değerlendirmesine kadar bilemezsiniz — ki o noktada yeniden fiyatlandırmak için çok geçtir.",
            "title": "Bakım sözleşmesi başına maliyet görünürlüğü yok"
          },
          {
            "body": "Tesis yöneticileri ve mülk sahipleri giderek daha fazla mevcudiyet kaydı ister: kim geldi, ne zaman vardı, ne yaptı. Haftalar sonra sunulan bir kâğıt kayıt, SLA gerekliliklerini karşılamaz.",
            "title": "Müşteriler yapılanın kanıtını bekler"
          },
          {
            "body": "Birbirinin yerine çalışan personelle, birçok yinelenen sahada dönüşümlü vardiyalar, manuel süreçlerin güvenilir şekilde çözemeyeceği bir planlama ve saat takibi bilmecesi yaratır.",
            "title": "Yinelenen ziyaretleri planlamak ve kaydetmek zor"
          },
          {
            "body": "Bahçe bakımı, cephe bakımı ve dış mekân tesis çalışmaları hava koşullarına bağlı durmalarla karşılaşır. Bunları doğru belgelemek dijital bir iz gerektirir.",
            "title": "Hava durmaları dış mekân bakımını da etkiler"
          }
        ],
        "quote": {
          "who": "Operasyon müdürü, bakım şirketi · 8 çalışan",
          "text": "Bir tesis yöneticisine kimin sahada olduğunu ve ne zaman olduğunu iki dakikada tam olarak söyleyebiliyoruz. Bu düzeyde bir kanıt, müşterilerin bizi görme şeklini değiştirdi.",
          "result": "Müşteri anlaşmazlıkları sıfıra indi"
        },
        "stats": [
          {
            "label": "bakım sözleşmesi başına maliyet",
            "value": "Canlı"
          },
          {
            "label": "talep üzerine müşteriler için hazır mevcudiyet kanıtı",
            "value": "GPS"
          },
          {
            "label": "kâr marjını bilmeden yapılan sözleşme yenilemesi",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Her bakım sözleşmesi bir projedir. Saatler otomatik olarak buna kaydedilir, size her müşteri için canlı bir maliyet rakamı ve kalan saat geri sayımı sunar.",
            "plan": "Project Basic",
            "title": "Sözleşme bazlı maliyet takibi"
          },
          {
            "body": "Zaman damgalı, konum doğrulamalı girişler, kimin sahada, ne zaman ve ne kadar süre olduğuna dair tartışılmaz bir kayıttır — istek üzerine müşterilerle paylaşmaya hazır.",
            "title": "GPS doğrulamalı mevcudiyet kanıtı"
          },
          {
            "body": "Çalışanlar sorunları, tamamlanan görevleri veya ek işleri doğrudan uygulamadan — metin ve fotoğraflarla — bildirir. Müşteriler gerçek zamanlı bir kayıt alır; sizin elinizde faturalandırma için belge olur.",
            "plan": "Project Basic",
            "title": "Sahadan fotoğraflı güncellemeler"
          },
          {
            "body": "Tüm sözleşmelerde yinelenen ziyaretleri planlayın, çalışanları atayın ve yerine geçmeleri halledin — herkesi tek tek aramadan.",
            "plan": "Time Pro",
            "title": "Yinelenen vardiya planlaması"
          },
          {
            "body": "Hava durmalarını ve diğer devamsızlık türlerini yapılandırın. Çalışanlar bunları uygulamadan kaydeder; belgeler dijital olarak yüklenir.",
            "title": "Dış mekân bakımı için devamsızlık türleri"
          }
        ],
        "headline": "Bakım ekipleri için zaman takibi — yinelenen saha ziyaretleri, sözleşme başına maliyet ve mevcudiyet kanıtı tek bir uygulamada",
        "workflow": [
          {
            "body": "Konum doğrulamalı giriş, varış saatini kaydeder ve saatleri doğru sözleşmeye bağlar. Mevcudiyet kanıtı otomatik olarak oluşturulur.",
            "step": "Çalışan bakım sahasına varır"
          },
          {
            "body": "Tamamlanan işler ve sorunlar uygulamadan fotoğraflarla bildirilir. Müşteriler tam olarak ne yapıldığını görebilir.",
            "step": "Görevler tamamlanır, sorunlar kaydedilir"
          },
          {
            "body": "Saatler sözleşme bütçesine karşı gerçek zamanlı birikir. Sözleşme yenilenmeden önce kâr marjını bilirsiniz.",
            "step": "Sözleşme başına maliyet hemen görünür"
          }
        ],
        "compliance": {
          "body": "Done-it, bakım ekiplerine sözleşme başına GPS doğrulamalı mevcudiyet kanıtı, özel devamsızlık türleri ve yinelenen müşteri başına canlı bir maliyet görünümü sunar — ek donanım olmadan her türlü yerel zaman kaydı gerekliliğini karşılar.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Sözleşme bazlı zaman takibi",
          "title": "Bakım sözleşmesi başına canlı maliyet görünürlüğü"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Mağazalar ve perakende",
        "slug": "retail",
        "intro": "Açılış vardiyaları, geç vardiyalar ve sürekli birinin yerine geçen bir başkası. Done-it her mağazaya kimin hangi vardiyada çalıştığının temiz bir dijital kaydını verir — çalışan kendi telefonundan giriş yapar, ay sonunda bordro hazırdır.",
        "pains": [
          {
            "body": "Biri hasta olan arkadaşının yerine geçer, biri kapanışta bir saat fazla kalır. Bu ya bir kâğıda not edilir ya da hiç. Bordro daha başlamadan yanlıştır.",
            "title": "Vardiya değişiklikleri bordroya hiç ulaşmıyor"
          },
          {
            "body": "Personel şubeler arasında geçiş yapar, yarı zamanlılar iki lokasyonda çalışır. Saatleri mağaza mağaza toplayıp elle birleştirmek her ay bir gün götürür.",
            "title": "Birkaç mağaza, tek bordro dönemi"
          },
          {
            "body": "Yasal molalar hafızadan düşülür, fazla saatler gayriresmî kapatılır — denetimin ilk sorduğu iki şey tam olarak bunlardır.",
            "title": "Molalar ve fazla mesai tahmine kalıyor"
          }
        ],
        "quote": {
          "who": "İşletme sahibi, perakende · 11 çalışan",
          "text": "İki mağaza ve bir sürü yarı zamanlı çalışan. Eskiden yerine geçme vardiyalarının yarısı hafızadan kapatılıyordu. Şimdi her saat doğru mağazada ve bordro dakikalar sürüyor.",
          "result": "Bordro hazırlığı bir günden bir saatin altına indi"
        },
        "stats": [
          {
            "label": "mesai girişi için — kasada terminal yok",
            "value": "1 dokunuş"
          },
          {
            "label": "tüm mağazalarda kimin işte olduğu görünümü",
            "value": "Canlı"
          },
          {
            "label": "mağaza ile bordro arasında kaybolan vardiya değişikliği",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Vardiya başında kendi telefonunda tek dokunuş. Kasada terminal yok, ortak kart yok, depo kapısında panoya asılı liste yok.",
            "title": "Mağaza içinde mesai başlatma"
          },
          {
            "body": "Her mağaza bir projedir. Başka bir şubede çalışan kişi o şubeye kaydedilir — saatleri gerçekten çalışıldığı yerde görürsünüz.",
            "title": "Mağaza başına saatler, şubeler arası personel"
          },
          {
            "body": "Mola kuralını bir kez ayarlarsınız, her vardiyaya uygulanır. Fazla mesai gerçekleştiği anda kaydedilir ve her çalışan ödeme mi izin mi istediğini kendisi seçer.",
            "title": "Molalar otomatik düşülür"
          }
        ],
        "headline": "Mağazalar için mesai takibi — vardiya girişi, yerine geçme ve bordroya hazır dışa aktarım, tek uygulamada",
        "workflow": [
          {
            "body": "Vardiya başlarken telefonunda tek dokunuş. Başka bir şubedeki destek o şubeye kaydedilir.",
            "step": "Personel vardiya girişini yapar"
          },
          {
            "body": "Tüm lokasyonlarda canlı görünüm — kapanmayan bir açılış vardiyasını kapılar açılmadan fark edersiniz.",
            "step": "Mağaza mağaza kimin işte olduğunu görürsünüz"
          },
          {
            "body": "Çalışan ve mağaza başına saatler, molalar ve fazla mesai; bordro sağlayıcınıza hazır biçimde dışa aktarılır.",
            "step": "Bordro tek dışa aktarımla"
          }
        ],
        "compliance": {
          "body": "Done-it her giriş ve çıkışın, molalar ve fazla mesaiyle birlikte nesnel bir dijital kaydını tutar — bir denetimin ya da bordro anlaşmazlığının istediği kaydı.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Vardiya bazlı zaman kaydı",
          "title": "Çalışılan her vardiyanın savunulabilir kaydı"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Ofisler ve profesyonel hizmetler",
        "slug": "offices",
        "intro": "Mali müşavirler, noterler, mimarlar, ajanslar ve danışmanlıklar zamanlarını faturalandırır — ya da en azından nereye gittiğini bilmek zorundadır. Done-it saatleri doğru müşteri ve projeye kaydeder; masa başında da yolda da.",
        "pains": [
          {
            "body": "Hafta sonunda yazılan zaman, tahmin edilen zamandır. İşle fatura arasında saatler sessizce kaybolur.",
            "title": "Faturalanabilir saatler cuma günü hatırlanıyor"
          },
          {
            "body": "Ücret aylar önce konuşuldu. İşin hâlâ o bütçeye sığıp sığmadığı, ancak biri oturup topladığında ortaya çıkar — genelde çok geç.",
            "title": "Bir müşterinin gerçek maliyeti bilinmiyor"
          },
          {
            "body": "Ekibin bir kısmı ofiste, bir kısmı evde, bir kısmı müşteride. Devam bir olgu olmaktan çıkıp yeniden kurguya dönüşür.",
            "title": "Hibrit çalışma kaydı delik deşik ediyor"
          }
        ],
        "quote": {
          "who": "Ortak, mali müşavirlik bürosu · 8 çalışan",
          "text": "Eskiden her cuma tüm haftayı yeniden kurardık. Şimdi saatler zaten doğru müşteride ve hangi dosyanın ücreti yediğini görebiliyorum.",
          "result": "Her ay geri kazanılan faturalanabilir saatler"
        },
        "stats": [
          {
            "label": "saatler, iş daha sürerken görünür",
            "value": "Müşteri başına"
          },
          {
            "label": "aynı kayıt, telefon ve tarayıcı",
            "value": "Ofis ya da yol"
          },
          {
            "label": "bordro ve faturalandırma için",
            "value": "1 dışa aktarım"
          }
        ],
        "features": [
          {
            "body": "Her kayıt bir projeye düşer; müşteri başına saatleri hiçbir şey dışa aktarmadan, kimseye sormadan görürsünüz.",
            "title": "Müşteri ve proje bazında saatler"
          },
          {
            "body": "Telefonda ya da tarayıcıda aynı uygulama. Müşteri ziyareti o müşteriye çalışılan zaman olarak sayılır, isterseniz yol süresiyle birlikte.",
            "title": "Masa başında da saha dışında da çalışır"
          },
          {
            "body": "Fazla saatler gerçekleştiği anda kaydedilir, izinler uygulamada talep edilip onaylanır — kimin ne zaman izinli olduğunu tutan ayrı bir tablo dosyası yok.",
            "title": "Fazla mesai ve izin tek yerde"
          }
        ],
        "headline": "Ofisler için zaman takibi — müşteri ve proje başına saatler, tablo dosyası olmadan",
        "workflow": [
          {
            "body": "Müşteriyle birlikte bir kez kurun; bütçeye göre faturalandırıyorsanız planladığınız saatleri de girin.",
            "step": "Bir müşteri projesi açın"
          },
          {
            "body": "Masa başından ya da telefondan. Her saat birinin hafızasına değil, bir müşteriye düşer.",
            "step": "Ekip zamanını o projeye kaydeder"
          },
          {
            "body": "Proje başına canlı toplamlar ve ay sonunda bordro ya da faturalandırma için temiz bir dışa aktarım.",
            "step": "Müşteri başına saatleri görün, bordro için dışa aktarın"
          }
        ],
        "compliance": {
          "body": "Done-it çalışan başına çalışma süresinin dijital ve değişiklik izi bırakan bir kaydını tutar — hem bordronun hem de savunulabilir bir müşteri faturasının temeli.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Müşteri bazlı zaman kaydı",
          "title": "Çalışılan saatlerin nesnel kaydı"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salonlar ve kişisel bakım",
        "slug": "beauty",
        "intro": "Kuaförler, berberler, tırnak ve güzellik stüdyoları vardiya ve yarı zamanlı sözleşmelerle döner. Done-it kimin ne zaman çalıştığını kaydeder, molaları otomatik düşer ve bordroya temiz bir dosya verir.",
        "pains": [
          {
            "body": "Bir hafta üç gün, ertesi hafta dört, cumartesi yerine salı. Sözleşmedeki saatlerle çalışılan saatler hızla birbirinden ayrılır.",
            "title": "Yarı zamanlı sözleşmeler, sonu gelmeyen varyasyonlar"
          },
          {
            "body": "Randevular neyin rezerve edildiğini söyler, kimin çalıştığını değil. Bordro ya da denetim sorduğunda rezervasyon sistemi yanlış cevaptır.",
            "title": "Randevu defteri bir zaman kaydı değildir"
          },
          {
            "body": "Son müşteri için geç kalmak hatırlanır, söz verilir, bazen de unutulur. Anlaşmazlığa dönüşen boşluk tam olarak budur.",
            "title": "Fazla saatler gayriresmî kapatılıyor"
          }
        ],
        "quote": {
          "who": "İşletme sahibi, kuaför salonu · 6 çalışan",
          "text": "Herkes yarı zamanlı ve her hafta farklı. Uygulama bunu olduğu gibi kaydediyor — ayı tablo dosyasında yeniden kurmayı bıraktım.",
          "result": "Ay sonunda tartışmalı saat kalmadı"
        },
        "stats": [
          {
            "label": "mesai girişi için — ortak cihaz yok, kâğıt yok",
            "value": "1 dokunuş"
          },
          {
            "label": "her vardiyada mola düşümü",
            "value": "Otomatik"
          },
          {
            "label": "hafızadan kapatılan geç saat",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Vardiya başında kendi telefonunda tek dokunuş — resepsiyonda ortak terminal yok, aynanın yanında imza listesi yok.",
            "title": "Salonda mesai başlatma"
          },
          {
            "body": "Mola kuralını ve standart saatleri bir kez ayarlayın; her vardiyaya uygulanır, sözleşmesi farklı olanlar için kişiye özel istisnalarla.",
            "title": "Mola ve yarı zamanlı kuralları bir kez"
          },
          {
            "body": "Fazla saatler çalışıldığı anda kaydedilir ve her çalışan ödeme mi karşılık izin mi istediğini seçer — hafızayla değil, uygulamada kapanır.",
            "title": "Fazla mesai: ödeme ya da izin"
          }
        ],
        "headline": "Salonlar için mesai takibi — vardiyalar, yarı zamanlı saatler ve kâğıt ajanda olmadan bordro",
        "workflow": [
          {
            "body": "Gelişte tek dokunuş. Molalar bir kez belirlediğiniz kurala göre düşülür.",
            "step": "Personel vardiya girişini yapar"
          },
          {
            "body": "Kim işte, kim molada, kim geç kaldı — sormadan, canlı olarak.",
            "step": "Günü akarken görürsünüz"
          },
          {
            "body": "Çalışan başına çalışılan saatler, molalar ve fazla mesai; bordro sağlayıcınız için dışa aktarılır.",
            "step": "Bordro temiz bir dosya alır"
          }
        ],
        "compliance": {
          "body": "Done-it çalışan başına gerçek çalışma süresini molalar ve fazla mesaiyle birlikte kaydeder — rezervasyonlardan bağımsız ve kontrol edildiğinde savunulabilir.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Dijital zaman kaydı",
          "title": "Randevu defterinin ötesinde ayakta kalan bir kayıt"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sağlık ve wellness",
        "slug": "wellness",
        "intro": "Spor salonları, fitness stüdyoları, fizyoterapi merkezleri ve spalar uzun açılış saatleriyle ve dönüşümlü personelle çalışır. Done-it hangi vardiyayı kimin devraldığını kaydeder, molaları otomatik düşer ve bordroyu temiz biçimde dışa aktarır.",
        "pains": [
          {
            "body": "Sabah vardiyaları, akşam dersleri ve hafta sonları; tam zamanlı, yarı zamanlı ve serbest çalışan karışımıyla doldurulur. Çizelge bir plandır, kayıt değil.",
            "title": "Uzun açılış saatleri, dönüşümlü destek"
          },
          {
            "body": "Bir eğitmen iki ders verir, aralarda resepsiyona bakar. Bunu doğru ödemek, planlananı değil gerçekte çalışılanı bilmeyi gerektirir.",
            "title": "Ders saatleri ile salon saatleri iç içe geçiyor"
          },
          {
            "body": "Personel stüdyolar arasında geçiş yapar. Her ay saatleri elle birleştirmek hem yavaş hem hataya açıktır.",
            "title": "Birkaç lokasyon, tek idari süreç"
          }
        ],
        "quote": {
          "who": "Müdür, fitness stüdyosu · 14 çalışan",
          "text": "İki stüdyo, uzun açılış saatleri ve bir sürü yerine geçme vardiyası. Şimdi saatler doğru lokasyona düşüyor ve bordro tek dosya.",
          "result": "Çizelge ve bordro nihayet birbirini tutuyor"
        },
        "stats": [
          {
            "label": "saatler, personel başka yerde çalışsa bile",
            "value": "Stüdyo başına"
          },
          {
            "label": "lokasyonlar genelinde salon görünümü",
            "value": "Canlı"
          },
          {
            "label": "molalar ve fazla mesai, elle hesap yok",
            "value": "Otomatik"
          }
        ],
        "features": [
          {
            "body": "Çalıştıkları lokasyonda telefonlarında tek dokunuş. Başka bir stüdyodaki destek o stüdyonun saatlerine düşer.",
            "title": "Stüdyo bazında mesai girişi"
          },
          {
            "body": "Tüm lokasyonlarda salonu gerçek zamanlı görün — boş kalan bir sabah vardiyası kapılar açıldıktan sonra değil, önce görünür.",
            "title": "Kimin işte olduğuna dair canlı görünüm"
          },
          {
            "body": "Mola kuralları otomatik uygulanır, fazla saatler gerçekleştiği anda kaydedilir; her çalışan ödeme ya da karşılık izin seçer.",
            "title": "Molalar ve fazla mesai hallolur"
          }
        ],
        "headline": "Spor salonları, stüdyolar ve spalar için mesai takibi — vardiyalar, dersler ve bordro tek uygulamada",
        "workflow": [
          {
            "body": "Vardiya başında, çalıştıkları lokasyonda tek dokunuş.",
            "step": "Personel stüdyoda mesai girişi yapar"
          },
          {
            "body": "Şu anda hangi lokasyonda kimin olduğu bellidir; boşluklar üyeler fark etmeden doldurulur.",
            "step": "Destek canlı olarak görünür"
          },
          {
            "body": "Çalışan ve stüdyo başına saatler, molalar ve fazla mesai; bordro sağlayıcısına hazır.",
            "step": "Bordro için tek dışa aktarım"
          }
        ],
        "compliance": {
          "body": "Done-it çalışan ve lokasyon başına çalışma süresinin dijital kaydını tutar — doğru ödemenin ve çalışılan saatlere dair her kontrolün temeli.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Çok lokasyonlu vardiya kaydı",
          "title": "Her vardiya ve her lokasyon için nesnel bir kayıt"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Konaklama ve yeme-içme",
        "slug": "hospitality",
        "intro": "Bölünmüş vardiyalar, geç kapanışlar ve uzayan yoğun bir cumartesi. Done-it saatleri gerçekte çalışıldığı gibi kaydeder, molaları sizin kuralınıza göre düşer ve bordroya tek temiz bir dosya verir.",
        "pains": [
          {
            "body": "Servis uzar, kapanış yarım saat daha alır. O dakikalar gerçek iştir ve hafızadan kapatılması anlaşmazlıkların başlangıcıdır.",
            "title": "Vardiya hiçbir zaman çizelgedeki saatte bitmiyor"
          },
          {
            "body": "Öğle servisi, bir mola, sonra akşam servisi. Kâğıt üzerinde bu ya tek uzun bloğa ya da iki tahmine dönüşür — ikisi de gerçek değildir.",
            "title": "Bölünmüş vardiyaları kaydetmek zor"
          },
          {
            "body": "Her sezon yeni personel. Eğitim gerektiren hiçbir sistem ilk yoğun haftadan sağ çıkmaz.",
            "title": "Yüksek devir, sürekli işe alım"
          }
        ],
        "quote": {
          "who": "İşletme sahibi, restoran · 17 çalışan",
          "text": "Kapanış her zaman uzar. Şimdi o dakikalar tartışılmak yerine kaydediliyor ve personel karşılığında izin kullanabiliyor.",
          "result": "Daha az anlaşmazlık, daha hızlı bordro"
        },
        "stats": [
          {
            "label": "tek tahmin değil, iki blok olarak kaydedilir",
            "value": "Bölünmüş vardiya"
          },
          {
            "label": "kuralınıza göre mola düşümü",
            "value": "Otomatik"
          },
          {
            "label": "yeni başlayanı sisteme almak için — kendi telefonu",
            "value": "1 dakika"
          }
        ],
        "features": [
          {
            "body": "Her bloğun başında ve sonunda tek dokunuş; bölünmüş vardiyalar olduğu gibi kaydedilir — tek blokta birleştirilmez.",
            "title": "Her servis için giriş ve çıkış"
          },
          {
            "body": "Zorunlu molalar otomatik düşülür, sözleşmesi gerektirenler için kişiye özel istisnalarla. Ay sonunda elle hesap yok.",
            "title": "Molalar sizin kuralınıza göre"
          },
          {
            "body": "Kapanıştan sonraki fazladan yarım saat çalışıldığı anda kaydedilir ve ödeme olarak ya da karşılık izin olarak kapanır — seçim çalışanın.",
            "title": "Fazla mesai uygulamada kapanır"
          }
        ],
        "headline": "Kafeler, restoranlar ve oteller için mesai takibi — vardiyalar, molalar ve fazla mesai adilce kapanır",
        "workflow": [
          {
            "body": "Bloğun başında tek dokunuş, sonunda aynısı. Bölünmüş vardiyalar bölünmüş kalır.",
            "step": "Personel servis için giriş yapar"
          },
          {
            "body": "Bu akşamki servis için kim işte, kim hâlâ molada, kim kapanışı geçti.",
            "step": "Salonu canlı görürsünüz"
          },
          {
            "body": "Çalışan başına çalışılan süre, molalar ve fazla mesai; tek dosyada dışa aktarılır.",
            "step": "Bordro gerçek saatleri alır"
          }
        ],
        "compliance": {
          "body": "Done-it her vardiyanın, molanın ve fazla saatin nesnel bir dijital kaydını tutar — bir bordro kontrolünün ya da iş müfettişliğinin görmek istediği tam olarak budur.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Bölünmüş vardiya zaman kaydı",
          "title": "Devri yüksek bir ekipte savunulabilir saat kaydı"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sağlık ve bakım hizmetleri",
        "slug": "healthcare",
        "intro": "Muayenehaneler, evde bakım ekipleri ve bakımevleri vardiyalar, ziyaretler ve sıkı kayıt tutma etrafında döner. Done-it çalışılan süreyi vardiya ve ziyaret bazında kaydeder, çalışan belgelerini de bulabileceğiniz yerde tutar.",
        "pains": [
          {
            "body": "Ev ziyaretleri bir araçta, çizelgedeki saatler başka birinde, bordro ise üçüncü bir sürümü alır. Bunları birbirine oturtmak aylık bir iş.",
            "title": "Ziyaretler ve vardiyalar ayrı sistemlerde"
          },
          {
            "body": "Farklı saatler farklı ücret taşır. Kayıt yaklaşıksa ödeme de yaklaşıktır — düzeltme ise sonra gelir.",
            "title": "Gece ve hafta sonu saatleri yanlış fiyatlanıyor"
          },
          {
            "body": "Bakım alanında yetkinlikler ve sertifikalar önemlidir; ama bir denetim sorana kadar kimsenin açmadığı bir klasörde durur.",
            "title": "Sertifikalar sessizce geçerliliğini yitiriyor"
          }
        ],
        "quote": {
          "who": "Koordinatör, evde bakım ekibi · 22 çalışan",
          "text": "Ev ziyaretleri ve çizelgedeki vardiyalar nihayet aynı kayıtta. Bordro artık bir mutabakat işi olmaktan çıktı.",
          "result": "Üç kayıt yerine tek kayıt"
        },
        "stats": [
          {
            "label": "ya da vardiya başına — ekibiniz nasıl çalışıyorsa",
            "value": "Ziyaret başına"
          },
          {
            "label": "gece ve hafta sonu saatleri, çalışıldığı gibi kaydedilir",
            "value": "Ayrı"
          },
          {
            "label": "çalışan başına saklanan sertifikalar",
            "value": "Arşivde"
          }
        ],
        "features": [
          {
            "body": "Vardiya başında ya da evde bakımda her müşteri adresinde tek dokunuş — kanıt gereken yerde konum doğrulamalı.",
            "title": "Vardiya ya da ziyaret bazında giriş"
          },
          {
            "body": "Gece, hafta sonu ve normal saatler ayrı ayrı kaydedilir; böylece bordro dışa aktarımı işin gerçekte nasıl ödendiğini zaten yansıtır.",
            "title": "Saatler ödediğiniz şekilde ayrılır"
          },
          {
            "body": "Sözleşmeler, sertifikalar ve kimlikler ait oldukları kişinin yanında saklanır — biri istediğinde saniyeler içinde bulunur.",
            "title": "Çalışan belgeleri tek yerde"
          }
        ],
        "headline": "Bakım ekipleri için mesai takibi — vardiyalar, ev ziyaretleri ve yetkinlikler tek kayıtta",
        "workflow": [
          {
            "body": "Lokasyonda ya da müşterinin adresinde tek dokunuş; kanıt gereken yerde konum doğrulamalı.",
            "step": "Vardiya ya da ziyaret için giriş yapın"
          },
          {
            "body": "Normal, gece ve hafta sonu saatleri gerçekleştikçe ayrı ayrı kaydedilir.",
            "step": "Saatler doğru kalemde toplanır"
          },
          {
            "body": "Dönem başına tek temiz dosya, zaten ödediğiniz şekilde ayrılmış olarak.",
            "step": "Bordro için dışa aktarın"
          }
        ],
        "compliance": {
          "body": "Done-it çalışan başına çalışma süresinin dijital ve nesnel bir kaydını tutar — saatler, molalar ve gece/hafta sonu ayrımları — her kişiye ait belgelerle birlikte.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Vardiya ve ziyaret kaydı",
          "title": "Denetimden sağ çıkan kayıtlar"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ],
    "lt": [
      {
        "name": "Statyba",
        "slug": "construction",
        "intro": "Komandos išsibarsčiusios po objektus, valandos užrašytos ant popieriaus, subrangovų valandų neįmanoma suderinti. Done-it suteikia kiekvienam objektui sandarų skaitmeninį darbo laiko žiniaraštį, kuris vienu paspaudimu pasiekia Jūsų darbo užmokesčio sistemą.",
        "pains": [
          {
            "body": "Su keliais aktyviais objektais ir besikeičiančiomis komandomis rankiniai žiniaraščiai klaidingi iš prigimties. Darbuotojai suapvalina, pamiršta įrašus arba užpildo juos po kelių dienų — palikdami Jus su darbo užmokesčio skaičiais, kurių negalite apginti.",
            "title": "Nėra patikimo įrašo, kas kur dirbo"
          },
          {
            "body": "Kol pastebite, kad objektas išnaudojo planuotas valandas, marža jau dingusi. Nėra atskaitos realiu laiku — tik nemaloni staigmena išrašant sąskaitą.",
            "title": "Biudžeto viršijimai išryškėja per vėlai"
          },
          {
            "body": "Žiniaraščių rinkimas, jų suderinimas su projektais ir darbo užmokesčio eksporto paruošimas užtrunka dienas. Kiekvienas įrašas yra potenciali klaida.",
            "title": "Darbo užmokesčio paruošimas suvalgo valandas kiekvieną mėnesį"
          }
        ],
        "quote": {
          "who": "Savininkas, statybų įmonė · 14 darbuotojų",
          "text": "Mūsų komanda registruojasi pati objekte. Mėnesio pabaigoje darbo užmokestis tiesiog susidėlioja — visiškai nustojome vaikytis žiniaraščių.",
          "result": "5 valandos per savaitę sutaupytos administracijai"
        },
        "stats": [
          {
            "label": "kad užsiregistruotumėte bet kuriame objekte — be terminalo, be popieriaus",
            "value": "1 prisilietimas"
          },
          {
            "label": "darbo užmokesčio eksportas paruoštas Jūsų paslaugų teikėjui",
            "value": "1 paspaudimas"
          },
          {
            "label": "likusių valandų rodinys pagal projektą ir objektą",
            "value": "Realiu laiku"
          }
        ],
        "features": [
          {
            "body": "Vienas prisilietimas užregistruoja darbuotoją su vietos patvirtinimu ir susieja valandas su tinkamu projektu. Jokių kortelių skaitytuvų ar terminalų — tik išmanusis telefonas, kurį Jūsų komanda jau turi.",
            "title": "Registracija su vietos patvirtinimu kiekviename objekte"
          },
          {
            "body": "Atidarydami projektą nustatykite planuojamas valandas kaip biudžetą. Darbuotojai mato likusio laiko atskaitą; Jūs matote tai realiu laiku savo skydelyje. Biudžeto viršijimai matomi anksčiau, nei įvyksta.",
            "title": "Likusios valandos pagal projektą realiu laiku"
          },
          {
            "body": "Pridėkite subrangovus prie projekto, priskirkite juos registracijai ir sekite jų valandas kartu su savo komanda — toje pačioje apžvalgoje.",
            "title": "Subrangovų valdymas ir buvimas"
          },
          {
            "body": "Visos registruotos valandos — pagal darbuotoją, pagal projektą — eksportuojamos į švarią skaičiuoklę Jūsų darbo užmokesčio paslaugų teikėjui. Jokio rankinio paruošimo, jokių klaidų.",
            "title": "Darbo užmokesčio eksportas vienu paspaudimu"
          }
        ],
        "headline": "Darbo laiko apskaita statybų komandoms — registracija su vietos patvirtinimu, projekto valandos ir biudžeto kontrolė vienoje programėlėje",
        "workflow": [
          {
            "body": "Kiekvienas darbuotojas paliečia vieną kartą, kad užsiregistruotų. GPS patvirtina vietą, pažymi įrašo laiką ir susieja valandas su projektu. Jokio popieriaus, jokio terminalo.",
            "step": "Komanda atvyksta į objektą"
          },
          {
            "body": "Valandos, likęs biudžetas, subrangovų buvimas ir bet kokie iš objekto praneši papildomi darbai — viskas Jūsų skydelyje, realiu laiku.",
            "step": "Matote viską realiu laiku"
          },
          {
            "body": "Eksportuokite visas valandas pagal darbuotoją ir projektą. Siųskite savo darbo užmokesčio paslaugų teikėjui. Done-it automatiškai generuoja švarias, auditui paruoštas ataskaitas.",
            "step": "Mėnesio pabaiga per minutes"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia registraciją su vietos patvirtinimu, darbo laiko apskaitą pagal projektą ir švarų darbo užmokesčio eksportą statybų komandoms. Komandoms, dirbančioms Belgijos objektuose, jis taip pat automatiškai perduoda registraciją atvykstant į darbą.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė darbo laiko registracija",
          "title": "Registracija su vietos patvirtinimu, sukurta statybvietėms"
        },
        "relatedSlugs": [
          "installation",
          "maintenance",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551027/blog/industry-construction.jpg"
      },
      {
        "name": "Valymas",
        "slug": "cleaning",
        "intro": "Valytojai visą dieną juda tarp vietų. Done-it seka, kas kur yra, realiu laiku — registracija su vietos patvirtinimu kiekviename objekte, automatinis pertraukų atėmimas ir švarus darbo užmokesčio eksportas mėnesio pabaigoje.",
        "pains": [
          {
            "body": "Klientai ir inspektoriai tikisi sandarių lankomumo įrašų. Rankiniai lapai gali būti ginčijami; skaitmeninės registracijos su vietos patvirtinimu — ne.",
            "title": "Buvimo įrodymas kiekvienoje vietoje"
          },
          {
            "body": "Valytojams visą dieną judant tarp objektų, Jūs neturite vaizdo realiu laiku, kas kur dirba — kol kažkas paskambina.",
            "title": "Komandos išsibarsčiusios po daugelį vietų"
          },
          {
            "body": "Be tikslaus atvykimo ir išvykimo laiko darbo užmokestis atkuriamas iš atminties. Valandos suapvalinamos į viršų, sąnaudos didėja ir kyla ginčai.",
            "title": "Darbo užmokesčio klaidos dėl suapvalintų valandų"
          }
        ],
        "quote": {
          "who": "Vadovas, valymo įmonė · 9 darbuotojai",
          "text": "Pagaliau galime įrodyti, kas kur ir kada valė. Jokių daugiau lankomumo lapų, jokių klientų ginčų — GPS tuo pasirūpina.",
          "result": "Jokio valandų apvalinimo į viršų"
        },
        "stats": [
          {
            "label": "kad užsiregistruotumėte bet kurioje vietoje — terminalo nereikia",
            "value": "1 prisilietimas"
          },
          {
            "label": "vaizdas, kas kuriame objekte yra šiuo metu",
            "value": "Realiu laiku"
          },
          {
            "label": "dvigubų įrašų — valandos teka tiesiai į darbo užmokestį",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Darbuotojai registruojasi ir išsiregistruoja telefonu kiekvienoje vietoje su vietos patvirtinimu; laikas tikslus, su pertraukų registracija.",
            "plan": "Time Basic",
            "title": "Registracija ir išsiregistravimas realiu laiku"
          },
          {
            "body": "Privalomos pertraukos automatiškai atimamos iš darbo dienos — jokios rankinės matematikos, jokių ginčų.",
            "plan": "Time Basic",
            "title": "Automatinis pertraukų atėmimas"
          },
          {
            "body": "Matykite, kurie valytojai yra kuriose vietose šiuo metu. Pastebėkite spragas anksčiau už klientus.",
            "title": "Daugelio vietų apžvalga realiu laiku"
          },
          {
            "body": "Darbuotojai įkelia nedarbingumo pažymėjimus ir nebuvimo dokumentus tiesiai iš programėlės. Sukurkite nebuvimo tipus, kuriuos Jūsų komanda iš tikrųjų naudoja.",
            "title": "Nebuvimo registracija su skaitmeniniais nedarbingumo pažymėjimais"
          },
          {
            "body": "Tikslūs laiko žymos teka tiesiai į darbo užmokesčiui paruoštą eksportą Jūsų paslaugų teikėjui. Jokio perrašymo, jokių klaidų.",
            "title": "Darbo užmokesčio eksportas vienu paspaudimu"
          }
        ],
        "headline": "Darbo laiko apskaita valymo įmonėms — registracija su vietos patvirtinimu, buvimo įrodymas ir darbo užmokestis vienoje programėlėje",
        "workflow": [
          {
            "body": "Vienas prisilietimas juos užregistruoja. GPS registruoja objektą ir pažymi įrašo laiką. Pertraukų registracija įmontuota programėlėje.",
            "step": "Valytojas atvyksta į vietą"
          },
          {
            "body": "Kas kuriame objekte yra šiuo metu — jokių skambučių, jokių spėliojimų. Pastebėkite aprėpties spragas anksčiau už klientus.",
            "step": "Matote kiekvieną vietą realiu laiku"
          },
          {
            "body": "Visi lankomumo duomenys — tikslus laikas, vietos ir pertraukos — švariai eksportuojami Jūsų darbo užmokesčio paslaugų teikėjui.",
            "step": "Darbo užmokestis vienu paspaudimu"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia valymo komandoms registraciją su vietos patvirtinimu kiekvienoje vietoje, automatinį pertraukų atėmimą ir vaizdą realiu laiku, kas kuriame objekte yra šiuo metu.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Lankomumas su vietos patvirtinimu",
          "title": "Lankomumas realiu laiku kiekvienoje valymo vietoje"
        },
        "relatedSlugs": [
          "maintenance",
          "field-service",
          "construction"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551026/blog/industry-cleaning.png"
      },
      {
        "name": "Montavimas",
        "slug": "installation",
        "intro": "Siųskite savo montuotojus tinkamu adresu su viskuo, ko jiems reikia, automatiškai susiekite kiekvieną dirbtą valandą su tinkamu darbu ir matykite likusį biudžetą prieš objektui užsidarant. Done-it yra paprasčiausias būdas išlaikyti montavimo projektus laiku ir pagal sąnaudas.",
        "pains": [
          {
            "body": "Komandos atvyksta į objektą be adreso, kontaktinio asmens ar apimties detalių. Tas pirmasis skambutis yra dešimt minučių apmokestinamo laiko, prarasto dar prieš dirbant vieną valandą.",
            "title": "Darbo informacija nepasiekia lauko komandos laiku"
          },
          {
            "body": "Kai darbuotojai dienos pabaigoje pildo valandas rankiniu būdu — jei iš viso pildo — valandos patenka į netinkamą darbą arba visai dingsta. Sąskaitos neatitinka realybės.",
            "title": "Valandos nesusietos su tinkamu projektu"
          },
          {
            "body": "Be likusių valandų atskaitos realiu laiku pagal projektą sužinote, kad darbas viršijo biudžetą, uždarydami sąskaitą — ne tada, kai dar galite reaguoti.",
            "title": "Biudžeto viršijimai pastebimi per vėlai"
          },
          {
            "body": "Subrangovai, dirbantys tame pačiame objekte, naudoja skirtingas sistemas, pildo valandas atskirai arba visai jų nepildo. Suderinimas mėnesio pabaigoje yra lėtas, klaidoms linkęs procesas.",
            "title": "Subrangovų valandas sunku sekti"
          }
        ],
        "quote": {
          "who": "Savininkas, montavimo įmonė · 6 darbuotojai",
          "text": "Valandos automatiškai patenka į tinkamą projektą. Darbo sąnaudų apskaita staiga tampa lengva — matome realią maržą prieš uždarydami darbą.",
          "result": "Realios sąnaudos pagal darbą, realiu laiku"
        },
        "stats": [
          {
            "label": "likusių valandų rodinys pagal projektą",
            "value": "Realiu laiku"
          },
          {
            "label": "skambučių į biurą dėl objektų adresų",
            "value": "0"
          },
          {
            "label": "naviguokite bet kuriuo projekto adresu iš programėlės",
            "value": "1 paspaudimas"
          }
        ],
        "features": [
          {
            "body": "Darbuotojai atidaro projektą telefone: adresas, planuojamos valandos, kontaktinis asmuo ir įkelti failai (planai, instrukcijos, PDF). Viskas, ko jiems reikia, yra ten dar prieš atvykstant.",
            "plan": "Project Basic",
            "title": "Projekto informacija dalijama tiesiai į programėlę"
          },
          {
            "body": "Paliečiate vieną kartą ir telefonas naviguoja projekto adresu — įmontuota programėlėje, atskiros žemėlapių programėlės nereikia.",
            "title": "Navigacija į objektą vienu mygtuku"
          },
          {
            "body": "Atidarydami projektą nustatykite planuojamas valandas. Darbuotojai mato, kiek valandų liko; Jūs matote būseną realiu laiku savo skydelyje. Viršijimai matomi anksčiau, nei įvyksta.",
            "plan": "Project Basic",
            "title": "Likusių valandų atskaita pagal projektą"
          },
          {
            "body": "Kiekvienas darbuotojas registruojasi tinkamame projekte. Visada žinote, kas kuriame objekte yra šiuo metu.",
            "plan": "Project Basic",
            "title": "Darbuotojų registracija pagal projektą"
          },
          {
            "body": "Kai objekte plečiasi apimtis, darbuotojai registruoja papildomus darbus ir medžiagas realiu laiku — su tekstu ir nuotraukomis — kad niekas nebūtų apmokestinta iš atminties.",
            "plan": "Project Basic",
            "title": "Papildomų darbų ir medžiagų registravimas"
          }
        ],
        "headline": "Darbo laiko apskaita montavimo komandoms — projekto valandos, navigacija ir biudžeto kontrolė vienoje programėlėje",
        "workflow": [
          {
            "body": "Adresas, kontaktas, apimtis ir įkelti failai yra čia pat. Jie naviguoja vienu prisilietimu — jokių skambučių į biurą dėl nurodymų.",
            "step": "Darbuotojas atidaro projektą telefone"
          },
          {
            "body": "Registracija susieja kiekvieną dirbtą minutę su tinkamu projektu. Likęs biudžetas atsinaujina realiu laiku.",
            "step": "Valandos automatiškai registruojamos tinkamam darbui"
          },
          {
            "body": "Apimties pakeitimai, papildomos medžiagos ir vėlavimai registruojami su tekstu ir nuotraukomis tą akimirką, kai įvyksta — paruošti sąskaitai.",
            "step": "Papildomi darbai fiksuojami objekte"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia montavimo komandoms registraciją su vietos patvirtinimu pagal projektą, likusių valandų atskaitą realiu laiku ir automatinį darbo užmokesčio eksportą — atitinkant bet kokį vietinį darbo laiko registracijos reikalavimą. Komandoms, dirbančioms Belgijos statybvietėse, jis taip pat integruojasi su CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė darbo laiko registracija",
          "title": "Registracija su vietos patvirtinimu pagal projektą montavimo komandoms"
        },
        "relatedSlugs": [
          "construction",
          "electricians",
          "hvac"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551034/blog/industry-installation.jpg"
      },
      {
        "name": "Lauko paslaugos",
        "slug": "field-service",
        "intro": "Technikai, lankantys kelis klientus per dieną, kvitai pirštinių dėtuvėse, kilometražas registruotas iš atminties. Done-it fiksuoja valandas, kilometrus ir išlaidas vietoje — susietus su tinkamu darbu tą akimirką, kai jie įvyksta.",
        "pains": [
          {
            "body": "Prašyti technikų savaitės pabaigoje atkurti savo maršrutus reiškia netikslias kompensacijas, ginčus su klientais ir augančią krūvą nepareikalautų kilometrų.",
            "title": "Kilometražas registruojamas po kelių dienų — jei iš viso"
          },
          {
            "body": "Kvitas pirštinių dėtuvėje yra sąnauda, kuri gali niekada nepatekti į sąskaitą. Reali sąnauda pagal darbą visada nepakankamai įvertinta.",
            "title": "Išlaidos ant popierinių kvitų, kurie dingsta"
          },
          {
            "body": "Be registracijų realiu laiku sužinote, kur technikas yra, tik kai kažkas nutinka ir kažkas paskambina.",
            "title": "Nėra vaizdo realiu laiku, kur yra komanda"
          },
          {
            "body": "Kai darbas, kelionės ir išlaidos sekamos atskirose sistemose — arba visai nesekamos — niekada nėra vienos sąnaudų sumos pagal darbą.",
            "title": "Sunku matyti faktinę maržą pagal darbą"
          }
        ],
        "quote": {
          "who": "Operacijų vadovas, lauko paslaugų įmonė · 11 darbuotojų",
          "text": "Kilometražas anksčiau buvo mėnesinis galvos skausmas. Dabar jis registruojasi pats — kiekvienas kilometras susiejamas su tinkamu klientu dar prieš mums grįžtant į biurą.",
          "result": "Tiksli sąnauda pagal darbą kiekvieną kartą"
        },
        "stats": [
          {
            "label": "kilometražo fiksavimas — be rankinio žurnalo",
            "value": "Automatinis"
          },
          {
            "label": "sąnauda pagal darbą: valandos + kelionės + išlaidos",
            "value": "Realiu laiku"
          },
          {
            "label": "prarastų kilometrų — kiekviena kelionė fiksuojama automatiškai",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "GPS registruoja išvykimą, atvykimą ir tikslų atstumą pagal kelionę. Konfigūruokite transporto tipus (nuosavas automobilis, įmonės transportas, bendra kelionė) su jų kompensacijos tarifais. Jokio rankinio kelionių žurnalo.",
            "plan": "Add-on",
            "title": "Automatinis kilometražo fiksavimas (Trax-it)"
          },
          {
            "body": "Darbuotojai nufotografuoja kvitą vietoje; jis susiejamas su darbu ir paruoštas kompensavimui — o ne vejamasis mėnesio pabaigoje.",
            "plan": "Time Basic",
            "title": "Išlaidų valdymas objekte"
          },
          {
            "body": "Valandos, kilometražas ir išlaidos priskiriamos darbui realiu laiku. Sąnauda pagal darbą matoma, kol darbas dar atviras.",
            "plan": "Project Basic",
            "title": "Su projektu susieta sąnaudų kontrolė"
          },
          {
            "body": "Kiekvienas technikas registruojasi kliento objekte. Matote, kas kur yra, šiuo metu — jokių skambučių, jokių spėliojimų.",
            "title": "Registracija su vietos patvirtinimu ir komandos apžvalga realiu laiku"
          },
          {
            "body": "Valandos ir kilometražo kompensacijos švariai eksportuojamos Jūsų darbo užmokesčio paslaugų teikėjui — su automatiškai pritaikytais Jūsų sukonfigūruotais kilometražo tarifais.",
            "title": "Darbo užmokesčio eksportas vienu paspaudimu"
          }
        ],
        "headline": "Darbo laiko apskaita lauko paslaugų komandoms — kilometražas, išlaidos ir valandos iš kelio, viskas vienoje programėlėje",
        "workflow": [
          {
            "body": "Registracija pradeda kelionės žurnalą. Kilometrai automatiškai fiksuojami nuo išvykimo iki atvykimo — be rankinio įvedimo.",
            "step": "Technikas išvyksta į pirmąjį iškvietimą"
          },
          {
            "body": "Valandos susiejamos su tinkamu projektu. Papildomi darbai, medžiagos ir kvitai registruojami programėlėje tą akimirką, kai įvyksta.",
            "step": "Darbo vietoje"
          },
          {
            "body": "Kiekviena valanda, kilometras ir išlaidos jau susieti su tinkamu darbu. Eksportuokite į darbo užmokestį ir išrašykite sąskaitą su realiais sąnaudų skaičiais.",
            "step": "Mėnesio pabaiga be chaoso"
          }
        ],
        "compliance": {
          "body": "Done-it automatiškai fiksuoja kilometražą pagal kelionę, pritaiko Jūsų sukonfigūruotus kompensacijos tarifus ir registruoja kiekvieną kilometrą tinkamam klientui ar projektui. ES Tyco sprendimas reiškia, kad kelionė iš namų pas pirmąjį klientą skaičiuojama kaip darbo laikas — Done-it tai taip pat seka.",
          "slug": "how-to-track-mileage-for-field-teams",
          "label": "Skaitmeninė laiko ir kilometražo apskaita",
          "title": "GPS valandos ir automatinis kilometražas lauko paslaugų komandoms"
        },
        "relatedSlugs": [
          "hvac",
          "maintenance",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551029/blog/industry-field-service.jpg"
      },
      {
        "name": "ŠVOK",
        "slug": "hvac",
        "intro": "Kiekvienas aptarnavimo iškvietimas turi tris sąnaudas: darbą, dalis ir keliones. Done-it fiksuoja visas tris vietoje ir priskiria jas tinkamam darbui — kad žinotumėte savo maržą prieš uždarydami sąskaitą.",
        "pains": [
          {
            "body": "Darbas, dalys ir kelionės gyvena skirtingose sistemose — arba skirtingose kišenėse. Reali iškvietimo sąnauda paaiškėja tik gerokai po to, kai technikas paliko objektą.",
            "title": "Aptarnavimo iškvietimus sunku tiksliai įvertinti"
          },
          {
            "body": "Kai klientas ginčija, kiek truko remontas, popierinį žiniaraštį lengva užginčyti. GPS patvirtintos registracijos ir išsiregistravimo laiko žymos — ne.",
            "title": "Nėra aptarnavimo laiko įrodymo"
          },
          {
            "body": "Pasikartojančiose priežiūros sutartyse maži viršijimai kaupiasi per daugelį vizitų. Be valandų skaitiklio realiu laiku sužinote, kad sutartis nuostolinga, tik atnaujinimo metu.",
            "title": "Priežiūros sutartys tyliai mažina maržą"
          },
          {
            "body": "Rankiniai laiko įrašai praleidžia pertraukas, todėl permokama ir darbo užmokestis neatitinka realybės.",
            "title": "Technikai pamiršta registruoti pertraukas"
          }
        ],
        "quote": {
          "who": "Savininkas, ŠVOK įmonė · 7 technikai",
          "text": "Pagaliau žinome, kiek mums iš tikrųjų kainuoja kiekviena aptarnavimo sutartis. Maržos staigmenos baigėsi tą dieną, kai pradėjome naudoti Done-it.",
          "result": "Reali sąnauda pagal aptarnavimo iškvietimą, realiu laiku"
        },
        "stats": [
          {
            "label": "sąnaudų tipai fiksuojami pagal iškvietimą: darbas, kelionės, dalys",
            "value": "3"
          },
          {
            "label": "maržos matomumas pagal aptarnavimo sutartį",
            "value": "Realiu laiku"
          },
          {
            "label": "staigmenų išrašant sąskaitą — sąnaudos matomos realiu laiku",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Kiekvienas aptarnavimo iškvietimas ar priežiūros sutartis yra projektas. Valandos, kelionės ir medžiagos priskiriamos realiu laiku — suteikdamos maržos matomumą realiu laiku.",
            "plan": "Project Basic",
            "title": "Projektu pagrįsta darbo laiko apskaita"
          },
          {
            "body": "Kai darbas išauga, technikai registruoja papildomus darbus ir dalis su tekstu bei nuotraukomis prieš išvykdami. Niekas neapmokestinama iš atminties.",
            "plan": "Project Basic",
            "title": "Papildomi darbai ir medžiagos, registruojami objekte"
          },
          {
            "body": "Kilometrai pagal iškvietimą registruojami automatiškai ir įvertinami darbui. Konfigūruokite kompensacijos tarifus pagal transporto tipą.",
            "plan": "Add-on",
            "title": "Kilometražas ir transporto sąnaudos"
          },
          {
            "body": "Privalomos pertraukos automatiškai atimamos iš bendro laiko — jokių ginčų, jokių darbo užmokesčio klaidų.",
            "title": "Automatinis pertraukų atėmimas"
          },
          {
            "body": "Laiku pažymėta, GPS patvirtinta registracija kiekviename objekte. Neginčijamas įrodymas, kada technikas atvyko ir išvyko.",
            "title": "Registracija su vietos patvirtinimu ir buvimo įrodymas"
          }
        ],
        "headline": "Darbo laiko apskaita ŠVOK technikams — darbo sąnaudų apskaita, dalys ir kelionės vienoje programėlėje",
        "workflow": [
          {
            "body": "GPS pažymi atvykimo laiką ir susieja valandas su aptarnavimo iškvietimu ar priežiūros sutartimi. Jokio popieriaus, jokio terminalo.",
            "step": "Technikas užsiregistruoja objekte"
          },
          {
            "body": "Panaudotos dalys, papildomos valandos ir apimties pakeitimai registruojami programėlėje su nuotraukomis — prieš paliekant objektą.",
            "step": "Papildomi darbai fiksuojami vietoje"
          },
          {
            "body": "Darbas, kelionės ir medžiagos sumuojami projektui realiu laiku. Matote maržą prieš išrašydami sąskaitą.",
            "step": "Darbo sąnauda matoma iškart"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia ŠVOK komandoms registraciją su vietos patvirtinimu pagal aptarnavimo iškvietimą, sąnaudų matomumą realiu laiku pagal darbą (darbas + kelionės + dalys) ir švarų darbo užmokesčio eksportą — atitinkant bet kokį vietinį darbo laiko registracijos reikalavimą be papildomos įrangos.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė laiko ir sąnaudų apskaita",
          "title": "Pilna darbo sąnaudų apskaita ŠVOK aptarnavimo iškvietimams"
        },
        "relatedSlugs": [
          "installation",
          "electricians",
          "plumbing"
        ],
        "relatedArticles": [
          "how-to-track-mileage-for-field-teams",
          "time-tracking-for-field-teams-complete-guide"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551030/blog/industry-hvac.jpg"
      },
      {
        "name": "Elektrikai",
        "slug": "electricians",
        "intro": "Valandos pagal projektą, likusio biudžeto atskaita realiu laiku ir navigacija į objektą vienu mygtuku — sukurta mažoms elektros komandoms, kurioms reikia projekto kontrolės be administracinės naštos.",
        "pains": [
          {
            "body": "Kai elektrikai per savaitę dirba prie kelių darbų, rankinis valandų priskyrimas dienos pabaigoje veda prie klaidingai priskirtų sąnaudų, sąskaitų ginčų ir darbo užmokesčio, kurio negalite paaiškinti.",
            "title": "Valandos nesusietos su tinkamu projektu"
          },
          {
            "body": "Be vaizdo realiu laiku, kiek valandų sunaudota palyginti su biudžetuotomis, sužinote, kad projektas viršijo biudžetą, išrašydami sąskaitą — ne tada, kai dar galite reaguoti.",
            "title": "Biudžeto viršijimai pastebimi per vėlai"
          },
          {
            "body": "Adresai įvedami į atskirą programėlę, skambučiai į biurą dėl nurodymų, vėlavimai pas klientus. Kiekviena prarasta minutė yra prarasta apmokestinama minutė.",
            "title": "Laikas švaistomas ieškant objekto"
          },
          {
            "body": "Didesniuose montavimo darbuose subrangovai elektrikai seka savo valandas atskirai. Gauti bendrą darbo sąnaudų vaizdą projekto pabaigoje yra rankinis, klaidoms linkęs darbas.",
            "title": "Subrangovų valandas sunku suderinti"
          }
        ],
        "quote": {
          "who": "Savininkas, elektros įmonė · 5 elektrikai",
          "text": "Realiu laiku žinome, ar projektas viršija biudžetą. Vien tai šiemet apsaugojo mus nuo dviejų blogų staigmenų.",
          "result": "Biudžeto viršijimai pagaunami anksčiau, nei įvyksta"
        },
        "stats": [
          {
            "label": "likusių valandų rodinys pagal projektą",
            "value": "Realiu laiku"
          },
          {
            "label": "skambučių į biurą dėl objektų adresų",
            "value": "0"
          },
          {
            "label": "kad užsiregistruotumėte bet kuriame objekte — terminalo nereikia",
            "value": "1 prisilietimas"
          }
        ],
        "features": [
          {
            "body": "Kiekviena dirbta minutė automatiškai susiejama su tinkamu projektu. Atskaita realiu laiku rodo, kiek valandų liko biudžete — Jums ir objekte esančiam darbuotojui.",
            "plan": "Project Basic",
            "title": "Projekto valandos su likusiu biudžetu realiu laiku"
          },
          {
            "body": "Projekto adresas yra programėlėje. Vienas prisilietimas atveria navigaciją — jokios paieškos, jokios atskiros žemėlapių programėlės, jokių skambučių į biurą.",
            "title": "Navigacija į objektą vienu mygtuku"
          },
          {
            "body": "Kiekvienas elektrikas registruojasi tinkamame darbe. Visada žinote, kas kuriame objekte yra šiuo metu.",
            "plan": "Project Basic",
            "title": "Darbuotojų registracija pagal projektą"
          },
          {
            "body": "Kai pasikeičia apimtis — netikėta grandinė, papildomos medžiagos — tai registruojama programėlėje su nuotraukomis, prieš komandai išvykstant.",
            "plan": "Project Basic",
            "title": "Papildomi darbai registruojami objekte"
          },
          {
            "body": "Viršvalandžiai registruojami tą akimirką, kai įvyksta. Darbuotojai pasirenka, ar jie bus apmokami, ar konvertuojami į laisvą laiką.",
            "plan": "Time Pro",
            "title": "Viršvalandžių apskaita su lanksčiu kompensavimu"
          }
        ],
        "headline": "Darbo laiko apskaita elektrikams — valandos pagal projektą, biudžeto kontrolė ir navigacija vienoje programėlėje",
        "workflow": [
          {
            "body": "Adresas ir apimtis jau yra programėlėje. Vienas prisilietimas atveria navigaciją — jokių skambučių, jokios painiavos.",
            "step": "Elektrikas naviguoja į darbą"
          },
          {
            "body": "Registracija objekte susieja kiekvieną dirbtą minutę su tinkamu projektu. Likusių valandų skaitiklis atsinaujina realiu laiku.",
            "step": "Valandos automatiškai susiejamos su tinkamu projektu"
          },
          {
            "body": "Papildomi darbai ir medžiagos registruojami objekte, prieš išvykstant. Sąskaita atspindi tai, kas iš tikrųjų įvyko.",
            "step": "Apimties pakeitimai lieka įraše"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia elektrikams registraciją su vietos patvirtinimu pagal projektą, likusių valandų biudžetą realiu laiku ir darbo užmokesčio eksportą — atitinkant bet kokį vietinį darbo laiko registracijos reikalavimą. Komandoms Belgijos statybvietėse jis taip pat integruojasi su CheckIn@Work.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Registracija su vietos patvirtinimu pagal projektą",
          "title": "Biudžeto kontrolė realiu laiku ir registracija su vietos patvirtinimu elektros komandoms"
        },
        "relatedSlugs": [
          "installation",
          "hvac",
          "plumbing"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551028/blog/industry-electricians.jpg"
      },
      {
        "name": "Santechnika",
        "slug": "plumbing",
        "intro": "Skubūs iškvietimai, keli darbai per dieną, valandos užpildytos iš atminties savaitės pabaigoje — arba visai ne. Done-it tai paverčia vieno prisilietimo darbu kiekviename objekte ir vieno paspaudimo darbo užmokesčiu mėnesio pabaigoje.",
        "pains": [
          {
            "body": "Su keliais darbais per dieną santechnikai retai turi laiko pildyti tikslius žiniaraščius. Valandos suapvalinamos arba pamirštamos, o darbo užmokestis geriausiu atveju yra įvertinimas.",
            "title": "Iškvietimų valandos atkuriamos iš atminties"
          },
          {
            "body": "Kai klientas ginčija, kiek truko remontas, nėra objektyvaus įrašo. GPS patvirtintą skaitmeninę registraciją lengva pateikti — popierinį žiniaraštį — ne.",
            "title": "Nėra laiko objekte įrodymo"
          },
          {
            "body": "Kelionės tarp iškvietimų kaupiasi per savaitę ir mėnesį, tačiau be automatinio fiksavimo jos retai teisingai apmokestinamos ar kompensuojamos.",
            "title": "Kilometražas tarp darbų nesekamas"
          },
          {
            "body": "Mėnesio pabaigoje žiniaraščių vaikymasis, klaidų taisymas ir darbo užmokesčio eksporto kūrimas užima laiką, kurio Jūsų administracijos komanda neturėtų leisti.",
            "title": "Darbo užmokesčio paruošimas lėtas"
          }
        ],
        "quote": {
          "who": "Savininkas, santechnikos įmonė · 4 santechnikai",
          "text": "Anksčiau praleisdavome rytą mėnesio pabaigoje atkurdami valandas. Dabar tiesiog eksportuojame ir siunčiame. Darbo užmokesčio paslaugų teikėjas gauna jas švarias.",
          "result": "Darbo užmokesčio paruošimas nuo valandų iki minučių"
        },
        "stats": [
          {
            "label": "kad užsiregistruotumėte — pakankamai greita skubiems iškvietimams",
            "value": "1 prisilietimas"
          },
          {
            "label": "darbo užmokesčio eksportas Jūsų paslaugų teikėjui",
            "value": "1 paspaudimas"
          },
          {
            "label": "valandų atkurtų iš atminties mėnesio pabaigoje",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Atvykimas ir išvykimas registruojami vienu prisilietimu su vietos patvirtinimu. Pakankamai greita skubiems iškvietimams; pakankamai tikslu ginčams.",
            "plan": "Time Basic",
            "title": "Registracija su vietos patvirtinimu vienu prisilietimu kiekviename iškvietime"
          },
          {
            "body": "Privalomos pertraukos automatiškai atimamos iš bendro laiko — nieko pildyti, jokių darbo užmokesčio klaidų.",
            "plan": "Time Basic",
            "title": "Automatinis pertraukų atėmimas"
          },
          {
            "body": "Konfigūruokite transporto tipus ir kompensacijos tarifus. Kilometrai registruojami automatiškai ir susiejami su tinkamu klientu ar projektu.",
            "plan": "Add-on",
            "title": "Kilometražas fiksuojamas pagal kelionę"
          },
          {
            "body": "Darbuotojai pateikia nedarbingumo pažymėjimus skaitmeniniu būdu iš programėlės. Sukurkite nebuvimo tipus, kuriuos Jūsų komanda iš tikrųjų naudoja, įskaitant orų sukeltus vėlavimus.",
            "title": "Nebuvimo ir nedarbingumo pažymėjimų valdymas"
          },
          {
            "body": "Visi valandų ir kilometražo duomenys švariai eksportuojami Jūsų darbo užmokesčio paslaugų teikėjui — jokio rankinio paruošimo, jokio Excel.",
            "plan": "Time Basic",
            "title": "Darbo užmokesčio eksportas vienu paspaudimu"
          }
        ],
        "headline": "Darbo laiko apskaita santechnikos komandoms — greita registracija, tikslus darbo užmokestis ir buvimo įrodymas kiekvienam iškvietimui",
        "workflow": [
          {
            "body": "Vienas prisilietimas registruoja. GPS registruoja vietą ir laiką. Pakankamai greita skubiam darbui.",
            "step": "Santechnikas atvyksta į iškvietimą"
          },
          {
            "body": "Išsiregistravimas uždaro laiko įrašą. Kilometražas iki kito darbo pradedamas registruoti automatiškai.",
            "step": "Išvykimas pažymimas išeinant"
          },
          {
            "body": "Visi iškvietimai, valandos ir kilometrai švariai eksportuojami. Darbo užmokesčio paruošimas iš dienos virsta minutėmis.",
            "step": "Mėnesio pabaiga vienu paspaudimu"
          }
        ],
        "compliance": {
          "body": "Done-it apima bet kokį vietinį darbo laiko registracijos reikalavimą santechnikos komandoms — registracija su vietos patvirtinimu vienu prisilietimu pagal iškvietimą, automatinis pertraukų atėmimas ir švarus darbo užmokesčio eksportas. Jokių popierinių žiniaraščių, jokio rankinio atkūrimo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė darbo laiko registracija",
          "title": "Greita registracija su vietos patvirtinimu kiekvienam iškvietimui"
        },
        "relatedSlugs": [
          "hvac",
          "electricians",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "how-to-track-mileage-for-field-teams"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551037/blog/industry-plumbing.jpg"
      },
      {
        "name": "Kraštovaizdžio tvarkymas",
        "slug": "landscaping",
        "intro": "Sezono piko metu — daug objektų, besikeičiančios komandos ir daug kilometrų. Done-it išlaiko kiekvieną valandą, kiekvieną nebuvimą ir kiekvieną kelionę sutvarkytus — kad galėtumėte sutelkti dėmesį į darbą, o ne į popierizmą.",
        "pains": [
          {
            "body": "Laikini darbuotojai, besikeičiantys grafikai ir kintantys komandos dydžiai daro tikslią valandų apskaitą beveik neįmanomą su popieriumi. Kol suderinate mėnesio pabaigoje, kažko visada trūksta.",
            "title": "Sezonines komandas sudėtinga valdyti"
          },
          {
            "body": "Komanda, lankanti tris ar keturis objektus per dieną, generuoja valandas, kurias reikia teisingai padalyti. Rankinis įvedimas veda prie klaidingo priskyrimo ir ginčijamo darbo užmokesčio.",
            "title": "Valandos išsibarsčiusios po daugelį objektų"
          },
          {
            "body": "Blogo oro prastova yra reali kraštovaizdžio tvarkymo įvykis. Be skaitmeninio įrašo sustojimų dokumentavimas ir atlygio koregavimas yra lėtas ir klaidoms linkęs.",
            "title": "Orų sukeltus sustojimus sunku dokumentuoti"
          },
          {
            "body": "Įmonės furgonai, asmeniniai automobiliai ir bendros kelionės visą dieną kerta tarp objektų. Be automatinio fiksavimo tie kilometrai niekada nepatenka į sąnaudų vaizdą.",
            "title": "Kilometražas tarp objektų nesekamas"
          }
        ],
        "quote": {
          "who": "Savininkas, kraštovaizdžio tvarkymo įmonė · 12 sezoninių darbuotojų",
          "text": "Sezono pikas anksčiau reiškė darbo užmokesčio chaosą. Dabar mūsų brigadininkas patikrina programėlę, visi suregistruoti, o aš eksportuoju valandas paskutinę mėnesio dieną.",
          "result": "Jokio daugiau mėnesio pabaigos darbo užmokesčio atkūrimo"
        },
        "stats": [
          {
            "label": "kilometražo fiksavimas — jokio daugiau žurnalo",
            "value": "Automatinis"
          },
          {
            "label": "komandos apžvalga visuose objektuose",
            "value": "Realiu laiku"
          },
          {
            "label": "darbo užmokesčio eksportas visiems objektams ir visai komandai",
            "value": "1 paspaudimas"
          }
        ],
        "features": [
          {
            "body": "Matykite visą komandą, visus objektus realiu laiku. Žinokite, kas kur dirba, šiuo metu — ne mėnesio pabaigoje.",
            "title": "Daugelio objektų komandos apžvalga"
          },
          {
            "body": "Planuokite, kas kur dirba, tvarkykite paskutinės minutės pakeitimus ir siųskite grafiką į komandos telefonus — be skambučio kiekvienam asmeniui.",
            "plan": "Time Pro",
            "title": "Pamainų grafikas sezoninėms komandoms"
          },
          {
            "body": "Sukurkite pasirinktinius nebuvimo tipus savo sektoriui: sezoninius orų sustojimus, vaiko priežiūros atostogas, nedarbingumo dienas. Darbuotojai įkelia dokumentaciją skaitmeniniu būdu iš programėlės.",
            "title": "Pasirinktiniai nebuvimo tipai"
          },
          {
            "body": "Konfigūruokite transporto tipus (įmonės furgonas, asmeninis automobilis, bendros kelionės vairuotojas ar keleivis) su jų tarifais. Kilometrai registruojami automatiškai pagal kelionę.",
            "plan": "Add-on",
            "title": "Kilometražas su bendros kelionės sekimu"
          },
          {
            "body": "Sezono piko viršvalandžiai kaupiasi greitai. Kiekvienas darbuotojas gali pasirinkti būti apmokamas arba kaupti valandas kaip laisvą laiką — sekama skaidriai.",
            "plan": "Time Pro",
            "title": "Viršvalandžių apskaita su konvertavimu į atostogas"
          }
        ],
        "headline": "Darbo laiko apskaita kraštovaizdžio tvarkymo įmonėms — sezoninės komandos, keli objektai ir kilometražas vienoje apžvalgoje",
        "workflow": [
          {
            "body": "GPS registruoja atvykimą. Valandos automatiškai padalijamos į tinkamą vietą ir projektą — be rankinio priskyrimo dienos pabaigoje.",
            "step": "Komanda registruojasi pirmajame objekte"
          },
          {
            "body": "Brigadininkas registruoja sustojimą iš programėlės — švarus skaitmeninis įrašas, jokio papildomo popierizmo.",
            "step": "Orai sustabdo darbą"
          },
          {
            "body": "Valandos, nebuvimai ir kilometražas visuose objektuose ir kiekvienam komandos nariui švariai eksportuojami darbo užmokesčiui.",
            "step": "Mėnesio pabaiga: visi objektai, visa komanda, vienas eksportas"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia kraštovaizdžio tvarkymo komandoms skaitmeninę darbo laiko registraciją visuose objektuose ir sezoniniams darbuotojams — registracija su vietos patvirtinimu, pasirinktiniai nebuvimo tipai orų sustojimams ir švarus darbo užmokesčio eksportas, atitinkantis bet kokį vietinį reikalavimą.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė darbo laiko registracija",
          "title": "Registracija su vietos patvirtinimu ir nebuvimo sekimas sezoninėms kraštovaizdžio tvarkymo komandoms"
        },
        "relatedSlugs": [
          "maintenance",
          "construction",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551035/blog/industry-landscaping.jpg"
      },
      {
        "name": "Priežiūra",
        "slug": "maintenance",
        "intro": "Pasikartojančios priežiūros sutartys gyvena arba miršta nuo sąnaudų matomumo. Done-it registruoja kiekvieną vizitą, seka valandas pagal sutarties biudžetą ir suteikia Jums — ir Jūsų klientams — buvimo įrodymą kiekvienam iškvietimui.",
        "pains": [
          {
            "body": "Kai pasikartojančių vizitų valandos nesekamos pagal konkrečią sutartį, nežinote, ar klientas pelningas, iki metų pabaigos peržiūros — o tada jau per vėlu perkainoti.",
            "title": "Nėra sąnaudų matomumo pagal priežiūros sutartį"
          },
          {
            "body": "Pastatų valdytojai ir savininkai vis dažniau nori lankomumo įrašų: kas atvyko, kada atvyko, ką padarė. Popierinis žurnalas, pateiktas po kelių savaičių, neatitinka SLA reikalavimų.",
            "title": "Klientai tikisi įrodymo, kas buvo padaryta"
          },
          {
            "body": "Besikeičiančios pamainos daugelyje pasikartojančių objektų — su darbuotojais, kurie keičia vieni kitus — sukuria planavimo ir valandų sekimo galvosūkį, kurio rankiniai procesai negali patikimai išspręsti.",
            "title": "Pasikartojančius vizitus sunku planuoti ir registruoti"
          },
          {
            "body": "Teritorijų priežiūra, fasadų priežiūra ir lauko įrenginių darbai susiduria su orų sukeltais sustojimais. Norint juos teisingai dokumentuoti, reikia skaitmeninio pėdsako.",
            "title": "Orų sustojimai veikia ir lauko priežiūrą"
          }
        ],
        "quote": {
          "who": "Operacijų vadovas, priežiūros įmonė · 8 darbuotojai",
          "text": "Galime pasakyti pastatų valdytojui tiksliai, kas buvo objekte ir kada, per dvi minutes. Toks įrodymo lygis pakeitė tai, kaip klientai mus mato.",
          "result": "Klientų ginčai sumažėjo iki nulio"
        },
        "stats": [
          {
            "label": "sąnauda pagal priežiūros sutartį",
            "value": "Realiu laiku"
          },
          {
            "label": "buvimo įrodymas paruoštas klientams pareikalavus",
            "value": "GPS"
          },
          {
            "label": "sutarčių atnaujinimų nežinant savo maržos",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Kiekviena priežiūros sutartis yra projektas. Valandos automatiškai registruojamos jai, suteikdamos sąnaudų skaičių realiu laiku ir likusių valandų atskaitą kiekvienam klientui.",
            "plan": "Project Basic",
            "title": "Sutartimi pagrįsta sąnaudų apskaita"
          },
          {
            "body": "Laiku pažymėtos, su vietos patvirtinimu atliktos registracijos yra neginčijamas įrašas, kas buvo objekte, kada ir kiek laiko — paruoštas dalintis su klientais pareikalavus.",
            "title": "GPS patvirtintas buvimo įrodymas"
          },
          {
            "body": "Darbuotojai praneša apie problemas, atliktas užduotis ar papildomus darbus tiesiai iš programėlės — su tekstu ir nuotraukomis. Klientai gauna įrašą realiu laiku; Jūs turite dokumentaciją sąskaitoms.",
            "plan": "Project Basic",
            "title": "Atnaujinimai su nuotraukomis iš objekto"
          },
          {
            "body": "Planuokite pasikartojančius vizitus visose sutartyse, priskirkite darbuotojus ir tvarkykite pakeitimus — be skambučio kiekvienam asmeniui.",
            "plan": "Time Pro",
            "title": "Pasikartojantis pamainų grafikas"
          },
          {
            "body": "Konfigūruokite orų sustojimus ir kitus nebuvimo tipus. Darbuotojai registruoja juos iš programėlės; dokumentacija įkeliama skaitmeniniu būdu.",
            "title": "Nebuvimo tipai lauko priežiūrai"
          }
        ],
        "headline": "Darbo laiko apskaita priežiūros komandoms — pasikartojantys objektų vizitai, sąnauda pagal sutartį ir buvimo įrodymas vienoje programėlėje",
        "workflow": [
          {
            "body": "Registracija su vietos patvirtinimu registruoja atvykimo laiką ir susieja valandas su tinkama sutartimi. Buvimo įrodymas sukuriamas automatiškai.",
            "step": "Darbuotojas atvyksta į priežiūros objektą"
          },
          {
            "body": "Atliktas darbas ir bet kokios problemos pranešamos iš programėlės su nuotraukomis. Klientai gali tiksliai matyti, kas buvo padaryta.",
            "step": "Užduotys atliktos, problemos užregistruotos"
          },
          {
            "body": "Valandos kaupiasi pagal sutarties biudžetą realiu laiku. Žinote maržą prieš sutarties atnaujinimą.",
            "step": "Sąnauda pagal sutartį matoma iškart"
          }
        ],
        "compliance": {
          "body": "Done-it suteikia priežiūros komandoms GPS patvirtintą buvimo įrodymą pagal sutartį, pasirinktinius nebuvimo tipus ir sąnaudų vaizdą realiu laiku pagal pasikartojantį klientą — atitinkant bet kokį vietinį darbo laiko registracijos reikalavimą be papildomos įrangos.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Sutartimi pagrįsta darbo laiko apskaita",
          "title": "Sąnaudų matomumas realiu laiku pagal priežiūros sutartį"
        },
        "relatedSlugs": [
          "cleaning",
          "landscaping",
          "field-service"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ],
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551036/blog/industry-maintenance.jpg"
      },
      {
        "name": "Parduotuvės ir prekyba",
        "slug": "retail",
        "intro": "Atidarymo pamainos, vėlyvos pamainos ir nuolat kažkas ką nors pavaduoja. Done-it kiekvienai parduotuvei suteikia tvarkingą skaitmeninį įrašą, kas kurią pamainą dirbo — pažymėta savo telefone ir paruošta atlyginimams mėnesio pabaigoje.",
        "pains": [
          {
            "body": "Vienas pavaduoja sergantį kolegą, kitas uždarydamas užtrunka valanda ilgiau. Tai lieka užrašyta ant lapelio arba niekur — ir atlyginimai klaidingi dar nepradėjus skaičiuoti.",
            "title": "Pamainų mainai nepasiekia atlyginimų"
          },
          {
            "body": "Darbuotojai keliauja tarp padalinių, dirbantieji ne visą dieną dengia dvi vietas. Valandų rinkimas po parduotuvę ir jų sujungimas rankomis kainuoja dieną kas mėnesį.",
            "title": "Kelios parduotuvės, vienas atlyginimų skaičiavimas"
          },
          {
            "body": "Privalomos pertraukos nuskaičiuojamos iš atminties, o papildomos valandos suderinamos neoficialiai — būtent apie tai patikrinimas klausia pirmiausia.",
            "title": "Pertraukos ir viršvalandžiai — spėjimas"
          }
        ],
        "quote": {
          "who": "Savininkas, mažmeninė prekyba · 11 darbuotojų",
          "text": "Dvi parduotuvės ir daug dirbančiųjų ne visą dieną. Anksčiau pusė pavadavimo pamainų būdavo suskaičiuojama iš atminties. Dabar kiekviena valanda priskirta tinkamai parduotuvei, o atlyginimai užtrunka kelias minutes.",
          "result": "Pasiruošimas atlyginimams — nuo dienos iki mažiau nei valandos"
        },
        "stats": [
          {
            "label": "ir pamaina pažymėta — jokio terminalo prie kasos",
            "value": "1 bakstelėjimas"
          },
          {
            "label": "matote, kas dirba kiekvienoje parduotuvėje",
            "value": "Gyvai"
          },
          {
            "label": "pamainų mainų, pamestų pakeliui į atlyginimus",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Vienas bakstelėjimas savo telefone pamainos pradžioje. Jokio terminalo prie kasos, jokios bendros kortelės, jokio segtuvo prie sandėlio durų.",
            "title": "Pamainos žymėjimas prekybos salėje"
          },
          {
            "body": "Kiekviena parduotuvė — atskiras projektas. Pavaduojantis kitame padalinyje žymimas būtent tam padaliniui: matote valandas ten, kur jos iš tikrųjų atidirbtos.",
            "title": "Valandos po parduotuvę, darbuotojai tarp padalinių"
          },
          {
            "body": "Nustatykite pertraukų taisyklę kartą — ji galios kiekvienai pamainai. Viršvalandžiai fiksuojami tą pačią akimirką, o kiekvienas darbuotojas pasirenka apmokėjimą arba laisvą laiką.",
            "title": "Pertraukos nuskaičiuojamos automatiškai"
          }
        ],
        "headline": "Darbo laiko apskaita parduotuvėms — pamainos žymėjimas, pavadavimai ir atlyginimams paruoštas eksportas vienoje programėlėje",
        "workflow": [
          {
            "body": "Vienas bakstelėjimas telefone prasidedant pamainai. Pavadavimas kitame padalinyje žymimas tam padaliniui.",
            "step": "Darbuotojai pažymi pamainos pradžią"
          },
          {
            "body": "Gyvas vaizdas visuose padaliniuose — neužpildytą atidarymo pamainą pastebite dar prieš atidarant duris.",
            "step": "Matote, kas dirba kiekvienoje parduotuvėje"
          },
          {
            "body": "Valandos, pertraukos ir viršvalandžiai pagal darbuotoją ir parduotuvę, paruošti jūsų atlyginimų paslaugų teikėjui.",
            "step": "Atlyginimai — vienu eksportu"
          }
        ],
        "compliance": {
          "body": "Done-it saugo objektyvų skaitmeninį kiekvieno atvykimo ir išvykimo įrašą su pertraukomis ir viršvalandžiais — būtent tokį, kokio prašo auditas ar ginčas dėl atlyginimo.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pamaininė laiko apskaita",
          "title": "Pagrįstas kiekvienos atidirbtos pamainos įrašas"
        },
        "relatedSlugs": [
          "hospitality",
          "beauty",
          "offices"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Biurai ir profesinės paslaugos",
        "slug": "offices",
        "intro": "Buhalteriai, notarai, architektai, agentūros ir konsultantai apmoka savo laiką — arba bent jau turi žinoti, kur jis dingo. Done-it fiksuoja valandas tinkamam klientui ir projektui: prie darbo stalo arba kelyje.",
        "pains": [
          {
            "body": "Laikas, užrašytas savaitės pabaigoje, yra spėjamas laikas. Ištisos valandos tyliai dingsta tarp darbo ir sąskaitos.",
            "title": "Apmokamos valandos atkuriamos penktadienį"
          },
          {
            "body": "Kaina sutarta prieš kelis mėnesius. Ar darbas vis dar telpa į ją, paaiškėja tik kai kas nors susumuoja — dažniausiai per vėlai.",
            "title": "Nežinia, kiek iš tikrųjų kainuoja klientas"
          },
          {
            "body": "Dalis komandos biure, dalis namuose, dalis pas klientą. Buvimas darbe nustoja būti faktu ir tampa atkūrimu.",
            "title": "Hibridinis darbas palieka spragų įrašuose"
          }
        ],
        "quote": {
          "who": "Partneris, buhalterinės apskaitos įmonė · 8 darbuotojai",
          "text": "Anksčiau kas penktadienį atkurdavome visą savaitę. Dabar valandos jau priskirtos tinkamam klientui, ir matau, kurios bylos suryja visą honorarą.",
          "result": "Kas mėnesį atgautos apmokamos valandos"
        },
        "stats": [
          {
            "label": "valandos, matomos dar vykstant darbui",
            "value": "Pagal klientą"
          },
          {
            "label": "tas pats įrašas telefone ir naršyklėje",
            "value": "Biure ar kelyje"
          },
          {
            "label": "atlyginimams ir sąskaitoms",
            "value": "1 eksportas"
          }
        ],
        "features": [
          {
            "body": "Kiekvienas įrašas patenka į projektą, todėl valandas pagal klientą matote nieko neeksportuodami ir nieko neklausdami.",
            "title": "Valandos pagal klientą ir projektą"
          },
          {
            "body": "Ta pati programėlė telefone ar naršyklėje. Vizitas pas klientą įskaitomas kaip darbas tam klientui, o jei norite — kartu su kelione.",
            "title": "Veikia prie stalo ir išvykoje"
          },
          {
            "body": "Papildomos valandos fiksuojamos iškart, atostogos prašomos ir tvirtinamos programėlėje — jokios lygiagrečios skaičiuoklės, kas ir kada nedirba.",
            "title": "Viršvalandžiai ir atostogos vienoje vietoje"
          }
        ],
        "headline": "Darbo laiko apskaita biurams — valandos pagal klientą ir projektą be skaičiuoklių",
        "workflow": [
          {
            "body": "Nustatykite kartą: klientą ir, jei dirbate pagal biudžetą, suplanuotas valandas.",
            "step": "Sukurkite kliento projektą"
          },
          {
            "body": "Prie stalo arba telefone. Kiekviena valanda patenka klientui, o ne į kažkieno atmintį.",
            "step": "Komanda fiksuoja laiką jame"
          },
          {
            "body": "Gyvos projektų sumos ir tvarkingas eksportas atlyginimams ar sąskaitoms mėnesio pabaigoje.",
            "step": "Matykite valandas pagal klientą, eksportuokite atlyginimams"
          }
        ],
        "compliance": {
          "body": "Done-it saugo skaitmeninį, klastojimą atskleidžiantį kiekvieno darbuotojo darbo laiko įrašą — pagrindą ir atlyginimams, ir pagrįstai kliento sąskaitai.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Laiko apskaita pagal klientą",
          "title": "Objektyvus atidirbtų valandų įrašas"
        },
        "relatedSlugs": [
          "retail",
          "healthcare",
          "wellness"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Salonai ir kūno priežiūra",
        "slug": "beauty",
        "intro": "Kirpyklos, barberiai, nagų ir grožio studijos dirba pamainomis ir su ne viso etato sutartimis. Done-it fiksuoja, kas ir kada dirbo, automatiškai nuskaičiuoja pertraukas ir pateikia buhalterijai tvarkingą failą.",
        "pains": [
          {
            "body": "Vieną savaitę trys dienos, kitą keturios, šeštadienis iškeistas į antradienį. Sutartos ir atidirbtos valandos greitai išsiskiria.",
            "title": "Ne viso etato sutartys, begalė variantų"
          },
          {
            "body": "Registracijos rodo, kas buvo užsakyta, o ne kas dirbo. Kai klausia buhalterija ar inspekcija, rezervacijų sistema yra netinkamas atsakymas.",
            "title": "Klientų žurnalas nėra darbo laiko apskaita"
          },
          {
            "body": "Pasilikimas paskutiniam klientui prisimenamas, pažadamas ir kartais pamirštamas. Būtent tokia spraga virsta ginču.",
            "title": "Papildomos valandos suderinamos neoficialiai"
          }
        ],
        "quote": {
          "who": "Savininkė, kirpykla · 6 darbuotojai",
          "text": "Visi dirba ne visą etatą ir kiekviena savaitė kitokia. Programėlė tiesiog viską užfiksuoja — nustojau kas mėnesį perrašinėti skaičiuoklę.",
          "result": "Mėnesio pabaigoje nebelieka ginčų dėl valandų"
        },
        "stats": [
          {
            "label": "ir pamaina pažymėta — nieko bendro, nieko popieriuje",
            "value": "1 bakstelėjimas"
          },
          {
            "label": "nuskaičiuojamos pertraukos kiekvienoje pamainoje",
            "value": "Automatiškai"
          },
          {
            "label": "vėlyvų valandų, suskaičiuotų iš atminties",
            "value": "0"
          }
        ],
        "features": [
          {
            "body": "Vienas bakstelėjimas savo telefone pamainos pradžioje — jokio bendro terminalo prie registratūros, jokio parašų sąrašo prie veidrodžio.",
            "title": "Pamainos žymėjimas salone"
          },
          {
            "body": "Nustatykite pertraukų taisyklę ir standartines valandas vieną kartą; jos galios kiekvienai pamainai, su išimtimis tiems, kurių sutartis kitokia.",
            "title": "Pertraukų ir ne viso etato taisyklės — kartą"
          },
          {
            "body": "Papildomos valandos fiksuojamos tą pačią akimirką, o kiekvienas darbuotojas renkasi apmokėjimą arba laisvą laiką — sutvarkoma programėlėje, o ne iš atminties.",
            "title": "Viršvalandžiai — apmokėti arba atsiimti"
          }
        ],
        "headline": "Darbo laiko apskaita salonams — pamainos, ne viso etato valandos ir atlyginimai be popierinio žurnalo",
        "workflow": [
          {
            "body": "Vienas bakstelėjimas atėjus. Pertraukos nuskaičiuojamos pagal kartą nustatytą taisyklę.",
            "step": "Darbuotojai pažymi pamainos pradžią"
          },
          {
            "body": "Kas dirba, kas per pertrauką, kas pasiliko ilgiau — gyvai ir nieko neklausiant.",
            "step": "Matote dieną tokią, kokia ji vyksta"
          },
          {
            "body": "Atidirbtos valandos, pertraukos ir viršvalandžiai pagal darbuotoją, eksportuoti jūsų atlyginimų paslaugų teikėjui.",
            "step": "Buhalterija gauna tvarkingą failą"
          }
        ],
        "compliance": {
          "body": "Done-it fiksuoja faktinį kiekvieno darbuotojo darbo laiką su pertraukomis ir viršvalandžiais — atskirai nuo rezervacijų ir pagrįstai, kai tikrinama.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Skaitmeninė laiko apskaita",
          "title": "Įrašas, kuris galioja ir be registracijų žurnalo"
        },
        "relatedSlugs": [
          "wellness",
          "retail",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sveikata ir sveikatingumas",
        "slug": "wellness",
        "intro": "Sporto klubai, fitneso studijos, kineziterapijos kabinetai ir SPA dirba ilgas valandas su besikeičiančiomis pamainomis. Done-it fiksuoja, kas kurią pamainą dengė, automatiškai nuskaičiuoja pertraukas ir tvarkingai eksportuoja duomenis atlyginimams.",
        "pains": [
          {
            "body": "Ankstyvos pamainos, vakarinės treniruotės ir savaitgaliai, kuriuos dengia visą ir ne visą etatą dirbantys bei laisvai samdomi darbuotojai. Grafikas yra planas, o ne apskaita.",
            "title": "Ilgas darbo laikas, nuolat besikeičiantys pavadavimai"
          },
          {
            "body": "Instruktorius veda dvi treniruotes, o tarp jų budi registratūroje. Kad apmokėtumėte teisingai, reikia žinoti, kas iš tikrųjų atidirbta, o ne kas buvo suplanuota.",
            "title": "Treniruočių ir salės valandos susilieja"
          },
          {
            "body": "Darbuotojai juda tarp studijų. Kas mėnesį sujungti jų valandas rankomis lėta ir klaidinga.",
            "title": "Kelios vietos, viena administracija"
          }
        ],
        "quote": {
          "who": "Vadovas, fitneso studija · 14 darbuotojų",
          "text": "Dvi studijos, ilgas darbo laikas ir daug pavadavimo pamainų. Dabar valandos patenka į tinkamą vietą, o atlyginimams užtenka vieno failo.",
          "result": "Grafikas ir atlyginimai pagaliau sutampa"
        },
        "stats": [
          {
            "label": "valandos, net kai darbuotojai pavaduoja kitur",
            "value": "Pagal studiją"
          },
          {
            "label": "matote salę visose vietose",
            "value": "Gyvai"
          },
          {
            "label": "pertraukos ir viršvalandžiai, be skaičiavimų ranka",
            "value": "Automatiškai"
          }
        ],
        "features": [
          {
            "body": "Vienas bakstelėjimas telefone toje vietoje, kurioje dirbama. Pavadavimas kitoje studijoje patenka į tos studijos valandas.",
            "title": "Pamainos žymėjimas kiekvienoje studijoje"
          },
          {
            "body": "Matykite salę visose vietose realiu laiku — neužpildyta ankstyva pamaina matoma dar prieš atidarant duris, o ne po to.",
            "title": "Gyvas vaizdas, kas dirba"
          },
          {
            "body": "Pertraukų taisyklės taikomos automatiškai, papildomos valandos fiksuojamos iškart, o kiekvienas darbuotojas renkasi apmokėjimą arba laisvą laiką.",
            "title": "Pertraukos ir viršvalandžiai — sutvarkyti"
          }
        ],
        "headline": "Darbo laiko apskaita sporto klubams, studijoms ir SPA — pamainos, treniruotės ir atlyginimai vienoje programėlėje",
        "workflow": [
          {
            "body": "Vienas bakstelėjimas pamainos pradžioje, toje vietoje, kurioje dirbama.",
            "step": "Darbuotojai pažymi pamainą studijoje"
          },
          {
            "body": "Kas ir kurioje vietoje dirba dabar, kad spragas užpildytumėte anksčiau, nei pastebės klientai.",
            "step": "Pavadavimai matomi gyvai"
          },
          {
            "body": "Valandos, pertraukos ir viršvalandžiai pagal darbuotoją ir studiją, paruošti atlyginimų paslaugų teikėjui.",
            "step": "Vienas eksportas atlyginimams"
          }
        ],
        "compliance": {
          "body": "Done-it saugo skaitmeninį darbo laiko įrašą pagal darbuotoją ir vietą — pagrindą teisingam apmokėjimui ir bet kokiam atidirbtų valandų patikrinimui.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pamainų apskaita keliose vietose",
          "title": "Objektyvus įrašas kiekvienai pamainai ir vietai"
        },
        "relatedSlugs": [
          "beauty",
          "healthcare",
          "hospitality"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Maitinimas ir apgyvendinimas",
        "slug": "hospitality",
        "intro": "Suskaidytos pamainos, vėlyvi uždarymai ir šeštadienis, kuris užsitęsia. Done-it fiksuoja valandas tokias, kokios iš tikrųjų atidirbtos, nuskaičiuoja pertraukas pagal jūsų taisyklę ir pateikia buhalterijai vieną tvarkingą failą.",
        "pains": [
          {
            "body": "Aptarnavimas užsitęsia, uždarymas atima dar pusvalandį. Tos minutės yra tikras darbas, o skaičiavimas iš atminties — ginčų pradžia.",
            "title": "Pamaina niekada nesibaigia taip, kaip rašo grafikas"
          },
          {
            "body": "Pietų aptarnavimas, pertrauka, tada vakarienė. Popieriuje tai virsta vienu ilgu bloku arba dviem spėjimais — nė vienas variantas nėra tiesa.",
            "title": "Suskaidytas pamainas sunku užfiksuoti"
          },
          {
            "body": "Kiekvieną sezoną nauji darbuotojai. Bet kokia sistema, kuriai reikia mokymų, neišgyvens pirmos įtemptos savaitės.",
            "title": "Didelė kaita, nuolatinis naujokų mokymas"
          }
        ],
        "quote": {
          "who": "Savininkas, restoranas · 17 darbuotojų",
          "text": "Uždarymas visada užsitęsia. Dabar tos minutės fiksuojamos, o ne ginčijamos, ir darbuotojai gali jas atsiimti laisvu laiku.",
          "result": "Mažiau ginčų, greitesni atlyginimai"
        },
        "stats": [
          {
            "label": "užfiksuotos kaip du blokai, o ne vienas spėjimas",
            "value": "Suskaidytos pamainos"
          },
          {
            "label": "nuskaičiuojamos pertraukos pagal jūsų taisyklę",
            "value": "Automatiškai"
          },
          {
            "label": "naujam darbuotojui pradėti — tai jo paties telefonas",
            "value": "1 min."
          }
        ],
        "features": [
          {
            "body": "Vienas bakstelėjimas kiekvieno bloko pradžioje ir pabaigoje, kad suskaidytos pamainos būtų užfiksuotos tokios, kokios buvo — o ne sulietos į vieną.",
            "title": "Žymėjimas kiekvieno aptarnavimo pradžioje ir pabaigoje"
          },
          {
            "body": "Privalomos pertraukos nuskaičiuojamos automatiškai, su išimtimis tiems, kurių sutartis to reikalauja. Jokių skaičiavimų ranka mėnesio pabaigoje.",
            "title": "Pertraukos pagal jūsų taisyklę"
          },
          {
            "body": "Papildomas pusvalandis po uždarymo fiksuojamas tą pačią akimirką ir apmokamas arba atsiimamas laisvu laiku — renkasi pats darbuotojas.",
            "title": "Viršvalandžiai sutvarkomi programėlėje"
          }
        ],
        "headline": "Darbo laiko apskaita kavinėms, restoranams ir viešbučiams — pamainos, pertraukos ir viršvalandžiai, apskaityti sąžiningai",
        "workflow": [
          {
            "body": "Vienas bakstelėjimas bloko pradžioje ir toks pat pabaigoje. Suskaidytos pamainos lieka suskaidytos.",
            "step": "Darbuotojai pažymi aptarnavimo pradžią"
          },
          {
            "body": "Kas dirba šio vakaro aptarnavime, kas dar per pertrauką, kas pasiliko po uždarymo.",
            "step": "Matote salę gyvai"
          },
          {
            "body": "Atidirbtas laikas, pertraukos ir viršvalandžiai pagal darbuotoją, eksportuoti vienu failu.",
            "step": "Buhalterija gauna tikras valandas"
          }
        ],
        "compliance": {
          "body": "Done-it saugo objektyvų skaitmeninį kiekvienos pamainos, pertraukos ir papildomos valandos įrašą — būtent tai, ko prašo atlyginimų patikra ar darbo inspekcija.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Suskaidytų pamainų apskaita",
          "title": "Pagrįstas valandų įrašas komandoje, kurioje didelė kaita"
        },
        "relatedSlugs": [
          "retail",
          "wellness",
          "beauty"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "reducing-payroll-admin-for-field-service-companies"
        ]
      },
      {
        "name": "Sveikatos ir slaugos paslaugos",
        "slug": "healthcare",
        "intro": "Kabinetai, slaugos namuose komandos ir globos namai dirba pagal pamainas, vizitus ir griežtus apskaitos reikalavimus. Done-it registruoja atidirbtą laiką pagal pamainą ir pagal vizitą, o darbuotojų dokumentus laiko ten, kur juos rasite.",
        "pains": [
          {
            "body": "Vizitai namuose vienoje programoje, grafiko valandos kitoje, o buhalterija gauna trečią versiją. Jų suderinimas virsta mėnesiniu darbu.",
            "title": "Vizitai ir pamainos — atskirose sistemose"
          },
          {
            "body": "Už nepatogų laiką mokami kitokie tarifai. Kai apskaita apytikslė, toks pat ir atlyginimas — o pataisymas ateina vėliau.",
            "title": "Naktinės ir savaitgalio valandos įkainotos klaidingai"
          },
          {
            "body": "Kvalifikacijos ir pažymėjimai slaugoje yra svarbūs, tačiau guli aplanke, kurio niekas neatverčia, kol nepaklausia inspekcija.",
            "title": "Pažymėjimai tyliai baigia galioti"
          }
        ],
        "quote": {
          "who": "Koordinatorė, slaugos namuose komanda · 22 darbuotojai",
          "text": "Vizitai namuose ir grafiko pamainos pagaliau yra tame pačiame įraše. Atlyginimai nustojo būti derinimo pratybomis.",
          "result": "Vienas įrašas vietoj trijų"
        },
        "stats": [
          {
            "label": "arba pagal pamainą — kaip dirba jūsų komanda",
            "value": "Pagal vizitą"
          },
          {
            "label": "naktinės ir savaitgalio valandos, fiksuotos kaip atidirbtos",
            "value": "Atskirai"
          },
          {
            "label": "pažymėjimai saugomi prie kiekvieno darbuotojo",
            "value": "Sutvarkyta"
          }
        ],
        "features": [
          {
            "body": "Vienas bakstelėjimas pamainos pradžioje arba prie kiekvieno kliento adreso teikiant priežiūrą namuose — su vietos patvirtinimu ten, kur reikia įrodymo.",
            "title": "Žymėjimas pagal pamainą arba pagal vizitą"
          },
          {
            "body": "Naktinės, savaitgalio ir įprastos valandos fiksuojamos atskirai, todėl eksportas atlyginimams jau atspindi, kaip darbas iš tikrųjų apmokamas.",
            "title": "Valandos suskirstytos taip, kaip už jas mokate"
          },
          {
            "body": "Sutartys, pažymėjimai ir asmens dokumentai saugomi prie to žmogaus, kuriam priklauso — randami per kelias sekundes, kai kas nors jų paprašo.",
            "title": "Darbuotojų dokumentai vienoje vietoje"
          }
        ],
        "headline": "Darbo laiko apskaita slaugos komandoms — pamainos, vizitai namuose ir kvalifikacijos viename įraše",
        "workflow": [
          {
            "body": "Vienas bakstelėjimas vietoje arba kliento adresu, su vietos patvirtinimu ten, kur reikia įrodymo.",
            "step": "Pažymėkite pamainos ar vizito pradžią"
          },
          {
            "body": "Įprastos, naktinės ir savaitgalio valandos fiksuojamos atskirai tą pačią akimirką.",
            "step": "Valandos patenka į tinkamą kategoriją"
          },
          {
            "body": "Vienas tvarkingas failas už laikotarpį, jau suskirstytas taip, kaip mokate.",
            "step": "Eksportas atlyginimams"
          }
        ],
        "compliance": {
          "body": "Done-it saugo skaitmeninį, objektyvų kiekvieno darbuotojo darbo laiko įrašą — valandas, pertraukas ir nepatogaus laiko atskyrimą — kartu su kiekvienam žmogui priklausančiais dokumentais.",
          "slug": "time-tracking-for-field-teams-complete-guide",
          "label": "Pamainų ir vizitų apskaita",
          "title": "Įrašai, kurie atlaiko patikrinimą"
        },
        "relatedSlugs": [
          "wellness",
          "offices",
          "cleaning"
        ],
        "relatedArticles": [
          "time-tracking-for-field-teams-complete-guide",
          "gps-tracking-field-workers-privacy-gdpr"
        ]
      }
    ]
  },
  "posts": {
    "en": [
      {
        "tag": "Mileage",
        "html": "<h2>Why manual mileage logs fail</h2><p>When workers fill in kilometres at the end of the week, they&#x27;re reconstructing routes from memory. The result: rounded numbers, missing trips and disputes at month-end. Payroll is inflated or under-reimbursed, and the company has no defensible audit trail.</p><h2>What automatic capture looks like</h2><p>A GPS-based system logs departure point, arrival point, actual route and exact distance for every trip — in the background, while the worker is driving. No manual entry. The data is timestamped, linked to the right client or project, and immediately available in the back office.</p><p>The worker selects the transport type at the start of the trip (own car, company vehicle, carpool, bike). The system applies the correct reimbursement rate automatically and flags anything above the threshold that requires proof of real costs.</p><h2>What it saves</h2><ul><li>Admin: no chasing paper logbooks or correcting spreadsheet errors at month-end</li><li>Disputes: GPS-confirmed data is objective — clients and workers see the same numbers</li><li>Cost: kilometres that would never have made it onto an expense note are captured automatically</li><li>Compliance: a full audit trail per worker, per trip, per project — ready for inspection</li></ul><h2>What to look for in a mileage tool</h2><ul><li>Automatic capture via GPS — no manual entry for workers</li><li>Multiple transport types with configurable rates</li><li>Per-project or per-client trip linking</li><li>GDPR-proof: GPS active only during working hours, data hosted in the EU</li><li>Export-ready reports that feed into payroll or invoicing</li></ul><h2>How Done-it handles it</h2><p>Done-it captures trips automatically via Trax-it — GPS logs the route, the worker selects the transport type, and the system applies the right rate. Everything links to the correct project or client. Reports export directly into payroll or e-invoicing, with no manual transcription.</p>",
        "lead": "When your team moves between sites all day, mileage adds up fast — and so do the errors. Here's how automatic mileage capture works, what it saves, and what to look for in a solution.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "How to track mileage for field teams — without the paperwork",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>The core rule: proportionality</h2><p>GPS tracking of employees is legal under GDPR — but only when it&#x27;s proportionate to a legitimate business purpose. Coordinating deliveries, confirming service visits, ensuring worker safety: all valid. Tracking someone&#x27;s every move &#x27;just in case&#x27;: not valid.</p><h2>Four things you must do</h2><ul><li>Define the purpose: route optimisation, safety, service confirmation — and write it down</li><li>Limit tracking to working hours only: workers must be able to switch GPS off in personal time</li><li>Inform your team clearly: what&#x27;s collected, why, who can see it, how long it&#x27;s kept</li><li>Document it: include GPS use in your work regulations and run a DPIA if tracking is large-scale or structural</li></ul><h2>What you must not do</h2><ul><li>Track 24/7 — tracking outside working hours violates GDPR proportionality</li><li>Use GPS data for automatic sanctions (e.g. speeding alerts that trigger discipline) without prior disclosure</li><li>Store location data longer than necessary — the CNIL recommends a maximum of two months</li><li>Skip informing workers — undisclosed tracking can invalidate evidence in any later dispute</li></ul><h2>Sector-specific notes</h2><p>For field service and logistics, GPS is expected and easily justified. For cleaning and maintenance, route planning by supervisors is fine — constant tracking per worker is harder to justify. For construction, GPS for vehicle and machinery protection is standard; it should not duplicate any presence-registration system already in use.</p><h2>How Done-it handles it</h2><p>Done-it activates GPS only at check-in, check-out and during active travel for work. There is no 24/7 tracking, no monitoring during breaks or personal time. Data is hosted in the EU with encryption and a dedicated Data Protection Officer — ready for any privacy audit.</p>",
        "lead": "GPS tracking of mobile workers raises real privacy questions. Here's the straightforward guide to what's legally allowed, what's not, and how to implement it in a way your team will accept.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS tracking for field workers: what's allowed and how to do it right",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>The problem with manual timesheets</h2><p>Field workers fill in hours from memory, often days later. Rounding is the norm. Hours land on the wrong project or client. Payroll is an approximation. And when a client disputes an invoice — or an inspector shows up — there&#x27;s no objective record to fall back on.</p><h2>What digital time registration actually means</h2><p>Digital registration means a worker taps to clock in at the site, the system timestamps it with GPS confirmation, and the hours automatically link to the right project or client. At month-end, the payroll export is generated in one click — no chasing, no reconciling, no errors.</p><p>The back office gets a live view: who is on which site, how many hours have been logged against each project, and whether any job is running over budget. That visibility changes how you manage — problems surface in real time instead of at month-end.</p><h2>What to look for in a time-tracking tool for field teams</h2><ul><li>GPS-confirmed check-in and check-out — no terminal, no card reader</li><li>Per-project or per-client hour linking, not just a daily total</li><li>Live remaining-hours view per project so budget overruns are visible before they happen</li><li>Overtime tracking with flexible payout or time-off conversion</li><li>Leave and absence management, including digital sick-note upload</li><li>One-click payroll export compatible with your social secretariat or HR system</li></ul><h2>Common objections — answered</h2><p>Workers won&#x27;t use it. In practice, a one-tap check-in takes less time than filling in a paper timesheet at week&#x27;s end. Adoption is almost always faster than expected. It&#x27;s too expensive. Done-it starts at €19/month base — less than the cost of one payroll error. We&#x27;re too small. There is no minimum team size.</p><h2>The compliance dimension</h2><p>Most EU countries are tightening requirements around working-hour registration — driven by the 2019 European Court of Justice ruling that employers must have an objective, reliable system to measure daily working time. A digital tool that produces a tamper-proof record per worker, per day, per project satisfies any local implementation of that standard.</p>",
        "lead": "When your team works across multiple sites, manual timesheets don't work. Here's how digital time registration changes the daily reality — for workers, managers and payroll.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Time tracking for field teams: a complete guide for SMEs",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Where the time goes</h2><p>For a company with 10–20 field workers, payroll prep typically takes one to two days per month. Someone collects timesheets (paper or WhatsApp), enters them into a spreadsheet, reconciles against project records, corrects the inevitable errors, and produces an export for the social secretariat or payroll provider. Every step is manual. Every step has failure modes.</p><h2>The bottlenecks</h2><ul><li>Timesheets arrive late or incomplete — workers are on the road, not at a desk</li><li>Hours are logged to the wrong project or client, requiring manual correction</li><li>Overtime and absence records live in a separate system (or a sticky note)</li><li>The payroll export is formatted differently from what the secretariat expects</li></ul><h2>What a digital system changes</h2><p>When workers check in and out via GPS on their phone, hours are registered at the moment they happen — linked to the right project, with exact times, no rounding. At month-end, the export is generated in one click. The numbers are already correct. There is nothing to reconcile.</p><p>Overtime is tracked as it happens. Absences are submitted digitally by the worker. Leave balances update automatically. The manager&#x27;s job becomes reviewing a dashboard, not building one from raw data.</p><h2>What teams report</h2><ul><li>Payroll prep down from two days to under an hour</li><li>Payroll errors down sharply — no manual entry means no transcription mistakes</li><li>Project post-costing becomes possible — real hours per job, not approximations</li><li>Workers actually prefer it — no timesheet to fill in at week&#x27;s end</li></ul><h2>Getting started</h2><p>Done-it takes most teams from sign-up to first tracked hours in the same afternoon. No hardware, no IT project. Workers download the app and check in. Hours appear in the dashboard. The payroll export is ready at month-end. The trial is 30 days free — no card required.</p>",
        "lead": "For companies with mobile teams, payroll prep is a monthly nightmare — chasing timesheets, correcting errors, reconciling projects. Here's how the teams that solved it did it.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "How field service companies cut payroll admin by 80%",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "nl": [
      {
        "tag": "Mileage",
        "html": "<h2>Waarom manuele kilometerlijsten falen</h2><p>Wanneer werknemers op het einde van de week hun kilometers invullen, reconstrueren ze hun routes uit het geheugen. Het resultaat: afgeronde cijfers, ontbrekende ritten en discussies op het einde van de maand. De loonadministratie is opgeblazen of onderbetaald, en het bedrijf heeft geen verdedigbare audit trail.</p><h2>Hoe automatische registratie eruitziet</h2><p>Een systeem op basis van GPS legt het vertrekpunt, het aankomstpunt, de werkelijke route en de exacte afstand vast voor elke rit — op de achtergrond, terwijl de werknemer rijdt. Geen manuele invoer. De gegevens zijn voorzien van een tijdstempel, gekoppeld aan de juiste klant of het juiste project, en meteen beschikbaar in de backoffice.</p><p>De werknemer selecteert het vervoerstype bij de start van de rit (eigen wagen, bedrijfswagen, carpool, fiets). Het systeem past automatisch het juiste terugbetalingstarief toe en signaleert alles boven de drempel waarvoor een bewijs van de werkelijke kosten nodig is.</p><h2>Wat het bespaart</h2><ul><li>Administratie: geen papieren rittenboeken achternalopen of Excel-fouten corrigeren op het einde van de maand</li><li>Discussies: door GPS bevestigde gegevens zijn objectief — klanten en werknemers zien dezelfde cijfers</li><li>Kosten: kilometers die nooit op een onkostennota zouden zijn beland, worden automatisch vastgelegd</li><li>Compliance: een volledige audit trail per werknemer, per rit, per project — klaar voor controle</li></ul><h2>Waar u op moet letten in een kilometertool</h2><ul><li>Automatische registratie via GPS — geen manuele invoer voor werknemers</li><li>Meerdere vervoerstypes met instelbare tarieven</li><li>Koppeling van ritten per project of per klant</li><li>GDPR-proof: GPS enkel actief tijdens de werkuren, gegevens gehost in de EU</li><li>Exportklare rapporten die rechtstreeks naar de loonadministratie of facturatie vloeien</li></ul><h2>Hoe Done-it het aanpakt</h2><p>Done-it legt ritten automatisch vast via Trax-it — GPS registreert de route, de werknemer selecteert het vervoerstype, en het systeem past het juiste tarief toe. Alles wordt gekoppeld aan het juiste project of de juiste klant. Rapporten exporteren rechtstreeks naar de loonadministratie of e-facturatie, zonder manuele overname.</p>",
        "lead": "Wanneer uw team de hele dag tussen werven beweegt, lopen de kilometers snel op — en de fouten ook. Dit is hoe automatische kilometerregistratie werkt, wat het bespaart, en waar u op moet letten in een oplossing.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Kilometers bijhouden voor mobiele teams — zonder het papierwerk",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>De kernregel: proportionaliteit</h2><p>GPS-tracking van werknemers is wettelijk onder de GDPR — maar enkel wanneer het in verhouding staat tot een gerechtvaardigd zakelijk doel. Het coördineren van leveringen, het bevestigen van servicebezoeken, het garanderen van de veiligheid van werknemers: allemaal geldig. Iemands elke beweging volgen &#x27;voor het geval dat&#x27;: niet geldig.</p><h2>Vier dingen die u moet doen</h2><ul><li>Bepaal het doel: routeoptimalisatie, veiligheid, bevestiging van een dienst — en leg het schriftelijk vast</li><li>Beperk de tracking tot de werkuren: werknemers moeten GPS in hun privétijd kunnen uitschakelen</li><li>Informeer uw team duidelijk: wat wordt verzameld, waarom, wie het kan zien, hoe lang het wordt bewaard</li><li>Documenteer het: neem het gebruik van GPS op in uw arbeidsreglement en voer een DPIA uit als de tracking grootschalig of structureel is</li></ul><h2>Wat u niet mag doen</h2><ul><li>24/7 tracken — tracking buiten de werkuren schendt de proportionaliteit van de GDPR</li><li>GPS-gegevens gebruiken voor automatische sancties (bv. snelheidswaarschuwingen die een tuchtmaatregel uitlokken) zonder voorafgaande mededeling</li><li>Locatiegegevens langer bewaren dan nodig — de CNIL beveelt een maximum van twee maanden aan</li><li>Werknemers niet informeren — niet-meegedeelde tracking kan bewijs ongeldig maken in een later geschil</li></ul><h2>Sectorspecifieke aandachtspunten</h2><p>Voor field service en logistiek wordt GPS verwacht en is het makkelijk te rechtvaardigen. Voor schoonmaak en onderhoud is routeplanning door supervisors prima — constante tracking per werknemer is moeilijker te rechtvaardigen. Voor de bouw is GPS voor de bescherming van voertuigen en machines standaard; het mag geen aanwezigheidsregistratiesysteem dubbelen dat al in gebruik is.</p><h2>Hoe Done-it het aanpakt</h2><p>Done-it activeert GPS enkel bij het inchecken, het uitchecken en tijdens actieve verplaatsingen voor het werk. Er is geen 24/7-tracking, geen toezicht tijdens pauzes of privétijd. De gegevens worden gehost in de EU met encryptie en een aparte functionaris voor gegevensbescherming — klaar voor elke privacy-audit.</p>",
        "lead": "GPS-tracking van mobiele werknemers roept reële privacyvragen op. Dit is de heldere gids over wat wettelijk is toegestaan, wat niet, en hoe u het zo invoert dat uw team het aanvaardt.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS-tracking voor mobiele werknemers: wat mag en hoe doet u het correct",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Het probleem met manuele timesheets</h2><p>Mobiele werknemers vullen hun uren uit het geheugen in, vaak dagen later. Afronden is de norm. Uren belanden op het verkeerde project of de verkeerde klant. De loonadministratie is een benadering. En wanneer een klant een factuur betwist — of een inspecteur opdaagt — is er geen objectief register om op terug te vallen.</p><h2>Wat digitale tijdsregistratie werkelijk betekent</h2><p>Digitale registratie betekent dat een werknemer op de werf op zijn scherm tikt om in te klokken, het systeem dat van een tijdstempel met GPS-bevestiging voorziet, en de uren automatisch aan het juiste project of de juiste klant koppelt. Op het einde van de maand wordt de loonexport met één klik gegenereerd — geen achternalopen, geen afstemmen, geen fouten.</p><p>De backoffice krijgt een live overzicht: wie op welke werf staat, hoeveel uren er per project zijn geregistreerd, en of een opdracht over het budget gaat. Dat inzicht verandert hoe u beheert — problemen komen in realtime aan het licht in plaats van op het einde van de maand.</p><h2>Waar u op moet letten in een tijdsregistratietool voor mobiele teams</h2><ul><li>In- en uitchecken bevestigd via GPS — geen terminal, geen kaartlezer</li><li>Koppeling van uren per project of per klant, niet enkel een dagtotaal</li><li>Live overzicht van de resterende uren per project zodat budgetoverschrijdingen zichtbaar zijn voor ze gebeuren</li><li>Overuren bijhouden met flexibele uitbetaling of omzetting in verlof</li><li>Beheer van verlof en afwezigheden, inclusief digitale upload van het ziektebriefje</li><li>Loonexport met één klik, compatibel met uw sociaal secretariaat of HR-systeem</li></ul><h2>Veelgehoorde bezwaren — beantwoord</h2><p>Werknemers gebruiken het niet. In de praktijk kost inchecken met één tik minder tijd dan op het einde van de week een papieren timesheet invullen. De adoptie verloopt bijna altijd sneller dan verwacht. Het is te duur. Done-it begint vanaf €19/maand basis — minder dan de kost van één fout in de loonadministratie. We zijn te klein. Er is geen minimale teamgrootte.</p><h2>De compliance-dimensie</h2><p>De meeste EU-landen verstrengen de vereisten rond arbeidstijdregistratie — aangedreven door de uitspraak van het Europees Hof van Justitie uit 2019 dat werkgevers een objectief en betrouwbaar systeem moeten hebben om de dagelijkse arbeidstijd te meten. Een digitale tool die een manipulatiebestendig register oplevert per werknemer, per dag, per project voldoet aan elke lokale uitwerking van die norm.</p>",
        "lead": "Wanneer uw team verspreid over meerdere werven werkt, werken manuele timesheets niet. Dit is hoe digitale tijdsregistratie de dagelijkse realiteit verandert — voor werknemers, managers en de loonadministratie.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Tijdsregistratie voor mobiele teams: een volledige gids voor kmo's",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Waar de tijd naartoe gaat</h2><p>Voor een bedrijf met 10–20 mobiele werknemers duurt de voorbereiding van de loonadministratie doorgaans één tot twee dagen per maand. Iemand verzamelt de timesheets (papier of WhatsApp), voert ze in een Excel-bestand in, stemt ze af op de projectgegevens, corrigeert de onvermijdelijke fouten, en maakt een export voor het sociaal secretariaat of de loonleverancier. Elke stap is manueel. Elke stap kent faalmechanismen.</p><h2>De knelpunten</h2><ul><li>Timesheets komen te laat of onvolledig binnen — werknemers zitten op de baan, niet aan een bureau</li><li>Uren worden op het verkeerde project of de verkeerde klant geboekt, wat een manuele correctie vereist</li><li>Overuren en afwezigheidsgegevens leven in een apart systeem (of op een post-it)</li><li>De loonexport heeft een andere opmaak dan wat het secretariaat verwacht</li></ul><h2>Wat een digitaal systeem verandert</h2><p>Wanneer werknemers in- en uitchecken via GPS op hun telefoon, worden de uren geregistreerd op het moment dat ze gebeuren — gekoppeld aan het juiste project, met exacte tijden, zonder afronden. Op het einde van de maand wordt de export met één klik gegenereerd. De cijfers kloppen al. Er is niets af te stemmen.</p><p>Overuren worden bijgehouden terwijl ze gebeuren. Afwezigheden worden digitaal ingediend door de werknemer. Verlofsaldo&#x27;s worden automatisch bijgewerkt. De taak van de manager wordt het bekijken van een dashboard, niet het opbouwen ervan uit ruwe gegevens.</p><h2>Wat teams rapporteren</h2><ul><li>Voorbereiding van de loonadministratie van twee dagen naar minder dan een uur</li><li>Fouten in de loonadministratie sterk gedaald — geen manuele invoer betekent geen overschrijffouten</li><li>Nacalculatie van projecten wordt mogelijk — werkelijke uren per opdracht, geen benaderingen</li><li>Werknemers verkiezen het zelfs — geen timesheet om op het einde van de week in te vullen</li></ul><h2>Aan de slag</h2><p>Done-it brengt de meeste teams van inschrijving tot de eerste geregistreerde uren in dezelfde namiddag. Geen hardware, geen IT-project. Werknemers downloaden de app en checken in. Uren verschijnen in het dashboard. De loonexport is klaar op het einde van de maand. De proefperiode is 30 dagen gratis — geen kaart vereist.</p>",
        "lead": "Voor bedrijven met mobiele teams is de voorbereiding van de loonadministratie een maandelijkse nachtmerrie — timesheets achternalopen, fouten corrigeren, projecten afstemmen. Dit is hoe de teams die het oplosten het aanpakten.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Hoe field-servicebedrijven hun loonadministratie met 80% terugdringen",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Waar België vandaag staat</h2><p>Het Belgische arbeidsrecht (dat op het punt staat te veranderen) kent vandaag geen algemene verplichting om uren systematisch te registreren. Het is enkel verplicht in specifieke gevallen — deeltijdse werknemers met variabele uurroosters en personeel met glijdende uurroosters, die afwijkingen van hun normale rooster moeten registreren. Buiten die uitzonderingen gebruiken de meeste bedrijven nog geen formele prikklok of digitale registratie.</p><p>Toch verplicht België in bepaalde sectoren al een aanwezigheidsregistratie als onderdeel van de strijd tegen sociale fraude:</p><ul><li>Bouw (werken in onroerende staat, betonlevering) — via CheckIn@Work</li><li>De vleessector — eveneens via CheckIn@Work</li><li>Schoonmaak van gebouwen — via CIAO (Check In And Out at Work)</li></ul><p>CIAO trad in werking op 1 september 2024 en verplicht schoonmaak- en onderhoudsbedrijven om het in- en uitchecken van hun werknemers digitaal te registreren op elke werkplek — ook buitenlandse bedrijven die in België actief zijn. Deze sectorinitiatieven willen de transparantie verhogen, de arbeidsomstandigheden verbeteren en zwartwerk tegengaan; de controles zijn actief en niet-naleving wordt gesanctioneerd.</p><h2>De nieuwe wet van 2027</h2><p>In lijn met de Europese tendensen voert België vanaf 1 januari 2027 een algemene verplichting in om de arbeidstijd van elke werknemer te registreren. De wijziging werd aangekondigd op 27 november 2025 als onderdeel van het federale begrotingsakkoord. Elke werkgever, privé en publiek, moet beschikken over een objectief, betrouwbaar en flexibel systeem om de uren van elke werknemer te registreren.</p><p>De concrete vorm wordt aan de werkgever overgelaten: u kiest zelf de technologie of methode (een digitale prikklok, een mobiele app of een ander systeem), zolang die een objectieve, betrouwbare registratie oplevert. De verplichting vloeit voort uit het EU-recht — het Hof van Justitie oordeelde in 2019 dat de lidstaten werkgevers moeten verplichten een objectief, betrouwbaar en toegankelijk systeem op te zetten dat de dagelijkse arbeidstijd meet. België verzette zich tot nu toe tegen een algemene verplichting.</p><p>Belangrijk: de definitieve wettekst is nog niet gepubliceerd, dus de details blijven open — of groepen die vaak vrijgesteld zijn van de klassieke arbeidstijdregels (bepaalde leidinggevende functies, mobiele werknemers) eronder vallen, hoe de registraties moeten worden bewaard, en de sancties bij niet-naleving. Eerdere voorstellen vermeldden dat de registraties minstens vijf jaar moeten worden bewaard.</p><h2>Impact en doelstellingen</h2><p>Voor veel bedrijven is dit een ingrijpende verandering, aangezien de meeste nog geen systeem hebben — alle bedrijven moeten hun procedures tegen 2027 aanpassen. Voor sommigen betekent het extra administratie en minder flexibiliteit in de planning. Er is ook een juridisch aspect: een Belgische uitspraak oordeelde dat zonder registraties de bewijslast volledig bij de werkgever ligt om aan te tonen dat er geen overuren werden gepresteerd — nagenoeg onmogelijk zonder objectieve registratie — wat het bedrijf blootstelt aan vorderingen voor onbetaalde uren.</p><p>De doelstellingen van de hervorming zijn de bescherming en het welzijn van de werknemer: het voorkomen van ongewenste of onbetaalde overuren, een betere werk-privébalans, en meer transparantie en eerlijkheid. De handhaving zal wellicht die van CheckIn@Work en CIAO weerspiegelen — controles en sancties — zodat een betrouwbaar systeem zowel boetes vermijdt als degelijk bewijs levert bij controles of geschillen.</p><h2>Lessen uit sectoren die het al doen</h2><p>In de bouw en de vleessector moet de aanwezigheid van elke werknemer al dagelijks worden geregistreerd via CheckIn@Work, vóór de werkdag begint; de werknemer kan zichzelf registreren of de werkgever kan het doen, maar er moet elektronisch bewijs zijn van wie aanwezig is, waar en wanneer. In de schoonmaak vereist CIAO een registratie in realtime van het begin en het einde van de activiteiten, inclusief pauzes; het geldt voor werknemers, zelfstandigen, uitzendkrachten en stagiairs, en pre-registratie of manueel terugdateren is niet toegestaan.</p><p>Deze pioniersectoren tonen aan dat digitale registratie haalbaar en efficiënt is: een klik in een app of een badgescan, met data die meteen beschikbaar is voor rapportage en controles. De technologie bestaat en is bewezen in de praktijk.</p><h2>Hoe u in orde bent: uw opties</h2><ul><li>Mobiele apps — de werknemer registreert begin/einde (en pauzes) vanaf een smartphone, met het exacte tijdstip en optioneel geolocatie; ideaal voor personeel verspreid over meerdere locaties of mobiele teams</li><li>Terminals / prikklokken — fysieke toestellen waarop personeel inklokt met een badge, pincode, polsband of biometrie; geschikt voor vaste werkplekken</li><li>Desktop- / cloudsoftware — manuele invoer, of systemen die activiteit detecteren bij aan-/afmelden en pauzes markeren bij inactiviteit</li></ul><p>Wat u ook kiest, het systeem moet het begin en het einde van elke werkdag registreren (en pauzes waar relevant), de data veilig bewaren, en rapporten genereren van uren, overuren en afwijkingen. Het moet manipulatie voorkomen (individuele logins, persoonlijke badges, geotagging of biometrie) en flexibel genoeg zijn voor glijdende uurroosters, nachtploegen, projectwerk en meerdere locaties — zodat u een volledig en verifieerbaar overzicht hebt van de uren van elke werknemer.</p><h2>Begin nu met voorbereiden</h2><p>2027 lijkt veraf, maar dit is hét moment om u voor te bereiden. Een digitaal systeem is niet alleen een antwoord op de toekomstige verplichting — het verbetert ook de dagelijkse organisatie: duidelijkere uren, minder fouten en geschillen, een betere planning van middelen, en een vroegere detectie van overbelasting. Veel bedrijven kiezen voor een volledig mobiele oplossing zoals Done-it in plaats van dure hardware: het personeel klokt in via smartphone, u krijgt een wettelijk, steeds toegankelijk urenregister met track &amp; trace, en rapporten voor controles of loonadministratie worden automatisch gegenereerd.</p>",
        "lead": "Vanaf 1 januari 2027 moet elke Belgische werkgever — privé en publiek — de arbeidstijd van zijn personeel registreren. Aangekondigd op 27 november 2025 als onderdeel van het federale begrotingsakkoord. Dit is wat het betekent en hoe u zich voorbereidt.",
        "read": "8 min",
        "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
        "title": "Verplichte arbeidstijdregistratie in België: wat bedrijven moeten weten",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551043/blog/verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedri.jpg"
      },
      {
        "tag": "E-invoicing",
        "html": "<h2>De Europese context</h2><p>De EU stimuleert de digitalisering van de btw via het initiatief VAT in the Digital Age (ViDA), dat transacties harmoniseert met gestructureerde e-facturen en het bijna realtime delen van btw-gegevens met de belastingdiensten. De Commissie schat dat dit tot €11 miljard per jaar aan btw-fraude kan voorkomen en meer dan €4,1 miljard aan administratieve kosten kan besparen.</p><p>België volgt deze strategie met een gefaseerde invoering. E-facturatie is sinds 2022 verplicht voor overheidsopdrachten (B2G), in fasen op 1 november 2022, 1 mei 2023 en 1 maart 2024 — leveranciers van overheidsinstellingen sturen hun facturen via het PEPPOL-netwerk door het nationale platform Mercurius. In maart 2024 keurde het parlement een wet goed die dit uitbreidt naar de privésector: vanaf 1 januari 2026 is gestructureerde e-facturatie verplicht voor alle B2B-transacties tussen Belgische btw-plichtige bedrijven.</p><h2>Wat is PEPPOL?</h2><p>PEPPOL (Pan-European Public Procurement Online) is een internationaal netwerk ontwikkeld door de EU om de elektronische uitwisseling van zakelijke documenten te standaardiseren. Sinds 2008 verbindt het bedrijven, overheden en organisaties via gecertificeerde Access Points. U koppelt uw boekhoudsoftware aan een erkende PEPPOL-provider, en vanaf dan kunt u uitwisselen met elke aangesloten partij in heel Europa — zonder aparte integraties. België gebruikt PEPPOL als standaard B2B-kanaal om pan-Europese interoperabiliteit te garanderen.</p><h2>Wat is een gestructureerde e-factuur?</h2><p>Een gestructureerde e-factuur organiseert alle gegevens (leverancier, klant, bedragen, btw, producten) in vaste velden, meestal een XML-bestand in UBL- of Peppol BIS-formaat. In tegenstelling tot een pdf of een scan is ze machineleesbaar: de boekhoudsoftware leest en verwerkt alles automatisch, zonder manuele invoer of foutgevoelige interpretatie. Voor kmo&#x27;s en zelfstandigen betekent dit veel minder handwerk, minder fouten en een snellere verwerking.</p><h2>De timing</h2><ul><li>2024 — de B2G-uitrol is afgerond; de wet die de B2B-verplichting van 2026 voorbereidt, wordt goedgekeurd</li><li>2025 — een Koninklijk Besluit legt de technische details vast (toegelaten formaten zoals Peppol BIS, uitwisselingsprotocollen, afrondingsregels); een tolerantieperiode wordt aangekondigd voor januari–maart 2026</li><li>1 januari 2026 — de verplichting geldt voor alle Belgische btw-plichtige bedrijven voor B2B; vanaf april 2026 worden papieren en pdf-facturen niet meer aanvaard</li></ul><h2>Sancties &amp; belangrijke FAQ&#x27;s</h2><p>Na de overgangsperiode gelden gradueel oplopende boetes: €1.500 voor een eerste overtreding, €3.000 voor een tweede, €5.000 voor een derde. Documenteer elke stap (softwarewijzigingen, interne communicatie, testverzendingen) om sancties te vermijden.</p><ul><li>Partner niet op PEPPOL? Controleer de PEPPOL-directory voor u verstuurt; als ze niet geregistreerd zijn, neem dan contact op om hen te laten starten — verstuur niet tegelijk een pdf én een e-factuur</li><li>Systeemstoring? Schakel over op een noodoplossing (tijdelijk een pdf per e-mail), documenteer de storing en verstuur daarna opnieuw via PEPPOL zodra alles hersteld is</li><li>Fouten? Gebruik de gebruikelijke correcties — een creditnota of een gecorrigeerde factuur met een duidelijke audit trail</li><li>Een pdf per e-mail voldoet vanaf 2026 niet meer aan de vereiste, behalve bij uitdrukkelijke schriftelijke overeenkomst en als ze converteerbaar is naar de norm EN 16931</li><li>Buitenlandse klanten vallen buiten het toepassingsgebied — de verplichting geldt enkel voor binnenlandse B2B</li><li>Steun voor kmo&#x27;s: een investeringsaftrek van 20% voor digitaal materiaal vanaf 1 januari 2025, en een aftrek van 120% op de kosten van e-facturatiesoftware voor de aanslagjaren 2024–2027</li></ul><h2>Praktische tips</h2><p>Begin nu: kies PEPPOL-compatibele software of een provider, informeer uw klanten en leveranciers, en documenteer elke stap zodat u juridisch beschermd bent. De website van de FOD Financiën (e-factuur) biedt communicatiekits om uw partners over de overstap te informeren.</p>",
        "lead": "Vanaf 1 januari 2026 wordt gestructureerde elektronische facturatie verplicht voor B2B-transacties tussen Belgische btw-plichtige bedrijven, met het PEPPOL-netwerk als standaardkanaal.",
        "read": "7 min",
        "slug": "verplichte-e-facturatie-b2b-via-peppol-in-belgie-vanaf-2026",
        "title": "Verplichte B2B-e-facturatie via PEPPOL in België vanaf 1 januari 2026",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551044/blog/verplichte-e-facturatie-b2b-via-peppol-in-belgie-vanaf-2026.jpg"
      },
      {
        "tag": "Cross-border",
        "html": "<h2>Meldingen &amp; vergunningen</h2><p>Een Belgisch bedrijf dat werknemers naar Nederland detacheert, moet vooraf een WagwEU-melding indienen via het portaal voor gedetacheerde werknemers van de Nederlandse Arbeidsinspectie; ook zelfstandigen moeten zich soms melden. Niet of te laat melden kan de werkgever en de Nederlandse opdrachtgever tot ongeveer €4.500 kosten.</p><p>Een Nederlands bedrijf dat personeel in België tewerkstelt, moet voor elke buitenlandse werknemer een LIMOSA-1-aangifte indienen vóór het werk begint, en het L1-attest op verzoek kunnen voorleggen — de sancties (strafrechtelijk of administratief) treffen zowel werkgever als opdrachtgever. Sinds 2016 moet de buitenlandse werkgever ook een lokaal contactpersoon in België aanduiden.</p><p>Voor bijna alle grensoverschrijdende tewerkstelling is een A1-attest (Certificate of Coverage) nodig: het bewijst dat de werknemer tijdens de opdracht onder de sociale zekerheid van het thuisland blijft. Zonder dit attest laten sommige landen het werk niet doorgaan. Vraag het aan bij de RSZ/RSVZ (België) of de SVB (Nederland) vóór het werk start.</p><h2>Uren, kilometers &amp; GPS</h2><p>Uren: Nederland verplicht elke werkgever strikt om uren en pauzes bij te houden. België kende lange tijd geen algemene verplichting; sinds 1 juli 2024 is het verplicht voor glijdende uurroosters (een registratiesysteem is vereist), terwijl vaste uurroosters nog niet verplicht zijn, hoewel registratie vaak de voorkeur krijgt.</p><p>Kilometers: beide landen laten een belastingvrije forfaitaire vergoeding per km toe, maar de maxima verschillen — NL stelde €0,23/km vast voor 2024, terwijl België veel hoger zit (rond €0,43–0,44/km, sinds 2022 per kwartaal geïndexeerd). Alles boven het maximum wordt in beide landen als loon belast.</p><p>GPS: in beide landen toegestaan, maar enkel onder de GDPR — een gerechtvaardigd belang afgewogen tegen de privacy, geen permanente tracking, de werknemer moet GPS kunnen uitschakelen in zijn privétijd, en het systeem moet zijn opgenomen in het arbeidsreglement met duidelijke informatie over wat wordt verzameld en waarom.</p><h2>Sociale zekerheid, belastingen &amp; detachering</h2><p>Detachering: werknemers blijven normaal verzekerd in het thuisland van de werkgever. Met het A1-attest kan een werknemer tot 24 maanden in het andere land werken zonder daar nieuwe sociale bijdragen te betalen, verlengbaar tot 36 maanden. Daarna kan het gastland bijdragen heffen als het werk doorloopt.</p><p>Belastingen: de vaak aangehaalde 183-dagenregel betekent dat als de werknemer in een periode van 12 maanden niet meer dan 183 dagen in het gastland verblijft, het thuisland normaal het recht behoudt om te belasten. De Nederlandse belastingdienst stelt het eenvoudig: als het gastland mag belasten, hoeft de werkgever geen Nederlandse loonheffing in te houden; als Nederland mag belasten, moet hij dat wel. Er bestaan bijzondere regimes, zoals de Nederlandse 30%-regeling voor expats. In België betalen buitenlandse werknemers doorgaans Belgische inkomstenbelasting voor het hier verrichte werk, hoewel de drempel van 183 dagen vaak de aangifte in het thuisland behoudt.</p><h2>Documenten &amp; sancties</h2><p>Bewaar arbeidsovereenkomsten, loonbrieven, tijdsregistraties, het A1-formulier en betalingsbewijzen minstens vijf jaar, en leg ze voor bij een controle. In Nederland kost een mislukte detacheringsmelding tot ongeveer €4.500 (ook opdrachtgevers zijn aansprakelijk); in België leidt het negeren van LIMOSA tot strafrechtelijke en administratieve sancties voor zowel werkgever als opdrachtgever, en een ontbrekend A1-attest verhoogt het controlerisico.</p>",
        "lead": "Werken over de grens tussen België en Nederland brengt aan beide kanten aparte meldingsplichten, sociale-zekerheidsformaliteiten en fiscale regels met zich mee. Dit is de praktische basis.",
        "read": "7 min",
        "slug": "gids-voor-belgische-en-nederlandse-bedrijven-die-actief-zijn-over-de-grens",
        "title": "Gids voor Belgische en Nederlandse bedrijven die over de grens actief zijn",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551019/blog/gids-voor-belgische-en-nederlandse-bedrijven-die-actief-zijn.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Wat verandert er</h2><p>Digitale tijdsregistratie op Belgische bouwwerven is gepland voor 2027 en staat al ver. NAR-advies nr. 2.465 bevestigt dat de regels zowel de aanwezigheid bij aankomst als bij vertrek (check-out) van elke werknemer digitaal op de werf zullen verplichten. De maatregel wil de arbeidsveiligheid versterken en de sociale fraude in de bouw bestrijden.</p><h2>Het juridische plaatje</h2><p>De huidige regels steunen op CheckIn@Work. Volgens de richtlijnen van de FOD Werkgelegenheid (de SIRS-gids) moet elke werknemer dagelijks worden geregistreerd vóór het werk begint. In de praktijk geldt dit momenteel voor werven van meer dan €500.000 excl. btw, waar de aanwezigheid van al het personeel via de RSZ-toepassing moet worden geregistreerd — registratie enkel bij aankomst.</p><p>NAR-advies nr. 2.465 behandelt een ontwerp dat dit uitbreidt: naast de aankomst wordt ook de registratie bij vertrek (check-out) verplicht. De Raad merkt op dat het nieuwe Koninklijk Besluit uiterlijk op 1 januari 2027 in werking moet treden, en dat overtredingen kunnen worden gesanctioneerd onder het Sociaal Strafwetboek.</p><h2>De sancties</h2><p>Na een overgangsperiode voorziet de wet boetes van €80–€800 (niveau 1) voor het niet registreren van een in- of uitklokking, zwaardere straffen tot €8.000, en in ernstige gevallen strafrechtelijke boetes tot €16.000. Een volledig digitaal systeem verhoogt de transparantie en maakt verificatie eenvoudiger, met duidelijk bewijs van de gewerkte uren en zonder manuele discussies.</p><h2>Aanbevelingen</h2><ul><li>Registratie in realtime via een officiële app (zoals Done-it) zodat elke werknemer op de werf in- en uitklokt vanaf zijn eigen smartphone — de registratie moet in realtime gebeuren</li><li>Train en informeer werknemers en onderaannemers; stel duidelijke protocollen op en vervang papieren lijsten volledig</li><li>Centraliseer de registraties online, koppel ze aan de officiële werfaangifte (formulier 30bis), en voer regelmatig digitale audits uit</li></ul><h2>Onderdeel van een bredere trend</h2><p>Verplichte digitale registratie breidt zich uit over de hele EU. Schoonmaak (CIAO) vereist sinds september 2024 een digitale in- en uitchecking, en de NAR heeft soortgelijke maatregelen aanbevolen voor de verhuissector. Eén mobiele app kan de aanwezigheidsregistratie dekken voor bouw, schoonmaak en verhuis tegelijk — zonder extra hardware.</p>",
        "lead": "Op bouwwerven moeten zowel de aankomst als het vertrek van elke werknemer digitaal worden geregistreerd. Gebaseerd op het advies nr. 2.465 van de Nationale Arbeidsraad (NAR) van 5 november 2025, onderdeel van het federale akkoord 2025–2029.",
        "read": "5 min",
        "slug": "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
        "title": "Digitaal in- en uitchecken verplicht op bouwwerven vanaf 2027",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551013/blog/digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<p>Bent u een kmo in de bouw, werkt u met onderaannemers of beheert u mobiele teams verspreid over verschillende werven? Dan is dit het moment om uw administratie op orde te brengen — bij voorkeur digitaal.</p><h2>Wat inspecteurs controleren</h2><ul><li>Arbeidsreglement — uren, pauzes, ploegen en psychosociale bijlagen</li><li>Arbeidsovereenkomsten — voltijds, deeltijds, uitzendkrachten, studenten en buitenlands personeel (LIMOSA)</li><li>Dimona — is iedereen correct en tijdig aangegeven?</li><li>CheckIn@Work-registratie op grote werven</li><li>Betalingsbewijzen &amp; loonbrieven, inclusief maaltijd- en mobiliteitsvergoedingen</li><li>Arbeidsongevallenverzekering, actief voor al het personeel en de onderaannemers</li><li>Dagelijkse aanwezigheids- / tijdsregistraties, op papier of digitaal</li></ul><h2>Als u niet in orde bent</h2><ul><li>Administratieve of strafrechtelijke boetes tot tienduizenden euro&#x27;s</li><li>Terugvordering van RSZ-bijdragen (sociale zekerheid)</li><li>Tijdelijke stillegging van een werf of project</li><li>Reputatieschade bij klanten en overheden</li></ul><h2>Hoe problemen voorkomen: digitaliseer</h2><p>Met een tool zoals Done-it houdt u alles centraal, veilig en up-to-date:</p><ul><li>Tijdsregistratie via smartphone — in-/uitklokken met geolocatie en koppeling aan het project</li><li>Documentbeheer in de cloud — overeenkomsten, verzekeringsattesten en loonbrieven op één plek</li><li>Rapportage per werknemer of project — meteen downloadbaar tijdens een controle</li><li>Opvolging van onderaannemers — controleer of hun personeel correct geregistreerd en aanwezig is</li></ul><h2>Kort samengevat</h2><p>De flashcontroles van de zomer van 2025 zijn geen verrassing en passen in een bredere trend naar strengere handhaving. Digitale tools houden u permanent compliant en geven u, als bonus, meer inzicht in de prestaties en kosten van uw team. Wacht niet tot de inspectie op uw werf staat — begin vandaag met digitaliseren.</p>",
        "lead": "In de zomer van 2025 voerde de Belgische sociale inspectie (SIOD/SIRS) opnieuw onaangekondigde flashcontroles uit in de bouw, de elektrotechniek en de metaalsector, gericht op de naleving van de arbeidswetgeving en op sociale fraude — zwartwerk, illegale tewerkstelling en foutieve Dimona-aangiftes.",
        "read": "4 min",
        "slug": "flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-vermijd-je-boetes-met-digitale-oplossingen",
        "title": "Flashcontroles in de Belgische bouwsector (zomer 2025): boetes vermijden met digitale tools",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551018/blog/flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-ver.jpg"
      },
      {
        "tag": "Mileage",
        "html": "<h2>Terugbetalingen en officiële tarieven</h2><p>Als werkgever mag u uw personeel een vergoeding betalen voor professionele verplaatsingen met hun eigen voertuig. Die is normaal vrij van belasting en van sociale bijdragen — voor beide partijen — zolang de officiële maxima worden gerespecteerd, en ze moet professionele verplaatsingen dekken (klantenbezoeken, externe vergaderingen, verplaatsingen tussen werkplaatsen), niet het woon-werkverkeer.</p><p>De officiële tarieven worden gepubliceerd door de federale overheid (FOD BOSA, via circulaires van de FOD Financiën). De fiscus aanvaardt dat de vergoeding de werkelijke kosten dekt zolang ze gebaseerd is op de effectief gereden kilometers en niet hoger is dan wat de overheid haar eigen personeel betaalt. U mag meer terugbetalen, maar dan moet u bewijzen dat het hogere bedrag de werkelijke kosten weerspiegelt — voor kmo&#x27;s is het vasthouden aan de forfaitaire tarieven de veiligste en eenvoudigste weg.</p><h2>Indexatie per kwartaal vs jaarlijks (2025)</h2><p>België kent twee indexatiemethodes. Het kwartaaltarief (ingevoerd in oktober 2022) volgt de schommelingen van de brandstofprijzen nauwer; het jaartarief verandert eenmaal per jaar, meestal op 1 juli. U kunt doorgaans kiezen — tenzij een sectorale collectieve arbeidsovereenkomst (cao) of het arbeidsreglement het anders bepaalt — maar zodra u voor het jaarsysteem kiest, moet u dat het hele indexatiejaar aanhouden (1 juli tot 30 juni); u kunt pas vanaf de volgende 1 juli terugschakelen naar het kwartaalsysteem.</p><ul><li>Q1 2025: €0,4290/km</li><li>Q2 2025: €0,4320/km</li><li>Q3 2025: €0,4309/km</li><li>Jaarlijks (1 juli 2025 – 30 juni 2026): €0,4449/km</li></ul><h2>Werknemers vs zelfstandigen</h2><p>Voor werknemers geldt er geen strikt maximumaantal terugbetaalbare kilometers, maar boven 24.000 km/jaar kan de fiscus of de RSZ een bewijs van de werkelijke kosten vragen — de vergoeding wordt niet automatisch belastbaar, maar de bewijslast verschuift naar de werkgever.</p><p>Voor zelfstandigen gelden andere regels: het woon-werkverkeer tussen de woonplaats en een vaste werkplek is doorgaans geen beroepskost, al is een forfaitaire aftrek van €0,15/km toegestaan (max €490/jaar). Voor professionele verplaatsingen kunnen ze kiezen tussen het forfaitaire kilometertarief of de aftrek van de werkelijke kosten (brandstof, onderhoud, verzekering, afschrijving); de aftrekbaarheid hangt af van het voertuig en de CO₂-uitstoot — een elektrische wagen is 100% aftrekbaar bij zuiver professioneel gebruik. Ze mogen de verplaatsing ook doorrekenen aan klanten (geen plafond, maar het telt als belastbaar inkomen).</p><h2>Een administratie is essentieel</h2><p>Voor iedereen geldt de regel: geen degelijke administratie, geen belastingvrijstelling. Een gedetailleerde rittenadministratie vermeldt de datum, het doel, de adressen van vertrek/aankomst en de kilometers. Boven het forfaitaire tarief of de drempel van 24.000 km moet u ook de werkelijke kostprijs per kilometer bewijzen (afschrijving, brandstof, onderhoud, verzekering).</p><p>Let op het verschil tussen aftrekbaar en terugbetaalbaar: voor werknemers gaat het om belastingvrije terugbetalingen door de werkgever; voor zelfstandigen om beroepskosten die van de belastbare winst worden afgetrokken. De €0,15/km voor het woon-werkverkeer is een persoonlijke belastingaftrek, geen terugbetaling door de werkgever aan dat tarief.</p><h2>Uitgewerkte voorbeelden</h2><ul><li>Technicus (werknemer), 150 km aan het tarief van Q2 2025: 150 × €0,4320 = €64,80, belastingvrij</li><li>Woon-werkverkeer (werknemer): een persoonlijke belastingvermindering aan €0,15/km, max €490 voor aanslagjaar 2025</li><li>Zelfstandige, 150 km aan het jaartarief €0,4415 (1 juli 2024–30 juni 2025): 150 × €0,4415 = €66,23, aftrekbaar als beroepskost</li></ul><h2>Waarom digitale kilometerregistratie loont</h2><p>Manuele methodes — Excel-bestanden, papier, losse notities — zijn foutgevoelig, moeilijk te controleren en gevoelig voor opgeblazen kilometers. Registratie op basis van geolocatie (zoals Done-it met Trax-it) legt de vertrek- en aankomstpunten, de werkelijke route en de exacte afstand automatisch vast, voorkomt manipulatie, past de officiële geïndexeerde tarieven toe, signaleert de drempel van 24.000 km per werknemer, en genereert auditklare rapporten — en dat alles met respect voor de GDPR (geen tracking buiten de werkuren).</p>",
        "lead": "Het beheer van kilometers voor mobiele werknemers is een constante uitdaging voor Belgische kmo's en zelfstandigen. Dit is hoe de vergoeding werkt, de officiële tarieven voor 2025, en de belangrijkste verschillen tussen werknemers en zelfstandigen.",
        "read": "7 min",
        "slug": "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
        "title": "Kilometervergoeding in België: regels en terugbetalingen voor kmo's en zelfstandigen (gids 2025)",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551038/blog/kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Het wettelijke kader</h2><p>Ook zonder een specifieke GPS-wet moeten bedrijven de GDPR naleven, de Belgische wet van 30 juli 2018 betreffende de gegevensbescherming, artikel 8 van het Europees Verdrag voor de Rechten van de Mens, en artikel 22 van de Belgische Grondwet. GPS-tracking is een verwerking van persoonsgegevens en moet dus de rechtmatigheid en behoorlijkheid, de doelbinding, de minimale gegevensverwerking, de transparantie en de beveiliging respecteren.</p><p>De Belgische Gegevensbeschermingsautoriteit (GBA) legde de kerntest al vast in advies 12/2005: rechtmatigheid, een gerechtvaardigd doel, proportionaliteit en transparantie. De Franse CNIL en de Nederlandse Autoriteit Persoonsgegevens geven vergelijkbare richtlijnen — geen toezicht buiten de werkuren, geen permanente tracking, en een gerechtvaardigd, proportioneel belang.</p><h2>Arbeidsrechtelijke verplichtingen</h2><ul><li>Bedrijven met 50+ werknemers moeten de ondernemingsraad raadplegen</li><li>Het gebruik van GPS moet in het arbeidsreglement worden opgenomen en aan al het personeel worden meegedeeld</li><li>In kmo&#x27;s zonder formele organen informeert u het preventiecomité of de werknemers rechtstreeks</li><li>Een DPIA is verplicht bij grootschalig of structureel gebruik</li></ul><h2>Vier kernprincipes</h2><p>Gerechtvaardigd doel — een duidelijke, gerechtvaardigde reden zoals de veiligheid van werknemers, diefstalpreventie, routeoptimalisatie of de bevestiging van een dienst; algemene tracking &#x27;voor het geval dat&#x27; of om iemand te betrappen is niet toegestaan. Proportionaliteit — geen 24/7-tracking, geen tracking buiten de werkuren, de werknemer moet GPS in zijn privétijd kunnen uitschakelen, en een beperkte bewaring (bv. max twee maanden volgens de CNIL). Transparantie — het personeel moet weten wat wordt verzameld, waarom, wie toegang heeft, hoe lang het wordt bewaard en wat hun rechten zijn, duidelijk schriftelijk vastgelegd. Toestemming — niet nodig wanneer GPS essentieel is voor de activiteit (koeriers, ambulances, dringende installaties), maar wel vereist wanneer dat niet zo is, en dan moet die vrij, geïnformeerd, specifiek en herroepbaar zijn.</p><h2>Per sector</h2><p>Bouw — GPS voor het coördineren van leveringen en het beschermen van voertuigen/machines, uitgeschakeld buiten de werkuren; als CheckIn@Work al wordt gebruikt, mag GPS de aanwezigheidscontrole niet dubbelen. Schoonmaak &amp; facilitaire diensten — prima voor routeplanning door supervisors; vermijd constante tracking, verkies in-/uitcheck-apps. Technische diensten (elektriciens, loodgieters, installateurs, koeriers) — helpt bij responstijden, routering en veiligheid, maar geen automatische sancties (bv. voor snelheidsovertredingen) en een privémodus moet beschikbaar zijn.</p><h2>Sancties bij misbruik</h2><ul><li>GDPR-boetes tot €20 miljoen of 4% van de jaaromzet</li><li>Bewijs nietig verklaard voor de arbeidsrechtbank — ontslagen op basis van niet-meegedeelde tracking kunnen worden teruggedraaid</li><li>Vorderingen van werknemers of vakbonden, en inspecties door de FOD WASO</li><li>Een slechter werkklimaat en reputatieschade</li></ul><p>Er is geen wettelijk verschil tussen Vlaanderen en Wallonië — de GDPR en de wet van 2018 gelden in heel het land — enkel een culturele nuance (Vlaanderen leunt op het arbeidsreglement en het voorafgaand overleg; Wallonië verwijst naar de CNIL-doctrine en het recht op deconnectie). Proportioneel en transparant gebruikt is GPS een nuttig en wettelijk instrument: Done-it activeert GPS bijvoorbeeld enkel bij het in-/uitchecken of tijdens een verplaatsing voor het werk, met respect voor de proportionaliteit en de privétijd.</p>",
        "lead": "GPS-tracking van mobiele werknemers komt steeds vaker voor — en roept reële vragen op over privacy op het werk. België heeft geen specifieke GPS-wet, maar de GDPR en aanverwante regels zijn duidelijk van toepassing.",
        "read": "6 min",
        "slug": "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
        "title": "Wettelijk en ethisch gebruik van GPS-tracking bij mobiele werknemers in België",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551045/blog/wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-we.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Drie kernverplichtingen om te controleren</h2><ul><li>Dimona — de elektronische melding aan de RSZ voor elk type werknemer (vast, tijdelijk, studenten, buitenlands), vóór de eerste werkdag; te laat of ontbrekend betekent boetes en problemen met de sociale zekerheid</li><li>LIMOSA — als een onderaannemer buitenlandse werknemers of zelfstandigen naar België brengt, is een LIMOSA-1-aangifte vereist vóór dag één, en u moet die verifiëren</li><li>Aanwezigheidsregistratie — CheckIn@Work voor bouw-/onroerende werken van ≥ €500.000 excl. btw (dagelijks, vóór het werk begint), of CIAO voor professionele schoonmaak naargelang de dienst/het contract</li></ul><h2>eC3.2A — de digitale controlekaart</h2><p>Tijdens tijdelijke werkloosheid (bijvoorbeeld bij weerverlet op de werf) moeten bouwvakkers de elektronische controlekaart eC3.2A gebruiken. Sinds 1 januari 2025 is ze verplicht in digitale vorm (papier verdwijnt, op enkele uitzonderingen na); met de officiële eC3.2-app kunnen werknemers ze beheren en op het einde van de maand naar de uitbetalingsinstelling sturen. Belangrijk: eC3.2A vervangt Dimona, LIMOSA of CheckIn@Work/CIAO niet — het is een bijkomende verplichting.</p><h2>Checklist voor het werken met onderaannemers</h2><ul><li>Vóór de start — vraag het Dimona-bewijs voor iedereen die de werf betreedt; eis het LIMOSA-1-attest voor buitenlands personeel vóór dag één; spreek schriftelijk af wie de aanwezigheid registreert en hoe dat dagelijks wordt gecontroleerd</li><li>Dagelijks — niemand begint zonder een geldige aangifte en registratie; bij vervangingen herhaalt u het proces</li><li>Wekelijks — download en archiveer de aanwezigheidslijsten (essentieel voor controles) en controleer de geldigheid van de documenten (verzekering, attesten, vergunningen)</li></ul><h2>Veelgemaakte fouten</h2><ul><li>Werknemers op de werf zonder Dimona/LIMOSA</li><li>Registreren in het verkeerde systeem (CheckIn@Work vs CIAO)</li><li>Onderaannemers blindelings vertrouwen zonder controle of bewijs</li></ul><h2>Organiseer het efficiënt</h2><p>Standaardiseer één checklist voor alle onderaannemers, centraliseer wie mag werken, wie aanwezig is en welke documenten ontbreken, en registreer alle begin-/eindtijden op de werf met een betrouwbaar systeem voor een volledige traceerbaarheid. Done-it focust op de dagelijkse essentie — digitale prikklok en aanwezigheidsoverzicht voor uw eigen team en uw onderaannemers — met een automatische koppeling naar CheckIn@Work en snelle toegang tot eC3.2A. Let op: de officiële CIAO-registratie in de schoonmaak verloopt via het eigen platform van de overheid; Done-it geeft een operationeel overzicht en centraliseert de klokkingen, maar vervangt CIAO niet.</p>",
        "lead": "Werken met onderaannemers is normaal in schoonmaak, renovatie, nieuwbouw en installatie — maar België kent een hoofdelijke aansprakelijkheid: als uw onderaannemer de regels overtreedt, kunt u als hoofdaannemer mee worden gesanctioneerd. Een praktische basis, zonder jargon.",
        "read": "5 min",
        "slug": "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
        "title": "Onderaannemers in schoonmaak, renovatie en nieuwbouw: de basis om boetes te vermijden",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551040/blog/onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgi.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Wat is CheckIn@Work?</h2><p>CheckIn@Work is de Belgische elektronische aanwezigheidsregistratie voor onroerende werken (bouw, burgerlijke bouwkunde, renovatie) en bepaalde andere sectoren. Het bestaat sinds 2014 en vereist een dagelijkse registratie van iedereen die zulke werken uitvoert zodra het project een drempel overschrijdt — €500.000 excl. btw voor werken gestart na 1 maart 2016 (voordien €800.000). Op elke werf die dat bedrag bereikt, moet elke persoon zich dagelijks registreren vóór de start.</p><p>Oorspronkelijk voor de bouw werd het toepassingsgebied verbreed: het dekt ook de vleessector (iedereen in slachthuizen of vleesverwerkende bedrijven onder toezicht van het FAVV, zonder drempel) en activiteiten zoals de levering van stortklaar beton. De schoonmaak is sinds 2024 uitgesloten (die valt onder CIAO), en land-, tuin- en bosbouw vallen uitdrukkelijk buiten het toepassingsgebied.</p><h2>Wie registreert, en hoe</h2><p>De verantwoordelijkheid wordt gedeeld tussen de entiteit die iemand naar de werf stuurt (werkgever, hoofdaannemer of onderaannemer) en de persoon die het werk uitvoert. In de praktijk registreert de werkgever of opdrachtgever het personeel, de onderaannemers en de zelfstandigen via de beveiligde app van de RSZ of via geautomatiseerde methodes (een badge op de werf, het scannen van de LIMOSA-QR-code, een mobiele app); werknemers en zelfstandige onderaannemers kunnen zichzelf registreren indien afgesproken. De registratie gebeurt dagelijks, vóór de start, en alle gegevens worden gecentraliseerd in de RSZ-databank en gekoppeld aan de werfaangifte (30bis) — elke werf die onder de verplichting valt, moet dus vooraf worden aangegeven om een werfnummer te verkrijgen.</p><h2>Wat is CIAO?</h2><p>CIAO (Check In And Out at Work) is het nieuwere systeem voor de schoonmaaksector, van kracht sinds 1 september 2024. Het vereist dat elke werknemer of zelfstandige die professionele schoonmaak uitvoert het begin en het einde van de activiteiten — plus de pauzes — digitaal en in realtime op de werf registreert. Het doel weerspiegelt dat van CheckIn@Work: meer transparantie, minder sociale fraude, veiligere werknemers.</p><p>Het dekt het onderhoud en de reiniging van onroerende goederen voor derden — het reinigen van de binnen-/buitenkant van gebouwen, kantoren, fabrieken of technische installaties, grondige reiniging na de bouw, ramen wassen, straatvegen, het ontsmetten van labo&#x27;s of cleanrooms. Uitgesloten: huishoudelijke schoonmaak via dienstencheques, schoonmaak die intern met eigen personeel wordt uitgevoerd, en niet-schoonmaakwerk (technisch onderhoud, herstellingen, montage). Vuistregel: als het enige doel van de activiteit is een plek te reinigen (niet te herbouwen of te herstellen), valt ze onder CIAO — binnen de hieronder vermelde drempels.</p><h2>Drempels &amp; hoe de registratie werkt</h2><p>In tegenstelling tot de vaste €500.000 van CheckIn@Work hanteert CIAO de 30bis-drempels, aangepast voor de schoonmaak:</p><ul><li>≥ €30.000 excl. btw zonder onderaannemer</li><li>≥ €5.000 met één onderaannemer</li><li>€0 (geen drempel) met twee of meer onderaannemers</li></ul><p>CIAO vereist twee handelingen per persoon per dag — een IN-registratie wanneer de schoonmaak begint en een OUT op het einde, plus elke pauze. Elke werknemer registreert zichzelf in realtime, op de werf, via de app of het toestel; de werkgever of teamleider mag het niet in zijn plaats doen en mag niet vooraf registreren. De officiële onlinedienst is beschikbaar sinds 1 januari 2024, met methodes zoals de web-/mobiele app van de RSZ (eID, Itsme, QR), een mobiele klok op de werf, of gecertificeerde apps van derden.</p><h2>Veelgemaakte fouten &amp; sancties</h2><ul><li>Werven die onder de verplichting vallen niet identificeren (denken dat een werf &#x27;te klein&#x27; is); een contract kunstmatig opsplitsen kan een overtreding zijn</li><li>De werfaangifte (30bis) vergeten — zonder die aangifte kunnen de registraties niet aan een geldige werf worden gekoppeld</li><li>Niet afspreken wie wie registreert wanneer meerdere bedrijven een werf delen</li><li>Te late of onnauwkeurige registratie — één registratie bij de start van het project in plaats van dagelijks, een verkeerd werfnummer, of OUT registreren in het depot in plaats van op de werf van de klant</li><li>Personeel niet informeren of trainen</li><li>Aannemen dat een intern badgesysteem volstaat — de gegevens moeten via de officiële RSZ-kanalen lopen</li><li>De boetes onderschatten</li></ul><p>De straffen onder het Sociaal Strafwetboek lopen van €300–€3.000 (niveau 1) of €600–€6.000 (niveau 3) per werknemer; ernstige gevallen kunnen leiden tot de sluiting van de werf of een verbod om te werken. CIAO had een sanctievrije overgangsperiode tot 30 april 2025; in de bouw is er geen tolerantie, en de controles omvatten systematisch CheckIn@Work.</p><h2>Compliant blijven</h2><p>Identificeer uw verplichtingen (sector, projectwaarde, onderaanneming), dien de 30bis-aangifte in vóór het werk begint, kies en configureer de officiële tools (of een gecertificeerde integratie die automatisch doorstuurt, zoals Done-it), train uw personeel, leg de verantwoordelijkheden schriftelijk vast, controleer de registraties dagelijks, en archiveer de gegevens. Met een tool zoals Done-it klokken werknemers in via één mobiele app (GPS, QR, badge) en worden de gegevens automatisch doorgestuurd naar CheckIn@Work of CIAO — het vervangt ze niet, het koppelt eraan — terwijl het operationele extra&#x27;s toevoegt (locatie, uren, kilometers, het delen van documenten en foto&#x27;s).</p>",
        "lead": "Belgische kmo's in bouw, renovatie, schoonmaak en technische diensten moeten voldoen aan de verplichtingen rond aanwezigheidsregistratie. In 2025 lopen twee systemen naast elkaar — CheckIn@Work en CIAO — voor verschillende sectoren, met verschillende regels. Niet-naleving wordt zwaar gesanctioneerd.",
        "read": "8 min",
        "slug": "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
        "title": "CheckIn@Work & CIAO: verplichtingen, fouten en tips voor Belgische kmo's",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551012/blog/checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-i.jpg"
      },
      {
        "tag": "E-invoicing",
        "html": "<h2>Wat de verplichting inhoudt</h2><p>Vanaf de startdatum mogen bedrijven geen papieren of pdf-facturen meer gebruiken voor B2B; ze moeten gestructureerde e-facturen uitgeven en ontvangen volgens gemeenschappelijke normen. De kernpunten:</p><ul><li>Start 1 januari 2026 — voor alle Belgische btw-plichtige bedrijven, enkel B2B; facturen aan consumenten (B2C) vallen voorlopig buiten het toepassingsgebied</li><li>Standaardformaat — de Europese norm EN 16931, in de praktijk Peppol BIS 3.0 (UBL XML); pdf&#x27;s en papier zijn niet meer geldig</li><li>Verzending via PEPPOL — een gedecentraliseerd model waarbij elke partij zich aansluit via een gecertificeerd Access Point; een digitale handtekening is niet vereist omdat PEPPOL de authenticiteit garandeert</li><li>Alternatieven — verzender en ontvanger mogen een ander kanaal gebruiken (bv. private EDI) als de factuur nog steeds voldoet aan EN 16931, maar elk bedrijf moet technisch in staat zijn om PEPPOL te gebruiken</li><li>Uitzonderingen — enkel binnenlandse B2B; buitenlandse transacties gebruiken e-facturatie enkel in onderling akkoord</li><li>Mogelijke fasering naar bedrijfsgrootte (&gt;€9M, €7–9M, &lt;€7M) — nog geen officieel schema bevestigd</li><li>Btw-afronding — vanaf 2026 mag de btw op e-facturen enkel per tarief worden afgerond, niet per lijn</li><li>Sancties — €1.500 / €3.000 / €5.000 voor de eerste/tweede/derde overtreding, plus een mogelijk verlies van het recht op btw-aftrek</li></ul><h2>Wat is PEPPOL en hoe werkt het</h2><p>PEPPOL (Pan-European Public Procurement On-Line) is een standaard en een internationaal netwerk om elektronische documenten veilig en interoperabel te versturen. Bedrijven mailen hun facturen niet rechtstreeks: elk sluit zich aan op een gecertificeerd Access Point dat de factuur over het netwerk naar het Access Point van de ontvanger routeert, dat ze in hun software aflevert — met gemeenschappelijke protocollen en formaten, zodat er geen op maat gemaakte point-to-pointverbindingen nodig zijn. Veel Belgische ERP&#x27;s en cloudtools (Odoo, SAP, enz.) ondersteunen het al.</p><h2>Voordelen</h2><ul><li>Een open netwerk — elk aangesloten bedrijf kan elk ander factureren, welke systemen ze ook gebruiken</li><li>Volledige automatisering — leveranciersfacturen komen rechtstreeks in uw software binnen en verkoopfacturen gaan buiten zonder e-mail</li><li>Betere beveiliging — enkel geautoriseerde deelnemers zitten op het netwerk</li><li>Snellere verwerking met minder fouten</li><li>Toekomstbestendig — België is van plan PEPPOL te gebruiken voor bijna realtime e-Reporting aan de belastingdiensten vanaf 2028</li></ul><h2>Hoe u zich voorbereidt</h2><ul><li>Informeer en train — ga na welke klanten/leveranciers binnenlandse B2B zijn, en train uw administratie in de nieuwe formaten (UBL XML) en tools</li><li>Evalueer uw huidige software — vraag uw leverancier naar de ondersteuning van PEPPOL en EN 16931; updates worden verwacht in 2025</li><li>Kies compatibele software — zoek naar &#x27;Peppol-ready&#x27; pakketten of erkende access points; een geïntegreerde tool (projecten, uren, kosten, documenten op één plek) houdt de factuurgegevens gestructureerd</li><li>Test vóór 2026 — wissel vrijwillig e-facturen uit met vertrouwde partners om problemen vroeg op te sporen</li><li>Raadpleeg specialisten of uw softwarepartner voor integratievragen</li></ul><h2>De rol van beheertools</h2><p>Voor 2026 gaat het niet alleen om het uitgeven van facturen in PEPPOL-formaat, maar om het goed organiseren van de onderliggende gegevens — uren, verplaatsingen en taken per klant. Een tool die dit alles centraliseert (zoals Done-it) maakt de e-facturen nauwkeuriger en de overgang veel vlotter. Bedrijven die zich vroeg voorbereiden, maken van de verplichting een kans tot modernisering: snellere facturatie, minder fouten en een productievere backoffice.</p>",
        "lead": "België heeft een wet goedgekeurd die B2B-e-facturatie verplicht maakt vanaf 1 januari 2026: alle commerciële transacties tussen Belgische btw-plichtige bedrijven moeten gestructureerde elektronische facturen gebruiken, met PEPPOL als uitwisselingskanaal — in lijn met VAT in the Digital Age (ViDA) van de EU.",
        "read": "6 min",
        "slug": "e-facturatie-in-belgie-peppol-verplicht-voor-alle-bedrijven-in-2026",
        "title": "E-facturatie in België: PEPPOL verplicht voor alle bedrijven in 2026",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551014/blog/e-facturatie-in-belgie-peppol-verplicht-voor-alle-bedrijven-.jpg"
      },
      {
        "tag": "Mileage",
        "html": "<h2>Wetgeving &amp; referenties</h2><ul><li>Officiële kilometervergoeding — vanaf 1 juli 2025 bedraagt het maximum €0,4449/km (jaarlijks geïndexeerd tarief tot 30 juni 2026), met kwartaalbedragen rond €0,4309/km; vrij van belasting en bijdragen binnen het maximum, en enkel voor het eigen voertuig van een werknemer (bij een bedrijfswagen draagt de werkgever de kost rechtstreeks)</li><li>Fietsvergoeding (cao 164) — verplicht sinds 1 mei 2023; €0,29/km in 2025, belastingvrij tot €0,36/km met een jaarplafond van €3.610 (een lagere sectorale cao heeft voorrang)</li><li>Verplichte e-facturatie (PEPPOL) vanaf 1 januari 2026 — een pdf per e-mail volstaat niet meer, registreer verplaatsingen dus digitaal om gestructureerde facturen te voeden</li></ul><h2>De verplaatsingskilometers berekenen</h2><p>Eigen vs bedrijfswagen: verplaatsingen met het eigen voertuig geven recht op de officiële vergoeding; een bedrijfswagen heeft geen aparte vergoeding, waarbij de werkgever de brandstof en het onderhoud draagt — maar registreer de kilometers hoe dan ook, voor de onkostennota of uw eigen kostprijsberekening. Vergeet de parking en de tol niet.</p><p>Andere vervoerswijzen: sommige medewerkers verplaatsen zich met de fiets, de trein, de tram, de bus of te voet — houd een consequent beleid aan. Openbaar vervoer kan worden terugbetaald aan de werkelijke ticketprijs (trein/tram/bus hebben 0% btw in België); een enkele verplaatsing kan meerdere vervoerswijzen combineren, dus uw systeem moet toelaten om verschillende vervoerstypes per rit te registreren.</p><p>Verplaatsingstijd kan arbeidstijd zijn: volgens het EU-Tyco-arrest (2015) geldt voor werknemers zonder vaste werkplek de verplaatsing van thuis naar de eerste klant en van de laatste klant terug naar huis als arbeidstijd. Dat betekent niet dat u alles moet aanrekenen, maar het personeel moet correct worden betaald en de planning moet er rekening mee houden — beslis vooraf of de verplaatsingstijd wordt gefactureerd.</p><h2>Tarieven bepalen &amp; afspraken met klanten</h2><p>De officiële vergoeding regelt vooral de interne terugbetaling; commercieel bent u vrij om uw eigen verplaatsingstarief te bepalen (sommigen rekenen het forfaitaire tarief door, anderen een hoger tarief of een vast voorrijbedrag). Er is geen wettelijk maximum, maar het telt als belastbaar inkomen, dus baseer het op iets redelijks om zowel klanten niet af te schrikken als uw kosten te dekken.</p><p>Wees transparant: zeg vooraf in de offerte of de verplaatsing inbegrepen is of apart wordt aangerekend, en toon ze op de factuur als een aparte lijn — bv. &#x27;Verplaatsing – bezoek ter plaatse aan [locatie] – 50 km&#x27;. Voor de btw volgen doorgerekende kosten doorgaans het tarief van de hoofddienst (dus 21% als de dienst 21% is), met een mogelijke uitzondering van 0% voor zuivere tickets van openbaar vervoer; veel bedrijven passen voor de eenvoud gewoon het standaardtarief toe. Houd dit gescheiden van uw eigen aftrekbaarheid, waar brandstof- en autokosten slechts gedeeltelijk aftrekbaar zijn volgens de CO₂-coëfficiënten.</p><h2>Uren en kilometers op de factuur brengen</h2><p>Kilometers en uren met de hand bijhouden is traag en foutgevoelig. De registratie integreren met uw facturatie bespaart administratie en verbetert de nauwkeurigheid — en met de PEPPOL-e-facturatie vanaf 2026 is digitale integratie een noodzaak, geen luxe. Leg de ritten en uren van een dag vast, koppel elk aan de juiste klant of het juiste project, en de gegevens vloeien rechtstreeks naar een factuur per klant — geen afstanden meer opzoeken of tijden hertypen, en een gestructureerde (Peppol BIS) factuur met één klik die correct en volledig is.</p><h2>Hoe Done-it helpt</h2><p>Done-it registreert ritten automatisch via geolocatie (Trax-it) — vertrek- en aankomstpunten, de werkelijke route en de exacte afstand — wat manuele invoer en opgeblazen kilometers uitsluit. U definieert vervoerstypes (leasewagen, eigen wagen, carpool met bestuurder/passagier, fiets, openbaar vervoer) met hun eigen regels en tarieven, bekijkt routes op een kaart gekoppeld aan klant/project/taak, en combineert het met tijdsregistratie voor een volledig beeld. Het genereert automatisch rapporten (datum, adressen, kilometers) &#x27;volgens ernstige normen&#x27;, past de officiële geïndexeerde tarieven toe, signaleert de drempel van 24.000 km en respecteert de GDPR (geen tracking buiten de werkuren) — klaar om te exporteren naar de boekhouding of e-facturatie.</p>",
        "lead": "Voor veel Belgische kmo's in schoonmaak, technische diensten, onderhoud en bouw zijn verplaatsingen naar klanten dagelijkse kost. Transparante verplaatsingskosten behouden het vertrouwen van de klant en vermijden verrassingen op de factuur — en houden u juridisch in orde.",
        "read": "7 min",
        "slug": "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen",
        "title": "Verplaatsingen naar klanten factureren: hoe u kilometers correct registreert en aanrekent",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551016/blog/facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-co.jpg"
      }
    ],
    "fr-be": [
      {
        "tag": "Mileage",
        "html": "<h2>Pourquoi les relevés kilométriques manuels échouent</h2><p>Lorsque les travailleurs encodent leurs kilomètres en fin de semaine, ils reconstituent leurs trajets de mémoire. Le résultat : des chiffres arrondis, des trajets oubliés et des discussions en fin de mois. L&#x27;administration des salaires est gonflée ou sous-payée, et l&#x27;entreprise n&#x27;a pas de piste d&#x27;audit défendable.</p><h2>À quoi ressemble l&#x27;enregistrement automatique</h2><p>Un système basé sur le GPS capte le point de départ, le point d&#x27;arrivée, l&#x27;itinéraire réel et la distance exacte pour chaque trajet — en arrière-plan, pendant que le travailleur conduit. Aucune saisie manuelle. Les données sont horodatées, reliées au bon client ou au bon projet, et immédiatement disponibles dans le back-office.</p><p>Le travailleur sélectionne le type de transport au début du trajet (véhicule personnel, voiture de société, covoiturage, vélo). Le système applique automatiquement le bon tarif de remboursement et signale tout ce qui dépasse le seuil pour lequel une preuve des frais réels est nécessaire.</p><h2>Ce que cela fait économiser</h2><ul><li>Administration : plus besoin de courir après des carnets de route papier ni de corriger des erreurs Excel en fin de mois</li><li>Discussions : les données confirmées par GPS sont objectives — clients et travailleurs voient les mêmes chiffres</li><li>Coûts : des kilomètres qui n&#x27;auraient jamais figuré sur une note de frais sont enregistrés automatiquement</li><li>Conformité : une piste d&#x27;audit complète par travailleur, par trajet, par projet — prête pour le contrôle</li></ul><h2>Ce à quoi prêter attention dans un outil kilométrique</h2><ul><li>Enregistrement automatique via GPS — pas de saisie manuelle pour les travailleurs</li><li>Plusieurs types de transport avec des tarifs paramétrables</li><li>Liaison des trajets par projet ou par client</li><li>Conforme au RGPD : GPS actif uniquement pendant les heures de travail, données hébergées dans l&#x27;UE</li><li>Rapports prêts à exporter qui alimentent directement l&#x27;administration des salaires ou la facturation</li></ul><h2>Comment Done-it s&#x27;y prend</h2><p>Done-it enregistre automatiquement les trajets via Trax-it — le GPS enregistre l&#x27;itinéraire, le travailleur sélectionne le type de transport, et le système applique le bon tarif. Tout est relié au bon projet ou au bon client. Les rapports s&#x27;exportent directement vers l&#x27;administration des salaires ou la facturation électronique, sans reprise manuelle.</p>",
        "lead": "Lorsque votre équipe se déplace toute la journée entre les chantiers, les kilomètres s'accumulent vite — et les erreurs aussi. Voici comment fonctionne l'enregistrement automatique des kilomètres, ce qu'il fait économiser, et ce à quoi vous devez prêter attention dans une solution.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Suivre les kilomètres des équipes mobiles — sans la paperasse",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>La règle de base : la proportionnalité</h2><p>Le suivi GPS des travailleurs est légal sous le RGPD — mais uniquement lorsqu&#x27;il est proportionné à une finalité commerciale légitime. Coordonner les livraisons, confirmer les visites de service, garantir la sécurité des travailleurs : tout cela est valable. Suivre chaque mouvement de quelqu&#x27;un « au cas où » : non valable.</p><h2>Quatre choses à faire</h2><ul><li>Définissez la finalité : optimisation des itinéraires, sécurité, confirmation d&#x27;une prestation — et consignez-la par écrit</li><li>Limitez le suivi aux heures de travail : les travailleurs doivent pouvoir désactiver le GPS pendant leur temps privé</li><li>Informez clairement votre équipe : ce qui est collecté, pourquoi, qui peut le voir, combien de temps c&#x27;est conservé</li><li>Documentez-le : reprenez l&#x27;usage du GPS dans votre règlement de travail et réalisez une AIPD si le suivi est à grande échelle ou structurel</li></ul><h2>Ce que vous ne pouvez pas faire</h2><ul><li>Suivre 24/7 — le suivi en dehors des heures de travail viole la proportionnalité du RGPD</li><li>Utiliser les données GPS pour des sanctions automatiques (p. ex. des alertes de vitesse déclenchant une mesure disciplinaire) sans communication préalable</li><li>Conserver les données de localisation plus longtemps que nécessaire — la CNIL recommande un maximum de deux mois</li><li>Ne pas informer les travailleurs — un suivi non communiqué peut invalider la preuve dans un litige ultérieur</li></ul><h2>Points d&#x27;attention spécifiques par secteur</h2><p>Pour le field service et la logistique, le GPS est attendu et facile à justifier. Pour le nettoyage et l&#x27;entretien, la planification des itinéraires par les superviseurs est parfaite — un suivi constant par travailleur est plus difficile à justifier. Pour la construction, le GPS pour la protection des véhicules et des machines est standard ; il ne peut pas dupliquer un système d&#x27;enregistrement de présence déjà en usage.</p><h2>Comment Done-it s&#x27;y prend</h2><p>Done-it n&#x27;active le GPS qu&#x27;à l&#x27;entrée, à la sortie et pendant les déplacements professionnels actifs. Il n&#x27;y a pas de suivi 24/7, pas de surveillance pendant les pauses ou le temps privé. Les données sont hébergées dans l&#x27;UE avec chiffrement et un délégué à la protection des données distinct — prêtes pour tout audit de confidentialité.</p>",
        "lead": "Le suivi GPS des travailleurs mobiles soulève de réelles questions de vie privée. Voici le guide clair sur ce qui est légalement autorisé, ce qui ne l'est pas, et comment l'introduire de manière à ce que votre équipe l'accepte.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Suivi GPS des travailleurs mobiles : ce qui est permis et comment bien le faire",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Le problème des feuilles de temps manuelles</h2><p>Les travailleurs mobiles encodent leurs heures de mémoire, souvent des jours plus tard. L&#x27;arrondi est la norme. Les heures atterrissent sur le mauvais projet ou le mauvais client. L&#x27;administration des salaires est une approximation. Et lorsqu&#x27;un client conteste une facture — ou qu&#x27;un inspecteur débarque — il n&#x27;y a pas de registre objectif sur lequel s&#x27;appuyer.</p><h2>Ce que l&#x27;enregistrement numérique du temps signifie réellement</h2><p>L&#x27;enregistrement numérique signifie qu&#x27;un travailleur sur le chantier touche son écran pour pointer, que le système l&#x27;horodate avec une confirmation GPS, et que les heures sont automatiquement reliées au bon projet ou au bon client. En fin de mois, l&#x27;export de paie est généré en un clic — pas de course-poursuite, pas de réconciliation, pas d&#x27;erreurs.</p><p>Le back-office obtient une vue en direct : qui est sur quel chantier, combien d&#x27;heures ont été enregistrées par projet, et si une mission dépasse le budget. Cette visibilité change la façon de gérer — les problèmes apparaissent en temps réel plutôt qu&#x27;en fin de mois.</p><h2>Ce à quoi prêter attention dans un outil d&#x27;enregistrement du temps pour équipes mobiles</h2><ul><li>Entrée et sortie confirmées via GPS — pas de terminal, pas de lecteur de carte</li><li>Liaison des heures par projet ou par client, pas seulement un total journalier</li><li>Vue en direct des heures restantes par projet afin que les dépassements de budget soient visibles avant qu&#x27;ils ne se produisent</li><li>Suivi des heures supplémentaires avec un paiement flexible ou une conversion en congé</li><li>Gestion des congés et des absences, y compris l&#x27;upload numérique du certificat médical</li><li>Export de paie en un clic, compatible avec votre secrétariat social ou votre système RH</li></ul><h2>Objections fréquentes — auxquelles on répond</h2><p>Les travailleurs ne l&#x27;utiliseront pas. En pratique, pointer en un seul geste prend moins de temps que de remplir une feuille de temps papier en fin de semaine. L&#x27;adoption est presque toujours plus rapide que prévu. C&#x27;est trop cher. Done-it démarre à partir de 19 €/mois en base — moins que le coût d&#x27;une seule erreur dans l&#x27;administration des salaires. Nous sommes trop petits. Il n&#x27;y a pas de taille d&#x27;équipe minimale.</p><h2>La dimension conformité</h2><p>La plupart des pays de l&#x27;UE durcissent les exigences relatives à l&#x27;enregistrement du temps de travail — sous l&#x27;impulsion de l&#x27;arrêt de la Cour de justice de l&#x27;Union européenne de 2019 selon lequel les employeurs doivent disposer d&#x27;un système objectif et fiable pour mesurer le temps de travail quotidien. Un outil numérique fournissant un registre infalsifiable par travailleur, par jour, par projet satisfait à toute déclinaison locale de cette norme.</p>",
        "lead": "Lorsque votre équipe travaille répartie sur plusieurs chantiers, les feuilles de temps manuelles ne fonctionnent pas. Voici comment l'enregistrement numérique du temps change la réalité quotidienne — pour les travailleurs, les managers et l'administration des salaires.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Enregistrement du temps pour les équipes mobiles : un guide complet pour les PME",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Où passe le temps</h2><p>Pour une entreprise de 10 à 20 travailleurs mobiles, la préparation de l&#x27;administration des salaires prend généralement un à deux jours par mois. Quelqu&#x27;un rassemble les feuilles de temps (papier ou WhatsApp), les encode dans un fichier Excel, les réconcilie avec les données de projet, corrige les inévitables erreurs, et réalise un export pour le secrétariat social ou le prestataire de paie. Chaque étape est manuelle. Chaque étape comporte des risques de défaillance.</p><h2>Les points de blocage</h2><ul><li>Les feuilles de temps arrivent en retard ou incomplètes — les travailleurs sont sur la route, pas à un bureau</li><li>Les heures sont imputées au mauvais projet ou au mauvais client, ce qui exige une correction manuelle</li><li>Les données d&#x27;heures supplémentaires et d&#x27;absences vivent dans un système séparé (ou sur un post-it)</li><li>L&#x27;export de paie a un format différent de ce que le secrétariat attend</li></ul><h2>Ce qu&#x27;un système numérique change</h2><p>Lorsque les travailleurs pointent l&#x27;entrée et la sortie via GPS sur leur téléphone, les heures sont enregistrées au moment où elles se produisent — reliées au bon projet, avec des heures exactes, sans arrondi. En fin de mois, l&#x27;export est généré en un clic. Les chiffres sont déjà corrects. Il n&#x27;y a rien à réconcilier.</p><p>Les heures supplémentaires sont suivies au fur et à mesure. Les absences sont introduites numériquement par le travailleur. Les soldes de congés sont mis à jour automatiquement. La tâche du manager devient de consulter un tableau de bord, et non de le construire à partir de données brutes.</p><h2>Ce que rapportent les équipes</h2><ul><li>Préparation de l&#x27;administration des salaires passée de deux jours à moins d&#x27;une heure</li><li>Erreurs de paie fortement réduites — pas de saisie manuelle signifie pas d&#x27;erreurs de transcription</li><li>Le calcul a posteriori des projets devient possible — heures réelles par mission, pas d&#x27;approximations</li><li>Les travailleurs le préfèrent même — pas de feuille de temps à remplir en fin de semaine</li></ul><h2>Pour commencer</h2><p>Done-it amène la plupart des équipes de l&#x27;inscription aux premières heures enregistrées dans le même après-midi. Pas de matériel, pas de projet IT. Les travailleurs téléchargent l&#x27;application et pointent. Les heures apparaissent dans le tableau de bord. L&#x27;export de paie est prêt en fin de mois. La période d&#x27;essai est de 30 jours gratuits — aucune carte requise.</p>",
        "lead": "Pour les entreprises ayant des équipes mobiles, la préparation de l'administration des salaires est un cauchemar mensuel — courir après les feuilles de temps, corriger les erreurs, réconcilier les projets. Voici comment les équipes qui l'ont résolu s'y sont prises.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Comment les entreprises de field service réduisent leur administration des salaires de 80 %",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Où en est la Belgique aujourd&#x27;hui</h2><p>Le droit du travail belge (qui est sur le point de changer) ne prévoit aujourd&#x27;hui aucune obligation générale d&#x27;enregistrer systématiquement les heures. Cela n&#x27;est obligatoire que dans des cas spécifiques — les travailleurs à temps partiel avec des horaires variables et le personnel à horaire flottant, qui doivent enregistrer les écarts par rapport à leur horaire normal. En dehors de ces exceptions, la plupart des entreprises n&#x27;utilisent pas encore de pointeuse formelle ni d&#x27;enregistrement numérique.</p><p>Pourtant, la Belgique impose déjà dans certains secteurs un enregistrement de présence dans le cadre de la lutte contre la fraude sociale :</p><ul><li>Construction (travaux immobiliers, livraison de béton) — via CheckIn@Work</li><li>Le secteur de la viande — également via CheckIn@Work</li><li>Le nettoyage de bâtiments — via CIAO (Check In And Out at Work)</li></ul><p>CIAO est entré en vigueur le 1er septembre 2024 et oblige les entreprises de nettoyage et d&#x27;entretien à enregistrer numériquement l&#x27;entrée et la sortie de leurs travailleurs sur chaque lieu de travail — y compris les entreprises étrangères actives en Belgique. Ces initiatives sectorielles visent à accroître la transparence, à améliorer les conditions de travail et à lutter contre le travail au noir ; les contrôles sont actifs et le non-respect est sanctionné.</p><h2>La nouvelle loi de 2027</h2><p>Conformément aux tendances européennes, la Belgique instaure à partir du 1er janvier 2027 une obligation générale d&#x27;enregistrer le temps de travail de chaque travailleur. La modification a été annoncée le 27 novembre 2025 dans le cadre de l&#x27;accord budgétaire fédéral. Chaque employeur, privé et public, devra disposer d&#x27;un système objectif, fiable et flexible pour enregistrer les heures de chaque travailleur.</p><p>La forme concrète est laissée à l&#x27;employeur : vous choisissez vous-même la technologie ou la méthode (une pointeuse numérique, une application mobile ou un autre système), pour autant qu&#x27;elle produise un enregistrement objectif et fiable. L&#x27;obligation découle du droit de l&#x27;UE — la Cour de justice a jugé en 2019 que les États membres doivent obliger les employeurs à mettre en place un système objectif, fiable et accessible mesurant le temps de travail quotidien. La Belgique s&#x27;est jusqu&#x27;à présent opposée à une obligation générale.</p><p>Important : le texte légal définitif n&#x27;est pas encore publié, de sorte que les détails restent ouverts — quels groupes souvent exemptés des règles classiques du temps de travail (certaines fonctions dirigeantes, les travailleurs mobiles) y seront soumis, comment les enregistrements devront être conservés, et les sanctions en cas de non-respect. Des propositions antérieures mentionnaient que les enregistrements devraient être conservés au moins cinq ans.</p><h2>Impact et objectifs</h2><p>Pour beaucoup d&#x27;entreprises, il s&#x27;agit d&#x27;un changement profond, étant donné que la plupart n&#x27;ont pas encore de système — toutes les entreprises devront adapter leurs procédures d&#x27;ici 2027. Pour certaines, cela signifie davantage d&#x27;administration et moins de flexibilité dans la planification. Il y a aussi un aspect juridique : une décision belge a jugé qu&#x27;en l&#x27;absence d&#x27;enregistrements, la charge de la preuve repose entièrement sur l&#x27;employeur pour démontrer qu&#x27;aucune heure supplémentaire n&#x27;a été prestée — quasi impossible sans enregistrement objectif — ce qui expose l&#x27;entreprise à des réclamations pour heures impayées.</p><p>Les objectifs de la réforme sont la protection et le bien-être du travailleur : prévenir les heures supplémentaires non souhaitées ou impayées, un meilleur équilibre entre vie professionnelle et vie privée, et davantage de transparence et d&#x27;équité. L&#x27;application reflétera probablement celle de CheckIn@Work et de CIAO — contrôles et sanctions — de sorte qu&#x27;un système fiable permet à la fois d&#x27;éviter les amendes et de fournir une preuve solide lors de contrôles ou de litiges.</p><h2>Leçons des secteurs qui le font déjà</h2><p>Dans la construction et le secteur de la viande, la présence de chaque travailleur doit déjà être enregistrée quotidiennement via CheckIn@Work, avant le début de la journée de travail ; le travailleur peut s&#x27;enregistrer lui-même ou l&#x27;employeur peut le faire, mais il doit y avoir une preuve électronique de qui est présent, où et quand. Dans le nettoyage, CIAO exige un enregistrement en temps réel du début et de la fin des activités, pauses comprises ; il s&#x27;applique aux travailleurs, aux indépendants, aux intérimaires et aux stagiaires, et le pré-enregistrement ou l&#x27;antidatage manuel n&#x27;est pas autorisé.</p><p>Ces secteurs pionniers démontrent que l&#x27;enregistrement numérique est réalisable et efficace : un clic dans une application ou un scan de badge, avec des données immédiatement disponibles pour le reporting et les contrôles. La technologie existe et a fait ses preuves sur le terrain.</p><h2>Comment être en règle : vos options</h2><ul><li>Applications mobiles — le travailleur enregistre le début/la fin (et les pauses) depuis un smartphone, avec l&#x27;heure exacte et, en option, la géolocalisation ; idéal pour un personnel réparti sur plusieurs sites ou des équipes mobiles</li><li>Terminaux / pointeuses — des appareils physiques sur lesquels le personnel pointe avec un badge, un code PIN, un bracelet ou la biométrie ; adaptés aux lieux de travail fixes</li><li>Logiciels de bureau / cloud — saisie manuelle, ou systèmes qui détectent l&#x27;activité à la connexion/déconnexion et marquent les pauses en cas d&#x27;inactivité</li></ul><p>Quel que soit votre choix, le système doit enregistrer le début et la fin de chaque journée de travail (et les pauses lorsque c&#x27;est pertinent), conserver les données de manière sécurisée, et générer des rapports d&#x27;heures, d&#x27;heures supplémentaires et d&#x27;écarts. Il doit prévenir la manipulation (connexions individuelles, badges personnels, géotagging ou biométrie) et être suffisamment flexible pour les horaires flottants, les équipes de nuit, le travail par projet et les sites multiples — afin que vous disposiez d&#x27;un aperçu complet et vérifiable des heures de chaque travailleur.</p><h2>Commencez à vous préparer dès maintenant</h2><p>2027 semble loin, mais c&#x27;est le moment de vous préparer. Un système numérique n&#x27;est pas seulement une réponse à la future obligation — il améliore aussi l&#x27;organisation quotidienne : des heures plus claires, moins d&#x27;erreurs et de litiges, une meilleure planification des ressources, et une détection plus précoce des surcharges. Beaucoup d&#x27;entreprises optent pour une solution entièrement mobile comme Done-it plutôt que pour du matériel coûteux : le personnel pointe via smartphone, vous obtenez un registre des heures légal, toujours accessible, avec track &amp; trace, et les rapports pour les contrôles ou l&#x27;administration des salaires sont générés automatiquement.</p>",
        "lead": "À partir du 1er janvier 2027, chaque employeur belge — privé et public — devra enregistrer le temps de travail de son personnel. Annoncé le 27 novembre 2025 dans le cadre de l'accord budgétaire fédéral. Voici ce que cela signifie et comment vous y préparer.",
        "read": "8 min",
        "slug": "verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedrijven-weten",
        "title": "Enregistrement obligatoire du temps de travail en Belgique : ce que les entreprises doivent savoir",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551043/blog/verplichte-arbeidstijdregistratie-in-belgie-wat-moeten-bedri.jpg"
      },
      {
        "tag": "E-invoicing",
        "html": "<h2>Le contexte européen</h2><p>L&#x27;UE encourage la numérisation de la TVA via l&#x27;initiative VAT in the Digital Age (ViDA), qui harmonise les transactions avec des factures électroniques structurées et le partage quasi en temps réel des données TVA avec les administrations fiscales. La Commission estime que cela peut prévenir jusqu&#x27;à 11 milliards d&#x27;euros par an de fraude à la TVA et économiser plus de 4,1 milliards d&#x27;euros de coûts administratifs.</p><p>La Belgique suit cette stratégie avec une introduction progressive. La facturation électronique est obligatoire depuis 2022 pour les marchés publics (B2G), par phases les 1er novembre 2022, 1er mai 2023 et 1er mars 2024 — les fournisseurs des institutions publiques envoient leurs factures via le réseau PEPPOL grâce à la plateforme nationale Mercurius. En mars 2024, le parlement a approuvé une loi qui étend cela au secteur privé : à partir du 1er janvier 2026, la facturation électronique structurée est obligatoire pour toutes les transactions B2B entre entreprises belges assujetties à la TVA.</p><h2>Qu&#x27;est-ce que PEPPOL ?</h2><p>PEPPOL (Pan-European Public Procurement Online) est un réseau international développé par l&#x27;UE pour standardiser l&#x27;échange électronique de documents commerciaux. Depuis 2008, il relie entreprises, administrations et organisations via des Access Points certifiés. Vous reliez votre logiciel comptable à un fournisseur PEPPOL agréé, et dès lors vous pouvez échanger avec toute partie connectée dans toute l&#x27;Europe — sans intégrations séparées. La Belgique utilise PEPPOL comme canal B2B standard pour garantir l&#x27;interopérabilité paneuropéenne.</p><h2>Qu&#x27;est-ce qu&#x27;une facture électronique structurée ?</h2><p>Une facture électronique structurée organise toutes les données (fournisseur, client, montants, TVA, produits) dans des champs fixes, généralement un fichier XML au format UBL ou Peppol BIS. Contrairement à un pdf ou à un scan, elle est lisible par machine : le logiciel comptable lit et traite tout automatiquement, sans saisie manuelle ni interprétation source d&#x27;erreurs. Pour les PME et les indépendants, cela signifie beaucoup moins de travail manuel, moins d&#x27;erreurs et un traitement plus rapide.</p><h2>Le calendrier</h2><ul><li>2024 — le déploiement B2G est achevé ; la loi qui prépare l&#x27;obligation B2B de 2026 est approuvée</li><li>2025 — un Arrêté royal fixe les détails techniques (formats autorisés comme Peppol BIS, protocoles d&#x27;échange, règles d&#x27;arrondi) ; une période de tolérance est annoncée pour janvier–mars 2026</li><li>1er janvier 2026 — l&#x27;obligation s&#x27;applique à toutes les entreprises belges assujetties à la TVA pour le B2B ; à partir d&#x27;avril 2026, les factures papier et pdf ne sont plus acceptées</li></ul><h2>Sanctions &amp; FAQ importantes</h2><p>Après la période transitoire s&#x27;appliquent des amendes croissant progressivement : 1.500 € pour une première infraction, 3.000 € pour une deuxième, 5.000 € pour une troisième. Documentez chaque étape (modifications logicielles, communication interne, envois de test) pour éviter les sanctions.</p><ul><li>Partenaire pas sur PEPPOL ? Vérifiez l&#x27;annuaire PEPPOL avant d&#x27;envoyer ; s&#x27;il n&#x27;est pas enregistré, contactez-le pour qu&#x27;il démarre — n&#x27;envoyez pas en même temps un pdf et une facture électronique</li><li>Panne de système ? Basculez vers une solution de secours (temporairement un pdf par e-mail), documentez la panne, puis renvoyez via PEPPOL dès que tout est rétabli</li><li>Erreurs ? Utilisez les corrections habituelles — une note de crédit ou une facture corrigée avec une piste d&#x27;audit claire</li><li>Un pdf par e-mail ne répond plus à l&#x27;exigence à partir de 2026, sauf accord écrit explicite et si elle est convertible vers la norme EN 16931</li><li>Les clients étrangers sont hors du champ d&#x27;application — l&#x27;obligation ne vaut que pour le B2B national</li><li>Soutien aux PME : une déduction pour investissement de 20 % pour le matériel numérique à partir du 1er janvier 2025, et une déduction de 120 % sur les coûts des logiciels de facturation électronique pour les exercices d&#x27;imposition 2024–2027</li></ul><h2>Conseils pratiques</h2><p>Commencez dès maintenant : choisissez un logiciel ou un fournisseur compatible PEPPOL, informez vos clients et fournisseurs, et documentez chaque étape afin d&#x27;être juridiquement protégé. Le site du SPF Finances (facture électronique) propose des kits de communication pour informer vos partenaires du changement.</p>",
        "lead": "À partir du 1er janvier 2026, la facturation électronique structurée devient obligatoire pour les transactions B2B entre entreprises belges assujetties à la TVA, avec le réseau PEPPOL comme canal standard.",
        "read": "7 min",
        "slug": "verplichte-e-facturatie-b2b-via-peppol-in-belgie-vanaf-2026",
        "title": "Facturation électronique B2B obligatoire via PEPPOL en Belgique à partir du 1er janvier 2026",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551044/blog/verplichte-e-facturatie-b2b-via-peppol-in-belgie-vanaf-2026.jpg"
      },
      {
        "tag": "Cross-border",
        "html": "<h2>Déclarations &amp; autorisations</h2><p>Une entreprise belge qui détache des travailleurs aux Pays-Bas doit introduire au préalable une déclaration WagwEU via le portail des travailleurs détachés de l&#x27;Inspection du travail néerlandaise ; les indépendants doivent eux aussi parfois se déclarer. Ne pas déclarer, ou trop tard, peut coûter à l&#x27;employeur et au donneur d&#x27;ordre néerlandais environ 4.500 €.</p><p>Une entreprise néerlandaise qui occupe du personnel en Belgique doit introduire pour chaque travailleur étranger une déclaration LIMOSA-1 avant le début du travail, et pouvoir présenter l&#x27;attestation L1 sur demande — les sanctions (pénales ou administratives) frappent tant l&#x27;employeur que le donneur d&#x27;ordre. Depuis 2016, l&#x27;employeur étranger doit également désigner une personne de contact locale en Belgique.</p><p>Pour presque tout emploi transfrontalier, une attestation A1 (Certificate of Coverage) est nécessaire : elle prouve que le travailleur reste, pendant la mission, soumis à la sécurité sociale de son pays d&#x27;origine. Sans cette attestation, certains pays n&#x27;autorisent pas le travail. Demandez-la auprès de l&#x27;ONSS/INASTI (Belgique) ou de la SVB (Pays-Bas) avant le début du travail.</p><h2>Heures, kilomètres &amp; GPS</h2><p>Heures : les Pays-Bas obligent strictement chaque employeur à tenir un relevé des heures et des pauses. La Belgique n&#x27;a longtemps connu aucune obligation générale ; depuis le 1er juillet 2024, c&#x27;est obligatoire pour les horaires flottants (un système d&#x27;enregistrement est requis), tandis que les horaires fixes ne sont pas encore obligatoires, bien que l&#x27;enregistrement soit souvent privilégié.</p><p>Kilomètres : les deux pays autorisent une indemnité forfaitaire par km exonérée d&#x27;impôt, mais les maxima diffèrent — les Pays-Bas ont fixé 0,23 €/km pour 2024, tandis que la Belgique se situe bien plus haut (autour de 0,43–0,44 €/km, indexée trimestriellement depuis 2022). Tout ce qui dépasse le maximum est imposé comme salaire dans les deux pays.</p><p>GPS : autorisé dans les deux pays, mais uniquement dans le respect du RGPD — un intérêt légitime mis en balance avec la vie privée, pas de suivi permanent, le travailleur doit pouvoir désactiver le GPS pendant son temps privé, et le système doit être repris dans le règlement de travail avec une information claire sur ce qui est collecté et pourquoi.</p><h2>Sécurité sociale, impôts &amp; détachement</h2><p>Détachement : les travailleurs restent normalement assurés dans le pays d&#x27;origine de l&#x27;employeur. Avec l&#x27;attestation A1, un travailleur peut travailler jusqu&#x27;à 24 mois dans l&#x27;autre pays sans y payer de nouvelles cotisations sociales, prolongeable jusqu&#x27;à 36 mois. Au-delà, le pays d&#x27;accueil peut prélever des cotisations si le travail se poursuit.</p><p>Impôts : la règle souvent citée des 183 jours signifie que si le travailleur ne séjourne pas plus de 183 jours dans le pays d&#x27;accueil sur une période de 12 mois, le pays d&#x27;origine conserve normalement le droit d&#x27;imposer. L&#x27;administration fiscale néerlandaise le formule simplement : si le pays d&#x27;accueil peut imposer, l&#x27;employeur ne doit pas retenir de précompte professionnel néerlandais ; si les Pays-Bas peuvent imposer, il le doit. Il existe des régimes particuliers, comme le régime néerlandais des 30 % pour les expatriés. En Belgique, les travailleurs étrangers paient généralement l&#x27;impôt belge sur les revenus pour le travail effectué ici, bien que le seuil des 183 jours maintienne souvent la déclaration dans le pays d&#x27;origine.</p><h2>Documents &amp; sanctions</h2><p>Conservez les contrats de travail, les fiches de paie, les enregistrements du temps, le formulaire A1 et les preuves de paiement au moins cinq ans, et présentez-les lors d&#x27;un contrôle. Aux Pays-Bas, une déclaration de détachement manquée coûte jusqu&#x27;à environ 4.500 € (les donneurs d&#x27;ordre sont aussi responsables) ; en Belgique, ignorer LIMOSA entraîne des sanctions pénales et administratives tant pour l&#x27;employeur que pour le donneur d&#x27;ordre, et une attestation A1 manquante augmente le risque de contrôle.</p>",
        "lead": "Travailler par-delà la frontière entre la Belgique et les Pays-Bas entraîne, de part et d'autre, des obligations de déclaration distinctes, des formalités de sécurité sociale et des règles fiscales. Voici la base pratique.",
        "read": "7 min",
        "slug": "gids-voor-belgische-en-nederlandse-bedrijven-die-actief-zijn-over-de-grens",
        "title": "Guide pour les entreprises belges et néerlandaises actives par-delà la frontière",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551019/blog/gids-voor-belgische-en-nederlandse-bedrijven-die-actief-zijn.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Ce qui change</h2><p>L&#x27;enregistrement numérique du temps sur les chantiers belges est prévu pour 2027 et est déjà bien avancé. L&#x27;avis n° 2.465 du CNT confirme que les règles imposeront d&#x27;enregistrer numériquement sur le chantier tant la présence à l&#x27;arrivée qu&#x27;au départ (check-out) de chaque travailleur. La mesure vise à renforcer la sécurité au travail et à lutter contre la fraude sociale dans la construction.</p><h2>Le cadre juridique</h2><p>Les règles actuelles reposent sur CheckIn@Work. Selon les directives du SPF Emploi (le guide SIRS), chaque travailleur doit être enregistré quotidiennement avant le début du travail. En pratique, cela s&#x27;applique actuellement aux chantiers de plus de 500.000 € hors TVA, où la présence de tout le personnel doit être enregistrée via l&#x27;application de l&#x27;ONSS — enregistrement uniquement à l&#x27;arrivée.</p><p>L&#x27;avis n° 2.465 du CNT traite d&#x27;un projet qui étend cela : outre l&#x27;arrivée, l&#x27;enregistrement au départ (check-out) devient également obligatoire. Le Conseil note que le nouvel Arrêté royal devra entrer en vigueur au plus tard le 1er janvier 2027, et que les infractions pourront être sanctionnées en vertu du Code pénal social.</p><h2>Les sanctions</h2><p>Après une période transitoire, la loi prévoit des amendes de 80 à 800 € (niveau 1) pour le non-enregistrement d&#x27;une entrée ou d&#x27;une sortie, des peines plus lourdes jusqu&#x27;à 8.000 €, et dans les cas graves des amendes pénales jusqu&#x27;à 16.000 €. Un système entièrement numérique accroît la transparence et facilite la vérification, avec une preuve claire des heures prestées et sans discussions manuelles.</p><h2>Recommandations</h2><ul><li>Enregistrement en temps réel via une application officielle (comme Done-it) afin que chaque travailleur sur le chantier pointe l&#x27;entrée et la sortie depuis son propre smartphone — l&#x27;enregistrement doit se faire en temps réel</li><li>Formez et informez les travailleurs et les sous-traitants ; établissez des protocoles clairs et remplacez entièrement les listes papier</li><li>Centralisez les enregistrements en ligne, reliez-les à la déclaration de chantier officielle (formulaire 30bis), et effectuez régulièrement des audits numériques</li></ul><h2>Partie d&#x27;une tendance plus large</h2><p>L&#x27;enregistrement numérique obligatoire s&#x27;étend à toute l&#x27;UE. Le nettoyage (CIAO) exige depuis septembre 2024 un enregistrement numérique des entrées et sorties, et le CNT a recommandé des mesures similaires pour le secteur du déménagement. Une seule application mobile peut couvrir l&#x27;enregistrement de présence pour la construction, le nettoyage et le déménagement à la fois — sans matériel supplémentaire.</p>",
        "lead": "Sur les chantiers, tant l'arrivée que le départ de chaque travailleur devront être enregistrés numériquement. Basé sur l'avis n° 2.465 du Conseil national du travail (CNT) du 5 novembre 2025, qui s'inscrit dans l'accord fédéral 2025–2029.",
        "read": "5 min",
        "slug": "digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025",
        "title": "Enregistrement numérique des entrées et sorties obligatoire sur les chantiers à partir de 2027",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551013/blog/digitaal-in-en-uitchecken-verplicht-op-bouwwerven-vanaf-2025.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<p>Êtes-vous une PME de la construction, travaillez-vous avec des sous-traitants ou gérez-vous des équipes mobiles réparties sur différents chantiers ? Alors c&#x27;est le moment de mettre votre administration en ordre — de préférence sous forme numérique.</p><h2>Ce que les inspecteurs contrôlent</h2><ul><li>Règlement de travail — heures, pauses, équipes et annexes psychosociales</li><li>Contrats de travail — temps plein, temps partiel, intérimaires, étudiants et personnel étranger (LIMOSA)</li><li>Dimona — tout le monde est-il déclaré correctement et à temps ?</li><li>Enregistrement CheckIn@Work sur les grands chantiers</li><li>Preuves de paiement &amp; fiches de paie, y compris les indemnités de repas et de mobilité</li><li>Assurance accidents du travail, active pour tout le personnel et les sous-traitants</li><li>Enregistrements quotidiens de présence / du temps, sur papier ou numériques</li></ul><h2>Si vous n&#x27;êtes pas en règle</h2><ul><li>Amendes administratives ou pénales jusqu&#x27;à des dizaines de milliers d&#x27;euros</li><li>Récupération des cotisations ONSS (sécurité sociale)</li><li>Arrêt temporaire d&#x27;un chantier ou d&#x27;un projet</li><li>Atteinte à la réputation auprès des clients et des autorités</li></ul><h2>Comment prévenir les problèmes : numérisez</h2><p>Avec un outil comme Done-it, vous gardez tout centralisé, sécurisé et à jour :</p><ul><li>Enregistrement du temps via smartphone — entrée/sortie avec géolocalisation et lien avec le projet</li><li>Gestion documentaire dans le cloud — contrats, attestations d&#x27;assurance et fiches de paie au même endroit</li><li>Reporting par travailleur ou par projet — téléchargeable immédiatement lors d&#x27;un contrôle</li><li>Suivi des sous-traitants — vérifiez si leur personnel est correctement enregistré et présent</li></ul><h2>En résumé</h2><p>Les contrôles flash de l&#x27;été 2025 ne sont pas une surprise et s&#x27;inscrivent dans une tendance plus large à un renforcement de l&#x27;application. Les outils numériques vous maintiennent en permanence en conformité et vous donnent, en prime, une meilleure visibilité sur les performances et les coûts de votre équipe. N&#x27;attendez pas que l&#x27;inspection débarque sur votre chantier — commencez à numériser dès aujourd&#x27;hui.</p>",
        "lead": "Au cours de l'été 2025, l'inspection sociale belge (SIOD/SIRS) a de nouveau mené des contrôles flash inopinés dans la construction, l'électrotechnique et la métallurgie, axés sur le respect de la législation du travail et sur la fraude sociale — travail au noir, emploi illégal et déclarations Dimona erronées.",
        "read": "4 min",
        "slug": "flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-vermijd-je-boetes-met-digitale-oplossingen",
        "title": "Contrôles flash dans le secteur belge de la construction (été 2025) : éviter les amendes grâce aux outils numériques",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551018/blog/flashcontroles-in-de-belgische-bouwsector-zomer-2025-hoe-ver.jpg"
      },
      {
        "tag": "Mileage",
        "html": "<h2>Remboursements et tarifs officiels</h2><p>En tant qu&#x27;employeur, vous pouvez verser à votre personnel une indemnité pour les déplacements professionnels effectués avec son propre véhicule. Elle est normalement exonérée d&#x27;impôt et de cotisations sociales — pour les deux parties — pour autant que les maxima officiels soient respectés, et elle doit couvrir des déplacements professionnels (visites de clients, réunions externes, déplacements entre lieux de travail), et non le trajet domicile-travail.</p><p>Les tarifs officiels sont publiés par l&#x27;autorité fédérale (SPF BOSA, via des circulaires du SPF Finances). Le fisc admet que l&#x27;indemnité couvre les frais réels pour autant qu&#x27;elle soit basée sur les kilomètres effectivement parcourus et qu&#x27;elle ne soit pas supérieure à ce que l&#x27;État verse à son propre personnel. Vous pouvez rembourser davantage, mais vous devez alors prouver que le montant supérieur reflète les frais réels — pour les PME, s&#x27;en tenir aux tarifs forfaitaires est la voie la plus sûre et la plus simple.</p><h2>Indexation trimestrielle vs annuelle (2025)</h2><p>La Belgique connaît deux méthodes d&#x27;indexation. Le tarif trimestriel (introduit en octobre 2022) suit de plus près les fluctuations des prix des carburants ; le tarif annuel change une fois par an, généralement le 1er juillet. Vous pouvez généralement choisir — sauf si une convention collective de travail (CCT) sectorielle ou le règlement de travail en dispose autrement — mais dès que vous optez pour le système annuel, vous devez le conserver pendant toute l&#x27;année d&#x27;indexation (du 1er juillet au 30 juin) ; vous ne pouvez revenir au système trimestriel qu&#x27;à partir du 1er juillet suivant.</p><ul><li>T1 2025 : 0,4290 €/km</li><li>T2 2025 : 0,4320 €/km</li><li>T3 2025 : 0,4309 €/km</li><li>Annuel (1er juillet 2025 – 30 juin 2026) : 0,4449 €/km</li></ul><h2>Travailleurs salariés vs indépendants</h2><p>Pour les travailleurs salariés, il n&#x27;y a pas de nombre maximal strict de kilomètres remboursables, mais au-delà de 24.000 km/an, le fisc ou l&#x27;ONSS peut demander une preuve des frais réels — l&#x27;indemnité ne devient pas automatiquement imposable, mais la charge de la preuve se déplace vers l&#x27;employeur.</p><p>Pour les indépendants, d&#x27;autres règles s&#x27;appliquent : le trajet domicile-travail entre le domicile et un lieu de travail fixe n&#x27;est généralement pas un frais professionnel, bien qu&#x27;une déduction forfaitaire de 0,15 €/km soit autorisée (max 490 €/an). Pour les déplacements professionnels, ils peuvent choisir entre le tarif kilométrique forfaitaire ou la déduction des frais réels (carburant, entretien, assurance, amortissement) ; la déductibilité dépend du véhicule et des émissions de CO₂ — une voiture électrique est déductible à 100 % en usage purement professionnel. Ils peuvent aussi refacturer le déplacement aux clients (pas de plafond, mais cela compte comme un revenu imposable).</p><h2>Une administration est essentielle</h2><p>Pour tout le monde, la règle vaut : pas d&#x27;administration solide, pas d&#x27;exonération fiscale. Un relevé détaillé des trajets mentionne la date, l&#x27;objet, les adresses de départ/arrivée et les kilomètres. Au-delà du tarif forfaitaire ou du seuil de 24.000 km, vous devez aussi prouver le coût réel par kilomètre (amortissement, carburant, entretien, assurance).</p><p>Attention à la différence entre déductible et remboursable : pour les travailleurs salariés, il s&#x27;agit de remboursements exonérés d&#x27;impôt par l&#x27;employeur ; pour les indépendants, de frais professionnels déduits du bénéfice imposable. Les 0,15 €/km pour le trajet domicile-travail constituent une déduction fiscale personnelle, et non un remboursement par l&#x27;employeur à ce tarif.</p><h2>Exemples concrets</h2><ul><li>Technicien (salarié), 150 km au tarif du T2 2025 : 150 × 0,4320 € = 64,80 €, exonéré d&#x27;impôt</li><li>Trajet domicile-travail (salarié) : une réduction d&#x27;impôt personnelle à 0,15 €/km, max 490 € pour l&#x27;exercice d&#x27;imposition 2025</li><li>Indépendant, 150 km au tarif annuel 0,4415 € (1er juillet 2024–30 juin 2025) : 150 × 0,4415 € = 66,23 €, déductible comme frais professionnel</li></ul><h2>Pourquoi l&#x27;enregistrement numérique des kilomètres est payant</h2><p>Les méthodes manuelles — fichiers Excel, papier, notes éparses — sont sources d&#x27;erreurs, difficiles à contrôler et sensibles aux kilomètres gonflés. L&#x27;enregistrement basé sur la géolocalisation (comme Done-it avec Trax-it) capte automatiquement les points de départ et d&#x27;arrivée, l&#x27;itinéraire réel et la distance exacte, prévient la manipulation, applique les tarifs officiels indexés, signale le seuil de 24.000 km par travailleur, et génère des rapports prêts pour l&#x27;audit — le tout dans le respect du RGPD (pas de suivi en dehors des heures de travail).</p>",
        "lead": "La gestion des kilomètres pour les travailleurs mobiles est un défi constant pour les PME et les indépendants belges. Voici comment fonctionne l'indemnité, les tarifs officiels pour 2025, et les principales différences entre travailleurs salariés et indépendants.",
        "read": "7 min",
        "slug": "kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor-kmo-s-en-zelfstandigen-gids-2025",
        "title": "Indemnité kilométrique en Belgique : règles et remboursements pour les PME et les indépendants (guide 2025)",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551038/blog/kilometervergoeding-in-belgie-regels-en-terugbetalingen-voor.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Le cadre légal</h2><p>Même en l&#x27;absence d&#x27;une loi GPS spécifique, les entreprises doivent respecter le RGPD, la loi belge du 30 juillet 2018 relative à la protection des données, l&#x27;article 8 de la Convention européenne des droits de l&#x27;homme, et l&#x27;article 22 de la Constitution belge. Le suivi GPS est un traitement de données à caractère personnel et doit donc respecter la licéité et la loyauté, la limitation des finalités, la minimisation des données, la transparence et la sécurité.</p><p>L&#x27;Autorité de protection des données belge (APD) a déjà fixé le test central dans son avis 12/2005 : licéité, finalité légitime, proportionnalité et transparence. La CNIL française et l&#x27;Autorité néerlandaise de protection des données donnent des orientations similaires — pas de surveillance en dehors des heures de travail, pas de suivi permanent, et un intérêt légitime et proportionné.</p><h2>Obligations en droit du travail</h2><ul><li>Les entreprises de 50 travailleurs ou plus doivent consulter le conseil d&#x27;entreprise</li><li>L&#x27;usage du GPS doit être repris dans le règlement de travail et communiqué à tout le personnel</li><li>Dans les PME sans organes formels, vous informez le comité de prévention ou les travailleurs directement</li><li>Une AIPD est obligatoire en cas d&#x27;usage à grande échelle ou structurel</li></ul><h2>Quatre principes fondamentaux</h2><p>Finalité légitime — une raison claire et légitime telle que la sécurité des travailleurs, la prévention du vol, l&#x27;optimisation des itinéraires ou la confirmation d&#x27;une prestation ; un suivi général « au cas où » ou pour prendre quelqu&#x27;un en faute n&#x27;est pas autorisé. Proportionnalité — pas de suivi 24/7, pas de suivi en dehors des heures de travail, le travailleur doit pouvoir désactiver le GPS pendant son temps privé, et une conservation limitée (p. ex. max deux mois selon la CNIL). Transparence — le personnel doit savoir ce qui est collecté, pourquoi, qui y a accès, combien de temps c&#x27;est conservé et quels sont ses droits, clairement consigné par écrit. Consentement — pas nécessaire lorsque le GPS est essentiel à l&#x27;activité (coursiers, ambulances, installations urgentes), mais requis lorsque ce n&#x27;est pas le cas, et il doit alors être libre, éclairé, spécifique et révocable.</p><h2>Par secteur</h2><p>Construction — GPS pour coordonner les livraisons et protéger les véhicules/machines, désactivé en dehors des heures de travail ; si CheckIn@Work est déjà utilisé, le GPS ne peut pas dupliquer le contrôle de présence. Nettoyage &amp; services facilitaires — parfait pour la planification des itinéraires par les superviseurs ; évitez le suivi constant, privilégiez les applications d&#x27;entrée/sortie. Services techniques (électriciens, plombiers, installateurs, coursiers) — aide aux temps de réponse, à l&#x27;acheminement et à la sécurité, mais pas de sanctions automatiques (p. ex. pour excès de vitesse) et un mode privé doit être disponible.</p><h2>Sanctions en cas d&#x27;abus</h2><ul><li>Amendes RGPD jusqu&#x27;à 20 millions d&#x27;euros ou 4 % du chiffre d&#x27;affaires annuel</li><li>Preuve annulée devant le tribunal du travail — des licenciements fondés sur un suivi non communiqué peuvent être annulés</li><li>Réclamations de travailleurs ou de syndicats, et inspections par le SPF Emploi</li><li>Un climat de travail dégradé et une atteinte à la réputation</li></ul><p>Il n&#x27;y a pas de différence légale entre la Flandre et la Wallonie — le RGPD et la loi de 2018 s&#x27;appliquent dans tout le pays — seulement une nuance culturelle (la Flandre s&#x27;appuie sur le règlement de travail et la concertation préalable ; la Wallonie se réfère à la doctrine de la CNIL et au droit à la déconnexion). Utilisé de manière proportionnée et transparente, le GPS est un instrument utile et légal : Done-it, par exemple, n&#x27;active le GPS que lors de l&#x27;entrée/sortie ou pendant un déplacement professionnel, dans le respect de la proportionnalité et du temps privé.</p>",
        "lead": "Le suivi GPS des travailleurs mobiles se répand de plus en plus — et soulève de réelles questions sur la vie privée au travail. La Belgique n'a pas de loi GPS spécifique, mais le RGPD et les règles connexes s'appliquent clairement.",
        "read": "6 min",
        "slug": "wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-werknemers-in-belgie",
        "title": "Usage légal et éthique du suivi GPS des travailleurs mobiles en Belgique",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551045/blog/wettelijk-en-ethisch-gebruik-van-gps-tracking-bij-mobiele-we.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Trois obligations clés à contrôler</h2><ul><li>Dimona — la déclaration électronique à l&#x27;ONSS pour tout type de travailleur (fixe, temporaire, étudiants, étrangers), avant le premier jour de travail ; en retard ou manquante, cela signifie des amendes et des problèmes avec la sécurité sociale</li><li>LIMOSA — si un sous-traitant amène des travailleurs étrangers ou des indépendants en Belgique, une déclaration LIMOSA-1 est requise avant le jour un, et vous devez la vérifier</li><li>Enregistrement de présence — CheckIn@Work pour les travaux de construction/immobiliers de ≥ 500.000 € hors TVA (quotidien, avant le début du travail), ou CIAO pour le nettoyage professionnel selon la prestation/le contrat</li></ul><h2>eC3.2A — la carte de contrôle numérique</h2><p>Pendant le chômage temporaire (par exemple en cas d&#x27;intempéries sur le chantier), les ouvriers de la construction doivent utiliser la carte de contrôle électronique eC3.2A. Depuis le 1er janvier 2025, elle est obligatoire sous forme numérique (le papier disparaît, à quelques exceptions près) ; avec l&#x27;application officielle eC3.2, les travailleurs peuvent la gérer et l&#x27;envoyer à l&#x27;organisme de paiement en fin de mois. Important : eC3.2A ne remplace ni Dimona, ni LIMOSA, ni CheckIn@Work/CIAO — c&#x27;est une obligation supplémentaire.</p><h2>Checklist pour travailler avec des sous-traitants</h2><ul><li>Avant le début — demandez la preuve Dimona pour toute personne qui entre sur le chantier ; exigez l&#x27;attestation LIMOSA-1 pour le personnel étranger avant le jour un ; convenez par écrit qui enregistre la présence et comment cela est contrôlé quotidiennement</li><li>Quotidiennement — personne ne commence sans une déclaration et un enregistrement valides ; en cas de remplacement, vous répétez le processus</li><li>Hebdomadairement — téléchargez et archivez les listes de présence (essentielles pour les contrôles) et vérifiez la validité des documents (assurance, attestations, autorisations)</li></ul><h2>Erreurs fréquentes</h2><ul><li>Des travailleurs sur le chantier sans Dimona/LIMOSA</li><li>Enregistrer dans le mauvais système (CheckIn@Work vs CIAO)</li><li>Faire aveuglément confiance aux sous-traitants sans contrôle ni preuve</li></ul><h2>Organisez-le efficacement</h2><p>Standardisez une seule checklist pour tous les sous-traitants, centralisez qui peut travailler, qui est présent et quels documents manquent, et enregistrez toutes les heures de début/fin sur le chantier avec un système fiable pour une traçabilité complète. Done-it se concentre sur l&#x27;essentiel quotidien — pointeuse numérique et aperçu de présence pour votre propre équipe et vos sous-traitants — avec un lien automatique vers CheckIn@Work et un accès rapide à eC3.2A. Attention : l&#x27;enregistrement CIAO officiel dans le nettoyage passe par la propre plateforme de l&#x27;État ; Done-it offre un aperçu opérationnel et centralise les pointages, mais ne remplace pas CIAO.</p>",
        "lead": "Travailler avec des sous-traitants est courant dans le nettoyage, la rénovation, la construction neuve et l'installation — mais la Belgique connaît une responsabilité solidaire : si votre sous-traitant enfreint les règles, vous pouvez, en tant qu'entrepreneur principal, être sanctionné avec lui. Une base pratique, sans jargon.",
        "read": "5 min",
        "slug": "onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgie-de-basis-om-boetes-te-vermijden-dimona-limosa-checkin-work-ciao-en-ec3-2a",
        "title": "Sous-traitants dans le nettoyage, la rénovation et la construction neuve : les bases pour éviter les amendes",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551040/blog/onderaannemers-in-schoonmaak-renovatie-en-nieuwbouw-in-belgi.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Qu&#x27;est-ce que CheckIn@Work ?</h2><p>CheckIn@Work est l&#x27;enregistrement de présence électronique belge pour les travaux immobiliers (construction, génie civil, rénovation) et certains autres secteurs. Il existe depuis 2014 et exige un enregistrement quotidien de toute personne effectuant de tels travaux dès que le projet dépasse un seuil — 500.000 € hors TVA pour les travaux entamés après le 1er mars 2016 (auparavant 800.000 €). Sur chaque chantier atteignant ce montant, chaque personne doit s&#x27;enregistrer quotidiennement avant le début.</p><p>Initialement destiné à la construction, le champ d&#x27;application a été élargi : il couvre aussi le secteur de la viande (toute personne dans les abattoirs ou les entreprises de transformation de viande sous le contrôle de l&#x27;AFSCA, sans seuil) et des activités telles que la livraison de béton prêt à l&#x27;emploi. Le nettoyage en est exclu depuis 2024 (il relève de CIAO), et l&#x27;agriculture, l&#x27;horticulture et la sylviculture sont expressément hors du champ d&#x27;application.</p><h2>Qui enregistre, et comment</h2><p>La responsabilité est partagée entre l&#x27;entité qui envoie quelqu&#x27;un sur le chantier (employeur, entrepreneur principal ou sous-traitant) et la personne qui effectue le travail. En pratique, l&#x27;employeur ou le donneur d&#x27;ordre enregistre le personnel, les sous-traitants et les indépendants via l&#x27;application sécurisée de l&#x27;ONSS ou via des méthodes automatisées (un badge sur le chantier, le scan du QR-code LIMOSA, une application mobile) ; les travailleurs et les sous-traitants indépendants peuvent s&#x27;enregistrer eux-mêmes si cela est convenu. L&#x27;enregistrement se fait quotidiennement, avant le début, et toutes les données sont centralisées dans la banque de données de l&#x27;ONSS et reliées à la déclaration de chantier (30bis) — chaque chantier soumis à l&#x27;obligation doit donc être déclaré au préalable pour obtenir un numéro de chantier.</p><h2>Qu&#x27;est-ce que CIAO ?</h2><p>CIAO (Check In And Out at Work) est le système plus récent destiné au secteur du nettoyage, en vigueur depuis le 1er septembre 2024. Il exige que chaque travailleur ou indépendant effectuant un nettoyage professionnel enregistre numériquement et en temps réel sur le chantier le début et la fin des activités — ainsi que les pauses. L&#x27;objectif reflète celui de CheckIn@Work : plus de transparence, moins de fraude sociale, des travailleurs plus en sécurité.</p><p>Il couvre l&#x27;entretien et le nettoyage de biens immobiliers pour des tiers — le nettoyage de l&#x27;intérieur/extérieur de bâtiments, bureaux, usines ou installations techniques, le nettoyage en profondeur après construction, le lavage de vitres, le balayage de rues, la désinfection de laboratoires ou de salles blanches. Exclus : le nettoyage domestique via titres-services, le nettoyage effectué en interne avec son propre personnel, et les travaux non liés au nettoyage (entretien technique, réparations, montage). Règle empirique : si le seul but de l&#x27;activité est de nettoyer un endroit (et non de le reconstruire ou de le réparer), elle relève de CIAO — dans les limites des seuils mentionnés ci-dessous.</p><h2>Seuils &amp; fonctionnement de l&#x27;enregistrement</h2><p>Contrairement au seuil fixe de 500.000 € de CheckIn@Work, CIAO applique les seuils 30bis, adaptés au nettoyage :</p><ul><li>≥ 30.000 € hors TVA sans sous-traitant</li><li>≥ 5.000 € avec un seul sous-traitant</li><li>0 € (pas de seuil) avec deux sous-traitants ou plus</li></ul><p>CIAO exige deux opérations par personne et par jour — un enregistrement IN au début du nettoyage et un OUT à la fin, plus chaque pause. Chaque travailleur s&#x27;enregistre lui-même en temps réel, sur le chantier, via l&#x27;application ou l&#x27;appareil ; l&#x27;employeur ou le chef d&#x27;équipe ne peut pas le faire à sa place et ne peut pas enregistrer à l&#x27;avance. Le service en ligne officiel est disponible depuis le 1er janvier 2024, avec des méthodes telles que l&#x27;application web/mobile de l&#x27;ONSS (eID, Itsme, QR), une pointeuse mobile sur le chantier, ou des applications certifiées de tiers.</p><h2>Erreurs fréquentes &amp; sanctions</h2><ul><li>Ne pas identifier les chantiers soumis à l&#x27;obligation (penser qu&#x27;un chantier est « trop petit ») ; scinder artificiellement un contrat peut constituer une infraction</li><li>Oublier la déclaration de chantier (30bis) — sans cette déclaration, les enregistrements ne peuvent pas être reliés à un chantier valide</li><li>Ne pas convenir qui enregistre qui lorsque plusieurs entreprises partagent un chantier</li><li>Enregistrement tardif ou imprécis — un seul enregistrement au début du projet au lieu de quotidien, un mauvais numéro de chantier, ou enregistrer le OUT au dépôt au lieu du chantier du client</li><li>Ne pas informer ou former le personnel</li><li>Supposer qu&#x27;un système de badge interne suffit — les données doivent passer par les canaux officiels de l&#x27;ONSS</li><li>Sous-estimer les amendes</li></ul><p>Les peines prévues par le Code pénal social vont de 300 à 3.000 € (niveau 1) ou de 600 à 6.000 € (niveau 3) par travailleur ; les cas graves peuvent entraîner la fermeture du chantier ou une interdiction de travailler. CIAO a connu une période transitoire sans sanction jusqu&#x27;au 30 avril 2025 ; dans la construction, il n&#x27;y a pas de tolérance, et les contrôles incluent systématiquement CheckIn@Work.</p><h2>Rester en conformité</h2><p>Identifiez vos obligations (secteur, valeur du projet, sous-traitance), introduisez la déclaration 30bis avant le début du travail, choisissez et configurez les outils officiels (ou une intégration certifiée qui transmet automatiquement, comme Done-it), formez votre personnel, consignez par écrit les responsabilités, contrôlez les enregistrements quotidiennement, et archivez les données. Avec un outil comme Done-it, les travailleurs pointent via une seule application mobile (GPS, QR, badge) et les données sont automatiquement transmises à CheckIn@Work ou CIAO — il ne les remplace pas, il s&#x27;y relie — tout en ajoutant des extras opérationnels (localisation, heures, kilomètres, partage de documents et de photos).</p>",
        "lead": "Les PME belges de la construction, de la rénovation, du nettoyage et des services techniques doivent satisfaire aux obligations relatives à l'enregistrement de présence. En 2025, deux systèmes coexistent — CheckIn@Work et CIAO — pour différents secteurs, avec des règles différentes. Le non-respect est lourdement sanctionné.",
        "read": "8 min",
        "slug": "checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-in-belgie",
        "title": "CheckIn@Work & CIAO : obligations, erreurs et conseils pour les PME belges",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551012/blog/checkin-work-ciao-verplichtingen-fouten-en-tips-voor-kmo-s-i.jpg"
      },
      {
        "tag": "E-invoicing",
        "html": "<h2>Ce qu&#x27;implique l&#x27;obligation</h2><p>À partir de la date de lancement, les entreprises ne peuvent plus utiliser de factures papier ou pdf pour le B2B ; elles doivent émettre et recevoir des factures électroniques structurées selon des normes communes. Les points essentiels :</p><ul><li>Lancement le 1er janvier 2026 — pour toutes les entreprises belges assujetties à la TVA, uniquement le B2B ; les factures aux consommateurs (B2C) sont pour l&#x27;instant hors du champ d&#x27;application</li><li>Format standard — la norme européenne EN 16931, en pratique Peppol BIS 3.0 (UBL XML) ; les pdf et le papier ne sont plus valides</li><li>Envoi via PEPPOL — un modèle décentralisé où chaque partie se connecte via un Access Point certifié ; une signature numérique n&#x27;est pas requise car PEPPOL garantit l&#x27;authenticité</li><li>Alternatives — l&#x27;expéditeur et le destinataire peuvent utiliser un autre canal (p. ex. un EDI privé) si la facture respecte toujours la norme EN 16931, mais chaque entreprise doit être techniquement capable d&#x27;utiliser PEPPOL</li><li>Exceptions — uniquement le B2B national ; les transactions étrangères n&#x27;utilisent la facturation électronique que de commun accord</li><li>Possible échelonnement selon la taille de l&#x27;entreprise (&gt;9 M€, 7–9 M€, &lt;7 M€) — aucun calendrier officiel confirmé pour l&#x27;instant</li><li>Arrondi de la TVA — à partir de 2026, la TVA sur les factures électroniques ne peut être arrondie que par taux, et non par ligne</li><li>Sanctions — 1.500 € / 3.000 € / 5.000 € pour la première/deuxième/troisième infraction, plus une possible perte du droit à la déduction de la TVA</li></ul><h2>Qu&#x27;est-ce que PEPPOL et comment ça fonctionne</h2><p>PEPPOL (Pan-European Public Procurement On-Line) est une norme et un réseau international permettant d&#x27;envoyer des documents électroniques de manière sécurisée et interopérable. Les entreprises n&#x27;envoient pas leurs factures directement par e-mail : chacune se connecte à un Access Point certifié qui achemine la facture sur le réseau vers l&#x27;Access Point du destinataire, qui la dépose dans son logiciel — avec des protocoles et des formats communs, de sorte qu&#x27;aucune connexion point à point sur mesure n&#x27;est nécessaire. De nombreux ERP et outils cloud belges (Odoo, SAP, etc.) le prennent déjà en charge.</p><h2>Avantages</h2><ul><li>Un réseau ouvert — chaque entreprise connectée peut facturer toute autre, quels que soient les systèmes utilisés</li><li>Automatisation complète — les factures fournisseurs arrivent directement dans votre logiciel et les factures de vente partent sans e-mail</li><li>Une meilleure sécurité — seuls les participants autorisés sont sur le réseau</li><li>Un traitement plus rapide avec moins d&#x27;erreurs</li><li>Pérenne — la Belgique prévoit d&#x27;utiliser PEPPOL pour un e-Reporting quasi en temps réel aux administrations fiscales à partir de 2028</li></ul><h2>Comment vous préparer</h2><ul><li>Informez et formez — déterminez quels clients/fournisseurs relèvent du B2B national, et formez votre administration aux nouveaux formats (UBL XML) et outils</li><li>Évaluez votre logiciel actuel — demandez à votre fournisseur la prise en charge de PEPPOL et d&#x27;EN 16931 ; des mises à jour sont attendues en 2025</li><li>Choisissez un logiciel compatible — recherchez des solutions « Peppol-ready » ou des access points agréés ; un outil intégré (projets, heures, frais, documents au même endroit) maintient les données de facture structurées</li><li>Testez avant 2026 — échangez volontairement des factures électroniques avec des partenaires de confiance pour détecter les problèmes tôt</li><li>Consultez des spécialistes ou votre partenaire logiciel pour les questions d&#x27;intégration</li></ul><h2>Le rôle des outils de gestion</h2><p>Pour 2026, il ne s&#x27;agit pas seulement d&#x27;émettre des factures au format PEPPOL, mais de bien organiser les données sous-jacentes — heures, déplacements et tâches par client. Un outil qui centralise tout cela (comme Done-it) rend les factures électroniques plus précises et la transition bien plus fluide. Les entreprises qui se préparent tôt font de l&#x27;obligation une opportunité de modernisation : une facturation plus rapide, moins d&#x27;erreurs et un back-office plus productif.</p>",
        "lead": "La Belgique a approuvé une loi qui rend la facturation électronique B2B obligatoire à partir du 1er janvier 2026 : toutes les transactions commerciales entre entreprises belges assujetties à la TVA doivent utiliser des factures électroniques structurées, avec PEPPOL comme canal d'échange — conformément à VAT in the Digital Age (ViDA) de l'UE.",
        "read": "6 min",
        "slug": "e-facturatie-in-belgie-peppol-verplicht-voor-alle-bedrijven-in-2026",
        "title": "Facturation électronique en Belgique : PEPPOL obligatoire pour toutes les entreprises en 2026",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551014/blog/e-facturatie-in-belgie-peppol-verplicht-voor-alle-bedrijven-.jpg"
      },
      {
        "tag": "Mileage",
        "html": "<h2>Législation &amp; références</h2><ul><li>Indemnité kilométrique officielle — à partir du 1er juillet 2025, le maximum s&#x27;élève à 0,4449 €/km (tarif annuel indexé jusqu&#x27;au 30 juin 2026), avec des montants trimestriels autour de 0,4309 €/km ; exonérée d&#x27;impôt et de cotisations dans la limite du maximum, et uniquement pour le véhicule personnel d&#x27;un travailleur (avec une voiture de société, l&#x27;employeur supporte directement le coût)</li><li>Indemnité vélo (CCT 164) — obligatoire depuis le 1er mai 2023 ; 0,29 €/km en 2025, exonérée d&#x27;impôt jusqu&#x27;à 0,36 €/km avec un plafond annuel de 3.610 € (une CCT sectorielle inférieure prime)</li><li>Facturation électronique obligatoire (PEPPOL) à partir du 1er janvier 2026 — un pdf par e-mail ne suffit plus, enregistrez donc les déplacements numériquement pour alimenter des factures structurées</li></ul><h2>Calculer les kilomètres de déplacement</h2><p>Véhicule personnel vs voiture de société : les déplacements avec le véhicule personnel donnent droit à l&#x27;indemnité officielle ; une voiture de société n&#x27;a pas d&#x27;indemnité distincte, l&#x27;employeur supportant le carburant et l&#x27;entretien — mais enregistrez les kilomètres dans tous les cas, pour la note de frais ou votre propre calcul de coût de revient. N&#x27;oubliez pas le parking et le péage.</p><p>Autres modes de transport : certains collaborateurs se déplacent à vélo, en train, en tram, en bus ou à pied — appliquez une politique cohérente. Les transports publics peuvent être remboursés au prix réel du ticket (train/tram/bus sont à 0 % de TVA en Belgique) ; un seul déplacement peut combiner plusieurs modes de transport, votre système doit donc permettre d&#x27;enregistrer différents types de transport par trajet.</p><p>Le temps de déplacement peut être du temps de travail : selon l&#x27;arrêt européen Tyco (2015), pour les travailleurs sans lieu de travail fixe, le déplacement du domicile vers le premier client et du dernier client vers le domicile compte comme temps de travail. Cela ne signifie pas que vous devez tout facturer, mais le personnel doit être correctement rémunéré et la planification doit en tenir compte — décidez à l&#x27;avance si le temps de déplacement est facturé.</p><h2>Déterminer les tarifs &amp; convenir avec les clients</h2><p>L&#x27;indemnité officielle régit surtout le remboursement interne ; commercialement, vous êtes libre de fixer votre propre tarif de déplacement (certains refacturent le tarif forfaitaire, d&#x27;autres un tarif plus élevé ou un forfait de déplacement fixe). Il n&#x27;y a pas de maximum légal, mais cela compte comme un revenu imposable, basez-le donc sur quelque chose de raisonnable afin à la fois de ne pas effrayer les clients et de couvrir vos coûts.</p><p>Soyez transparent : indiquez à l&#x27;avance dans le devis si le déplacement est inclus ou facturé séparément, et faites-le apparaître sur la facture comme une ligne distincte — p. ex. « Déplacement – visite sur place à [lieu] – 50 km ». Pour la TVA, les frais refacturés suivent généralement le taux de la prestation principale (donc 21 % si la prestation est à 21 %), avec une exception possible de 0 % pour les purs tickets de transports publics ; beaucoup d&#x27;entreprises appliquent simplement le taux standard par souci de simplicité. Distinguez cela de votre propre déductibilité, où les frais de carburant et de voiture ne sont que partiellement déductibles selon les coefficients de CO₂.</p><h2>Reporter les heures et les kilomètres sur la facture</h2><p>Tenir les kilomètres et les heures à la main est lent et source d&#x27;erreurs. Intégrer l&#x27;enregistrement à votre facturation économise de l&#x27;administration et améliore la précision — et avec la facturation électronique PEPPOL à partir de 2026, l&#x27;intégration numérique est une nécessité, pas un luxe. Enregistrez les trajets et les heures d&#x27;une journée, reliez chacun au bon client ou au bon projet, et les données alimentent directement une facture par client — fini de chercher les distances ou de retaper les heures, et une facture structurée (Peppol BIS) en un clic, correcte et complète.</p><h2>Comment Done-it aide</h2><p>Done-it enregistre automatiquement les trajets via la géolocalisation (Trax-it) — points de départ et d&#x27;arrivée, itinéraire réel et distance exacte — ce qui exclut la saisie manuelle et les kilomètres gonflés. Vous définissez des types de transport (voiture de leasing, véhicule personnel, covoiturage conducteur/passager, vélo, transports publics) avec leurs propres règles et tarifs, visualisez les itinéraires sur une carte reliée au client/projet/tâche, et combinez le tout avec l&#x27;enregistrement du temps pour une vue complète. Il génère automatiquement des rapports (date, adresses, kilomètres) « selon des normes sérieuses », applique les tarifs officiels indexés, signale le seuil de 24.000 km et respecte le RGPD (pas de suivi en dehors des heures de travail) — prêts à exporter vers la comptabilité ou la facturation électronique.</p>",
        "lead": "Pour beaucoup de PME belges du nettoyage, des services techniques, de l'entretien et de la construction, les déplacements chez les clients font partie du quotidien. Des frais de déplacement transparents préservent la confiance du client et évitent les surprises sur la facture — et vous gardent en règle sur le plan juridique.",
        "read": "7 min",
        "slug": "facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-correct-registreren-en-aanrekenen",
        "title": "Facturer les déplacements chez les clients : comment enregistrer et facturer correctement les kilomètres",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551016/blog/facturatie-van-verplaatsingen-naar-klanten-hoe-kilometers-co.jpg"
      }
    ],
    "es": [
      {
        "tag": "Mileage",
        "html": "<h2>Por qué fallan los registros manuales de kilómetros</h2><p>Cuando los trabajadores anotan los kilómetros al final de la semana, reconstruyen las rutas de memoria. ¿El resultado? Cifras redondeadas, trayectos olvidados y disputas a fin de mes. La nómina se infla o se reembolsa de menos, y la empresa no tiene un registro defendible para una auditoría.</p><h2>Cómo es la captura automática</h2><p>Un sistema basado en GPS registra el punto de salida, el punto de llegada, la ruta real y la distancia exacta de cada trayecto, en segundo plano, mientras el trabajador conduce. Sin introducción manual de datos. La información lleva marca de tiempo, se vincula al cliente o proyecto correcto y queda disponible de inmediato en la oficina.</p><p>El trabajador selecciona el tipo de transporte al inicio del trayecto (coche propio, vehículo de empresa, coche compartido, bici). El sistema aplica automáticamente la tarifa de reembolso correcta y señala todo lo que supere el umbral que exige justificar los costes reales.</p><h2>Qué ahorra</h2><ul><li>Administración: se acabó perseguir cuadernos de ruta en papel o corregir errores de hojas de cálculo a fin de mes</li><li>Disputas: los datos confirmados por GPS son objetivos; clientes y trabajadores ven las mismas cifras</li><li>Coste: se capturan automáticamente los kilómetros que nunca habrían llegado a una nota de gastos</li><li>Cumplimiento: un registro de auditoría completo por trabajador, por trayecto y por proyecto, listo para una inspección</li></ul><h2>En qué fijarte en una herramienta de kilometraje</h2><ul><li>Captura automática por GPS, sin introducción manual de datos para los trabajadores</li><li>Varios tipos de transporte con tarifas configurables</li><li>Vinculación de trayectos por proyecto o por cliente</li><li>A prueba de RGPD: GPS activo solo durante la jornada laboral y datos alojados en la UE</li><li>Informes listos para exportar que alimentan la nómina o la facturación</li></ul><h2>Cómo lo resuelve Done-it</h2><p>Done-it captura los trayectos automáticamente con Trax-it: el GPS registra la ruta, el trabajador selecciona el tipo de transporte y el sistema aplica la tarifa correcta. Todo se vincula al proyecto o cliente adecuado. Los informes se exportan directamente a la nómina o a la facturación electrónica, sin transcripción manual.</p>",
        "lead": "Cuando tu equipo se desplaza entre obras todo el día, los kilómetros se acumulan rápido, y los errores también. Te explicamos cómo funciona la captura automática de kilómetros, qué ahorra y en qué fijarte al elegir una solución.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Cómo registrar los kilómetros de los equipos de campo, sin papeleo",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>La regla básica: proporcionalidad</h2><p>El seguimiento por GPS de los empleados es legal según el RGPD, pero solo cuando es proporcional a una finalidad empresarial legítima. Coordinar entregas, confirmar visitas de servicio, garantizar la seguridad del trabajador: todo válido. Rastrear cada movimiento de alguien «por si acaso»: no es válido.</p><h2>Cuatro cosas que debes hacer</h2><ul><li>Define la finalidad: optimización de rutas, seguridad, confirmación de servicio, y déjala por escrito</li><li>Limita el seguimiento únicamente a la jornada laboral: los trabajadores deben poder apagar el GPS en su tiempo personal</li><li>Informa a tu equipo con claridad: qué se recopila, por qué, quién puede verlo y cuánto tiempo se conserva</li><li>Documéntalo: incluye el uso del GPS en tu reglamento de trabajo y realiza una EIPD si el seguimiento es a gran escala o estructural</li></ul><h2>Lo que no debes hacer</h2><ul><li>Rastrear las 24 horas: el seguimiento fuera de la jornada laboral vulnera la proporcionalidad del RGPD</li><li>Usar los datos de GPS para sanciones automáticas (por ejemplo, alertas de exceso de velocidad que activan medidas disciplinarias) sin haberlo comunicado antes</li><li>Conservar los datos de localización más tiempo del necesario; la CNIL recomienda un máximo de dos meses</li><li>Omitir la información a los trabajadores: un seguimiento no comunicado puede invalidar la prueba en cualquier disputa posterior</li></ul><h2>Notas específicas por sector</h2><p>En servicios de campo y logística, el GPS se da por hecho y se justifica con facilidad. En limpieza y mantenimiento, la planificación de rutas por parte de los supervisores está bien, pero un seguimiento constante por trabajador es más difícil de justificar. En construcción, el GPS para proteger vehículos y maquinaria es habitual; no debería duplicar ningún sistema de registro de presencia ya en uso.</p><h2>Cómo lo resuelve Done-it</h2><p>Done-it activa el GPS solo en el check-in, el check-out y durante los desplazamientos activos por trabajo. No hay seguimiento 24/7, ni control durante las pausas o el tiempo personal. Los datos se alojan en la UE con cifrado y un Delegado de Protección de Datos dedicado, listos para cualquier auditoría de privacidad.</p>",
        "lead": "El seguimiento por GPS de los trabajadores móviles plantea cuestiones reales de privacidad. Aquí tienes la guía clara sobre lo que está permitido legalmente, lo que no, y cómo implementarlo de una forma que tu equipo acepte.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Seguimiento GPS de trabajadores de campo: qué está permitido y cómo hacerlo bien",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>El problema de las hojas de horas manuales</h2><p>Los trabajadores de campo anotan las horas de memoria, a menudo varios días después. Redondear es la norma. Las horas acaban en el proyecto o cliente equivocado. La nómina es una aproximación. Y cuando un cliente reclama una factura, o aparece un inspector, no hay un registro objetivo al que recurrir.</p><h2>Qué significa realmente el registro horario digital</h2><p>El registro digital significa que el trabajador toca para fichar al llegar a la obra, el sistema le pone marca de tiempo con confirmación por GPS, y las horas se vinculan automáticamente al proyecto o cliente correcto. A fin de mes, la exportación para la nómina se genera con un clic: sin perseguir a nadie, sin conciliar, sin errores.</p><p>La oficina obtiene una vista en tiempo real: quién está en qué obra, cuántas horas se han registrado en cada proyecto y si algún trabajo supera el presupuesto. Esa visibilidad cambia tu forma de gestionar: los problemas afloran en tiempo real en lugar de a fin de mes.</p><h2>En qué fijarte en una herramienta de control horario para equipos de campo</h2><ul><li>Check-in y check-out confirmados por GPS, sin terminal ni lector de tarjetas</li><li>Vinculación de horas por proyecto o por cliente, no solo un total diario</li><li>Vista en tiempo real de las horas restantes por proyecto para ver los sobrecostes antes de que ocurran</li><li>Control de horas extra con pago flexible o conversión en tiempo libre</li><li>Gestión de vacaciones y ausencias, incluida la carga digital de bajas médicas</li><li>Exportación de nómina con un clic compatible con tu gestoría o sistema de RR. HH.</li></ul><h2>Objeciones habituales, resueltas</h2><p>Los trabajadores no la usarán. En la práctica, un fichaje de un solo toque lleva menos tiempo que rellenar una hoja de horas en papel a final de semana. La adopción casi siempre es más rápida de lo esperado. Es demasiado cara. Done-it parte de 19 €/mes de base, menos que el coste de un solo error de nómina. Somos demasiado pequeños. No hay tamaño mínimo de equipo.</p><h2>La dimensión del cumplimiento</h2><p>La mayoría de los países de la UE están endureciendo los requisitos en torno al registro de la jornada laboral, impulsados por la sentencia de 2019 del Tribunal de Justicia de la Unión Europea según la cual los empleadores deben disponer de un sistema objetivo y fiable para medir el tiempo de trabajo diario. Una herramienta digital que produce un registro inalterable por trabajador, por día y por proyecto cumple con cualquier aplicación local de ese estándar.</p>",
        "lead": "Cuando tu equipo trabaja en varias obras, las hojas de horas manuales no funcionan. Te explicamos cómo el registro horario digital cambia la realidad del día a día, para trabajadores, responsables y nómina.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Control horario para equipos de campo: una guía completa para pymes",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Adónde se va el tiempo</h2><p>Para una empresa con 10 a 20 trabajadores de campo, preparar la nómina suele llevar de uno a dos días al mes. Alguien recopila las hojas de horas (en papel o por WhatsApp), las introduce en una hoja de cálculo, las concilia con los registros de proyecto, corrige los inevitables errores y genera una exportación para la gestoría o el proveedor de nóminas. Cada paso es manual. Cada paso tiene puntos de fallo.</p><h2>Los cuellos de botella</h2><ul><li>Las hojas de horas llegan tarde o incompletas: los trabajadores están en la carretera, no en un escritorio</li><li>Las horas se registran en el proyecto o cliente equivocado, lo que exige corrección manual</li><li>Las horas extra y los registros de ausencias viven en un sistema aparte (o en una nota adhesiva)</li><li>La exportación de nómina tiene un formato distinto del que espera la gestoría</li></ul><h2>Qué cambia un sistema digital</h2><p>Cuando los trabajadores fichan la entrada y la salida por GPS desde su móvil, las horas se registran en el momento en que ocurren, vinculadas al proyecto correcto, con horas exactas, sin redondeos. A fin de mes, la exportación se genera con un clic. Las cifras ya son correctas. No hay nada que conciliar.</p><p>Las horas extra se registran a medida que ocurren. Las ausencias las presenta el trabajador de forma digital. Los saldos de vacaciones se actualizan automáticamente. El trabajo del responsable pasa a ser revisar un panel, no construirlo a partir de datos en bruto.</p><h2>Qué cuentan los equipos</h2><ul><li>La preparación de la nómina baja de dos días a menos de una hora</li><li>Los errores de nómina caen drásticamente: sin introducción manual no hay errores de transcripción</li><li>El análisis de costes posterior por proyecto se vuelve posible: horas reales por trabajo, no aproximaciones</li><li>A los trabajadores de hecho les gusta más: no hay hoja de horas que rellenar a final de semana</li></ul><h2>Cómo empezar</h2><p>Done-it lleva a la mayoría de los equipos del registro a las primeras horas controladas en la misma tarde. Sin hardware, sin proyecto de TI. Los trabajadores descargan la app y fichan. Las horas aparecen en el panel. La exportación de nómina está lista a fin de mes. La prueba es de 30 días gratis, sin tarjeta.</p>",
        "lead": "Para las empresas con equipos móviles, preparar la nómina es una pesadilla mensual: perseguir hojas de horas, corregir errores, conciliar proyectos. Te contamos cómo lo resolvieron los equipos que lo lograron.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Cómo las empresas de servicios de campo reducen la administración de nóminas en un 80 %",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "de": [
      {
        "tag": "Mileage",
        "html": "<h2>Warum manuelle Kilometerprotokolle scheitern</h2><p>Wenn Mitarbeitende die Kilometer am Ende der Woche eintragen, rekonstruieren sie die Routen aus dem Gedächtnis. Das Ergebnis: gerundete Zahlen, fehlende Fahrten und Streitigkeiten zum Monatsende. Die Lohnabrechnung ist überhöht oder zu niedrig erstattet, und das Unternehmen hat keinen belastbaren Prüfpfad.</p><h2>So sieht automatische Erfassung aus</h2><p>Ein GPS-basiertes System erfasst Abfahrtspunkt, Ankunftspunkt, tatsächliche Route und exakte Distanz für jede Fahrt — im Hintergrund, während der Mitarbeitende fährt. Keine manuelle Eingabe. Die Daten sind mit einem Zeitstempel versehen, dem richtigen Kunden oder Projekt zugeordnet und sofort im Back Office verfügbar.</p><p>Der Mitarbeitende wählt zu Beginn der Fahrt die Transportart aus (eigenes Auto, Firmenfahrzeug, Fahrgemeinschaft, Fahrrad). Das System wendet den korrekten Erstattungssatz automatisch an und kennzeichnet alles oberhalb der Schwelle, das einen Nachweis der tatsächlichen Kosten erfordert.</p><h2>Was es spart</h2><ul><li>Verwaltung: kein Hinterherjagen nach Papier-Fahrtenbüchern und keine Korrektur von Tabellenfehlern zum Monatsende</li><li>Streitigkeiten: GPS-bestätigte Daten sind objektiv — Kunden und Mitarbeitende sehen dieselben Zahlen</li><li>Kosten: Kilometer, die nie auf eine Spesenabrechnung gekommen wären, werden automatisch erfasst</li><li>Compliance: ein vollständiger Prüfpfad pro Mitarbeitendem, pro Fahrt, pro Projekt — bereit zur Kontrolle</li></ul><h2>Worauf Sie bei einem Kilometer-Tool achten sollten</h2><ul><li>Automatische Erfassung per GPS — keine manuelle Eingabe für Mitarbeitende</li><li>Mehrere Transportarten mit konfigurierbaren Sätzen</li><li>Verknüpfung von Fahrten pro Projekt oder pro Kunde</li><li>DSGVO-konform: GPS nur während der Arbeitszeit aktiv, Daten in der EU gehostet</li><li>Exportfertige Berichte, die in die Lohnabrechnung oder Rechnungsstellung einfließen</li></ul><h2>Wie Done-it das handhabt</h2><p>Done-it erfasst Fahrten automatisch über Trax-it — GPS protokolliert die Route, der Mitarbeitende wählt die Transportart, und das System wendet den richtigen Satz an. Alles wird mit dem richtigen Projekt oder Kunden verknüpft. Berichte werden direkt in die Lohnabrechnung oder E-Rechnung exportiert, ohne manuelle Übertragung.</p>",
        "lead": "Wenn Ihr Team den ganzen Tag zwischen Standorten unterwegs ist, summieren sich die Kilometer schnell — und ebenso die Fehler. So funktioniert die automatische Kilometererfassung, was sie spart und worauf Sie bei einer Lösung achten sollten.",
        "read": "6 Min.",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "So erfassen Sie Kilometer für Außenteams — ohne den Papierkram",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Die Grundregel: Verhältnismäßigkeit</h2><p>Die GPS-Ortung von Mitarbeitern ist nach der DSGVO zulässig — aber nur, wenn sie zu einem legitimen geschäftlichen Zweck verhältnismäßig ist. Lieferungen koordinieren, Serviceeinsätze bestätigen, die Sicherheit der Mitarbeitenden gewährleisten: alles gültig. Jeden Schritt einer Person „nur für den Fall“ verfolgen: nicht gültig.</p><h2>Vier Dinge, die Sie tun müssen</h2><ul><li>Definieren Sie den Zweck: Routenoptimierung, Sicherheit, Servicebestätigung — und halten Sie ihn schriftlich fest</li><li>Beschränken Sie die Ortung ausschließlich auf die Arbeitszeit: Mitarbeitende müssen GPS in der Freizeit abschalten können</li><li>Informieren Sie Ihr Team klar: was erfasst wird, warum, wer es sehen kann, wie lange es aufbewahrt wird</li><li>Dokumentieren Sie es: nehmen Sie die GPS-Nutzung in Ihre Arbeitsordnung auf und führen Sie eine Datenschutz-Folgenabschätzung durch, wenn die Ortung großflächig oder strukturell ist</li></ul><h2>Was Sie nicht tun dürfen</h2><ul><li>Rund um die Uhr orten — eine Ortung außerhalb der Arbeitszeit verletzt die Verhältnismäßigkeit der DSGVO</li><li>GPS-Daten für automatische Sanktionen nutzen (z. B. Geschwindigkeitswarnungen, die Disziplinarmaßnahmen auslösen) ohne vorherige Offenlegung</li><li>Standortdaten länger als nötig speichern — die CNIL empfiehlt maximal zwei Monate</li><li>Das Informieren der Mitarbeitenden auslassen — eine nicht offengelegte Ortung kann Beweise in jeder späteren Streitigkeit unwirksam machen</li></ul><h2>Branchenspezifische Hinweise</h2><p>Für Außendienst und Logistik wird GPS erwartet und ist leicht zu rechtfertigen. Für Reinigung und Wartung ist die Routenplanung durch Vorgesetzte in Ordnung — eine ständige Ortung pro Mitarbeitendem ist schwerer zu rechtfertigen. Im Baugewerbe ist GPS zum Schutz von Fahrzeugen und Maschinen üblich; es sollte kein bereits genutztes Anwesenheitserfassungssystem duplizieren.</p><h2>Wie Done-it das handhabt</h2><p>Done-it aktiviert GPS nur beim Check-in, Check-out und während aktiver dienstlicher Fahrten. Es gibt keine Ortung rund um die Uhr, keine Überwachung während Pausen oder in der Freizeit. Die Daten werden in der EU gehostet, mit Verschlüsselung und einem eigenen Datenschutzbeauftragten — bereit für jede Datenschutzprüfung.</p>",
        "lead": "Die GPS-Ortung mobiler Mitarbeiter wirft echte Datenschutzfragen auf. Hier ist der unkomplizierte Leitfaden dazu, was rechtlich erlaubt ist, was nicht und wie Sie es so umsetzen, dass Ihr Team es akzeptiert.",
        "read": "5 Min.",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS-Ortung von Außendienstmitarbeitern: was erlaubt ist und wie man es richtig macht",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Das Problem mit manuellen Stundenzetteln</h2><p>Außendienstmitarbeiter tragen die Stunden aus dem Gedächtnis ein, oft Tage später. Runden ist die Norm. Stunden landen auf dem falschen Projekt oder Kunden. Die Lohnabrechnung ist eine Annäherung. Und wenn ein Kunde eine Rechnung anficht — oder ein Kontrolleur auftaucht — gibt es keine objektive Aufzeichnung, auf die man zurückgreifen kann.</p><h2>Was digitale Zeiterfassung tatsächlich bedeutet</h2><p>Digitale Erfassung bedeutet, dass ein Mitarbeitender vor Ort zum Einstempeln tippt, das System dies mit GPS-Bestätigung mit einem Zeitstempel versieht und die Stunden automatisch mit dem richtigen Projekt oder Kunden verknüpft werden. Zum Monatsende wird der Lohnexport mit einem Klick erstellt — kein Hinterherjagen, kein Abgleichen, keine Fehler.</p><p>Das Back Office erhält eine Live-Ansicht: wer auf welchem Standort ist, wie viele Stunden gegen jedes Projekt erfasst wurden und ob ein Auftrag das Budget überschreitet. Diese Transparenz verändert, wie Sie führen — Probleme tauchen in Echtzeit auf statt erst zum Monatsende.</p><h2>Worauf Sie bei einem Zeiterfassungs-Tool für Außenteams achten sollten</h2><ul><li>GPS-bestätigter Check-in und Check-out — kein Terminal, kein Kartenleser</li><li>Verknüpfung der Stunden pro Projekt oder pro Kunde, nicht nur eine Tagessumme</li><li>Live-Ansicht der verbleibenden Stunden pro Projekt, sodass Budgetüberschreitungen sichtbar sind, bevor sie eintreten</li><li>Überstundenerfassung mit flexibler Auszahlung oder Umwandlung in Freizeit</li><li>Urlaubs- und Abwesenheitsverwaltung, einschließlich digitalem Upload von Krankmeldungen</li><li>Lohnexport mit einem Klick, kompatibel mit Ihrem Sozialsekretariat oder HR-System</li></ul><h2>Häufige Einwände — beantwortet</h2><p>Mitarbeitende werden es nicht nutzen. In der Praxis dauert ein Check-in mit einem Tippen weniger lang als das Ausfüllen eines Papier-Stundenzettels am Wochenende. Die Akzeptanz ist fast immer schneller als erwartet. Es ist zu teuer. Done-it beginnt bei einer Grundgebühr von 19 €/Monat — weniger als die Kosten eines einzigen Lohnabrechnungsfehlers. Wir sind zu klein. Es gibt keine Mindestteamgröße.</p><h2>Die Compliance-Dimension</h2><p>Die meisten EU-Länder verschärfen die Anforderungen an die Arbeitszeiterfassung — angetrieben durch das Urteil des Europäischen Gerichtshofs von 2019, dass Arbeitgeber über ein objektives, zuverlässiges System zur Messung der täglichen Arbeitszeit verfügen müssen. Ein digitales Werkzeug, das eine manipulationssichere Aufzeichnung pro Mitarbeitendem, pro Tag, pro Projekt erstellt, erfüllt jede lokale Umsetzung dieses Standards.</p>",
        "lead": "Wenn Ihr Team über mehrere Standorte hinweg arbeitet, funktionieren manuelle Stundenzettel nicht. So verändert die digitale Zeiterfassung die tägliche Realität — für Mitarbeitende, Führungskräfte und die Lohnabrechnung.",
        "read": "7 Min.",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Zeiterfassung für Außenteams: ein vollständiger Leitfaden für KMU",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Wohin die Zeit geht</h2><p>Für ein Unternehmen mit 10–20 Außendienstmitarbeitern dauert die Lohnvorbereitung typischerweise ein bis zwei Tage pro Monat. Jemand sammelt die Stundenzettel ein (Papier oder WhatsApp), gibt sie in eine Tabelle ein, gleicht sie mit den Projektaufzeichnungen ab, korrigiert die unvermeidlichen Fehler und erstellt einen Export für das Sozialsekretariat oder den Lohnabrechnungsanbieter. Jeder Schritt ist manuell. Jeder Schritt hat Fehlerquellen.</p><h2>Die Engpässe</h2><ul><li>Stundenzettel treffen verspätet oder unvollständig ein — die Mitarbeitenden sind unterwegs, nicht am Schreibtisch</li><li>Stunden werden auf dem falschen Projekt oder Kunden erfasst und müssen manuell korrigiert werden</li><li>Überstunden- und Abwesenheitsaufzeichnungen befinden sich in einem separaten System (oder auf einem Notizzettel)</li><li>Der Lohnexport ist anders formatiert, als das Sekretariat es erwartet</li></ul><h2>Was ein digitales System verändert</h2><p>Wenn Mitarbeitende per GPS auf ihrem Telefon ein- und auschecken, werden die Stunden in dem Moment erfasst, in dem sie anfallen — verknüpft mit dem richtigen Projekt, mit exakten Zeiten, ohne Runden. Zum Monatsende wird der Export mit einem Klick erstellt. Die Zahlen sind bereits korrekt. Es gibt nichts abzugleichen.</p><p>Überstunden werden erfasst, während sie anfallen. Abwesenheiten werden vom Mitarbeitenden digital eingereicht. Die Urlaubssalden aktualisieren sich automatisch. Die Aufgabe der Führungskraft besteht darin, ein Dashboard zu prüfen, nicht eines aus Rohdaten zu erstellen.</p><h2>Was Teams berichten</h2><ul><li>Lohnvorbereitung von zwei Tagen auf unter eine Stunde reduziert</li><li>Lohnabrechnungsfehler stark gesunken — keine manuelle Eingabe bedeutet keine Übertragungsfehler</li><li>Projektnachkalkulation wird möglich — echte Stunden pro Auftrag, keine Annäherungen</li><li>Mitarbeitende bevorzugen es sogar — kein Stundenzettel, der am Wochenende auszufüllen ist</li></ul><h2>Erste Schritte</h2><p>Done-it bringt die meisten Teams noch am selben Nachmittag von der Anmeldung zu den ersten erfassten Stunden. Keine Hardware, kein IT-Projekt. Mitarbeitende laden die App herunter und checken ein. Die Stunden erscheinen im Dashboard. Der Lohnexport ist zum Monatsende bereit. Die Testphase ist 30 Tage kostenlos — keine Karte erforderlich.</p>",
        "lead": "Für Unternehmen mit mobilen Teams ist die Lohnvorbereitung ein monatlicher Albtraum — Stundenzettel hinterherjagen, Fehler korrigieren, Projekte abgleichen. So haben es die Teams gelöst, die es geschafft haben.",
        "read": "4 Min.",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Wie Außendienstunternehmen den Lohnverwaltungsaufwand um 80 % senken",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "it": [
      {
        "tag": "Mileage",
        "html": "<h2>Perché i registri chilometrici manuali falliscono</h2><p>Quando i lavoratori compilano i chilometri a fine settimana, stanno ricostruendo i percorsi a memoria. Il risultato: numeri arrotondati, spostamenti mancanti e contestazioni a fine mese. Le buste paga sono gonfiate o sotto-rimborsate, e l&#x27;azienda non ha una traccia di audit difendibile.</p><h2>Com&#x27;è la cattura automatica</h2><p>Un sistema basato su GPS registra punto di partenza, punto di arrivo, percorso effettivo e distanza esatta per ogni spostamento — in background, mentre il lavoratore guida. Nessun inserimento manuale. I dati hanno una marca temporale, sono collegati al cliente o progetto giusto e immediatamente disponibili nel back office.</p><p>Il lavoratore seleziona il tipo di trasporto all&#x27;inizio dello spostamento (auto propria, veicolo aziendale, car pooling, bici). Il sistema applica automaticamente la tariffa di rimborso corretta e segnala tutto ciò che supera la soglia che richiede la prova dei costi reali.</p><h2>Cosa fa risparmiare</h2><ul><li>Lavoro amministrativo: niente rincorsa dei registri cartacei o correzione degli errori dei fogli di calcolo a fine mese</li><li>Contestazioni: i dati confermati dal GPS sono oggettivi — clienti e lavoratori vedono gli stessi numeri</li><li>Costi: i chilometri che non sarebbero mai finiti in una nota spese vengono catturati automaticamente</li><li>Conformità: una traccia di audit completa per lavoratore, per spostamento, per progetto — pronta per l&#x27;ispezione</li></ul><h2>Cosa cercare in uno strumento per il chilometraggio</h2><ul><li>Cattura automatica tramite GPS — nessun inserimento manuale per i lavoratori</li><li>Più tipi di trasporto con tariffe configurabili</li><li>Collegamento degli spostamenti per progetto o per cliente</li><li>Conforme al GDPR: GPS attivo solo durante l&#x27;orario di lavoro, dati ospitati nell&#x27;UE</li><li>Report pronti per l&#x27;esportazione che alimentano le buste paga o la fatturazione</li></ul><h2>Come lo gestisce Done-it</h2><p>Done-it cattura gli spostamenti automaticamente tramite Trax-it — il GPS registra il percorso, il lavoratore seleziona il tipo di trasporto e il sistema applica la tariffa giusta. Tutto si collega al progetto o cliente corretto. I report si esportano direttamente nelle buste paga o nella fatturazione elettronica, senza trascrizione manuale.</p>",
        "lead": "Quando la tua squadra si sposta tra le sedi tutto il giorno, i chilometri si accumulano in fretta — e con loro gli errori. Ecco come funziona la cattura automatica del chilometraggio, cosa fa risparmiare e cosa cercare in una soluzione.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Come tracciare il chilometraggio per le squadre sul campo — senza le scartoffie",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>La regola fondamentale: la proporzionalità</h2><p>Il tracciamento GPS dei dipendenti è legale ai sensi del GDPR — ma solo quando è proporzionato a una finalità aziendale legittima. Coordinare le consegne, confermare le visite di servizio, garantire la sicurezza dei lavoratori: tutto valido. Tracciare ogni movimento di una persona &#x27;per sicurezza&#x27;: non valido.</p><h2>Quattro cose che devi fare</h2><ul><li>Definisci la finalità: ottimizzazione dei percorsi, sicurezza, conferma del servizio — e mettila per iscritto</li><li>Limita il tracciamento al solo orario di lavoro: i lavoratori devono poter disattivare il GPS nel tempo personale</li><li>Informa la tua squadra in modo chiaro: cosa viene raccolto, perché, chi può vederlo, per quanto tempo viene conservato</li><li>Documentalo: includi l&#x27;uso del GPS nel regolamento aziendale ed esegui una DPIA se il tracciamento è su larga scala o strutturale</li></ul><h2>Cosa non devi fare</h2><ul><li>Tracciare 24 ore su 24 — il tracciamento al di fuori dell&#x27;orario di lavoro viola la proporzionalità del GDPR</li><li>Usare i dati GPS per sanzioni automatiche (ad es. avvisi di velocità che attivano provvedimenti disciplinari) senza previa informativa</li><li>Conservare i dati di posizione più a lungo del necessario — la CNIL raccomanda un massimo di due mesi</li><li>Omettere di informare i lavoratori — un tracciamento non comunicato può invalidare le prove in qualsiasi contenzioso successivo</li></ul><h2>Note specifiche per settore</h2><p>Per l&#x27;assistenza sul campo e la logistica, il GPS è atteso e facilmente giustificabile. Per le pulizie e la manutenzione, la pianificazione dei percorsi da parte dei responsabili va bene — il tracciamento costante per lavoratore è più difficile da giustificare. Per l&#x27;edilizia, il GPS per la protezione di veicoli e macchinari è standard; non dovrebbe duplicare alcun sistema di registrazione delle presenze già in uso.</p><h2>Come lo gestisce Done-it</h2><p>Done-it attiva il GPS solo all&#x27;entrata, all&#x27;uscita e durante gli spostamenti di lavoro attivi. Non c&#x27;è tracciamento 24 ore su 24, nessun monitoraggio durante le pause o il tempo personale. I dati sono ospitati nell&#x27;UE con crittografia e un responsabile della protezione dei dati dedicato — pronti per qualsiasi audit sulla privacy.</p>",
        "lead": "Il tracciamento GPS dei lavoratori mobili solleva questioni reali di privacy. Ecco la guida chiara su cosa è legalmente consentito, cosa no e come implementarlo in un modo che la tua squadra accetterà.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Tracciamento GPS per i lavoratori sul campo: cosa è consentito e come farlo bene",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Il problema dei fogli ore manuali</h2><p>I lavoratori sul campo compilano le ore a memoria, spesso giorni dopo. L&#x27;arrotondamento è la norma. Le ore finiscono sul progetto o cliente sbagliato. Le buste paga sono un&#x27;approssimazione. E quando un cliente contesta una fattura — o si presenta un ispettore — non c&#x27;è un record oggettivo su cui contare.</p><h2>Cosa significa davvero la registrazione digitale delle ore</h2><p>La registrazione digitale significa che un lavoratore tocca per timbrare l&#x27;entrata in cantiere, il sistema vi appone una marca temporale con conferma GPS, e le ore si collegano automaticamente al progetto o cliente giusto. A fine mese, l&#x27;esportazione per le buste paga viene generata con un clic — niente rincorsa, niente riconciliazione, nessun errore.</p><p>Il back office ottiene una vista in tempo reale: chi è in quale cantiere, quante ore sono state registrate su ciascun progetto e se un lavoro sta andando fuori budget. Quella visibilità cambia il modo in cui gestisci — i problemi emergono in tempo reale invece che a fine mese.</p><h2>Cosa cercare in uno strumento di rilevazione delle ore per le squadre sul campo</h2><ul><li>Check-in e check-out confermati dal GPS — niente terminale, niente lettore di tessere</li><li>Collegamento delle ore per progetto o per cliente, non solo un totale giornaliero</li><li>Vista delle ore residue in tempo reale per progetto così gli sforamenti di budget sono visibili prima che accadano</li><li>Rilevazione degli straordinari con pagamento flessibile o conversione in tempo libero</li><li>Gestione di ferie e assenze, incluso il caricamento digitale dei certificati medici</li><li>Esportazione per le buste paga con un clic compatibile con il tuo segretariato sociale o sistema HR</li></ul><h2>Obiezioni comuni — con risposta</h2><p>I lavoratori non lo useranno. In pratica, un check-in con un tocco richiede meno tempo che compilare un foglio ore cartaceo a fine settimana. L&#x27;adozione è quasi sempre più rapida del previsto. È troppo costoso. Done-it parte da 19 €/mese di base — meno del costo di un singolo errore nelle buste paga. Siamo troppo piccoli. Non c&#x27;è una dimensione minima del team.</p><h2>La dimensione della conformità</h2><p>La maggior parte dei paesi dell&#x27;UE sta rafforzando i requisiti sulla registrazione delle ore di lavoro — spinta dalla sentenza della Corte di giustizia europea del 2019 secondo cui i datori di lavoro devono disporre di un sistema oggettivo e affidabile per misurare l&#x27;orario di lavoro giornaliero. Uno strumento digitale che produce un record a prova di manomissione per lavoratore, per giorno, per progetto soddisfa qualsiasi attuazione locale di tale standard.</p>",
        "lead": "Quando la tua squadra lavora su più cantieri, i fogli ore manuali non funzionano. Ecco come la registrazione digitale delle ore cambia la realtà quotidiana — per lavoratori, responsabili e buste paga.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Rilevazione delle ore per le squadre sul campo: una guida completa per le PMI",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Dove se ne va il tempo</h2><p>Per un&#x27;azienda con 10–20 lavoratori sul campo, la preparazione delle buste paga richiede in genere da uno a due giorni al mese. Qualcuno raccoglie i fogli ore (carta o WhatsApp), li inserisce in un foglio di calcolo, li riconcilia con i record dei progetti, corregge gli inevitabili errori e produce un&#x27;esportazione per il segretariato sociale o il fornitore di buste paga. Ogni passaggio è manuale. Ogni passaggio ha modalità di errore.</p><h2>I colli di bottiglia</h2><ul><li>I fogli ore arrivano in ritardo o incompleti — i lavoratori sono in strada, non alla scrivania</li><li>Le ore vengono registrate sul progetto o cliente sbagliato, richiedendo una correzione manuale</li><li>I record di straordinari e assenze vivono in un sistema separato (o su un foglietto)</li><li>L&#x27;esportazione per le buste paga è formattata diversamente da come se l&#x27;aspetta il segretariato</li></ul><h2>Cosa cambia con un sistema digitale</h2><p>Quando i lavoratori timbrano entrata e uscita tramite GPS sul telefono, le ore vengono registrate nel momento in cui accadono — collegate al progetto giusto, con orari esatti, senza arrotondamenti. A fine mese, l&#x27;esportazione viene generata con un clic. I numeri sono già corretti. Non c&#x27;è nulla da riconciliare.</p><p>Gli straordinari vengono tracciati man mano che accadono. Le assenze vengono inviate in digitale dal lavoratore. I saldi delle ferie si aggiornano automaticamente. Il lavoro del responsabile diventa rivedere una dashboard, non costruirne una dai dati grezzi.</p><h2>Cosa riferiscono i team</h2><ul><li>Preparazione delle buste paga ridotta da due giorni a meno di un&#x27;ora</li><li>Errori nelle buste paga in netto calo — nessun inserimento manuale significa nessun errore di trascrizione</li><li>Il calcolo dei costi a posteriori dei progetti diventa possibile — ore reali per lavoro, non approssimazioni</li><li>I lavoratori lo preferiscono davvero — niente foglio ore da compilare a fine settimana</li></ul><h2>Per iniziare</h2><p>Done-it porta la maggior parte dei team dalla registrazione alle prime ore tracciate nel pomeriggio stesso. Nessun hardware, nessun progetto IT. I lavoratori scaricano l&#x27;app e registrano l&#x27;entrata. Le ore appaiono nella dashboard. L&#x27;esportazione per le buste paga è pronta a fine mese. La prova è di 30 giorni gratis — nessuna carta richiesta.</p>",
        "lead": "Per le aziende con squadre mobili, la preparazione delle buste paga è un incubo mensile — rincorrere i fogli ore, correggere gli errori, riconciliare i progetti. Ecco come l'hanno risolto i team che ci sono riusciti.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Come le imprese di assistenza sul campo riducono dell'80% il lavoro amministrativo per le buste paga",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "pt": [
      {
        "tag": "Mileage",
        "html": "<h2>Porque é que os registos manuais de quilómetros falham</h2><p>Quando os trabalhadores preenchem os quilómetros no final da semana, estão a reconstruir os trajetos de memória. O resultado: números arredondados, deslocações em falta e litígios no fecho do mês. A folha de pagamento fica inflacionada ou sub-reembolsada, e a empresa não dispõe de um registo de auditoria defensável.</p><h2>Como é o registo automático</h2><p>Um sistema baseado em GPS regista o ponto de partida, o ponto de chegada, o trajeto efetivo e a distância exata de cada deslocação — em segundo plano, enquanto o trabalhador conduz. Sem introdução manual. Os dados têm data e hora, ficam associados ao cliente ou projeto certo e ficam imediatamente disponíveis no back office.</p><p>O trabalhador seleciona o tipo de transporte no início da deslocação (viatura própria, viatura de empresa, boleia partilhada, bicicleta). O sistema aplica automaticamente a taxa de reembolso correta e assinala tudo o que ultrapasse o limiar que exige comprovativo de custos reais.</p><h2>O que poupa</h2><ul><li>Administração: sem andar atrás de cadernetas em papel nem corrigir erros de folha de cálculo no fecho do mês</li><li>Litígios: os dados confirmados por GPS são objetivos — clientes e trabalhadores veem os mesmos números</li><li>Custo: os quilómetros que nunca teriam chegado a uma nota de despesa são registados automaticamente</li><li>Conformidade: um registo de auditoria completo por trabalhador, por deslocação, por projeto — pronto para inspeção</li></ul><h2>O que procurar numa ferramenta de quilometragem</h2><ul><li>Registo automático via GPS — sem introdução manual por parte dos trabalhadores</li><li>Vários tipos de transporte com taxas configuráveis</li><li>Associação de deslocações por projeto ou por cliente</li><li>Conforme com o RGPD: GPS ativo apenas durante o horário de trabalho, dados alojados na UE</li><li>Relatórios prontos para exportação que alimentam a folha de pagamento ou a faturação</li></ul><h2>Como o Done-it resolve isto</h2><p>O Done-it regista as deslocações automaticamente através do Trax-it — o GPS regista o trajeto, o trabalhador seleciona o tipo de transporte e o sistema aplica a taxa certa. Tudo fica associado ao projeto ou cliente correto. Os relatórios são exportados diretamente para a folha de pagamento ou para a faturação eletrónica, sem qualquer transcrição manual.</p>",
        "lead": "Quando a sua equipa se desloca entre obras ao longo de todo o dia, os quilómetros acumulam-se depressa — e os erros também. Eis como funciona o registo automático de quilometragem, o que poupa e o que deve procurar numa solução.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Como registar a quilometragem de equipas no terreno — sem papelada",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>A regra central: a proporcionalidade</h2><p>A localização por GPS de colaboradores é legal ao abrigo do RGPD — mas apenas quando é proporcional a uma finalidade empresarial legítima. Coordenar entregas, confirmar visitas de serviço, garantir a segurança dos trabalhadores: tudo válido. Localizar cada movimento de alguém &#x27;só por precaução&#x27;: não é válido.</p><h2>Quatro coisas que tem de fazer</h2><ul><li>Defina a finalidade: otimização de trajetos, segurança, confirmação de serviço — e ponha-a por escrito</li><li>Limite a localização apenas ao horário de trabalho: os trabalhadores têm de poder desligar o GPS no tempo pessoal</li><li>Informe claramente a sua equipa: o que é recolhido, porquê, quem o pode ver e durante quanto tempo é conservado</li><li>Documente: inclua o uso do GPS no seu regulamento de trabalho e realize uma AIPD se a localização for em larga escala ou estrutural</li></ul><h2>O que não pode fazer</h2><ul><li>Localizar 24 horas por dia, 7 dias por semana — localizar fora do horário de trabalho viola a proporcionalidade do RGPD</li><li>Usar os dados de GPS para sanções automáticas (por exemplo, alertas de excesso de velocidade que desencadeiam medidas disciplinares) sem divulgação prévia</li><li>Conservar os dados de localização por mais tempo do que o necessário — a CNIL recomenda um máximo de dois meses</li><li>Deixar de informar os trabalhadores — a localização não divulgada pode invalidar provas em qualquer litígio posterior</li></ul><h2>Notas específicas por setor</h2><p>Para serviços no terreno e logística, o GPS é esperado e facilmente justificável. Para limpeza e manutenção, o planeamento de trajetos por parte das chefias é aceitável — a localização constante por trabalhador é mais difícil de justificar. Para a construção, o GPS para proteção de viaturas e máquinas é padrão; não deve duplicar nenhum sistema de registo de presenças já em uso.</p><h2>Como o Done-it resolve isto</h2><p>O Done-it ativa o GPS apenas no check-in, no check-out e durante as deslocações ativas em serviço. Não há localização 24 horas por dia, 7 dias por semana, nem monitorização durante as pausas ou o tempo pessoal. Os dados são alojados na UE com encriptação e um Encarregado de Proteção de Dados dedicado — prontos para qualquer auditoria de privacidade.</p>",
        "lead": "A localização por GPS de trabalhadores móveis levanta verdadeiras questões de privacidade. Eis o guia direto sobre o que é legalmente permitido, o que não é e como implementá-lo de uma forma que a sua equipa aceite.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Localização por GPS de trabalhadores no terreno: o que é permitido e como fazê-lo bem",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>O problema das folhas de horas manuais</h2><p>Os trabalhadores no terreno preenchem as horas de memória, muitas vezes dias depois. O arredondamento é a norma. As horas vão parar ao projeto ou cliente errado. A folha de pagamento é uma aproximação. E quando um cliente contesta uma fatura — ou aparece um inspetor — não há um registo objetivo a que recorrer.</p><h2>O que significa realmente o registo digital de tempos</h2><p>O registo digital significa que um trabalhador toca para registar a entrada na obra, o sistema marca a data e a hora com confirmação por GPS, e as horas ficam automaticamente associadas ao projeto ou cliente certo. No fecho do mês, a exportação para a folha de pagamento é gerada com um clique — sem andar atrás de ninguém, sem reconciliações, sem erros.</p><p>O back office obtém uma visão em tempo real: quem está em cada obra, quantas horas foram registadas em cada projeto e se algum trabalho está a ultrapassar o orçamento. Essa visibilidade muda a forma como gere — os problemas surgem em tempo real, em vez de só no fecho do mês.</p><h2>O que procurar numa ferramenta de registo de tempos para equipas no terreno</h2><ul><li>Check-in e check-out confirmados por GPS — sem terminal, sem leitor de cartões</li><li>Associação de horas por projeto ou por cliente, não apenas um total diário</li><li>Visão em tempo real das horas restantes por projeto, para que os excessos de orçamento sejam visíveis antes de acontecerem</li><li>Registo de horas extraordinárias com pagamento flexível ou conversão em tempo de descanso</li><li>Gestão de férias e ausências, incluindo o carregamento digital de atestados médicos</li><li>Exportação para a folha de pagamento com um clique, compatível com o seu secretariado social ou sistema de RH</li></ul><h2>Objeções comuns — respondidas</h2><p>Os trabalhadores não vão usar. Na prática, um check-in com um toque demora menos tempo do que preencher uma folha de horas em papel no fim da semana. A adesão é quase sempre mais rápida do que o esperado. É demasiado caro. O Done-it começa em 19 €/mês de base — menos do que o custo de um único erro na folha de pagamento. Somos demasiado pequenos. Não existe dimensão mínima de equipa.</p><h2>A dimensão da conformidade</h2><p>A maioria dos países da UE está a reforçar as exigências em torno do registo das horas de trabalho — impulsionada pelo acórdão do Tribunal de Justiça Europeu de 2019, segundo o qual os empregadores têm de dispor de um sistema objetivo e fiável para medir o tempo de trabalho diário. Uma ferramenta digital que produz um registo inviolável por trabalhador, por dia e por projeto satisfaz qualquer implementação local dessa norma.</p>",
        "lead": "Quando a sua equipa trabalha em vários locais, as folhas de horas manuais não funcionam. Eis como o registo digital de tempos transforma a realidade do dia a dia — para trabalhadores, gestores e folha de pagamento.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Registo de tempos para equipas no terreno: um guia completo para PME",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Para onde vai o tempo</h2><p>Para uma empresa com 10 a 20 trabalhadores no terreno, a preparação da folha de pagamento demora normalmente um a dois dias por mês. Alguém recolhe as folhas de horas (em papel ou por WhatsApp), introduz tudo numa folha de cálculo, reconcilia com os registos dos projetos, corrige os erros inevitáveis e produz uma exportação para o secretariado social ou para o prestador da folha de pagamento. Todos os passos são manuais. Todos os passos têm pontos de falha.</p><h2>Os estrangulamentos</h2><ul><li>As folhas de horas chegam atrasadas ou incompletas — os trabalhadores estão na estrada, não a uma secretária</li><li>As horas são registadas no projeto ou cliente errado, exigindo correção manual</li><li>Os registos de horas extraordinárias e ausências vivem num sistema separado (ou num post-it)</li><li>A exportação para a folha de pagamento tem um formato diferente do que o secretariado espera</li></ul><h2>O que muda um sistema digital</h2><p>Quando os trabalhadores fazem check-in e check-out via GPS no telemóvel, as horas são registadas no momento em que acontecem — associadas ao projeto certo, com horas exatas e sem arredondamentos. No fecho do mês, a exportação é gerada com um clique. Os números já estão corretos. Não há nada para reconciliar.</p><p>As horas extraordinárias são registadas à medida que acontecem. As ausências são submetidas digitalmente pelo trabalhador. Os saldos de férias atualizam-se automaticamente. O trabalho do gestor passa a ser rever um painel, e não construí-lo a partir de dados em bruto.</p><h2>O que as equipas relatam</h2><ul><li>Preparação da folha de pagamento reduzida de dois dias para menos de uma hora</li><li>Erros na folha de pagamento drasticamente reduzidos — sem introdução manual não há erros de transcrição</li><li>O apuramento de custos a posteriori por projeto torna-se possível — horas reais por trabalho, e não aproximações</li><li>Os trabalhadores até preferem assim — sem folha de horas para preencher no fim da semana</li></ul><h2>Como começar</h2><p>O Done-it leva a maioria das equipas do registo às primeiras horas monitorizadas na mesma tarde. Sem hardware, sem projeto de TI. Os trabalhadores descarregam a aplicação e fazem check-in. As horas aparecem no painel. A exportação para a folha de pagamento fica pronta no fecho do mês. O período de experiência é de 30 dias gratuitos — sem necessidade de cartão.</p>",
        "lead": "Para as empresas com equipas móveis, a preparação da folha de pagamento é um pesadelo mensal — andar atrás de folhas de horas, corrigir erros, reconciliar projetos. Eis como o fizeram as equipas que resolveram o problema.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Como as empresas de serviços no terreno reduziram a administração da folha de pagamento em 80%",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "pl": [
      {
        "tag": "Mileage",
        "html": "<h2>Dlaczego ręczne rejestry przebiegu zawodzą</h2><p>Gdy pracownicy uzupełniają kilometry na koniec tygodnia, odtwarzają trasy z pamięci. Efekt: zaokrąglone liczby, brakujące przejazdy i spory na koniec miesiąca. Płace są zawyżane lub zaniżane, a firma nie ma możliwego do obrony śladu audytowego.</p><h2>Jak wygląda automatyczna rejestracja</h2><p>System oparty na GPS rejestruje punkt wyjazdu, punkt przybycia, rzeczywistą trasę i dokładną odległość dla każdego przejazdu — w tle, podczas gdy pracownik prowadzi. Bez ręcznego wprowadzania. Dane są opatrzone znacznikiem czasu, powiązane z właściwym klientem lub projektem i natychmiast dostępne w panelu administracyjnym.</p><p>Pracownik wybiera rodzaj transportu na początku przejazdu (własny samochód, pojazd służbowy, wspólny dojazd, rower). System automatycznie stosuje właściwą stawkę zwrotu i oznacza wszystko powyżej progu, co wymaga udokumentowania rzeczywistych kosztów.</p><h2>Co pozwala zaoszczędzić</h2><ul><li>Biurokracja: koniec z gonieniem za papierowymi rejestrami czy poprawianiem błędów w arkuszach na koniec miesiąca</li><li>Spory: dane potwierdzone przez GPS są obiektywne — klienci i pracownicy widzą te same liczby</li><li>Koszty: kilometry, które nigdy nie trafiłyby na notę kosztową, są rejestrowane automatycznie</li><li>Zgodność: pełny ślad audytowy w podziale na pracownika, przejazd i projekt — gotowy do kontroli</li></ul><h2>Na co zwrócić uwagę przy wyborze narzędzia do rejestracji przebiegu</h2><ul><li>Automatyczna rejestracja przez GPS — bez ręcznego wprowadzania przez pracowników</li><li>Wiele rodzajów transportu z konfigurowalnymi stawkami</li><li>Powiązanie przejazdów z projektem lub klientem</li><li>Zgodność z RODO: GPS aktywny tylko w godzinach pracy, dane hostowane w UE</li><li>Raporty gotowe do eksportu, które zasilają płace lub fakturowanie</li></ul><h2>Jak radzi sobie z tym Done-it</h2><p>Done-it rejestruje przejazdy automatycznie za pomocą Trax-it — GPS rejestruje trasę, pracownik wybiera rodzaj transportu, a system stosuje właściwą stawkę. Wszystko łączy się z właściwym projektem lub klientem. Raporty eksportują się bezpośrednio do płac lub e-fakturowania, bez ręcznego przepisywania.</p>",
        "lead": "Gdy Twój zespół przemieszcza się między lokalizacjami przez cały dzień, kilometry szybko się sumują — a wraz z nimi błędy. Oto jak działa automatyczna rejestracja przebiegu, co pozwala zaoszczędzić i na co zwrócić uwagę przy wyborze rozwiązania.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Jak rejestrować przebieg kilometrów dla zespołów terenowych — bez papierkowej roboty",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Główna zasada: proporcjonalność</h2><p>Śledzenie GPS pracowników jest zgodne z prawem na gruncie RODO — ale tylko wtedy, gdy jest proporcjonalne do uzasadnionego celu biznesowego. Koordynowanie dostaw, potwierdzanie wizyt serwisowych, zapewnianie bezpieczeństwa pracownikom: wszystko to jest uzasadnione. Śledzenie każdego ruchu „na wszelki wypadek”: nieuzasadnione.</p><h2>Cztery rzeczy, które musisz zrobić</h2><ul><li>Zdefiniuj cel: optymalizacja tras, bezpieczeństwo, potwierdzanie serwisu — i zapisz go</li><li>Ogranicz śledzenie wyłącznie do godzin pracy: pracownicy muszą mieć możliwość wyłączenia GPS w czasie prywatnym</li><li>Jasno poinformuj swój zespół: co jest zbierane, dlaczego, kto może to widzieć i jak długo jest przechowywane</li><li>Udokumentuj to: uwzględnij użycie GPS w regulaminie pracy i przeprowadź ocenę skutków (DPIA), jeśli śledzenie jest prowadzone na dużą skalę lub strukturalnie</li></ul><h2>Czego nie wolno robić</h2><ul><li>Śledzić przez całą dobę — śledzenie poza godzinami pracy narusza zasadę proporcjonalności RODO</li><li>Wykorzystywać danych GPS do automatycznych sankcji (np. alertów o przekroczeniu prędkości uruchamiających postępowanie dyscyplinarne) bez wcześniejszego poinformowania</li><li>Przechowywać danych o lokalizacji dłużej niż to konieczne — francuski organ CNIL zaleca maksymalnie dwa miesiące</li><li>Pomijać informowania pracowników — nieujawnione śledzenie może unieważnić dowody w późniejszym sporze</li></ul><h2>Uwagi specyficzne dla sektora</h2><p>W przypadku serwisu terenowego i logistyki GPS jest oczekiwany i łatwy do uzasadnienia. W przypadku sprzątania i konserwacji planowanie tras przez przełożonych jest w porządku — stałe śledzenie każdego pracownika jest trudniejsze do uzasadnienia. W budownictwie GPS do ochrony pojazdów i maszyn jest standardem; nie powinien dublować żadnego systemu rejestracji obecności, który jest już w użyciu.</p><h2>Jak radzi sobie z tym Done-it</h2><p>Done-it aktywuje GPS tylko podczas zameldowania, wymeldowania i w trakcie aktywnej podróży służbowej. Nie ma śledzenia przez całą dobę, nie ma monitorowania podczas przerw ani czasu prywatnego. Dane są hostowane w UE z szyfrowaniem i z udziałem wyznaczonego inspektora ochrony danych — gotowe na każdy audyt prywatności.</p>",
        "lead": "Śledzenie GPS pracowników mobilnych rodzi realne pytania o prywatność. Oto prosty przewodnik po tym, co jest prawnie dozwolone, co nie, i jak wdrożyć to w sposób, który Twój zespół zaakceptuje.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Śledzenie GPS pracowników terenowych: co jest dozwolone i jak robić to właściwie",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Problem z ręcznymi kartami pracy</h2><p>Pracownicy terenowi uzupełniają godziny z pamięci, często wiele dni później. Zaokrąglanie jest normą. Godziny trafiają do niewłaściwego projektu lub klienta. Płace są przybliżeniem. A gdy klient kwestionuje fakturę — albo pojawia się inspektor — nie ma obiektywnego zapisu, na którym można się oprzeć.</p><h2>Co tak naprawdę oznacza cyfrowa rejestracja czasu pracy</h2><p>Cyfrowa rejestracja oznacza, że pracownik melduje się jednym dotknięciem na lokalizacji, system opatruje to znacznikiem czasu z potwierdzeniem GPS, a godziny automatycznie wiążą się z właściwym projektem lub klientem. Na koniec miesiąca eksport do płac jest generowany jednym kliknięciem — bez gonienia, bez uzgadniania, bez błędów.</p><p>Panel administracyjny otrzymuje widok na żywo: kto jest na której lokalizacji, ile godzin zarejestrowano w ramach każdego projektu i czy któreś zlecenie przekracza budżet. Ta widoczność zmienia sposób zarządzania — problemy ujawniają się w czasie rzeczywistym, a nie na koniec miesiąca.</p><h2>Na co zwrócić uwagę przy wyborze narzędzia do rejestracji czasu dla zespołów terenowych</h2><ul><li>Zameldowanie i wymeldowanie potwierdzone przez GPS — bez terminala, bez czytnika kart</li><li>Powiązanie godzin z projektem lub klientem, a nie tylko sumy dziennej</li><li>Widok pozostałych godzin na żywo w podziale na projekt, aby przekroczenia budżetu były widoczne, zanim nastąpią</li><li>Rejestracja nadgodzin z elastyczną wypłatą lub zamianą na czas wolny</li><li>Zarządzanie urlopami i nieobecnościami, w tym cyfrowe przesyłanie zwolnień lekarskich</li><li>Eksport do płac jednym kliknięciem, kompatybilny z Twoim sekretariatem socjalnym lub systemem kadrowym</li></ul><h2>Najczęstsze zastrzeżenia — z odpowiedziami</h2><p>Pracownicy nie będą tego używać. W praktyce zameldowanie jednym dotknięciem zajmuje mniej czasu niż wypełnianie papierowej karty pracy na koniec tygodnia. Przyswojenie jest niemal zawsze szybsze niż oczekiwano. To zbyt drogie. Done-it zaczyna się od 19 €/miesiąc opłaty podstawowej — mniej niż koszt jednego błędu płacowego. Jesteśmy zbyt mali. Nie ma minimalnej wielkości zespołu.</p><h2>Wymiar zgodności z przepisami</h2><p>Większość krajów UE zaostrza wymogi dotyczące rejestracji godzin pracy — w następstwie wyroku Trybunału Sprawiedliwości Unii Europejskiej z 2019 roku, zgodnie z którym pracodawcy muszą mieć obiektywny, niezawodny system pomiaru dziennego czasu pracy. Cyfrowe narzędzie tworzące odporny na manipulacje zapis w podziale na pracownika, dzień i projekt spełnia każdą lokalną implementację tego standardu.</p>",
        "lead": "Gdy Twój zespół pracuje w wielu lokalizacjach, ręczne karty pracy się nie sprawdzają. Oto jak cyfrowa rejestracja czasu pracy zmienia codzienną rzeczywistość — dla pracowników, menedżerów i działu płac.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Rejestracja czasu pracy dla zespołów terenowych: kompletny przewodnik dla MŚP",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Gdzie ucieka czas</h2><p>W przypadku firmy zatrudniającej od 10 do 20 pracowników terenowych przygotowanie płac zajmuje zazwyczaj jeden do dwóch dni miesięcznie. Ktoś zbiera karty pracy (papierowe lub z WhatsAppa), wprowadza je do arkusza kalkulacyjnego, uzgadnia je z zapisami projektów, poprawia nieuniknione błędy i przygotowuje eksport dla sekretariatu socjalnego lub dostawcy usług płacowych. Każdy krok jest ręczny. Każdy krok ma swoje punkty awarii.</p><h2>Wąskie gardła</h2><ul><li>Karty pracy przychodzą z opóźnieniem lub niekompletne — pracownicy są w drodze, a nie przy biurku</li><li>Godziny są rejestrowane do niewłaściwego projektu lub klienta, co wymaga ręcznej korekty</li><li>Zapisy nadgodzin i nieobecności żyją w osobnym systemie (lub na karteczce samoprzylepnej)</li><li>Eksport do płac ma inny format niż oczekuje sekretariat</li></ul><h2>Co zmienia system cyfrowy</h2><p>Gdy pracownicy meldują się i wymeldowują przez GPS na swoim telefonie, godziny są rejestrowane w momencie, gdy się dzieją — powiązane z właściwym projektem, z dokładnymi godzinami, bez zaokrąglania. Na koniec miesiąca eksport jest generowany jednym kliknięciem. Liczby są już poprawne. Nie ma nic do uzgadniania.</p><p>Nadgodziny są rejestrowane na bieżąco. Nieobecności są zgłaszane cyfrowo przez pracownika. Salda urlopowe aktualizują się automatycznie. Praca menedżera sprowadza się do przeglądania pulpitu, a nie budowania go z surowych danych.</p><h2>Co zgłaszają zespoły</h2><ul><li>Przygotowanie płac skrócone z dwóch dni do mniej niż godziny</li><li>Błędy płacowe znacznie ograniczone — brak ręcznego wprowadzania oznacza brak pomyłek przy przepisywaniu</li><li>Kosztorysowanie projektów po fakcie staje się możliwe — rzeczywiste godziny w podziale na zlecenie, a nie przybliżenia</li><li>Pracownicy naprawdę to wolą — żadnej karty pracy do wypełnienia na koniec tygodnia</li></ul><h2>Jak zacząć</h2><p>Done-it przeprowadza większość zespołów od rejestracji do pierwszych zarejestrowanych godzin tego samego popołudnia. Bez sprzętu, bez projektu IT. Pracownicy pobierają aplikację i meldują się. Godziny pojawiają się na pulpicie. Eksport do płac jest gotowy na koniec miesiąca. Okres próbny to 30 dni bezpłatnie — bez karty.</p>",
        "lead": "Dla firm z mobilnymi zespołami przygotowanie płac to comiesięczny koszmar — gonienie za kartami pracy, poprawianie błędów, uzgadnianie projektów. Oto jak zrobiły to zespoły, które ten problem rozwiązały.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Jak firmy serwisu terenowego ograniczyły biurokrację płacową o 80%",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "ro": [
      {
        "tag": "Mileage",
        "html": "<h2>De ce eșuează jurnalele manuale de kilometraj</h2><p>Când lucrătorii completează kilometrii la sfârșitul săptămânii, reconstituie rutele din memorie. Rezultatul: cifre rotunjite, deplasări lipsă și dispute la sfârșitul lunii. Salarizarea este umflată sau subrambursată, iar firma nu are nicio urmă de audit pe care să o poată susține.</p><h2>Cum arată captarea automată</h2><p>Un sistem bazat pe GPS înregistrează punctul de plecare, punctul de sosire, ruta efectivă și distanța exactă pentru fiecare deplasare — în fundal, în timp ce lucrătorul conduce. Fără înregistrare manuală. Datele au marcaj de timp, sunt legate de clientul sau proiectul potrivit și disponibile imediat în back office.</p><p>Lucrătorul selectează tipul de transport la începutul deplasării (mașină proprie, vehicul de firmă, transport în comun, bicicletă). Sistemul aplică automat tariful corect de rambursare și semnalează orice depășește pragul care necesită dovada costurilor reale.</p><h2>Ce economisește</h2><ul><li>Administrație: gata cu alergatul după jurnale de bord pe hârtie sau corectarea erorilor din foi de calcul la sfârșitul lunii</li><li>Dispute: datele confirmate prin GPS sunt obiective — clienții și lucrătorii văd aceleași cifre</li><li>Cost: kilometri care nu ar fi ajuns niciodată pe o notă de cheltuieli sunt captați automat</li><li>Conformitate: o urmă de audit completă pe lucrător, pe deplasare, pe proiect — gata de inspecție</li></ul><h2>La ce să te uiți într-un instrument de kilometraj</h2><ul><li>Captare automată prin GPS — fără înregistrare manuală pentru lucrători</li><li>Mai multe tipuri de transport cu tarife configurabile</li><li>Legarea deplasărilor pe proiect sau pe client</li><li>Conform GDPR: GPS activ doar în timpul programului de lucru, date găzduite în UE</li><li>Rapoarte gata de export care alimentează salarizarea sau facturarea</li></ul><h2>Cum se ocupă Done-it de asta</h2><p>Done-it captează deplasările automat prin Trax-it — GPS-ul înregistrează ruta, lucrătorul selectează tipul de transport, iar sistemul aplică tariful corect. Totul se leagă de proiectul sau clientul corect. Rapoartele se exportă direct în salarizare sau facturare electronică, fără transcriere manuală.</p>",
        "lead": "Când echipa ta se deplasează între locații toată ziua, kilometrajul se adună rapid — și la fel și erorile. Iată cum funcționează captarea automată a kilometrajului, ce economisește și la ce să te uiți într-o soluție.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Cum să urmărești kilometrajul pentru echipele de teren — fără hârțogărie",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Regula de bază: proporționalitatea</h2><p>Urmărirea prin GPS a angajaților este legală conform GDPR — dar numai când este proporțională cu un scop comercial legitim. Coordonarea livrărilor, confirmarea vizitelor de service, asigurarea siguranței lucrătorilor: toate valabile. Urmărirea fiecărei mișcări a cuiva „pentru orice eventualitate”: nu este valabilă.</p><h2>Patru lucruri pe care trebuie să le faci</h2><ul><li>Definește scopul: optimizarea rutelor, siguranța, confirmarea serviciului — și pune-l pe hârtie</li><li>Limitează urmărirea doar la programul de lucru: lucrătorii trebuie să poată dezactiva GPS-ul în timpul personal</li><li>Informează-ți clar echipa: ce se colectează, de ce, cine poate vedea, cât timp se păstrează</li><li>Documentează: include utilizarea GPS în regulamentul de lucru și efectuează un DPIA dacă urmărirea este de amploare sau structurală</li></ul><h2>Ce nu trebuie să faci</h2><ul><li>Să urmărești 24/7 — urmărirea în afara programului de lucru încalcă proporționalitatea GDPR</li><li>Să folosești datele GPS pentru sancțiuni automate (de ex. alerte de viteză care declanșează măsuri disciplinare) fără informare prealabilă</li><li>Să stochezi datele de locație mai mult decât este necesar — CNIL recomandă un maxim de două luni</li><li>Să omiți informarea lucrătorilor — urmărirea nedeclarată poate invalida probele în orice dispută ulterioară</li></ul><h2>Note specifice sectorului</h2><p>Pentru servicii pe teren și logistică, GPS-ul este așteptat și ușor de justificat. Pentru curățenie și mentenanță, planificarea rutelor de către supervizori este în regulă — urmărirea constantă pe fiecare lucrător este mai greu de justificat. Pentru construcții, GPS-ul pentru protecția vehiculelor și utilajelor este standard; nu ar trebui să dubleze niciun sistem de înregistrare a prezenței deja în uz.</p><h2>Cum se ocupă Done-it de asta</h2><p>Done-it activează GPS-ul doar la pontajul de intrare, la pontajul de ieșire și în timpul deplasărilor active pentru muncă. Nu există urmărire 24/7, nicio monitorizare în timpul pauzelor sau al timpului personal. Datele sunt găzduite în UE cu criptare și un responsabil dedicat cu protecția datelor — gata pentru orice audit de confidențialitate.</p>",
        "lead": "Urmărirea prin GPS a lucrătorilor mobili ridică întrebări reale legate de confidențialitate. Iată ghidul direct despre ce este permis legal, ce nu este și cum să o implementezi într-un mod pe care echipa ta îl va accepta.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Urmărirea prin GPS a lucrătorilor de teren: ce este permis și cum să o faci corect",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Problema cu fișele de pontaj manuale</h2><p>Lucrătorii de teren completează orele din memorie, deseori zile mai târziu. Rotunjirea este norma. Orele ajung pe proiectul sau clientul greșit. Salarizarea este o aproximare. Iar când un client contestă o factură — sau apare un inspector — nu există o evidență obiectivă pe care să te poți baza.</p><h2>Ce înseamnă de fapt înregistrarea digitală a timpului</h2><p>Înregistrarea digitală înseamnă că un lucrător atinge pentru a se ponta la șantier, sistemul marchează ora cu confirmare GPS, iar orele se leagă automat de proiectul sau clientul potrivit. La sfârșitul lunii, exportul pentru salarizare este generat cu un singur clic — fără alergat, fără reconciliere, fără erori.</p><p>Back office-ul primește o imagine în timp real: cine se află pe ce șantier, câte ore au fost înregistrate pe fiecare proiect și dacă vreo lucrare depășește bugetul. Acea vizibilitate schimbă modul în care gestionezi — problemele apar în timp real în loc de la sfârșitul lunii.</p><h2>La ce să te uiți într-un instrument de pontaj pentru echipele de teren</h2><ul><li>Pontaj la intrare și ieșire confirmat prin GPS — fără terminal, fără cititor de carduri</li><li>Legarea orelor pe proiect sau pe client, nu doar un total zilnic</li><li>Vizualizarea orelor rămase în timp real pe proiect, astfel încât depășirile de buget să fie vizibile înainte să se întâmple</li><li>Urmărirea orelor suplimentare cu plată flexibilă sau conversie în timp liber</li><li>Gestionarea concediilor și absențelor, inclusiv încărcarea digitală a certificatelor medicale</li><li>Export pentru salarizare cu un singur clic compatibil cu secretariatul tău social sau sistemul HR</li></ul><h2>Obiecții frecvente — cu răspunsuri</h2><p>Lucrătorii nu îl vor folosi. În practică, un pontaj cu o singură atingere durează mai puțin decât completarea unei fișe de pontaj pe hârtie la sfârșitul săptămânii. Adoptarea este aproape întotdeauna mai rapidă decât se așteaptă. Este prea scump. Done-it începe de la 19 €/lună de bază — mai puțin decât costul unei singure erori de salarizare. Suntem prea mici. Nu există o dimensiune minimă a echipei.</p><h2>Dimensiunea conformității</h2><p>Majoritatea țărilor UE își înăspresc cerințele privind înregistrarea orelor de lucru — determinate de hotărârea Curții Europene de Justiție din 2019, conform căreia angajatorii trebuie să aibă un sistem obiectiv și fiabil de măsurare a timpului de lucru zilnic. Un instrument digital care produce o evidență inviolabilă pe lucrător, pe zi, pe proiect satisface orice implementare locală a acelui standard.</p>",
        "lead": "Când echipa ta lucrează în mai multe locații, fișele de pontaj manuale nu funcționează. Iată cum schimbă înregistrarea digitală a timpului realitatea zilnică — pentru lucrători, manageri și salarizare.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Pontajul pentru echipele de teren: un ghid complet pentru IMM-uri",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Unde se duce timpul</h2><p>Pentru o firmă cu 10–20 de lucrători de teren, pregătirea salarizării durează de regulă una până la două zile pe lună. Cineva colectează fișele de pontaj (hârtie sau WhatsApp), le introduce într-o foaie de calcul, le reconciliază cu evidențele de proiect, corectează inevitabilele erori și produce un export pentru secretariatul social sau furnizorul de salarizare. Fiecare pas este manual. Fiecare pas are moduri de eșec.</p><h2>Punctele de blocaj</h2><ul><li>Fișele de pontaj sosesc târziu sau incomplete — lucrătorii sunt pe drum, nu la birou</li><li>Orele sunt înregistrate pe proiectul sau clientul greșit, necesitând corecție manuală</li><li>Evidențele de ore suplimentare și absențe trăiesc într-un sistem separat (sau pe un bilețel)</li><li>Exportul pentru salarizare este formatat diferit față de ce așteaptă secretariatul</li></ul><h2>Ce schimbă un sistem digital</h2><p>Când lucrătorii se pontează la intrare și ieșire prin GPS de pe telefon, orele sunt înregistrate în momentul în care se întâmplă — legate de proiectul potrivit, cu ore exacte, fără rotunjire. La sfârșitul lunii, exportul este generat cu un singur clic. Cifrele sunt deja corecte. Nu este nimic de reconciliat.</p><p>Orele suplimentare sunt urmărite pe măsură ce se întâmplă. Absențele sunt trimise digital de lucrător. Soldurile de concediu se actualizează automat. Munca managerului devine analizarea unui panou de control, nu construirea lui din date brute.</p><h2>Ce raportează echipele</h2><ul><li>Pregătirea salarizării redusă de la două zile la sub o oră</li><li>Erorile de salarizare scad puternic — fără înregistrare manuală nu există greșeli de transcriere</li><li>Calculul costurilor post-proiect devine posibil — ore reale pe lucrare, nu aproximări</li><li>Lucrătorii chiar îl preferă — nicio fișă de pontaj de completat la sfârșitul săptămânii</li></ul><h2>Cum începi</h2><p>Done-it duce majoritatea echipelor de la înscriere la primele ore înregistrate în aceeași după-amiază. Fără echipamente, fără proiect IT. Lucrătorii descarcă aplicația și se pontează. Orele apar în panoul de control. Exportul pentru salarizare este gata la sfârșitul lunii. Perioada de probă este de 30 de zile gratuită — fără card necesar.</p>",
        "lead": "Pentru firmele cu echipe mobile, pregătirea salarizării este un coșmar lunar — alergat după fișe de pontaj, corectarea erorilor, reconcilierea proiectelor. Iată cum au procedat echipele care au rezolvat-o.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Cum firmele de servicii pe teren și-au redus administrarea salarizării cu 80%",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "no": [
      {
        "tag": "Mileage",
        "html": "<h2>Hvorfor manuelle kjørelogger feiler</h2><p>Når arbeidere fyller inn kilometer ved slutten av uken, rekonstruerer de ruter fra hukommelsen. Resultatet: avrundede tall, manglende turer og tvister ved månedsslutt. Lønn er for høy eller for lavt refundert, og selskapet har ikke noe forsvarbart revisjonsspor.</p><h2>Hvordan automatisk fangst ser ut</h2><p>Et GPS-basert system logger avgangspunkt, ankomstpunkt, faktisk rute og nøyaktig distanse for hver tur — i bakgrunnen, mens arbeideren kjører. Ingen manuell registrering. Dataene er tidsstemplet, knyttet til riktig kunde eller prosjekt, og umiddelbart tilgjengelige i baksystemet.</p><p>Arbeideren velger transporttype ved starten av turen (egen bil, firmabil, samkjøring, sykkel). Systemet bruker riktig refusjonssats automatisk og flagger alt over terskelen som krever bevis på reelle kostnader.</p><h2>Hva det sparer</h2><ul><li>Administrasjon: ingen jakt på papirkjørebøker eller korrigering av regnearkfeil ved månedsslutt</li><li>Tvister: GPS-bekreftede data er objektive — kunder og arbeidere ser de samme tallene</li><li>Kostnad: kilometer som aldri ville kommet inn på en utgiftsnote fanges automatisk</li><li>Samsvar: et fullstendig revisjonsspor per arbeider, per tur, per prosjekt — klart for inspeksjon</li></ul><h2>Hva du bør se etter i et kjørelengdeverktøy</h2><ul><li>Automatisk fangst via GPS — ingen manuell registrering for arbeidere</li><li>Flere transporttyper med konfigurerbare satser</li><li>Turknytting per prosjekt eller per kunde</li><li>GDPR-sikker: GPS aktiv kun i arbeidstiden, data lagret i EU</li><li>Eksportklare rapporter som mater inn i lønn eller fakturering</li></ul><h2>Hvordan Done-it håndterer det</h2><p>Done-it fanger turer automatisk via Trax-it — GPS logger ruten, arbeideren velger transporttypen, og systemet bruker riktig sats. Alt knyttes til riktig prosjekt eller kunde. Rapporter eksporteres direkte inn i lønn eller e-fakturering, uten manuell avskrift.</p>",
        "lead": "Når teamet ditt flytter seg mellom steder hele dagen, summerer kjørelengden seg raskt — og det samme gjør feilene. Her er hvordan automatisk fangst av kjørelengde fungerer, hva det sparer, og hva du bør se etter i en løsning.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Slik sporer du kjørelengde for feltteam — uten papirarbeidet",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Kjerneregelen: forholdsmessighet</h2><p>GPS-sporing av ansatte er lovlig under GDPR — men bare når den er forholdsmessig til et legitimt forretningsformål. Å koordinere leveranser, bekrefte servicebesøk, sikre arbeidersikkerhet: alt gyldig. Å spore noens hver bevegelse «for sikkerhets skyld»: ikke gyldig.</p><h2>Fire ting du må gjøre</h2><ul><li>Definer formålet: ruteoptimalisering, sikkerhet, servicebekreftelse — og skriv det ned</li><li>Begrens sporing til kun arbeidstiden: arbeidere må kunne slå av GPS i fritiden</li><li>Informer teamet ditt tydelig: hva som samles inn, hvorfor, hvem som kan se det, hvor lenge det oppbevares</li><li>Dokumenter det: inkluder GPS-bruk i arbeidsreglementet ditt og kjør en DPIA hvis sporingen er storskala eller strukturell</li></ul><h2>Hva du ikke må gjøre</h2><ul><li>Spore døgnet rundt — sporing utenfor arbeidstiden bryter GDPRs forholdsmessighet</li><li>Bruke GPS-data til automatiske sanksjoner (f.eks. fartsvarsler som utløser disiplin) uten forhåndsvarsel</li><li>Lagre stedsdata lenger enn nødvendig — CNIL anbefaler maksimalt to måneder</li><li>Hoppe over å informere arbeidere — uoppgitt sporing kan ugyldiggjøre bevis i enhver senere tvist</li></ul><h2>Bransjespesifikke merknader</h2><p>For felttjeneste og logistikk er GPS forventet og lett å rettferdiggjøre. For renhold og vedlikehold er ruteplanlegging av overordnede greit — konstant sporing per arbeider er vanskeligere å rettferdiggjøre. For bygg og anlegg er GPS for beskyttelse av kjøretøy og maskiner standard; den bør ikke duplisere et tilstedeværelsesregistreringssystem som allerede er i bruk.</p><h2>Hvordan Done-it håndterer det</h2><p>Done-it aktiverer GPS bare ved innsjekk, utsjekk og under aktiv reise i jobbsammenheng. Det er ingen sporing døgnet rundt, ingen overvåking i pauser eller fritid. Data lagres i EU med kryptering og et dedikert personvernombud — klart for enhver personvernrevisjon.</p>",
        "lead": "GPS-sporing av mobile arbeidere reiser reelle personvernspørsmål. Her er den enkle veiledningen til hva som er juridisk tillatt, hva som ikke er det, og hvordan du implementerer det på en måte teamet ditt vil akseptere.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS-sporing av feltarbeidere: hva som er tillatt og hvordan du gjør det riktig",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Problemet med manuelle timelister</h2><p>Feltarbeidere fyller inn timer fra hukommelsen, ofte dager senere. Avrunding er normen. Timer lander på feil prosjekt eller kunde. Lønn er en tilnærming. Og når en kunde bestrider en faktura — eller en inspektør dukker opp — finnes det ingen objektiv registrering å falle tilbake på.</p><h2>Hva digital tidsregistrering faktisk betyr</h2><p>Digital registrering betyr at en arbeider trykker for å stemple inn på stedet, systemet tidsstempler det med GPS-bekreftelse, og timene knyttes automatisk til riktig prosjekt eller kunde. Ved månedsslutt genereres lønnseksporten med ett klikk — ingen jakt, ingen avstemming, ingen feil.</p><p>Baksystemet får en sanntidsoversikt: hvem som er på hvilket sted, hvor mange timer som er logget mot hvert prosjekt, og om noen jobb går over budsjett. Den oversikten endrer hvordan du leder — problemer dukker opp i sanntid i stedet for ved månedsslutt.</p><h2>Hva du bør se etter i et tidsregistreringsverktøy for feltteam</h2><ul><li>GPS-bekreftet inn- og utsjekk — ingen terminal, ingen kortleser</li><li>Timeknytting per prosjekt eller per kunde, ikke bare en daglig sum</li><li>Sanntidsvisning av gjenstående timer per prosjekt slik at budsjettoverskridelser er synlige før de skjer</li><li>Overtidsregistrering med fleksibel utbetaling eller avspaseringskonvertering</li><li>Permisjons- og fraværshåndtering, inkludert digital opplasting av sykmeldinger</li><li>Lønnseksport med ett klikk kompatibel med ditt sosiale sekretariat eller HR-system</li></ul><h2>Vanlige innvendinger — besvart</h2><p>Arbeidere vil ikke bruke det. I praksis tar en innsjekk med ett trykk mindre tid enn å fylle inn en papir-timeliste ved ukens slutt. Innføringen er nesten alltid raskere enn forventet. Det er for dyrt. Done-it starter på €19/måned grunnpris — mindre enn kostnaden av én lønnsfeil. Vi er for små. Det finnes ingen minste teamstørrelse.</p><h2>Samsvarsdimensjonen</h2><p>De fleste EU-land strammer inn kravene rundt arbeidstidsregistrering — drevet av dommen fra EU-domstolen i 2019 om at arbeidsgivere må ha et objektivt, pålitelig system for å måle daglig arbeidstid. Et digitalt verktøy som produserer en manipuleringssikker registrering per arbeider, per dag, per prosjekt oppfyller enhver lokal implementering av den standarden.</p>",
        "lead": "Når teamet ditt jobber på tvers av flere steder, fungerer ikke manuelle timelister. Her er hvordan digital tidsregistrering endrer den daglige virkeligheten — for arbeidere, ledere og lønn.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Tidsregistrering for feltteam: en komplett veiledning for SMB-er",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Hvor tiden går</h2><p>For et selskap med 10–20 feltarbeidere tar lønnsforberedelse vanligvis en til to dager per måned. Noen samler inn timelister (papir eller WhatsApp), legger dem inn i et regneark, avstemmer mot prosjektregistreringer, korrigerer de uunngåelige feilene, og produserer en eksport for det sosiale sekretariatet eller lønnsleverandøren. Hvert trinn er manuelt. Hvert trinn har feilmuligheter.</p><h2>Flaskehalsene</h2><ul><li>Timelister kommer sent eller ufullstendige — arbeidere er på veien, ikke ved et skrivebord</li><li>Timer logges til feil prosjekt eller kunde, noe som krever manuell korrigering</li><li>Overtids- og fraværsregistreringer ligger i et separat system (eller på en gul lapp)</li><li>Lønnseksporten er formatert annerledes enn det sekretariatet forventer</li></ul><h2>Hva et digitalt system endrer</h2><p>Når arbeidere sjekker inn og ut via GPS på telefonen, registreres timene i det øyeblikket de skjer — knyttet til riktig prosjekt, med nøyaktige tider, ingen avrunding. Ved månedsslutt genereres eksporten med ett klikk. Tallene er allerede riktige. Det er ingenting å avstemme.</p><p>Overtid spores etter hvert som den skjer. Fravær sendes inn digitalt av arbeideren. Permisjonssaldoer oppdateres automatisk. Lederens jobb blir å gjennomgå et dashbord, ikke å bygge ett fra rådata.</p><h2>Hva team rapporterer</h2><ul><li>Lønnsforberedelse ned fra to dager til under en time</li><li>Lønnsfeil kraftig ned — ingen manuell registrering betyr ingen avskriftsfeil</li><li>Etterkalkyle av prosjekter blir mulig — reelle timer per jobb, ikke tilnærminger</li><li>Arbeidere foretrekker det faktisk — ingen timeliste å fylle inn ved ukens slutt</li></ul><h2>Komme i gang</h2><p>Done-it tar de fleste team fra registrering til første registrerte timer samme ettermiddag. Ingen maskinvare, intet IT-prosjekt. Arbeidere laster ned appen og sjekker inn. Timer vises i dashbordet. Lønnseksporten er klar ved månedsslutt. Prøveperioden er 30 dager gratis — ingen kort nødvendig.</p>",
        "lead": "For selskaper med mobile team er lønnsforberedelse et månedlig mareritt — jakt på timelister, korrigering av feil, avstemming av prosjekter. Her er hvordan teamene som løste det gjorde det.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Hvordan felttjenestefirmaer kutter lønnsadministrasjon med 80 %",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "bg": [
      {
        "tag": "Mileage",
        "html": "<h2>Защо ръчните дневници за километри се провалят</h2><p>Когато служителите попълват километрите в края на седмицата, те възстановяват маршрутите по памет. Резултатът: закръглени числа, пропуснати пътувания и спорове в края на месеца. Заплатите се завишават или се възстановяват недостатъчно средства, а компанията няма защитима одитна следа.</p><h2>Как изглежда автоматичното отчитане</h2><p>Системата, базирана на GPS, регистрира началната точка, крайната точка, действителния маршрут и точното разстояние за всяко пътуване — на заден план, докато служителят шофира. Без ръчно въвеждане. Данните имат времеви маркер, свързани са с правилния клиент или проект и са незабавно достъпни в офиса.</p><p>Служителят избира вида транспорт в началото на пътуването (собствен автомобил, служебен автомобил, споделено пътуване, велосипед). Системата автоматично прилага правилната ставка за възстановяване и сигнализира за всичко над прага, което изисква доказателство за реални разходи.</p><h2>Какво спестява</h2><ul><li>Администрация: без гонене на хартиени дневници или коригиране на грешки в електронни таблици в края на месеца</li><li>Спорове: потвърдените чрез GPS данни са обективни — клиентите и служителите виждат едни и същи числа</li><li>Разходи: километрите, които иначе никога не биха попаднали в разходна бележка, се отчитат автоматично</li><li>Съответствие: пълна одитна следа за всеки служител, за всяко пътуване, за всеки проект — готова за проверка</li></ul><h2>На какво да обърнете внимание при инструмент за километри</h2><ul><li>Автоматично отчитане чрез GPS — без ръчно въвеждане от служителите</li><li>Множество видове транспорт с конфигурируеми ставки</li><li>Свързване на пътуванията по проект или по клиент</li><li>Съответствие с GDPR: GPS активен само през работно време, данни, хоствани в ЕС</li><li>Готови за експорт отчети, които се подават към ведомостта за заплати или фактурирането</li></ul><h2>Как Done-it се справя с това</h2><p>Done-it отчита пътуванията автоматично чрез Trax-it — GPS регистрира маршрута, служителят избира вида транспорт, а системата прилага правилната ставка. Всичко се свързва с правилния проект или клиент. Отчетите се експортират директно във ведомостта за заплати или в електронното фактуриране, без ръчно преписване.</p>",
        "lead": "Когато екипът Ви се движи между обекти през целия ден, километрите се натрупват бързо — а заедно с тях и грешките. Ето как работи автоматичното отчитане на километри, какво спестява то и на какво да обърнете внимание при избора на решение.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Как да проследявате километрите на изнесените си екипи — без бумащина",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Основното правило: пропорционалност</h2><p>GPS проследяването на служители е законно съгласно GDPR — но само когато е пропорционално на легитимна бизнес цел. Координиране на доставки, потвърждаване на сервизни посещения, осигуряване на безопасността на служителите: всичко това е валидно. Проследяване на всяка стъпка на някого „за всеки случай“: не е валидно.</p><h2>Четири неща, които трябва да направите</h2><ul><li>Определете целта: оптимизация на маршрута, безопасност, потвърждаване на услуга — и я запишете</li><li>Ограничете проследяването само до работно време: служителите трябва да могат да изключват GPS в личното си време</li><li>Информирайте екипа си ясно: какво се събира, защо, кой може да го вижда, колко дълго се съхранява</li><li>Документирайте го: включете използването на GPS в правилника за работа и проведете оценка на въздействието върху защитата на данните (DPIA), ако проследяването е мащабно или структурно</li></ul><h2>Какво не трябва да правите</h2><ul><li>Да проследявате 24/7 — проследяването извън работно време нарушава принципа на пропорционалност на GDPR</li><li>Да използвате GPS данни за автоматични санкции (напр. сигнали за превишена скорост, които задействат дисциплинарни мерки) без предварително оповестяване</li><li>Да съхранявате данни за местоположението по-дълго от необходимото — CNIL препоръчва максимум два месеца</li><li>Да пропускате информирането на служителите — неоповестеното проследяване може да обезсили доказателствата при всеки последващ спор</li></ul><h2>Бележки според сектора</h2><p>За изнесените услуги и логистиката GPS е очакван и лесно обоснован. За почистване и поддръжка планирането на маршрути от ръководители е допустимо — постоянното проследяване на всеки служител е по-трудно за обосноваване. За строителството GPS за защита на превозни средства и машини е стандарт; той не трябва да дублира никоя вече използвана система за регистриране на присъствие.</p><h2>Как Done-it се справя с това</h2><p>Done-it активира GPS само при отчитане на пристигане, отчитане на тръгване и по време на активно пътуване за работа. Няма проследяване 24/7, няма наблюдение по време на почивки или лично време. Данните се хостват в ЕС с криптиране и специален длъжностен директор по защита на данните — готови за всяка проверка на неприкосновеността на личните данни.</p>",
        "lead": "GPS проследяването на мобилни служители повдига реални въпроси за неприкосновеността на личните данни. Ето ясното ръководство за това какво е законово разрешено, какво не е и как да го внедрите по начин, който екипът Ви ще приеме.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS проследяване на изнесени служители: какво е разрешено и как да го направите правилно",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Проблемът с ръчните графици за работно време</h2><p>Изнесените служители попълват часовете по памет, често дни по-късно. Закръгляването е норма. Часовете попадат в грешен проект или клиент. Ведомостта за заплати е приблизителна. А когато клиент оспори фактура — или се появи инспектор — няма обективен запис, на който да се опрете.</p><h2>Какво всъщност означава цифрова регистрация на работното време</h2><p>Цифровата регистрация означава, че служителят докосва екрана, за да се отчете при пристигане на обекта, системата поставя времеви маркер с GPS потвърждение и часовете автоматично се свързват с правилния проект или клиент. В края на месеца експортът за ведомостта за заплати се генерира с едно кликване — без гонене, без съгласуване, без грешки.</p><p>Офисът получава картина в реално време: кой на кой обект се намира, колко часа са отчетени по всеки проект и дали някоя задача надхвърля бюджета. Тази видимост променя начина, по който управлявате — проблемите изплуват в реално време, вместо в края на месеца.</p><h2>На какво да обърнете внимание при инструмент за отчитане на работното време за изнесени екипи</h2><ul><li>Потвърдено с GPS отчитане на пристигане и тръгване — без терминал, без четец на карти</li><li>Свързване на часовете по проект или по клиент, а не само дневен сбор</li><li>Картина на оставащите часове в реално време по проект, така че превишаването на бюджета да е видимо, преди да се случи</li><li>Отчитане на извънреден труд с гъвкаво изплащане или преобразуване в почивни дни</li><li>Управление на отпуски и отсъствия, включително цифрово качване на болничен лист</li><li>Експорт за ведомостта за заплати с едно кликване, съвместим с Вашата счетоводна къща за заплати или HR система</li></ul><h2>Чести възражения — с отговори</h2><p>Служителите няма да го използват. На практика отчитането с едно докосване отнема по-малко време от попълването на хартиен график в края на седмицата. Възприемането почти винаги е по-бързо от очакваното. Твърде скъпо е. Done-it започва от 19 € на месец базова цена — по-малко от цената на една грешка във ведомостта за заплати. Твърде малки сме. Няма минимален размер на екипа.</p><h2>Измерението на съответствието</h2><p>Повечето страни от ЕС затягат изискванията относно регистрирането на работните часове — водени от решението на Съда на Европейския съюз от 2019 г., че работодателите трябва да разполагат с обективна и надеждна система за измерване на дневното работно време. Цифров инструмент, който създава защитен от подправяне запис за всеки служител, за всеки ден, за всеки проект, удовлетворява всяко местно прилагане на този стандарт.</p>",
        "lead": "Когато екипът Ви работи на множество обекти, ръчните графици за работно време не вършат работа. Ето как цифровата регистрация на работното време променя ежедневната реалност — за служителите, мениджърите и ведомостта за заплати.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Отчитане на работното време за изнесени екипи: пълно ръководство за МСП",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Къде отива времето</h2><p>За компания с 10–20 изнесени служители подготовката на заплатите обикновено отнема един до два дни на месец. Някой събира графиците (хартиени или по WhatsApp), въвежда ги в електронна таблица, съгласува ги с проектните записи, коригира неизбежните грешки и създава експорт за счетоводната къща за заплати или доставчика на услуги по заплати. Всяка стъпка е ръчна. Всяка стъпка има възможности за провал.</p><h2>Тесните места</h2><ul><li>Графиците пристигат със закъснение или непълни — служителите са на път, а не на бюро</li><li>Часовете се отчитат към грешен проект или клиент, което изисква ръчна корекция</li><li>Записите за извънреден труд и отсъствия живеят в отделна система (или на лепящо листче)</li><li>Експортът за заплати е форматиран различно от това, което счетоводната къща очаква</li></ul><h2>Какво променя една цифрова система</h2><p>Когато служителите се отчитат при пристигане и тръгване чрез GPS на телефона си, часовете се регистрират в момента на случването им — свързани с правилния проект, с точно време, без закръгляване. В края на месеца експортът се генерира с едно кликване. Числата вече са правилни. Няма нищо за съгласуване.</p><p>Извънредният труд се отчита в момента на случването му. Отсъствията се подават цифрово от служителя. Балансите на отпуските се актуализират автоматично. Работата на мениджъра се свежда до преглед на табло, а не до изграждането му от сурови данни.</p><h2>Какво съобщават екипите</h2><ul><li>Подготовката на заплатите спадна от два дни до под един час</li><li>Грешките във ведомостта за заплати рязко намаляха — липсата на ръчно въвеждане означава липса на грешки при преписване</li><li>Калкулирането на разходите по проект става възможно — реални часове за всяка задача, а не приблизителни оценки</li><li>Служителите всъщност го предпочитат — няма график за попълване в края на седмицата</li></ul><h2>Първи стъпки</h2><p>Done-it отвежда повечето екипи от регистрацията до първите отчетени часове в същия следобед. Без хардуер, без ИТ проект. Служителите изтеглят приложението и се отчитат. Часовете се появяват в таблото. Експортът за заплати е готов в края на месеца. Пробният период е 30 дни безплатно — без изискване за карта.</p>",
        "lead": "За компаниите с мобилни екипи подготовката на заплатите е месечен кошмар — гонене на графици, коригиране на грешки, съгласуване на проекти. Ето как екипите, които решиха този проблем, го направиха.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Как компаниите за изнесени услуги намаляват администрацията на заплатите с 80%",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "tr": [
      {
        "tag": "Mileage",
        "html": "<h2>Manuel kilometre kayıtları neden başarısız olur</h2><p>Çalışanlar kilometreleri hafta sonunda doldurduğunda, rotaları hafızadan yeniden oluştururlar. Sonuç: yuvarlanmış sayılar, eksik yolculuklar ve ay sonunda anlaşmazlıklar. Bordro şişer veya eksik geri ödenir ve şirketin savunulabilir bir denetim izi olmaz.</p><h2>Otomatik yakalama nasıl görünür</h2><p>GPS tabanlı bir sistem, her yolculuk için kalkış noktasını, varış noktasını, gerçek rotayı ve tam mesafeyi kaydeder — arka planda, çalışan araç kullanırken. Manuel giriş yok. Veriler zaman damgalıdır, doğru müşteriye veya projeye bağlıdır ve back office&#x27;te anında kullanılabilir.</p><p>Çalışan, yolculuğun başında ulaşım türünü seçer (kendi aracı, şirket aracı, ortak araç, bisiklet). Sistem doğru geri ödeme oranını otomatik olarak uygular ve gerçek maliyet kanıtı gerektiren eşiğin üzerindeki her şeyi işaretler.</p><h2>Neyi kazandırır</h2><ul><li>İdari iş: ay sonunda kâğıt kayıt defterlerinin peşinde koşmak veya tablo hatalarını düzeltmek yok</li><li>Anlaşmazlıklar: GPS doğrulamalı veriler objektiftir — müşteriler ve çalışanlar aynı sayıları görür</li><li>Maliyet: bir masraf notuna asla girmeyecek olan kilometreler otomatik yakalanır</li><li>Uyumluluk: çalışan başına, yolculuk başına, proje başına eksiksiz bir denetim izi — denetime hazır</li></ul><h2>Bir kilometre aracında nelere dikkat edilmeli</h2><ul><li>GPS ile otomatik yakalama — çalışanlar için manuel giriş yok</li><li>Yapılandırılabilir oranlarla birden fazla ulaşım türü</li><li>Proje veya müşteri başına yolculuk bağlama</li><li>GDPR uyumlu: GPS yalnızca çalışma saatlerinde aktif, veriler AB&#x27;de barındırılır</li><li>Bordroya veya faturalandırmaya beslenen dışa aktarıma hazır raporlar</li></ul><h2>Done-it bunu nasıl hallediyor</h2><p>Done-it yolculukları Trax-it aracılığıyla otomatik yakalar — GPS rotayı kaydeder, çalışan ulaşım türünü seçer ve sistem doğru oranı uygular. Her şey doğru projeye veya müşteriye bağlanır. Raporlar manuel kopyalama olmadan doğrudan bordroya veya e-faturalandırmaya aktarılır.</p>",
        "lead": "Ekibiniz gün boyu sahalar arasında hareket ettiğinde, kilometre hızla birikir — hatalar da öyle. İşte otomatik kilometre yakalamanın nasıl çalıştığı, neyi kazandırdığı ve bir çözümde nelere dikkat etmeniz gerektiği.",
        "read": "6 dk",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Saha ekipleri için kilometre nasıl takip edilir — evrak işi olmadan",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Temel kural: orantılılık</h2><p>Çalışanların GPS takibi GDPR kapsamında yasaldır — ancak yalnızca meşru bir ticari amaçla orantılı olduğunda. Teslimatları koordine etmek, servis ziyaretlerini doğrulamak, çalışan güvenliğini sağlamak: hepsi geçerlidir. Birinin her hareketini &#x27;ne olur ne olmaz diye&#x27; takip etmek: geçerli değildir.</p><h2>Yapmanız gereken dört şey</h2><ul><li>Amacı tanımlayın: rota optimizasyonu, güvenlik, servis doğrulama — ve bunu yazılı hale getirin</li><li>Takibi yalnızca çalışma saatleriyle sınırlayın: çalışanlar kişisel zamanlarında GPS&#x27;i kapatabilmeli</li><li>Ekibinizi açıkça bilgilendirin: ne toplanıyor, neden, kim görebiliyor, ne kadar süreyle saklanıyor</li><li>Belgeleyin: GPS kullanımını çalışma yönetmeliğinize dahil edin ve takip büyük ölçekli veya yapısalsa bir DPIA gerçekleştirin</li></ul><h2>Yapmamanız gerekenler</h2><ul><li>7/24 takip — çalışma saatleri dışında takip GDPR orantılılığını ihlal eder</li><li>GPS verilerini önceden bildirim olmadan otomatik yaptırımlar için kullanmak (örneğin disiplini tetikleyen hız uyarıları)</li><li>Konum verilerini gerekenden uzun süre saklamak — CNIL en fazla iki ay önerir</li><li>Çalışanları bilgilendirmemek — açıklanmamış takip, sonraki bir anlaşmazlıkta kanıtı geçersiz kılabilir</li></ul><h2>Sektöre özel notlar</h2><p>Saha servisi ve lojistik için GPS beklenir ve kolayca gerekçelendirilir. Temizlik ve bakım için, denetçiler tarafından rota planlaması uygundur — çalışan başına sürekli takip gerekçelendirmesi daha zordur. İnşaat için, araç ve makine korumasına yönelik GPS standarttır; halihazırda kullanılan herhangi bir mevcudiyet kayıt sistemini tekrarlamamalıdır.</p><h2>Done-it bunu nasıl hallediyor</h2><p>Done-it GPS&#x27;i yalnızca girişte, çıkışta ve iş için aktif seyahat sırasında etkinleştirir. 7/24 takip yok, molalar veya kişisel zaman sırasında izleme yok. Veriler şifrelemeyle AB&#x27;de barındırılır ve özel bir Veri Koruma Görevlisi vardır — her türlü gizlilik denetimine hazır.</p>",
        "lead": "Mobil çalışanların GPS takibi gerçek gizlilik soruları doğurur. İşte neye yasal olarak izin verildiğine, neye verilmediğine ve ekibinizin kabul edeceği bir şekilde nasıl uygulanacağına dair anlaşılır bir rehber.",
        "read": "5 dk",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "Saha çalışanları için GPS takibi: neye izin var ve doğru nasıl yapılır",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Manuel zaman çizelgelerinin sorunu</h2><p>Saha çalışanları saatleri hafızadan, genellikle günler sonra doldurur. Yuvarlama normaldir. Saatler yanlış projeye veya müşteriye düşer. Bordro bir yaklaşımdır. Ve bir müşteri bir faturaya itiraz ettiğinde — ya da bir müfettiş geldiğinde — başvurulacak objektif bir kayıt yoktur.</p><h2>Dijital zaman kaydı gerçekte ne anlama gelir</h2><p>Dijital kayıt, çalışanın sahada giriş yapmak için dokunması, sistemin bunu GPS doğrulamasıyla zaman damgalaması ve saatlerin otomatik olarak doğru projeye veya müşteriye bağlanması anlamına gelir. Ay sonunda, bordro dışa aktarımı tek tıkla oluşturulur — peşinde koşmak yok, mutabakat yok, hata yok.</p><p>Back office canlı bir görünüm elde eder: kimin hangi sahada olduğu, her projeye karşı kaç saat kaydedildiği ve herhangi bir işin bütçeyi aşıp aşmadığı. Bu görünürlük yönetme şeklinizi değiştirir — sorunlar ay sonunda değil, gerçek zamanlı olarak ortaya çıkar.</p><h2>Saha ekipleri için bir zaman takibi aracında nelere dikkat edilmeli</h2><ul><li>GPS doğrulamalı giriş ve çıkış — terminal yok, kart okuyucu yok</li><li>Yalnızca günlük toplam değil, proje veya müşteri başına saat bağlama</li><li>Bütçe aşımları olmadan önce görünür olsun diye proje başına canlı kalan saat görünümü</li><li>Esnek ödeme veya izne dönüştürmeli fazla mesai takibi</li><li>Dijital hastalık raporu yükleme dahil izin ve devamsızlık yönetimi</li><li>Sosyal sekretaryanız veya İK sisteminizle uyumlu tek tıkla bordro dışa aktarımı</li></ul><h2>Yaygın itirazlar — yanıtlandı</h2><p>Çalışanlar bunu kullanmaz. Uygulamada, tek dokunuşluk bir giriş, hafta sonunda kâğıt zaman çizelgesi doldurmaktan daha az zaman alır. Benimsenmesi neredeyse her zaman beklenenden hızlıdır. Çok pahalı. Done-it ayda 19 € temel fiyatla başlar — tek bir bordro hatasının maliyetinden daha az. Çok küçüğüz. Minimum ekip büyüklüğü yoktur.</p><h2>Uyumluluk boyutu</h2><p>Çoğu AB ülkesi, işverenlerin günlük çalışma süresini ölçmek için objektif ve güvenilir bir sisteme sahip olması gerektiğine ilişkin 2019 Avrupa Adalet Divanı kararıyla yönlendirilen çalışma saati kaydı gerekliliklerini sıkılaştırıyor. Çalışan başına, gün başına, proje başına kurcalanamaz bir kayıt üreten dijital bir araç, bu standardın her türlü yerel uygulamasını karşılar.</p>",
        "lead": "Ekibiniz birden fazla sahada çalıştığında, manuel zaman çizelgeleri işe yaramaz. İşte dijital zaman kaydının günlük gerçekliği nasıl değiştirdiği — çalışanlar, yöneticiler ve bordro için.",
        "read": "7 dk",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Saha ekipleri için zaman takibi: KOBİ'ler için eksiksiz bir rehber",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Zaman nereye gidiyor</h2><p>10-20 saha çalışanı olan bir şirket için, bordro hazırlığı genellikle ayda bir ila iki gün sürer. Biri zaman çizelgelerini toplar (kâğıt veya WhatsApp), bunları bir tabloya girer, proje kayıtlarıyla mutabık kılar, kaçınılmaz hataları düzeltir ve sosyal sekretarya veya bordro sağlayıcısı için bir dışa aktarım üretir. Her adım manuel. Her adımın hata modları var.</p><h2>Darboğazlar</h2><ul><li>Zaman çizelgeleri geç veya eksik gelir — çalışanlar yolda, masa başında değil</li><li>Saatler yanlış projeye veya müşteriye kaydedilir, manuel düzeltme gerektirir</li><li>Fazla mesai ve devamsızlık kayıtları ayrı bir sistemde (veya bir yapışkan notta) bulunur</li><li>Bordro dışa aktarımı, sekretaryanın beklediğinden farklı biçimlendirilmiştir</li></ul><h2>Dijital bir sistem neyi değiştirir</h2><p>Çalışanlar telefonlarından GPS ile giriş ve çıkış yaptığında, saatler oldukları anda kaydedilir — doğru projeye bağlı, tam saatlerle, yuvarlama olmadan. Ay sonunda, dışa aktarım tek tıkla oluşturulur. Sayılar zaten doğrudur. Mutabık kılınacak hiçbir şey yoktur.</p><p>Fazla mesai oluştuğu anda takip edilir. Devamsızlıklar çalışan tarafından dijital olarak gönderilir. İzin bakiyeleri otomatik güncellenir. Yöneticinin işi, ham verilerden bir pano oluşturmak yerine, bir panoyu incelemek haline gelir.</p><h2>Ekiplerin bildirdikleri</h2><ul><li>Bordro hazırlığı iki günden bir saatin altına indi</li><li>Bordro hataları keskin düştü — manuel giriş olmaması kopyalama hatası olmaması demektir</li><li>Proje sonrası maliyetlendirme mümkün hale geliyor — yaklaşımlar değil, iş başına gerçek saatler</li><li>Çalışanlar bunu gerçekten tercih ediyor — hafta sonunda doldurulacak zaman çizelgesi yok</li></ul><h2>Başlangıç</h2><p>Done-it çoğu ekibi kayıttan ilk takip edilen saatlere aynı öğleden sonra getirir. Donanım yok, BT projesi yok. Çalışanlar uygulamayı indirir ve giriş yapar. Saatler panoda görünür. Bordro dışa aktarımı ay sonunda hazırdır. Deneme 30 gün ücretsizdir — kart gerekmez.</p>",
        "lead": "Mobil ekiplere sahip şirketler için bordro hazırlığı aylık bir kâbustur — zaman çizelgelerinin peşinde koşmak, hataları düzeltmek, projeleri mutabık kılmak. İşte bunu çözen ekiplerin nasıl yaptığı.",
        "read": "4 dk",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Saha servisi şirketleri bordro işlerini %80 nasıl azaltıyor",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ],
    "lt": [
      {
        "tag": "Mileage",
        "html": "<h2>Kodėl rankiniai kilometražo žurnalai nepasiteisina</h2><p>Kai darbuotojai pildo kilometrus savaitės pabaigoje, jie atkuria maršrutus iš atminties. Rezultatas: suapvalinti skaičiai, praleistos kelionės ir ginčai mėnesio pabaigoje. Darbo užmokestis išpučiamas arba nepakankamai kompensuojamas, o įmonė neturi apginamo audito pėdsako.</p><h2>Kaip atrodo automatinis fiksavimas</h2><p>GPS pagrįsta sistema registruoja išvykimo tašką, atvykimo tašką, faktinį maršrutą ir tikslų atstumą kiekvienai kelionei — fone, kol darbuotojas vairuoja. Jokio rankinio įvedimo. Duomenys pažymėti laiku, susieti su tinkamu klientu ar projektu ir iškart prieinami biure.</p><p>Darbuotojas kelionės pradžioje pasirenka transporto tipą (nuosavas automobilis, įmonės transportas, bendra kelionė, dviratis). Sistema automatiškai pritaiko teisingą kompensacijos tarifą ir pažymi viską, kas viršija slenkstį ir reikalauja realių sąnaudų įrodymo.</p><h2>Ką tai sutaupo</h2><ul><li>Administracija: jokio popierinių žurnalų vaikymosi ar skaičiuoklių klaidų taisymo mėnesio pabaigoje</li><li>Ginčai: GPS patvirtinti duomenys objektyvūs — klientai ir darbuotojai mato tuos pačius skaičius</li><li>Sąnaudos: kilometrai, kurie niekada nebūtų patekę į išlaidų pažymą, fiksuojami automatiškai</li><li>Atitiktis: pilnas audito pėdsakas kiekvienam darbuotojui, kelionei, projektui — paruoštas patikrinimui</li></ul><h2>Į ką atkreipti dėmesį renkantis kilometražo įrankį</h2><ul><li>Automatinis fiksavimas per GPS — jokio rankinio įvedimo darbuotojams</li><li>Keli transporto tipai su konfigūruojamais tarifais</li><li>Kelionių susiejimas pagal projektą ar klientą</li><li>Atitinka BDAR: GPS aktyvus tik darbo valandomis, duomenys saugomi ES</li><li>Eksportui paruoštos ataskaitos, kurios teka į darbo užmokestį ar sąskaitų išrašymą</li></ul><h2>Kaip Done-it tai tvarko</h2><p>Done-it automatiškai fiksuoja keliones per Trax-it — GPS registruoja maršrutą, darbuotojas pasirenka transporto tipą, o sistema pritaiko teisingą tarifą. Viskas susiejama su tinkamu projektu ar klientu. Ataskaitos eksportuojamos tiesiai į darbo užmokestį ar e. sąskaitas, be rankinio perrašymo.</p>",
        "lead": "Kai Jūsų komanda visą dieną juda tarp objektų, kilometražas greitai kaupiasi — ir klaidos taip pat. Štai kaip veikia automatinis kilometražo fiksavimas, ką jis sutaupo ir į ką atkreipti dėmesį renkantis sprendimą.",
        "read": "6 min",
        "slug": "how-to-track-mileage-for-field-teams",
        "title": "Kaip sekti kilometražą lauko komandoms — be popierizmo",
        "featured": true,
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551023/blog/how-to-track-mileage-for-field-teams.jpg"
      },
      {
        "tag": "GPS & privacy",
        "html": "<h2>Pagrindinė taisyklė: proporcingumas</h2><p>Darbuotojų GPS sekimas pagal BDAR yra teisėtas — bet tik tada, kai jis proporcingas teisėtam verslo tikslui. Pristatymų koordinavimas, aptarnavimo vizitų patvirtinimas, darbuotojų saugumo užtikrinimas: visa tai galioja. Kiekvieno žmogaus judesio sekimas „tik dėl viso pikto“: negalioja.</p><h2>Keturi dalykai, kuriuos privalote padaryti</h2><ul><li>Apibrėžkite tikslą: maršruto optimizavimas, saugumas, aptarnavimo patvirtinimas — ir užrašykite tai</li><li>Apribokite sekimą tik darbo valandomis: darbuotojai turi galėti išjungti GPS asmeniniu laiku</li><li>Aiškiai informuokite savo komandą: kas renkama, kodėl, kas gali matyti, kiek laiko saugoma</li><li>Dokumentuokite tai: įtraukite GPS naudojimą į savo darbo taisykles ir atlikite DPIA, jei sekimas didelio masto ar struktūrinis</li></ul><h2>Ko negalite daryti</h2><ul><li>Sekti visą parą — sekimas ne darbo valandomis pažeidžia BDAR proporcingumą</li><li>Naudoti GPS duomenis automatinėms sankcijoms (pvz., greičio viršijimo įspėjimams, kurie sukelia drausmines priemones) be išankstinio atskleidimo</li><li>Saugoti vietos duomenis ilgiau, nei būtina — CNIL rekomenduoja ne ilgiau kaip du mėnesius</li><li>Praleisti darbuotojų informavimą — neatskleistas sekimas gali padaryti įrodymus negaliojančiais bet kokiame vėlesniame ginče</li></ul><h2>Sektoriui būdingos pastabos</h2><p>Lauko paslaugoms ir logistikai GPS yra tikimasi ir lengvai pateisinamas. Valymui ir priežiūrai vadovų atliekamas maršruto planavimas yra tinkamas — nuolatinį sekimą pagal darbuotoją sunkiau pateisinti. Statybai GPS transporto ir mechanizmų apsaugai yra standartas; jis neturėtų dubliuoti jokios jau naudojamos buvimo registracijos sistemos.</p><h2>Kaip Done-it tai tvarko</h2><p>Done-it aktyvuoja GPS tik registruojantis, išsiregistruojant ir aktyvios kelionės dėl darbo metu. Nėra sekimo visą parą, jokio stebėjimo per pertraukas ar asmeniniu laiku. Duomenys saugomi ES su šifravimu ir dedikuotu Duomenų apsaugos pareigūnu — paruošti bet kokiam privatumo auditui.</p>",
        "lead": "Mobiliųjų darbuotojų GPS sekimas kelia realius privatumo klausimus. Štai aiškus vadovas apie tai, kas teisiškai leidžiama, kas ne ir kaip tai įgyvendinti taip, kad Jūsų komanda priimtų.",
        "read": "5 min",
        "slug": "gps-tracking-field-workers-privacy-gdpr",
        "title": "GPS sekimas lauko darbuotojams: kas leidžiama ir kaip tai daryti teisingai",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551021/blog/gps-tracking-field-workers-privacy-gdpr.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Rankinių žiniaraščių problema</h2><p>Lauko darbuotojai pildo valandas iš atminties, dažnai po kelių dienų. Apvalinimas yra norma. Valandos patenka į netinkamą projektą ar klientą. Darbo užmokestis yra apytikslis. O kai klientas ginčija sąskaitą — arba pasirodo inspektorius — nėra objektyvaus įrašo, į kurį būtų galima atsiremti.</p><h2>Ką iš tikrųjų reiškia skaitmeninė darbo laiko registracija</h2><p>Skaitmeninė registracija reiškia, kad darbuotojas paliečia, kad užsiregistruotų objekte, sistema pažymi laiką su GPS patvirtinimu, o valandos automatiškai susiejamos su tinkamu projektu ar klientu. Mėnesio pabaigoje darbo užmokesčio eksportas generuojamas vienu paspaudimu — jokio vaikymosi, jokio suderinimo, jokių klaidų.</p><p>Biuras gauna vaizdą realiu laiku: kas kuriame objekte, kiek valandų užregistruota kiekvienam projektui ir ar koks darbas viršija biudžetą. Toks matomumas keičia tai, kaip valdote — problemos išryškėja realiu laiku, o ne mėnesio pabaigoje.</p><h2>Į ką atkreipti dėmesį renkantis darbo laiko apskaitos įrankį lauko komandoms</h2><ul><li>GPS patvirtinta registracija ir išsiregistravimas — be terminalo, be kortelės skaitytuvo</li><li>Valandų susiejimas pagal projektą ar klientą, o ne tik dienos suma</li><li>Likusių valandų rodinys realiu laiku pagal projektą, kad biudžeto viršijimai būtų matomi anksčiau, nei įvyksta</li><li>Viršvalandžių apskaita su lanksčiu apmokėjimu ar konvertavimu į laisvą laiką</li><li>Atostogų ir nebuvimo valdymas, įskaitant skaitmeninį nedarbingumo pažymėjimų įkėlimą</li><li>Darbo užmokesčio eksportas vienu paspaudimu, suderinamas su Jūsų socialiniu sekretoriatu ar HR sistema</li></ul><h2>Dažni prieštaravimai — atsakyti</h2><p>Darbuotojai jo nenaudos. Praktiškai registracija vienu prisilietimu užtrunka mažiau laiko nei popierinio žiniaraščio pildymas savaitės pabaigoje. Pritaikymas beveik visada greitesnis, nei tikimasi. Tai per brangu. Done-it prasideda nuo 19 €/mėn. bazinės kainos — mažiau nei vienos darbo užmokesčio klaidos kaina. Mes per maži. Nėra minimalaus komandos dydžio.</p><h2>Atitikties aspektas</h2><p>Dauguma ES šalių griežtina darbo valandų registracijos reikalavimus — paskatintos 2019 m. Europos Teisingumo Teismo sprendimo, kad darbdaviai privalo turėti objektyvią, patikimą sistemą dienos darbo laikui matuoti. Skaitmeninis įrankis, kuris sukuria nuo klastojimo apsaugotą įrašą kiekvienam darbuotojui, dienai, projektui, atitinka bet kokį vietinį to standarto įgyvendinimą.</p>",
        "lead": "Kai Jūsų komanda dirba keliuose objektuose, rankiniai žiniaraščiai neveikia. Štai kaip skaitmeninė darbo laiko registracija keičia kasdienę realybę — darbuotojams, vadovams ir darbo užmokesčiui.",
        "read": "7 min",
        "slug": "time-tracking-for-field-teams-complete-guide",
        "title": "Darbo laiko apskaita lauko komandoms: pilnas vadovas MVĮ",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551042/blog/time-tracking-for-field-teams-complete-guide.jpg"
      },
      {
        "tag": "Compliance",
        "html": "<h2>Kur dingsta laikas</h2><p>Įmonei su 10–20 lauko darbuotojų darbo užmokesčio paruošimas paprastai užtrunka vieną ar dvi dienas per mėnesį. Kažkas surenka žiniaraščius (popierinius ar per WhatsApp), suveda juos į skaičiuoklę, suderina su projektų įrašais, taiso neišvengiamas klaidas ir parengia eksportą socialiniam sekretoriatui ar darbo užmokesčio paslaugų teikėjui. Kiekvienas žingsnis rankinis. Kiekvienas žingsnis turi gedimo galimybių.</p><h2>Kliūtys</h2><ul><li>Žiniaraščiai ateina vėluodami arba neišsamūs — darbuotojai kelyje, o ne prie stalo</li><li>Valandos registruojamos netinkamam projektui ar klientui, todėl reikia rankinio taisymo</li><li>Viršvalandžių ir nebuvimo įrašai gyvena atskiroje sistemoje (arba ant lipnaus lapelio)</li><li>Darbo užmokesčio eksportas suformatuotas kitaip, nei tikisi sekretoriatas</li></ul><h2>Ką keičia skaitmeninė sistema</h2><p>Kai darbuotojai registruojasi ir išsiregistruoja per GPS telefone, valandos registruojamos tą akimirką, kai įvyksta — susietos su tinkamu projektu, su tiksliu laiku, be apvalinimo. Mėnesio pabaigoje eksportas generuojamas vienu paspaudimu. Skaičiai jau teisingi. Nėra ką suderinti.</p><p>Viršvalandžiai sekami jiems įvykstant. Nebuvimus darbuotojas pateikia skaitmeniniu būdu. Atostogų likučiai atsinaujina automatiškai. Vadovo darbas tampa skydelio peržiūra, o ne jo kūrimas iš neapdorotų duomenų.</p><h2>Ką praneša komandos</h2><ul><li>Darbo užmokesčio paruošimas nuo dviejų dienų iki mažiau nei valandos</li><li>Darbo užmokesčio klaidos smarkiai sumažėjo — jokio rankinio įvedimo reiškia jokių perrašymo klaidų</li><li>Projekto sąnaudų vertinimas po fakto tampa įmanomas — realios valandos pagal darbą, o ne apytiksliai</li><li>Darbuotojai tai netgi mėgsta labiau — nereikia pildyti žiniaraščio savaitės pabaigoje</li></ul><h2>Kaip pradėti</h2><p>Done-it daugumą komandų nuo registracijos iki pirmųjų registruotų valandų atveda tą pačią popietę. Jokios įrangos, jokio IT projekto. Darbuotojai atsisiunčia programėlę ir registruojasi. Valandos atsiranda skydelyje. Darbo užmokesčio eksportas paruoštas mėnesio pabaigoje. Bandomoji versija 30 dienų nemokama — kortelės nereikia.</p>",
        "lead": "Įmonėms su mobiliomis komandomis darbo užmokesčio paruošimas yra mėnesinis košmaras — žiniaraščių vaikymasis, klaidų taisymas, projektų suderinimas. Štai kaip tai išsprendusios komandos tai padarė.",
        "read": "4 min",
        "slug": "reducing-payroll-admin-for-field-service-companies",
        "title": "Kaip lauko paslaugų įmonės sumažina darbo užmokesčio administravimą 80 %",
        "cover": "https://res.cloudinary.com/lbx0aw1r/image/upload/v1784551041/blog/reducing-payroll-admin-for-field-service-companies.jpg"
      }
    ]
  }
};
